const pincodeData = [
{ pincode: 110000, min_days: 2, max_days: 3 },
{ pincode: 110001, min_days: 2, max_days: 3 },
{ pincode: 110002, min_days: 2, max_days: 3 },
{ pincode: 110003, min_days: 2, max_days: 3 },
{ pincode: 110004, min_days: 2, max_days: 3 },
{ pincode: 110005, min_days: 2, max_days: 3 },
{ pincode: 110006, min_days: 2, max_days: 3 },
{ pincode: 110007, min_days: 2, max_days: 3 },
{ pincode: 110008, min_days: 2, max_days: 3 },
{ pincode: 110009, min_days: 2, max_days: 3 },
{ pincode: 110010, min_days: 2, max_days: 3 },
{ pincode: 110011, min_days: 2, max_days: 3 },
{ pincode: 110012, min_days: 2, max_days: 3 },
{ pincode: 110013, min_days: 2, max_days: 3 },
{ pincode: 110014, min_days: 2, max_days: 3 },
{ pincode: 110015, min_days: 2, max_days: 3 },
{ pincode: 110016, min_days: 2, max_days: 3 },
{ pincode: 110017, min_days: 2, max_days: 3 },
{ pincode: 110018, min_days: 2, max_days: 3 },
{ pincode: 110019, min_days: 2, max_days: 3 },
{ pincode: 110020, min_days: 2, max_days: 3 },
{ pincode: 110021, min_days: 2, max_days: 3 },
{ pincode: 110022, min_days: 2, max_days: 3 },
{ pincode: 110023, min_days: 2, max_days: 3 },
{ pincode: 110024, min_days: 2, max_days: 3 },
{ pincode: 110025, min_days: 2, max_days: 3 },
{ pincode: 110026, min_days: 2, max_days: 3 },
{ pincode: 110027, min_days: 2, max_days: 3 },
{ pincode: 110028, min_days: 2, max_days: 3 },
{ pincode: 110029, min_days: 2, max_days: 3 },
{ pincode: 110030, min_days: 2, max_days: 3 },
{ pincode: 110031, min_days: 2, max_days: 3 },
{ pincode: 110032, min_days: 2, max_days: 3 },
{ pincode: 110033, min_days: 2, max_days: 3 },
{ pincode: 110034, min_days: 2, max_days: 3 },
{ pincode: 110035, min_days: 2, max_days: 3 },
{ pincode: 110036, min_days: 2, max_days: 3 },
{ pincode: 110037, min_days: 2, max_days: 3 },
{ pincode: 110038, min_days: 2, max_days: 3 },
{ pincode: 110039, min_days: 2, max_days: 3 },
{ pincode: 110040, min_days: 2, max_days: 3 },
{ pincode: 110041, min_days: 2, max_days: 3 },
{ pincode: 110042, min_days: 2, max_days: 3 },
{ pincode: 110043, min_days: 2, max_days: 3 },
{ pincode: 110044, min_days: 2, max_days: 3 },
{ pincode: 110045, min_days: 2, max_days: 3 },
{ pincode: 110046, min_days: 2, max_days: 3 },
{ pincode: 110047, min_days: 2, max_days: 3 },
{ pincode: 110048, min_days: 2, max_days: 3 },
{ pincode: 110049, min_days: 2, max_days: 3 },
{ pincode: 110050, min_days: 2, max_days: 3 },
{ pincode: 110051, min_days: 2, max_days: 3 },
{ pincode: 110052, min_days: 2, max_days: 3 },
{ pincode: 110053, min_days: 2, max_days: 3 },
{ pincode: 110054, min_days: 2, max_days: 3 },
{ pincode: 110055, min_days: 2, max_days: 3 },
{ pincode: 110056, min_days: 2, max_days: 3 },
{ pincode: 110057, min_days: 2, max_days: 3 },
{ pincode: 110058, min_days: 2, max_days: 3 },
{ pincode: 110059, min_days: 2, max_days: 3 },
{ pincode: 110060, min_days: 2, max_days: 3 },
{ pincode: 110061, min_days: 2, max_days: 3 },
{ pincode: 110062, min_days: 2, max_days: 3 },
{ pincode: 110063, min_days: 2, max_days: 3 },
{ pincode: 110064, min_days: 2, max_days: 3 },
{ pincode: 110065, min_days: 2, max_days: 3 },
{ pincode: 110066, min_days: 2, max_days: 3 },
{ pincode: 110067, min_days: 2, max_days: 3 },
{ pincode: 110068, min_days: 2, max_days: 3 },
{ pincode: 110069, min_days: 2, max_days: 3 },
{ pincode: 110070, min_days: 2, max_days: 3 },
{ pincode: 110071, min_days: 2, max_days: 3 },
{ pincode: 110072, min_days: 2, max_days: 3 },
{ pincode: 110073, min_days: 2, max_days: 3 },
{ pincode: 110074, min_days: 2, max_days: 3 },
{ pincode: 110075, min_days: 2, max_days: 3 },
{ pincode: 110076, min_days: 2, max_days: 3 },
{ pincode: 110077, min_days: 2, max_days: 3 },
{ pincode: 110078, min_days: 2, max_days: 3 },
{ pincode: 110079, min_days: 2, max_days: 3 },
{ pincode: 110080, min_days: 2, max_days: 3 },
{ pincode: 110081, min_days: 2, max_days: 3 },
{ pincode: 110082, min_days: 2, max_days: 3 },
{ pincode: 110083, min_days: 2, max_days: 3 },
{ pincode: 110084, min_days: 2, max_days: 3 },
{ pincode: 110085, min_days: 2, max_days: 3 },
{ pincode: 110086, min_days: 2, max_days: 3 },
{ pincode: 110087, min_days: 2, max_days: 3 },
{ pincode: 110088, min_days: 2, max_days: 3 },
{ pincode: 110089, min_days: 2, max_days: 3 },
{ pincode: 110090, min_days: 2, max_days: 3 },
{ pincode: 110091, min_days: 2, max_days: 3 },
{ pincode: 110092, min_days: 2, max_days: 3 },
{ pincode: 110093, min_days: 2, max_days: 3 },
{ pincode: 110094, min_days: 2, max_days: 3 },
{ pincode: 110095, min_days: 2, max_days: 3 },
{ pincode: 110096, min_days: 2, max_days: 3 },
{ pincode: 110097, min_days: 2, max_days: 3 },
{ pincode: 110098, min_days: 2, max_days: 3 },
{ pincode: 110099, min_days: 2, max_days: 3 },
{ pincode: 110100, min_days: 2, max_days: 3 },
{ pincode: 110101, min_days: 2, max_days: 3 },
{ pincode: 110102, min_days: 2, max_days: 3 },
{ pincode: 110103, min_days: 2, max_days: 3 },
{ pincode: 110104, min_days: 2, max_days: 3 },
{ pincode: 110105, min_days: 2, max_days: 3 },
{ pincode: 110106, min_days: 2, max_days: 3 },
{ pincode: 110107, min_days: 2, max_days: 3 },
{ pincode: 110108, min_days: 2, max_days: 3 },
{ pincode: 110109, min_days: 2, max_days: 3 },
{ pincode: 110110, min_days: 2, max_days: 3 },
{ pincode: 110112, min_days: 2, max_days: 3 },
{ pincode: 110113, min_days: 2, max_days: 3 },
{ pincode: 110114, min_days: 2, max_days: 3 },
{ pincode: 110115, min_days: 2, max_days: 3 },
{ pincode: 110116, min_days: 2, max_days: 3 },
{ pincode: 110117, min_days: 2, max_days: 3 },
{ pincode: 110118, min_days: 2, max_days: 3 },
{ pincode: 110119, min_days: 2, max_days: 3 },
{ pincode: 110120, min_days: 2, max_days: 3 },
{ pincode: 110121, min_days: 2, max_days: 3 },
{ pincode: 110122, min_days: 2, max_days: 3 },
{ pincode: 110124, min_days: 2, max_days: 3 },
{ pincode: 110125, min_days: 2, max_days: 3 },
{ pincode: 110151, min_days: 2, max_days: 3 },
{ pincode: 110175, min_days: 2, max_days: 3 },
{ pincode: 110301, min_days: 2, max_days: 3 },
{ pincode: 110302, min_days: 2, max_days: 3 },
{ pincode: 110401, min_days: 2, max_days: 3 },
{ pincode: 110402, min_days: 2, max_days: 3 },
{ pincode: 110403, min_days: 2, max_days: 3 },
{ pincode: 110501, min_days: 2, max_days: 3 },
{ pincode: 110502, min_days: 2, max_days: 3 },
{ pincode: 110503, min_days: 2, max_days: 3 },
{ pincode: 110504, min_days: 2, max_days: 3 },
{ pincode: 110505, min_days: 2, max_days: 3 },
{ pincode: 110506, min_days: 2, max_days: 3 },
{ pincode: 110507, min_days: 2, max_days: 3 },
{ pincode: 110508, min_days: 2, max_days: 3 },
{ pincode: 110509, min_days: 2, max_days: 3 },
{ pincode: 110510, min_days: 2, max_days: 3 },
{ pincode: 110511, min_days: 2, max_days: 3 },
{ pincode: 110512, min_days: 2, max_days: 3 },
{ pincode: 110601, min_days: 2, max_days: 3 },
{ pincode: 110602, min_days: 2, max_days: 3 },
{ pincode: 110603, min_days: 2, max_days: 3 },
{ pincode: 110604, min_days: 2, max_days: 3 },
{ pincode: 110605, min_days: 2, max_days: 3 },
{ pincode: 110606, min_days: 2, max_days: 3 },
{ pincode: 110607, min_days: 2, max_days: 3 },
{ pincode: 110608, min_days: 2, max_days: 3 },
{ pincode: 110609, min_days: 2, max_days: 3 },
{ pincode: 111105, min_days: 2, max_days: 3 },
{ pincode: 111112, min_days: 2, max_days: 3 },
{ pincode: 111114, min_days: 2, max_days: 3 },
{ pincode: 111120, min_days: 2, max_days: 3 },
{ pincode: 111121, min_days: 2, max_days: 3 },
{ pincode: 116019, min_days: 2, max_days: 3 },
{ pincode: 120001, min_days: 2, max_days: 3 },
{ pincode: 120002, min_days: 2, max_days: 3 },
{ pincode: 121000, min_days: 2, max_days: 3 },
{ pincode: 121001, min_days: 2, max_days: 3 },
{ pincode: 121002, min_days: 2, max_days: 3 },
{ pincode: 121003, min_days: 2, max_days: 3 },
{ pincode: 121004, min_days: 2, max_days: 3 },
{ pincode: 121005, min_days: 2, max_days: 3 },
{ pincode: 121006, min_days: 2, max_days: 3 },
{ pincode: 121007, min_days: 2, max_days: 3 },
{ pincode: 121008, min_days: 2, max_days: 3 },
{ pincode: 121009, min_days: 2, max_days: 3 },
{ pincode: 121010, min_days: 2, max_days: 3 },
{ pincode: 121011, min_days: 2, max_days: 3 },
{ pincode: 121012, min_days: 2, max_days: 3 },
{ pincode: 121013, min_days: 2, max_days: 3 },
{ pincode: 121014, min_days: 2, max_days: 3 },
{ pincode: 121015, min_days: 2, max_days: 3 },
{ pincode: 121101, min_days: 2, max_days: 3 },
{ pincode: 121102, min_days: 2, max_days: 3 },
{ pincode: 121103, min_days: 2, max_days: 3 },
{ pincode: 121104, min_days: 2, max_days: 3 },
{ pincode: 121105, min_days: 2, max_days: 3 },
{ pincode: 121106, min_days: 2, max_days: 3 },
{ pincode: 121107, min_days: 2, max_days: 3 },
{ pincode: 121206, min_days: 2, max_days: 3 },
{ pincode: 121705, min_days: 2, max_days: 3 },
{ pincode: 122000, min_days: 2, max_days: 3 },
{ pincode: 122001, min_days: 2, max_days: 3 },
{ pincode: 122002, min_days: 2, max_days: 3 },
{ pincode: 122003, min_days: 2, max_days: 3 },
{ pincode: 122004, min_days: 2, max_days: 3 },
{ pincode: 122005, min_days: 2, max_days: 3 },
{ pincode: 122006, min_days: 2, max_days: 3 },
{ pincode: 122007, min_days: 2, max_days: 3 },
{ pincode: 122008, min_days: 2, max_days: 3 },
{ pincode: 122009, min_days: 2, max_days: 3 },
{ pincode: 122010, min_days: 2, max_days: 3 },
{ pincode: 122011, min_days: 2, max_days: 3 },
{ pincode: 122012, min_days: 2, max_days: 3 },
{ pincode: 122013, min_days: 2, max_days: 3 },
{ pincode: 122014, min_days: 2, max_days: 3 },
{ pincode: 122015, min_days: 2, max_days: 3 },
{ pincode: 122016, min_days: 2, max_days: 3 },
{ pincode: 122017, min_days: 2, max_days: 3 },
{ pincode: 122018, min_days: 2, max_days: 3 },
{ pincode: 122019, min_days: 2, max_days: 3 },
{ pincode: 122020, min_days: 2, max_days: 3 },
{ pincode: 122021, min_days: 2, max_days: 3 },
{ pincode: 122022, min_days: 2, max_days: 3 },
{ pincode: 122023, min_days: 2, max_days: 3 },
{ pincode: 122024, min_days: 2, max_days: 3 },
{ pincode: 122025, min_days: 2, max_days: 3 },
{ pincode: 122026, min_days: 2, max_days: 3 },
{ pincode: 122027, min_days: 2, max_days: 3 },
{ pincode: 122028, min_days: 2, max_days: 3 },
{ pincode: 122029, min_days: 2, max_days: 3 },
{ pincode: 122030, min_days: 2, max_days: 3 },
{ pincode: 122031, min_days: 2, max_days: 3 },
{ pincode: 122032, min_days: 2, max_days: 3 },
{ pincode: 122033, min_days: 2, max_days: 3 },
{ pincode: 122050, min_days: 2, max_days: 3 },
{ pincode: 122051, min_days: 2, max_days: 3 },
{ pincode: 122052, min_days: 2, max_days: 3 },
{ pincode: 122055, min_days: 2, max_days: 3 },
{ pincode: 122098, min_days: 2, max_days: 3 },
{ pincode: 122100, min_days: 2, max_days: 3 },
{ pincode: 122101, min_days: 2, max_days: 3 },
{ pincode: 122102, min_days: 2, max_days: 3 },
{ pincode: 122103, min_days: 2, max_days: 3 },
{ pincode: 122104, min_days: 2, max_days: 3 },
{ pincode: 122105, min_days: 2, max_days: 3 },
{ pincode: 122106, min_days: 2, max_days: 3 },
{ pincode: 122107, min_days: 2, max_days: 3 },
{ pincode: 122108, min_days: 2, max_days: 3 },
{ pincode: 122109, min_days: 2, max_days: 3 },
{ pincode: 122110, min_days: 2, max_days: 3 },
{ pincode: 122203, min_days: 2, max_days: 3 },
{ pincode: 122204, min_days: 2, max_days: 3 },
{ pincode: 122206, min_days: 2, max_days: 3 },
{ pincode: 122207, min_days: 2, max_days: 3 },
{ pincode: 122208, min_days: 2, max_days: 3 },
{ pincode: 122209, min_days: 2, max_days: 3 },
{ pincode: 122210, min_days: 2, max_days: 3 },
{ pincode: 122211, min_days: 2, max_days: 3 },
{ pincode: 122213, min_days: 2, max_days: 3 },
{ pincode: 122214, min_days: 2, max_days: 3 },
{ pincode: 122215, min_days: 2, max_days: 3 },
{ pincode: 122216, min_days: 2, max_days: 3 },
{ pincode: 122217, min_days: 2, max_days: 3 },
{ pincode: 122218, min_days: 2, max_days: 3 },
{ pincode: 122219, min_days: 2, max_days: 3 },
{ pincode: 122220, min_days: 2, max_days: 3 },
{ pincode: 122223, min_days: 2, max_days: 3 },
{ pincode: 122224, min_days: 2, max_days: 3 },
{ pincode: 122225, min_days: 2, max_days: 3 },
{ pincode: 122226, min_days: 2, max_days: 3 },
{ pincode: 122227, min_days: 2, max_days: 3 },
{ pincode: 122228, min_days: 2, max_days: 3 },
{ pincode: 122229, min_days: 2, max_days: 3 },
{ pincode: 122230, min_days: 2, max_days: 3 },
{ pincode: 122231, min_days: 2, max_days: 3 },
{ pincode: 122232, min_days: 2, max_days: 3 },
{ pincode: 122233, min_days: 2, max_days: 3 },
{ pincode: 122234, min_days: 2, max_days: 3 },
{ pincode: 122413, min_days: 2, max_days: 3 },
{ pincode: 122414, min_days: 2, max_days: 3 },
{ pincode: 122502, min_days: 2, max_days: 3 },
{ pincode: 122503, min_days: 2, max_days: 3 },
{ pincode: 122504, min_days: 2, max_days: 3 },
{ pincode: 122505, min_days: 2, max_days: 3 },
{ pincode: 122506, min_days: 2, max_days: 3 },
{ pincode: 122508, min_days: 2, max_days: 3 },
{ pincode: 123001, min_days: 2, max_days: 3 },
{ pincode: 123003, min_days: 2, max_days: 3 },
{ pincode: 123021, min_days: 2, max_days: 3 },
{ pincode: 123023, min_days: 2, max_days: 3 },
{ pincode: 123024, min_days: 2, max_days: 3 },
{ pincode: 123027, min_days: 2, max_days: 3 },
{ pincode: 123028, min_days: 2, max_days: 3 },
{ pincode: 123029, min_days: 2, max_days: 3 },
{ pincode: 123031, min_days: 2, max_days: 3 },
{ pincode: 123034, min_days: 2, max_days: 3 },
{ pincode: 123035, min_days: 2, max_days: 3 },
{ pincode: 123101, min_days: 2, max_days: 3 },
{ pincode: 123102, min_days: 2, max_days: 3 },
{ pincode: 123103, min_days: 2, max_days: 3 },
{ pincode: 123106, min_days: 2, max_days: 3 },
{ pincode: 123110, min_days: 2, max_days: 3 },
{ pincode: 123301, min_days: 2, max_days: 3 },
{ pincode: 123302, min_days: 2, max_days: 3 },
{ pincode: 123303, min_days: 2, max_days: 3 },
{ pincode: 123304, min_days: 2, max_days: 3 },
{ pincode: 123305, min_days: 2, max_days: 3 },
{ pincode: 123401, min_days: 2, max_days: 3 },
{ pincode: 123411, min_days: 2, max_days: 3 },
{ pincode: 123412, min_days: 2, max_days: 3 },
{ pincode: 123413, min_days: 2, max_days: 3 },
{ pincode: 123414, min_days: 2, max_days: 3 },
{ pincode: 123501, min_days: 2, max_days: 3 },
{ pincode: 123502, min_days: 2, max_days: 3 },
{ pincode: 123504, min_days: 2, max_days: 3 },
{ pincode: 123505, min_days: 2, max_days: 3 },
{ pincode: 123506, min_days: 2, max_days: 3 },
{ pincode: 123507, min_days: 2, max_days: 3 },
{ pincode: 124001, min_days: 2, max_days: 3 },
{ pincode: 124010, min_days: 2, max_days: 3 },
{ pincode: 124021, min_days: 2, max_days: 3 },
{ pincode: 124022, min_days: 2, max_days: 3 },
{ pincode: 124101, min_days: 2, max_days: 3 },
{ pincode: 124102, min_days: 2, max_days: 3 },
{ pincode: 124103, min_days: 2, max_days: 3 },
{ pincode: 124104, min_days: 2, max_days: 3 },
{ pincode: 124105, min_days: 2, max_days: 3 },
{ pincode: 124106, min_days: 2, max_days: 3 },
{ pincode: 124107, min_days: 2, max_days: 3 },
{ pincode: 124108, min_days: 2, max_days: 3 },
{ pincode: 124109, min_days: 2, max_days: 3 },
{ pincode: 124111, min_days: 2, max_days: 3 },
{ pincode: 124112, min_days: 2, max_days: 3 },
{ pincode: 124113, min_days: 2, max_days: 3 },
{ pincode: 124127, min_days: 2, max_days: 3 },
{ pincode: 124139, min_days: 2, max_days: 3 },
{ pincode: 124141, min_days: 2, max_days: 3 },
{ pincode: 124142, min_days: 2, max_days: 3 },
{ pincode: 124146, min_days: 2, max_days: 3 },
{ pincode: 124201, min_days: 2, max_days: 3 },
{ pincode: 124202, min_days: 2, max_days: 3 },
{ pincode: 124203, min_days: 2, max_days: 3 },
{ pincode: 124303, min_days: 2, max_days: 3 },
{ pincode: 124401, min_days: 2, max_days: 3 },
{ pincode: 124404, min_days: 2, max_days: 3 },
{ pincode: 124406, min_days: 2, max_days: 3 },
{ pincode: 124411, min_days: 2, max_days: 3 },
{ pincode: 124412, min_days: 2, max_days: 3 },
{ pincode: 124416, min_days: 2, max_days: 3 },
{ pincode: 124501, min_days: 2, max_days: 3 },
{ pincode: 124504, min_days: 2, max_days: 3 },
{ pincode: 124505, min_days: 2, max_days: 3 },
{ pincode: 124506, min_days: 2, max_days: 3 },
{ pincode: 124507, min_days: 2, max_days: 3 },
{ pincode: 124508, min_days: 2, max_days: 3 },
{ pincode: 124513, min_days: 2, max_days: 3 },
{ pincode: 124514, min_days: 2, max_days: 3 },
{ pincode: 124515, min_days: 2, max_days: 3 },
{ pincode: 124517, min_days: 2, max_days: 3 },
{ pincode: 125001, min_days: 2, max_days: 3 },
{ pincode: 125002, min_days: 2, max_days: 3 },
{ pincode: 125003, min_days: 2, max_days: 3 },
{ pincode: 125004, min_days: 2, max_days: 3 },
{ pincode: 125005, min_days: 2, max_days: 3 },
{ pincode: 125006, min_days: 2, max_days: 3 },
{ pincode: 125007, min_days: 2, max_days: 3 },
{ pincode: 125011, min_days: 2, max_days: 3 },
{ pincode: 125021, min_days: 2, max_days: 3 },
{ pincode: 125033, min_days: 2, max_days: 3 },
{ pincode: 125034, min_days: 2, max_days: 3 },
{ pincode: 125037, min_days: 2, max_days: 3 },
{ pincode: 125038, min_days: 2, max_days: 3 },
{ pincode: 125039, min_days: 2, max_days: 3 },
{ pincode: 125042, min_days: 2, max_days: 3 },
{ pincode: 125044, min_days: 2, max_days: 3 },
{ pincode: 125047, min_days: 2, max_days: 3 },
{ pincode: 125048, min_days: 2, max_days: 3 },
{ pincode: 125049, min_days: 2, max_days: 3 },
{ pincode: 125050, min_days: 2, max_days: 3 },
{ pincode: 125051, min_days: 2, max_days: 3 },
{ pincode: 125052, min_days: 2, max_days: 3 },
{ pincode: 125053, min_days: 2, max_days: 3 },
{ pincode: 125054, min_days: 2, max_days: 3 },
{ pincode: 125055, min_days: 2, max_days: 3 },
{ pincode: 125056, min_days: 2, max_days: 3 },
{ pincode: 125057, min_days: 2, max_days: 3 },
{ pincode: 125058, min_days: 2, max_days: 3 },
{ pincode: 125060, min_days: 2, max_days: 3 },
{ pincode: 125075, min_days: 2, max_days: 3 },
{ pincode: 125076, min_days: 2, max_days: 3 },
{ pincode: 125077, min_days: 2, max_days: 3 },
{ pincode: 125078, min_days: 2, max_days: 3 },
{ pincode: 125101, min_days: 2, max_days: 3 },
{ pincode: 125102, min_days: 2, max_days: 3 },
{ pincode: 125103, min_days: 2, max_days: 3 },
{ pincode: 125104, min_days: 2, max_days: 3 },
{ pincode: 125106, min_days: 2, max_days: 3 },
{ pincode: 125110, min_days: 2, max_days: 3 },
{ pincode: 125111, min_days: 2, max_days: 3 },
{ pincode: 125112, min_days: 2, max_days: 3 },
{ pincode: 125113, min_days: 2, max_days: 3 },
{ pincode: 125120, min_days: 2, max_days: 3 },
{ pincode: 125121, min_days: 2, max_days: 3 },
{ pincode: 125122, min_days: 2, max_days: 3 },
{ pincode: 125133, min_days: 2, max_days: 3 },
{ pincode: 125201, min_days: 2, max_days: 3 },
{ pincode: 126001, min_days: 2, max_days: 3 },
{ pincode: 126008, min_days: 2, max_days: 3 },
{ pincode: 126101, min_days: 2, max_days: 3 },
{ pincode: 126102, min_days: 2, max_days: 3 },
{ pincode: 126104, min_days: 2, max_days: 3 },
{ pincode: 126110, min_days: 2, max_days: 3 },
{ pincode: 126111, min_days: 2, max_days: 3 },
{ pincode: 126112, min_days: 2, max_days: 3 },
{ pincode: 126113, min_days: 2, max_days: 3 },
{ pincode: 126114, min_days: 2, max_days: 3 },
{ pincode: 126115, min_days: 2, max_days: 3 },
{ pincode: 126116, min_days: 2, max_days: 3 },
{ pincode: 126125, min_days: 2, max_days: 3 },
{ pincode: 126126, min_days: 2, max_days: 3 },
{ pincode: 126127, min_days: 2, max_days: 3 },
{ pincode: 126128, min_days: 2, max_days: 3 },
{ pincode: 126152, min_days: 2, max_days: 3 },
{ pincode: 127020, min_days: 2, max_days: 3 },
{ pincode: 127021, min_days: 2, max_days: 3 },
{ pincode: 127022, min_days: 2, max_days: 3 },
{ pincode: 127025, min_days: 2, max_days: 3 },
{ pincode: 127026, min_days: 2, max_days: 3 },
{ pincode: 127027, min_days: 2, max_days: 3 },
{ pincode: 127028, min_days: 2, max_days: 3 },
{ pincode: 127029, min_days: 2, max_days: 3 },
{ pincode: 127030, min_days: 2, max_days: 3 },
{ pincode: 127031, min_days: 2, max_days: 3 },
{ pincode: 127032, min_days: 2, max_days: 3 },
{ pincode: 127035, min_days: 2, max_days: 3 },
{ pincode: 127040, min_days: 2, max_days: 3 },
{ pincode: 127041, min_days: 2, max_days: 3 },
{ pincode: 127042, min_days: 2, max_days: 3 },
{ pincode: 127043, min_days: 2, max_days: 3 },
{ pincode: 127045, min_days: 2, max_days: 3 },
{ pincode: 127046, min_days: 2, max_days: 3 },
{ pincode: 127110, min_days: 2, max_days: 3 },
{ pincode: 127111, min_days: 2, max_days: 3 },
{ pincode: 127114, min_days: 2, max_days: 3 },
{ pincode: 127201, min_days: 2, max_days: 3 },
{ pincode: 127306, min_days: 2, max_days: 3 },
{ pincode: 127307, min_days: 2, max_days: 3 },
{ pincode: 127308, min_days: 2, max_days: 3 },
{ pincode: 127309, min_days: 2, max_days: 3 },
{ pincode: 127310, min_days: 2, max_days: 3 },
{ pincode: 127311, min_days: 2, max_days: 3 },
{ pincode: 127312, min_days: 2, max_days: 3 },
{ pincode: 131001, min_days: 2, max_days: 3 },
{ pincode: 131002, min_days: 2, max_days: 3 },
{ pincode: 131021, min_days: 2, max_days: 3 },
{ pincode: 131022, min_days: 2, max_days: 3 },
{ pincode: 131023, min_days: 2, max_days: 3 },
{ pincode: 131024, min_days: 2, max_days: 3 },
{ pincode: 131027, min_days: 2, max_days: 3 },
{ pincode: 131028, min_days: 2, max_days: 3 },
{ pincode: 131029, min_days: 2, max_days: 3 },
{ pincode: 131030, min_days: 2, max_days: 3 },
{ pincode: 131038, min_days: 2, max_days: 3 },
{ pincode: 131039, min_days: 2, max_days: 3 },
{ pincode: 131040, min_days: 2, max_days: 3 },
{ pincode: 131101, min_days: 2, max_days: 3 },
{ pincode: 131102, min_days: 2, max_days: 3 },
{ pincode: 131103, min_days: 2, max_days: 3 },
{ pincode: 131301, min_days: 2, max_days: 3 },
{ pincode: 131302, min_days: 2, max_days: 3 },
{ pincode: 131303, min_days: 2, max_days: 3 },
{ pincode: 131304, min_days: 2, max_days: 3 },
{ pincode: 131305, min_days: 2, max_days: 3 },
{ pincode: 131306, min_days: 2, max_days: 3 },
{ pincode: 131310, min_days: 2, max_days: 3 },
{ pincode: 131402, min_days: 2, max_days: 3 },
{ pincode: 131403, min_days: 2, max_days: 3 },
{ pincode: 131407, min_days: 2, max_days: 3 },
{ pincode: 131408, min_days: 2, max_days: 3 },
{ pincode: 131409, min_days: 2, max_days: 3 },
{ pincode: 132001, min_days: 2, max_days: 3 },
{ pincode: 132004, min_days: 2, max_days: 3 },
{ pincode: 132021, min_days: 2, max_days: 3 },
{ pincode: 132022, min_days: 2, max_days: 3 },
{ pincode: 132023, min_days: 2, max_days: 3 },
{ pincode: 132024, min_days: 2, max_days: 3 },
{ pincode: 132025, min_days: 2, max_days: 3 },
{ pincode: 132026, min_days: 2, max_days: 3 },
{ pincode: 132036, min_days: 2, max_days: 3 },
{ pincode: 132037, min_days: 2, max_days: 3 },
{ pincode: 132039, min_days: 2, max_days: 3 },
{ pincode: 132040, min_days: 2, max_days: 3 },
{ pincode: 132041, min_days: 2, max_days: 3 },
{ pincode: 132046, min_days: 2, max_days: 3 },
{ pincode: 132054, min_days: 2, max_days: 3 },
{ pincode: 132101, min_days: 2, max_days: 3 },
{ pincode: 132102, min_days: 2, max_days: 3 },
{ pincode: 132103, min_days: 2, max_days: 3 },
{ pincode: 132104, min_days: 2, max_days: 3 },
{ pincode: 132105, min_days: 2, max_days: 3 },
{ pincode: 132106, min_days: 2, max_days: 3 },
{ pincode: 132107, min_days: 2, max_days: 3 },
{ pincode: 132108, min_days: 2, max_days: 3 },
{ pincode: 132110, min_days: 2, max_days: 3 },
{ pincode: 132113, min_days: 2, max_days: 3 },
{ pincode: 132114, min_days: 2, max_days: 3 },
{ pincode: 132115, min_days: 2, max_days: 3 },
{ pincode: 132116, min_days: 2, max_days: 3 },
{ pincode: 132117, min_days: 2, max_days: 3 },
{ pincode: 132118, min_days: 2, max_days: 3 },
{ pincode: 132119, min_days: 2, max_days: 3 },
{ pincode: 132122, min_days: 2, max_days: 3 },
{ pincode: 132123, min_days: 2, max_days: 3 },
{ pincode: 132140, min_days: 2, max_days: 3 },
{ pincode: 132145, min_days: 2, max_days: 3 },
{ pincode: 132151, min_days: 2, max_days: 3 },
{ pincode: 132152, min_days: 2, max_days: 3 },
{ pincode: 132157, min_days: 2, max_days: 3 },
{ pincode: 133001, min_days: 2, max_days: 3 },
{ pincode: 133002, min_days: 2, max_days: 3 },
{ pincode: 133003, min_days: 2, max_days: 3 },
{ pincode: 133004, min_days: 2, max_days: 3 },
{ pincode: 133005, min_days: 2, max_days: 3 },
{ pincode: 133006, min_days: 2, max_days: 3 },
{ pincode: 133007, min_days: 2, max_days: 3 },
{ pincode: 133008, min_days: 2, max_days: 3 },
{ pincode: 133010, min_days: 2, max_days: 3 },
{ pincode: 133021, min_days: 2, max_days: 3 },
{ pincode: 133101, min_days: 2, max_days: 3 },
{ pincode: 133102, min_days: 2, max_days: 3 },
{ pincode: 133103, min_days: 2, max_days: 3 },
{ pincode: 133104, min_days: 2, max_days: 3 },
{ pincode: 133105, min_days: 2, max_days: 3 },
{ pincode: 133201, min_days: 2, max_days: 3 },
{ pincode: 133202, min_days: 2, max_days: 3 },
{ pincode: 133203, min_days: 2, max_days: 3 },
{ pincode: 133204, min_days: 2, max_days: 3 },
{ pincode: 133205, min_days: 2, max_days: 3 },
{ pincode: 133206, min_days: 2, max_days: 3 },
{ pincode: 133207, min_days: 2, max_days: 3 },
{ pincode: 133301, min_days: 2, max_days: 3 },
{ pincode: 133302, min_days: 2, max_days: 3 },
{ pincode: 134001, min_days: 2, max_days: 3 },
{ pincode: 134002, min_days: 2, max_days: 3 },
{ pincode: 134003, min_days: 2, max_days: 3 },
{ pincode: 134004, min_days: 2, max_days: 3 },
{ pincode: 134005, min_days: 2, max_days: 3 },
{ pincode: 134006, min_days: 2, max_days: 3 },
{ pincode: 134007, min_days: 2, max_days: 3 },
{ pincode: 134008, min_days: 2, max_days: 3 },
{ pincode: 134009, min_days: 2, max_days: 3 },
{ pincode: 134011, min_days: 2, max_days: 3 },
{ pincode: 134012, min_days: 2, max_days: 3 },
{ pincode: 134101, min_days: 2, max_days: 3 },
{ pincode: 134102, min_days: 2, max_days: 3 },
{ pincode: 134103, min_days: 2, max_days: 3 },
{ pincode: 134104, min_days: 2, max_days: 3 },
{ pincode: 134105, min_days: 2, max_days: 3 },
{ pincode: 134107, min_days: 2, max_days: 3 },
{ pincode: 134108, min_days: 2, max_days: 3 },
{ pincode: 134109, min_days: 2, max_days: 3 },
{ pincode: 134110, min_days: 2, max_days: 3 },
{ pincode: 134111, min_days: 2, max_days: 3 },
{ pincode: 134112, min_days: 2, max_days: 3 },
{ pincode: 134113, min_days: 2, max_days: 3 },
{ pincode: 134114, min_days: 2, max_days: 3 },
{ pincode: 134115, min_days: 2, max_days: 3 },
{ pincode: 134116, min_days: 2, max_days: 3 },
{ pincode: 134117, min_days: 2, max_days: 3 },
{ pincode: 134118, min_days: 2, max_days: 3 },
{ pincode: 134119, min_days: 2, max_days: 3 },
{ pincode: 134126, min_days: 2, max_days: 3 },
{ pincode: 134151, min_days: 2, max_days: 3 },
{ pincode: 134152, min_days: 2, max_days: 3 },
{ pincode: 134201, min_days: 2, max_days: 3 },
{ pincode: 134202, min_days: 2, max_days: 3 },
{ pincode: 134203, min_days: 2, max_days: 3 },
{ pincode: 134204, min_days: 2, max_days: 3 },
{ pincode: 134205, min_days: 2, max_days: 3 },
{ pincode: 135001, min_days: 2, max_days: 3 },
{ pincode: 135002, min_days: 2, max_days: 3 },
{ pincode: 135003, min_days: 2, max_days: 3 },
{ pincode: 135004, min_days: 2, max_days: 3 },
{ pincode: 135021, min_days: 2, max_days: 3 },
{ pincode: 135101, min_days: 2, max_days: 3 },
{ pincode: 135102, min_days: 2, max_days: 3 },
{ pincode: 135103, min_days: 2, max_days: 3 },
{ pincode: 135105, min_days: 2, max_days: 3 },
{ pincode: 135106, min_days: 2, max_days: 3 },
{ pincode: 135133, min_days: 2, max_days: 3 },
{ pincode: 136020, min_days: 2, max_days: 3 },
{ pincode: 136021, min_days: 2, max_days: 3 },
{ pincode: 136026, min_days: 2, max_days: 3 },
{ pincode: 136027, min_days: 2, max_days: 3 },
{ pincode: 136030, min_days: 2, max_days: 3 },
{ pincode: 136033, min_days: 2, max_days: 3 },
{ pincode: 136034, min_days: 2, max_days: 3 },
{ pincode: 136035, min_days: 2, max_days: 3 },
{ pincode: 136038, min_days: 2, max_days: 3 },
{ pincode: 136042, min_days: 2, max_days: 3 },
{ pincode: 136043, min_days: 2, max_days: 3 },
{ pincode: 136044, min_days: 2, max_days: 3 },
{ pincode: 136117, min_days: 2, max_days: 3 },
{ pincode: 136118, min_days: 2, max_days: 3 },
{ pincode: 136119, min_days: 2, max_days: 3 },
{ pincode: 136128, min_days: 2, max_days: 3 },
{ pincode: 136129, min_days: 2, max_days: 3 },
{ pincode: 136130, min_days: 2, max_days: 3 },
{ pincode: 136131, min_days: 2, max_days: 3 },
{ pincode: 136132, min_days: 2, max_days: 3 },
{ pincode: 136134, min_days: 2, max_days: 3 },
{ pincode: 136135, min_days: 2, max_days: 3 },
{ pincode: 136136, min_days: 2, max_days: 3 },
{ pincode: 136156, min_days: 2, max_days: 3 },
{ pincode: 140001, min_days: 2, max_days: 3 },
{ pincode: 140063, min_days: 2, max_days: 3 },
{ pincode: 140101, min_days: 2, max_days: 3 },
{ pincode: 140102, min_days: 2, max_days: 3 },
{ pincode: 140103, min_days: 2, max_days: 3 },
{ pincode: 140104, min_days: 2, max_days: 3 },
{ pincode: 140105, min_days: 2, max_days: 3 },
{ pincode: 140108, min_days: 2, max_days: 3 },
{ pincode: 140109, min_days: 2, max_days: 3 },
{ pincode: 140110, min_days: 2, max_days: 3 },
{ pincode: 140111, min_days: 2, max_days: 3 },
{ pincode: 140112, min_days: 2, max_days: 3 },
{ pincode: 140113, min_days: 2, max_days: 3 },
{ pincode: 140114, min_days: 2, max_days: 3 },
{ pincode: 140115, min_days: 2, max_days: 3 },
{ pincode: 140116, min_days: 2, max_days: 3 },
{ pincode: 140117, min_days: 2, max_days: 3 },
{ pincode: 140118, min_days: 2, max_days: 3 },
{ pincode: 140119, min_days: 2, max_days: 3 },
{ pincode: 140123, min_days: 2, max_days: 3 },
{ pincode: 140124, min_days: 2, max_days: 3 },
{ pincode: 140125, min_days: 2, max_days: 3 },
{ pincode: 140126, min_days: 2, max_days: 3 },
{ pincode: 140127, min_days: 2, max_days: 3 },
{ pincode: 140128, min_days: 2, max_days: 3 },
{ pincode: 140133, min_days: 2, max_days: 3 },
{ pincode: 140201, min_days: 2, max_days: 3 },
{ pincode: 140202, min_days: 2, max_days: 3 },
{ pincode: 140203, min_days: 2, max_days: 3 },
{ pincode: 140301, min_days: 2, max_days: 3 },
{ pincode: 140306, min_days: 2, max_days: 3 },
{ pincode: 140307, min_days: 2, max_days: 3 },
{ pincode: 140308, min_days: 2, max_days: 3 },
{ pincode: 140401, min_days: 2, max_days: 3 },
{ pincode: 140402, min_days: 2, max_days: 3 },
{ pincode: 140405, min_days: 2, max_days: 3 },
{ pincode: 140406, min_days: 2, max_days: 3 },
{ pincode: 140407, min_days: 2, max_days: 3 },
{ pincode: 140408, min_days: 2, max_days: 3 },
{ pincode: 140412, min_days: 2, max_days: 3 },
{ pincode: 140413, min_days: 2, max_days: 3 },
{ pincode: 140417, min_days: 2, max_days: 3 },
{ pincode: 140501, min_days: 2, max_days: 3 },
{ pincode: 140502, min_days: 2, max_days: 3 },
{ pincode: 140506, min_days: 2, max_days: 3 },
{ pincode: 140507, min_days: 2, max_days: 3 },
{ pincode: 140508, min_days: 2, max_days: 3 },
{ pincode: 140601, min_days: 2, max_days: 3 },
{ pincode: 140602, min_days: 2, max_days: 3 },
{ pincode: 140603, min_days: 2, max_days: 3 },
{ pincode: 140604, min_days: 2, max_days: 3 },
{ pincode: 140701, min_days: 2, max_days: 3 },
{ pincode: 140702, min_days: 2, max_days: 3 },
{ pincode: 140801, min_days: 2, max_days: 3 },
{ pincode: 140802, min_days: 2, max_days: 3 },
{ pincode: 140901, min_days: 2, max_days: 3 },
{ pincode: 141000, min_days: 2, max_days: 3 },
{ pincode: 141001, min_days: 2, max_days: 3 },
{ pincode: 141002, min_days: 2, max_days: 3 },
{ pincode: 141003, min_days: 2, max_days: 3 },
{ pincode: 141004, min_days: 2, max_days: 3 },
{ pincode: 141005, min_days: 2, max_days: 3 },
{ pincode: 141006, min_days: 2, max_days: 3 },
{ pincode: 141007, min_days: 2, max_days: 3 },
{ pincode: 141008, min_days: 2, max_days: 3 },
{ pincode: 141009, min_days: 2, max_days: 3 },
{ pincode: 141010, min_days: 2, max_days: 3 },
{ pincode: 141011, min_days: 2, max_days: 3 },
{ pincode: 141012, min_days: 2, max_days: 3 },
{ pincode: 141013, min_days: 2, max_days: 3 },
{ pincode: 141014, min_days: 2, max_days: 3 },
{ pincode: 141015, min_days: 2, max_days: 3 },
{ pincode: 141016, min_days: 2, max_days: 3 },
{ pincode: 141017, min_days: 2, max_days: 3 },
{ pincode: 141020, min_days: 2, max_days: 3 },
{ pincode: 141021, min_days: 2, max_days: 3 },
{ pincode: 141025, min_days: 2, max_days: 3 },
{ pincode: 141027, min_days: 2, max_days: 3 },
{ pincode: 141033, min_days: 2, max_days: 3 },
{ pincode: 141101, min_days: 2, max_days: 3 },
{ pincode: 141102, min_days: 2, max_days: 3 },
{ pincode: 141103, min_days: 2, max_days: 3 },
{ pincode: 141104, min_days: 2, max_days: 3 },
{ pincode: 141105, min_days: 2, max_days: 3 },
{ pincode: 141106, min_days: 2, max_days: 3 },
{ pincode: 141107, min_days: 2, max_days: 3 },
{ pincode: 141108, min_days: 2, max_days: 3 },
{ pincode: 141109, min_days: 2, max_days: 3 },
{ pincode: 141110, min_days: 2, max_days: 3 },
{ pincode: 141111, min_days: 2, max_days: 3 },
{ pincode: 141112, min_days: 2, max_days: 3 },
{ pincode: 141113, min_days: 2, max_days: 3 },
{ pincode: 141114, min_days: 2, max_days: 3 },
{ pincode: 141115, min_days: 2, max_days: 3 },
{ pincode: 141116, min_days: 2, max_days: 3 },
{ pincode: 141117, min_days: 2, max_days: 3 },
{ pincode: 141118, min_days: 2, max_days: 3 },
{ pincode: 141119, min_days: 2, max_days: 3 },
{ pincode: 141120, min_days: 2, max_days: 3 },
{ pincode: 141121, min_days: 2, max_days: 3 },
{ pincode: 141122, min_days: 2, max_days: 3 },
{ pincode: 141123, min_days: 2, max_days: 3 },
{ pincode: 141124, min_days: 2, max_days: 3 },
{ pincode: 141125, min_days: 2, max_days: 3 },
{ pincode: 141126, min_days: 2, max_days: 3 },
{ pincode: 141127, min_days: 2, max_days: 3 },
{ pincode: 141201, min_days: 2, max_days: 3 },
{ pincode: 141202, min_days: 2, max_days: 3 },
{ pincode: 141203, min_days: 2, max_days: 3 },
{ pincode: 141204, min_days: 2, max_days: 3 },
{ pincode: 141205, min_days: 2, max_days: 3 },
{ pincode: 141206, min_days: 2, max_days: 3 },
{ pincode: 141231, min_days: 2, max_days: 3 },
{ pincode: 141234, min_days: 2, max_days: 3 },
{ pincode: 141301, min_days: 2, max_days: 3 },
{ pincode: 141302, min_days: 2, max_days: 3 },
{ pincode: 141303, min_days: 2, max_days: 3 },
{ pincode: 141304, min_days: 2, max_days: 3 },
{ pincode: 141305, min_days: 2, max_days: 3 },
{ pincode: 141306, min_days: 2, max_days: 3 },
{ pincode: 141307, min_days: 2, max_days: 3 },
{ pincode: 141308, min_days: 2, max_days: 3 },
{ pincode: 141309, min_days: 2, max_days: 3 },
{ pincode: 141310, min_days: 2, max_days: 3 },
{ pincode: 141311, min_days: 2, max_days: 3 },
{ pincode: 141315, min_days: 2, max_days: 3 },
{ pincode: 141317, min_days: 2, max_days: 3 },
{ pincode: 141318, min_days: 2, max_days: 3 },
{ pincode: 141400, min_days: 2, max_days: 3 },
{ pincode: 141401, min_days: 2, max_days: 3 },
{ pincode: 141402, min_days: 2, max_days: 3 },
{ pincode: 141411, min_days: 2, max_days: 3 },
{ pincode: 141412, min_days: 2, max_days: 3 },
{ pincode: 141413, min_days: 2, max_days: 3 },
{ pincode: 141414, min_days: 2, max_days: 3 },
{ pincode: 141415, min_days: 2, max_days: 3 },
{ pincode: 141416, min_days: 2, max_days: 3 },
{ pincode: 141417, min_days: 2, max_days: 3 },
{ pincode: 141418, min_days: 2, max_days: 3 },
{ pincode: 141419, min_days: 2, max_days: 3 },
{ pincode: 141420, min_days: 2, max_days: 3 },
{ pincode: 141421, min_days: 2, max_days: 3 },
{ pincode: 141422, min_days: 2, max_days: 3 },
{ pincode: 141801, min_days: 2, max_days: 3 },
{ pincode: 142001, min_days: 2, max_days: 3 },
{ pincode: 142002, min_days: 2, max_days: 3 },
{ pincode: 142003, min_days: 2, max_days: 3 },
{ pincode: 142011, min_days: 2, max_days: 3 },
{ pincode: 142021, min_days: 2, max_days: 3 },
{ pincode: 142022, min_days: 2, max_days: 3 },
{ pincode: 142023, min_days: 2, max_days: 3 },
{ pincode: 142024, min_days: 2, max_days: 3 },
{ pincode: 142025, min_days: 2, max_days: 3 },
{ pincode: 142026, min_days: 2, max_days: 3 },
{ pincode: 142027, min_days: 2, max_days: 3 },
{ pincode: 142028, min_days: 2, max_days: 3 },
{ pincode: 142029, min_days: 2, max_days: 3 },
{ pincode: 142030, min_days: 2, max_days: 3 },
{ pincode: 142031, min_days: 2, max_days: 3 },
{ pincode: 142032, min_days: 2, max_days: 3 },
{ pincode: 142033, min_days: 2, max_days: 3 },
{ pincode: 142034, min_days: 2, max_days: 3 },
{ pincode: 142035, min_days: 2, max_days: 3 },
{ pincode: 142036, min_days: 2, max_days: 3 },
{ pincode: 142037, min_days: 2, max_days: 3 },
{ pincode: 142038, min_days: 2, max_days: 3 },
{ pincode: 142039, min_days: 2, max_days: 3 },
{ pincode: 142040, min_days: 2, max_days: 3 },
{ pincode: 142041, min_days: 2, max_days: 3 },
{ pincode: 142042, min_days: 2, max_days: 3 },
{ pincode: 142043, min_days: 2, max_days: 3 },
{ pincode: 142044, min_days: 2, max_days: 3 },
{ pincode: 142045, min_days: 2, max_days: 3 },
{ pincode: 142046, min_days: 2, max_days: 3 },
{ pincode: 142047, min_days: 2, max_days: 3 },
{ pincode: 142048, min_days: 2, max_days: 3 },
{ pincode: 142049, min_days: 2, max_days: 3 },
{ pincode: 142050, min_days: 2, max_days: 3 },
{ pincode: 142051, min_days: 2, max_days: 3 },
{ pincode: 142052, min_days: 2, max_days: 3 },
{ pincode: 142053, min_days: 2, max_days: 3 },
{ pincode: 142054, min_days: 2, max_days: 3 },
{ pincode: 142055, min_days: 2, max_days: 3 },
{ pincode: 142056, min_days: 2, max_days: 3 },
{ pincode: 142057, min_days: 2, max_days: 3 },
{ pincode: 142058, min_days: 2, max_days: 3 },
{ pincode: 142059, min_days: 2, max_days: 3 },
{ pincode: 142060, min_days: 2, max_days: 3 },
{ pincode: 142061, min_days: 2, max_days: 3 },
{ pincode: 143000, min_days: 2, max_days: 3 },
{ pincode: 143001, min_days: 2, max_days: 3 },
{ pincode: 143002, min_days: 2, max_days: 3 },
{ pincode: 143003, min_days: 2, max_days: 3 },
{ pincode: 143004, min_days: 2, max_days: 3 },
{ pincode: 143005, min_days: 2, max_days: 3 },
{ pincode: 143006, min_days: 2, max_days: 3 },
{ pincode: 143007, min_days: 2, max_days: 3 },
{ pincode: 143008, min_days: 2, max_days: 3 },
{ pincode: 143009, min_days: 2, max_days: 3 },
{ pincode: 143010, min_days: 2, max_days: 3 },
{ pincode: 143021, min_days: 2, max_days: 3 },
{ pincode: 143022, min_days: 2, max_days: 3 },
{ pincode: 143026, min_days: 2, max_days: 3 },
{ pincode: 143036, min_days: 2, max_days: 3 },
{ pincode: 143044, min_days: 2, max_days: 3 },
{ pincode: 143066, min_days: 2, max_days: 3 },
{ pincode: 143093, min_days: 2, max_days: 3 },
{ pincode: 143101, min_days: 2, max_days: 3 },
{ pincode: 143102, min_days: 2, max_days: 3 },
{ pincode: 143103, min_days: 2, max_days: 3 },
{ pincode: 143104, min_days: 2, max_days: 3 },
{ pincode: 143105, min_days: 2, max_days: 3 },
{ pincode: 143106, min_days: 2, max_days: 3 },
{ pincode: 143107, min_days: 2, max_days: 3 },
{ pincode: 143108, min_days: 2, max_days: 3 },
{ pincode: 143109, min_days: 2, max_days: 3 },
{ pincode: 143110, min_days: 2, max_days: 3 },
{ pincode: 143111, min_days: 2, max_days: 3 },
{ pincode: 143112, min_days: 2, max_days: 3 },
{ pincode: 143113, min_days: 2, max_days: 3 },
{ pincode: 143114, min_days: 2, max_days: 3 },
{ pincode: 143115, min_days: 2, max_days: 3 },
{ pincode: 143116, min_days: 2, max_days: 3 },
{ pincode: 143117, min_days: 2, max_days: 3 },
{ pincode: 143118, min_days: 2, max_days: 3 },
{ pincode: 143119, min_days: 2, max_days: 3 },
{ pincode: 143149, min_days: 2, max_days: 3 },
{ pincode: 143201, min_days: 2, max_days: 3 },
{ pincode: 143202, min_days: 2, max_days: 3 },
{ pincode: 143203, min_days: 2, max_days: 3 },
{ pincode: 143204, min_days: 2, max_days: 3 },
{ pincode: 143205, min_days: 2, max_days: 3 },
{ pincode: 143301, min_days: 2, max_days: 3 },
{ pincode: 143302, min_days: 2, max_days: 3 },
{ pincode: 143303, min_days: 2, max_days: 3 },
{ pincode: 143304, min_days: 2, max_days: 3 },
{ pincode: 143305, min_days: 2, max_days: 3 },
{ pincode: 143306, min_days: 2, max_days: 3 },
{ pincode: 143401, min_days: 2, max_days: 3 },
{ pincode: 143402, min_days: 2, max_days: 3 },
{ pincode: 143406, min_days: 2, max_days: 3 },
{ pincode: 143407, min_days: 2, max_days: 3 },
{ pincode: 143408, min_days: 2, max_days: 3 },
{ pincode: 143409, min_days: 2, max_days: 3 },
{ pincode: 143410, min_days: 2, max_days: 3 },
{ pincode: 143411, min_days: 2, max_days: 3 },
{ pincode: 143412, min_days: 2, max_days: 3 },
{ pincode: 143413, min_days: 2, max_days: 3 },
{ pincode: 143414, min_days: 2, max_days: 3 },
{ pincode: 143415, min_days: 2, max_days: 3 },
{ pincode: 143416, min_days: 2, max_days: 3 },
{ pincode: 143417, min_days: 2, max_days: 3 },
{ pincode: 143418, min_days: 2, max_days: 3 },
{ pincode: 143419, min_days: 2, max_days: 3 },
{ pincode: 143420, min_days: 2, max_days: 3 },
{ pincode: 143421, min_days: 2, max_days: 3 },
{ pincode: 143422, min_days: 2, max_days: 3 },
{ pincode: 143423, min_days: 2, max_days: 3 },
{ pincode: 143501, min_days: 2, max_days: 3 },
{ pincode: 143502, min_days: 2, max_days: 3 },
{ pincode: 143503, min_days: 2, max_days: 3 },
{ pincode: 143504, min_days: 2, max_days: 3 },
{ pincode: 143505, min_days: 2, max_days: 3 },
{ pincode: 143506, min_days: 2, max_days: 3 },
{ pincode: 143507, min_days: 2, max_days: 3 },
{ pincode: 143508, min_days: 2, max_days: 3 },
{ pincode: 143510, min_days: 2, max_days: 3 },
{ pincode: 143511, min_days: 2, max_days: 3 },
{ pincode: 143512, min_days: 2, max_days: 3 },
{ pincode: 143513, min_days: 2, max_days: 3 },
{ pincode: 143514, min_days: 2, max_days: 3 },
{ pincode: 143515, min_days: 2, max_days: 3 },
{ pincode: 143516, min_days: 2, max_days: 3 },
{ pincode: 143517, min_days: 2, max_days: 3 },
{ pincode: 143518, min_days: 2, max_days: 3 },
{ pincode: 143519, min_days: 2, max_days: 3 },
{ pincode: 143520, min_days: 2, max_days: 3 },
{ pincode: 143521, min_days: 2, max_days: 3 },
{ pincode: 143523, min_days: 2, max_days: 3 },
{ pincode: 143525, min_days: 2, max_days: 3 },
{ pincode: 143526, min_days: 2, max_days: 3 },
{ pincode: 143527, min_days: 2, max_days: 3 },
{ pincode: 143528, min_days: 2, max_days: 3 },
{ pincode: 143529, min_days: 2, max_days: 3 },
{ pincode: 143530, min_days: 2, max_days: 3 },
{ pincode: 143531, min_days: 2, max_days: 3 },
{ pincode: 143532, min_days: 2, max_days: 3 },
{ pincode: 143533, min_days: 2, max_days: 3 },
{ pincode: 143534, min_days: 2, max_days: 3 },
{ pincode: 143535, min_days: 2, max_days: 3 },
{ pincode: 143536, min_days: 2, max_days: 3 },
{ pincode: 143537, min_days: 2, max_days: 3 },
{ pincode: 143538, min_days: 2, max_days: 3 },
{ pincode: 143601, min_days: 2, max_days: 3 },
{ pincode: 143602, min_days: 2, max_days: 3 },
{ pincode: 143603, min_days: 2, max_days: 3 },
{ pincode: 143604, min_days: 2, max_days: 3 },
{ pincode: 143605, min_days: 2, max_days: 3 },
{ pincode: 143606, min_days: 2, max_days: 3 },
{ pincode: 143607, min_days: 2, max_days: 3 },
{ pincode: 143804, min_days: 2, max_days: 3 },
{ pincode: 144000, min_days: 2, max_days: 3 },
{ pincode: 144001, min_days: 2, max_days: 3 },
{ pincode: 144002, min_days: 2, max_days: 3 },
{ pincode: 144003, min_days: 2, max_days: 3 },
{ pincode: 144004, min_days: 2, max_days: 3 },
{ pincode: 144005, min_days: 2, max_days: 3 },
{ pincode: 144006, min_days: 2, max_days: 3 },
{ pincode: 144007, min_days: 2, max_days: 3 },
{ pincode: 144008, min_days: 2, max_days: 3 },
{ pincode: 144009, min_days: 2, max_days: 3 },
{ pincode: 144010, min_days: 2, max_days: 3 },
{ pincode: 144011, min_days: 2, max_days: 3 },
{ pincode: 144012, min_days: 2, max_days: 3 },
{ pincode: 144013, min_days: 2, max_days: 3 },
{ pincode: 144014, min_days: 2, max_days: 3 },
{ pincode: 144015, min_days: 2, max_days: 3 },
{ pincode: 144019, min_days: 2, max_days: 3 },
{ pincode: 144020, min_days: 2, max_days: 3 },
{ pincode: 144021, min_days: 2, max_days: 3 },
{ pincode: 144022, min_days: 2, max_days: 3 },
{ pincode: 144023, min_days: 2, max_days: 3 },
{ pincode: 144024, min_days: 2, max_days: 3 },
{ pincode: 144025, min_days: 2, max_days: 3 },
{ pincode: 144026, min_days: 2, max_days: 3 },
{ pincode: 144027, min_days: 2, max_days: 3 },
{ pincode: 144028, min_days: 2, max_days: 3 },
{ pincode: 144029, min_days: 2, max_days: 3 },
{ pincode: 144030, min_days: 2, max_days: 3 },
{ pincode: 144031, min_days: 2, max_days: 3 },
{ pincode: 144032, min_days: 2, max_days: 3 },
{ pincode: 144033, min_days: 2, max_days: 3 },
{ pincode: 144034, min_days: 2, max_days: 3 },
{ pincode: 144035, min_days: 2, max_days: 3 },
{ pincode: 144036, min_days: 2, max_days: 3 },
{ pincode: 144037, min_days: 2, max_days: 3 },
{ pincode: 144038, min_days: 2, max_days: 3 },
{ pincode: 144039, min_days: 2, max_days: 3 },
{ pincode: 144040, min_days: 2, max_days: 3 },
{ pincode: 144041, min_days: 2, max_days: 3 },
{ pincode: 144042, min_days: 2, max_days: 3 },
{ pincode: 144043, min_days: 2, max_days: 3 },
{ pincode: 144044, min_days: 2, max_days: 3 },
{ pincode: 144046, min_days: 2, max_days: 3 },
{ pincode: 144047, min_days: 2, max_days: 3 },
{ pincode: 144048, min_days: 2, max_days: 3 },
{ pincode: 144049, min_days: 2, max_days: 3 },
{ pincode: 144050, min_days: 2, max_days: 3 },
{ pincode: 144051, min_days: 2, max_days: 3 },
{ pincode: 144052, min_days: 2, max_days: 3 },
{ pincode: 144053, min_days: 2, max_days: 3 },
{ pincode: 144101, min_days: 2, max_days: 3 },
{ pincode: 144102, min_days: 2, max_days: 3 },
{ pincode: 144103, min_days: 2, max_days: 3 },
{ pincode: 144104, min_days: 2, max_days: 3 },
{ pincode: 144105, min_days: 2, max_days: 3 },
{ pincode: 144106, min_days: 2, max_days: 3 },
{ pincode: 144201, min_days: 2, max_days: 3 },
{ pincode: 144202, min_days: 2, max_days: 3 },
{ pincode: 144203, min_days: 2, max_days: 3 },
{ pincode: 144204, min_days: 2, max_days: 3 },
{ pincode: 144205, min_days: 2, max_days: 3 },
{ pincode: 144206, min_days: 2, max_days: 3 },
{ pincode: 144207, min_days: 2, max_days: 3 },
{ pincode: 144208, min_days: 2, max_days: 3 },
{ pincode: 144209, min_days: 2, max_days: 3 },
{ pincode: 144210, min_days: 2, max_days: 3 },
{ pincode: 144211, min_days: 2, max_days: 3 },
{ pincode: 144212, min_days: 2, max_days: 3 },
{ pincode: 144213, min_days: 2, max_days: 3 },
{ pincode: 144214, min_days: 2, max_days: 3 },
{ pincode: 144216, min_days: 2, max_days: 3 },
{ pincode: 144218, min_days: 2, max_days: 3 },
{ pincode: 144221, min_days: 2, max_days: 3 },
{ pincode: 144222, min_days: 2, max_days: 3 },
{ pincode: 144223, min_days: 2, max_days: 3 },
{ pincode: 144224, min_days: 2, max_days: 3 },
{ pincode: 144225, min_days: 2, max_days: 3 },
{ pincode: 144301, min_days: 2, max_days: 3 },
{ pincode: 144302, min_days: 2, max_days: 3 },
{ pincode: 144303, min_days: 2, max_days: 3 },
{ pincode: 144304, min_days: 2, max_days: 3 },
{ pincode: 144305, min_days: 2, max_days: 3 },
{ pincode: 144306, min_days: 2, max_days: 3 },
{ pincode: 144311, min_days: 2, max_days: 3 },
{ pincode: 144401, min_days: 2, max_days: 3 },
{ pincode: 144402, min_days: 2, max_days: 3 },
{ pincode: 144403, min_days: 2, max_days: 3 },
{ pincode: 144404, min_days: 2, max_days: 3 },
{ pincode: 144405, min_days: 2, max_days: 3 },
{ pincode: 144406, min_days: 2, max_days: 3 },
{ pincode: 144407, min_days: 2, max_days: 3 },
{ pincode: 144408, min_days: 2, max_days: 3 },
{ pincode: 144409, min_days: 2, max_days: 3 },
{ pincode: 144410, min_days: 2, max_days: 3 },
{ pincode: 144411, min_days: 2, max_days: 3 },
{ pincode: 144415, min_days: 2, max_days: 3 },
{ pincode: 144416, min_days: 2, max_days: 3 },
{ pincode: 144417, min_days: 2, max_days: 3 },
{ pincode: 144418, min_days: 2, max_days: 3 },
{ pincode: 144419, min_days: 2, max_days: 3 },
{ pincode: 144421, min_days: 2, max_days: 3 },
{ pincode: 144422, min_days: 2, max_days: 3 },
{ pincode: 144423, min_days: 2, max_days: 3 },
{ pincode: 144424, min_days: 2, max_days: 3 },
{ pincode: 144501, min_days: 2, max_days: 3 },
{ pincode: 144502, min_days: 2, max_days: 3 },
{ pincode: 144503, min_days: 2, max_days: 3 },
{ pincode: 144504, min_days: 2, max_days: 3 },
{ pincode: 144505, min_days: 2, max_days: 3 },
{ pincode: 144506, min_days: 2, max_days: 3 },
{ pincode: 144507, min_days: 2, max_days: 3 },
{ pincode: 144508, min_days: 2, max_days: 3 },
{ pincode: 144509, min_days: 2, max_days: 3 },
{ pincode: 144510, min_days: 2, max_days: 3 },
{ pincode: 144511, min_days: 2, max_days: 3 },
{ pincode: 144512, min_days: 2, max_days: 3 },
{ pincode: 144513, min_days: 2, max_days: 3 },
{ pincode: 144514, min_days: 2, max_days: 3 },
{ pincode: 144515, min_days: 2, max_days: 3 },
{ pincode: 144516, min_days: 2, max_days: 3 },
{ pincode: 144517, min_days: 2, max_days: 3 },
{ pincode: 144518, min_days: 2, max_days: 3 },
{ pincode: 144519, min_days: 2, max_days: 3 },
{ pincode: 144520, min_days: 2, max_days: 3 },
{ pincode: 144521, min_days: 2, max_days: 3 },
{ pincode: 144522, min_days: 2, max_days: 3 },
{ pincode: 144523, min_days: 2, max_days: 3 },
{ pincode: 144524, min_days: 2, max_days: 3 },
{ pincode: 144525, min_days: 2, max_days: 3 },
{ pincode: 144526, min_days: 2, max_days: 3 },
{ pincode: 144527, min_days: 2, max_days: 3 },
{ pincode: 144528, min_days: 2, max_days: 3 },
{ pincode: 144529, min_days: 2, max_days: 3 },
{ pincode: 144530, min_days: 2, max_days: 3 },
{ pincode: 144531, min_days: 2, max_days: 3 },
{ pincode: 144532, min_days: 2, max_days: 3 },
{ pincode: 144533, min_days: 2, max_days: 3 },
{ pincode: 144601, min_days: 2, max_days: 3 },
{ pincode: 144602, min_days: 2, max_days: 3 },
{ pincode: 144603, min_days: 2, max_days: 3 },
{ pincode: 144606, min_days: 2, max_days: 3 },
{ pincode: 144619, min_days: 2, max_days: 3 },
{ pincode: 144620, min_days: 2, max_days: 3 },
{ pincode: 144621, min_days: 2, max_days: 3 },
{ pincode: 144622, min_days: 2, max_days: 3 },
{ pincode: 144623, min_days: 2, max_days: 3 },
{ pincode: 144624, min_days: 2, max_days: 3 },
{ pincode: 144625, min_days: 2, max_days: 3 },
{ pincode: 144626, min_days: 2, max_days: 3 },
{ pincode: 144628, min_days: 2, max_days: 3 },
{ pincode: 144629, min_days: 2, max_days: 3 },
{ pincode: 144630, min_days: 2, max_days: 3 },
{ pincode: 144631, min_days: 2, max_days: 3 },
{ pincode: 144632, min_days: 2, max_days: 3 },
{ pincode: 144633, min_days: 2, max_days: 3 },
{ pincode: 144701, min_days: 2, max_days: 3 },
{ pincode: 144702, min_days: 2, max_days: 3 },
{ pincode: 144703, min_days: 2, max_days: 3 },
{ pincode: 144801, min_days: 2, max_days: 3 },
{ pincode: 144802, min_days: 2, max_days: 3 },
{ pincode: 144803, min_days: 2, max_days: 3 },
{ pincode: 144804, min_days: 2, max_days: 3 },
{ pincode: 144805, min_days: 2, max_days: 3 },
{ pincode: 144806, min_days: 2, max_days: 3 },
{ pincode: 144819, min_days: 2, max_days: 3 },
{ pincode: 145001, min_days: 2, max_days: 3 },
{ pincode: 145002, min_days: 2, max_days: 3 },
{ pincode: 145003, min_days: 2, max_days: 3 },
{ pincode: 145021, min_days: 2, max_days: 3 },
{ pincode: 145022, min_days: 2, max_days: 3 },
{ pincode: 145023, min_days: 2, max_days: 3 },
{ pincode: 145024, min_days: 2, max_days: 3 },
{ pincode: 145025, min_days: 2, max_days: 3 },
{ pincode: 145026, min_days: 2, max_days: 3 },
{ pincode: 145027, min_days: 2, max_days: 3 },
{ pincode: 145029, min_days: 2, max_days: 3 },
{ pincode: 145101, min_days: 2, max_days: 3 },
{ pincode: 145105, min_days: 2, max_days: 3 },
{ pincode: 146001, min_days: 2, max_days: 3 },
{ pincode: 146002, min_days: 2, max_days: 3 },
{ pincode: 146004, min_days: 2, max_days: 3 },
{ pincode: 146006, min_days: 2, max_days: 3 },
{ pincode: 146007, min_days: 2, max_days: 3 },
{ pincode: 146019, min_days: 2, max_days: 3 },
{ pincode: 146021, min_days: 2, max_days: 3 },
{ pincode: 146022, min_days: 2, max_days: 3 },
{ pincode: 146023, min_days: 2, max_days: 3 },
{ pincode: 146024, min_days: 2, max_days: 3 },
{ pincode: 146101, min_days: 2, max_days: 3 },
{ pincode: 146102, min_days: 2, max_days: 3 },
{ pincode: 146103, min_days: 2, max_days: 3 },
{ pincode: 146104, min_days: 2, max_days: 3 },
{ pincode: 146105, min_days: 2, max_days: 3 },
{ pincode: 146106, min_days: 2, max_days: 3 },
{ pincode: 146107, min_days: 2, max_days: 3 },
{ pincode: 146108, min_days: 2, max_days: 3 },
{ pincode: 146109, min_days: 2, max_days: 3 },
{ pincode: 146110, min_days: 2, max_days: 3 },
{ pincode: 146111, min_days: 2, max_days: 3 },
{ pincode: 146112, min_days: 2, max_days: 3 },
{ pincode: 146113, min_days: 2, max_days: 3 },
{ pincode: 146114, min_days: 2, max_days: 3 },
{ pincode: 146115, min_days: 2, max_days: 3 },
{ pincode: 146116, min_days: 2, max_days: 3 },
{ pincode: 147001, min_days: 2, max_days: 3 },
{ pincode: 147002, min_days: 2, max_days: 3 },
{ pincode: 147003, min_days: 2, max_days: 3 },
{ pincode: 147004, min_days: 2, max_days: 3 },
{ pincode: 147005, min_days: 2, max_days: 3 },
{ pincode: 147006, min_days: 2, max_days: 3 },
{ pincode: 147007, min_days: 2, max_days: 3 },
{ pincode: 147008, min_days: 2, max_days: 3 },
{ pincode: 147021, min_days: 2, max_days: 3 },
{ pincode: 147100, min_days: 2, max_days: 3 },
{ pincode: 147101, min_days: 2, max_days: 3 },
{ pincode: 147102, min_days: 2, max_days: 3 },
{ pincode: 147103, min_days: 2, max_days: 3 },
{ pincode: 147104, min_days: 2, max_days: 3 },
{ pincode: 147105, min_days: 2, max_days: 3 },
{ pincode: 147111, min_days: 2, max_days: 3 },
{ pincode: 147201, min_days: 2, max_days: 3 },
{ pincode: 147202, min_days: 2, max_days: 3 },
{ pincode: 147203, min_days: 2, max_days: 3 },
{ pincode: 147204, min_days: 2, max_days: 3 },
{ pincode: 147301, min_days: 2, max_days: 3 },
{ pincode: 148000, min_days: 2, max_days: 3 },
{ pincode: 148001, min_days: 2, max_days: 3 },
{ pincode: 148002, min_days: 2, max_days: 3 },
{ pincode: 148004, min_days: 2, max_days: 3 },
{ pincode: 148006, min_days: 2, max_days: 3 },
{ pincode: 148007, min_days: 2, max_days: 3 },
{ pincode: 148008, min_days: 2, max_days: 3 },
{ pincode: 148009, min_days: 2, max_days: 3 },
{ pincode: 148017, min_days: 2, max_days: 3 },
{ pincode: 148018, min_days: 2, max_days: 3 },
{ pincode: 148019, min_days: 2, max_days: 3 },
{ pincode: 148020, min_days: 2, max_days: 3 },
{ pincode: 148021, min_days: 2, max_days: 3 },
{ pincode: 148022, min_days: 2, max_days: 3 },
{ pincode: 148023, min_days: 2, max_days: 3 },
{ pincode: 148024, min_days: 2, max_days: 3 },
{ pincode: 148025, min_days: 2, max_days: 3 },
{ pincode: 148026, min_days: 2, max_days: 3 },
{ pincode: 148027, min_days: 2, max_days: 3 },
{ pincode: 148028, min_days: 2, max_days: 3 },
{ pincode: 148029, min_days: 2, max_days: 3 },
{ pincode: 148030, min_days: 2, max_days: 3 },
{ pincode: 148031, min_days: 2, max_days: 3 },
{ pincode: 148033, min_days: 2, max_days: 3 },
{ pincode: 148034, min_days: 2, max_days: 3 },
{ pincode: 148035, min_days: 2, max_days: 3 },
{ pincode: 148036, min_days: 2, max_days: 3 },
{ pincode: 148038, min_days: 2, max_days: 3 },
{ pincode: 148040, min_days: 2, max_days: 3 },
{ pincode: 148041, min_days: 2, max_days: 3 },
{ pincode: 148042, min_days: 2, max_days: 3 },
{ pincode: 148045, min_days: 2, max_days: 3 },
{ pincode: 148046, min_days: 2, max_days: 3 },
{ pincode: 148047, min_days: 2, max_days: 3 },
{ pincode: 148049, min_days: 2, max_days: 3 },
{ pincode: 148050, min_days: 2, max_days: 3 },
{ pincode: 148051, min_days: 2, max_days: 3 },
{ pincode: 148100, min_days: 2, max_days: 3 },
{ pincode: 148101, min_days: 2, max_days: 3 },
{ pincode: 148102, min_days: 2, max_days: 3 },
{ pincode: 148103, min_days: 2, max_days: 3 },
{ pincode: 148104, min_days: 2, max_days: 3 },
{ pincode: 148105, min_days: 2, max_days: 3 },
{ pincode: 148106, min_days: 2, max_days: 3 },
{ pincode: 148107, min_days: 2, max_days: 3 },
{ pincode: 148108, min_days: 2, max_days: 3 },
{ pincode: 148109, min_days: 2, max_days: 3 },
{ pincode: 148110, min_days: 2, max_days: 3 },
{ pincode: 148111, min_days: 2, max_days: 3 },
{ pincode: 148112, min_days: 2, max_days: 3 },
{ pincode: 148113, min_days: 2, max_days: 3 },
{ pincode: 148114, min_days: 2, max_days: 3 },
{ pincode: 148115, min_days: 2, max_days: 3 },
{ pincode: 148116, min_days: 2, max_days: 3 },
{ pincode: 148117, min_days: 2, max_days: 3 },
{ pincode: 151001, min_days: 2, max_days: 3 },
{ pincode: 151002, min_days: 2, max_days: 3 },
{ pincode: 151003, min_days: 2, max_days: 3 },
{ pincode: 151004, min_days: 2, max_days: 3 },
{ pincode: 151005, min_days: 2, max_days: 3 },
{ pincode: 151006, min_days: 2, max_days: 3 },
{ pincode: 151007, min_days: 2, max_days: 3 },
{ pincode: 151101, min_days: 2, max_days: 3 },
{ pincode: 151102, min_days: 2, max_days: 3 },
{ pincode: 151103, min_days: 2, max_days: 3 },
{ pincode: 151104, min_days: 2, max_days: 3 },
{ pincode: 151105, min_days: 2, max_days: 3 },
{ pincode: 151106, min_days: 2, max_days: 3 },
{ pincode: 151107, min_days: 2, max_days: 3 },
{ pincode: 151108, min_days: 2, max_days: 3 },
{ pincode: 151110, min_days: 2, max_days: 3 },
{ pincode: 151111, min_days: 2, max_days: 3 },
{ pincode: 151201, min_days: 2, max_days: 3 },
{ pincode: 151202, min_days: 2, max_days: 3 },
{ pincode: 151203, min_days: 2, max_days: 3 },
{ pincode: 151204, min_days: 2, max_days: 3 },
{ pincode: 151205, min_days: 2, max_days: 3 },
{ pincode: 151206, min_days: 2, max_days: 3 },
{ pincode: 151207, min_days: 2, max_days: 3 },
{ pincode: 151208, min_days: 2, max_days: 3 },
{ pincode: 151209, min_days: 2, max_days: 3 },
{ pincode: 151210, min_days: 2, max_days: 3 },
{ pincode: 151211, min_days: 2, max_days: 3 },
{ pincode: 151212, min_days: 2, max_days: 3 },
{ pincode: 151213, min_days: 2, max_days: 3 },
{ pincode: 151214, min_days: 2, max_days: 3 },
{ pincode: 151301, min_days: 2, max_days: 3 },
{ pincode: 151302, min_days: 2, max_days: 3 },
{ pincode: 151401, min_days: 2, max_days: 3 },
{ pincode: 151501, min_days: 2, max_days: 3 },
{ pincode: 151502, min_days: 2, max_days: 3 },
{ pincode: 151503, min_days: 2, max_days: 3 },
{ pincode: 151504, min_days: 2, max_days: 3 },
{ pincode: 151505, min_days: 2, max_days: 3 },
{ pincode: 151506, min_days: 2, max_days: 3 },
{ pincode: 151507, min_days: 2, max_days: 3 },
{ pincode: 151508, min_days: 2, max_days: 3 },
{ pincode: 151509, min_days: 2, max_days: 3 },
{ pincode: 151510, min_days: 2, max_days: 3 },
{ pincode: 151511, min_days: 2, max_days: 3 },
{ pincode: 152001, min_days: 2, max_days: 3 },
{ pincode: 152002, min_days: 2, max_days: 3 },
{ pincode: 152003, min_days: 2, max_days: 3 },
{ pincode: 152004, min_days: 2, max_days: 3 },
{ pincode: 152005, min_days: 2, max_days: 3 },
{ pincode: 152020, min_days: 2, max_days: 3 },
{ pincode: 152021, min_days: 2, max_days: 3 },
{ pincode: 152022, min_days: 2, max_days: 3 },
{ pincode: 152023, min_days: 2, max_days: 3 },
{ pincode: 152024, min_days: 2, max_days: 3 },
{ pincode: 152025, min_days: 2, max_days: 3 },
{ pincode: 152026, min_days: 2, max_days: 3 },
{ pincode: 152028, min_days: 2, max_days: 3 },
{ pincode: 152031, min_days: 2, max_days: 3 },
{ pincode: 152032, min_days: 2, max_days: 3 },
{ pincode: 152033, min_days: 2, max_days: 3 },
{ pincode: 152101, min_days: 2, max_days: 3 },
{ pincode: 152102, min_days: 2, max_days: 3 },
{ pincode: 152103, min_days: 2, max_days: 3 },
{ pincode: 152104, min_days: 2, max_days: 3 },
{ pincode: 152107, min_days: 2, max_days: 3 },
{ pincode: 152112, min_days: 2, max_days: 3 },
{ pincode: 152113, min_days: 2, max_days: 3 },
{ pincode: 152114, min_days: 2, max_days: 3 },
{ pincode: 152115, min_days: 2, max_days: 3 },
{ pincode: 152116, min_days: 2, max_days: 3 },
{ pincode: 152117, min_days: 2, max_days: 3 },
{ pincode: 152118, min_days: 2, max_days: 3 },
{ pincode: 152120, min_days: 2, max_days: 3 },
{ pincode: 152121, min_days: 2, max_days: 3 },
{ pincode: 152122, min_days: 2, max_days: 3 },
{ pincode: 152123, min_days: 2, max_days: 3 },
{ pincode: 152124, min_days: 2, max_days: 3 },
{ pincode: 152125, min_days: 2, max_days: 3 },
{ pincode: 152126, min_days: 2, max_days: 3 },
{ pincode: 152128, min_days: 2, max_days: 3 },
{ pincode: 152130, min_days: 2, max_days: 3 },
{ pincode: 152131, min_days: 2, max_days: 3 },
{ pincode: 152132, min_days: 2, max_days: 3 },
{ pincode: 160001, min_days: 2, max_days: 3 },
{ pincode: 160002, min_days: 2, max_days: 3 },
{ pincode: 160003, min_days: 2, max_days: 3 },
{ pincode: 160004, min_days: 2, max_days: 3 },
{ pincode: 160005, min_days: 2, max_days: 3 },
{ pincode: 160006, min_days: 2, max_days: 3 },
{ pincode: 160007, min_days: 2, max_days: 3 },
{ pincode: 160008, min_days: 2, max_days: 3 },
{ pincode: 160009, min_days: 2, max_days: 3 },
{ pincode: 160010, min_days: 2, max_days: 3 },
{ pincode: 160011, min_days: 2, max_days: 3 },
{ pincode: 160012, min_days: 2, max_days: 3 },
{ pincode: 160013, min_days: 2, max_days: 3 },
{ pincode: 160014, min_days: 2, max_days: 3 },
{ pincode: 160015, min_days: 2, max_days: 3 },
{ pincode: 160016, min_days: 2, max_days: 3 },
{ pincode: 160017, min_days: 2, max_days: 3 },
{ pincode: 160018, min_days: 2, max_days: 3 },
{ pincode: 160019, min_days: 2, max_days: 3 },
{ pincode: 160020, min_days: 2, max_days: 3 },
{ pincode: 160021, min_days: 2, max_days: 3 },
{ pincode: 160022, min_days: 2, max_days: 3 },
{ pincode: 160023, min_days: 2, max_days: 3 },
{ pincode: 160024, min_days: 2, max_days: 3 },
{ pincode: 160025, min_days: 2, max_days: 3 },
{ pincode: 160026, min_days: 2, max_days: 3 },
{ pincode: 160027, min_days: 2, max_days: 3 },
{ pincode: 160028, min_days: 2, max_days: 3 },
{ pincode: 160029, min_days: 2, max_days: 3 },
{ pincode: 160030, min_days: 2, max_days: 3 },
{ pincode: 160031, min_days: 2, max_days: 3 },
{ pincode: 160032, min_days: 2, max_days: 3 },
{ pincode: 160033, min_days: 2, max_days: 3 },
{ pincode: 160034, min_days: 2, max_days: 3 },
{ pincode: 160035, min_days: 2, max_days: 3 },
{ pincode: 160036, min_days: 2, max_days: 3 },
{ pincode: 160037, min_days: 2, max_days: 3 },
{ pincode: 160038, min_days: 2, max_days: 3 },
{ pincode: 160039, min_days: 2, max_days: 3 },
{ pincode: 160040, min_days: 2, max_days: 3 },
{ pincode: 160041, min_days: 2, max_days: 3 },
{ pincode: 160042, min_days: 2, max_days: 3 },
{ pincode: 160043, min_days: 2, max_days: 3 },
{ pincode: 160044, min_days: 2, max_days: 3 },
{ pincode: 160045, min_days: 2, max_days: 3 },
{ pincode: 160046, min_days: 2, max_days: 3 },
{ pincode: 160047, min_days: 2, max_days: 3 },
{ pincode: 160048, min_days: 2, max_days: 3 },
{ pincode: 160049, min_days: 2, max_days: 3 },
{ pincode: 160050, min_days: 2, max_days: 3 },
{ pincode: 160051, min_days: 2, max_days: 3 },
{ pincode: 160052, min_days: 2, max_days: 3 },
{ pincode: 160053, min_days: 2, max_days: 3 },
{ pincode: 160054, min_days: 2, max_days: 3 },
{ pincode: 160055, min_days: 2, max_days: 3 },
{ pincode: 160056, min_days: 2, max_days: 3 },
{ pincode: 160057, min_days: 2, max_days: 3 },
{ pincode: 160058, min_days: 2, max_days: 3 },
{ pincode: 160059, min_days: 2, max_days: 3 },
{ pincode: 160060, min_days: 2, max_days: 3 },
{ pincode: 160061, min_days: 2, max_days: 3 },
{ pincode: 160062, min_days: 2, max_days: 3 },
{ pincode: 160063, min_days: 2, max_days: 3 },
{ pincode: 160064, min_days: 2, max_days: 3 },
{ pincode: 160065, min_days: 2, max_days: 3 },
{ pincode: 160066, min_days: 2, max_days: 3 },
{ pincode: 160067, min_days: 2, max_days: 3 },
{ pincode: 160068, min_days: 2, max_days: 3 },
{ pincode: 160069, min_days: 2, max_days: 3 },
{ pincode: 160070, min_days: 2, max_days: 3 },
{ pincode: 160071, min_days: 2, max_days: 3 },
{ pincode: 160073, min_days: 2, max_days: 3 },
{ pincode: 160074, min_days: 2, max_days: 3 },
{ pincode: 160078, min_days: 2, max_days: 3 },
{ pincode: 160079, min_days: 2, max_days: 3 },
{ pincode: 160101, min_days: 2, max_days: 3 },
{ pincode: 160102, min_days: 2, max_days: 3 },
{ pincode: 160103, min_days: 2, max_days: 3 },
{ pincode: 160104, min_days: 2, max_days: 3 },
{ pincode: 160106, min_days: 2, max_days: 3 },
{ pincode: 166031, min_days: 2, max_days: 3 },
{ pincode: 170001, min_days: 3, max_days: 4 },
{ pincode: 171001, min_days: 2, max_days: 3 },
{ pincode: 171002, min_days: 2, max_days: 3 },
{ pincode: 171003, min_days: 2, max_days: 3 },
{ pincode: 171004, min_days: 2, max_days: 3 },
{ pincode: 171005, min_days: 2, max_days: 3 },
{ pincode: 171006, min_days: 2, max_days: 3 },
{ pincode: 171007, min_days: 2, max_days: 3 },
{ pincode: 171008, min_days: 2, max_days: 3 },
{ pincode: 171009, min_days: 2, max_days: 3 },
{ pincode: 171010, min_days: 2, max_days: 3 },
{ pincode: 171011, min_days: 2, max_days: 3 },
{ pincode: 171012, min_days: 2, max_days: 3 },
{ pincode: 171013, min_days: 2, max_days: 3 },
{ pincode: 171014, min_days: 2, max_days: 3 },
{ pincode: 171015, min_days: 2, max_days: 3 },
{ pincode: 171018, min_days: 2, max_days: 3 },
{ pincode: 171019, min_days: 2, max_days: 3 },
{ pincode: 171102, min_days: 2, max_days: 3 },
{ pincode: 171103, min_days: 2, max_days: 3 },
{ pincode: 171108, min_days: 2, max_days: 3 },
{ pincode: 171201, min_days: 2, max_days: 3 },
{ pincode: 171202, min_days: 2, max_days: 3 },
{ pincode: 171203, min_days: 2, max_days: 3 },
{ pincode: 171204, min_days: 2, max_days: 3 },
{ pincode: 171205, min_days: 2, max_days: 3 },
{ pincode: 171206, min_days: 2, max_days: 3 },
{ pincode: 171207, min_days: 2, max_days: 3 },
{ pincode: 171208, min_days: 2, max_days: 3 },
{ pincode: 171209, min_days: 2, max_days: 3 },
{ pincode: 171210, min_days: 2, max_days: 3 },
{ pincode: 171211, min_days: 2, max_days: 3 },
{ pincode: 171212, min_days: 2, max_days: 3 },
{ pincode: 171213, min_days: 2, max_days: 3 },
{ pincode: 171214, min_days: 2, max_days: 3 },
{ pincode: 171215, min_days: 2, max_days: 3 },
{ pincode: 171216, min_days: 2, max_days: 3 },
{ pincode: 171217, min_days: 2, max_days: 3 },
{ pincode: 171218, min_days: 2, max_days: 3 },
{ pincode: 171219, min_days: 2, max_days: 3 },
{ pincode: 171220, min_days: 2, max_days: 3 },
{ pincode: 171221, min_days: 2, max_days: 3 },
{ pincode: 171222, min_days: 2, max_days: 3 },
{ pincode: 171223, min_days: 2, max_days: 3 },
{ pincode: 171224, min_days: 2, max_days: 3 },
{ pincode: 171225, min_days: 2, max_days: 3 },
{ pincode: 171226, min_days: 2, max_days: 3 },
{ pincode: 171301, min_days: 2, max_days: 3 },
{ pincode: 171302, min_days: 2, max_days: 3 },
{ pincode: 171303, min_days: 3, max_days: 4 },
{ pincode: 171304, min_days: 3, max_days: 4 },
{ pincode: 172001, min_days: 2, max_days: 3 },
{ pincode: 172002, min_days: 2, max_days: 3 },
{ pincode: 172021, min_days: 2, max_days: 3 },
{ pincode: 172022, min_days: 2, max_days: 3 },
{ pincode: 172023, min_days: 2, max_days: 3 },
{ pincode: 172024, min_days: 2, max_days: 3 },
{ pincode: 172025, min_days: 2, max_days: 3 },
{ pincode: 172026, min_days: 2, max_days: 3 },
{ pincode: 172027, min_days: 2, max_days: 3 },
{ pincode: 172028, min_days: 2, max_days: 3 },
{ pincode: 172029, min_days: 2, max_days: 3 },
{ pincode: 172030, min_days: 2, max_days: 3 },
{ pincode: 172031, min_days: 2, max_days: 3 },
{ pincode: 172032, min_days: 2, max_days: 3 },
{ pincode: 172033, min_days: 2, max_days: 3 },
{ pincode: 172034, min_days: 2, max_days: 3 },
{ pincode: 172101, min_days: 2, max_days: 3 },
{ pincode: 172102, min_days: 2, max_days: 3 },
{ pincode: 172103, min_days: 2, max_days: 3 },
{ pincode: 172104, min_days: 2, max_days: 3 },
{ pincode: 172105, min_days: 2, max_days: 3 },
{ pincode: 172106, min_days: 2, max_days: 3 },
{ pincode: 172107, min_days: 2, max_days: 3 },
{ pincode: 172108, min_days: 2, max_days: 3 },
{ pincode: 172109, min_days: 2, max_days: 3 },
{ pincode: 172110, min_days: 2, max_days: 3 },
{ pincode: 172111, min_days: 2, max_days: 3 },
{ pincode: 172112, min_days: 2, max_days: 3 },
{ pincode: 172113, min_days: 2, max_days: 3 },
{ pincode: 172114, min_days: 2, max_days: 3 },
{ pincode: 172115, min_days: 2, max_days: 3 },
{ pincode: 172116, min_days: 2, max_days: 3 },
{ pincode: 172117, min_days: 2, max_days: 3 },
{ pincode: 172118, min_days: 2, max_days: 3 },
{ pincode: 172201, min_days: 2, max_days: 3 },
{ pincode: 173001, min_days: 2, max_days: 3 },
{ pincode: 173002, min_days: 3, max_days: 4 },
{ pincode: 173004, min_days: 3, max_days: 4 },
{ pincode: 173020, min_days: 3, max_days: 4 },
{ pincode: 173021, min_days: 2, max_days: 3 },
{ pincode: 173022, min_days: 2, max_days: 3 },
{ pincode: 173023, min_days: 2, max_days: 3 },
{ pincode: 173024, min_days: 2, max_days: 3 },
{ pincode: 173025, min_days: 2, max_days: 3 },
{ pincode: 173026, min_days: 2, max_days: 3 },
{ pincode: 173027, min_days: 2, max_days: 3 },
{ pincode: 173028, min_days: 3, max_days: 4 },
{ pincode: 173029, min_days: 2, max_days: 3 },
{ pincode: 173030, min_days: 2, max_days: 3 },
{ pincode: 173031, min_days: 2, max_days: 3 },
{ pincode: 173032, min_days: 2, max_days: 3 },
{ pincode: 173101, min_days: 2, max_days: 3 },
{ pincode: 173104, min_days: 2, max_days: 3 },
{ pincode: 173201, min_days: 2, max_days: 3 },
{ pincode: 173202, min_days: 2, max_days: 3 },
{ pincode: 173204, min_days: 2, max_days: 3 },
{ pincode: 173205, min_days: 2, max_days: 3 },
{ pincode: 173206, min_days: 2, max_days: 3 },
{ pincode: 173207, min_days: 2, max_days: 3 },
{ pincode: 173208, min_days: 2, max_days: 3 },
{ pincode: 173209, min_days: 2, max_days: 3 },
{ pincode: 173210, min_days: 2, max_days: 3 },
{ pincode: 173211, min_days: 2, max_days: 3 },
{ pincode: 173212, min_days: 2, max_days: 3 },
{ pincode: 173213, min_days: 2, max_days: 3 },
{ pincode: 173214, min_days: 2, max_days: 3 },
{ pincode: 173215, min_days: 2, max_days: 3 },
{ pincode: 173216, min_days: 2, max_days: 3 },
{ pincode: 173217, min_days: 2, max_days: 3 },
{ pincode: 173218, min_days: 2, max_days: 3 },
{ pincode: 173219, min_days: 3, max_days: 4 },
{ pincode: 173220, min_days: 2, max_days: 3 },
{ pincode: 173221, min_days: 2, max_days: 3 },
{ pincode: 173222, min_days: 2, max_days: 3 },
{ pincode: 173223, min_days: 2, max_days: 3 },
{ pincode: 173225, min_days: 2, max_days: 3 },
{ pincode: 173229, min_days: 2, max_days: 3 },
{ pincode: 173230, min_days: 2, max_days: 3 },
{ pincode: 173233, min_days: 2, max_days: 3 },
{ pincode: 173234, min_days: 2, max_days: 3 },
{ pincode: 173235, min_days: 2, max_days: 3 },
{ pincode: 173236, min_days: 2, max_days: 3 },
{ pincode: 174001, min_days: 2, max_days: 3 },
{ pincode: 174002, min_days: 2, max_days: 3 },
{ pincode: 174003, min_days: 2, max_days: 3 },
{ pincode: 174004, min_days: 2, max_days: 3 },
{ pincode: 174005, min_days: 2, max_days: 3 },
{ pincode: 174011, min_days: 2, max_days: 3 },
{ pincode: 174012, min_days: 2, max_days: 3 },
{ pincode: 174013, min_days: 2, max_days: 3 },
{ pincode: 174015, min_days: 2, max_days: 3 },
{ pincode: 174017, min_days: 2, max_days: 3 },
{ pincode: 174021, min_days: 2, max_days: 3 },
{ pincode: 174022, min_days: 2, max_days: 3 },
{ pincode: 174023, min_days: 2, max_days: 3 },
{ pincode: 174024, min_days: 2, max_days: 3 },
{ pincode: 174026, min_days: 2, max_days: 3 },
{ pincode: 174027, min_days: 2, max_days: 3 },
{ pincode: 174028, min_days: 2, max_days: 3 },
{ pincode: 174029, min_days: 2, max_days: 3 },
{ pincode: 174030, min_days: 2, max_days: 3 },
{ pincode: 174031, min_days: 2, max_days: 3 },
{ pincode: 174032, min_days: 2, max_days: 3 },
{ pincode: 174033, min_days: 2, max_days: 3 },
{ pincode: 174034, min_days: 2, max_days: 3 },
{ pincode: 174035, min_days: 2, max_days: 3 },
{ pincode: 174036, min_days: 2, max_days: 3 },
{ pincode: 174037, min_days: 2, max_days: 3 },
{ pincode: 174101, min_days: 2, max_days: 3 },
{ pincode: 174102, min_days: 2, max_days: 3 },
{ pincode: 174103, min_days: 2, max_days: 3 },
{ pincode: 174201, min_days: 2, max_days: 3 },
{ pincode: 174301, min_days: 2, max_days: 3 },
{ pincode: 174302, min_days: 2, max_days: 3 },
{ pincode: 174303, min_days: 2, max_days: 3 },
{ pincode: 174304, min_days: 2, max_days: 3 },
{ pincode: 174305, min_days: 2, max_days: 3 },
{ pincode: 174306, min_days: 2, max_days: 3 },
{ pincode: 174307, min_days: 2, max_days: 3 },
{ pincode: 174308, min_days: 2, max_days: 3 },
{ pincode: 174309, min_days: 2, max_days: 3 },
{ pincode: 174310, min_days: 2, max_days: 3 },
{ pincode: 174311, min_days: 2, max_days: 3 },
{ pincode: 174312, min_days: 2, max_days: 3 },
{ pincode: 174314, min_days: 2, max_days: 3 },
{ pincode: 174315, min_days: 2, max_days: 3 },
{ pincode: 174316, min_days: 2, max_days: 3 },
{ pincode: 174317, min_days: 2, max_days: 3 },
{ pincode: 174319, min_days: 2, max_days: 3 },
{ pincode: 174320, min_days: 2, max_days: 3 },
{ pincode: 174321, min_days: 2, max_days: 3 },
{ pincode: 174401, min_days: 3, max_days: 4 },
{ pincode: 174402, min_days: 3, max_days: 4 },
{ pincode: 174405, min_days: 2, max_days: 3 },
{ pincode: 174503, min_days: 2, max_days: 3 },
{ pincode: 174505, min_days: 2, max_days: 3 },
{ pincode: 174507, min_days: 2, max_days: 3 },
{ pincode: 175001, min_days: 2, max_days: 3 },
{ pincode: 175002, min_days: 2, max_days: 3 },
{ pincode: 175003, min_days: 2, max_days: 3 },
{ pincode: 175004, min_days: 2, max_days: 3 },
{ pincode: 175005, min_days: 2, max_days: 3 },
{ pincode: 175006, min_days: 2, max_days: 3 },
{ pincode: 175007, min_days: 2, max_days: 3 },
{ pincode: 175008, min_days: 2, max_days: 3 },
{ pincode: 175009, min_days: 2, max_days: 3 },
{ pincode: 175010, min_days: 2, max_days: 3 },
{ pincode: 175011, min_days: 2, max_days: 3 },
{ pincode: 175012, min_days: 2, max_days: 3 },
{ pincode: 175013, min_days: 2, max_days: 3 },
{ pincode: 175014, min_days: 2, max_days: 3 },
{ pincode: 175015, min_days: 2, max_days: 3 },
{ pincode: 175016, min_days: 2, max_days: 3 },
{ pincode: 175017, min_days: 2, max_days: 3 },
{ pincode: 175018, min_days: 2, max_days: 3 },
{ pincode: 175019, min_days: 2, max_days: 3 },
{ pincode: 175020, min_days: 2, max_days: 3 },
{ pincode: 175021, min_days: 2, max_days: 3 },
{ pincode: 175022, min_days: 3, max_days: 4 },
{ pincode: 175023, min_days: 2, max_days: 3 },
{ pincode: 175024, min_days: 2, max_days: 3 },
{ pincode: 175025, min_days: 2, max_days: 3 },
{ pincode: 175026, min_days: 2, max_days: 3 },
{ pincode: 175027, min_days: 2, max_days: 3 },
{ pincode: 175028, min_days: 2, max_days: 3 },
{ pincode: 175029, min_days: 2, max_days: 3 },
{ pincode: 175030, min_days: 2, max_days: 3 },
{ pincode: 175031, min_days: 2, max_days: 3 },
{ pincode: 175032, min_days: 2, max_days: 3 },
{ pincode: 175033, min_days: 2, max_days: 3 },
{ pincode: 175034, min_days: 2, max_days: 3 },
{ pincode: 175035, min_days: 2, max_days: 3 },
{ pincode: 175036, min_days: 2, max_days: 3 },
{ pincode: 175037, min_days: 2, max_days: 3 },
{ pincode: 175038, min_days: 2, max_days: 3 },
{ pincode: 175039, min_days: 2, max_days: 3 },
{ pincode: 175040, min_days: 2, max_days: 3 },
{ pincode: 175042, min_days: 2, max_days: 3 },
{ pincode: 175045, min_days: 2, max_days: 3 },
{ pincode: 175046, min_days: 2, max_days: 3 },
{ pincode: 175047, min_days: 2, max_days: 3 },
{ pincode: 175048, min_days: 2, max_days: 3 },
{ pincode: 175049, min_days: 2, max_days: 3 },
{ pincode: 175050, min_days: 2, max_days: 3 },
{ pincode: 175051, min_days: 2, max_days: 3 },
{ pincode: 175052, min_days: 2, max_days: 3 },
{ pincode: 175075, min_days: 2, max_days: 3 },
{ pincode: 175101, min_days: 2, max_days: 3 },
{ pincode: 175102, min_days: 2, max_days: 3 },
{ pincode: 175103, min_days: 2, max_days: 3 },
{ pincode: 175104, min_days: 2, max_days: 3 },
{ pincode: 175105, min_days: 2, max_days: 3 },
{ pincode: 175106, min_days: 2, max_days: 3 },
{ pincode: 175121, min_days: 2, max_days: 3 },
{ pincode: 175122, min_days: 3, max_days: 4 },
{ pincode: 175123, min_days: 2, max_days: 3 },
{ pincode: 175124, min_days: 2, max_days: 3 },
{ pincode: 175125, min_days: 2, max_days: 3 },
{ pincode: 175126, min_days: 2, max_days: 3 },
{ pincode: 175128, min_days: 2, max_days: 3 },
{ pincode: 175129, min_days: 2, max_days: 3 },
{ pincode: 175130, min_days: 2, max_days: 3 },
{ pincode: 175131, min_days: 2, max_days: 3 },
{ pincode: 175132, min_days: 2, max_days: 3 },
{ pincode: 175133, min_days: 2, max_days: 3 },
{ pincode: 175134, min_days: 2, max_days: 3 },
{ pincode: 175136, min_days: 2, max_days: 3 },
{ pincode: 175137, min_days: 3, max_days: 4 },
{ pincode: 175138, min_days: 2, max_days: 3 },
{ pincode: 175139, min_days: 2, max_days: 3 },
{ pincode: 175140, min_days: 2, max_days: 3 },
{ pincode: 175141, min_days: 2, max_days: 3 },
{ pincode: 175142, min_days: 2, max_days: 3 },
{ pincode: 175143, min_days: 2, max_days: 3 },
{ pincode: 176001, min_days: 2, max_days: 3 },
{ pincode: 176002, min_days: 2, max_days: 3 },
{ pincode: 176021, min_days: 2, max_days: 3 },
{ pincode: 176022, min_days: 2, max_days: 3 },
{ pincode: 176023, min_days: 2, max_days: 3 },
{ pincode: 176025, min_days: 2, max_days: 3 },
{ pincode: 176026, min_days: 2, max_days: 3 },
{ pincode: 176027, min_days: 2, max_days: 3 },
{ pincode: 176028, min_days: 2, max_days: 3 },
{ pincode: 176029, min_days: 2, max_days: 3 },
{ pincode: 176030, min_days: 2, max_days: 3 },
{ pincode: 176031, min_days: 2, max_days: 3 },
{ pincode: 176032, min_days: 2, max_days: 3 },
{ pincode: 176033, min_days: 2, max_days: 3 },
{ pincode: 176036, min_days: 2, max_days: 3 },
{ pincode: 176037, min_days: 2, max_days: 3 },
{ pincode: 176038, min_days: 2, max_days: 3 },
{ pincode: 176039, min_days: 2, max_days: 3 },
{ pincode: 176040, min_days: 2, max_days: 3 },
{ pincode: 176041, min_days: 2, max_days: 3 },
{ pincode: 176042, min_days: 2, max_days: 3 },
{ pincode: 176043, min_days: 2, max_days: 3 },
{ pincode: 176044, min_days: 2, max_days: 3 },
{ pincode: 176045, min_days: 2, max_days: 3 },
{ pincode: 176047, min_days: 2, max_days: 3 },
{ pincode: 176048, min_days: 2, max_days: 3 },
{ pincode: 176049, min_days: 2, max_days: 3 },
{ pincode: 176051, min_days: 2, max_days: 3 },
{ pincode: 176052, min_days: 2, max_days: 3 },
{ pincode: 176053, min_days: 2, max_days: 3 },
{ pincode: 176054, min_days: 2, max_days: 3 },
{ pincode: 176055, min_days: 2, max_days: 3 },
{ pincode: 176056, min_days: 2, max_days: 3 },
{ pincode: 176057, min_days: 2, max_days: 3 },
{ pincode: 176058, min_days: 2, max_days: 3 },
{ pincode: 176059, min_days: 2, max_days: 3 },
{ pincode: 176060, min_days: 2, max_days: 3 },
{ pincode: 176061, min_days: 2, max_days: 3 },
{ pincode: 176062, min_days: 2, max_days: 3 },
{ pincode: 176063, min_days: 2, max_days: 3 },
{ pincode: 176064, min_days: 2, max_days: 3 },
{ pincode: 176065, min_days: 2, max_days: 3 },
{ pincode: 176066, min_days: 2, max_days: 3 },
{ pincode: 176067, min_days: 2, max_days: 3 },
{ pincode: 176071, min_days: 2, max_days: 3 },
{ pincode: 176073, min_days: 2, max_days: 3 },
{ pincode: 176075, min_days: 2, max_days: 3 },
{ pincode: 176076, min_days: 2, max_days: 3 },
{ pincode: 176077, min_days: 2, max_days: 3 },
{ pincode: 176081, min_days: 2, max_days: 3 },
{ pincode: 176082, min_days: 2, max_days: 3 },
{ pincode: 176083, min_days: 2, max_days: 3 },
{ pincode: 176084, min_days: 2, max_days: 3 },
{ pincode: 176085, min_days: 2, max_days: 3 },
{ pincode: 176086, min_days: 2, max_days: 3 },
{ pincode: 176087, min_days: 2, max_days: 3 },
{ pincode: 176088, min_days: 2, max_days: 3 },
{ pincode: 176089, min_days: 2, max_days: 3 },
{ pincode: 176090, min_days: 2, max_days: 3 },
{ pincode: 176091, min_days: 2, max_days: 3 },
{ pincode: 176092, min_days: 2, max_days: 3 },
{ pincode: 176093, min_days: 2, max_days: 3 },
{ pincode: 176094, min_days: 2, max_days: 3 },
{ pincode: 176095, min_days: 2, max_days: 3 },
{ pincode: 176096, min_days: 2, max_days: 3 },
{ pincode: 176097, min_days: 2, max_days: 3 },
{ pincode: 176098, min_days: 2, max_days: 3 },
{ pincode: 176101, min_days: 2, max_days: 3 },
{ pincode: 176102, min_days: 2, max_days: 3 },
{ pincode: 176103, min_days: 2, max_days: 3 },
{ pincode: 176107, min_days: 2, max_days: 3 },
{ pincode: 176108, min_days: 2, max_days: 3 },
{ pincode: 176109, min_days: 2, max_days: 3 },
{ pincode: 176110, min_days: 2, max_days: 3 },
{ pincode: 176111, min_days: 2, max_days: 3 },
{ pincode: 176115, min_days: 2, max_days: 3 },
{ pincode: 176120, min_days: 3, max_days: 4 },
{ pincode: 176125, min_days: 2, max_days: 3 },
{ pincode: 176128, min_days: 2, max_days: 3 },
{ pincode: 176200, min_days: 2, max_days: 3 },
{ pincode: 176201, min_days: 2, max_days: 3 },
{ pincode: 176202, min_days: 2, max_days: 3 },
{ pincode: 176203, min_days: 2, max_days: 3 },
{ pincode: 176204, min_days: 2, max_days: 3 },
{ pincode: 176205, min_days: 2, max_days: 3 },
{ pincode: 176206, min_days: 2, max_days: 3 },
{ pincode: 176207, min_days: 2, max_days: 3 },
{ pincode: 176208, min_days: 2, max_days: 3 },
{ pincode: 176209, min_days: 2, max_days: 3 },
{ pincode: 176210, min_days: 2, max_days: 3 },
{ pincode: 176211, min_days: 2, max_days: 3 },
{ pincode: 176213, min_days: 2, max_days: 3 },
{ pincode: 176214, min_days: 2, max_days: 3 },
{ pincode: 176215, min_days: 2, max_days: 3 },
{ pincode: 176216, min_days: 2, max_days: 3 },
{ pincode: 176217, min_days: 2, max_days: 3 },
{ pincode: 176218, min_days: 2, max_days: 3 },
{ pincode: 176219, min_days: 2, max_days: 3 },
{ pincode: 176223, min_days: 3, max_days: 4 },
{ pincode: 176225, min_days: 2, max_days: 3 },
{ pincode: 176301, min_days: 2, max_days: 3 },
{ pincode: 176302, min_days: 2, max_days: 3 },
{ pincode: 176303, min_days: 2, max_days: 3 },
{ pincode: 176304, min_days: 2, max_days: 3 },
{ pincode: 176305, min_days: 2, max_days: 3 },
{ pincode: 176306, min_days: 2, max_days: 3 },
{ pincode: 176308, min_days: 2, max_days: 3 },
{ pincode: 176309, min_days: 2, max_days: 3 },
{ pincode: 176310, min_days: 2, max_days: 3 },
{ pincode: 176311, min_days: 2, max_days: 3 },
{ pincode: 176312, min_days: 2, max_days: 3 },
{ pincode: 176313, min_days: 2, max_days: 3 },
{ pincode: 176314, min_days: 2, max_days: 3 },
{ pincode: 176315, min_days: 2, max_days: 3 },
{ pincode: 176316, min_days: 2, max_days: 3 },
{ pincode: 176317, min_days: 2, max_days: 3 },
{ pincode: 176318, min_days: 2, max_days: 3 },
{ pincode: 176319, min_days: 2, max_days: 3 },
{ pincode: 176320, min_days: 2, max_days: 3 },
{ pincode: 176321, min_days: 2, max_days: 3 },
{ pincode: 176323, min_days: 2, max_days: 3 },
{ pincode: 176324, min_days: 2, max_days: 3 },
{ pincode: 176325, min_days: 2, max_days: 3 },
{ pincode: 176326, min_days: 2, max_days: 3 },
{ pincode: 176401, min_days: 2, max_days: 3 },
{ pincode: 176402, min_days: 2, max_days: 3 },
{ pincode: 176403, min_days: 2, max_days: 3 },
{ pincode: 176501, min_days: 2, max_days: 3 },
{ pincode: 176502, min_days: 2, max_days: 3 },
{ pincode: 176601, min_days: 2, max_days: 3 },
{ pincode: 177001, min_days: 2, max_days: 3 },
{ pincode: 177005, min_days: 2, max_days: 3 },
{ pincode: 177006, min_days: 2, max_days: 3 },
{ pincode: 177007, min_days: 2, max_days: 3 },
{ pincode: 177020, min_days: 2, max_days: 3 },
{ pincode: 177021, min_days: 2, max_days: 3 },
{ pincode: 177022, min_days: 2, max_days: 3 },
{ pincode: 177023, min_days: 2, max_days: 3 },
{ pincode: 177024, min_days: 2, max_days: 3 },
{ pincode: 177025, min_days: 2, max_days: 3 },
{ pincode: 177026, min_days: 2, max_days: 3 },
{ pincode: 177027, min_days: 2, max_days: 3 },
{ pincode: 177028, min_days: 2, max_days: 3 },
{ pincode: 177029, min_days: 2, max_days: 3 },
{ pincode: 177030, min_days: 2, max_days: 3 },
{ pincode: 177031, min_days: 2, max_days: 3 },
{ pincode: 177032, min_days: 2, max_days: 3 },
{ pincode: 177033, min_days: 2, max_days: 3 },
{ pincode: 177034, min_days: 2, max_days: 3 },
{ pincode: 177038, min_days: 2, max_days: 3 },
{ pincode: 177039, min_days: 2, max_days: 3 },
{ pincode: 177040, min_days: 2, max_days: 3 },
{ pincode: 177041, min_days: 2, max_days: 3 },
{ pincode: 177042, min_days: 2, max_days: 3 },
{ pincode: 177043, min_days: 2, max_days: 3 },
{ pincode: 177044, min_days: 2, max_days: 3 },
{ pincode: 177045, min_days: 2, max_days: 3 },
{ pincode: 177046, min_days: 3, max_days: 4 },
{ pincode: 177048, min_days: 2, max_days: 3 },
{ pincode: 177101, min_days: 2, max_days: 3 },
{ pincode: 177103, min_days: 2, max_days: 3 },
{ pincode: 177104, min_days: 2, max_days: 3 },
{ pincode: 177105, min_days: 2, max_days: 3 },
{ pincode: 177106, min_days: 2, max_days: 3 },
{ pincode: 177107, min_days: 2, max_days: 3 },
{ pincode: 177108, min_days: 2, max_days: 3 },
{ pincode: 177109, min_days: 2, max_days: 3 },
{ pincode: 177110, min_days: 2, max_days: 3 },
{ pincode: 177111, min_days: 2, max_days: 3 },
{ pincode: 177112, min_days: 2, max_days: 3 },
{ pincode: 177113, min_days: 2, max_days: 3 },
{ pincode: 177114, min_days: 2, max_days: 3 },
{ pincode: 177117, min_days: 2, max_days: 3 },
{ pincode: 177118, min_days: 2, max_days: 3 },
{ pincode: 177119, min_days: 2, max_days: 3 },
{ pincode: 177201, min_days: 2, max_days: 3 },
{ pincode: 177202, min_days: 2, max_days: 3 },
{ pincode: 177203, min_days: 2, max_days: 3 },
{ pincode: 177204, min_days: 2, max_days: 3 },
{ pincode: 177205, min_days: 2, max_days: 3 },
{ pincode: 177206, min_days: 2, max_days: 3 },
{ pincode: 177207, min_days: 2, max_days: 3 },
{ pincode: 177208, min_days: 2, max_days: 3 },
{ pincode: 177209, min_days: 2, max_days: 3 },
{ pincode: 177210, min_days: 2, max_days: 3 },
{ pincode: 177211, min_days: 2, max_days: 3 },
{ pincode: 177212, min_days: 2, max_days: 3 },
{ pincode: 177213, min_days: 2, max_days: 3 },
{ pincode: 177219, min_days: 2, max_days: 3 },
{ pincode: 177220, min_days: 2, max_days: 3 },
{ pincode: 177301, min_days: 2, max_days: 3 },
{ pincode: 177401, min_days: 2, max_days: 3 },
{ pincode: 177501, min_days: 2, max_days: 3 },
{ pincode: 177601, min_days: 2, max_days: 3 },
{ pincode: 180001, min_days: 2, max_days: 3 },
{ pincode: 180002, min_days: 2, max_days: 3 },
{ pincode: 180003, min_days: 2, max_days: 3 },
{ pincode: 180004, min_days: 2, max_days: 3 },
{ pincode: 180005, min_days: 2, max_days: 3 },
{ pincode: 180006, min_days: 2, max_days: 3 },
{ pincode: 180007, min_days: 2, max_days: 3 },
{ pincode: 180008, min_days: 2, max_days: 3 },
{ pincode: 180009, min_days: 2, max_days: 3 },
{ pincode: 180010, min_days: 2, max_days: 3 },
{ pincode: 180011, min_days: 2, max_days: 3 },
{ pincode: 180012, min_days: 2, max_days: 3 },
{ pincode: 180013, min_days: 2, max_days: 3 },
{ pincode: 180015, min_days: 2, max_days: 3 },
{ pincode: 180016, min_days: 2, max_days: 3 },
{ pincode: 180017, min_days: 2, max_days: 3 },
{ pincode: 180018, min_days: 2, max_days: 3 },
{ pincode: 180019, min_days: 2, max_days: 3 },
{ pincode: 180020, min_days: 2, max_days: 3 },
{ pincode: 180121, min_days: 2, max_days: 3 },
{ pincode: 180133, min_days: 2, max_days: 3 },
{ pincode: 181008, min_days: 2, max_days: 3 },
{ pincode: 181101, min_days: 2, max_days: 3 },
{ pincode: 181102, min_days: 2, max_days: 3 },
{ pincode: 181103, min_days: 2, max_days: 3 },
{ pincode: 181104, min_days: 2, max_days: 3 },
{ pincode: 181111, min_days: 2, max_days: 3 },
{ pincode: 181113, min_days: 2, max_days: 3 },
{ pincode: 181121, min_days: 2, max_days: 3 },
{ pincode: 181122, min_days: 2, max_days: 3 },
{ pincode: 181123, min_days: 2, max_days: 3 },
{ pincode: 181124, min_days: 2, max_days: 3 },
{ pincode: 181131, min_days: 2, max_days: 3 },
{ pincode: 181132, min_days: 2, max_days: 3 },
{ pincode: 181133, min_days: 2, max_days: 3 },
{ pincode: 181134, min_days: 2, max_days: 3 },
{ pincode: 181141, min_days: 2, max_days: 3 },
{ pincode: 181142, min_days: 2, max_days: 3 },
{ pincode: 181143, min_days: 2, max_days: 3 },
{ pincode: 181145, min_days: 2, max_days: 3 },
{ pincode: 181152, min_days: 2, max_days: 3 },
{ pincode: 181201, min_days: 2, max_days: 3 },
{ pincode: 181202, min_days: 2, max_days: 3 },
{ pincode: 181203, min_days: 2, max_days: 3 },
{ pincode: 181204, min_days: 2, max_days: 3 },
{ pincode: 181205, min_days: 2, max_days: 3 },
{ pincode: 181206, min_days: 2, max_days: 3 },
{ pincode: 181207, min_days: 2, max_days: 3 },
{ pincode: 181208, min_days: 2, max_days: 3 },
{ pincode: 181209, min_days: 2, max_days: 3 },
{ pincode: 181221, min_days: 2, max_days: 3 },
{ pincode: 181224, min_days: 2, max_days: 3 },
{ pincode: 182101, min_days: 2, max_days: 3 },
{ pincode: 182104, min_days: 2, max_days: 3 },
{ pincode: 182117, min_days: 2, max_days: 3 },
{ pincode: 182121, min_days: 2, max_days: 3 },
{ pincode: 182122, min_days: 2, max_days: 3 },
{ pincode: 182124, min_days: 2, max_days: 3 },
{ pincode: 182125, min_days: 2, max_days: 3 },
{ pincode: 182126, min_days: 2, max_days: 3 },
{ pincode: 182127, min_days: 2, max_days: 3 },
{ pincode: 182128, min_days: 2, max_days: 3 },
{ pincode: 182141, min_days: 2, max_days: 3 },
{ pincode: 182142, min_days: 2, max_days: 3 },
{ pincode: 182143, min_days: 2, max_days: 3 },
{ pincode: 182144, min_days: 2, max_days: 3 },
{ pincode: 182145, min_days: 2, max_days: 3 },
{ pincode: 182146, min_days: 2, max_days: 3 },
{ pincode: 182147, min_days: 2, max_days: 3 },
{ pincode: 182148, min_days: 2, max_days: 3 },
{ pincode: 182161, min_days: 2, max_days: 3 },
{ pincode: 182200, min_days: 2, max_days: 3 },
{ pincode: 182201, min_days: 2, max_days: 3 },
{ pincode: 182202, min_days: 2, max_days: 3 },
{ pincode: 182203, min_days: 2, max_days: 3 },
{ pincode: 182204, min_days: 2, max_days: 3 },
{ pincode: 182205, min_days: 2, max_days: 3 },
{ pincode: 182206, min_days: 2, max_days: 3 },
{ pincode: 182207, min_days: 2, max_days: 3 },
{ pincode: 182221, min_days: 2, max_days: 3 },
{ pincode: 182222, min_days: 2, max_days: 3 },
{ pincode: 182301, min_days: 2, max_days: 3 },
{ pincode: 182311, min_days: 2, max_days: 3 },
{ pincode: 182312, min_days: 2, max_days: 3 },
{ pincode: 182313, min_days: 2, max_days: 3 },
{ pincode: 182315, min_days: 2, max_days: 3 },
{ pincode: 182320, min_days: 2, max_days: 3 },
{ pincode: 184101, min_days: 2, max_days: 3 },
{ pincode: 184102, min_days: 2, max_days: 3 },
{ pincode: 184103, min_days: 2, max_days: 3 },
{ pincode: 184104, min_days: 2, max_days: 3 },
{ pincode: 184120, min_days: 2, max_days: 3 },
{ pincode: 184121, min_days: 2, max_days: 3 },
{ pincode: 184141, min_days: 2, max_days: 3 },
{ pincode: 184142, min_days: 2, max_days: 3 },
{ pincode: 184143, min_days: 2, max_days: 3 },
{ pincode: 184144, min_days: 2, max_days: 3 },
{ pincode: 184145, min_days: 2, max_days: 3 },
{ pincode: 184147, min_days: 2, max_days: 3 },
{ pincode: 184148, min_days: 2, max_days: 3 },
{ pincode: 184151, min_days: 2, max_days: 3 },
{ pincode: 184152, min_days: 2, max_days: 3 },
{ pincode: 184201, min_days: 2, max_days: 3 },
{ pincode: 184202, min_days: 2, max_days: 3 },
{ pincode: 184203, min_days: 2, max_days: 3 },
{ pincode: 184204, min_days: 2, max_days: 3 },
{ pincode: 184205, min_days: 2, max_days: 3 },
{ pincode: 184206, min_days: 2, max_days: 3 },
{ pincode: 184210, min_days: 2, max_days: 3 },
{ pincode: 185101, min_days: 2, max_days: 3 },
{ pincode: 185102, min_days: 2, max_days: 3 },
{ pincode: 185111, min_days: 2, max_days: 3 },
{ pincode: 185121, min_days: 2, max_days: 3 },
{ pincode: 185131, min_days: 2, max_days: 3 },
{ pincode: 185132, min_days: 2, max_days: 3 },
{ pincode: 185133, min_days: 2, max_days: 3 },
{ pincode: 185135, min_days: 2, max_days: 3 },
{ pincode: 185151, min_days: 2, max_days: 3 },
{ pincode: 185152, min_days: 2, max_days: 3 },
{ pincode: 185153, min_days: 2, max_days: 3 },
{ pincode: 185154, min_days: 2, max_days: 3 },
{ pincode: 185155, min_days: 2, max_days: 3 },
{ pincode: 185156, min_days: 2, max_days: 3 },
{ pincode: 185201, min_days: 2, max_days: 3 },
{ pincode: 185202, min_days: 2, max_days: 3 },
{ pincode: 185203, min_days: 2, max_days: 3 },
{ pincode: 185211, min_days: 2, max_days: 3 },
{ pincode: 185212, min_days: 2, max_days: 3 },
{ pincode: 185233, min_days: 2, max_days: 3 },
{ pincode: 185234, min_days: 2, max_days: 3 },
{ pincode: 190001, min_days: 2, max_days: 3 },
{ pincode: 190002, min_days: 2, max_days: 3 },
{ pincode: 190003, min_days: 2, max_days: 3 },
{ pincode: 190004, min_days: 2, max_days: 3 },
{ pincode: 190005, min_days: 2, max_days: 3 },
{ pincode: 190006, min_days: 2, max_days: 3 },
{ pincode: 190007, min_days: 2, max_days: 3 },
{ pincode: 190008, min_days: 2, max_days: 3 },
{ pincode: 190009, min_days: 2, max_days: 3 },
{ pincode: 190010, min_days: 2, max_days: 3 },
{ pincode: 190011, min_days: 2, max_days: 3 },
{ pincode: 190012, min_days: 2, max_days: 3 },
{ pincode: 190013, min_days: 2, max_days: 3 },
{ pincode: 190014, min_days: 2, max_days: 3 },
{ pincode: 190015, min_days: 2, max_days: 3 },
{ pincode: 190016, min_days: 2, max_days: 3 },
{ pincode: 190017, min_days: 2, max_days: 3 },
{ pincode: 190018, min_days: 2, max_days: 3 },
{ pincode: 190019, min_days: 2, max_days: 3 },
{ pincode: 190020, min_days: 2, max_days: 3 },
{ pincode: 190021, min_days: 2, max_days: 3 },
{ pincode: 190023, min_days: 2, max_days: 3 },
{ pincode: 190024, min_days: 2, max_days: 3 },
{ pincode: 190025, min_days: 2, max_days: 3 },
{ pincode: 191101, min_days: 2, max_days: 3 },
{ pincode: 191102, min_days: 2, max_days: 3 },
{ pincode: 191103, min_days: 2, max_days: 3 },
{ pincode: 191111, min_days: 2, max_days: 3 },
{ pincode: 191112, min_days: 2, max_days: 3 },
{ pincode: 191113, min_days: 2, max_days: 3 },
{ pincode: 191121, min_days: 2, max_days: 3 },
{ pincode: 191123, min_days: 2, max_days: 3 },
{ pincode: 191131, min_days: 2, max_days: 3 },
{ pincode: 191132, min_days: 2, max_days: 3 },
{ pincode: 191201, min_days: 2, max_days: 3 },
{ pincode: 191202, min_days: 2, max_days: 3 },
{ pincode: 191204, min_days: 2, max_days: 3 },
{ pincode: 192101, min_days: 2, max_days: 3 },
{ pincode: 192102, min_days: 2, max_days: 3 },
{ pincode: 192121, min_days: 2, max_days: 3 },
{ pincode: 192122, min_days: 2, max_days: 3 },
{ pincode: 192123, min_days: 2, max_days: 3 },
{ pincode: 192124, min_days: 2, max_days: 3 },
{ pincode: 192125, min_days: 2, max_days: 3 },
{ pincode: 192126, min_days: 2, max_days: 3 },
{ pincode: 192129, min_days: 2, max_days: 3 },
{ pincode: 192201, min_days: 2, max_days: 3 },
{ pincode: 192202, min_days: 2, max_days: 3 },
{ pincode: 192210, min_days: 2, max_days: 3 },
{ pincode: 192211, min_days: 2, max_days: 3 },
{ pincode: 192212, min_days: 2, max_days: 3 },
{ pincode: 192221, min_days: 2, max_days: 3 },
{ pincode: 192231, min_days: 2, max_days: 3 },
{ pincode: 192232, min_days: 2, max_days: 3 },
{ pincode: 192233, min_days: 2, max_days: 3 },
{ pincode: 192301, min_days: 2, max_days: 3 },
{ pincode: 192302, min_days: 2, max_days: 3 },
{ pincode: 192303, min_days: 2, max_days: 3 },
{ pincode: 192304, min_days: 2, max_days: 3 },
{ pincode: 192305, min_days: 2, max_days: 3 },
{ pincode: 192306, min_days: 2, max_days: 3 },
{ pincode: 192401, min_days: 2, max_days: 3 },
{ pincode: 193101, min_days: 2, max_days: 3 },
{ pincode: 193102, min_days: 2, max_days: 3 },
{ pincode: 193103, min_days: 2, max_days: 3 },
{ pincode: 193108, min_days: 2, max_days: 3 },
{ pincode: 193109, min_days: 2, max_days: 3 },
{ pincode: 193121, min_days: 2, max_days: 3 },
{ pincode: 193122, min_days: 2, max_days: 3 },
{ pincode: 193123, min_days: 2, max_days: 3 },
{ pincode: 193198, min_days: 2, max_days: 3 },
{ pincode: 193201, min_days: 2, max_days: 3 },
{ pincode: 193202, min_days: 2, max_days: 3 },
{ pincode: 193221, min_days: 2, max_days: 3 },
{ pincode: 193222, min_days: 2, max_days: 3 },
{ pincode: 193223, min_days: 2, max_days: 3 },
{ pincode: 193224, min_days: 2, max_days: 3 },
{ pincode: 193225, min_days: 2, max_days: 3 },
{ pincode: 193301, min_days: 2, max_days: 3 },
{ pincode: 193302, min_days: 2, max_days: 3 },
{ pincode: 193303, min_days: 2, max_days: 3 },
{ pincode: 193306, min_days: 2, max_days: 3 },
{ pincode: 193401, min_days: 2, max_days: 3 },
{ pincode: 193402, min_days: 2, max_days: 3 },
{ pincode: 193403, min_days: 2, max_days: 3 },
{ pincode: 193404, min_days: 2, max_days: 3 },
{ pincode: 193411, min_days: 2, max_days: 3 },
{ pincode: 193501, min_days: 2, max_days: 3 },
{ pincode: 193502, min_days: 2, max_days: 3 },
{ pincode: 193503, min_days: 2, max_days: 3 },
{ pincode: 193504, min_days: 2, max_days: 3 },
{ pincode: 193505, min_days: 2, max_days: 3 },
{ pincode: 194101, min_days: 2, max_days: 3 },
{ pincode: 194102, min_days: 2, max_days: 3 },
{ pincode: 194103, min_days: 2, max_days: 3 },
{ pincode: 194104, min_days: 2, max_days: 3 },
{ pincode: 194106, min_days: 2, max_days: 3 },
{ pincode: 194107, min_days: 2, max_days: 3 },
{ pincode: 194109, min_days: 2, max_days: 3 },
{ pincode: 194201, min_days: 2, max_days: 3 },
{ pincode: 194202, min_days: 2, max_days: 3 },
{ pincode: 194301, min_days: 2, max_days: 3 },
{ pincode: 194302, min_days: 2, max_days: 3 },
{ pincode: 194303, min_days: 2, max_days: 3 },
{ pincode: 194401, min_days: 2, max_days: 3 },
{ pincode: 200101, min_days: 2, max_days: 3 },
{ pincode: 200102, min_days: 2, max_days: 3 },
{ pincode: 200742, min_days: 2, max_days: 3 },
{ pincode: 201000, min_days: 2, max_days: 3 },
{ pincode: 201001, min_days: 2, max_days: 3 },
{ pincode: 201002, min_days: 2, max_days: 3 },
{ pincode: 201003, min_days: 2, max_days: 3 },
{ pincode: 201004, min_days: 2, max_days: 3 },
{ pincode: 201005, min_days: 2, max_days: 3 },
{ pincode: 201006, min_days: 2, max_days: 3 },
{ pincode: 201007, min_days: 2, max_days: 3 },
{ pincode: 201008, min_days: 2, max_days: 3 },
{ pincode: 201009, min_days: 2, max_days: 3 },
{ pincode: 201010, min_days: 2, max_days: 3 },
{ pincode: 201011, min_days: 2, max_days: 3 },
{ pincode: 201012, min_days: 2, max_days: 3 },
{ pincode: 201013, min_days: 2, max_days: 3 },
{ pincode: 201014, min_days: 2, max_days: 3 },
{ pincode: 201015, min_days: 2, max_days: 3 },
{ pincode: 201016, min_days: 2, max_days: 3 },
{ pincode: 201017, min_days: 2, max_days: 3 },
{ pincode: 201018, min_days: 2, max_days: 3 },
{ pincode: 201019, min_days: 2, max_days: 3 },
{ pincode: 201020, min_days: 2, max_days: 3 },
{ pincode: 201021, min_days: 2, max_days: 3 },
{ pincode: 201023, min_days: 2, max_days: 3 },
{ pincode: 201101, min_days: 2, max_days: 3 },
{ pincode: 201102, min_days: 2, max_days: 3 },
{ pincode: 201103, min_days: 2, max_days: 3 },
{ pincode: 201106, min_days: 2, max_days: 3 },
{ pincode: 201201, min_days: 2, max_days: 3 },
{ pincode: 201202, min_days: 2, max_days: 3 },
{ pincode: 201204, min_days: 2, max_days: 3 },
{ pincode: 201205, min_days: 2, max_days: 3 },
{ pincode: 201206, min_days: 2, max_days: 3 },
{ pincode: 201300, min_days: 2, max_days: 3 },
{ pincode: 201301, min_days: 2, max_days: 3 },
{ pincode: 201302, min_days: 2, max_days: 3 },
{ pincode: 201303, min_days: 2, max_days: 3 },
{ pincode: 201304, min_days: 2, max_days: 3 },
{ pincode: 201305, min_days: 2, max_days: 3 },
{ pincode: 201306, min_days: 2, max_days: 3 },
{ pincode: 201307, min_days: 2, max_days: 3 },
{ pincode: 201308, min_days: 2, max_days: 3 },
{ pincode: 201309, min_days: 2, max_days: 3 },
{ pincode: 201310, min_days: 2, max_days: 3 },
{ pincode: 201311, min_days: 2, max_days: 3 },
{ pincode: 201312, min_days: 2, max_days: 3 },
{ pincode: 201313, min_days: 2, max_days: 3 },
{ pincode: 201314, min_days: 2, max_days: 3 },
{ pincode: 201315, min_days: 2, max_days: 3 },
{ pincode: 201316, min_days: 2, max_days: 3 },
{ pincode: 201317, min_days: 2, max_days: 3 },
{ pincode: 201318, min_days: 2, max_days: 3 },
{ pincode: 202001, min_days: 2, max_days: 3 },
{ pincode: 202002, min_days: 2, max_days: 3 },
{ pincode: 202004, min_days: 2, max_days: 3 },
{ pincode: 202117, min_days: 2, max_days: 3 },
{ pincode: 202118, min_days: 2, max_days: 3 },
{ pincode: 202120, min_days: 2, max_days: 3 },
{ pincode: 202121, min_days: 2, max_days: 3 },
{ pincode: 202122, min_days: 2, max_days: 3 },
{ pincode: 202123, min_days: 2, max_days: 3 },
{ pincode: 202124, min_days: 2, max_days: 3 },
{ pincode: 202125, min_days: 2, max_days: 3 },
{ pincode: 202126, min_days: 2, max_days: 3 },
{ pincode: 202127, min_days: 2, max_days: 3 },
{ pincode: 202128, min_days: 2, max_days: 3 },
{ pincode: 202129, min_days: 2, max_days: 3 },
{ pincode: 202130, min_days: 2, max_days: 3 },
{ pincode: 202131, min_days: 2, max_days: 3 },
{ pincode: 202132, min_days: 2, max_days: 3 },
{ pincode: 202133, min_days: 2, max_days: 3 },
{ pincode: 202134, min_days: 2, max_days: 3 },
{ pincode: 202135, min_days: 2, max_days: 3 },
{ pincode: 202136, min_days: 2, max_days: 3 },
{ pincode: 202137, min_days: 2, max_days: 3 },
{ pincode: 202138, min_days: 2, max_days: 3 },
{ pincode: 202139, min_days: 2, max_days: 3 },
{ pincode: 202140, min_days: 2, max_days: 3 },
{ pincode: 202141, min_days: 2, max_days: 3 },
{ pincode: 202142, min_days: 2, max_days: 3 },
{ pincode: 202143, min_days: 2, max_days: 3 },
{ pincode: 202145, min_days: 2, max_days: 3 },
{ pincode: 202146, min_days: 2, max_days: 3 },
{ pincode: 202150, min_days: 2, max_days: 3 },
{ pincode: 202151, min_days: 2, max_days: 3 },
{ pincode: 202155, min_days: 2, max_days: 3 },
{ pincode: 202165, min_days: 2, max_days: 3 },
{ pincode: 202170, min_days: 2, max_days: 3 },
{ pincode: 202280, min_days: 2, max_days: 3 },
{ pincode: 202281, min_days: 2, max_days: 3 },
{ pincode: 202282, min_days: 2, max_days: 3 },
{ pincode: 202305, min_days: 2, max_days: 3 },
{ pincode: 202389, min_days: 2, max_days: 3 },
{ pincode: 202390, min_days: 2, max_days: 3 },
{ pincode: 202391, min_days: 2, max_days: 3 },
{ pincode: 202392, min_days: 2, max_days: 3 },
{ pincode: 202393, min_days: 2, max_days: 3 },
{ pincode: 202394, min_days: 2, max_days: 3 },
{ pincode: 202395, min_days: 2, max_days: 3 },
{ pincode: 202396, min_days: 2, max_days: 3 },
{ pincode: 202397, min_days: 2, max_days: 3 },
{ pincode: 202398, min_days: 2, max_days: 3 },
{ pincode: 202399, min_days: 2, max_days: 3 },
{ pincode: 202410, min_days: 2, max_days: 3 },
{ pincode: 202411, min_days: 2, max_days: 3 },
{ pincode: 202412, min_days: 2, max_days: 3 },
{ pincode: 202413, min_days: 2, max_days: 3 },
{ pincode: 202414, min_days: 2, max_days: 3 },
{ pincode: 202415, min_days: 2, max_days: 3 },
{ pincode: 202417, min_days: 2, max_days: 3 },
{ pincode: 202520, min_days: 2, max_days: 3 },
{ pincode: 202521, min_days: 2, max_days: 3 },
{ pincode: 202523, min_days: 2, max_days: 3 },
{ pincode: 202524, min_days: 2, max_days: 3 },
{ pincode: 202525, min_days: 2, max_days: 3 },
{ pincode: 202526, min_days: 2, max_days: 3 },
{ pincode: 202527, min_days: 2, max_days: 3 },
{ pincode: 202720, min_days: 2, max_days: 3 },
{ pincode: 202723, min_days: 2, max_days: 3 },
{ pincode: 203001, min_days: 2, max_days: 3 },
{ pincode: 203002, min_days: 2, max_days: 3 },
{ pincode: 203121, min_days: 2, max_days: 3 },
{ pincode: 203129, min_days: 2, max_days: 3 },
{ pincode: 203131, min_days: 2, max_days: 3 },
{ pincode: 203132, min_days: 2, max_days: 3 },
{ pincode: 203133, min_days: 2, max_days: 3 },
{ pincode: 203135, min_days: 2, max_days: 3 },
{ pincode: 203141, min_days: 2, max_days: 3 },
{ pincode: 203145, min_days: 2, max_days: 3 },
{ pincode: 203150, min_days: 2, max_days: 3 },
{ pincode: 203155, min_days: 2, max_days: 3 },
{ pincode: 203201, min_days: 2, max_days: 3 },
{ pincode: 203202, min_days: 2, max_days: 3 },
{ pincode: 203203, min_days: 2, max_days: 3 },
{ pincode: 203205, min_days: 2, max_days: 3 },
{ pincode: 203206, min_days: 2, max_days: 3 },
{ pincode: 203207, min_days: 2, max_days: 3 },
{ pincode: 203208, min_days: 2, max_days: 3 },
{ pincode: 203209, min_days: 2, max_days: 3 },
{ pincode: 203389, min_days: 2, max_days: 3 },
{ pincode: 203390, min_days: 2, max_days: 3 },
{ pincode: 203391, min_days: 2, max_days: 3 },
{ pincode: 203392, min_days: 2, max_days: 3 },
{ pincode: 203393, min_days: 2, max_days: 3 },
{ pincode: 203394, min_days: 2, max_days: 3 },
{ pincode: 203395, min_days: 2, max_days: 3 },
{ pincode: 203396, min_days: 2, max_days: 3 },
{ pincode: 203397, min_days: 2, max_days: 3 },
{ pincode: 203398, min_days: 2, max_days: 3 },
{ pincode: 203399, min_days: 2, max_days: 3 },
{ pincode: 203401, min_days: 2, max_days: 3 },
{ pincode: 203402, min_days: 2, max_days: 3 },
{ pincode: 203403, min_days: 2, max_days: 3 },
{ pincode: 203405, min_days: 2, max_days: 3 },
{ pincode: 203407, min_days: 2, max_days: 3 },
{ pincode: 203408, min_days: 2, max_days: 3 },
{ pincode: 203409, min_days: 2, max_days: 3 },
{ pincode: 203411, min_days: 2, max_days: 3 },
{ pincode: 203412, min_days: 2, max_days: 3 },
{ pincode: 204001, min_days: 2, max_days: 3 },
{ pincode: 204101, min_days: 2, max_days: 3 },
{ pincode: 204102, min_days: 2, max_days: 3 },
{ pincode: 204103, min_days: 2, max_days: 3 },
{ pincode: 204104, min_days: 2, max_days: 3 },
{ pincode: 204105, min_days: 2, max_days: 3 },
{ pincode: 204106, min_days: 2, max_days: 3 },
{ pincode: 204207, min_days: 2, max_days: 3 },
{ pincode: 204208, min_days: 2, max_days: 3 },
{ pincode: 204210, min_days: 2, max_days: 3 },
{ pincode: 204211, min_days: 2, max_days: 3 },
{ pincode: 204212, min_days: 2, max_days: 3 },
{ pincode: 204213, min_days: 2, max_days: 3 },
{ pincode: 204214, min_days: 2, max_days: 3 },
{ pincode: 204215, min_days: 2, max_days: 3 },
{ pincode: 204216, min_days: 2, max_days: 3 },
{ pincode: 204217, min_days: 2, max_days: 3 },
{ pincode: 205001, min_days: 2, max_days: 3 },
{ pincode: 205119, min_days: 2, max_days: 3 },
{ pincode: 205120, min_days: 2, max_days: 3 },
{ pincode: 205121, min_days: 2, max_days: 3 },
{ pincode: 205125, min_days: 2, max_days: 3 },
{ pincode: 205130, min_days: 2, max_days: 3 },
{ pincode: 205135, min_days: 2, max_days: 3 },
{ pincode: 205141, min_days: 2, max_days: 3 },
{ pincode: 205142, min_days: 2, max_days: 3 },
{ pincode: 205145, min_days: 2, max_days: 3 },
{ pincode: 205147, min_days: 2, max_days: 3 },
{ pincode: 205151, min_days: 2, max_days: 3 },
{ pincode: 205152, min_days: 2, max_days: 3 },
{ pincode: 205247, min_days: 2, max_days: 3 },
{ pincode: 205261, min_days: 2, max_days: 3 },
{ pincode: 205262, min_days: 2, max_days: 3 },
{ pincode: 205263, min_days: 2, max_days: 3 },
{ pincode: 205264, min_days: 2, max_days: 3 },
{ pincode: 205265, min_days: 2, max_days: 3 },
{ pincode: 205266, min_days: 2, max_days: 3 },
{ pincode: 205267, min_days: 2, max_days: 3 },
{ pincode: 205268, min_days: 2, max_days: 3 },
{ pincode: 205301, min_days: 2, max_days: 3 },
{ pincode: 205302, min_days: 2, max_days: 3 },
{ pincode: 205303, min_days: 2, max_days: 3 },
{ pincode: 205304, min_days: 2, max_days: 3 },
{ pincode: 206001, min_days: 2, max_days: 3 },
{ pincode: 206002, min_days: 2, max_days: 3 },
{ pincode: 206003, min_days: 2, max_days: 3 },
{ pincode: 206016, min_days: 2, max_days: 3 },
{ pincode: 206120, min_days: 2, max_days: 3 },
{ pincode: 206121, min_days: 2, max_days: 3 },
{ pincode: 206122, min_days: 2, max_days: 3 },
{ pincode: 206123, min_days: 2, max_days: 3 },
{ pincode: 206124, min_days: 2, max_days: 3 },
{ pincode: 206125, min_days: 2, max_days: 3 },
{ pincode: 206126, min_days: 2, max_days: 3 },
{ pincode: 206127, min_days: 2, max_days: 3 },
{ pincode: 206128, min_days: 2, max_days: 3 },
{ pincode: 206129, min_days: 2, max_days: 3 },
{ pincode: 206130, min_days: 2, max_days: 3 },
{ pincode: 206131, min_days: 2, max_days: 3 },
{ pincode: 206241, min_days: 2, max_days: 3 },
{ pincode: 206242, min_days: 2, max_days: 3 },
{ pincode: 206243, min_days: 2, max_days: 3 },
{ pincode: 206244, min_days: 2, max_days: 3 },
{ pincode: 206245, min_days: 2, max_days: 3 },
{ pincode: 206246, min_days: 2, max_days: 3 },
{ pincode: 206247, min_days: 2, max_days: 3 },
{ pincode: 206248, min_days: 2, max_days: 3 },
{ pincode: 206249, min_days: 2, max_days: 3 },
{ pincode: 206250, min_days: 2, max_days: 3 },
{ pincode: 206251, min_days: 2, max_days: 3 },
{ pincode: 206252, min_days: 2, max_days: 3 },
{ pincode: 206253, min_days: 2, max_days: 3 },
{ pincode: 206255, min_days: 2, max_days: 3 },
{ pincode: 206301, min_days: 2, max_days: 3 },
{ pincode: 206302, min_days: 2, max_days: 3 },
{ pincode: 206303, min_days: 2, max_days: 3 },
{ pincode: 206451, min_days: 2, max_days: 3 },
{ pincode: 207001, min_days: 2, max_days: 3 },
{ pincode: 207002, min_days: 2, max_days: 3 },
{ pincode: 207003, min_days: 2, max_days: 3 },
{ pincode: 207120, min_days: 2, max_days: 3 },
{ pincode: 207121, min_days: 2, max_days: 3 },
{ pincode: 207122, min_days: 2, max_days: 3 },
{ pincode: 207123, min_days: 2, max_days: 3 },
{ pincode: 207124, min_days: 2, max_days: 3 },
{ pincode: 207125, min_days: 2, max_days: 3 },
{ pincode: 207126, min_days: 2, max_days: 3 },
{ pincode: 207241, min_days: 2, max_days: 3 },
{ pincode: 207242, min_days: 2, max_days: 3 },
{ pincode: 207243, min_days: 2, max_days: 3 },
{ pincode: 207244, min_days: 2, max_days: 3 },
{ pincode: 207245, min_days: 2, max_days: 3 },
{ pincode: 207246, min_days: 2, max_days: 3 },
{ pincode: 207247, min_days: 2, max_days: 3 },
{ pincode: 207248, min_days: 2, max_days: 3 },
{ pincode: 207249, min_days: 2, max_days: 3 },
{ pincode: 207250, min_days: 2, max_days: 3 },
{ pincode: 207301, min_days: 2, max_days: 3 },
{ pincode: 207302, min_days: 2, max_days: 3 },
{ pincode: 207401, min_days: 2, max_days: 3 },
{ pincode: 207402, min_days: 2, max_days: 3 },
{ pincode: 207403, min_days: 2, max_days: 3 },
{ pincode: 207404, min_days: 2, max_days: 3 },
{ pincode: 207501, min_days: 2, max_days: 3 },
{ pincode: 207502, min_days: 2, max_days: 3 },
{ pincode: 207503, min_days: 2, max_days: 3 },
{ pincode: 207505, min_days: 2, max_days: 3 },
{ pincode: 208001, min_days: 2, max_days: 3 },
{ pincode: 208002, min_days: 2, max_days: 3 },
{ pincode: 208003, min_days: 2, max_days: 3 },
{ pincode: 208004, min_days: 2, max_days: 3 },
{ pincode: 208005, min_days: 2, max_days: 3 },
{ pincode: 208006, min_days: 2, max_days: 3 },
{ pincode: 208007, min_days: 2, max_days: 3 },
{ pincode: 208008, min_days: 2, max_days: 3 },
{ pincode: 208009, min_days: 2, max_days: 3 },
{ pincode: 208010, min_days: 2, max_days: 3 },
{ pincode: 208011, min_days: 2, max_days: 3 },
{ pincode: 208012, min_days: 2, max_days: 3 },
{ pincode: 208013, min_days: 2, max_days: 3 },
{ pincode: 208014, min_days: 2, max_days: 3 },
{ pincode: 208015, min_days: 2, max_days: 3 },
{ pincode: 208016, min_days: 2, max_days: 3 },
{ pincode: 208017, min_days: 2, max_days: 3 },
{ pincode: 208018, min_days: 2, max_days: 3 },
{ pincode: 208019, min_days: 2, max_days: 3 },
{ pincode: 208020, min_days: 2, max_days: 3 },
{ pincode: 208021, min_days: 2, max_days: 3 },
{ pincode: 208022, min_days: 2, max_days: 3 },
{ pincode: 208023, min_days: 2, max_days: 3 },
{ pincode: 208024, min_days: 2, max_days: 3 },
{ pincode: 208025, min_days: 2, max_days: 3 },
{ pincode: 208026, min_days: 2, max_days: 3 },
{ pincode: 208027, min_days: 2, max_days: 3 },
{ pincode: 208039, min_days: 2, max_days: 3 },
{ pincode: 208120, min_days: 2, max_days: 3 },
{ pincode: 209101, min_days: 2, max_days: 3 },
{ pincode: 209111, min_days: 2, max_days: 3 },
{ pincode: 209112, min_days: 2, max_days: 3 },
{ pincode: 209115, min_days: 2, max_days: 3 },
{ pincode: 209121, min_days: 2, max_days: 3 },
{ pincode: 209125, min_days: 2, max_days: 3 },
{ pincode: 209201, min_days: 2, max_days: 3 },
{ pincode: 209202, min_days: 2, max_days: 3 },
{ pincode: 209203, min_days: 2, max_days: 3 },
{ pincode: 209204, min_days: 2, max_days: 3 },
{ pincode: 209205, min_days: 2, max_days: 3 },
{ pincode: 209206, min_days: 2, max_days: 3 },
{ pincode: 209207, min_days: 2, max_days: 3 },
{ pincode: 209208, min_days: 2, max_days: 3 },
{ pincode: 209209, min_days: 2, max_days: 3 },
{ pincode: 209210, min_days: 2, max_days: 3 },
{ pincode: 209214, min_days: 2, max_days: 3 },
{ pincode: 209217, min_days: 2, max_days: 3 },
{ pincode: 209293, min_days: 2, max_days: 3 },
{ pincode: 209301, min_days: 2, max_days: 3 },
{ pincode: 209302, min_days: 2, max_days: 3 },
{ pincode: 209303, min_days: 2, max_days: 3 },
{ pincode: 209304, min_days: 2, max_days: 3 },
{ pincode: 209305, min_days: 2, max_days: 3 },
{ pincode: 209306, min_days: 2, max_days: 3 },
{ pincode: 209307, min_days: 2, max_days: 3 },
{ pincode: 209308, min_days: 2, max_days: 3 },
{ pincode: 209310, min_days: 2, max_days: 3 },
{ pincode: 209311, min_days: 2, max_days: 3 },
{ pincode: 209312, min_days: 2, max_days: 3 },
{ pincode: 209401, min_days: 2, max_days: 3 },
{ pincode: 209402, min_days: 2, max_days: 3 },
{ pincode: 209407, min_days: 2, max_days: 3 },
{ pincode: 209501, min_days: 2, max_days: 3 },
{ pincode: 209502, min_days: 2, max_days: 3 },
{ pincode: 209503, min_days: 2, max_days: 3 },
{ pincode: 209504, min_days: 2, max_days: 3 },
{ pincode: 209505, min_days: 2, max_days: 3 },
{ pincode: 209506, min_days: 2, max_days: 3 },
{ pincode: 209601, min_days: 2, max_days: 3 },
{ pincode: 209602, min_days: 2, max_days: 3 },
{ pincode: 209608, min_days: 2, max_days: 3 },
{ pincode: 209621, min_days: 2, max_days: 3 },
{ pincode: 209622, min_days: 2, max_days: 3 },
{ pincode: 209624, min_days: 2, max_days: 3 },
{ pincode: 209625, min_days: 2, max_days: 3 },
{ pincode: 209651, min_days: 2, max_days: 3 },
{ pincode: 209652, min_days: 2, max_days: 3 },
{ pincode: 209701, min_days: 2, max_days: 3 },
{ pincode: 209715, min_days: 2, max_days: 3 },
{ pincode: 209720, min_days: 2, max_days: 3 },
{ pincode: 209721, min_days: 2, max_days: 3 },
{ pincode: 209722, min_days: 2, max_days: 3 },
{ pincode: 209723, min_days: 2, max_days: 3 },
{ pincode: 209724, min_days: 2, max_days: 3 },
{ pincode: 209725, min_days: 2, max_days: 3 },
{ pincode: 209726, min_days: 2, max_days: 3 },
{ pincode: 209727, min_days: 2, max_days: 3 },
{ pincode: 209728, min_days: 2, max_days: 3 },
{ pincode: 209729, min_days: 2, max_days: 3 },
{ pincode: 209731, min_days: 2, max_days: 3 },
{ pincode: 209732, min_days: 2, max_days: 3 },
{ pincode: 209733, min_days: 2, max_days: 3 },
{ pincode: 209734, min_days: 2, max_days: 3 },
{ pincode: 209735, min_days: 2, max_days: 3 },
{ pincode: 209736, min_days: 2, max_days: 3 },
{ pincode: 209738, min_days: 2, max_days: 3 },
{ pincode: 209739, min_days: 2, max_days: 3 },
{ pincode: 209743, min_days: 2, max_days: 3 },
{ pincode: 209744, min_days: 2, max_days: 3 },
{ pincode: 209745, min_days: 2, max_days: 3 },
{ pincode: 209746, min_days: 2, max_days: 3 },
{ pincode: 209747, min_days: 2, max_days: 3 },
{ pincode: 209748, min_days: 2, max_days: 3 },
{ pincode: 209749, min_days: 2, max_days: 3 },
{ pincode: 209800, min_days: 2, max_days: 3 },
{ pincode: 209801, min_days: 2, max_days: 3 },
{ pincode: 209821, min_days: 2, max_days: 3 },
{ pincode: 209822, min_days: 2, max_days: 3 },
{ pincode: 209825, min_days: 2, max_days: 3 },
{ pincode: 209827, min_days: 2, max_days: 3 },
{ pincode: 209831, min_days: 2, max_days: 3 },
{ pincode: 209841, min_days: 2, max_days: 3 },
{ pincode: 209859, min_days: 2, max_days: 3 },
{ pincode: 209860, min_days: 2, max_days: 3 },
{ pincode: 209861, min_days: 2, max_days: 3 },
{ pincode: 209862, min_days: 2, max_days: 3 },
{ pincode: 209863, min_days: 2, max_days: 3 },
{ pincode: 209864, min_days: 2, max_days: 3 },
{ pincode: 209865, min_days: 2, max_days: 3 },
{ pincode: 209866, min_days: 2, max_days: 3 },
{ pincode: 209867, min_days: 2, max_days: 3 },
{ pincode: 209868, min_days: 2, max_days: 3 },
{ pincode: 209869, min_days: 2, max_days: 3 },
{ pincode: 209870, min_days: 2, max_days: 3 },
{ pincode: 209871, min_days: 2, max_days: 3 },
{ pincode: 209881, min_days: 2, max_days: 3 },
{ pincode: 210001, min_days: 2, max_days: 3 },
{ pincode: 210009, min_days: 2, max_days: 3 },
{ pincode: 210010, min_days: 2, max_days: 3 },
{ pincode: 210011, min_days: 2, max_days: 3 },
{ pincode: 210012, min_days: 2, max_days: 3 },
{ pincode: 210100, min_days: 2, max_days: 3 },
{ pincode: 210105, min_days: 2, max_days: 3 },
{ pincode: 210120, min_days: 2, max_days: 3 },
{ pincode: 210121, min_days: 2, max_days: 3 },
{ pincode: 210123, min_days: 2, max_days: 3 },
{ pincode: 210125, min_days: 2, max_days: 3 },
{ pincode: 210126, min_days: 2, max_days: 3 },
{ pincode: 210128, min_days: 2, max_days: 3 },
{ pincode: 210129, min_days: 2, max_days: 3 },
{ pincode: 210201, min_days: 2, max_days: 3 },
{ pincode: 210202, min_days: 2, max_days: 3 },
{ pincode: 210203, min_days: 2, max_days: 3 },
{ pincode: 210204, min_days: 2, max_days: 3 },
{ pincode: 210205, min_days: 2, max_days: 3 },
{ pincode: 210206, min_days: 2, max_days: 3 },
{ pincode: 210207, min_days: 2, max_days: 3 },
{ pincode: 210208, min_days: 2, max_days: 3 },
{ pincode: 210209, min_days: 2, max_days: 3 },
{ pincode: 210301, min_days: 2, max_days: 3 },
{ pincode: 210302, min_days: 2, max_days: 3 },
{ pincode: 210341, min_days: 2, max_days: 3 },
{ pincode: 210421, min_days: 2, max_days: 3 },
{ pincode: 210422, min_days: 2, max_days: 3 },
{ pincode: 210423, min_days: 2, max_days: 3 },
{ pincode: 210424, min_days: 2, max_days: 3 },
{ pincode: 210425, min_days: 2, max_days: 3 },
{ pincode: 210426, min_days: 2, max_days: 3 },
{ pincode: 210427, min_days: 2, max_days: 3 },
{ pincode: 210428, min_days: 2, max_days: 3 },
{ pincode: 210429, min_days: 2, max_days: 3 },
{ pincode: 210430, min_days: 2, max_days: 3 },
{ pincode: 210431, min_days: 2, max_days: 3 },
{ pincode: 210432, min_days: 2, max_days: 3 },
{ pincode: 210433, min_days: 2, max_days: 3 },
{ pincode: 210434, min_days: 2, max_days: 3 },
{ pincode: 210501, min_days: 2, max_days: 3 },
{ pincode: 210502, min_days: 2, max_days: 3 },
{ pincode: 210504, min_days: 2, max_days: 3 },
{ pincode: 210505, min_days: 2, max_days: 3 },
{ pincode: 210506, min_days: 2, max_days: 3 },
{ pincode: 210507, min_days: 2, max_days: 3 },
{ pincode: 211001, min_days: 2, max_days: 3 },
{ pincode: 211002, min_days: 2, max_days: 3 },
{ pincode: 211003, min_days: 2, max_days: 3 },
{ pincode: 211004, min_days: 2, max_days: 3 },
{ pincode: 211005, min_days: 2, max_days: 3 },
{ pincode: 211006, min_days: 2, max_days: 3 },
{ pincode: 211007, min_days: 2, max_days: 3 },
{ pincode: 211008, min_days: 2, max_days: 3 },
{ pincode: 211009, min_days: 2, max_days: 3 },
{ pincode: 211010, min_days: 2, max_days: 3 },
{ pincode: 211011, min_days: 2, max_days: 3 },
{ pincode: 211012, min_days: 2, max_days: 3 },
{ pincode: 211013, min_days: 2, max_days: 3 },
{ pincode: 211014, min_days: 2, max_days: 3 },
{ pincode: 211015, min_days: 2, max_days: 3 },
{ pincode: 211016, min_days: 2, max_days: 3 },
{ pincode: 211017, min_days: 2, max_days: 3 },
{ pincode: 211018, min_days: 2, max_days: 3 },
{ pincode: 211019, min_days: 2, max_days: 3 },
{ pincode: 211020, min_days: 2, max_days: 3 },
{ pincode: 211021, min_days: 2, max_days: 3 },
{ pincode: 211022, min_days: 2, max_days: 3 },
{ pincode: 211023, min_days: 2, max_days: 3 },
{ pincode: 211104, min_days: 2, max_days: 3 },
{ pincode: 212011, min_days: 2, max_days: 3 },
{ pincode: 212104, min_days: 2, max_days: 3 },
{ pincode: 212105, min_days: 2, max_days: 3 },
{ pincode: 212106, min_days: 2, max_days: 3 },
{ pincode: 212107, min_days: 2, max_days: 3 },
{ pincode: 212108, min_days: 2, max_days: 3 },
{ pincode: 212109, min_days: 2, max_days: 3 },
{ pincode: 212111, min_days: 2, max_days: 3 },
{ pincode: 212128, min_days: 2, max_days: 3 },
{ pincode: 212201, min_days: 2, max_days: 3 },
{ pincode: 212202, min_days: 2, max_days: 3 },
{ pincode: 212203, min_days: 2, max_days: 3 },
{ pincode: 212204, min_days: 2, max_days: 3 },
{ pincode: 212205, min_days: 2, max_days: 3 },
{ pincode: 212206, min_days: 2, max_days: 3 },
{ pincode: 212207, min_days: 2, max_days: 3 },
{ pincode: 212208, min_days: 2, max_days: 3 },
{ pincode: 212210, min_days: 2, max_days: 3 },
{ pincode: 212212, min_days: 2, max_days: 3 },
{ pincode: 212213, min_days: 2, max_days: 3 },
{ pincode: 212214, min_days: 2, max_days: 3 },
{ pincode: 212215, min_days: 2, max_days: 3 },
{ pincode: 212216, min_days: 2, max_days: 3 },
{ pincode: 212217, min_days: 2, max_days: 3 },
{ pincode: 212218, min_days: 2, max_days: 3 },
{ pincode: 212301, min_days: 2, max_days: 3 },
{ pincode: 212302, min_days: 2, max_days: 3 },
{ pincode: 212303, min_days: 2, max_days: 3 },
{ pincode: 212304, min_days: 2, max_days: 3 },
{ pincode: 212305, min_days: 2, max_days: 3 },
{ pincode: 212306, min_days: 2, max_days: 3 },
{ pincode: 212307, min_days: 2, max_days: 3 },
{ pincode: 212308, min_days: 2, max_days: 3 },
{ pincode: 212401, min_days: 2, max_days: 3 },
{ pincode: 212402, min_days: 2, max_days: 3 },
{ pincode: 212404, min_days: 2, max_days: 3 },
{ pincode: 212405, min_days: 2, max_days: 3 },
{ pincode: 212410, min_days: 2, max_days: 3 },
{ pincode: 212413, min_days: 2, max_days: 3 },
{ pincode: 212501, min_days: 2, max_days: 3 },
{ pincode: 212502, min_days: 2, max_days: 3 },
{ pincode: 212503, min_days: 2, max_days: 3 },
{ pincode: 212507, min_days: 2, max_days: 3 },
{ pincode: 212601, min_days: 2, max_days: 3 },
{ pincode: 212620, min_days: 2, max_days: 3 },
{ pincode: 212621, min_days: 2, max_days: 3 },
{ pincode: 212622, min_days: 2, max_days: 3 },
{ pincode: 212623, min_days: 2, max_days: 3 },
{ pincode: 212631, min_days: 2, max_days: 3 },
{ pincode: 212635, min_days: 2, max_days: 3 },
{ pincode: 212641, min_days: 2, max_days: 3 },
{ pincode: 212645, min_days: 2, max_days: 3 },
{ pincode: 212650, min_days: 2, max_days: 3 },
{ pincode: 212651, min_days: 2, max_days: 3 },
{ pincode: 212652, min_days: 2, max_days: 3 },
{ pincode: 212653, min_days: 2, max_days: 3 },
{ pincode: 212654, min_days: 2, max_days: 3 },
{ pincode: 212655, min_days: 2, max_days: 3 },
{ pincode: 212656, min_days: 2, max_days: 3 },
{ pincode: 212657, min_days: 2, max_days: 3 },
{ pincode: 212658, min_days: 2, max_days: 3 },
{ pincode: 212659, min_days: 2, max_days: 3 },
{ pincode: 212660, min_days: 2, max_days: 3 },
{ pincode: 212661, min_days: 2, max_days: 3 },
{ pincode: 212662, min_days: 2, max_days: 3 },
{ pincode: 212663, min_days: 2, max_days: 3 },
{ pincode: 212664, min_days: 2, max_days: 3 },
{ pincode: 212665, min_days: 2, max_days: 3 },
{ pincode: 212666, min_days: 2, max_days: 3 },
{ pincode: 215126, min_days: 2, max_days: 3 },
{ pincode: 220016, min_days: 2, max_days: 3 },
{ pincode: 221001, min_days: 2, max_days: 3 },
{ pincode: 221002, min_days: 2, max_days: 3 },
{ pincode: 221003, min_days: 2, max_days: 3 },
{ pincode: 221004, min_days: 2, max_days: 3 },
{ pincode: 221005, min_days: 2, max_days: 3 },
{ pincode: 221006, min_days: 2, max_days: 3 },
{ pincode: 221007, min_days: 2, max_days: 3 },
{ pincode: 221008, min_days: 2, max_days: 3 },
{ pincode: 221009, min_days: 2, max_days: 3 },
{ pincode: 221010, min_days: 2, max_days: 3 },
{ pincode: 221011, min_days: 2, max_days: 3 },
{ pincode: 221012, min_days: 2, max_days: 3 },
{ pincode: 221101, min_days: 2, max_days: 3 },
{ pincode: 221102, min_days: 2, max_days: 3 },
{ pincode: 221103, min_days: 2, max_days: 3 },
{ pincode: 221104, min_days: 2, max_days: 3 },
{ pincode: 221105, min_days: 2, max_days: 3 },
{ pincode: 221106, min_days: 2, max_days: 3 },
{ pincode: 221107, min_days: 2, max_days: 3 },
{ pincode: 221108, min_days: 2, max_days: 3 },
{ pincode: 221109, min_days: 2, max_days: 3 },
{ pincode: 221110, min_days: 2, max_days: 3 },
{ pincode: 221111, min_days: 2, max_days: 3 },
{ pincode: 221112, min_days: 2, max_days: 3 },
{ pincode: 221113, min_days: 2, max_days: 3 },
{ pincode: 221115, min_days: 2, max_days: 3 },
{ pincode: 221116, min_days: 2, max_days: 3 },
{ pincode: 221201, min_days: 2, max_days: 3 },
{ pincode: 221202, min_days: 2, max_days: 3 },
{ pincode: 221203, min_days: 2, max_days: 3 },
{ pincode: 221204, min_days: 2, max_days: 3 },
{ pincode: 221205, min_days: 2, max_days: 3 },
{ pincode: 221206, min_days: 2, max_days: 3 },
{ pincode: 221207, min_days: 2, max_days: 3 },
{ pincode: 221208, min_days: 2, max_days: 3 },
{ pincode: 221209, min_days: 2, max_days: 3 },
{ pincode: 221210, min_days: 2, max_days: 3 },
{ pincode: 221211, min_days: 2, max_days: 3 },
{ pincode: 221301, min_days: 2, max_days: 3 },
{ pincode: 221302, min_days: 2, max_days: 3 },
{ pincode: 221303, min_days: 2, max_days: 3 },
{ pincode: 221304, min_days: 2, max_days: 3 },
{ pincode: 221305, min_days: 2, max_days: 3 },
{ pincode: 221306, min_days: 2, max_days: 3 },
{ pincode: 221307, min_days: 2, max_days: 3 },
{ pincode: 221308, min_days: 2, max_days: 3 },
{ pincode: 221309, min_days: 2, max_days: 3 },
{ pincode: 221310, min_days: 2, max_days: 3 },
{ pincode: 221311, min_days: 2, max_days: 3 },
{ pincode: 221313, min_days: 2, max_days: 3 },
{ pincode: 221314, min_days: 2, max_days: 3 },
{ pincode: 221401, min_days: 2, max_days: 3 },
{ pincode: 221402, min_days: 2, max_days: 3 },
{ pincode: 221403, min_days: 2, max_days: 3 },
{ pincode: 221404, min_days: 2, max_days: 3 },
{ pincode: 221405, min_days: 2, max_days: 3 },
{ pincode: 221406, min_days: 2, max_days: 3 },
{ pincode: 221407, min_days: 2, max_days: 3 },
{ pincode: 221408, min_days: 2, max_days: 3 },
{ pincode: 221409, min_days: 2, max_days: 3 },
{ pincode: 221502, min_days: 2, max_days: 3 },
{ pincode: 221503, min_days: 2, max_days: 3 },
{ pincode: 221504, min_days: 2, max_days: 3 },
{ pincode: 221505, min_days: 2, max_days: 3 },
{ pincode: 221506, min_days: 2, max_days: 3 },
{ pincode: 221507, min_days: 2, max_days: 3 },
{ pincode: 221508, min_days: 2, max_days: 3 },
{ pincode: 221601, min_days: 2, max_days: 3 },
{ pincode: 221602, min_days: 2, max_days: 3 },
{ pincode: 221603, min_days: 2, max_days: 3 },
{ pincode: 221605, min_days: 2, max_days: 3 },
{ pincode: 221701, min_days: 2, max_days: 3 },
{ pincode: 221705, min_days: 2, max_days: 3 },
{ pincode: 221706, min_days: 2, max_days: 3 },
{ pincode: 221709, min_days: 2, max_days: 3 },
{ pincode: 221711, min_days: 2, max_days: 3 },
{ pincode: 221712, min_days: 2, max_days: 3 },
{ pincode: 221713, min_days: 2, max_days: 3 },
{ pincode: 221714, min_days: 2, max_days: 3 },
{ pincode: 221715, min_days: 2, max_days: 3 },
{ pincode: 221716, min_days: 2, max_days: 3 },
{ pincode: 221717, min_days: 2, max_days: 3 },
{ pincode: 221718, min_days: 2, max_days: 3 },
{ pincode: 221719, min_days: 2, max_days: 3 },
{ pincode: 222001, min_days: 2, max_days: 3 },
{ pincode: 222002, min_days: 2, max_days: 3 },
{ pincode: 222003, min_days: 2, max_days: 3 },
{ pincode: 222101, min_days: 2, max_days: 3 },
{ pincode: 222102, min_days: 2, max_days: 3 },
{ pincode: 222103, min_days: 2, max_days: 3 },
{ pincode: 222104, min_days: 2, max_days: 3 },
{ pincode: 222105, min_days: 2, max_days: 3 },
{ pincode: 222107, min_days: 2, max_days: 3 },
{ pincode: 222108, min_days: 2, max_days: 3 },
{ pincode: 222109, min_days: 2, max_days: 3 },
{ pincode: 222110, min_days: 2, max_days: 3 },
{ pincode: 222111, min_days: 2, max_days: 3 },
{ pincode: 222112, min_days: 2, max_days: 3 },
{ pincode: 222113, min_days: 2, max_days: 3 },
{ pincode: 222125, min_days: 2, max_days: 3 },
{ pincode: 222126, min_days: 2, max_days: 3 },
{ pincode: 222127, min_days: 2, max_days: 3 },
{ pincode: 222128, min_days: 2, max_days: 3 },
{ pincode: 222129, min_days: 2, max_days: 3 },
{ pincode: 222131, min_days: 2, max_days: 3 },
{ pincode: 222132, min_days: 2, max_days: 3 },
{ pincode: 222133, min_days: 2, max_days: 3 },
{ pincode: 222135, min_days: 2, max_days: 3 },
{ pincode: 222136, min_days: 2, max_days: 3 },
{ pincode: 222137, min_days: 2, max_days: 3 },
{ pincode: 222138, min_days: 2, max_days: 3 },
{ pincode: 222139, min_days: 2, max_days: 3 },
{ pincode: 222141, min_days: 2, max_days: 3 },
{ pincode: 222142, min_days: 2, max_days: 3 },
{ pincode: 222143, min_days: 2, max_days: 3 },
{ pincode: 222144, min_days: 2, max_days: 3 },
{ pincode: 222145, min_days: 2, max_days: 3 },
{ pincode: 222146, min_days: 2, max_days: 3 },
{ pincode: 222148, min_days: 2, max_days: 3 },
{ pincode: 222149, min_days: 2, max_days: 3 },
{ pincode: 222161, min_days: 2, max_days: 3 },
{ pincode: 222162, min_days: 2, max_days: 3 },
{ pincode: 222165, min_days: 2, max_days: 3 },
{ pincode: 222170, min_days: 2, max_days: 3 },
{ pincode: 222175, min_days: 2, max_days: 3 },
{ pincode: 222180, min_days: 2, max_days: 3 },
{ pincode: 222181, min_days: 2, max_days: 3 },
{ pincode: 222201, min_days: 2, max_days: 3 },
{ pincode: 222202, min_days: 2, max_days: 3 },
{ pincode: 222203, min_days: 2, max_days: 3 },
{ pincode: 222204, min_days: 2, max_days: 3 },
{ pincode: 222205, min_days: 2, max_days: 3 },
{ pincode: 222301, min_days: 2, max_days: 3 },
{ pincode: 222302, min_days: 2, max_days: 3 },
{ pincode: 222303, min_days: 2, max_days: 3 },
{ pincode: 222304, min_days: 2, max_days: 3 },
{ pincode: 223101, min_days: 2, max_days: 3 },
{ pincode: 223102, min_days: 2, max_days: 3 },
{ pincode: 223103, min_days: 2, max_days: 3 },
{ pincode: 223104, min_days: 2, max_days: 3 },
{ pincode: 223105, min_days: 2, max_days: 3 },
{ pincode: 223106, min_days: 2, max_days: 3 },
{ pincode: 223107, min_days: 2, max_days: 3 },
{ pincode: 223221, min_days: 2, max_days: 3 },
{ pincode: 223222, min_days: 2, max_days: 3 },
{ pincode: 223223, min_days: 2, max_days: 3 },
{ pincode: 223224, min_days: 2, max_days: 3 },
{ pincode: 223225, min_days: 2, max_days: 3 },
{ pincode: 223226, min_days: 2, max_days: 3 },
{ pincode: 223227, min_days: 2, max_days: 3 },
{ pincode: 223288, min_days: 2, max_days: 3 },
{ pincode: 224001, min_days: 2, max_days: 3 },
{ pincode: 224116, min_days: 2, max_days: 3 },
{ pincode: 224117, min_days: 2, max_days: 3 },
{ pincode: 224118, min_days: 2, max_days: 3 },
{ pincode: 224119, min_days: 2, max_days: 3 },
{ pincode: 224120, min_days: 2, max_days: 3 },
{ pincode: 224121, min_days: 2, max_days: 3 },
{ pincode: 224122, min_days: 2, max_days: 3 },
{ pincode: 224123, min_days: 2, max_days: 3 },
{ pincode: 224125, min_days: 2, max_days: 3 },
{ pincode: 224126, min_days: 2, max_days: 3 },
{ pincode: 224127, min_days: 2, max_days: 3 },
{ pincode: 224129, min_days: 2, max_days: 3 },
{ pincode: 224132, min_days: 2, max_days: 3 },
{ pincode: 224133, min_days: 2, max_days: 3 },
{ pincode: 224135, min_days: 2, max_days: 3 },
{ pincode: 224137, min_days: 2, max_days: 3 },
{ pincode: 224138, min_days: 2, max_days: 3 },
{ pincode: 224139, min_days: 2, max_days: 3 },
{ pincode: 224141, min_days: 2, max_days: 3 },
{ pincode: 224143, min_days: 2, max_days: 3 },
{ pincode: 224145, min_days: 2, max_days: 3 },
{ pincode: 224146, min_days: 2, max_days: 3 },
{ pincode: 224147, min_days: 2, max_days: 3 },
{ pincode: 224149, min_days: 2, max_days: 3 },
{ pincode: 224151, min_days: 2, max_days: 3 },
{ pincode: 224152, min_days: 2, max_days: 3 },
{ pincode: 224153, min_days: 2, max_days: 3 },
{ pincode: 224155, min_days: 2, max_days: 3 },
{ pincode: 224157, min_days: 2, max_days: 3 },
{ pincode: 224158, min_days: 2, max_days: 3 },
{ pincode: 224159, min_days: 2, max_days: 3 },
{ pincode: 224161, min_days: 2, max_days: 3 },
{ pincode: 224164, min_days: 2, max_days: 3 },
{ pincode: 224166, min_days: 2, max_days: 3 },
{ pincode: 224168, min_days: 2, max_days: 3 },
{ pincode: 224171, min_days: 2, max_days: 3 },
{ pincode: 224172, min_days: 2, max_days: 3 },
{ pincode: 224176, min_days: 2, max_days: 3 },
{ pincode: 224181, min_days: 2, max_days: 3 },
{ pincode: 224182, min_days: 2, max_days: 3 },
{ pincode: 224183, min_days: 2, max_days: 3 },
{ pincode: 224184, min_days: 2, max_days: 3 },
{ pincode: 224186, min_days: 2, max_days: 3 },
{ pincode: 224188, min_days: 2, max_days: 3 },
{ pincode: 224189, min_days: 2, max_days: 3 },
{ pincode: 224190, min_days: 2, max_days: 3 },
{ pincode: 224195, min_days: 2, max_days: 3 },
{ pincode: 224201, min_days: 2, max_days: 3 },
{ pincode: 224202, min_days: 2, max_days: 3 },
{ pincode: 224203, min_days: 2, max_days: 3 },
{ pincode: 224204, min_days: 2, max_days: 3 },
{ pincode: 224205, min_days: 2, max_days: 3 },
{ pincode: 224206, min_days: 2, max_days: 3 },
{ pincode: 224207, min_days: 2, max_days: 3 },
{ pincode: 224208, min_days: 2, max_days: 3 },
{ pincode: 224209, min_days: 2, max_days: 3 },
{ pincode: 224210, min_days: 2, max_days: 3 },
{ pincode: 224211, min_days: 2, max_days: 3 },
{ pincode: 224212, min_days: 2, max_days: 3 },
{ pincode: 224216, min_days: 2, max_days: 3 },
{ pincode: 224220, min_days: 2, max_days: 3 },
{ pincode: 224221, min_days: 2, max_days: 3 },
{ pincode: 224223, min_days: 2, max_days: 3 },
{ pincode: 224225, min_days: 2, max_days: 3 },
{ pincode: 224226, min_days: 2, max_days: 3 },
{ pincode: 224227, min_days: 2, max_days: 3 },
{ pincode: 224228, min_days: 2, max_days: 3 },
{ pincode: 224229, min_days: 2, max_days: 3 },
{ pincode: 224230, min_days: 2, max_days: 3 },
{ pincode: 224231, min_days: 2, max_days: 3 },
{ pincode: 224232, min_days: 2, max_days: 3 },
{ pincode: 224234, min_days: 2, max_days: 3 },
{ pincode: 224235, min_days: 2, max_days: 3 },
{ pincode: 224238, min_days: 2, max_days: 3 },
{ pincode: 224284, min_days: 2, max_days: 3 },
{ pincode: 224401, min_days: 2, max_days: 3 },
{ pincode: 225001, min_days: 2, max_days: 3 },
{ pincode: 225002, min_days: 2, max_days: 3 },
{ pincode: 225003, min_days: 2, max_days: 3 },
{ pincode: 225119, min_days: 2, max_days: 3 },
{ pincode: 225120, min_days: 2, max_days: 3 },
{ pincode: 225121, min_days: 2, max_days: 3 },
{ pincode: 225122, min_days: 2, max_days: 3 },
{ pincode: 225123, min_days: 2, max_days: 3 },
{ pincode: 225124, min_days: 2, max_days: 3 },
{ pincode: 225125, min_days: 2, max_days: 3 },
{ pincode: 225126, min_days: 2, max_days: 3 },
{ pincode: 225131, min_days: 2, max_days: 3 },
{ pincode: 225201, min_days: 2, max_days: 3 },
{ pincode: 225202, min_days: 2, max_days: 3 },
{ pincode: 225203, min_days: 2, max_days: 3 },
{ pincode: 225204, min_days: 2, max_days: 3 },
{ pincode: 225205, min_days: 2, max_days: 3 },
{ pincode: 225206, min_days: 2, max_days: 3 },
{ pincode: 225207, min_days: 2, max_days: 3 },
{ pincode: 225208, min_days: 2, max_days: 3 },
{ pincode: 225301, min_days: 2, max_days: 3 },
{ pincode: 225302, min_days: 2, max_days: 3 },
{ pincode: 225303, min_days: 2, max_days: 3 },
{ pincode: 225304, min_days: 2, max_days: 3 },
{ pincode: 225305, min_days: 2, max_days: 3 },
{ pincode: 225306, min_days: 2, max_days: 3 },
{ pincode: 225401, min_days: 2, max_days: 3 },
{ pincode: 225402, min_days: 2, max_days: 3 },
{ pincode: 225403, min_days: 2, max_days: 3 },
{ pincode: 225404, min_days: 2, max_days: 3 },
{ pincode: 225405, min_days: 2, max_days: 3 },
{ pincode: 225406, min_days: 2, max_days: 3 },
{ pincode: 225407, min_days: 2, max_days: 3 },
{ pincode: 225408, min_days: 2, max_days: 3 },
{ pincode: 225409, min_days: 2, max_days: 3 },
{ pincode: 225411, min_days: 2, max_days: 3 },
{ pincode: 225412, min_days: 2, max_days: 3 },
{ pincode: 225413, min_days: 2, max_days: 3 },
{ pincode: 225414, min_days: 2, max_days: 3 },
{ pincode: 225415, min_days: 2, max_days: 3 },
{ pincode: 225416, min_days: 2, max_days: 3 },
{ pincode: 226000, min_days: 2, max_days: 3 },
{ pincode: 226001, min_days: 2, max_days: 3 },
{ pincode: 226002, min_days: 2, max_days: 3 },
{ pincode: 226003, min_days: 2, max_days: 3 },
{ pincode: 226004, min_days: 2, max_days: 3 },
{ pincode: 226005, min_days: 2, max_days: 3 },
{ pincode: 226006, min_days: 2, max_days: 3 },
{ pincode: 226007, min_days: 2, max_days: 3 },
{ pincode: 226008, min_days: 2, max_days: 3 },
{ pincode: 226009, min_days: 2, max_days: 3 },
{ pincode: 226010, min_days: 2, max_days: 3 },
{ pincode: 226011, min_days: 2, max_days: 3 },
{ pincode: 226012, min_days: 2, max_days: 3 },
{ pincode: 226013, min_days: 2, max_days: 3 },
{ pincode: 226014, min_days: 2, max_days: 3 },
{ pincode: 226015, min_days: 2, max_days: 3 },
{ pincode: 226016, min_days: 2, max_days: 3 },
{ pincode: 226017, min_days: 2, max_days: 3 },
{ pincode: 226018, min_days: 2, max_days: 3 },
{ pincode: 226019, min_days: 2, max_days: 3 },
{ pincode: 226020, min_days: 2, max_days: 3 },
{ pincode: 226021, min_days: 2, max_days: 3 },
{ pincode: 226022, min_days: 2, max_days: 3 },
{ pincode: 226023, min_days: 2, max_days: 3 },
{ pincode: 226024, min_days: 2, max_days: 3 },
{ pincode: 226025, min_days: 2, max_days: 3 },
{ pincode: 226026, min_days: 2, max_days: 3 },
{ pincode: 226027, min_days: 2, max_days: 3 },
{ pincode: 226028, min_days: 2, max_days: 3 },
{ pincode: 226029, min_days: 2, max_days: 3 },
{ pincode: 226030, min_days: 2, max_days: 3 },
{ pincode: 226031, min_days: 2, max_days: 3 },
{ pincode: 226101, min_days: 2, max_days: 3 },
{ pincode: 226102, min_days: 2, max_days: 3 },
{ pincode: 226103, min_days: 2, max_days: 3 },
{ pincode: 226104, min_days: 2, max_days: 3 },
{ pincode: 226106, min_days: 2, max_days: 3 },
{ pincode: 226201, min_days: 2, max_days: 3 },
{ pincode: 226202, min_days: 2, max_days: 3 },
{ pincode: 226203, min_days: 2, max_days: 3 },
{ pincode: 226301, min_days: 2, max_days: 3 },
{ pincode: 226302, min_days: 2, max_days: 3 },
{ pincode: 226303, min_days: 2, max_days: 3 },
{ pincode: 226305, min_days: 2, max_days: 3 },
{ pincode: 226401, min_days: 2, max_days: 3 },
{ pincode: 226501, min_days: 2, max_days: 3 },
{ pincode: 227005, min_days: 2, max_days: 3 },
{ pincode: 227015, min_days: 2, max_days: 3 },
{ pincode: 227101, min_days: 2, max_days: 3 },
{ pincode: 227105, min_days: 2, max_days: 3 },
{ pincode: 227106, min_days: 2, max_days: 3 },
{ pincode: 227107, min_days: 2, max_days: 3 },
{ pincode: 227111, min_days: 2, max_days: 3 },
{ pincode: 227115, min_days: 2, max_days: 3 },
{ pincode: 227116, min_days: 2, max_days: 3 },
{ pincode: 227120, min_days: 2, max_days: 3 },
{ pincode: 227125, min_days: 2, max_days: 3 },
{ pincode: 227131, min_days: 2, max_days: 3 },
{ pincode: 227132, min_days: 2, max_days: 3 },
{ pincode: 227202, min_days: 2, max_days: 3 },
{ pincode: 227205, min_days: 2, max_days: 3 },
{ pincode: 227207, min_days: 2, max_days: 3 },
{ pincode: 227208, min_days: 2, max_days: 3 },
{ pincode: 227301, min_days: 2, max_days: 3 },
{ pincode: 227302, min_days: 2, max_days: 3 },
{ pincode: 227304, min_days: 2, max_days: 3 },
{ pincode: 227305, min_days: 2, max_days: 3 },
{ pincode: 227308, min_days: 2, max_days: 3 },
{ pincode: 227309, min_days: 2, max_days: 3 },
{ pincode: 227405, min_days: 2, max_days: 3 },
{ pincode: 227406, min_days: 2, max_days: 3 },
{ pincode: 227407, min_days: 2, max_days: 3 },
{ pincode: 227408, min_days: 2, max_days: 3 },
{ pincode: 227409, min_days: 2, max_days: 3 },
{ pincode: 227411, min_days: 2, max_days: 3 },
{ pincode: 227412, min_days: 2, max_days: 3 },
{ pincode: 227413, min_days: 2, max_days: 3 },
{ pincode: 227801, min_days: 2, max_days: 3 },
{ pincode: 227802, min_days: 2, max_days: 3 },
{ pincode: 227805, min_days: 2, max_days: 3 },
{ pincode: 227806, min_days: 2, max_days: 3 },
{ pincode: 227807, min_days: 2, max_days: 3 },
{ pincode: 227808, min_days: 2, max_days: 3 },
{ pincode: 227809, min_days: 2, max_days: 3 },
{ pincode: 227811, min_days: 2, max_days: 3 },
{ pincode: 227812, min_days: 2, max_days: 3 },
{ pincode: 227813, min_days: 2, max_days: 3 },
{ pincode: 227814, min_days: 2, max_days: 3 },
{ pincode: 227815, min_days: 2, max_days: 3 },
{ pincode: 227816, min_days: 2, max_days: 3 },
{ pincode: 227817, min_days: 2, max_days: 3 },
{ pincode: 228001, min_days: 2, max_days: 3 },
{ pincode: 228101, min_days: 2, max_days: 3 },
{ pincode: 228115, min_days: 2, max_days: 3 },
{ pincode: 228118, min_days: 2, max_days: 3 },
{ pincode: 228119, min_days: 2, max_days: 3 },
{ pincode: 228120, min_days: 2, max_days: 3 },
{ pincode: 228121, min_days: 2, max_days: 3 },
{ pincode: 228125, min_days: 2, max_days: 3 },
{ pincode: 228131, min_days: 2, max_days: 3 },
{ pincode: 228132, min_days: 2, max_days: 3 },
{ pincode: 228133, min_days: 2, max_days: 3 },
{ pincode: 228141, min_days: 2, max_days: 3 },
{ pincode: 228142, min_days: 2, max_days: 3 },
{ pincode: 228145, min_days: 2, max_days: 3 },
{ pincode: 228151, min_days: 2, max_days: 3 },
{ pincode: 228155, min_days: 2, max_days: 3 },
{ pincode: 228159, min_days: 2, max_days: 3 },
{ pincode: 228161, min_days: 2, max_days: 3 },
{ pincode: 228171, min_days: 2, max_days: 3 },
{ pincode: 228411, min_days: 2, max_days: 3 },
{ pincode: 229001, min_days: 2, max_days: 3 },
{ pincode: 229002, min_days: 2, max_days: 3 },
{ pincode: 229003, min_days: 2, max_days: 3 },
{ pincode: 229010, min_days: 2, max_days: 3 },
{ pincode: 229103, min_days: 2, max_days: 3 },
{ pincode: 229120, min_days: 2, max_days: 3 },
{ pincode: 229121, min_days: 2, max_days: 3 },
{ pincode: 229122, min_days: 2, max_days: 3 },
{ pincode: 229123, min_days: 2, max_days: 3 },
{ pincode: 229124, min_days: 2, max_days: 3 },
{ pincode: 229125, min_days: 2, max_days: 3 },
{ pincode: 229126, min_days: 2, max_days: 3 },
{ pincode: 229127, min_days: 2, max_days: 3 },
{ pincode: 229128, min_days: 2, max_days: 3 },
{ pincode: 229129, min_days: 2, max_days: 3 },
{ pincode: 229130, min_days: 2, max_days: 3 },
{ pincode: 229135, min_days: 2, max_days: 3 },
{ pincode: 229201, min_days: 2, max_days: 3 },
{ pincode: 229202, min_days: 2, max_days: 3 },
{ pincode: 229203, min_days: 2, max_days: 3 },
{ pincode: 229204, min_days: 2, max_days: 3 },
{ pincode: 229205, min_days: 2, max_days: 3 },
{ pincode: 229206, min_days: 2, max_days: 3 },
{ pincode: 229207, min_days: 2, max_days: 3 },
{ pincode: 229208, min_days: 2, max_days: 3 },
{ pincode: 229209, min_days: 2, max_days: 3 },
{ pincode: 229210, min_days: 2, max_days: 3 },
{ pincode: 229211, min_days: 2, max_days: 3 },
{ pincode: 229212, min_days: 2, max_days: 3 },
{ pincode: 229215, min_days: 2, max_days: 3 },
{ pincode: 229216, min_days: 2, max_days: 3 },
{ pincode: 229301, min_days: 2, max_days: 3 },
{ pincode: 229302, min_days: 2, max_days: 3 },
{ pincode: 229303, min_days: 2, max_days: 3 },
{ pincode: 229304, min_days: 2, max_days: 3 },
{ pincode: 229305, min_days: 2, max_days: 3 },
{ pincode: 229306, min_days: 2, max_days: 3 },
{ pincode: 229307, min_days: 2, max_days: 3 },
{ pincode: 229308, min_days: 2, max_days: 3 },
{ pincode: 229309, min_days: 2, max_days: 3 },
{ pincode: 229310, min_days: 2, max_days: 3 },
{ pincode: 229311, min_days: 2, max_days: 3 },
{ pincode: 229315, min_days: 2, max_days: 3 },
{ pincode: 229316, min_days: 2, max_days: 3 },
{ pincode: 229401, min_days: 2, max_days: 3 },
{ pincode: 229402, min_days: 2, max_days: 3 },
{ pincode: 229403, min_days: 2, max_days: 3 },
{ pincode: 229404, min_days: 2, max_days: 3 },
{ pincode: 229405, min_days: 2, max_days: 3 },
{ pincode: 229406, min_days: 2, max_days: 3 },
{ pincode: 229408, min_days: 2, max_days: 3 },
{ pincode: 229410, min_days: 2, max_days: 3 },
{ pincode: 229411, min_days: 2, max_days: 3 },
{ pincode: 229412, min_days: 2, max_days: 3 },
{ pincode: 229413, min_days: 2, max_days: 3 },
{ pincode: 229415, min_days: 2, max_days: 3 },
{ pincode: 229416, min_days: 2, max_days: 3 },
{ pincode: 229417, min_days: 2, max_days: 3 },
{ pincode: 229418, min_days: 2, max_days: 3 },
{ pincode: 229419, min_days: 2, max_days: 3 },
{ pincode: 229502, min_days: 2, max_days: 3 },
{ pincode: 229503, min_days: 2, max_days: 3 },
{ pincode: 229504, min_days: 2, max_days: 3 },
{ pincode: 229801, min_days: 2, max_days: 3 },
{ pincode: 229802, min_days: 2, max_days: 3 },
{ pincode: 229841, min_days: 2, max_days: 3 },
{ pincode: 229881, min_days: 2, max_days: 3 },
{ pincode: 230001, min_days: 2, max_days: 3 },
{ pincode: 230002, min_days: 2, max_days: 3 },
{ pincode: 230121, min_days: 2, max_days: 3 },
{ pincode: 230122, min_days: 2, max_days: 3 },
{ pincode: 230123, min_days: 2, max_days: 3 },
{ pincode: 230124, min_days: 2, max_days: 3 },
{ pincode: 230125, min_days: 2, max_days: 3 },
{ pincode: 230126, min_days: 2, max_days: 3 },
{ pincode: 230127, min_days: 2, max_days: 3 },
{ pincode: 230128, min_days: 2, max_days: 3 },
{ pincode: 230129, min_days: 2, max_days: 3 },
{ pincode: 230130, min_days: 2, max_days: 3 },
{ pincode: 230131, min_days: 2, max_days: 3 },
{ pincode: 230132, min_days: 2, max_days: 3 },
{ pincode: 230133, min_days: 2, max_days: 3 },
{ pincode: 230134, min_days: 2, max_days: 3 },
{ pincode: 230135, min_days: 2, max_days: 3 },
{ pincode: 230136, min_days: 2, max_days: 3 },
{ pincode: 230137, min_days: 2, max_days: 3 },
{ pincode: 230138, min_days: 2, max_days: 3 },
{ pincode: 230139, min_days: 2, max_days: 3 },
{ pincode: 230140, min_days: 2, max_days: 3 },
{ pincode: 230141, min_days: 2, max_days: 3 },
{ pincode: 230142, min_days: 2, max_days: 3 },
{ pincode: 230143, min_days: 2, max_days: 3 },
{ pincode: 230144, min_days: 2, max_days: 3 },
{ pincode: 230145, min_days: 2, max_days: 3 },
{ pincode: 230146, min_days: 2, max_days: 3 },
{ pincode: 230201, min_days: 2, max_days: 3 },
{ pincode: 230202, min_days: 2, max_days: 3 },
{ pincode: 230204, min_days: 2, max_days: 3 },
{ pincode: 230301, min_days: 2, max_days: 3 },
{ pincode: 230302, min_days: 2, max_days: 3 },
{ pincode: 230304, min_days: 2, max_days: 3 },
{ pincode: 230305, min_days: 2, max_days: 3 },
{ pincode: 230306, min_days: 2, max_days: 3 },
{ pincode: 230401, min_days: 2, max_days: 3 },
{ pincode: 230402, min_days: 2, max_days: 3 },
{ pincode: 230403, min_days: 2, max_days: 3 },
{ pincode: 230404, min_days: 2, max_days: 3 },
{ pincode: 230405, min_days: 2, max_days: 3 },
{ pincode: 230406, min_days: 2, max_days: 3 },
{ pincode: 230501, min_days: 2, max_days: 3 },
{ pincode: 230502, min_days: 2, max_days: 3 },
{ pincode: 230503, min_days: 2, max_days: 3 },
{ pincode: 231001, min_days: 2, max_days: 3 },
{ pincode: 231205, min_days: 2, max_days: 3 },
{ pincode: 231206, min_days: 2, max_days: 3 },
{ pincode: 231207, min_days: 2, max_days: 3 },
{ pincode: 231208, min_days: 2, max_days: 3 },
{ pincode: 231209, min_days: 2, max_days: 3 },
{ pincode: 231210, min_days: 2, max_days: 3 },
{ pincode: 231211, min_days: 2, max_days: 3 },
{ pincode: 231212, min_days: 2, max_days: 3 },
{ pincode: 231213, min_days: 2, max_days: 3 },
{ pincode: 231214, min_days: 2, max_days: 3 },
{ pincode: 231215, min_days: 2, max_days: 3 },
{ pincode: 231216, min_days: 2, max_days: 3 },
{ pincode: 231217, min_days: 2, max_days: 3 },
{ pincode: 231218, min_days: 2, max_days: 3 },
{ pincode: 231219, min_days: 2, max_days: 3 },
{ pincode: 231220, min_days: 2, max_days: 3 },
{ pincode: 231221, min_days: 2, max_days: 3 },
{ pincode: 231222, min_days: 2, max_days: 3 },
{ pincode: 231223, min_days: 2, max_days: 3 },
{ pincode: 231224, min_days: 2, max_days: 3 },
{ pincode: 231225, min_days: 2, max_days: 3 },
{ pincode: 231226, min_days: 2, max_days: 3 },
{ pincode: 231301, min_days: 2, max_days: 3 },
{ pincode: 231302, min_days: 2, max_days: 3 },
{ pincode: 231303, min_days: 2, max_days: 3 },
{ pincode: 231304, min_days: 2, max_days: 3 },
{ pincode: 231305, min_days: 2, max_days: 3 },
{ pincode: 231306, min_days: 2, max_days: 3 },
{ pincode: 231307, min_days: 2, max_days: 3 },
{ pincode: 231309, min_days: 2, max_days: 3 },
{ pincode: 231310, min_days: 2, max_days: 3 },
{ pincode: 231311, min_days: 2, max_days: 3 },
{ pincode: 231312, min_days: 2, max_days: 3 },
{ pincode: 231313, min_days: 2, max_days: 3 },
{ pincode: 231314, min_days: 2, max_days: 3 },
{ pincode: 231501, min_days: 2, max_days: 3 },
{ pincode: 232101, min_days: 2, max_days: 3 },
{ pincode: 232102, min_days: 2, max_days: 3 },
{ pincode: 232103, min_days: 2, max_days: 3 },
{ pincode: 232104, min_days: 2, max_days: 3 },
{ pincode: 232105, min_days: 2, max_days: 3 },
{ pincode: 232106, min_days: 2, max_days: 3 },
{ pincode: 232107, min_days: 2, max_days: 3 },
{ pincode: 232108, min_days: 2, max_days: 3 },
{ pincode: 232109, min_days: 2, max_days: 3 },
{ pincode: 232110, min_days: 2, max_days: 3 },
{ pincode: 232111, min_days: 2, max_days: 3 },
{ pincode: 232112, min_days: 2, max_days: 3 },
{ pincode: 232114, min_days: 2, max_days: 3 },
{ pincode: 232115, min_days: 2, max_days: 3 },
{ pincode: 232116, min_days: 2, max_days: 3 },
{ pincode: 232118, min_days: 2, max_days: 3 },
{ pincode: 232119, min_days: 2, max_days: 3 },
{ pincode: 232120, min_days: 2, max_days: 3 },
{ pincode: 232221, min_days: 2, max_days: 3 },
{ pincode: 232325, min_days: 2, max_days: 3 },
{ pincode: 232326, min_days: 2, max_days: 3 },
{ pincode: 232327, min_days: 2, max_days: 3 },
{ pincode: 232328, min_days: 2, max_days: 3 },
{ pincode: 232329, min_days: 2, max_days: 3 },
{ pincode: 232330, min_days: 2, max_days: 3 },
{ pincode: 232331, min_days: 2, max_days: 3 },
{ pincode: 232332, min_days: 2, max_days: 3 },
{ pincode: 232333, min_days: 2, max_days: 3 },
{ pincode: 232336, min_days: 2, max_days: 3 },
{ pincode: 232339, min_days: 2, max_days: 3 },
{ pincode: 232340, min_days: 2, max_days: 3 },
{ pincode: 232341, min_days: 2, max_days: 3 },
{ pincode: 233001, min_days: 2, max_days: 3 },
{ pincode: 233002, min_days: 2, max_days: 3 },
{ pincode: 233221, min_days: 2, max_days: 3 },
{ pincode: 233222, min_days: 2, max_days: 3 },
{ pincode: 233223, min_days: 2, max_days: 3 },
{ pincode: 233224, min_days: 2, max_days: 3 },
{ pincode: 233225, min_days: 2, max_days: 3 },
{ pincode: 233226, min_days: 2, max_days: 3 },
{ pincode: 233227, min_days: 2, max_days: 3 },
{ pincode: 233228, min_days: 2, max_days: 3 },
{ pincode: 233229, min_days: 2, max_days: 3 },
{ pincode: 233230, min_days: 2, max_days: 3 },
{ pincode: 233231, min_days: 2, max_days: 3 },
{ pincode: 233232, min_days: 2, max_days: 3 },
{ pincode: 233233, min_days: 2, max_days: 3 },
{ pincode: 233234, min_days: 2, max_days: 3 },
{ pincode: 233235, min_days: 2, max_days: 3 },
{ pincode: 233300, min_days: 2, max_days: 3 },
{ pincode: 233301, min_days: 2, max_days: 3 },
{ pincode: 233302, min_days: 2, max_days: 3 },
{ pincode: 233303, min_days: 2, max_days: 3 },
{ pincode: 233304, min_days: 2, max_days: 3 },
{ pincode: 233305, min_days: 2, max_days: 3 },
{ pincode: 233306, min_days: 2, max_days: 3 },
{ pincode: 233307, min_days: 2, max_days: 3 },
{ pincode: 233308, min_days: 2, max_days: 3 },
{ pincode: 233310, min_days: 2, max_days: 3 },
{ pincode: 233311, min_days: 2, max_days: 3 },
{ pincode: 241001, min_days: 2, max_days: 3 },
{ pincode: 241121, min_days: 2, max_days: 3 },
{ pincode: 241122, min_days: 2, max_days: 3 },
{ pincode: 241123, min_days: 2, max_days: 3 },
{ pincode: 241124, min_days: 2, max_days: 3 },
{ pincode: 241125, min_days: 2, max_days: 3 },
{ pincode: 241126, min_days: 2, max_days: 3 },
{ pincode: 241127, min_days: 2, max_days: 3 },
{ pincode: 241201, min_days: 2, max_days: 3 },
{ pincode: 241202, min_days: 2, max_days: 3 },
{ pincode: 241203, min_days: 2, max_days: 3 },
{ pincode: 241204, min_days: 2, max_days: 3 },
{ pincode: 241301, min_days: 2, max_days: 3 },
{ pincode: 241302, min_days: 2, max_days: 3 },
{ pincode: 241303, min_days: 2, max_days: 3 },
{ pincode: 241304, min_days: 2, max_days: 3 },
{ pincode: 241305, min_days: 2, max_days: 3 },
{ pincode: 241401, min_days: 2, max_days: 3 },
{ pincode: 241402, min_days: 2, max_days: 3 },
{ pincode: 241403, min_days: 2, max_days: 3 },
{ pincode: 241404, min_days: 2, max_days: 3 },
{ pincode: 241405, min_days: 2, max_days: 3 },
{ pincode: 241406, min_days: 2, max_days: 3 },
{ pincode: 241407, min_days: 2, max_days: 3 },
{ pincode: 241501, min_days: 2, max_days: 3 },
{ pincode: 241502, min_days: 2, max_days: 3 },
{ pincode: 241503, min_days: 2, max_days: 3 },
{ pincode: 241504, min_days: 2, max_days: 3 },
{ pincode: 242001, min_days: 2, max_days: 3 },
{ pincode: 242005, min_days: 2, max_days: 3 },
{ pincode: 242021, min_days: 2, max_days: 3 },
{ pincode: 242042, min_days: 2, max_days: 3 },
{ pincode: 242123, min_days: 2, max_days: 3 },
{ pincode: 242127, min_days: 2, max_days: 3 },
{ pincode: 242220, min_days: 2, max_days: 3 },
{ pincode: 242221, min_days: 2, max_days: 3 },
{ pincode: 242222, min_days: 2, max_days: 3 },
{ pincode: 242223, min_days: 2, max_days: 3 },
{ pincode: 242225, min_days: 2, max_days: 3 },
{ pincode: 242226, min_days: 2, max_days: 3 },
{ pincode: 242227, min_days: 2, max_days: 3 },
{ pincode: 242301, min_days: 2, max_days: 3 },
{ pincode: 242303, min_days: 2, max_days: 3 },
{ pincode: 242305, min_days: 2, max_days: 3 },
{ pincode: 242306, min_days: 2, max_days: 3 },
{ pincode: 242307, min_days: 2, max_days: 3 },
{ pincode: 242308, min_days: 2, max_days: 3 },
{ pincode: 242401, min_days: 2, max_days: 3 },
{ pincode: 242402, min_days: 2, max_days: 3 },
{ pincode: 242404, min_days: 2, max_days: 3 },
{ pincode: 242405, min_days: 2, max_days: 3 },
{ pincode: 242406, min_days: 2, max_days: 3 },
{ pincode: 242407, min_days: 2, max_days: 3 },
{ pincode: 243001, min_days: 2, max_days: 3 },
{ pincode: 243002, min_days: 2, max_days: 3 },
{ pincode: 243003, min_days: 2, max_days: 3 },
{ pincode: 243004, min_days: 2, max_days: 3 },
{ pincode: 243005, min_days: 2, max_days: 3 },
{ pincode: 243006, min_days: 2, max_days: 3 },
{ pincode: 243121, min_days: 2, max_days: 3 },
{ pincode: 243122, min_days: 2, max_days: 3 },
{ pincode: 243123, min_days: 2, max_days: 3 },
{ pincode: 243124, min_days: 2, max_days: 3 },
{ pincode: 243125, min_days: 2, max_days: 3 },
{ pincode: 243126, min_days: 2, max_days: 3 },
{ pincode: 243127, min_days: 2, max_days: 3 },
{ pincode: 243201, min_days: 2, max_days: 3 },
{ pincode: 243202, min_days: 2, max_days: 3 },
{ pincode: 243203, min_days: 2, max_days: 3 },
{ pincode: 243204, min_days: 2, max_days: 3 },
{ pincode: 243205, min_days: 2, max_days: 3 },
{ pincode: 243208, min_days: 2, max_days: 3 },
{ pincode: 243215, min_days: 2, max_days: 3 },
{ pincode: 243301, min_days: 2, max_days: 3 },
{ pincode: 243302, min_days: 2, max_days: 3 },
{ pincode: 243303, min_days: 2, max_days: 3 },
{ pincode: 243304, min_days: 2, max_days: 3 },
{ pincode: 243401, min_days: 2, max_days: 3 },
{ pincode: 243402, min_days: 2, max_days: 3 },
{ pincode: 243403, min_days: 2, max_days: 3 },
{ pincode: 243406, min_days: 2, max_days: 3 },
{ pincode: 243407, min_days: 2, max_days: 3 },
{ pincode: 243408, min_days: 2, max_days: 3 },
{ pincode: 243501, min_days: 2, max_days: 3 },
{ pincode: 243502, min_days: 2, max_days: 3 },
{ pincode: 243503, min_days: 2, max_days: 3 },
{ pincode: 243504, min_days: 2, max_days: 3 },
{ pincode: 243505, min_days: 2, max_days: 3 },
{ pincode: 243506, min_days: 2, max_days: 3 },
{ pincode: 243509, min_days: 2, max_days: 3 },
{ pincode: 243601, min_days: 2, max_days: 3 },
{ pincode: 243630, min_days: 2, max_days: 3 },
{ pincode: 243631, min_days: 2, max_days: 3 },
{ pincode: 243632, min_days: 2, max_days: 3 },
{ pincode: 243633, min_days: 2, max_days: 3 },
{ pincode: 243634, min_days: 2, max_days: 3 },
{ pincode: 243635, min_days: 2, max_days: 3 },
{ pincode: 243636, min_days: 2, max_days: 3 },
{ pincode: 243637, min_days: 2, max_days: 3 },
{ pincode: 243638, min_days: 2, max_days: 3 },
{ pincode: 243639, min_days: 2, max_days: 3 },
{ pincode: 243640, min_days: 2, max_days: 3 },
{ pincode: 243641, min_days: 2, max_days: 3 },
{ pincode: 243643, min_days: 2, max_days: 3 },
{ pincode: 243701, min_days: 2, max_days: 3 },
{ pincode: 243702, min_days: 2, max_days: 3 },
{ pincode: 243720, min_days: 2, max_days: 3 },
{ pincode: 243722, min_days: 2, max_days: 3 },
{ pincode: 243723, min_days: 2, max_days: 3 },
{ pincode: 243724, min_days: 2, max_days: 3 },
{ pincode: 243725, min_days: 2, max_days: 3 },
{ pincode: 243726, min_days: 2, max_days: 3 },
{ pincode: 243727, min_days: 2, max_days: 3 },
{ pincode: 243751, min_days: 2, max_days: 3 },
{ pincode: 244001, min_days: 2, max_days: 3 },
{ pincode: 244002, min_days: 2, max_days: 3 },
{ pincode: 244003, min_days: 2, max_days: 3 },
{ pincode: 244004, min_days: 2, max_days: 3 },
{ pincode: 244102, min_days: 2, max_days: 3 },
{ pincode: 244103, min_days: 2, max_days: 3 },
{ pincode: 244104, min_days: 2, max_days: 3 },
{ pincode: 244105, min_days: 2, max_days: 3 },
{ pincode: 244221, min_days: 2, max_days: 3 },
{ pincode: 244222, min_days: 2, max_days: 3 },
{ pincode: 244223, min_days: 2, max_days: 3 },
{ pincode: 244224, min_days: 2, max_days: 3 },
{ pincode: 244225, min_days: 2, max_days: 3 },
{ pincode: 244226, min_days: 2, max_days: 3 },
{ pincode: 244227, min_days: 2, max_days: 3 },
{ pincode: 244231, min_days: 2, max_days: 3 },
{ pincode: 244235, min_days: 2, max_days: 3 },
{ pincode: 244236, min_days: 2, max_days: 3 },
{ pincode: 244241, min_days: 2, max_days: 3 },
{ pincode: 244242, min_days: 2, max_days: 3 },
{ pincode: 244245, min_days: 2, max_days: 3 },
{ pincode: 244251, min_days: 2, max_days: 3 },
{ pincode: 244255, min_days: 2, max_days: 3 },
{ pincode: 244301, min_days: 2, max_days: 3 },
{ pincode: 244302, min_days: 2, max_days: 3 },
{ pincode: 244303, min_days: 2, max_days: 3 },
{ pincode: 244304, min_days: 2, max_days: 3 },
{ pincode: 244401, min_days: 2, max_days: 3 },
{ pincode: 244402, min_days: 2, max_days: 3 },
{ pincode: 244410, min_days: 2, max_days: 3 },
{ pincode: 244411, min_days: 2, max_days: 3 },
{ pincode: 244412, min_days: 2, max_days: 3 },
{ pincode: 244413, min_days: 2, max_days: 3 },
{ pincode: 244414, min_days: 2, max_days: 3 },
{ pincode: 244415, min_days: 2, max_days: 3 },
{ pincode: 244500, min_days: 2, max_days: 3 },
{ pincode: 244501, min_days: 2, max_days: 3 },
{ pincode: 244502, min_days: 2, max_days: 3 },
{ pincode: 244504, min_days: 2, max_days: 3 },
{ pincode: 244601, min_days: 2, max_days: 3 },
{ pincode: 244602, min_days: 2, max_days: 3 },
{ pincode: 244701, min_days: 2, max_days: 3 },
{ pincode: 244711, min_days: 2, max_days: 3 },
{ pincode: 244712, min_days: 2, max_days: 3 },
{ pincode: 244713, min_days: 2, max_days: 3 },
{ pincode: 244714, min_days: 2, max_days: 3 },
{ pincode: 244715, min_days: 2, max_days: 3 },
{ pincode: 244716, min_days: 2, max_days: 3 },
{ pincode: 244717, min_days: 2, max_days: 3 },
{ pincode: 244720, min_days: 2, max_days: 3 },
{ pincode: 244801, min_days: 2, max_days: 3 },
{ pincode: 244901, min_days: 2, max_days: 3 },
{ pincode: 244902, min_days: 2, max_days: 3 },
{ pincode: 244921, min_days: 2, max_days: 3 },
{ pincode: 244922, min_days: 2, max_days: 3 },
{ pincode: 244923, min_days: 2, max_days: 3 },
{ pincode: 244924, min_days: 2, max_days: 3 },
{ pincode: 244925, min_days: 2, max_days: 3 },
{ pincode: 244926, min_days: 2, max_days: 3 },
{ pincode: 244927, min_days: 2, max_days: 3 },
{ pincode: 244928, min_days: 2, max_days: 3 },
{ pincode: 245101, min_days: 2, max_days: 3 },
{ pincode: 245102, min_days: 2, max_days: 3 },
{ pincode: 245201, min_days: 2, max_days: 3 },
{ pincode: 245205, min_days: 2, max_days: 3 },
{ pincode: 245206, min_days: 2, max_days: 3 },
{ pincode: 245207, min_days: 2, max_days: 3 },
{ pincode: 245208, min_days: 2, max_days: 3 },
{ pincode: 245301, min_days: 2, max_days: 3 },
{ pincode: 245304, min_days: 2, max_days: 3 },
{ pincode: 245401, min_days: 2, max_days: 3 },
{ pincode: 245402, min_days: 2, max_days: 3 },
{ pincode: 245403, min_days: 2, max_days: 3 },
{ pincode: 245405, min_days: 2, max_days: 3 },
{ pincode: 245406, min_days: 2, max_days: 3 },
{ pincode: 245407, min_days: 2, max_days: 3 },
{ pincode: 245408, min_days: 2, max_days: 3 },
{ pincode: 245409, min_days: 2, max_days: 3 },
{ pincode: 245411, min_days: 2, max_days: 3 },
{ pincode: 245412, min_days: 2, max_days: 3 },
{ pincode: 246001, min_days: 2, max_days: 3 },
{ pincode: 246113, min_days: 2, max_days: 3 },
{ pincode: 246121, min_days: 2, max_days: 3 },
{ pincode: 246123, min_days: 2, max_days: 3 },
{ pincode: 246124, min_days: 2, max_days: 3 },
{ pincode: 246125, min_days: 2, max_days: 3 },
{ pincode: 246127, min_days: 2, max_days: 3 },
{ pincode: 246128, min_days: 2, max_days: 3 },
{ pincode: 246129, min_days: 2, max_days: 3 },
{ pincode: 246130, min_days: 2, max_days: 3 },
{ pincode: 246131, min_days: 2, max_days: 3 },
{ pincode: 246141, min_days: 2, max_days: 3 },
{ pincode: 246142, min_days: 2, max_days: 3 },
{ pincode: 246144, min_days: 2, max_days: 3 },
{ pincode: 246146, min_days: 2, max_days: 3 },
{ pincode: 246147, min_days: 2, max_days: 3 },
{ pincode: 246148, min_days: 2, max_days: 3 },
{ pincode: 246149, min_days: 2, max_days: 3 },
{ pincode: 246150, min_days: 2, max_days: 3 },
{ pincode: 246155, min_days: 2, max_days: 3 },
{ pincode: 246159, min_days: 2, max_days: 3 },
{ pincode: 246161, min_days: 2, max_days: 3 },
{ pincode: 246162, min_days: 2, max_days: 3 },
{ pincode: 246163, min_days: 2, max_days: 3 },
{ pincode: 246164, min_days: 2, max_days: 3 },
{ pincode: 246165, min_days: 2, max_days: 3 },
{ pincode: 246166, min_days: 2, max_days: 3 },
{ pincode: 246167, min_days: 2, max_days: 3 },
{ pincode: 246169, min_days: 2, max_days: 3 },
{ pincode: 246171, min_days: 2, max_days: 3 },
{ pincode: 246172, min_days: 2, max_days: 3 },
{ pincode: 246173, min_days: 2, max_days: 3 },
{ pincode: 246174, min_days: 2, max_days: 3 },
{ pincode: 246175, min_days: 2, max_days: 3 },
{ pincode: 246176, min_days: 2, max_days: 3 },
{ pincode: 246177, min_days: 2, max_days: 3 },
{ pincode: 246178, min_days: 2, max_days: 3 },
{ pincode: 246179, min_days: 2, max_days: 3 },
{ pincode: 246191, min_days: 2, max_days: 3 },
{ pincode: 246193, min_days: 2, max_days: 3 },
{ pincode: 246194, min_days: 2, max_days: 3 },
{ pincode: 246275, min_days: 2, max_days: 3 },
{ pincode: 246276, min_days: 2, max_days: 3 },
{ pincode: 246277, min_days: 2, max_days: 3 },
{ pincode: 246278, min_days: 2, max_days: 3 },
{ pincode: 246279, min_days: 2, max_days: 3 },
{ pincode: 246285, min_days: 2, max_days: 3 },
{ pincode: 246401, min_days: 2, max_days: 3 },
{ pincode: 246419, min_days: 2, max_days: 3 },
{ pincode: 246421, min_days: 2, max_days: 3 },
{ pincode: 246422, min_days: 2, max_days: 3 },
{ pincode: 246424, min_days: 2, max_days: 3 },
{ pincode: 246425, min_days: 2, max_days: 3 },
{ pincode: 246426, min_days: 2, max_days: 3 },
{ pincode: 246427, min_days: 2, max_days: 3 },
{ pincode: 246428, min_days: 2, max_days: 3 },
{ pincode: 246429, min_days: 2, max_days: 3 },
{ pincode: 246431, min_days: 2, max_days: 3 },
{ pincode: 246435, min_days: 2, max_days: 3 },
{ pincode: 246439, min_days: 2, max_days: 3 },
{ pincode: 246440, min_days: 2, max_days: 3 },
{ pincode: 246441, min_days: 2, max_days: 3 },
{ pincode: 246442, min_days: 2, max_days: 3 },
{ pincode: 246443, min_days: 2, max_days: 3 },
{ pincode: 246444, min_days: 2, max_days: 3 },
{ pincode: 246445, min_days: 2, max_days: 3 },
{ pincode: 246446, min_days: 2, max_days: 3 },
{ pincode: 246448, min_days: 2, max_days: 3 },
{ pincode: 246449, min_days: 2, max_days: 3 },
{ pincode: 246453, min_days: 2, max_days: 3 },
{ pincode: 246455, min_days: 2, max_days: 3 },
{ pincode: 246469, min_days: 2, max_days: 3 },
{ pincode: 246471, min_days: 2, max_days: 3 },
{ pincode: 246472, min_days: 2, max_days: 3 },
{ pincode: 246473, min_days: 2, max_days: 3 },
{ pincode: 246474, min_days: 2, max_days: 3 },
{ pincode: 246475, min_days: 2, max_days: 3 },
{ pincode: 246481, min_days: 2, max_days: 3 },
{ pincode: 246482, min_days: 2, max_days: 3 },
{ pincode: 246483, min_days: 2, max_days: 3 },
{ pincode: 246486, min_days: 2, max_days: 3 },
{ pincode: 246487, min_days: 2, max_days: 3 },
{ pincode: 246488, min_days: 2, max_days: 3 },
{ pincode: 246495, min_days: 2, max_days: 3 },
{ pincode: 246700, min_days: 2, max_days: 3 },
{ pincode: 246701, min_days: 2, max_days: 3 },
{ pincode: 246721, min_days: 2, max_days: 3 },
{ pincode: 246722, min_days: 2, max_days: 3 },
{ pincode: 246723, min_days: 2, max_days: 3 },
{ pincode: 246724, min_days: 2, max_days: 3 },
{ pincode: 246725, min_days: 2, max_days: 3 },
{ pincode: 246726, min_days: 2, max_days: 3 },
{ pincode: 246727, min_days: 2, max_days: 3 },
{ pincode: 246728, min_days: 2, max_days: 3 },
{ pincode: 246729, min_days: 2, max_days: 3 },
{ pincode: 246731, min_days: 2, max_days: 3 },
{ pincode: 246732, min_days: 2, max_days: 3 },
{ pincode: 246733, min_days: 2, max_days: 3 },
{ pincode: 246734, min_days: 2, max_days: 3 },
{ pincode: 246735, min_days: 2, max_days: 3 },
{ pincode: 246736, min_days: 2, max_days: 3 },
{ pincode: 246737, min_days: 2, max_days: 3 },
{ pincode: 246738, min_days: 2, max_days: 3 },
{ pincode: 246745, min_days: 2, max_days: 3 },
{ pincode: 246746, min_days: 2, max_days: 3 },
{ pincode: 246747, min_days: 2, max_days: 3 },
{ pincode: 246749, min_days: 2, max_days: 3 },
{ pincode: 246761, min_days: 2, max_days: 3 },
{ pincode: 246762, min_days: 2, max_days: 3 },
{ pincode: 246763, min_days: 2, max_days: 3 },
{ pincode: 246764, min_days: 2, max_days: 3 },
{ pincode: 246765, min_days: 2, max_days: 3 },
{ pincode: 246768, min_days: 2, max_days: 3 },
{ pincode: 247001, min_days: 2, max_days: 3 },
{ pincode: 247002, min_days: 2, max_days: 3 },
{ pincode: 247111, min_days: 2, max_days: 3 },
{ pincode: 247120, min_days: 2, max_days: 3 },
{ pincode: 247121, min_days: 2, max_days: 3 },
{ pincode: 247122, min_days: 2, max_days: 3 },
{ pincode: 247129, min_days: 2, max_days: 3 },
{ pincode: 247231, min_days: 2, max_days: 3 },
{ pincode: 247232, min_days: 2, max_days: 3 },
{ pincode: 247340, min_days: 2, max_days: 3 },
{ pincode: 247341, min_days: 2, max_days: 3 },
{ pincode: 247342, min_days: 2, max_days: 3 },
{ pincode: 247343, min_days: 2, max_days: 3 },
{ pincode: 247445, min_days: 2, max_days: 3 },
{ pincode: 247451, min_days: 2, max_days: 3 },
{ pincode: 247452, min_days: 2, max_days: 3 },
{ pincode: 247453, min_days: 2, max_days: 3 },
{ pincode: 247470, min_days: 2, max_days: 3 },
{ pincode: 247551, min_days: 2, max_days: 3 },
{ pincode: 247554, min_days: 2, max_days: 3 },
{ pincode: 247656, min_days: 2, max_days: 3 },
{ pincode: 247661, min_days: 2, max_days: 3 },
{ pincode: 247662, min_days: 2, max_days: 3 },
{ pincode: 247663, min_days: 2, max_days: 3 },
{ pincode: 247664, min_days: 2, max_days: 3 },
{ pincode: 247665, min_days: 2, max_days: 3 },
{ pincode: 247666, min_days: 2, max_days: 3 },
{ pincode: 247667, min_days: 2, max_days: 3 },
{ pincode: 247668, min_days: 2, max_days: 3 },
{ pincode: 247669, min_days: 2, max_days: 3 },
{ pincode: 247670, min_days: 2, max_days: 3 },
{ pincode: 247671, min_days: 2, max_days: 3 },
{ pincode: 247672, min_days: 2, max_days: 3 },
{ pincode: 247769, min_days: 2, max_days: 3 },
{ pincode: 247771, min_days: 2, max_days: 3 },
{ pincode: 247772, min_days: 2, max_days: 3 },
{ pincode: 247773, min_days: 2, max_days: 3 },
{ pincode: 247774, min_days: 2, max_days: 3 },
{ pincode: 247775, min_days: 2, max_days: 3 },
{ pincode: 247776, min_days: 2, max_days: 3 },
{ pincode: 247777, min_days: 2, max_days: 3 },
{ pincode: 247778, min_days: 2, max_days: 3 },
{ pincode: 248001, min_days: 2, max_days: 3 },
{ pincode: 248002, min_days: 2, max_days: 3 },
{ pincode: 248003, min_days: 2, max_days: 3 },
{ pincode: 248004, min_days: 2, max_days: 3 },
{ pincode: 248005, min_days: 2, max_days: 3 },
{ pincode: 248006, min_days: 2, max_days: 3 },
{ pincode: 248007, min_days: 2, max_days: 3 },
{ pincode: 248008, min_days: 2, max_days: 3 },
{ pincode: 248009, min_days: 2, max_days: 3 },
{ pincode: 248010, min_days: 2, max_days: 3 },
{ pincode: 248011, min_days: 2, max_days: 3 },
{ pincode: 248012, min_days: 2, max_days: 3 },
{ pincode: 248013, min_days: 2, max_days: 3 },
{ pincode: 248014, min_days: 2, max_days: 3 },
{ pincode: 248015, min_days: 2, max_days: 3 },
{ pincode: 248016, min_days: 2, max_days: 3 },
{ pincode: 248018, min_days: 2, max_days: 3 },
{ pincode: 248019, min_days: 2, max_days: 3 },
{ pincode: 248102, min_days: 2, max_days: 3 },
{ pincode: 248110, min_days: 2, max_days: 3 },
{ pincode: 248115, min_days: 2, max_days: 3 },
{ pincode: 248116, min_days: 2, max_days: 3 },
{ pincode: 248121, min_days: 2, max_days: 3 },
{ pincode: 248122, min_days: 2, max_days: 3 },
{ pincode: 248123, min_days: 2, max_days: 3 },
{ pincode: 248124, min_days: 2, max_days: 3 },
{ pincode: 248125, min_days: 2, max_days: 3 },
{ pincode: 248126, min_days: 2, max_days: 3 },
{ pincode: 248140, min_days: 2, max_days: 3 },
{ pincode: 248141, min_days: 2, max_days: 3 },
{ pincode: 248142, min_days: 2, max_days: 3 },
{ pincode: 248143, min_days: 2, max_days: 3 },
{ pincode: 248145, min_days: 2, max_days: 3 },
{ pincode: 248146, min_days: 2, max_days: 3 },
{ pincode: 248147, min_days: 2, max_days: 3 },
{ pincode: 248158, min_days: 2, max_days: 3 },
{ pincode: 248159, min_days: 2, max_days: 3 },
{ pincode: 248160, min_days: 2, max_days: 3 },
{ pincode: 248161, min_days: 2, max_days: 3 },
{ pincode: 248165, min_days: 2, max_days: 3 },
{ pincode: 248171, min_days: 2, max_days: 3 },
{ pincode: 248179, min_days: 2, max_days: 3 },
{ pincode: 248195, min_days: 2, max_days: 3 },
{ pincode: 248196, min_days: 2, max_days: 3 },
{ pincode: 248197, min_days: 2, max_days: 3 },
{ pincode: 248198, min_days: 2, max_days: 3 },
{ pincode: 248199, min_days: 2, max_days: 3 },
{ pincode: 248201, min_days: 2, max_days: 3 },
{ pincode: 248202, min_days: 2, max_days: 3 },
{ pincode: 249001, min_days: 2, max_days: 3 },
{ pincode: 249121, min_days: 2, max_days: 3 },
{ pincode: 249122, min_days: 2, max_days: 3 },
{ pincode: 249123, min_days: 2, max_days: 3 },
{ pincode: 249124, min_days: 2, max_days: 3 },
{ pincode: 249125, min_days: 2, max_days: 3 },
{ pincode: 249126, min_days: 2, max_days: 3 },
{ pincode: 249127, min_days: 2, max_days: 3 },
{ pincode: 249128, min_days: 2, max_days: 3 },
{ pincode: 249130, min_days: 2, max_days: 3 },
{ pincode: 249131, min_days: 2, max_days: 3 },
{ pincode: 249132, min_days: 2, max_days: 3 },
{ pincode: 249135, min_days: 2, max_days: 3 },
{ pincode: 249136, min_days: 2, max_days: 3 },
{ pincode: 249137, min_days: 2, max_days: 3 },
{ pincode: 249141, min_days: 2, max_days: 3 },
{ pincode: 249145, min_days: 2, max_days: 3 },
{ pincode: 249146, min_days: 2, max_days: 3 },
{ pincode: 249151, min_days: 2, max_days: 3 },
{ pincode: 249152, min_days: 2, max_days: 3 },
{ pincode: 249155, min_days: 2, max_days: 3 },
{ pincode: 249161, min_days: 2, max_days: 3 },
{ pincode: 249165, min_days: 2, max_days: 3 },
{ pincode: 249171, min_days: 2, max_days: 3 },
{ pincode: 249175, min_days: 2, max_days: 3 },
{ pincode: 249180, min_days: 2, max_days: 3 },
{ pincode: 249181, min_days: 2, max_days: 3 },
{ pincode: 249185, min_days: 2, max_days: 3 },
{ pincode: 249186, min_days: 2, max_days: 3 },
{ pincode: 249192, min_days: 2, max_days: 3 },
{ pincode: 249193, min_days: 2, max_days: 3 },
{ pincode: 249194, min_days: 2, max_days: 3 },
{ pincode: 249196, min_days: 2, max_days: 3 },
{ pincode: 249199, min_days: 2, max_days: 3 },
{ pincode: 249201, min_days: 2, max_days: 3 },
{ pincode: 249202, min_days: 2, max_days: 3 },
{ pincode: 249203, min_days: 2, max_days: 3 },
{ pincode: 249204, min_days: 2, max_days: 3 },
{ pincode: 249205, min_days: 2, max_days: 3 },
{ pincode: 249206, min_days: 2, max_days: 3 },
{ pincode: 249301, min_days: 2, max_days: 3 },
{ pincode: 249302, min_days: 2, max_days: 3 },
{ pincode: 249304, min_days: 2, max_days: 3 },
{ pincode: 249306, min_days: 2, max_days: 3 },
{ pincode: 249401, min_days: 2, max_days: 3 },
{ pincode: 249402, min_days: 2, max_days: 3 },
{ pincode: 249403, min_days: 2, max_days: 3 },
{ pincode: 249404, min_days: 2, max_days: 3 },
{ pincode: 249405, min_days: 2, max_days: 3 },
{ pincode: 249406, min_days: 2, max_days: 3 },
{ pincode: 249407, min_days: 2, max_days: 3 },
{ pincode: 249408, min_days: 2, max_days: 3 },
{ pincode: 249409, min_days: 2, max_days: 3 },
{ pincode: 249410, min_days: 2, max_days: 3 },
{ pincode: 249411, min_days: 2, max_days: 3 },
{ pincode: 249412, min_days: 2, max_days: 3 },
{ pincode: 250001, min_days: 2, max_days: 3 },
{ pincode: 250002, min_days: 2, max_days: 3 },
{ pincode: 250003, min_days: 2, max_days: 3 },
{ pincode: 250004, min_days: 2, max_days: 3 },
{ pincode: 250005, min_days: 2, max_days: 3 },
{ pincode: 250006, min_days: 2, max_days: 3 },
{ pincode: 250007, min_days: 2, max_days: 3 },
{ pincode: 250010, min_days: 2, max_days: 3 },
{ pincode: 250013, min_days: 2, max_days: 3 },
{ pincode: 250101, min_days: 2, max_days: 3 },
{ pincode: 250102, min_days: 2, max_days: 3 },
{ pincode: 250103, min_days: 2, max_days: 3 },
{ pincode: 250104, min_days: 2, max_days: 3 },
{ pincode: 250105, min_days: 2, max_days: 3 },
{ pincode: 250106, min_days: 2, max_days: 3 },
{ pincode: 250110, min_days: 2, max_days: 3 },
{ pincode: 250205, min_days: 2, max_days: 3 },
{ pincode: 250221, min_days: 2, max_days: 3 },
{ pincode: 250222, min_days: 2, max_days: 3 },
{ pincode: 250223, min_days: 2, max_days: 3 },
{ pincode: 250341, min_days: 2, max_days: 3 },
{ pincode: 250342, min_days: 2, max_days: 3 },
{ pincode: 250344, min_days: 2, max_days: 3 },
{ pincode: 250345, min_days: 2, max_days: 3 },
{ pincode: 250401, min_days: 2, max_days: 3 },
{ pincode: 250402, min_days: 2, max_days: 3 },
{ pincode: 250403, min_days: 2, max_days: 3 },
{ pincode: 250404, min_days: 2, max_days: 3 },
{ pincode: 250406, min_days: 2, max_days: 3 },
{ pincode: 250501, min_days: 2, max_days: 3 },
{ pincode: 250502, min_days: 2, max_days: 3 },
{ pincode: 250515, min_days: 2, max_days: 3 },
{ pincode: 250601, min_days: 2, max_days: 3 },
{ pincode: 250602, min_days: 2, max_days: 3 },
{ pincode: 250604, min_days: 2, max_days: 3 },
{ pincode: 250606, min_days: 2, max_days: 3 },
{ pincode: 250609, min_days: 2, max_days: 3 },
{ pincode: 250611, min_days: 2, max_days: 3 },
{ pincode: 250612, min_days: 2, max_days: 3 },
{ pincode: 250615, min_days: 2, max_days: 3 },
{ pincode: 250617, min_days: 2, max_days: 3 },
{ pincode: 250619, min_days: 2, max_days: 3 },
{ pincode: 250620, min_days: 2, max_days: 3 },
{ pincode: 250621, min_days: 2, max_days: 3 },
{ pincode: 250622, min_days: 2, max_days: 3 },
{ pincode: 250623, min_days: 2, max_days: 3 },
{ pincode: 250625, min_days: 2, max_days: 3 },
{ pincode: 250626, min_days: 2, max_days: 3 },
{ pincode: 250645, min_days: 2, max_days: 3 },
{ pincode: 251001, min_days: 2, max_days: 3 },
{ pincode: 251002, min_days: 2, max_days: 3 },
{ pincode: 251003, min_days: 2, max_days: 3 },
{ pincode: 251201, min_days: 2, max_days: 3 },
{ pincode: 251202, min_days: 2, max_days: 3 },
{ pincode: 251203, min_days: 2, max_days: 3 },
{ pincode: 251301, min_days: 2, max_days: 3 },
{ pincode: 251305, min_days: 2, max_days: 3 },
{ pincode: 251306, min_days: 2, max_days: 3 },
{ pincode: 251307, min_days: 2, max_days: 3 },
{ pincode: 251308, min_days: 2, max_days: 3 },
{ pincode: 251309, min_days: 2, max_days: 3 },
{ pincode: 251310, min_days: 2, max_days: 3 },
{ pincode: 251311, min_days: 2, max_days: 3 },
{ pincode: 251314, min_days: 2, max_days: 3 },
{ pincode: 251315, min_days: 2, max_days: 3 },
{ pincode: 251316, min_days: 2, max_days: 3 },
{ pincode: 251318, min_days: 2, max_days: 3 },
{ pincode: 251319, min_days: 2, max_days: 3 },
{ pincode: 251320, min_days: 2, max_days: 3 },
{ pincode: 251327, min_days: 2, max_days: 3 },
{ pincode: 261001, min_days: 2, max_days: 3 },
{ pincode: 261121, min_days: 2, max_days: 3 },
{ pincode: 261125, min_days: 2, max_days: 3 },
{ pincode: 261131, min_days: 2, max_days: 3 },
{ pincode: 261135, min_days: 2, max_days: 3 },
{ pincode: 261136, min_days: 2, max_days: 3 },
{ pincode: 261141, min_days: 2, max_days: 3 },
{ pincode: 261145, min_days: 2, max_days: 3 },
{ pincode: 261151, min_days: 2, max_days: 3 },
{ pincode: 261201, min_days: 2, max_days: 3 },
{ pincode: 261202, min_days: 2, max_days: 3 },
{ pincode: 261203, min_days: 2, max_days: 3 },
{ pincode: 261204, min_days: 2, max_days: 3 },
{ pincode: 261205, min_days: 2, max_days: 3 },
{ pincode: 261206, min_days: 2, max_days: 3 },
{ pincode: 261207, min_days: 2, max_days: 3 },
{ pincode: 261208, min_days: 2, max_days: 3 },
{ pincode: 261301, min_days: 2, max_days: 3 },
{ pincode: 261302, min_days: 2, max_days: 3 },
{ pincode: 261303, min_days: 2, max_days: 3 },
{ pincode: 261304, min_days: 2, max_days: 3 },
{ pincode: 261401, min_days: 2, max_days: 3 },
{ pincode: 261402, min_days: 2, max_days: 3 },
{ pincode: 261403, min_days: 2, max_days: 3 },
{ pincode: 261404, min_days: 2, max_days: 3 },
{ pincode: 261405, min_days: 2, max_days: 3 },
{ pincode: 261501, min_days: 2, max_days: 3 },
{ pincode: 261502, min_days: 2, max_days: 3 },
{ pincode: 261505, min_days: 2, max_days: 3 },
{ pincode: 261506, min_days: 2, max_days: 3 },
{ pincode: 262001, min_days: 2, max_days: 3 },
{ pincode: 262121, min_days: 2, max_days: 3 },
{ pincode: 262122, min_days: 2, max_days: 3 },
{ pincode: 262123, min_days: 2, max_days: 3 },
{ pincode: 262124, min_days: 2, max_days: 3 },
{ pincode: 262201, min_days: 2, max_days: 3 },
{ pincode: 262202, min_days: 2, max_days: 3 },
{ pincode: 262203, min_days: 2, max_days: 3 },
{ pincode: 262302, min_days: 2, max_days: 3 },
{ pincode: 262305, min_days: 2, max_days: 3 },
{ pincode: 262308, min_days: 2, max_days: 3 },
{ pincode: 262309, min_days: 2, max_days: 3 },
{ pincode: 262310, min_days: 2, max_days: 3 },
{ pincode: 262311, min_days: 2, max_days: 3 },
{ pincode: 262401, min_days: 2, max_days: 3 },
{ pincode: 262402, min_days: 2, max_days: 3 },
{ pincode: 262404, min_days: 2, max_days: 3 },
{ pincode: 262405, min_days: 2, max_days: 3 },
{ pincode: 262406, min_days: 2, max_days: 3 },
{ pincode: 262407, min_days: 2, max_days: 3 },
{ pincode: 262410, min_days: 2, max_days: 3 },
{ pincode: 262411, min_days: 2, max_days: 3 },
{ pincode: 262501, min_days: 2, max_days: 3 },
{ pincode: 262502, min_days: 2, max_days: 3 },
{ pincode: 262520, min_days: 2, max_days: 3 },
{ pincode: 262521, min_days: 2, max_days: 3 },
{ pincode: 262522, min_days: 2, max_days: 3 },
{ pincode: 262523, min_days: 2, max_days: 3 },
{ pincode: 262524, min_days: 2, max_days: 3 },
{ pincode: 262525, min_days: 2, max_days: 3 },
{ pincode: 262526, min_days: 2, max_days: 3 },
{ pincode: 262527, min_days: 2, max_days: 3 },
{ pincode: 262528, min_days: 2, max_days: 3 },
{ pincode: 262529, min_days: 2, max_days: 3 },
{ pincode: 262530, min_days: 2, max_days: 3 },
{ pincode: 262531, min_days: 2, max_days: 3 },
{ pincode: 262532, min_days: 2, max_days: 3 },
{ pincode: 262533, min_days: 2, max_days: 3 },
{ pincode: 262534, min_days: 2, max_days: 3 },
{ pincode: 262540, min_days: 2, max_days: 3 },
{ pincode: 262541, min_days: 2, max_days: 3 },
{ pincode: 262542, min_days: 2, max_days: 3 },
{ pincode: 262543, min_days: 2, max_days: 3 },
{ pincode: 262544, min_days: 2, max_days: 3 },
{ pincode: 262545, min_days: 2, max_days: 3 },
{ pincode: 262546, min_days: 2, max_days: 3 },
{ pincode: 262547, min_days: 2, max_days: 3 },
{ pincode: 262550, min_days: 2, max_days: 3 },
{ pincode: 262551, min_days: 2, max_days: 3 },
{ pincode: 262552, min_days: 2, max_days: 3 },
{ pincode: 262553, min_days: 2, max_days: 3 },
{ pincode: 262554, min_days: 2, max_days: 3 },
{ pincode: 262555, min_days: 2, max_days: 3 },
{ pincode: 262561, min_days: 2, max_days: 3 },
{ pincode: 262572, min_days: 2, max_days: 3 },
{ pincode: 262576, min_days: 2, max_days: 3 },
{ pincode: 262580, min_days: 2, max_days: 3 },
{ pincode: 262701, min_days: 2, max_days: 3 },
{ pincode: 262702, min_days: 2, max_days: 3 },
{ pincode: 262721, min_days: 2, max_days: 3 },
{ pincode: 262722, min_days: 2, max_days: 3 },
{ pincode: 262723, min_days: 2, max_days: 3 },
{ pincode: 262724, min_days: 2, max_days: 3 },
{ pincode: 262725, min_days: 2, max_days: 3 },
{ pincode: 262726, min_days: 2, max_days: 3 },
{ pincode: 262727, min_days: 2, max_days: 3 },
{ pincode: 262728, min_days: 2, max_days: 3 },
{ pincode: 262801, min_days: 2, max_days: 3 },
{ pincode: 262802, min_days: 2, max_days: 3 },
{ pincode: 262803, min_days: 2, max_days: 3 },
{ pincode: 262804, min_days: 2, max_days: 3 },
{ pincode: 262805, min_days: 2, max_days: 3 },
{ pincode: 262901, min_days: 2, max_days: 3 },
{ pincode: 262902, min_days: 2, max_days: 3 },
{ pincode: 262903, min_days: 2, max_days: 3 },
{ pincode: 262904, min_days: 2, max_days: 3 },
{ pincode: 262905, min_days: 2, max_days: 3 },
{ pincode: 262906, min_days: 2, max_days: 3 },
{ pincode: 262907, min_days: 2, max_days: 3 },
{ pincode: 262908, min_days: 2, max_days: 3 },
{ pincode: 263001, min_days: 2, max_days: 3 },
{ pincode: 263002, min_days: 2, max_days: 3 },
{ pincode: 263126, min_days: 2, max_days: 3 },
{ pincode: 263127, min_days: 2, max_days: 3 },
{ pincode: 263128, min_days: 2, max_days: 3 },
{ pincode: 263129, min_days: 2, max_days: 3 },
{ pincode: 263131, min_days: 2, max_days: 3 },
{ pincode: 263132, min_days: 2, max_days: 3 },
{ pincode: 263134, min_days: 2, max_days: 3 },
{ pincode: 263135, min_days: 2, max_days: 3 },
{ pincode: 263136, min_days: 2, max_days: 3 },
{ pincode: 263137, min_days: 2, max_days: 3 },
{ pincode: 263138, min_days: 2, max_days: 3 },
{ pincode: 263139, min_days: 2, max_days: 3 },
{ pincode: 263140, min_days: 2, max_days: 3 },
{ pincode: 263141, min_days: 2, max_days: 3 },
{ pincode: 263142, min_days: 2, max_days: 3 },
{ pincode: 263143, min_days: 2, max_days: 3 },
{ pincode: 263145, min_days: 2, max_days: 3 },
{ pincode: 263146, min_days: 2, max_days: 3 },
{ pincode: 263147, min_days: 2, max_days: 3 },
{ pincode: 263148, min_days: 2, max_days: 3 },
{ pincode: 263149, min_days: 2, max_days: 3 },
{ pincode: 263150, min_days: 2, max_days: 3 },
{ pincode: 263151, min_days: 2, max_days: 3 },
{ pincode: 263152, min_days: 2, max_days: 3 },
{ pincode: 263153, min_days: 2, max_days: 3 },
{ pincode: 263154, min_days: 2, max_days: 3 },
{ pincode: 263156, min_days: 2, max_days: 3 },
{ pincode: 263157, min_days: 2, max_days: 3 },
{ pincode: 263158, min_days: 2, max_days: 3 },
{ pincode: 263159, min_days: 2, max_days: 3 },
{ pincode: 263160, min_days: 2, max_days: 3 },
{ pincode: 263401, min_days: 2, max_days: 3 },
{ pincode: 263601, min_days: 2, max_days: 3 },
{ pincode: 263619, min_days: 2, max_days: 3 },
{ pincode: 263620, min_days: 2, max_days: 3 },
{ pincode: 263621, min_days: 2, max_days: 3 },
{ pincode: 263622, min_days: 2, max_days: 3 },
{ pincode: 263623, min_days: 2, max_days: 3 },
{ pincode: 263624, min_days: 2, max_days: 3 },
{ pincode: 263625, min_days: 2, max_days: 3 },
{ pincode: 263626, min_days: 2, max_days: 3 },
{ pincode: 263628, min_days: 2, max_days: 3 },
{ pincode: 263629, min_days: 2, max_days: 3 },
{ pincode: 263630, min_days: 2, max_days: 3 },
{ pincode: 263631, min_days: 2, max_days: 3 },
{ pincode: 263632, min_days: 2, max_days: 3 },
{ pincode: 263633, min_days: 2, max_days: 3 },
{ pincode: 263634, min_days: 2, max_days: 3 },
{ pincode: 263635, min_days: 2, max_days: 3 },
{ pincode: 263636, min_days: 2, max_days: 3 },
{ pincode: 263637, min_days: 2, max_days: 3 },
{ pincode: 263638, min_days: 2, max_days: 3 },
{ pincode: 263639, min_days: 2, max_days: 3 },
{ pincode: 263640, min_days: 2, max_days: 3 },
{ pincode: 263641, min_days: 2, max_days: 3 },
{ pincode: 263642, min_days: 2, max_days: 3 },
{ pincode: 263643, min_days: 2, max_days: 3 },
{ pincode: 263645, min_days: 2, max_days: 3 },
{ pincode: 263646, min_days: 2, max_days: 3 },
{ pincode: 263651, min_days: 2, max_days: 3 },
{ pincode: 263652, min_days: 2, max_days: 3 },
{ pincode: 263653, min_days: 2, max_days: 3 },
{ pincode: 263655, min_days: 2, max_days: 3 },
{ pincode: 263656, min_days: 2, max_days: 3 },
{ pincode: 263658, min_days: 2, max_days: 3 },
{ pincode: 263659, min_days: 2, max_days: 3 },
{ pincode: 263660, min_days: 2, max_days: 3 },
{ pincode: 263661, min_days: 2, max_days: 3 },
{ pincode: 263663, min_days: 2, max_days: 3 },
{ pincode: 263664, min_days: 2, max_days: 3 },
{ pincode: 263665, min_days: 2, max_days: 3 },
{ pincode: 263667, min_days: 2, max_days: 3 },
{ pincode: 263676, min_days: 2, max_days: 3 },
{ pincode: 263678, min_days: 2, max_days: 3 },
{ pincode: 263679, min_days: 2, max_days: 3 },
{ pincode: 263680, min_days: 2, max_days: 3 },
{ pincode: 266005, min_days: 2, max_days: 3 },
{ pincode: 271001, min_days: 2, max_days: 3 },
{ pincode: 271002, min_days: 2, max_days: 3 },
{ pincode: 271003, min_days: 2, max_days: 3 },
{ pincode: 271122, min_days: 2, max_days: 3 },
{ pincode: 271123, min_days: 2, max_days: 3 },
{ pincode: 271124, min_days: 2, max_days: 3 },
{ pincode: 271125, min_days: 2, max_days: 3 },
{ pincode: 271126, min_days: 2, max_days: 3 },
{ pincode: 271127, min_days: 2, max_days: 3 },
{ pincode: 271128, min_days: 2, max_days: 3 },
{ pincode: 271129, min_days: 2, max_days: 3 },
{ pincode: 271201, min_days: 2, max_days: 3 },
{ pincode: 271202, min_days: 2, max_days: 3 },
{ pincode: 271203, min_days: 2, max_days: 3 },
{ pincode: 271204, min_days: 2, max_days: 3 },
{ pincode: 271205, min_days: 2, max_days: 3 },
{ pincode: 271206, min_days: 2, max_days: 3 },
{ pincode: 271207, min_days: 2, max_days: 3 },
{ pincode: 271208, min_days: 2, max_days: 3 },
{ pincode: 271209, min_days: 2, max_days: 3 },
{ pincode: 271210, min_days: 2, max_days: 3 },
{ pincode: 271211, min_days: 2, max_days: 3 },
{ pincode: 271212, min_days: 2, max_days: 3 },
{ pincode: 271214, min_days: 2, max_days: 3 },
{ pincode: 271215, min_days: 2, max_days: 3 },
{ pincode: 271301, min_days: 2, max_days: 3 },
{ pincode: 271302, min_days: 2, max_days: 3 },
{ pincode: 271303, min_days: 2, max_days: 3 },
{ pincode: 271304, min_days: 2, max_days: 3 },
{ pincode: 271305, min_days: 2, max_days: 3 },
{ pincode: 271306, min_days: 2, max_days: 3 },
{ pincode: 271307, min_days: 2, max_days: 3 },
{ pincode: 271308, min_days: 2, max_days: 3 },
{ pincode: 271309, min_days: 2, max_days: 3 },
{ pincode: 271310, min_days: 2, max_days: 3 },
{ pincode: 271311, min_days: 2, max_days: 3 },
{ pincode: 271312, min_days: 2, max_days: 3 },
{ pincode: 271313, min_days: 2, max_days: 3 },
{ pincode: 271317, min_days: 2, max_days: 3 },
{ pincode: 271318, min_days: 2, max_days: 3 },
{ pincode: 271319, min_days: 2, max_days: 3 },
{ pincode: 271320, min_days: 2, max_days: 3 },
{ pincode: 271401, min_days: 2, max_days: 3 },
{ pincode: 271402, min_days: 2, max_days: 3 },
{ pincode: 271403, min_days: 2, max_days: 3 },
{ pincode: 271404, min_days: 2, max_days: 3 },
{ pincode: 271405, min_days: 2, max_days: 3 },
{ pincode: 271502, min_days: 2, max_days: 3 },
{ pincode: 271503, min_days: 2, max_days: 3 },
{ pincode: 271504, min_days: 2, max_days: 3 },
{ pincode: 271601, min_days: 2, max_days: 3 },
{ pincode: 271602, min_days: 2, max_days: 3 },
{ pincode: 271603, min_days: 2, max_days: 3 },
{ pincode: 271604, min_days: 2, max_days: 3 },
{ pincode: 271605, min_days: 2, max_days: 3 },
{ pincode: 271606, min_days: 2, max_days: 3 },
{ pincode: 271607, min_days: 2, max_days: 3 },
{ pincode: 271608, min_days: 2, max_days: 3 },
{ pincode: 271609, min_days: 2, max_days: 3 },
{ pincode: 271801, min_days: 2, max_days: 3 },
{ pincode: 271802, min_days: 2, max_days: 3 },
{ pincode: 271803, min_days: 2, max_days: 3 },
{ pincode: 271804, min_days: 2, max_days: 3 },
{ pincode: 271805, min_days: 2, max_days: 3 },
{ pincode: 271806, min_days: 2, max_days: 3 },
{ pincode: 271821, min_days: 2, max_days: 3 },
{ pincode: 271823, min_days: 2, max_days: 3 },
{ pincode: 271824, min_days: 2, max_days: 3 },
{ pincode: 271825, min_days: 2, max_days: 3 },
{ pincode: 271826, min_days: 2, max_days: 3 },
{ pincode: 271830, min_days: 2, max_days: 3 },
{ pincode: 271831, min_days: 2, max_days: 3 },
{ pincode: 271832, min_days: 2, max_days: 3 },
{ pincode: 271835, min_days: 2, max_days: 3 },
{ pincode: 271836, min_days: 2, max_days: 3 },
{ pincode: 271840, min_days: 2, max_days: 3 },
{ pincode: 271841, min_days: 2, max_days: 3 },
{ pincode: 271845, min_days: 2, max_days: 3 },
{ pincode: 271851, min_days: 2, max_days: 3 },
{ pincode: 271855, min_days: 2, max_days: 3 },
{ pincode: 271857, min_days: 2, max_days: 3 },
{ pincode: 271861, min_days: 2, max_days: 3 },
{ pincode: 271865, min_days: 2, max_days: 3 },
{ pincode: 271870, min_days: 2, max_days: 3 },
{ pincode: 271871, min_days: 2, max_days: 3 },
{ pincode: 271872, min_days: 2, max_days: 3 },
{ pincode: 271875, min_days: 2, max_days: 3 },
{ pincode: 271881, min_days: 2, max_days: 3 },
{ pincode: 271882, min_days: 2, max_days: 3 },
{ pincode: 271901, min_days: 2, max_days: 3 },
{ pincode: 271902, min_days: 2, max_days: 3 },
{ pincode: 271903, min_days: 2, max_days: 3 },
{ pincode: 271904, min_days: 2, max_days: 3 },
{ pincode: 272001, min_days: 2, max_days: 3 },
{ pincode: 272002, min_days: 2, max_days: 3 },
{ pincode: 272003, min_days: 2, max_days: 3 },
{ pincode: 272102, min_days: 2, max_days: 3 },
{ pincode: 272105, min_days: 2, max_days: 3 },
{ pincode: 272123, min_days: 2, max_days: 3 },
{ pincode: 272124, min_days: 2, max_days: 3 },
{ pincode: 272125, min_days: 2, max_days: 3 },
{ pincode: 272126, min_days: 2, max_days: 3 },
{ pincode: 272127, min_days: 2, max_days: 3 },
{ pincode: 272128, min_days: 2, max_days: 3 },
{ pincode: 272129, min_days: 2, max_days: 3 },
{ pincode: 272130, min_days: 2, max_days: 3 },
{ pincode: 272131, min_days: 2, max_days: 3 },
{ pincode: 272141, min_days: 2, max_days: 3 },
{ pincode: 272148, min_days: 2, max_days: 3 },
{ pincode: 272149, min_days: 2, max_days: 3 },
{ pincode: 272150, min_days: 2, max_days: 3 },
{ pincode: 272151, min_days: 2, max_days: 3 },
{ pincode: 272152, min_days: 2, max_days: 3 },
{ pincode: 272153, min_days: 2, max_days: 3 },
{ pincode: 272154, min_days: 2, max_days: 3 },
{ pincode: 272155, min_days: 2, max_days: 3 },
{ pincode: 272161, min_days: 2, max_days: 3 },
{ pincode: 272162, min_days: 2, max_days: 3 },
{ pincode: 272163, min_days: 2, max_days: 3 },
{ pincode: 272164, min_days: 2, max_days: 3 },
{ pincode: 272165, min_days: 2, max_days: 3 },
{ pincode: 272170, min_days: 2, max_days: 3 },
{ pincode: 272171, min_days: 2, max_days: 3 },
{ pincode: 272172, min_days: 2, max_days: 3 },
{ pincode: 272173, min_days: 2, max_days: 3 },
{ pincode: 272175, min_days: 2, max_days: 3 },
{ pincode: 272176, min_days: 2, max_days: 3 },
{ pincode: 272177, min_days: 2, max_days: 3 },
{ pincode: 272178, min_days: 2, max_days: 3 },
{ pincode: 272181, min_days: 2, max_days: 3 },
{ pincode: 272182, min_days: 2, max_days: 3 },
{ pincode: 272189, min_days: 2, max_days: 3 },
{ pincode: 272190, min_days: 2, max_days: 3 },
{ pincode: 272191, min_days: 2, max_days: 3 },
{ pincode: 272192, min_days: 2, max_days: 3 },
{ pincode: 272193, min_days: 2, max_days: 3 },
{ pincode: 272194, min_days: 2, max_days: 3 },
{ pincode: 272195, min_days: 2, max_days: 3 },
{ pincode: 272199, min_days: 2, max_days: 3 },
{ pincode: 272201, min_days: 2, max_days: 3 },
{ pincode: 272202, min_days: 2, max_days: 3 },
{ pincode: 272203, min_days: 2, max_days: 3 },
{ pincode: 272204, min_days: 2, max_days: 3 },
{ pincode: 272205, min_days: 2, max_days: 3 },
{ pincode: 272206, min_days: 2, max_days: 3 },
{ pincode: 272207, min_days: 2, max_days: 3 },
{ pincode: 272208, min_days: 2, max_days: 3 },
{ pincode: 272209, min_days: 2, max_days: 3 },
{ pincode: 272269, min_days: 2, max_days: 3 },
{ pincode: 272270, min_days: 2, max_days: 3 },
{ pincode: 272271, min_days: 2, max_days: 3 },
{ pincode: 272301, min_days: 2, max_days: 3 },
{ pincode: 272302, min_days: 2, max_days: 3 },
{ pincode: 273001, min_days: 2, max_days: 3 },
{ pincode: 273002, min_days: 2, max_days: 3 },
{ pincode: 273003, min_days: 2, max_days: 3 },
{ pincode: 273004, min_days: 2, max_days: 3 },
{ pincode: 273005, min_days: 2, max_days: 3 },
{ pincode: 273006, min_days: 2, max_days: 3 },
{ pincode: 273007, min_days: 2, max_days: 3 },
{ pincode: 273008, min_days: 2, max_days: 3 },
{ pincode: 273009, min_days: 2, max_days: 3 },
{ pincode: 273010, min_days: 2, max_days: 3 },
{ pincode: 273011, min_days: 2, max_days: 3 },
{ pincode: 273012, min_days: 2, max_days: 3 },
{ pincode: 273013, min_days: 2, max_days: 3 },
{ pincode: 273014, min_days: 2, max_days: 3 },
{ pincode: 273015, min_days: 2, max_days: 3 },
{ pincode: 273016, min_days: 2, max_days: 3 },
{ pincode: 273017, min_days: 2, max_days: 3 },
{ pincode: 273151, min_days: 2, max_days: 3 },
{ pincode: 273152, min_days: 2, max_days: 3 },
{ pincode: 273155, min_days: 2, max_days: 3 },
{ pincode: 273157, min_days: 2, max_days: 3 },
{ pincode: 273158, min_days: 2, max_days: 3 },
{ pincode: 273161, min_days: 2, max_days: 3 },
{ pincode: 273162, min_days: 2, max_days: 3 },
{ pincode: 273163, min_days: 2, max_days: 3 },
{ pincode: 273164, min_days: 2, max_days: 3 },
{ pincode: 273165, min_days: 2, max_days: 3 },
{ pincode: 273200, min_days: 2, max_days: 3 },
{ pincode: 273201, min_days: 2, max_days: 3 },
{ pincode: 273202, min_days: 2, max_days: 3 },
{ pincode: 273203, min_days: 2, max_days: 3 },
{ pincode: 273207, min_days: 2, max_days: 3 },
{ pincode: 273209, min_days: 2, max_days: 3 },
{ pincode: 273211, min_days: 2, max_days: 3 },
{ pincode: 273212, min_days: 2, max_days: 3 },
{ pincode: 273213, min_days: 2, max_days: 3 },
{ pincode: 273301, min_days: 2, max_days: 3 },
{ pincode: 273302, min_days: 2, max_days: 3 },
{ pincode: 273303, min_days: 2, max_days: 3 },
{ pincode: 273304, min_days: 2, max_days: 3 },
{ pincode: 273305, min_days: 2, max_days: 3 },
{ pincode: 273306, min_days: 2, max_days: 3 },
{ pincode: 273307, min_days: 2, max_days: 3 },
{ pincode: 273308, min_days: 2, max_days: 3 },
{ pincode: 273309, min_days: 2, max_days: 3 },
{ pincode: 273310, min_days: 2, max_days: 3 },
{ pincode: 273311, min_days: 2, max_days: 3 },
{ pincode: 273401, min_days: 2, max_days: 3 },
{ pincode: 273402, min_days: 2, max_days: 3 },
{ pincode: 273403, min_days: 2, max_days: 3 },
{ pincode: 273404, min_days: 2, max_days: 3 },
{ pincode: 273405, min_days: 2, max_days: 3 },
{ pincode: 273406, min_days: 2, max_days: 3 },
{ pincode: 273407, min_days: 2, max_days: 3 },
{ pincode: 273408, min_days: 2, max_days: 3 },
{ pincode: 273409, min_days: 2, max_days: 3 },
{ pincode: 273411, min_days: 2, max_days: 3 },
{ pincode: 273412, min_days: 2, max_days: 3 },
{ pincode: 273413, min_days: 2, max_days: 3 },
{ pincode: 274001, min_days: 2, max_days: 3 },
{ pincode: 274002, min_days: 2, max_days: 3 },
{ pincode: 274003, min_days: 2, max_days: 3 },
{ pincode: 274122, min_days: 2, max_days: 3 },
{ pincode: 274149, min_days: 2, max_days: 3 },
{ pincode: 274182, min_days: 2, max_days: 3 },
{ pincode: 274201, min_days: 2, max_days: 3 },
{ pincode: 274202, min_days: 2, max_days: 3 },
{ pincode: 274203, min_days: 2, max_days: 3 },
{ pincode: 274204, min_days: 2, max_days: 3 },
{ pincode: 274205, min_days: 2, max_days: 3 },
{ pincode: 274206, min_days: 2, max_days: 3 },
{ pincode: 274207, min_days: 2, max_days: 3 },
{ pincode: 274208, min_days: 2, max_days: 3 },
{ pincode: 274249, min_days: 2, max_days: 3 },
{ pincode: 274301, min_days: 2, max_days: 3 },
{ pincode: 274302, min_days: 2, max_days: 3 },
{ pincode: 274303, min_days: 2, max_days: 3 },
{ pincode: 274304, min_days: 2, max_days: 3 },
{ pincode: 274305, min_days: 2, max_days: 3 },
{ pincode: 274306, min_days: 2, max_days: 3 },
{ pincode: 274307, min_days: 2, max_days: 3 },
{ pincode: 274308, min_days: 2, max_days: 3 },
{ pincode: 274309, min_days: 2, max_days: 3 },
{ pincode: 274401, min_days: 2, max_days: 3 },
{ pincode: 274402, min_days: 2, max_days: 3 },
{ pincode: 274403, min_days: 2, max_days: 3 },
{ pincode: 274404, min_days: 2, max_days: 3 },
{ pincode: 274405, min_days: 2, max_days: 3 },
{ pincode: 274406, min_days: 2, max_days: 3 },
{ pincode: 274407, min_days: 2, max_days: 3 },
{ pincode: 274408, min_days: 2, max_days: 3 },
{ pincode: 274409, min_days: 2, max_days: 3 },
{ pincode: 274501, min_days: 2, max_days: 3 },
{ pincode: 274502, min_days: 2, max_days: 3 },
{ pincode: 274505, min_days: 2, max_days: 3 },
{ pincode: 274506, min_days: 2, max_days: 3 },
{ pincode: 274508, min_days: 2, max_days: 3 },
{ pincode: 274509, min_days: 2, max_days: 3 },
{ pincode: 274601, min_days: 2, max_days: 3 },
{ pincode: 274602, min_days: 2, max_days: 3 },
{ pincode: 274603, min_days: 2, max_days: 3 },
{ pincode: 274604, min_days: 2, max_days: 3 },
{ pincode: 274701, min_days: 2, max_days: 3 },
{ pincode: 274702, min_days: 2, max_days: 3 },
{ pincode: 274703, min_days: 2, max_days: 3 },
{ pincode: 274704, min_days: 2, max_days: 3 },
{ pincode: 274705, min_days: 2, max_days: 3 },
{ pincode: 274801, min_days: 2, max_days: 3 },
{ pincode: 274802, min_days: 2, max_days: 3 },
{ pincode: 274806, min_days: 2, max_days: 3 },
{ pincode: 274807, min_days: 2, max_days: 3 },
{ pincode: 274808, min_days: 2, max_days: 3 },
{ pincode: 275101, min_days: 2, max_days: 3 },
{ pincode: 275102, min_days: 2, max_days: 3 },
{ pincode: 275103, min_days: 2, max_days: 3 },
{ pincode: 275105, min_days: 2, max_days: 3 },
{ pincode: 275107, min_days: 2, max_days: 3 },
{ pincode: 275201, min_days: 2, max_days: 3 },
{ pincode: 275202, min_days: 2, max_days: 3 },
{ pincode: 275203, min_days: 2, max_days: 3 },
{ pincode: 275204, min_days: 2, max_days: 3 },
{ pincode: 275205, min_days: 2, max_days: 3 },
{ pincode: 275207, min_days: 2, max_days: 3 },
{ pincode: 275301, min_days: 2, max_days: 3 },
{ pincode: 275302, min_days: 2, max_days: 3 },
{ pincode: 275303, min_days: 2, max_days: 3 },
{ pincode: 275304, min_days: 2, max_days: 3 },
{ pincode: 275305, min_days: 2, max_days: 3 },
{ pincode: 275306, min_days: 2, max_days: 3 },
{ pincode: 275307, min_days: 2, max_days: 3 },
{ pincode: 276001, min_days: 2, max_days: 3 },
{ pincode: 276121, min_days: 2, max_days: 3 },
{ pincode: 276122, min_days: 2, max_days: 3 },
{ pincode: 276123, min_days: 2, max_days: 3 },
{ pincode: 276124, min_days: 2, max_days: 3 },
{ pincode: 276125, min_days: 2, max_days: 3 },
{ pincode: 276126, min_days: 2, max_days: 3 },
{ pincode: 276127, min_days: 2, max_days: 3 },
{ pincode: 276128, min_days: 2, max_days: 3 },
{ pincode: 276129, min_days: 2, max_days: 3 },
{ pincode: 276131, min_days: 2, max_days: 3 },
{ pincode: 276135, min_days: 2, max_days: 3 },
{ pincode: 276136, min_days: 2, max_days: 3 },
{ pincode: 276137, min_days: 2, max_days: 3 },
{ pincode: 276138, min_days: 2, max_days: 3 },
{ pincode: 276139, min_days: 2, max_days: 3 },
{ pincode: 276140, min_days: 2, max_days: 3 },
{ pincode: 276141, min_days: 2, max_days: 3 },
{ pincode: 276142, min_days: 2, max_days: 3 },
{ pincode: 276143, min_days: 2, max_days: 3 },
{ pincode: 276201, min_days: 2, max_days: 3 },
{ pincode: 276202, min_days: 2, max_days: 3 },
{ pincode: 276203, min_days: 2, max_days: 3 },
{ pincode: 276204, min_days: 2, max_days: 3 },
{ pincode: 276205, min_days: 2, max_days: 3 },
{ pincode: 276206, min_days: 2, max_days: 3 },
{ pincode: 276207, min_days: 2, max_days: 3 },
{ pincode: 276208, min_days: 2, max_days: 3 },
{ pincode: 276288, min_days: 2, max_days: 3 },
{ pincode: 276301, min_days: 2, max_days: 3 },
{ pincode: 276302, min_days: 2, max_days: 3 },
{ pincode: 276303, min_days: 2, max_days: 3 },
{ pincode: 276304, min_days: 2, max_days: 3 },
{ pincode: 276305, min_days: 2, max_days: 3 },
{ pincode: 276306, min_days: 2, max_days: 3 },
{ pincode: 276401, min_days: 2, max_days: 3 },
{ pincode: 276402, min_days: 2, max_days: 3 },
{ pincode: 276403, min_days: 2, max_days: 3 },
{ pincode: 276404, min_days: 2, max_days: 3 },
{ pincode: 276405, min_days: 2, max_days: 3 },
{ pincode: 276406, min_days: 2, max_days: 3 },
{ pincode: 277001, min_days: 2, max_days: 3 },
{ pincode: 277121, min_days: 2, max_days: 3 },
{ pincode: 277122, min_days: 2, max_days: 3 },
{ pincode: 277123, min_days: 2, max_days: 3 },
{ pincode: 277124, min_days: 2, max_days: 3 },
{ pincode: 277201, min_days: 2, max_days: 3 },
{ pincode: 277202, min_days: 2, max_days: 3 },
{ pincode: 277203, min_days: 2, max_days: 3 },
{ pincode: 277204, min_days: 2, max_days: 3 },
{ pincode: 277205, min_days: 2, max_days: 3 },
{ pincode: 277207, min_days: 2, max_days: 3 },
{ pincode: 277208, min_days: 2, max_days: 3 },
{ pincode: 277209, min_days: 2, max_days: 3 },
{ pincode: 277210, min_days: 2, max_days: 3 },
{ pincode: 277211, min_days: 2, max_days: 3 },
{ pincode: 277212, min_days: 2, max_days: 3 },
{ pincode: 277213, min_days: 2, max_days: 3 },
{ pincode: 277214, min_days: 2, max_days: 3 },
{ pincode: 277216, min_days: 2, max_days: 3 },
{ pincode: 277218, min_days: 2, max_days: 3 },
{ pincode: 277219, min_days: 2, max_days: 3 },
{ pincode: 277301, min_days: 2, max_days: 3 },
{ pincode: 277302, min_days: 2, max_days: 3 },
{ pincode: 277303, min_days: 2, max_days: 3 },
{ pincode: 277304, min_days: 2, max_days: 3 },
{ pincode: 277305, min_days: 2, max_days: 3 },
{ pincode: 277306, min_days: 2, max_days: 3 },
{ pincode: 277307, min_days: 2, max_days: 3 },
{ pincode: 277401, min_days: 2, max_days: 3 },
{ pincode: 277402, min_days: 2, max_days: 3 },
{ pincode: 277403, min_days: 2, max_days: 3 },
{ pincode: 277405, min_days: 2, max_days: 3 },
{ pincode: 277501, min_days: 2, max_days: 3 },
{ pincode: 277502, min_days: 2, max_days: 3 },
{ pincode: 277503, min_days: 2, max_days: 3 },
{ pincode: 277504, min_days: 2, max_days: 3 },
{ pincode: 277506, min_days: 2, max_days: 3 },
{ pincode: 281001, min_days: 2, max_days: 3 },
{ pincode: 281002, min_days: 2, max_days: 3 },
{ pincode: 281003, min_days: 2, max_days: 3 },
{ pincode: 281004, min_days: 2, max_days: 3 },
{ pincode: 281005, min_days: 2, max_days: 3 },
{ pincode: 281006, min_days: 2, max_days: 3 },
{ pincode: 281104, min_days: 2, max_days: 3 },
{ pincode: 281112, min_days: 2, max_days: 3 },
{ pincode: 281121, min_days: 2, max_days: 3 },
{ pincode: 281122, min_days: 2, max_days: 3 },
{ pincode: 281123, min_days: 2, max_days: 3 },
{ pincode: 281124, min_days: 2, max_days: 3 },
{ pincode: 281201, min_days: 2, max_days: 3 },
{ pincode: 281202, min_days: 2, max_days: 3 },
{ pincode: 281203, min_days: 2, max_days: 3 },
{ pincode: 281204, min_days: 2, max_days: 3 },
{ pincode: 281205, min_days: 2, max_days: 3 },
{ pincode: 281206, min_days: 2, max_days: 3 },
{ pincode: 281301, min_days: 2, max_days: 3 },
{ pincode: 281302, min_days: 2, max_days: 3 },
{ pincode: 281303, min_days: 2, max_days: 3 },
{ pincode: 281304, min_days: 2, max_days: 3 },
{ pincode: 281305, min_days: 2, max_days: 3 },
{ pincode: 281306, min_days: 2, max_days: 3 },
{ pincode: 281307, min_days: 2, max_days: 3 },
{ pincode: 281308, min_days: 2, max_days: 3 },
{ pincode: 281401, min_days: 2, max_days: 3 },
{ pincode: 281402, min_days: 2, max_days: 3 },
{ pincode: 281403, min_days: 2, max_days: 3 },
{ pincode: 281404, min_days: 2, max_days: 3 },
{ pincode: 281405, min_days: 2, max_days: 3 },
{ pincode: 281406, min_days: 2, max_days: 3 },
{ pincode: 281501, min_days: 2, max_days: 3 },
{ pincode: 281502, min_days: 2, max_days: 3 },
{ pincode: 281503, min_days: 2, max_days: 3 },
{ pincode: 281504, min_days: 2, max_days: 3 },
{ pincode: 282001, min_days: 2, max_days: 3 },
{ pincode: 282002, min_days: 2, max_days: 3 },
{ pincode: 282003, min_days: 2, max_days: 3 },
{ pincode: 282004, min_days: 2, max_days: 3 },
{ pincode: 282005, min_days: 2, max_days: 3 },
{ pincode: 282006, min_days: 2, max_days: 3 },
{ pincode: 282007, min_days: 2, max_days: 3 },
{ pincode: 282008, min_days: 2, max_days: 3 },
{ pincode: 282009, min_days: 2, max_days: 3 },
{ pincode: 282010, min_days: 2, max_days: 3 },
{ pincode: 283101, min_days: 2, max_days: 3 },
{ pincode: 283102, min_days: 2, max_days: 3 },
{ pincode: 283103, min_days: 2, max_days: 3 },
{ pincode: 283104, min_days: 2, max_days: 3 },
{ pincode: 283105, min_days: 2, max_days: 3 },
{ pincode: 283110, min_days: 2, max_days: 3 },
{ pincode: 283111, min_days: 2, max_days: 3 },
{ pincode: 283112, min_days: 2, max_days: 3 },
{ pincode: 283113, min_days: 2, max_days: 3 },
{ pincode: 283114, min_days: 2, max_days: 3 },
{ pincode: 283115, min_days: 2, max_days: 3 },
{ pincode: 283119, min_days: 2, max_days: 3 },
{ pincode: 283121, min_days: 2, max_days: 3 },
{ pincode: 283122, min_days: 2, max_days: 3 },
{ pincode: 283123, min_days: 2, max_days: 3 },
{ pincode: 283124, min_days: 2, max_days: 3 },
{ pincode: 283125, min_days: 2, max_days: 3 },
{ pincode: 283126, min_days: 2, max_days: 3 },
{ pincode: 283130, min_days: 2, max_days: 3 },
{ pincode: 283135, min_days: 2, max_days: 3 },
{ pincode: 283136, min_days: 2, max_days: 3 },
{ pincode: 283141, min_days: 2, max_days: 3 },
{ pincode: 283142, min_days: 2, max_days: 3 },
{ pincode: 283145, min_days: 2, max_days: 3 },
{ pincode: 283151, min_days: 2, max_days: 3 },
{ pincode: 283152, min_days: 2, max_days: 3 },
{ pincode: 283201, min_days: 2, max_days: 3 },
{ pincode: 283202, min_days: 2, max_days: 3 },
{ pincode: 283203, min_days: 2, max_days: 3 },
{ pincode: 283204, min_days: 2, max_days: 3 },
{ pincode: 283205, min_days: 2, max_days: 3 },
{ pincode: 283206, min_days: 2, max_days: 3 },
{ pincode: 283207, min_days: 2, max_days: 3 },
{ pincode: 284001, min_days: 2, max_days: 3 },
{ pincode: 284002, min_days: 2, max_days: 3 },
{ pincode: 284003, min_days: 2, max_days: 3 },
{ pincode: 284120, min_days: 2, max_days: 3 },
{ pincode: 284121, min_days: 2, max_days: 3 },
{ pincode: 284122, min_days: 2, max_days: 3 },
{ pincode: 284123, min_days: 2, max_days: 3 },
{ pincode: 284124, min_days: 2, max_days: 3 },
{ pincode: 284125, min_days: 2, max_days: 3 },
{ pincode: 284126, min_days: 2, max_days: 3 },
{ pincode: 284127, min_days: 2, max_days: 3 },
{ pincode: 284128, min_days: 2, max_days: 3 },
{ pincode: 284129, min_days: 2, max_days: 3 },
{ pincode: 284135, min_days: 2, max_days: 3 },
{ pincode: 284136, min_days: 2, max_days: 3 },
{ pincode: 284201, min_days: 2, max_days: 3 },
{ pincode: 284202, min_days: 2, max_days: 3 },
{ pincode: 284203, min_days: 2, max_days: 3 },
{ pincode: 284204, min_days: 2, max_days: 3 },
{ pincode: 284205, min_days: 2, max_days: 3 },
{ pincode: 284206, min_days: 2, max_days: 3 },
{ pincode: 284301, min_days: 2, max_days: 3 },
{ pincode: 284302, min_days: 2, max_days: 3 },
{ pincode: 284303, min_days: 2, max_days: 3 },
{ pincode: 284304, min_days: 2, max_days: 3 },
{ pincode: 284305, min_days: 2, max_days: 3 },
{ pincode: 284306, min_days: 2, max_days: 3 },
{ pincode: 284401, min_days: 2, max_days: 3 },
{ pincode: 284402, min_days: 2, max_days: 3 },
{ pincode: 284403, min_days: 2, max_days: 3 },
{ pincode: 284404, min_days: 2, max_days: 3 },
{ pincode: 284405, min_days: 2, max_days: 3 },
{ pincode: 284406, min_days: 2, max_days: 3 },
{ pincode: 284407, min_days: 2, max_days: 3 },
{ pincode: 284419, min_days: 2, max_days: 3 },
{ pincode: 284501, min_days: 2, max_days: 3 },
{ pincode: 285001, min_days: 2, max_days: 3 },
{ pincode: 285121, min_days: 2, max_days: 3 },
{ pincode: 285122, min_days: 2, max_days: 3 },
{ pincode: 285123, min_days: 2, max_days: 3 },
{ pincode: 285124, min_days: 2, max_days: 3 },
{ pincode: 285125, min_days: 2, max_days: 3 },
{ pincode: 285126, min_days: 2, max_days: 3 },
{ pincode: 285127, min_days: 2, max_days: 3 },
{ pincode: 285128, min_days: 2, max_days: 3 },
{ pincode: 285129, min_days: 2, max_days: 3 },
{ pincode: 285130, min_days: 2, max_days: 3 },
{ pincode: 285134, min_days: 2, max_days: 3 },
{ pincode: 285196, min_days: 2, max_days: 3 },
{ pincode: 285201, min_days: 2, max_days: 3 },
{ pincode: 285202, min_days: 2, max_days: 3 },
{ pincode: 285203, min_days: 2, max_days: 3 },
{ pincode: 285204, min_days: 2, max_days: 3 },
{ pincode: 285205, min_days: 2, max_days: 3 },
{ pincode: 285206, min_days: 2, max_days: 3 },
{ pincode: 285211, min_days: 2, max_days: 3 },
{ pincode: 285223, min_days: 2, max_days: 3 },
{ pincode: 285251, min_days: 2, max_days: 3 },
{ pincode: 288005, min_days: 2, max_days: 3 },
{ pincode: 301001, min_days: 2, max_days: 3 },
{ pincode: 301002, min_days: 2, max_days: 3 },
{ pincode: 301017, min_days: 2, max_days: 3 },
{ pincode: 301018, min_days: 2, max_days: 3 },
{ pincode: 301019, min_days: 2, max_days: 3 },
{ pincode: 301020, min_days: 2, max_days: 3 },
{ pincode: 301021, min_days: 2, max_days: 3 },
{ pincode: 301022, min_days: 2, max_days: 3 },
{ pincode: 301023, min_days: 2, max_days: 3 },
{ pincode: 301024, min_days: 2, max_days: 3 },
{ pincode: 301025, min_days: 2, max_days: 3 },
{ pincode: 301026, min_days: 2, max_days: 3 },
{ pincode: 301027, min_days: 2, max_days: 3 },
{ pincode: 301028, min_days: 2, max_days: 3 },
{ pincode: 301029, min_days: 2, max_days: 3 },
{ pincode: 301030, min_days: 2, max_days: 3 },
{ pincode: 301031, min_days: 2, max_days: 3 },
{ pincode: 301032, min_days: 2, max_days: 3 },
{ pincode: 301033, min_days: 2, max_days: 3 },
{ pincode: 301034, min_days: 2, max_days: 3 },
{ pincode: 301035, min_days: 2, max_days: 3 },
{ pincode: 301036, min_days: 2, max_days: 3 },
{ pincode: 301042, min_days: 2, max_days: 3 },
{ pincode: 301044, min_days: 2, max_days: 3 },
{ pincode: 301101, min_days: 2, max_days: 3 },
{ pincode: 301160, min_days: 2, max_days: 3 },
{ pincode: 301301, min_days: 2, max_days: 3 },
{ pincode: 301401, min_days: 2, max_days: 3 },
{ pincode: 301402, min_days: 2, max_days: 3 },
{ pincode: 301403, min_days: 2, max_days: 3 },
{ pincode: 301404, min_days: 2, max_days: 3 },
{ pincode: 301405, min_days: 2, max_days: 3 },
{ pincode: 301406, min_days: 2, max_days: 3 },
{ pincode: 301407, min_days: 2, max_days: 3 },
{ pincode: 301408, min_days: 2, max_days: 3 },
{ pincode: 301409, min_days: 2, max_days: 3 },
{ pincode: 301410, min_days: 2, max_days: 3 },
{ pincode: 301411, min_days: 2, max_days: 3 },
{ pincode: 301412, min_days: 2, max_days: 3 },
{ pincode: 301413, min_days: 2, max_days: 3 },
{ pincode: 301414, min_days: 2, max_days: 3 },
{ pincode: 301415, min_days: 2, max_days: 3 },
{ pincode: 301416, min_days: 2, max_days: 3 },
{ pincode: 301417, min_days: 2, max_days: 3 },
{ pincode: 301418, min_days: 2, max_days: 3 },
{ pincode: 301419, min_days: 2, max_days: 3 },
{ pincode: 301421, min_days: 2, max_days: 3 },
{ pincode: 301422, min_days: 2, max_days: 3 },
{ pincode: 301424, min_days: 2, max_days: 3 },
{ pincode: 301426, min_days: 2, max_days: 3 },
{ pincode: 301427, min_days: 2, max_days: 3 },
{ pincode: 301604, min_days: 2, max_days: 3 },
{ pincode: 301607, min_days: 2, max_days: 3 },
{ pincode: 301701, min_days: 2, max_days: 3 },
{ pincode: 301702, min_days: 2, max_days: 3 },
{ pincode: 301703, min_days: 2, max_days: 3 },
{ pincode: 301704, min_days: 2, max_days: 3 },
{ pincode: 301705, min_days: 2, max_days: 3 },
{ pincode: 301706, min_days: 2, max_days: 3 },
{ pincode: 301707, min_days: 2, max_days: 3 },
{ pincode: 301708, min_days: 2, max_days: 3 },
{ pincode: 301709, min_days: 2, max_days: 3 },
{ pincode: 301711, min_days: 2, max_days: 3 },
{ pincode: 301712, min_days: 2, max_days: 3 },
{ pincode: 301713, min_days: 2, max_days: 3 },
{ pincode: 301714, min_days: 2, max_days: 3 },
{ pincode: 302000, min_days: 2, max_days: 3 },
{ pincode: 302001, min_days: 2, max_days: 3 },
{ pincode: 302002, min_days: 2, max_days: 3 },
{ pincode: 302003, min_days: 2, max_days: 3 },
{ pincode: 302004, min_days: 2, max_days: 3 },
{ pincode: 302005, min_days: 2, max_days: 3 },
{ pincode: 302006, min_days: 2, max_days: 3 },
{ pincode: 302007, min_days: 2, max_days: 3 },
{ pincode: 302008, min_days: 2, max_days: 3 },
{ pincode: 302009, min_days: 2, max_days: 3 },
{ pincode: 302010, min_days: 2, max_days: 3 },
{ pincode: 302011, min_days: 2, max_days: 3 },
{ pincode: 302012, min_days: 2, max_days: 3 },
{ pincode: 302013, min_days: 2, max_days: 3 },
{ pincode: 302014, min_days: 2, max_days: 3 },
{ pincode: 302015, min_days: 2, max_days: 3 },
{ pincode: 302016, min_days: 2, max_days: 3 },
{ pincode: 302017, min_days: 2, max_days: 3 },
{ pincode: 302018, min_days: 2, max_days: 3 },
{ pincode: 302019, min_days: 2, max_days: 3 },
{ pincode: 302020, min_days: 2, max_days: 3 },
{ pincode: 302021, min_days: 2, max_days: 3 },
{ pincode: 302022, min_days: 2, max_days: 3 },
{ pincode: 302023, min_days: 2, max_days: 3 },
{ pincode: 302024, min_days: 2, max_days: 3 },
{ pincode: 302025, min_days: 2, max_days: 3 },
{ pincode: 302026, min_days: 2, max_days: 3 },
{ pincode: 302027, min_days: 2, max_days: 3 },
{ pincode: 302028, min_days: 2, max_days: 3 },
{ pincode: 302029, min_days: 2, max_days: 3 },
{ pincode: 302030, min_days: 2, max_days: 3 },
{ pincode: 302031, min_days: 2, max_days: 3 },
{ pincode: 302032, min_days: 2, max_days: 3 },
{ pincode: 302033, min_days: 2, max_days: 3 },
{ pincode: 302034, min_days: 2, max_days: 3 },
{ pincode: 302035, min_days: 2, max_days: 3 },
{ pincode: 302036, min_days: 2, max_days: 3 },
{ pincode: 302037, min_days: 2, max_days: 3 },
{ pincode: 302038, min_days: 2, max_days: 3 },
{ pincode: 302039, min_days: 2, max_days: 3 },
{ pincode: 302040, min_days: 2, max_days: 3 },
{ pincode: 302041, min_days: 2, max_days: 3 },
{ pincode: 302042, min_days: 2, max_days: 3 },
{ pincode: 302043, min_days: 2, max_days: 3 },
{ pincode: 302044, min_days: 2, max_days: 3 },
{ pincode: 302046, min_days: 2, max_days: 3 },
{ pincode: 302047, min_days: 2, max_days: 3 },
{ pincode: 302048, min_days: 2, max_days: 3 },
{ pincode: 302049, min_days: 2, max_days: 3 },
{ pincode: 302051, min_days: 2, max_days: 3 },
{ pincode: 302052, min_days: 2, max_days: 3 },
{ pincode: 302053, min_days: 2, max_days: 3 },
{ pincode: 302054, min_days: 2, max_days: 3 },
{ pincode: 302055, min_days: 2, max_days: 3 },
{ pincode: 302103, min_days: 2, max_days: 3 },
{ pincode: 303001, min_days: 2, max_days: 3 },
{ pincode: 303002, min_days: 2, max_days: 3 },
{ pincode: 303003, min_days: 2, max_days: 3 },
{ pincode: 303004, min_days: 2, max_days: 3 },
{ pincode: 303005, min_days: 2, max_days: 3 },
{ pincode: 303006, min_days: 2, max_days: 3 },
{ pincode: 303007, min_days: 2, max_days: 3 },
{ pincode: 303008, min_days: 2, max_days: 3 },
{ pincode: 303009, min_days: 2, max_days: 3 },
{ pincode: 303010, min_days: 2, max_days: 3 },
{ pincode: 303011, min_days: 2, max_days: 3 },
{ pincode: 303012, min_days: 2, max_days: 3 },
{ pincode: 303101, min_days: 2, max_days: 3 },
{ pincode: 303102, min_days: 2, max_days: 3 },
{ pincode: 303103, min_days: 2, max_days: 3 },
{ pincode: 303104, min_days: 2, max_days: 3 },
{ pincode: 303105, min_days: 2, max_days: 3 },
{ pincode: 303106, min_days: 2, max_days: 3 },
{ pincode: 303107, min_days: 2, max_days: 3 },
{ pincode: 303108, min_days: 2, max_days: 3 },
{ pincode: 303109, min_days: 2, max_days: 3 },
{ pincode: 303110, min_days: 2, max_days: 3 },
{ pincode: 303112, min_days: 2, max_days: 3 },
{ pincode: 303113, min_days: 2, max_days: 3 },
{ pincode: 303114, min_days: 2, max_days: 3 },
{ pincode: 303115, min_days: 2, max_days: 3 },
{ pincode: 303116, min_days: 2, max_days: 3 },
{ pincode: 303117, min_days: 2, max_days: 3 },
{ pincode: 303118, min_days: 2, max_days: 3 },
{ pincode: 303119, min_days: 2, max_days: 3 },
{ pincode: 303120, min_days: 2, max_days: 3 },
{ pincode: 303121, min_days: 2, max_days: 3 },
{ pincode: 303122, min_days: 2, max_days: 3 },
{ pincode: 303123, min_days: 2, max_days: 3 },
{ pincode: 303124, min_days: 2, max_days: 3 },
{ pincode: 303209, min_days: 2, max_days: 3 },
{ pincode: 303301, min_days: 2, max_days: 3 },
{ pincode: 303302, min_days: 2, max_days: 3 },
{ pincode: 303303, min_days: 2, max_days: 3 },
{ pincode: 303304, min_days: 2, max_days: 3 },
{ pincode: 303305, min_days: 2, max_days: 3 },
{ pincode: 303306, min_days: 2, max_days: 3 },
{ pincode: 303307, min_days: 2, max_days: 3 },
{ pincode: 303308, min_days: 2, max_days: 3 },
{ pincode: 303310, min_days: 2, max_days: 3 },
{ pincode: 303313, min_days: 2, max_days: 3 },
{ pincode: 303314, min_days: 2, max_days: 3 },
{ pincode: 303315, min_days: 2, max_days: 3 },
{ pincode: 303323, min_days: 2, max_days: 3 },
{ pincode: 303324, min_days: 2, max_days: 3 },
{ pincode: 303325, min_days: 2, max_days: 3 },
{ pincode: 303326, min_days: 2, max_days: 3 },
{ pincode: 303327, min_days: 2, max_days: 3 },
{ pincode: 303328, min_days: 2, max_days: 3 },
{ pincode: 303329, min_days: 2, max_days: 3 },
{ pincode: 303330, min_days: 2, max_days: 3 },
{ pincode: 303331, min_days: 2, max_days: 3 },
{ pincode: 303338, min_days: 2, max_days: 3 },
{ pincode: 303339, min_days: 2, max_days: 3 },
{ pincode: 303340, min_days: 2, max_days: 3 },
{ pincode: 303348, min_days: 2, max_days: 3 },
{ pincode: 303501, min_days: 2, max_days: 3 },
{ pincode: 303502, min_days: 2, max_days: 3 },
{ pincode: 303503, min_days: 2, max_days: 3 },
{ pincode: 303504, min_days: 2, max_days: 3 },
{ pincode: 303505, min_days: 2, max_days: 3 },
{ pincode: 303506, min_days: 2, max_days: 3 },
{ pincode: 303507, min_days: 2, max_days: 3 },
{ pincode: 303508, min_days: 2, max_days: 3 },
{ pincode: 303509, min_days: 2, max_days: 3 },
{ pincode: 303510, min_days: 2, max_days: 3 },
{ pincode: 303511, min_days: 2, max_days: 3 },
{ pincode: 303601, min_days: 2, max_days: 3 },
{ pincode: 303602, min_days: 2, max_days: 3 },
{ pincode: 303603, min_days: 2, max_days: 3 },
{ pincode: 303604, min_days: 2, max_days: 3 },
{ pincode: 303610, min_days: 2, max_days: 3 },
{ pincode: 303701, min_days: 2, max_days: 3 },
{ pincode: 303702, min_days: 2, max_days: 3 },
{ pincode: 303703, min_days: 2, max_days: 3 },
{ pincode: 303704, min_days: 2, max_days: 3 },
{ pincode: 303705, min_days: 2, max_days: 3 },
{ pincode: 303706, min_days: 2, max_days: 3 },
{ pincode: 303712, min_days: 2, max_days: 3 },
{ pincode: 303801, min_days: 2, max_days: 3 },
{ pincode: 303802, min_days: 2, max_days: 3 },
{ pincode: 303803, min_days: 2, max_days: 3 },
{ pincode: 303804, min_days: 2, max_days: 3 },
{ pincode: 303805, min_days: 2, max_days: 3 },
{ pincode: 303806, min_days: 2, max_days: 3 },
{ pincode: 303807, min_days: 2, max_days: 3 },
{ pincode: 303901, min_days: 2, max_days: 3 },
{ pincode: 303902, min_days: 2, max_days: 3 },
{ pincode: 303903, min_days: 2, max_days: 3 },
{ pincode: 303904, min_days: 2, max_days: 3 },
{ pincode: 303905, min_days: 2, max_days: 3 },
{ pincode: 303906, min_days: 2, max_days: 3 },
{ pincode: 303907, min_days: 2, max_days: 3 },
{ pincode: 303908, min_days: 2, max_days: 3 },
{ pincode: 304001, min_days: 2, max_days: 3 },
{ pincode: 304005, min_days: 2, max_days: 3 },
{ pincode: 304020, min_days: 2, max_days: 3 },
{ pincode: 304021, min_days: 2, max_days: 3 },
{ pincode: 304022, min_days: 2, max_days: 3 },
{ pincode: 304023, min_days: 2, max_days: 3 },
{ pincode: 304024, min_days: 2, max_days: 3 },
{ pincode: 304025, min_days: 2, max_days: 3 },
{ pincode: 304026, min_days: 2, max_days: 3 },
{ pincode: 304501, min_days: 2, max_days: 3 },
{ pincode: 304502, min_days: 2, max_days: 3 },
{ pincode: 304503, min_days: 2, max_days: 3 },
{ pincode: 304504, min_days: 2, max_days: 3 },
{ pincode: 304505, min_days: 2, max_days: 3 },
{ pincode: 304507, min_days: 2, max_days: 3 },
{ pincode: 304801, min_days: 2, max_days: 3 },
{ pincode: 304802, min_days: 2, max_days: 3 },
{ pincode: 304803, min_days: 2, max_days: 3 },
{ pincode: 304804, min_days: 2, max_days: 3 },
{ pincode: 304805, min_days: 2, max_days: 3 },
{ pincode: 304807, min_days: 2, max_days: 3 },
{ pincode: 305001, min_days: 2, max_days: 3 },
{ pincode: 305002, min_days: 2, max_days: 3 },
{ pincode: 305003, min_days: 2, max_days: 3 },
{ pincode: 305004, min_days: 2, max_days: 3 },
{ pincode: 305005, min_days: 2, max_days: 3 },
{ pincode: 305006, min_days: 2, max_days: 3 },
{ pincode: 305007, min_days: 2, max_days: 3 },
{ pincode: 305008, min_days: 2, max_days: 3 },
{ pincode: 305009, min_days: 2, max_days: 3 },
{ pincode: 305011, min_days: 2, max_days: 3 },
{ pincode: 305012, min_days: 2, max_days: 3 },
{ pincode: 305021, min_days: 2, max_days: 3 },
{ pincode: 305022, min_days: 2, max_days: 3 },
{ pincode: 305023, min_days: 2, max_days: 3 },
{ pincode: 305024, min_days: 2, max_days: 3 },
{ pincode: 305025, min_days: 2, max_days: 3 },
{ pincode: 305026, min_days: 2, max_days: 3 },
{ pincode: 305201, min_days: 2, max_days: 3 },
{ pincode: 305202, min_days: 2, max_days: 3 },
{ pincode: 305203, min_days: 2, max_days: 3 },
{ pincode: 305204, min_days: 2, max_days: 3 },
{ pincode: 305205, min_days: 2, max_days: 3 },
{ pincode: 305206, min_days: 2, max_days: 3 },
{ pincode: 305207, min_days: 2, max_days: 3 },
{ pincode: 305401, min_days: 2, max_days: 3 },
{ pincode: 305402, min_days: 2, max_days: 3 },
{ pincode: 305403, min_days: 2, max_days: 3 },
{ pincode: 305404, min_days: 2, max_days: 3 },
{ pincode: 305405, min_days: 2, max_days: 3 },
{ pincode: 305406, min_days: 2, max_days: 3 },
{ pincode: 305407, min_days: 2, max_days: 3 },
{ pincode: 305408, min_days: 2, max_days: 3 },
{ pincode: 305412, min_days: 2, max_days: 3 },
{ pincode: 305415, min_days: 2, max_days: 3 },
{ pincode: 305601, min_days: 2, max_days: 3 },
{ pincode: 305621, min_days: 2, max_days: 3 },
{ pincode: 305622, min_days: 2, max_days: 3 },
{ pincode: 305623, min_days: 2, max_days: 3 },
{ pincode: 305624, min_days: 2, max_days: 3 },
{ pincode: 305625, min_days: 2, max_days: 3 },
{ pincode: 305627, min_days: 2, max_days: 3 },
{ pincode: 305628, min_days: 2, max_days: 3 },
{ pincode: 305629, min_days: 2, max_days: 3 },
{ pincode: 305630, min_days: 2, max_days: 3 },
{ pincode: 305631, min_days: 2, max_days: 3 },
{ pincode: 305801, min_days: 2, max_days: 3 },
{ pincode: 305802, min_days: 2, max_days: 3 },
{ pincode: 305805, min_days: 2, max_days: 3 },
{ pincode: 305811, min_days: 2, max_days: 3 },
{ pincode: 305812, min_days: 2, max_days: 3 },
{ pincode: 305813, min_days: 2, max_days: 3 },
{ pincode: 305814, min_days: 2, max_days: 3 },
{ pincode: 305815, min_days: 2, max_days: 3 },
{ pincode: 305816, min_days: 2, max_days: 3 },
{ pincode: 305817, min_days: 2, max_days: 3 },
{ pincode: 305819, min_days: 2, max_days: 3 },
{ pincode: 305820, min_days: 2, max_days: 3 },
{ pincode: 305901, min_days: 2, max_days: 3 },
{ pincode: 305921, min_days: 2, max_days: 3 },
{ pincode: 305922, min_days: 2, max_days: 3 },
{ pincode: 305923, min_days: 2, max_days: 3 },
{ pincode: 305924, min_days: 2, max_days: 3 },
{ pincode: 305925, min_days: 2, max_days: 3 },
{ pincode: 305926, min_days: 2, max_days: 3 },
{ pincode: 305927, min_days: 2, max_days: 3 },
{ pincode: 305929, min_days: 2, max_days: 3 },
{ pincode: 306001, min_days: 2, max_days: 3 },
{ pincode: 306021, min_days: 2, max_days: 3 },
{ pincode: 306022, min_days: 2, max_days: 3 },
{ pincode: 306023, min_days: 2, max_days: 3 },
{ pincode: 306027, min_days: 2, max_days: 3 },
{ pincode: 306101, min_days: 2, max_days: 3 },
{ pincode: 306102, min_days: 2, max_days: 3 },
{ pincode: 306103, min_days: 2, max_days: 3 },
{ pincode: 306104, min_days: 2, max_days: 3 },
{ pincode: 306105, min_days: 2, max_days: 3 },
{ pincode: 306106, min_days: 2, max_days: 3 },
{ pincode: 306107, min_days: 2, max_days: 3 },
{ pincode: 306114, min_days: 2, max_days: 3 },
{ pincode: 306115, min_days: 2, max_days: 3 },
{ pincode: 306116, min_days: 2, max_days: 3 },
{ pincode: 306119, min_days: 2, max_days: 3 },
{ pincode: 306126, min_days: 2, max_days: 3 },
{ pincode: 306301, min_days: 2, max_days: 3 },
{ pincode: 306302, min_days: 2, max_days: 3 },
{ pincode: 306303, min_days: 2, max_days: 3 },
{ pincode: 306304, min_days: 2, max_days: 3 },
{ pincode: 306305, min_days: 2, max_days: 3 },
{ pincode: 306306, min_days: 2, max_days: 3 },
{ pincode: 306307, min_days: 2, max_days: 3 },
{ pincode: 306308, min_days: 2, max_days: 3 },
{ pincode: 306401, min_days: 2, max_days: 3 },
{ pincode: 306421, min_days: 2, max_days: 3 },
{ pincode: 306422, min_days: 2, max_days: 3 },
{ pincode: 306501, min_days: 2, max_days: 3 },
{ pincode: 306502, min_days: 2, max_days: 3 },
{ pincode: 306503, min_days: 2, max_days: 3 },
{ pincode: 306504, min_days: 2, max_days: 3 },
{ pincode: 306601, min_days: 2, max_days: 3 },
{ pincode: 306602, min_days: 2, max_days: 3 },
{ pincode: 306603, min_days: 2, max_days: 3 },
{ pincode: 306701, min_days: 2, max_days: 3 },
{ pincode: 306702, min_days: 2, max_days: 3 },
{ pincode: 306703, min_days: 2, max_days: 3 },
{ pincode: 306704, min_days: 2, max_days: 3 },
{ pincode: 306705, min_days: 2, max_days: 3 },
{ pincode: 306706, min_days: 2, max_days: 3 },
{ pincode: 306707, min_days: 2, max_days: 3 },
{ pincode: 306708, min_days: 2, max_days: 3 },
{ pincode: 306709, min_days: 2, max_days: 3 },
{ pincode: 306901, min_days: 2, max_days: 3 },
{ pincode: 306902, min_days: 2, max_days: 3 },
{ pincode: 306912, min_days: 2, max_days: 3 },
{ pincode: 307001, min_days: 2, max_days: 3 },
{ pincode: 307019, min_days: 2, max_days: 3 },
{ pincode: 307020, min_days: 2, max_days: 3 },
{ pincode: 307021, min_days: 2, max_days: 3 },
{ pincode: 307022, min_days: 2, max_days: 3 },
{ pincode: 307023, min_days: 2, max_days: 3 },
{ pincode: 307024, min_days: 2, max_days: 3 },
{ pincode: 307025, min_days: 2, max_days: 3 },
{ pincode: 307026, min_days: 2, max_days: 3 },
{ pincode: 307027, min_days: 2, max_days: 3 },
{ pincode: 307028, min_days: 2, max_days: 3 },
{ pincode: 307029, min_days: 2, max_days: 3 },
{ pincode: 307030, min_days: 2, max_days: 3 },
{ pincode: 307031, min_days: 2, max_days: 3 },
{ pincode: 307032, min_days: 2, max_days: 3 },
{ pincode: 307033, min_days: 2, max_days: 3 },
{ pincode: 307043, min_days: 2, max_days: 3 },
{ pincode: 307501, min_days: 2, max_days: 3 },
{ pincode: 307510, min_days: 2, max_days: 3 },
{ pincode: 307511, min_days: 2, max_days: 3 },
{ pincode: 307512, min_days: 2, max_days: 3 },
{ pincode: 307513, min_days: 2, max_days: 3 },
{ pincode: 307514, min_days: 2, max_days: 3 },
{ pincode: 307515, min_days: 2, max_days: 3 },
{ pincode: 307526, min_days: 2, max_days: 3 },
{ pincode: 307801, min_days: 2, max_days: 3 },
{ pincode: 307802, min_days: 2, max_days: 3 },
{ pincode: 307803, min_days: 2, max_days: 3 },
{ pincode: 310001, min_days: 2, max_days: 3 },
{ pincode: 311001, min_days: 2, max_days: 3 },
{ pincode: 311011, min_days: 2, max_days: 3 },
{ pincode: 311012, min_days: 2, max_days: 3 },
{ pincode: 311013, min_days: 2, max_days: 3 },
{ pincode: 311020, min_days: 2, max_days: 3 },
{ pincode: 311021, min_days: 2, max_days: 3 },
{ pincode: 311022, min_days: 2, max_days: 3 },
{ pincode: 311023, min_days: 2, max_days: 3 },
{ pincode: 311024, min_days: 2, max_days: 3 },
{ pincode: 311025, min_days: 2, max_days: 3 },
{ pincode: 311026, min_days: 2, max_days: 3 },
{ pincode: 311028, min_days: 2, max_days: 3 },
{ pincode: 311029, min_days: 2, max_days: 3 },
{ pincode: 311030, min_days: 2, max_days: 3 },
{ pincode: 311201, min_days: 2, max_days: 3 },
{ pincode: 311202, min_days: 2, max_days: 3 },
{ pincode: 311203, min_days: 2, max_days: 3 },
{ pincode: 311204, min_days: 2, max_days: 3 },
{ pincode: 311301, min_days: 2, max_days: 3 },
{ pincode: 311302, min_days: 2, max_days: 3 },
{ pincode: 311303, min_days: 2, max_days: 3 },
{ pincode: 311401, min_days: 2, max_days: 3 },
{ pincode: 311402, min_days: 2, max_days: 3 },
{ pincode: 311403, min_days: 2, max_days: 3 },
{ pincode: 311404, min_days: 2, max_days: 3 },
{ pincode: 311405, min_days: 2, max_days: 3 },
{ pincode: 311407, min_days: 2, max_days: 3 },
{ pincode: 311408, min_days: 2, max_days: 3 },
{ pincode: 311601, min_days: 2, max_days: 3 },
{ pincode: 311602, min_days: 2, max_days: 3 },
{ pincode: 311603, min_days: 2, max_days: 3 },
{ pincode: 311604, min_days: 2, max_days: 3 },
{ pincode: 311605, min_days: 2, max_days: 3 },
{ pincode: 311606, min_days: 2, max_days: 3 },
{ pincode: 311801, min_days: 2, max_days: 3 },
{ pincode: 311802, min_days: 2, max_days: 3 },
{ pincode: 311803, min_days: 2, max_days: 3 },
{ pincode: 311804, min_days: 2, max_days: 3 },
{ pincode: 311805, min_days: 2, max_days: 3 },
{ pincode: 311806, min_days: 2, max_days: 3 },
{ pincode: 312000, min_days: 2, max_days: 3 },
{ pincode: 312001, min_days: 2, max_days: 3 },
{ pincode: 312002, min_days: 2, max_days: 3 },
{ pincode: 312021, min_days: 2, max_days: 3 },
{ pincode: 312022, min_days: 2, max_days: 3 },
{ pincode: 312023, min_days: 2, max_days: 3 },
{ pincode: 312024, min_days: 2, max_days: 3 },
{ pincode: 312025, min_days: 2, max_days: 3 },
{ pincode: 312027, min_days: 2, max_days: 3 },
{ pincode: 312201, min_days: 2, max_days: 3 },
{ pincode: 312202, min_days: 2, max_days: 3 },
{ pincode: 312203, min_days: 2, max_days: 3 },
{ pincode: 312204, min_days: 2, max_days: 3 },
{ pincode: 312205, min_days: 2, max_days: 3 },
{ pincode: 312206, min_days: 2, max_days: 3 },
{ pincode: 312207, min_days: 2, max_days: 3 },
{ pincode: 312401, min_days: 2, max_days: 3 },
{ pincode: 312402, min_days: 2, max_days: 3 },
{ pincode: 312403, min_days: 2, max_days: 3 },
{ pincode: 312404, min_days: 2, max_days: 3 },
{ pincode: 312601, min_days: 2, max_days: 3 },
{ pincode: 312602, min_days: 2, max_days: 3 },
{ pincode: 312603, min_days: 2, max_days: 3 },
{ pincode: 312604, min_days: 2, max_days: 3 },
{ pincode: 312605, min_days: 2, max_days: 3 },
{ pincode: 312606, min_days: 2, max_days: 3 },
{ pincode: 312612, min_days: 2, max_days: 3 },
{ pincode: 312613, min_days: 2, max_days: 3 },
{ pincode: 312614, min_days: 2, max_days: 3 },
{ pincode: 312615, min_days: 2, max_days: 3 },
{ pincode: 312616, min_days: 2, max_days: 3 },
{ pincode: 312617, min_days: 2, max_days: 3 },
{ pincode: 312618, min_days: 2, max_days: 3 },
{ pincode: 312619, min_days: 2, max_days: 3 },
{ pincode: 312620, min_days: 2, max_days: 3 },
{ pincode: 312621, min_days: 2, max_days: 3 },
{ pincode: 312622, min_days: 2, max_days: 3 },
{ pincode: 312623, min_days: 2, max_days: 3 },
{ pincode: 312624, min_days: 2, max_days: 3 },
{ pincode: 312625, min_days: 2, max_days: 3 },
{ pincode: 312626, min_days: 2, max_days: 3 },
{ pincode: 312627, min_days: 2, max_days: 3 },
{ pincode: 312901, min_days: 2, max_days: 3 },
{ pincode: 312902, min_days: 2, max_days: 3 },
{ pincode: 313001, min_days: 2, max_days: 3 },
{ pincode: 313002, min_days: 2, max_days: 3 },
{ pincode: 313003, min_days: 2, max_days: 3 },
{ pincode: 313004, min_days: 2, max_days: 3 },
{ pincode: 313011, min_days: 2, max_days: 3 },
{ pincode: 313012, min_days: 2, max_days: 3 },
{ pincode: 313013, min_days: 2, max_days: 3 },
{ pincode: 313014, min_days: 2, max_days: 3 },
{ pincode: 313015, min_days: 2, max_days: 3 },
{ pincode: 313016, min_days: 2, max_days: 3 },
{ pincode: 313021, min_days: 2, max_days: 3 },
{ pincode: 313022, min_days: 2, max_days: 3 },
{ pincode: 313024, min_days: 2, max_days: 3 },
{ pincode: 313025, min_days: 2, max_days: 3 },
{ pincode: 313026, min_days: 2, max_days: 3 },
{ pincode: 313027, min_days: 2, max_days: 3 },
{ pincode: 313031, min_days: 2, max_days: 3 },
{ pincode: 313033, min_days: 2, max_days: 3 },
{ pincode: 313038, min_days: 2, max_days: 3 },
{ pincode: 313201, min_days: 2, max_days: 3 },
{ pincode: 313202, min_days: 2, max_days: 3 },
{ pincode: 313203, min_days: 2, max_days: 3 },
{ pincode: 313204, min_days: 2, max_days: 3 },
{ pincode: 313205, min_days: 2, max_days: 3 },
{ pincode: 313206, min_days: 2, max_days: 3 },
{ pincode: 313207, min_days: 2, max_days: 3 },
{ pincode: 313211, min_days: 2, max_days: 3 },
{ pincode: 313301, min_days: 2, max_days: 3 },
{ pincode: 313303, min_days: 2, max_days: 3 },
{ pincode: 313321, min_days: 2, max_days: 3 },
{ pincode: 313322, min_days: 2, max_days: 3 },
{ pincode: 313323, min_days: 2, max_days: 3 },
{ pincode: 313324, min_days: 2, max_days: 3 },
{ pincode: 313325, min_days: 2, max_days: 3 },
{ pincode: 313326, min_days: 2, max_days: 3 },
{ pincode: 313327, min_days: 2, max_days: 3 },
{ pincode: 313328, min_days: 2, max_days: 3 },
{ pincode: 313329, min_days: 2, max_days: 3 },
{ pincode: 313330, min_days: 2, max_days: 3 },
{ pincode: 313331, min_days: 2, max_days: 3 },
{ pincode: 313332, min_days: 2, max_days: 3 },
{ pincode: 313333, min_days: 2, max_days: 3 },
{ pincode: 313334, min_days: 2, max_days: 3 },
{ pincode: 313338, min_days: 2, max_days: 3 },
{ pincode: 313341, min_days: 2, max_days: 3 },
{ pincode: 313342, min_days: 2, max_days: 3 },
{ pincode: 313601, min_days: 2, max_days: 3 },
{ pincode: 313602, min_days: 2, max_days: 3 },
{ pincode: 313603, min_days: 2, max_days: 3 },
{ pincode: 313604, min_days: 2, max_days: 3 },
{ pincode: 313605, min_days: 2, max_days: 3 },
{ pincode: 313608, min_days: 2, max_days: 3 },
{ pincode: 313611, min_days: 2, max_days: 3 },
{ pincode: 313701, min_days: 2, max_days: 3 },
{ pincode: 313702, min_days: 2, max_days: 3 },
{ pincode: 313703, min_days: 2, max_days: 3 },
{ pincode: 313704, min_days: 2, max_days: 3 },
{ pincode: 313705, min_days: 2, max_days: 3 },
{ pincode: 313706, min_days: 2, max_days: 3 },
{ pincode: 313708, min_days: 2, max_days: 3 },
{ pincode: 313801, min_days: 2, max_days: 3 },
{ pincode: 313802, min_days: 2, max_days: 3 },
{ pincode: 313803, min_days: 2, max_days: 3 },
{ pincode: 313804, min_days: 2, max_days: 3 },
{ pincode: 313805, min_days: 2, max_days: 3 },
{ pincode: 313806, min_days: 2, max_days: 3 },
{ pincode: 313901, min_days: 2, max_days: 3 },
{ pincode: 313902, min_days: 2, max_days: 3 },
{ pincode: 313903, min_days: 2, max_days: 3 },
{ pincode: 313904, min_days: 2, max_days: 3 },
{ pincode: 313905, min_days: 2, max_days: 3 },
{ pincode: 313906, min_days: 2, max_days: 3 },
{ pincode: 314001, min_days: 2, max_days: 3 },
{ pincode: 314011, min_days: 2, max_days: 3 },
{ pincode: 314021, min_days: 2, max_days: 3 },
{ pincode: 314022, min_days: 2, max_days: 3 },
{ pincode: 314023, min_days: 2, max_days: 3 },
{ pincode: 314024, min_days: 2, max_days: 3 },
{ pincode: 314025, min_days: 2, max_days: 3 },
{ pincode: 314026, min_days: 2, max_days: 3 },
{ pincode: 314027, min_days: 2, max_days: 3 },
{ pincode: 314028, min_days: 2, max_days: 3 },
{ pincode: 314029, min_days: 2, max_days: 3 },
{ pincode: 314030, min_days: 2, max_days: 3 },
{ pincode: 314031, min_days: 2, max_days: 3 },
{ pincode: 314032, min_days: 2, max_days: 3 },
{ pincode: 314034, min_days: 2, max_days: 3 },
{ pincode: 314035, min_days: 2, max_days: 3 },
{ pincode: 314036, min_days: 2, max_days: 3 },
{ pincode: 314037, min_days: 2, max_days: 3 },
{ pincode: 314038, min_days: 2, max_days: 3 },
{ pincode: 314401, min_days: 2, max_days: 3 },
{ pincode: 314402, min_days: 2, max_days: 3 },
{ pincode: 314403, min_days: 2, max_days: 3 },
{ pincode: 314404, min_days: 2, max_days: 3 },
{ pincode: 314406, min_days: 2, max_days: 3 },
{ pincode: 314801, min_days: 2, max_days: 3 },
{ pincode: 314804, min_days: 2, max_days: 3 },
{ pincode: 320006, min_days: 2, max_days: 3 },
{ pincode: 320008, min_days: 2, max_days: 3 },
{ pincode: 321001, min_days: 2, max_days: 3 },
{ pincode: 321006, min_days: 2, max_days: 3 },
{ pincode: 321021, min_days: 2, max_days: 3 },
{ pincode: 321022, min_days: 2, max_days: 3 },
{ pincode: 321023, min_days: 2, max_days: 3 },
{ pincode: 321024, min_days: 2, max_days: 3 },
{ pincode: 321025, min_days: 2, max_days: 3 },
{ pincode: 321026, min_days: 2, max_days: 3 },
{ pincode: 321028, min_days: 2, max_days: 3 },
{ pincode: 321035, min_days: 2, max_days: 3 },
{ pincode: 321201, min_days: 2, max_days: 3 },
{ pincode: 321202, min_days: 2, max_days: 3 },
{ pincode: 321203, min_days: 2, max_days: 3 },
{ pincode: 321204, min_days: 2, max_days: 3 },
{ pincode: 321205, min_days: 2, max_days: 3 },
{ pincode: 321206, min_days: 2, max_days: 3 },
{ pincode: 321209, min_days: 2, max_days: 3 },
{ pincode: 321301, min_days: 2, max_days: 3 },
{ pincode: 321302, min_days: 2, max_days: 3 },
{ pincode: 321303, min_days: 2, max_days: 3 },
{ pincode: 321305, min_days: 2, max_days: 3 },
{ pincode: 321401, min_days: 2, max_days: 3 },
{ pincode: 321402, min_days: 2, max_days: 3 },
{ pincode: 321403, min_days: 2, max_days: 3 },
{ pincode: 321404, min_days: 2, max_days: 3 },
{ pincode: 321405, min_days: 2, max_days: 3 },
{ pincode: 321406, min_days: 2, max_days: 3 },
{ pincode: 321407, min_days: 2, max_days: 3 },
{ pincode: 321408, min_days: 2, max_days: 3 },
{ pincode: 321409, min_days: 2, max_days: 3 },
{ pincode: 321410, min_days: 2, max_days: 3 },
{ pincode: 321411, min_days: 2, max_days: 3 },
{ pincode: 321412, min_days: 2, max_days: 3 },
{ pincode: 321413, min_days: 2, max_days: 3 },
{ pincode: 321414, min_days: 2, max_days: 3 },
{ pincode: 321415, min_days: 2, max_days: 3 },
{ pincode: 321416, min_days: 2, max_days: 3 },
{ pincode: 321417, min_days: 2, max_days: 3 },
{ pincode: 321429, min_days: 2, max_days: 3 },
{ pincode: 321601, min_days: 2, max_days: 3 },
{ pincode: 321602, min_days: 2, max_days: 3 },
{ pincode: 321603, min_days: 2, max_days: 3 },
{ pincode: 321605, min_days: 2, max_days: 3 },
{ pincode: 321606, min_days: 2, max_days: 3 },
{ pincode: 321607, min_days: 2, max_days: 3 },
{ pincode: 321608, min_days: 2, max_days: 3 },
{ pincode: 321609, min_days: 2, max_days: 3 },
{ pincode: 321610, min_days: 2, max_days: 3 },
{ pincode: 321611, min_days: 2, max_days: 3 },
{ pincode: 321612, min_days: 2, max_days: 3 },
{ pincode: 321613, min_days: 2, max_days: 3 },
{ pincode: 321614, min_days: 2, max_days: 3 },
{ pincode: 321615, min_days: 2, max_days: 3 },
{ pincode: 321616, min_days: 2, max_days: 3 },
{ pincode: 321617, min_days: 2, max_days: 3 },
{ pincode: 321618, min_days: 2, max_days: 3 },
{ pincode: 321632, min_days: 2, max_days: 3 },
{ pincode: 321633, min_days: 2, max_days: 3 },
{ pincode: 321634, min_days: 2, max_days: 3 },
{ pincode: 321636, min_days: 2, max_days: 3 },
{ pincode: 321637, min_days: 2, max_days: 3 },
{ pincode: 321642, min_days: 2, max_days: 3 },
{ pincode: 322001, min_days: 2, max_days: 3 },
{ pincode: 322021, min_days: 2, max_days: 3 },
{ pincode: 322022, min_days: 2, max_days: 3 },
{ pincode: 322023, min_days: 2, max_days: 3 },
{ pincode: 322024, min_days: 2, max_days: 3 },
{ pincode: 322025, min_days: 2, max_days: 3 },
{ pincode: 322026, min_days: 2, max_days: 3 },
{ pincode: 322027, min_days: 2, max_days: 3 },
{ pincode: 322028, min_days: 2, max_days: 3 },
{ pincode: 322029, min_days: 2, max_days: 3 },
{ pincode: 322030, min_days: 2, max_days: 3 },
{ pincode: 322033, min_days: 2, max_days: 3 },
{ pincode: 322034, min_days: 2, max_days: 3 },
{ pincode: 322201, min_days: 2, max_days: 3 },
{ pincode: 322202, min_days: 2, max_days: 3 },
{ pincode: 322203, min_days: 2, max_days: 3 },
{ pincode: 322204, min_days: 2, max_days: 3 },
{ pincode: 322205, min_days: 2, max_days: 3 },
{ pincode: 322211, min_days: 2, max_days: 3 },
{ pincode: 322212, min_days: 2, max_days: 3 },
{ pincode: 322213, min_days: 2, max_days: 3 },
{ pincode: 322214, min_days: 2, max_days: 3 },
{ pincode: 322215, min_days: 2, max_days: 3 },
{ pincode: 322216, min_days: 2, max_days: 3 },
{ pincode: 322218, min_days: 2, max_days: 3 },
{ pincode: 322219, min_days: 2, max_days: 3 },
{ pincode: 322220, min_days: 2, max_days: 3 },
{ pincode: 322230, min_days: 2, max_days: 3 },
{ pincode: 322231, min_days: 2, max_days: 3 },
{ pincode: 322232, min_days: 2, max_days: 3 },
{ pincode: 322233, min_days: 2, max_days: 3 },
{ pincode: 322234, min_days: 2, max_days: 3 },
{ pincode: 322236, min_days: 2, max_days: 3 },
{ pincode: 322238, min_days: 2, max_days: 3 },
{ pincode: 322240, min_days: 2, max_days: 3 },
{ pincode: 322241, min_days: 2, max_days: 3 },
{ pincode: 322242, min_days: 2, max_days: 3 },
{ pincode: 322243, min_days: 2, max_days: 3 },
{ pincode: 322245, min_days: 2, max_days: 3 },
{ pincode: 322249, min_days: 2, max_days: 3 },
{ pincode: 322251, min_days: 2, max_days: 3 },
{ pincode: 322252, min_days: 2, max_days: 3 },
{ pincode: 322254, min_days: 2, max_days: 3 },
{ pincode: 322255, min_days: 2, max_days: 3 },
{ pincode: 322701, min_days: 2, max_days: 3 },
{ pincode: 322702, min_days: 2, max_days: 3 },
{ pincode: 322703, min_days: 2, max_days: 3 },
{ pincode: 322704, min_days: 2, max_days: 3 },
{ pincode: 323001, min_days: 2, max_days: 3 },
{ pincode: 323021, min_days: 2, max_days: 3 },
{ pincode: 323022, min_days: 2, max_days: 3 },
{ pincode: 323023, min_days: 2, max_days: 3 },
{ pincode: 323024, min_days: 2, max_days: 3 },
{ pincode: 323025, min_days: 2, max_days: 3 },
{ pincode: 323026, min_days: 2, max_days: 3 },
{ pincode: 323301, min_days: 2, max_days: 3 },
{ pincode: 323302, min_days: 2, max_days: 3 },
{ pincode: 323303, min_days: 2, max_days: 3 },
{ pincode: 323304, min_days: 2, max_days: 3 },
{ pincode: 323305, min_days: 2, max_days: 3 },
{ pincode: 323306, min_days: 2, max_days: 3 },
{ pincode: 323307, min_days: 2, max_days: 3 },
{ pincode: 323601, min_days: 2, max_days: 3 },
{ pincode: 323602, min_days: 2, max_days: 3 },
{ pincode: 323603, min_days: 2, max_days: 3 },
{ pincode: 323604, min_days: 2, max_days: 3 },
{ pincode: 323613, min_days: 2, max_days: 3 },
{ pincode: 323614, min_days: 2, max_days: 3 },
{ pincode: 323615, min_days: 2, max_days: 3 },
{ pincode: 323616, min_days: 2, max_days: 3 },
{ pincode: 323801, min_days: 2, max_days: 3 },
{ pincode: 323802, min_days: 2, max_days: 3 },
{ pincode: 323803, min_days: 2, max_days: 3 },
{ pincode: 324001, min_days: 2, max_days: 3 },
{ pincode: 324002, min_days: 2, max_days: 3 },
{ pincode: 324003, min_days: 2, max_days: 3 },
{ pincode: 324004, min_days: 2, max_days: 3 },
{ pincode: 324005, min_days: 2, max_days: 3 },
{ pincode: 324006, min_days: 2, max_days: 3 },
{ pincode: 324007, min_days: 2, max_days: 3 },
{ pincode: 324008, min_days: 2, max_days: 3 },
{ pincode: 324009, min_days: 2, max_days: 3 },
{ pincode: 324010, min_days: 2, max_days: 3 },
{ pincode: 325001, min_days: 2, max_days: 3 },
{ pincode: 325003, min_days: 2, max_days: 3 },
{ pincode: 325004, min_days: 2, max_days: 3 },
{ pincode: 325007, min_days: 2, max_days: 3 },
{ pincode: 325009, min_days: 2, max_days: 3 },
{ pincode: 325201, min_days: 2, max_days: 3 },
{ pincode: 325202, min_days: 2, max_days: 3 },
{ pincode: 325203, min_days: 2, max_days: 3 },
{ pincode: 325204, min_days: 2, max_days: 3 },
{ pincode: 325205, min_days: 2, max_days: 3 },
{ pincode: 325206, min_days: 2, max_days: 3 },
{ pincode: 325207, min_days: 2, max_days: 3 },
{ pincode: 325208, min_days: 2, max_days: 3 },
{ pincode: 325209, min_days: 2, max_days: 3 },
{ pincode: 325214, min_days: 2, max_days: 3 },
{ pincode: 325215, min_days: 2, max_days: 3 },
{ pincode: 325216, min_days: 2, max_days: 3 },
{ pincode: 325217, min_days: 2, max_days: 3 },
{ pincode: 325218, min_days: 2, max_days: 3 },
{ pincode: 325219, min_days: 2, max_days: 3 },
{ pincode: 325220, min_days: 2, max_days: 3 },
{ pincode: 325221, min_days: 2, max_days: 3 },
{ pincode: 325222, min_days: 2, max_days: 3 },
{ pincode: 325223, min_days: 2, max_days: 3 },
{ pincode: 325224, min_days: 2, max_days: 3 },
{ pincode: 325225, min_days: 2, max_days: 3 },
{ pincode: 325226, min_days: 2, max_days: 3 },
{ pincode: 325601, min_days: 2, max_days: 3 },
{ pincode: 325602, min_days: 2, max_days: 3 },
{ pincode: 326001, min_days: 2, max_days: 3 },
{ pincode: 326003, min_days: 2, max_days: 3 },
{ pincode: 326021, min_days: 2, max_days: 3 },
{ pincode: 326022, min_days: 2, max_days: 3 },
{ pincode: 326023, min_days: 2, max_days: 3 },
{ pincode: 326033, min_days: 2, max_days: 3 },
{ pincode: 326034, min_days: 2, max_days: 3 },
{ pincode: 326035, min_days: 2, max_days: 3 },
{ pincode: 326036, min_days: 2, max_days: 3 },
{ pincode: 326037, min_days: 2, max_days: 3 },
{ pincode: 326038, min_days: 2, max_days: 3 },
{ pincode: 326039, min_days: 2, max_days: 3 },
{ pincode: 326040, min_days: 2, max_days: 3 },
{ pincode: 326501, min_days: 2, max_days: 3 },
{ pincode: 326502, min_days: 2, max_days: 3 },
{ pincode: 326503, min_days: 2, max_days: 3 },
{ pincode: 326510, min_days: 2, max_days: 3 },
{ pincode: 326512, min_days: 2, max_days: 3 },
{ pincode: 326513, min_days: 2, max_days: 3 },
{ pincode: 326514, min_days: 2, max_days: 3 },
{ pincode: 326515, min_days: 2, max_days: 3 },
{ pincode: 326516, min_days: 2, max_days: 3 },
{ pincode: 326517, min_days: 2, max_days: 3 },
{ pincode: 326518, min_days: 2, max_days: 3 },
{ pincode: 326519, min_days: 2, max_days: 3 },
{ pincode: 326520, min_days: 2, max_days: 3 },
{ pincode: 326529, min_days: 2, max_days: 3 },
{ pincode: 326530, min_days: 2, max_days: 3 },
{ pincode: 327001, min_days: 2, max_days: 3 },
{ pincode: 327002, min_days: 2, max_days: 3 },
{ pincode: 327007, min_days: 2, max_days: 3 },
{ pincode: 327021, min_days: 2, max_days: 3 },
{ pincode: 327022, min_days: 2, max_days: 3 },
{ pincode: 327023, min_days: 2, max_days: 3 },
{ pincode: 327024, min_days: 2, max_days: 3 },
{ pincode: 327025, min_days: 2, max_days: 3 },
{ pincode: 327026, min_days: 2, max_days: 3 },
{ pincode: 327027, min_days: 2, max_days: 3 },
{ pincode: 327030, min_days: 2, max_days: 3 },
{ pincode: 327031, min_days: 2, max_days: 3 },
{ pincode: 327032, min_days: 2, max_days: 3 },
{ pincode: 327034, min_days: 2, max_days: 3 },
{ pincode: 327601, min_days: 2, max_days: 3 },
{ pincode: 327602, min_days: 2, max_days: 3 },
{ pincode: 327603, min_days: 2, max_days: 3 },
{ pincode: 327604, min_days: 2, max_days: 3 },
{ pincode: 327605, min_days: 2, max_days: 3 },
{ pincode: 327606, min_days: 2, max_days: 3 },
{ pincode: 327608, min_days: 2, max_days: 3 },
{ pincode: 327801, min_days: 2, max_days: 3 },
{ pincode: 328001, min_days: 2, max_days: 3 },
{ pincode: 328021, min_days: 2, max_days: 3 },
{ pincode: 328022, min_days: 2, max_days: 3 },
{ pincode: 328023, min_days: 2, max_days: 3 },
{ pincode: 328024, min_days: 2, max_days: 3 },
{ pincode: 328025, min_days: 2, max_days: 3 },
{ pincode: 328026, min_days: 2, max_days: 3 },
{ pincode: 328027, min_days: 2, max_days: 3 },
{ pincode: 328028, min_days: 2, max_days: 3 },
{ pincode: 328029, min_days: 2, max_days: 3 },
{ pincode: 328030, min_days: 2, max_days: 3 },
{ pincode: 328031, min_days: 2, max_days: 3 },
{ pincode: 328034, min_days: 2, max_days: 3 },
{ pincode: 328035, min_days: 2, max_days: 3 },
{ pincode: 328037, min_days: 2, max_days: 3 },
{ pincode: 328038, min_days: 2, max_days: 3 },
{ pincode: 328040, min_days: 2, max_days: 3 },
{ pincode: 328041, min_days: 2, max_days: 3 },
{ pincode: 331001, min_days: 2, max_days: 3 },
{ pincode: 331020, min_days: 2, max_days: 3 },
{ pincode: 331021, min_days: 2, max_days: 3 },
{ pincode: 331022, min_days: 2, max_days: 3 },
{ pincode: 331023, min_days: 2, max_days: 3 },
{ pincode: 331024, min_days: 2, max_days: 3 },
{ pincode: 331025, min_days: 2, max_days: 3 },
{ pincode: 331026, min_days: 2, max_days: 3 },
{ pincode: 331027, min_days: 2, max_days: 3 },
{ pincode: 331028, min_days: 2, max_days: 3 },
{ pincode: 331029, min_days: 2, max_days: 3 },
{ pincode: 331031, min_days: 2, max_days: 3 },
{ pincode: 331034, min_days: 2, max_days: 3 },
{ pincode: 331301, min_days: 2, max_days: 3 },
{ pincode: 331302, min_days: 2, max_days: 3 },
{ pincode: 331303, min_days: 2, max_days: 3 },
{ pincode: 331304, min_days: 2, max_days: 3 },
{ pincode: 331305, min_days: 2, max_days: 3 },
{ pincode: 331306, min_days: 2, max_days: 3 },
{ pincode: 331401, min_days: 2, max_days: 3 },
{ pincode: 331402, min_days: 2, max_days: 3 },
{ pincode: 331403, min_days: 2, max_days: 3 },
{ pincode: 331411, min_days: 2, max_days: 3 },
{ pincode: 331501, min_days: 2, max_days: 3 },
{ pincode: 331502, min_days: 2, max_days: 3 },
{ pincode: 331503, min_days: 2, max_days: 3 },
{ pincode: 331504, min_days: 2, max_days: 3 },
{ pincode: 331505, min_days: 2, max_days: 3 },
{ pincode: 331506, min_days: 2, max_days: 3 },
{ pincode: 331507, min_days: 2, max_days: 3 },
{ pincode: 331510, min_days: 2, max_days: 3 },
{ pincode: 331517, min_days: 2, max_days: 3 },
{ pincode: 331518, min_days: 2, max_days: 3 },
{ pincode: 331701, min_days: 2, max_days: 3 },
{ pincode: 331801, min_days: 2, max_days: 3 },
{ pincode: 331802, min_days: 2, max_days: 3 },
{ pincode: 331803, min_days: 2, max_days: 3 },
{ pincode: 331804, min_days: 2, max_days: 3 },
{ pincode: 331811, min_days: 2, max_days: 3 },
{ pincode: 332001, min_days: 2, max_days: 3 },
{ pincode: 332002, min_days: 2, max_days: 3 },
{ pincode: 332003, min_days: 2, max_days: 3 },
{ pincode: 332021, min_days: 2, max_days: 3 },
{ pincode: 332022, min_days: 2, max_days: 3 },
{ pincode: 332023, min_days: 2, max_days: 3 },
{ pincode: 332024, min_days: 2, max_days: 3 },
{ pincode: 332025, min_days: 2, max_days: 3 },
{ pincode: 332026, min_days: 2, max_days: 3 },
{ pincode: 332027, min_days: 2, max_days: 3 },
{ pincode: 332028, min_days: 2, max_days: 3 },
{ pincode: 332029, min_days: 2, max_days: 3 },
{ pincode: 332030, min_days: 2, max_days: 3 },
{ pincode: 332031, min_days: 2, max_days: 3 },
{ pincode: 332032, min_days: 2, max_days: 3 },
{ pincode: 332039, min_days: 2, max_days: 3 },
{ pincode: 332041, min_days: 2, max_days: 3 },
{ pincode: 332042, min_days: 2, max_days: 3 },
{ pincode: 332043, min_days: 2, max_days: 3 },
{ pincode: 332045, min_days: 2, max_days: 3 },
{ pincode: 332301, min_days: 2, max_days: 3 },
{ pincode: 332302, min_days: 2, max_days: 3 },
{ pincode: 332303, min_days: 2, max_days: 3 },
{ pincode: 332304, min_days: 2, max_days: 3 },
{ pincode: 332305, min_days: 2, max_days: 3 },
{ pincode: 332307, min_days: 2, max_days: 3 },
{ pincode: 332311, min_days: 2, max_days: 3 },
{ pincode: 332312, min_days: 2, max_days: 3 },
{ pincode: 332313, min_days: 2, max_days: 3 },
{ pincode: 332315, min_days: 2, max_days: 3 },
{ pincode: 332316, min_days: 2, max_days: 3 },
{ pincode: 332317, min_days: 2, max_days: 3 },
{ pincode: 332318, min_days: 2, max_days: 3 },
{ pincode: 332401, min_days: 2, max_days: 3 },
{ pincode: 332402, min_days: 2, max_days: 3 },
{ pincode: 332403, min_days: 2, max_days: 3 },
{ pincode: 332404, min_days: 2, max_days: 3 },
{ pincode: 332405, min_days: 2, max_days: 3 },
{ pincode: 332406, min_days: 2, max_days: 3 },
{ pincode: 332407, min_days: 2, max_days: 3 },
{ pincode: 332409, min_days: 2, max_days: 3 },
{ pincode: 332410, min_days: 2, max_days: 3 },
{ pincode: 332411, min_days: 2, max_days: 3 },
{ pincode: 332413, min_days: 2, max_days: 3 },
{ pincode: 332601, min_days: 2, max_days: 3 },
{ pincode: 332602, min_days: 2, max_days: 3 },
{ pincode: 332603, min_days: 2, max_days: 3 },
{ pincode: 332701, min_days: 2, max_days: 3 },
{ pincode: 332702, min_days: 2, max_days: 3 },
{ pincode: 332703, min_days: 2, max_days: 3 },
{ pincode: 332704, min_days: 2, max_days: 3 },
{ pincode: 332705, min_days: 2, max_days: 3 },
{ pincode: 332706, min_days: 2, max_days: 3 },
{ pincode: 332707, min_days: 2, max_days: 3 },
{ pincode: 332708, min_days: 2, max_days: 3 },
{ pincode: 332709, min_days: 2, max_days: 3 },
{ pincode: 332710, min_days: 2, max_days: 3 },
{ pincode: 332711, min_days: 2, max_days: 3 },
{ pincode: 332712, min_days: 2, max_days: 3 },
{ pincode: 332713, min_days: 2, max_days: 3 },
{ pincode: 332714, min_days: 2, max_days: 3 },
{ pincode: 332715, min_days: 2, max_days: 3 },
{ pincode: 332716, min_days: 2, max_days: 3 },
{ pincode: 332718, min_days: 2, max_days: 3 },
{ pincode: 332719, min_days: 2, max_days: 3 },
{ pincode: 332721, min_days: 2, max_days: 3 },
{ pincode: 332722, min_days: 2, max_days: 3 },
{ pincode: 332726, min_days: 2, max_days: 3 },
{ pincode: 332729, min_days: 2, max_days: 3 },
{ pincode: 332730, min_days: 2, max_days: 3 },
{ pincode: 332734, min_days: 2, max_days: 3 },
{ pincode: 332735, min_days: 2, max_days: 3 },
{ pincode: 332739, min_days: 2, max_days: 3 },
{ pincode: 332740, min_days: 2, max_days: 3 },
{ pincode: 332742, min_days: 2, max_days: 3 },
{ pincode: 332746, min_days: 2, max_days: 3 },
{ pincode: 333001, min_days: 2, max_days: 3 },
{ pincode: 333010, min_days: 2, max_days: 3 },
{ pincode: 333011, min_days: 2, max_days: 3 },
{ pincode: 333012, min_days: 2, max_days: 3 },
{ pincode: 333020, min_days: 2, max_days: 3 },
{ pincode: 333021, min_days: 2, max_days: 3 },
{ pincode: 333022, min_days: 2, max_days: 3 },
{ pincode: 333023, min_days: 2, max_days: 3 },
{ pincode: 333024, min_days: 2, max_days: 3 },
{ pincode: 333025, min_days: 2, max_days: 3 },
{ pincode: 333026, min_days: 2, max_days: 3 },
{ pincode: 333027, min_days: 2, max_days: 3 },
{ pincode: 333028, min_days: 2, max_days: 3 },
{ pincode: 333029, min_days: 2, max_days: 3 },
{ pincode: 333030, min_days: 2, max_days: 3 },
{ pincode: 333031, min_days: 2, max_days: 3 },
{ pincode: 333032, min_days: 2, max_days: 3 },
{ pincode: 333033, min_days: 2, max_days: 3 },
{ pincode: 333034, min_days: 2, max_days: 3 },
{ pincode: 333035, min_days: 2, max_days: 3 },
{ pincode: 333036, min_days: 2, max_days: 3 },
{ pincode: 333038, min_days: 2, max_days: 3 },
{ pincode: 333041, min_days: 2, max_days: 3 },
{ pincode: 333042, min_days: 2, max_days: 3 },
{ pincode: 333043, min_days: 2, max_days: 3 },
{ pincode: 333044, min_days: 2, max_days: 3 },
{ pincode: 333045, min_days: 2, max_days: 3 },
{ pincode: 333053, min_days: 2, max_days: 3 },
{ pincode: 333055, min_days: 2, max_days: 3 },
{ pincode: 333302, min_days: 2, max_days: 3 },
{ pincode: 333303, min_days: 2, max_days: 3 },
{ pincode: 333304, min_days: 2, max_days: 3 },
{ pincode: 333305, min_days: 2, max_days: 3 },
{ pincode: 333306, min_days: 2, max_days: 3 },
{ pincode: 333307, min_days: 2, max_days: 3 },
{ pincode: 333308, min_days: 2, max_days: 3 },
{ pincode: 333310, min_days: 2, max_days: 3 },
{ pincode: 333501, min_days: 2, max_days: 3 },
{ pincode: 333502, min_days: 2, max_days: 3 },
{ pincode: 333503, min_days: 2, max_days: 3 },
{ pincode: 333504, min_days: 2, max_days: 3 },
{ pincode: 333514, min_days: 2, max_days: 3 },
{ pincode: 333515, min_days: 2, max_days: 3 },
{ pincode: 333516, min_days: 2, max_days: 3 },
{ pincode: 333517, min_days: 2, max_days: 3 },
{ pincode: 333701, min_days: 2, max_days: 3 },
{ pincode: 333702, min_days: 2, max_days: 3 },
{ pincode: 333704, min_days: 2, max_days: 3 },
{ pincode: 333705, min_days: 2, max_days: 3 },
{ pincode: 333707, min_days: 2, max_days: 3 },
{ pincode: 333801, min_days: 2, max_days: 3 },
{ pincode: 334001, min_days: 2, max_days: 3 },
{ pincode: 334002, min_days: 2, max_days: 3 },
{ pincode: 334003, min_days: 2, max_days: 3 },
{ pincode: 334004, min_days: 2, max_days: 3 },
{ pincode: 334005, min_days: 2, max_days: 3 },
{ pincode: 334006, min_days: 2, max_days: 3 },
{ pincode: 334021, min_days: 2, max_days: 3 },
{ pincode: 334022, min_days: 2, max_days: 3 },
{ pincode: 334023, min_days: 2, max_days: 3 },
{ pincode: 334024, min_days: 2, max_days: 3 },
{ pincode: 334201, min_days: 2, max_days: 3 },
{ pincode: 334202, min_days: 2, max_days: 3 },
{ pincode: 334301, min_days: 2, max_days: 3 },
{ pincode: 334302, min_days: 2, max_days: 3 },
{ pincode: 334303, min_days: 2, max_days: 3 },
{ pincode: 334305, min_days: 2, max_days: 3 },
{ pincode: 334306, min_days: 2, max_days: 3 },
{ pincode: 334401, min_days: 2, max_days: 3 },
{ pincode: 334402, min_days: 2, max_days: 3 },
{ pincode: 334403, min_days: 2, max_days: 3 },
{ pincode: 334404, min_days: 2, max_days: 3 },
{ pincode: 334601, min_days: 2, max_days: 3 },
{ pincode: 334602, min_days: 2, max_days: 3 },
{ pincode: 334603, min_days: 2, max_days: 3 },
{ pincode: 334604, min_days: 2, max_days: 3 },
{ pincode: 334801, min_days: 2, max_days: 3 },
{ pincode: 334802, min_days: 2, max_days: 3 },
{ pincode: 334803, min_days: 2, max_days: 3 },
{ pincode: 334804, min_days: 2, max_days: 3 },
{ pincode: 334808, min_days: 2, max_days: 3 },
{ pincode: 335001, min_days: 2, max_days: 3 },
{ pincode: 335002, min_days: 2, max_days: 3 },
{ pincode: 335021, min_days: 2, max_days: 3 },
{ pincode: 335022, min_days: 2, max_days: 3 },
{ pincode: 335023, min_days: 2, max_days: 3 },
{ pincode: 335024, min_days: 2, max_days: 3 },
{ pincode: 335025, min_days: 2, max_days: 3 },
{ pincode: 335026, min_days: 2, max_days: 3 },
{ pincode: 335027, min_days: 2, max_days: 3 },
{ pincode: 335037, min_days: 2, max_days: 3 },
{ pincode: 335038, min_days: 2, max_days: 3 },
{ pincode: 335039, min_days: 2, max_days: 3 },
{ pincode: 335040, min_days: 2, max_days: 3 },
{ pincode: 335041, min_days: 2, max_days: 3 },
{ pincode: 335042, min_days: 2, max_days: 3 },
{ pincode: 335051, min_days: 2, max_days: 3 },
{ pincode: 335061, min_days: 2, max_days: 3 },
{ pincode: 335062, min_days: 2, max_days: 3 },
{ pincode: 335063, min_days: 2, max_days: 3 },
{ pincode: 335064, min_days: 2, max_days: 3 },
{ pincode: 335065, min_days: 2, max_days: 3 },
{ pincode: 335073, min_days: 2, max_days: 3 },
{ pincode: 335501, min_days: 2, max_days: 3 },
{ pincode: 335502, min_days: 2, max_days: 3 },
{ pincode: 335503, min_days: 2, max_days: 3 },
{ pincode: 335504, min_days: 2, max_days: 3 },
{ pincode: 335511, min_days: 2, max_days: 3 },
{ pincode: 335512, min_days: 2, max_days: 3 },
{ pincode: 335513, min_days: 2, max_days: 3 },
{ pincode: 335521, min_days: 2, max_days: 3 },
{ pincode: 335522, min_days: 2, max_days: 3 },
{ pincode: 335523, min_days: 2, max_days: 3 },
{ pincode: 335524, min_days: 2, max_days: 3 },
{ pincode: 335525, min_days: 2, max_days: 3 },
{ pincode: 335526, min_days: 2, max_days: 3 },
{ pincode: 335527, min_days: 2, max_days: 3 },
{ pincode: 335528, min_days: 2, max_days: 3 },
{ pincode: 335701, min_days: 2, max_days: 3 },
{ pincode: 335702, min_days: 2, max_days: 3 },
{ pincode: 335703, min_days: 2, max_days: 3 },
{ pincode: 335704, min_days: 2, max_days: 3 },
{ pincode: 335705, min_days: 2, max_days: 3 },
{ pincode: 335707, min_days: 2, max_days: 3 },
{ pincode: 335708, min_days: 2, max_days: 3 },
{ pincode: 335711, min_days: 2, max_days: 3 },
{ pincode: 335771, min_days: 2, max_days: 3 },
{ pincode: 335801, min_days: 2, max_days: 3 },
{ pincode: 335802, min_days: 2, max_days: 3 },
{ pincode: 335803, min_days: 2, max_days: 3 },
{ pincode: 335804, min_days: 2, max_days: 3 },
{ pincode: 335805, min_days: 2, max_days: 3 },
{ pincode: 335806, min_days: 2, max_days: 3 },
{ pincode: 335807, min_days: 2, max_days: 3 },
{ pincode: 335901, min_days: 2, max_days: 3 },
{ pincode: 341001, min_days: 2, max_days: 3 },
{ pincode: 341012, min_days: 2, max_days: 3 },
{ pincode: 341013, min_days: 2, max_days: 3 },
{ pincode: 341020, min_days: 2, max_days: 3 },
{ pincode: 341021, min_days: 2, max_days: 3 },
{ pincode: 341022, min_days: 2, max_days: 3 },
{ pincode: 341023, min_days: 2, max_days: 3 },
{ pincode: 341024, min_days: 2, max_days: 3 },
{ pincode: 341025, min_days: 2, max_days: 3 },
{ pincode: 341026, min_days: 2, max_days: 3 },
{ pincode: 341027, min_days: 2, max_days: 3 },
{ pincode: 341028, min_days: 2, max_days: 3 },
{ pincode: 341029, min_days: 2, max_days: 3 },
{ pincode: 341030, min_days: 2, max_days: 3 },
{ pincode: 341031, min_days: 2, max_days: 3 },
{ pincode: 341035, min_days: 2, max_days: 3 },
{ pincode: 341301, min_days: 2, max_days: 3 },
{ pincode: 341302, min_days: 2, max_days: 3 },
{ pincode: 341303, min_days: 2, max_days: 3 },
{ pincode: 341304, min_days: 2, max_days: 3 },
{ pincode: 341305, min_days: 2, max_days: 3 },
{ pincode: 341306, min_days: 2, max_days: 3 },
{ pincode: 341309, min_days: 2, max_days: 3 },
{ pincode: 341313, min_days: 2, max_days: 3 },
{ pincode: 341316, min_days: 2, max_days: 3 },
{ pincode: 341317, min_days: 2, max_days: 3 },
{ pincode: 341318, min_days: 2, max_days: 3 },
{ pincode: 341319, min_days: 2, max_days: 3 },
{ pincode: 341501, min_days: 2, max_days: 3 },
{ pincode: 341502, min_days: 2, max_days: 3 },
{ pincode: 341503, min_days: 2, max_days: 3 },
{ pincode: 341504, min_days: 2, max_days: 3 },
{ pincode: 341505, min_days: 2, max_days: 3 },
{ pincode: 341506, min_days: 2, max_days: 3 },
{ pincode: 341507, min_days: 2, max_days: 3 },
{ pincode: 341508, min_days: 2, max_days: 3 },
{ pincode: 341509, min_days: 2, max_days: 3 },
{ pincode: 341510, min_days: 2, max_days: 3 },
{ pincode: 341511, min_days: 2, max_days: 3 },
{ pincode: 341512, min_days: 2, max_days: 3 },
{ pincode: 341513, min_days: 2, max_days: 3 },
{ pincode: 341514, min_days: 2, max_days: 3 },
{ pincode: 341515, min_days: 2, max_days: 3 },
{ pincode: 341516, min_days: 2, max_days: 3 },
{ pincode: 341517, min_days: 2, max_days: 3 },
{ pincode: 341518, min_days: 2, max_days: 3 },
{ pincode: 341519, min_days: 2, max_days: 3 },
{ pincode: 341520, min_days: 2, max_days: 3 },
{ pincode: 341522, min_days: 2, max_days: 3 },
{ pincode: 341527, min_days: 2, max_days: 3 },
{ pincode: 341533, min_days: 2, max_days: 3 },
{ pincode: 341535, min_days: 2, max_days: 3 },
{ pincode: 341539, min_days: 2, max_days: 3 },
{ pincode: 341542, min_days: 2, max_days: 3 },
{ pincode: 341544, min_days: 2, max_days: 3 },
{ pincode: 341545, min_days: 2, max_days: 3 },
{ pincode: 341546, min_days: 2, max_days: 3 },
{ pincode: 341547, min_days: 2, max_days: 3 },
{ pincode: 341550, min_days: 2, max_days: 3 },
{ pincode: 341551, min_days: 2, max_days: 3 },
{ pincode: 342001, min_days: 2, max_days: 3 },
{ pincode: 342002, min_days: 2, max_days: 3 },
{ pincode: 342003, min_days: 2, max_days: 3 },
{ pincode: 342004, min_days: 2, max_days: 3 },
{ pincode: 342005, min_days: 2, max_days: 3 },
{ pincode: 342006, min_days: 2, max_days: 3 },
{ pincode: 342007, min_days: 2, max_days: 3 },
{ pincode: 342008, min_days: 2, max_days: 3 },
{ pincode: 342009, min_days: 2, max_days: 3 },
{ pincode: 342010, min_days: 2, max_days: 3 },
{ pincode: 342011, min_days: 2, max_days: 3 },
{ pincode: 342012, min_days: 2, max_days: 3 },
{ pincode: 342013, min_days: 2, max_days: 3 },
{ pincode: 342014, min_days: 2, max_days: 3 },
{ pincode: 342015, min_days: 2, max_days: 3 },
{ pincode: 342016, min_days: 2, max_days: 3 },
{ pincode: 342017, min_days: 2, max_days: 3 },
{ pincode: 342018, min_days: 2, max_days: 3 },
{ pincode: 342019, min_days: 2, max_days: 3 },
{ pincode: 342020, min_days: 2, max_days: 3 },
{ pincode: 342021, min_days: 2, max_days: 3 },
{ pincode: 342022, min_days: 2, max_days: 3 },
{ pincode: 342023, min_days: 2, max_days: 3 },
{ pincode: 342024, min_days: 2, max_days: 3 },
{ pincode: 342025, min_days: 2, max_days: 3 },
{ pincode: 342026, min_days: 2, max_days: 3 },
{ pincode: 342027, min_days: 2, max_days: 3 },
{ pincode: 342028, min_days: 2, max_days: 3 },
{ pincode: 342029, min_days: 2, max_days: 3 },
{ pincode: 342030, min_days: 2, max_days: 3 },
{ pincode: 342032, min_days: 2, max_days: 3 },
{ pincode: 342033, min_days: 2, max_days: 3 },
{ pincode: 342037, min_days: 2, max_days: 3 },
{ pincode: 342301, min_days: 2, max_days: 3 },
{ pincode: 342302, min_days: 2, max_days: 3 },
{ pincode: 342303, min_days: 2, max_days: 3 },
{ pincode: 342304, min_days: 2, max_days: 3 },
{ pincode: 342305, min_days: 2, max_days: 3 },
{ pincode: 342306, min_days: 2, max_days: 3 },
{ pincode: 342307, min_days: 2, max_days: 3 },
{ pincode: 342308, min_days: 2, max_days: 3 },
{ pincode: 342309, min_days: 2, max_days: 3 },
{ pincode: 342310, min_days: 2, max_days: 3 },
{ pincode: 342311, min_days: 2, max_days: 3 },
{ pincode: 342312, min_days: 2, max_days: 3 },
{ pincode: 342314, min_days: 2, max_days: 3 },
{ pincode: 342601, min_days: 2, max_days: 3 },
{ pincode: 342602, min_days: 2, max_days: 3 },
{ pincode: 342603, min_days: 2, max_days: 3 },
{ pincode: 342604, min_days: 2, max_days: 3 },
{ pincode: 342605, min_days: 2, max_days: 3 },
{ pincode: 342606, min_days: 2, max_days: 3 },
{ pincode: 342801, min_days: 2, max_days: 3 },
{ pincode: 342802, min_days: 2, max_days: 3 },
{ pincode: 342804, min_days: 2, max_days: 3 },
{ pincode: 342901, min_days: 2, max_days: 3 },
{ pincode: 342902, min_days: 2, max_days: 3 },
{ pincode: 343001, min_days: 2, max_days: 3 },
{ pincode: 343002, min_days: 2, max_days: 3 },
{ pincode: 343021, min_days: 2, max_days: 3 },
{ pincode: 343022, min_days: 2, max_days: 3 },
{ pincode: 343023, min_days: 2, max_days: 3 },
{ pincode: 343024, min_days: 2, max_days: 3 },
{ pincode: 343025, min_days: 2, max_days: 3 },
{ pincode: 343026, min_days: 2, max_days: 3 },
{ pincode: 343027, min_days: 2, max_days: 3 },
{ pincode: 343028, min_days: 2, max_days: 3 },
{ pincode: 343029, min_days: 2, max_days: 3 },
{ pincode: 343030, min_days: 2, max_days: 3 },
{ pincode: 343031, min_days: 2, max_days: 3 },
{ pincode: 343032, min_days: 2, max_days: 3 },
{ pincode: 343034, min_days: 2, max_days: 3 },
{ pincode: 343039, min_days: 2, max_days: 3 },
{ pincode: 343040, min_days: 2, max_days: 3 },
{ pincode: 343041, min_days: 2, max_days: 3 },
{ pincode: 343042, min_days: 2, max_days: 3 },
{ pincode: 343043, min_days: 2, max_days: 3 },
{ pincode: 343044, min_days: 2, max_days: 3 },
{ pincode: 343045, min_days: 2, max_days: 3 },
{ pincode: 343048, min_days: 2, max_days: 3 },
{ pincode: 343049, min_days: 2, max_days: 3 },
{ pincode: 344001, min_days: 2, max_days: 3 },
{ pincode: 344011, min_days: 2, max_days: 3 },
{ pincode: 344012, min_days: 2, max_days: 3 },
{ pincode: 344015, min_days: 2, max_days: 3 },
{ pincode: 344021, min_days: 2, max_days: 3 },
{ pincode: 344022, min_days: 2, max_days: 3 },
{ pincode: 344023, min_days: 2, max_days: 3 },
{ pincode: 344024, min_days: 2, max_days: 3 },
{ pincode: 344025, min_days: 2, max_days: 3 },
{ pincode: 344026, min_days: 2, max_days: 3 },
{ pincode: 344027, min_days: 2, max_days: 3 },
{ pincode: 344028, min_days: 2, max_days: 3 },
{ pincode: 344031, min_days: 2, max_days: 3 },
{ pincode: 344032, min_days: 2, max_days: 3 },
{ pincode: 344033, min_days: 2, max_days: 3 },
{ pincode: 344034, min_days: 2, max_days: 3 },
{ pincode: 344035, min_days: 2, max_days: 3 },
{ pincode: 344037, min_days: 2, max_days: 3 },
{ pincode: 344043, min_days: 2, max_days: 3 },
{ pincode: 344044, min_days: 2, max_days: 3 },
{ pincode: 344501, min_days: 2, max_days: 3 },
{ pincode: 344502, min_days: 2, max_days: 3 },
{ pincode: 344601, min_days: 2, max_days: 3 },
{ pincode: 344701, min_days: 2, max_days: 3 },
{ pincode: 344702, min_days: 2, max_days: 3 },
{ pincode: 344703, min_days: 2, max_days: 3 },
{ pincode: 344704, min_days: 2, max_days: 3 },
{ pincode: 344705, min_days: 2, max_days: 3 },
{ pincode: 344706, min_days: 2, max_days: 3 },
{ pincode: 344708, min_days: 2, max_days: 3 },
{ pincode: 344801, min_days: 2, max_days: 3 },
{ pincode: 344802, min_days: 2, max_days: 3 },
{ pincode: 345001, min_days: 2, max_days: 3 },
{ pincode: 345002, min_days: 2, max_days: 3 },
{ pincode: 345021, min_days: 2, max_days: 3 },
{ pincode: 345022, min_days: 2, max_days: 3 },
{ pincode: 345023, min_days: 2, max_days: 3 },
{ pincode: 345024, min_days: 2, max_days: 3 },
{ pincode: 345025, min_days: 2, max_days: 3 },
{ pincode: 345026, min_days: 2, max_days: 3 },
{ pincode: 345027, min_days: 2, max_days: 3 },
{ pincode: 345028, min_days: 2, max_days: 3 },
{ pincode: 345031, min_days: 2, max_days: 3 },
{ pincode: 345032, min_days: 2, max_days: 3 },
{ pincode: 345033, min_days: 2, max_days: 3 },
{ pincode: 345034, min_days: 2, max_days: 3 },
{ pincode: 346002, min_days: 2, max_days: 3 },
{ pincode: 346003, min_days: 2, max_days: 3 },
{ pincode: 346004, min_days: 2, max_days: 3 },
{ pincode: 346005, min_days: 2, max_days: 3 },
{ pincode: 346110, min_days: 2, max_days: 3 },
{ pincode: 360001, min_days: 1, max_days: 2 },
{ pincode: 360002, min_days: 1, max_days: 2 },
{ pincode: 360003, min_days: 1, max_days: 2 },
{ pincode: 360004, min_days: 1, max_days: 2 },
{ pincode: 360005, min_days: 1, max_days: 2 },
{ pincode: 360006, min_days: 1, max_days: 2 },
{ pincode: 360007, min_days: 1, max_days: 2 },
{ pincode: 360008, min_days: 1, max_days: 2 },
{ pincode: 360011, min_days: 1, max_days: 2 },
{ pincode: 360012, min_days: 1, max_days: 2 },
{ pincode: 360013, min_days: 1, max_days: 2 },
{ pincode: 360018, min_days: 1, max_days: 2 },
{ pincode: 360020, min_days: 1, max_days: 2 },
{ pincode: 360021, min_days: 1, max_days: 2 },
{ pincode: 360022, min_days: 1, max_days: 2 },
{ pincode: 360023, min_days: 1, max_days: 2 },
{ pincode: 360024, min_days: 1, max_days: 2 },
{ pincode: 360025, min_days: 1, max_days: 2 },
{ pincode: 360026, min_days: 1, max_days: 2 },
{ pincode: 360028, min_days: 2, max_days: 3 },
{ pincode: 360030, min_days: 1, max_days: 2 },
{ pincode: 360034, min_days: 1, max_days: 2 },
{ pincode: 360035, min_days: 1, max_days: 2 },
{ pincode: 360040, min_days: 1, max_days: 2 },
{ pincode: 360045, min_days: 1, max_days: 2 },
{ pincode: 360050, min_days: 1, max_days: 2 },
{ pincode: 360055, min_days: 1, max_days: 2 },
{ pincode: 360060, min_days: 1, max_days: 2 },
{ pincode: 360070, min_days: 1, max_days: 2 },
{ pincode: 360075, min_days: 1, max_days: 2 },
{ pincode: 360080, min_days: 1, max_days: 2 },
{ pincode: 360110, min_days: 1, max_days: 2 },
{ pincode: 360150, min_days: 1, max_days: 2 },
{ pincode: 360311, min_days: 1, max_days: 2 },
{ pincode: 360320, min_days: 1, max_days: 2 },
{ pincode: 360325, min_days: 1, max_days: 2 },
{ pincode: 360330, min_days: 1, max_days: 2 },
{ pincode: 360335, min_days: 1, max_days: 2 },
{ pincode: 360360, min_days: 1, max_days: 2 },
{ pincode: 360370, min_days: 1, max_days: 2 },
{ pincode: 360375, min_days: 1, max_days: 2 },
{ pincode: 360380, min_days: 1, max_days: 2 },
{ pincode: 360405, min_days: 1, max_days: 2 },
{ pincode: 360410, min_days: 1, max_days: 2 },
{ pincode: 360421, min_days: 1, max_days: 2 },
{ pincode: 360430, min_days: 1, max_days: 2 },
{ pincode: 360440, min_days: 1, max_days: 2 },
{ pincode: 360450, min_days: 1, max_days: 2 },
{ pincode: 360452, min_days: 2, max_days: 3 },
{ pincode: 360460, min_days: 1, max_days: 2 },
{ pincode: 360465, min_days: 2, max_days: 3 },
{ pincode: 360470, min_days: 1, max_days: 2 },
{ pincode: 360480, min_days: 1, max_days: 2 },
{ pincode: 360485, min_days: 2, max_days: 3 },
{ pincode: 360490, min_days: 1, max_days: 2 },
{ pincode: 360510, min_days: 1, max_days: 2 },
{ pincode: 360515, min_days: 1, max_days: 2 },
{ pincode: 360520, min_days: 1, max_days: 2 },
{ pincode: 360530, min_days: 1, max_days: 2 },
{ pincode: 360531, min_days: 1, max_days: 2 },
{ pincode: 360540, min_days: 2, max_days: 3 },
{ pincode: 360545, min_days: 1, max_days: 2 },
{ pincode: 360550, min_days: 1, max_days: 2 },
{ pincode: 360560, min_days: 1, max_days: 2 },
{ pincode: 360570, min_days: 1, max_days: 2 },
{ pincode: 360575, min_days: 1, max_days: 2 },
{ pincode: 360576, min_days: 1, max_days: 2 },
{ pincode: 360577, min_days: 1, max_days: 2 },
{ pincode: 360578, min_days: 1, max_days: 2 },
{ pincode: 360579, min_days: 1, max_days: 2 },
{ pincode: 360583, min_days: 1, max_days: 2 },
{ pincode: 360585, min_days: 1, max_days: 2 },
{ pincode: 360590, min_days: 1, max_days: 2 },
{ pincode: 361001, min_days: 1, max_days: 2 },
{ pincode: 361002, min_days: 1, max_days: 2 },
{ pincode: 361003, min_days: 1, max_days: 2 },
{ pincode: 361004, min_days: 1, max_days: 2 },
{ pincode: 361005, min_days: 1, max_days: 2 },
{ pincode: 361006, min_days: 1, max_days: 2 },
{ pincode: 361007, min_days: 1, max_days: 2 },
{ pincode: 361008, min_days: 1, max_days: 2 },
{ pincode: 361009, min_days: 1, max_days: 2 },
{ pincode: 361010, min_days: 1, max_days: 2 },
{ pincode: 361011, min_days: 1, max_days: 2 },
{ pincode: 361012, min_days: 2, max_days: 3 },
{ pincode: 361013, min_days: 1, max_days: 2 },
{ pincode: 361101, min_days: 1, max_days: 2 },
{ pincode: 361110, min_days: 1, max_days: 2 },
{ pincode: 361120, min_days: 1, max_days: 2 },
{ pincode: 361130, min_days: 1, max_days: 2 },
{ pincode: 361140, min_days: 1, max_days: 2 },
{ pincode: 361141, min_days: 1, max_days: 2 },
{ pincode: 361142, min_days: 1, max_days: 2 },
{ pincode: 361150, min_days: 1, max_days: 2 },
{ pincode: 361160, min_days: 1, max_days: 2 },
{ pincode: 361162, min_days: 1, max_days: 2 },
{ pincode: 361170, min_days: 1, max_days: 2 },
{ pincode: 361210, min_days: 1, max_days: 2 },
{ pincode: 361220, min_days: 1, max_days: 2 },
{ pincode: 361230, min_days: 1, max_days: 2 },
{ pincode: 361240, min_days: 1, max_days: 2 },
{ pincode: 361250, min_days: 1, max_days: 2 },
{ pincode: 361280, min_days: 1, max_days: 2 },
{ pincode: 361305, min_days: 1, max_days: 2 },
{ pincode: 361306, min_days: 1, max_days: 2 },
{ pincode: 361310, min_days: 1, max_days: 2 },
{ pincode: 361315, min_days: 2, max_days: 3 },
{ pincode: 361320, min_days: 1, max_days: 2 },
{ pincode: 361325, min_days: 1, max_days: 2 },
{ pincode: 361330, min_days: 1, max_days: 2 },
{ pincode: 361335, min_days: 1, max_days: 2 },
{ pincode: 361336, min_days: 1, max_days: 2 },
{ pincode: 361345, min_days: 1, max_days: 2 },
{ pincode: 361347, min_days: 1, max_days: 2 },
{ pincode: 361350, min_days: 1, max_days: 2 },
{ pincode: 362001, min_days: 1, max_days: 2 },
{ pincode: 362002, min_days: 1, max_days: 2 },
{ pincode: 362003, min_days: 1, max_days: 2 },
{ pincode: 362004, min_days: 1, max_days: 2 },
{ pincode: 362005, min_days: 1, max_days: 2 },
{ pincode: 362011, min_days: 1, max_days: 2 },
{ pincode: 362013, min_days: 1, max_days: 2 },
{ pincode: 362014, min_days: 1, max_days: 2 },
{ pincode: 362015, min_days: 1, max_days: 2 },
{ pincode: 362020, min_days: 1, max_days: 2 },
{ pincode: 362030, min_days: 1, max_days: 2 },
{ pincode: 362037, min_days: 1, max_days: 2 },
{ pincode: 362110, min_days: 1, max_days: 2 },
{ pincode: 362120, min_days: 1, max_days: 2 },
{ pincode: 362130, min_days: 1, max_days: 2 },
{ pincode: 362135, min_days: 1, max_days: 2 },
{ pincode: 362136, min_days: 1, max_days: 2 },
{ pincode: 362140, min_days: 1, max_days: 2 },
{ pincode: 362150, min_days: 1, max_days: 2 },
{ pincode: 362205, min_days: 1, max_days: 2 },
{ pincode: 362215, min_days: 1, max_days: 2 },
{ pincode: 362220, min_days: 1, max_days: 2 },
{ pincode: 362221, min_days: 1, max_days: 2 },
{ pincode: 362222, min_days: 1, max_days: 2 },
{ pincode: 362224, min_days: 1, max_days: 2 },
{ pincode: 362225, min_days: 1, max_days: 2 },
{ pincode: 362226, min_days: 1, max_days: 2 },
{ pincode: 362227, min_days: 1, max_days: 2 },
{ pincode: 362229, min_days: 1, max_days: 2 },
{ pincode: 362230, min_days: 1, max_days: 2 },
{ pincode: 362235, min_days: 1, max_days: 2 },
{ pincode: 362240, min_days: 1, max_days: 2 },
{ pincode: 362245, min_days: 1, max_days: 2 },
{ pincode: 362248, min_days: 1, max_days: 2 },
{ pincode: 362249, min_days: 1, max_days: 2 },
{ pincode: 362250, min_days: 1, max_days: 2 },
{ pincode: 362255, min_days: 1, max_days: 2 },
{ pincode: 362256, min_days: 1, max_days: 2 },
{ pincode: 362258, min_days: 1, max_days: 2 },
{ pincode: 362259, min_days: 1, max_days: 2 },
{ pincode: 362260, min_days: 1, max_days: 2 },
{ pincode: 362263, min_days: 1, max_days: 2 },
{ pincode: 362265, min_days: 1, max_days: 2 },
{ pincode: 362266, min_days: 1, max_days: 2 },
{ pincode: 362267, min_days: 1, max_days: 2 },
{ pincode: 362268, min_days: 1, max_days: 2 },
{ pincode: 362269, min_days: 1, max_days: 2 },
{ pincode: 362271, min_days: 1, max_days: 2 },
{ pincode: 362275, min_days: 1, max_days: 2 },
{ pincode: 362276, min_days: 1, max_days: 2 },
{ pincode: 362278, min_days: 1, max_days: 2 },
{ pincode: 362310, min_days: 1, max_days: 2 },
{ pincode: 362315, min_days: 1, max_days: 2 },
{ pincode: 362510, min_days: 1, max_days: 2 },
{ pincode: 362520, min_days: 1, max_days: 2 },
{ pincode: 362530, min_days: 1, max_days: 2 },
{ pincode: 362540, min_days: 1, max_days: 2 },
{ pincode: 362550, min_days: 1, max_days: 2 },
{ pincode: 362560, min_days: 1, max_days: 2 },
{ pincode: 362565, min_days: 1, max_days: 2 },
{ pincode: 362570, min_days: 1, max_days: 2 },
{ pincode: 362571, min_days: 1, max_days: 2 },
{ pincode: 362610, min_days: 1, max_days: 2 },
{ pincode: 362615, min_days: 1, max_days: 2 },
{ pincode: 362620, min_days: 1, max_days: 2 },
{ pincode: 362625, min_days: 1, max_days: 2 },
{ pincode: 362626, min_days: 1, max_days: 2 },
{ pincode: 362630, min_days: 1, max_days: 2 },
{ pincode: 362640, min_days: 1, max_days: 2 },
{ pincode: 362650, min_days: 1, max_days: 2 },
{ pincode: 362710, min_days: 1, max_days: 2 },
{ pincode: 362715, min_days: 1, max_days: 2 },
{ pincode: 362720, min_days: 1, max_days: 2 },
{ pincode: 362725, min_days: 1, max_days: 2 },
{ pincode: 362727, min_days: 1, max_days: 2 },
{ pincode: 362733, min_days: 1, max_days: 2 },
{ pincode: 363001, min_days: 1, max_days: 2 },
{ pincode: 363002, min_days: 1, max_days: 2 },
{ pincode: 363007, min_days: 1, max_days: 2 },
{ pincode: 363020, min_days: 1, max_days: 2 },
{ pincode: 363022, min_days: 1, max_days: 2 },
{ pincode: 363023, min_days: 1, max_days: 2 },
{ pincode: 363030, min_days: 1, max_days: 2 },
{ pincode: 363031, min_days: 1, max_days: 2 },
{ pincode: 363035, min_days: 1, max_days: 2 },
{ pincode: 363039, min_days: 1, max_days: 2 },
{ pincode: 363040, min_days: 1, max_days: 2 },
{ pincode: 363110, min_days: 1, max_days: 2 },
{ pincode: 363115, min_days: 1, max_days: 2 },
{ pincode: 363310, min_days: 1, max_days: 2 },
{ pincode: 363312, min_days: 1, max_days: 2 },
{ pincode: 363315, min_days: 1, max_days: 2 },
{ pincode: 363320, min_days: 1, max_days: 2 },
{ pincode: 363330, min_days: 1, max_days: 2 },
{ pincode: 363333, min_days: 1, max_days: 2 },
{ pincode: 363334, min_days: 1, max_days: 2 },
{ pincode: 363351, min_days: 2, max_days: 3 },
{ pincode: 363410, min_days: 1, max_days: 2 },
{ pincode: 363412, min_days: 1, max_days: 2 },
{ pincode: 363415, min_days: 1, max_days: 2 },
{ pincode: 363421, min_days: 1, max_days: 2 },
{ pincode: 363423, min_days: 1, max_days: 2 },
{ pincode: 363424, min_days: 1, max_days: 2 },
{ pincode: 363426, min_days: 1, max_days: 2 },
{ pincode: 363427, min_days: 1, max_days: 2 },
{ pincode: 363430, min_days: 1, max_days: 2 },
{ pincode: 363435, min_days: 1, max_days: 2 },
{ pincode: 363440, min_days: 1, max_days: 2 },
{ pincode: 363510, min_days: 1, max_days: 2 },
{ pincode: 363520, min_days: 1, max_days: 2 },
{ pincode: 363530, min_days: 1, max_days: 2 },
{ pincode: 363535, min_days: 1, max_days: 2 },
{ pincode: 363610, min_days: 1, max_days: 2 },
{ pincode: 363621, min_days: 1, max_days: 2 },
{ pincode: 363622, min_days: 1, max_days: 2 },
{ pincode: 363623, min_days: 1, max_days: 2 },
{ pincode: 363626, min_days: 1, max_days: 2 },
{ pincode: 363630, min_days: 1, max_days: 2 },
{ pincode: 363631, min_days: 1, max_days: 2 },
{ pincode: 363636, min_days: 1, max_days: 2 },
{ pincode: 363641, min_days: 1, max_days: 2 },
{ pincode: 363642, min_days: 1, max_days: 2 },
{ pincode: 363643, min_days: 2, max_days: 3 },
{ pincode: 363646, min_days: 2, max_days: 3 },
{ pincode: 363650, min_days: 1, max_days: 2 },
{ pincode: 363655, min_days: 1, max_days: 2 },
{ pincode: 363660, min_days: 2, max_days: 3 },
{ pincode: 363665, min_days: 1, max_days: 2 },
{ pincode: 363667, min_days: 1, max_days: 2 },
{ pincode: 363669, min_days: 1, max_days: 2 },
{ pincode: 363670, min_days: 2, max_days: 3 },
{ pincode: 363745, min_days: 1, max_days: 2 },
{ pincode: 363750, min_days: 1, max_days: 2 },
{ pincode: 363755, min_days: 1, max_days: 2 },
{ pincode: 363760, min_days: 1, max_days: 2 },
{ pincode: 363765, min_days: 1, max_days: 2 },
{ pincode: 363775, min_days: 2, max_days: 3 },
{ pincode: 363780, min_days: 2, max_days: 3 },
{ pincode: 364001, min_days: 1, max_days: 2 },
{ pincode: 364002, min_days: 1, max_days: 2 },
{ pincode: 364003, min_days: 1, max_days: 2 },
{ pincode: 364004, min_days: 1, max_days: 2 },
{ pincode: 364005, min_days: 1, max_days: 2 },
{ pincode: 364006, min_days: 1, max_days: 2 },
{ pincode: 364022, min_days: 1, max_days: 2 },
{ pincode: 364050, min_days: 1, max_days: 2 },
{ pincode: 364060, min_days: 1, max_days: 2 },
{ pincode: 364070, min_days: 1, max_days: 2 },
{ pincode: 364081, min_days: 1, max_days: 2 },
{ pincode: 364110, min_days: 1, max_days: 2 },
{ pincode: 364120, min_days: 1, max_days: 2 },
{ pincode: 364130, min_days: 1, max_days: 2 },
{ pincode: 364135, min_days: 1, max_days: 2 },
{ pincode: 364140, min_days: 1, max_days: 2 },
{ pincode: 364145, min_days: 1, max_days: 2 },
{ pincode: 364150, min_days: 1, max_days: 2 },
{ pincode: 364210, min_days: 1, max_days: 2 },
{ pincode: 364215, min_days: 1, max_days: 2 },
{ pincode: 364220, min_days: 1, max_days: 2 },
{ pincode: 364225, min_days: 1, max_days: 2 },
{ pincode: 364230, min_days: 1, max_days: 2 },
{ pincode: 364240, min_days: 1, max_days: 2 },
{ pincode: 364241, min_days: 1, max_days: 2 },
{ pincode: 364245, min_days: 1, max_days: 2 },
{ pincode: 364250, min_days: 1, max_days: 2 },
{ pincode: 364260, min_days: 1, max_days: 2 },
{ pincode: 364265, min_days: 1, max_days: 2 },
{ pincode: 364270, min_days: 1, max_days: 2 },
{ pincode: 364275, min_days: 1, max_days: 2 },
{ pincode: 364280, min_days: 1, max_days: 2 },
{ pincode: 364290, min_days: 1, max_days: 2 },
{ pincode: 364292, min_days: 1, max_days: 2 },
{ pincode: 364293, min_days: 1, max_days: 2 },
{ pincode: 364295, min_days: 1, max_days: 2 },
{ pincode: 364297, min_days: 1, max_days: 2 },
{ pincode: 364310, min_days: 1, max_days: 2 },
{ pincode: 364313, min_days: 1, max_days: 2 },
{ pincode: 364315, min_days: 1, max_days: 2 },
{ pincode: 364320, min_days: 1, max_days: 2 },
{ pincode: 364330, min_days: 1, max_days: 2 },
{ pincode: 364455, min_days: 1, max_days: 2 },
{ pincode: 364457, min_days: 1, max_days: 2 },
{ pincode: 364465, min_days: 1, max_days: 2 },
{ pincode: 364470, min_days: 1, max_days: 2 },
{ pincode: 364485, min_days: 1, max_days: 2 },
{ pincode: 364490, min_days: 1, max_days: 2 },
{ pincode: 364505, min_days: 1, max_days: 2 },
{ pincode: 364510, min_days: 1, max_days: 2 },
{ pincode: 364515, min_days: 1, max_days: 2 },
{ pincode: 364521, min_days: 1, max_days: 2 },
{ pincode: 364522, min_days: 1, max_days: 2 },
{ pincode: 364524, min_days: 1, max_days: 2 },
{ pincode: 364525, min_days: 2, max_days: 3 },
{ pincode: 364530, min_days: 1, max_days: 2 },
{ pincode: 364536, min_days: 1, max_days: 2 },
{ pincode: 364537, min_days: 1, max_days: 2 },
{ pincode: 364540, min_days: 1, max_days: 2 },
{ pincode: 364560, min_days: 1, max_days: 2 },
{ pincode: 364561, min_days: 1, max_days: 2 },
{ pincode: 364565, min_days: 1, max_days: 2 },
{ pincode: 364570, min_days: 1, max_days: 2 },
{ pincode: 364601, min_days: 1, max_days: 2 },
{ pincode: 364615, min_days: 1, max_days: 2 },
{ pincode: 364660, min_days: 1, max_days: 2 },
{ pincode: 364710, min_days: 1, max_days: 2 },
{ pincode: 364712, min_days: 1, max_days: 2 },
{ pincode: 364713, min_days: 1, max_days: 2 },
{ pincode: 364714, min_days: 1, max_days: 2 },
{ pincode: 364720, min_days: 1, max_days: 2 },
{ pincode: 364730, min_days: 1, max_days: 2 },
{ pincode: 364740, min_days: 1, max_days: 2 },
{ pincode: 364750, min_days: 1, max_days: 2 },
{ pincode: 364760, min_days: 1, max_days: 2 },
{ pincode: 364765, min_days: 1, max_days: 2 },
{ pincode: 365001, min_days: 1, max_days: 2 },
{ pincode: 365220, min_days: 1, max_days: 2 },
{ pincode: 365410, min_days: 1, max_days: 2 },
{ pincode: 365421, min_days: 1, max_days: 2 },
{ pincode: 365430, min_days: 1, max_days: 2 },
{ pincode: 365435, min_days: 1, max_days: 2 },
{ pincode: 365440, min_days: 1, max_days: 2 },
{ pincode: 365450, min_days: 1, max_days: 2 },
{ pincode: 365455, min_days: 1, max_days: 2 },
{ pincode: 365456, min_days: 1, max_days: 2 },
{ pincode: 365460, min_days: 1, max_days: 2 },
{ pincode: 365480, min_days: 1, max_days: 2 },
{ pincode: 365490, min_days: 2, max_days: 3 },
{ pincode: 365535, min_days: 1, max_days: 2 },
{ pincode: 365540, min_days: 1, max_days: 2 },
{ pincode: 365541, min_days: 1, max_days: 2 },
{ pincode: 365545, min_days: 1, max_days: 2 },
{ pincode: 365550, min_days: 2, max_days: 3 },
{ pincode: 365555, min_days: 1, max_days: 2 },
{ pincode: 365560, min_days: 1, max_days: 2 },
{ pincode: 365601, min_days: 1, max_days: 2 },
{ pincode: 365610, min_days: 1, max_days: 2 },
{ pincode: 365615, min_days: 1, max_days: 2 },
{ pincode: 365616, min_days: 1, max_days: 2 },
{ pincode: 365620, min_days: 1, max_days: 2 },
{ pincode: 365630, min_days: 1, max_days: 2 },
{ pincode: 365635, min_days: 1, max_days: 2 },
{ pincode: 365640, min_days: 1, max_days: 2 },
{ pincode: 365645, min_days: 1, max_days: 2 },
{ pincode: 365650, min_days: 1, max_days: 2 },
{ pincode: 365660, min_days: 1, max_days: 2 },
{ pincode: 365665, min_days: 1, max_days: 2 },
{ pincode: 365730, min_days: 1, max_days: 2 },
{ pincode: 370001, min_days: 1, max_days: 2 },
{ pincode: 370002, min_days: 1, max_days: 2 },
{ pincode: 370006, min_days: 1, max_days: 2 },
{ pincode: 370007, min_days: 1, max_days: 2 },
{ pincode: 370015, min_days: 1, max_days: 2 },
{ pincode: 370020, min_days: 1, max_days: 2 },
{ pincode: 370030, min_days: 2, max_days: 3 },
{ pincode: 370040, min_days: 1, max_days: 2 },
{ pincode: 370105, min_days: 2, max_days: 3 },
{ pincode: 370110, min_days: 1, max_days: 2 },
{ pincode: 370111, min_days: 1, max_days: 2 },
{ pincode: 370115, min_days: 1, max_days: 2 },
{ pincode: 370130, min_days: 1, max_days: 2 },
{ pincode: 370135, min_days: 1, max_days: 2 },
{ pincode: 370140, min_days: 1, max_days: 2 },
{ pincode: 370145, min_days: 2, max_days: 3 },
{ pincode: 370150, min_days: 1, max_days: 2 },
{ pincode: 370155, min_days: 1, max_days: 2 },
{ pincode: 370156, min_days: 1, max_days: 2 },
{ pincode: 370160, min_days: 1, max_days: 2 },
{ pincode: 370165, min_days: 1, max_days: 2 },
{ pincode: 370170, min_days: 1, max_days: 2 },
{ pincode: 370201, min_days: 1, max_days: 2 },
{ pincode: 370202, min_days: 1, max_days: 2 },
{ pincode: 370203, min_days: 1, max_days: 2 },
{ pincode: 370204, min_days: 1, max_days: 2 },
{ pincode: 370205, min_days: 1, max_days: 2 },
{ pincode: 370210, min_days: 1, max_days: 2 },
{ pincode: 370230, min_days: 1, max_days: 2 },
{ pincode: 370240, min_days: 1, max_days: 2 },
{ pincode: 370405, min_days: 1, max_days: 2 },
{ pincode: 370410, min_days: 1, max_days: 2 },
{ pincode: 370415, min_days: 1, max_days: 2 },
{ pincode: 370421, min_days: 1, max_days: 2 },
{ pincode: 370425, min_days: 2, max_days: 3 },
{ pincode: 370427, min_days: 1, max_days: 2 },
{ pincode: 370430, min_days: 2, max_days: 3 },
{ pincode: 370435, min_days: 1, max_days: 2 },
{ pincode: 370445, min_days: 1, max_days: 2 },
{ pincode: 370450, min_days: 1, max_days: 2 },
{ pincode: 370455, min_days: 1, max_days: 2 },
{ pincode: 370460, min_days: 1, max_days: 2 },
{ pincode: 370465, min_days: 1, max_days: 2 },
{ pincode: 370475, min_days: 1, max_days: 2 },
{ pincode: 370485, min_days: 1, max_days: 2 },
{ pincode: 370490, min_days: 1, max_days: 2 },
{ pincode: 370510, min_days: 2, max_days: 3 },
{ pincode: 370511, min_days: 1, max_days: 2 },
{ pincode: 370601, min_days: 2, max_days: 3 },
{ pincode: 370605, min_days: 1, max_days: 2 },
{ pincode: 370610, min_days: 1, max_days: 2 },
{ pincode: 370615, min_days: 1, max_days: 2 },
{ pincode: 370620, min_days: 1, max_days: 2 },
{ pincode: 370625, min_days: 1, max_days: 2 },
{ pincode: 370627, min_days: 1, max_days: 2 },
{ pincode: 370630, min_days: 1, max_days: 2 },
{ pincode: 370640, min_days: 1, max_days: 2 },
{ pincode: 370641, min_days: 2, max_days: 3 },
{ pincode: 370645, min_days: 1, max_days: 2 },
{ pincode: 370650, min_days: 1, max_days: 2 },
{ pincode: 370655, min_days: 1, max_days: 2 },
{ pincode: 370660, min_days: 1, max_days: 2 },
{ pincode: 370665, min_days: 1, max_days: 2 },
{ pincode: 370670, min_days: 1, max_days: 2 },
{ pincode: 370675, min_days: 1, max_days: 2 },
{ pincode: 380000, min_days: 1, max_days: 2 },
{ pincode: 380001, min_days: 1, max_days: 2 },
{ pincode: 380002, min_days: 1, max_days: 2 },
{ pincode: 380003, min_days: 1, max_days: 2 },
{ pincode: 380004, min_days: 1, max_days: 2 },
{ pincode: 380005, min_days: 1, max_days: 2 },
{ pincode: 380006, min_days: 1, max_days: 2 },
{ pincode: 380007, min_days: 1, max_days: 2 },
{ pincode: 380008, min_days: 1, max_days: 2 },
{ pincode: 380009, min_days: 1, max_days: 2 },
{ pincode: 380010, min_days: 1, max_days: 2 },
{ pincode: 380011, min_days: 1, max_days: 2 },
{ pincode: 380012, min_days: 1, max_days: 2 },
{ pincode: 380013, min_days: 1, max_days: 2 },
{ pincode: 380014, min_days: 1, max_days: 2 },
{ pincode: 380015, min_days: 1, max_days: 2 },
{ pincode: 380016, min_days: 1, max_days: 2 },
{ pincode: 380017, min_days: 1, max_days: 2 },
{ pincode: 380018, min_days: 1, max_days: 2 },
{ pincode: 380019, min_days: 1, max_days: 2 },
{ pincode: 380020, min_days: 1, max_days: 2 },
{ pincode: 380021, min_days: 1, max_days: 2 },
{ pincode: 380022, min_days: 1, max_days: 2 },
{ pincode: 380023, min_days: 1, max_days: 2 },
{ pincode: 380024, min_days: 1, max_days: 2 },
{ pincode: 380025, min_days: 1, max_days: 2 },
{ pincode: 380026, min_days: 1, max_days: 2 },
{ pincode: 380027, min_days: 1, max_days: 2 },
{ pincode: 380028, min_days: 1, max_days: 2 },
{ pincode: 380029, min_days: 1, max_days: 2 },
{ pincode: 380030, min_days: 1, max_days: 2 },
{ pincode: 380038, min_days: 1, max_days: 2 },
{ pincode: 380041, min_days: 1, max_days: 2 },
{ pincode: 380043, min_days: 1, max_days: 2 },
{ pincode: 380045, min_days: 1, max_days: 2 },
{ pincode: 380049, min_days: 1, max_days: 2 },
{ pincode: 380050, min_days: 1, max_days: 2 },
{ pincode: 380051, min_days: 1, max_days: 2 },
{ pincode: 380052, min_days: 1, max_days: 2 },
{ pincode: 380053, min_days: 1, max_days: 2 },
{ pincode: 380054, min_days: 1, max_days: 2 },
{ pincode: 380055, min_days: 1, max_days: 2 },
{ pincode: 380056, min_days: 1, max_days: 2 },
{ pincode: 380057, min_days: 1, max_days: 2 },
{ pincode: 380058, min_days: 1, max_days: 2 },
{ pincode: 380059, min_days: 1, max_days: 2 },
{ pincode: 380060, min_days: 1, max_days: 2 },
{ pincode: 380061, min_days: 1, max_days: 2 },
{ pincode: 380062, min_days: 1, max_days: 2 },
{ pincode: 380063, min_days: 1, max_days: 2 },
{ pincode: 380081, min_days: 1, max_days: 2 },
{ pincode: 380123, min_days: 1, max_days: 2 },
{ pincode: 380202, min_days: 1, max_days: 2 },
{ pincode: 380210, min_days: 1, max_days: 2 },
{ pincode: 380215, min_days: 1, max_days: 2 },
{ pincode: 380316, min_days: 1, max_days: 2 },
{ pincode: 380330, min_days: 1, max_days: 2 },
{ pincode: 380452, min_days: 1, max_days: 2 },
{ pincode: 380481, min_days: 1, max_days: 2 },
{ pincode: 381156, min_days: 1, max_days: 2 },
{ pincode: 381520, min_days: 1, max_days: 2 },
{ pincode: 382000, min_days: 1, max_days: 2 },
{ pincode: 382001, min_days: 1, max_days: 2 },
{ pincode: 382002, min_days: 1, max_days: 2 },
{ pincode: 382003, min_days: 1, max_days: 2 },
{ pincode: 382004, min_days: 1, max_days: 2 },
{ pincode: 382005, min_days: 1, max_days: 2 },
{ pincode: 382006, min_days: 1, max_days: 2 },
{ pincode: 382007, min_days: 1, max_days: 2 },
{ pincode: 382008, min_days: 1, max_days: 2 },
{ pincode: 382009, min_days: 1, max_days: 2 },
{ pincode: 382010, min_days: 1, max_days: 2 },
{ pincode: 382011, min_days: 1, max_days: 2 },
{ pincode: 382012, min_days: 1, max_days: 2 },
{ pincode: 382013, min_days: 1, max_days: 2 },
{ pincode: 382014, min_days: 1, max_days: 2 },
{ pincode: 382015, min_days: 1, max_days: 2 },
{ pincode: 382016, min_days: 1, max_days: 2 },
{ pincode: 382017, min_days: 1, max_days: 2 },
{ pincode: 382018, min_days: 1, max_days: 2 },
{ pincode: 382019, min_days: 1, max_days: 2 },
{ pincode: 382020, min_days: 1, max_days: 2 },
{ pincode: 382021, min_days: 1, max_days: 2 },
{ pincode: 382022, min_days: 1, max_days: 2 },
{ pincode: 382023, min_days: 1, max_days: 2 },
{ pincode: 382024, min_days: 1, max_days: 2 },
{ pincode: 382025, min_days: 1, max_days: 2 },
{ pincode: 382026, min_days: 1, max_days: 2 },
{ pincode: 382027, min_days: 1, max_days: 2 },
{ pincode: 382028, min_days: 1, max_days: 2 },
{ pincode: 382029, min_days: 1, max_days: 2 },
{ pincode: 382030, min_days: 1, max_days: 2 },
{ pincode: 382041, min_days: 1, max_days: 2 },
{ pincode: 382042, min_days: 1, max_days: 2 },
{ pincode: 382043, min_days: 1, max_days: 2 },
{ pincode: 382044, min_days: 1, max_days: 2 },
{ pincode: 382045, min_days: 1, max_days: 2 },
{ pincode: 382051, min_days: 1, max_days: 2 },
{ pincode: 382055, min_days: 2, max_days: 3 },
{ pincode: 382110, min_days: 1, max_days: 2 },
{ pincode: 382115, min_days: 1, max_days: 2 },
{ pincode: 382120, min_days: 1, max_days: 2 },
{ pincode: 382130, min_days: 1, max_days: 2 },
{ pincode: 382140, min_days: 1, max_days: 2 },
{ pincode: 382145, min_days: 1, max_days: 2 },
{ pincode: 382150, min_days: 1, max_days: 2 },
{ pincode: 382155, min_days: 1, max_days: 2 },
{ pincode: 382160, min_days: 1, max_days: 2 },
{ pincode: 382165, min_days: 1, max_days: 2 },
{ pincode: 382170, min_days: 1, max_days: 2 },
{ pincode: 382210, min_days: 1, max_days: 2 },
{ pincode: 382211, min_days: 1, max_days: 2 },
{ pincode: 382213, min_days: 1, max_days: 2 },
{ pincode: 382220, min_days: 1, max_days: 2 },
{ pincode: 382225, min_days: 1, max_days: 2 },
{ pincode: 382230, min_days: 1, max_days: 2 },
{ pincode: 382240, min_days: 1, max_days: 2 },
{ pincode: 382245, min_days: 1, max_days: 2 },
{ pincode: 382250, min_days: 1, max_days: 2 },
{ pincode: 382255, min_days: 1, max_days: 2 },
{ pincode: 382260, min_days: 1, max_days: 2 },
{ pincode: 382265, min_days: 1, max_days: 2 },
{ pincode: 382270, min_days: 1, max_days: 2 },
{ pincode: 382305, min_days: 1, max_days: 2 },
{ pincode: 382308, min_days: 1, max_days: 2 },
{ pincode: 382310, min_days: 1, max_days: 2 },
{ pincode: 382315, min_days: 1, max_days: 2 },
{ pincode: 382316, min_days: 1, max_days: 2 },
{ pincode: 382320, min_days: 1, max_days: 2 },
{ pincode: 382321, min_days: 1, max_days: 2 },
{ pincode: 382324, min_days: 1, max_days: 2 },
{ pincode: 382325, min_days: 1, max_days: 2 },
{ pincode: 382327, min_days: 1, max_days: 2 },
{ pincode: 382330, min_days: 1, max_days: 2 },
{ pincode: 382333, min_days: 1, max_days: 2 },
{ pincode: 382340, min_days: 1, max_days: 2 },
{ pincode: 382345, min_days: 1, max_days: 2 },
{ pincode: 382346, min_days: 1, max_days: 2 },
{ pincode: 382350, min_days: 1, max_days: 2 },
{ pincode: 382352, min_days: 1, max_days: 2 },
{ pincode: 382355, min_days: 1, max_days: 2 },
{ pincode: 382360, min_days: 1, max_days: 2 },
{ pincode: 382404, min_days: 1, max_days: 2 },
{ pincode: 382405, min_days: 1, max_days: 2 },
{ pincode: 382410, min_days: 1, max_days: 2 },
{ pincode: 382415, min_days: 1, max_days: 2 },
{ pincode: 382418, min_days: 1, max_days: 2 },
{ pincode: 382419, min_days: 2, max_days: 3 },
{ pincode: 382420, min_days: 1, max_days: 2 },
{ pincode: 382421, min_days: 1, max_days: 2 },
{ pincode: 382422, min_days: 1, max_days: 2 },
{ pincode: 382423, min_days: 1, max_days: 2 },
{ pincode: 382424, min_days: 1, max_days: 2 },
{ pincode: 382425, min_days: 1, max_days: 2 },
{ pincode: 382426, min_days: 1, max_days: 2 },
{ pincode: 382427, min_days: 1, max_days: 2 },
{ pincode: 382428, min_days: 1, max_days: 2 },
{ pincode: 382430, min_days: 1, max_days: 2 },
{ pincode: 382433, min_days: 1, max_days: 2 },
{ pincode: 382435, min_days: 1, max_days: 2 },
{ pincode: 382440, min_days: 1, max_days: 2 },
{ pincode: 382442, min_days: 1, max_days: 2 },
{ pincode: 382443, min_days: 1, max_days: 2 },
{ pincode: 382445, min_days: 1, max_days: 2 },
{ pincode: 382449, min_days: 1, max_days: 2 },
{ pincode: 382450, min_days: 1, max_days: 2 },
{ pincode: 382455, min_days: 1, max_days: 2 },
{ pincode: 382460, min_days: 1, max_days: 2 },
{ pincode: 382463, min_days: 1, max_days: 2 },
{ pincode: 382465, min_days: 1, max_days: 2 },
{ pincode: 382470, min_days: 1, max_days: 2 },
{ pincode: 382475, min_days: 1, max_days: 2 },
{ pincode: 382480, min_days: 1, max_days: 2 },
{ pincode: 382481, min_days: 1, max_days: 2 },
{ pincode: 382501, min_days: 2, max_days: 3 },
{ pincode: 382610, min_days: 1, max_days: 2 },
{ pincode: 382620, min_days: 1, max_days: 2 },
{ pincode: 382625, min_days: 1, max_days: 2 },
{ pincode: 382630, min_days: 1, max_days: 2 },
{ pincode: 382640, min_days: 1, max_days: 2 },
{ pincode: 382644, min_days: 1, max_days: 2 },
{ pincode: 382650, min_days: 1, max_days: 2 },
{ pincode: 382655, min_days: 1, max_days: 2 },
{ pincode: 382704, min_days: 1, max_days: 2 },
{ pincode: 382705, min_days: 1, max_days: 2 },
{ pincode: 382706, min_days: 1, max_days: 2 },
{ pincode: 382707, min_days: 1, max_days: 2 },
{ pincode: 382708, min_days: 1, max_days: 2 },
{ pincode: 382709, min_days: 1, max_days: 2 },
{ pincode: 382710, min_days: 1, max_days: 2 },
{ pincode: 382711, min_days: 1, max_days: 2 },
{ pincode: 382712, min_days: 1, max_days: 2 },
{ pincode: 382713, min_days: 1, max_days: 2 },
{ pincode: 382715, min_days: 1, max_days: 2 },
{ pincode: 382716, min_days: 1, max_days: 2 },
{ pincode: 382717, min_days: 1, max_days: 2 },
{ pincode: 382718, min_days: 1, max_days: 2 },
{ pincode: 382719, min_days: 1, max_days: 2 },
{ pincode: 382720, min_days: 1, max_days: 2 },
{ pincode: 382721, min_days: 1, max_days: 2 },
{ pincode: 382722, min_days: 1, max_days: 2 },
{ pincode: 382723, min_days: 1, max_days: 2 },
{ pincode: 382724, min_days: 1, max_days: 2 },
{ pincode: 382725, min_days: 1, max_days: 2 },
{ pincode: 382727, min_days: 1, max_days: 2 },
{ pincode: 382728, min_days: 1, max_days: 2 },
{ pincode: 382729, min_days: 1, max_days: 2 },
{ pincode: 382730, min_days: 1, max_days: 2 },
{ pincode: 382731, min_days: 1, max_days: 2 },
{ pincode: 382732, min_days: 1, max_days: 2 },
{ pincode: 382733, min_days: 1, max_days: 2 },
{ pincode: 382735, min_days: 1, max_days: 2 },
{ pincode: 382736, min_days: 1, max_days: 2 },
{ pincode: 382737, min_days: 1, max_days: 2 },
{ pincode: 382740, min_days: 1, max_days: 2 },
{ pincode: 382741, min_days: 1, max_days: 2 },
{ pincode: 382743, min_days: 1, max_days: 2 },
{ pincode: 382745, min_days: 1, max_days: 2 },
{ pincode: 382750, min_days: 1, max_days: 2 },
{ pincode: 382755, min_days: 1, max_days: 2 },
{ pincode: 382760, min_days: 1, max_days: 2 },
{ pincode: 382765, min_days: 1, max_days: 2 },
{ pincode: 382775, min_days: 1, max_days: 2 },
{ pincode: 382780, min_days: 1, max_days: 2 },
{ pincode: 382805, min_days: 1, max_days: 2 },
{ pincode: 382806, min_days: 1, max_days: 2 },
{ pincode: 382810, min_days: 1, max_days: 2 },
{ pincode: 382815, min_days: 1, max_days: 2 },
{ pincode: 382816, min_days: 1, max_days: 2 },
{ pincode: 382820, min_days: 1, max_days: 2 },
{ pincode: 382825, min_days: 1, max_days: 2 },
{ pincode: 382826, min_days: 1, max_days: 2 },
{ pincode: 382830, min_days: 1, max_days: 2 },
{ pincode: 382831, min_days: 1, max_days: 2 },
{ pincode: 382833, min_days: 1, max_days: 2 },
{ pincode: 382835, min_days: 1, max_days: 2 },
{ pincode: 382840, min_days: 1, max_days: 2 },
{ pincode: 382845, min_days: 1, max_days: 2 },
{ pincode: 382850, min_days: 1, max_days: 2 },
{ pincode: 382851, min_days: 1, max_days: 2 },
{ pincode: 382855, min_days: 1, max_days: 2 },
{ pincode: 382857, min_days: 1, max_days: 2 },
{ pincode: 382860, min_days: 1, max_days: 2 },
{ pincode: 382861, min_days: 1, max_days: 2 },
{ pincode: 382865, min_days: 1, max_days: 2 },
{ pincode: 382870, min_days: 1, max_days: 2 },
{ pincode: 382871, min_days: 1, max_days: 2 },
{ pincode: 382875, min_days: 1, max_days: 2 },
{ pincode: 383001, min_days: 1, max_days: 2 },
{ pincode: 383002, min_days: 1, max_days: 2 },
{ pincode: 383004, min_days: 2, max_days: 3 },
{ pincode: 383006, min_days: 1, max_days: 2 },
{ pincode: 383009, min_days: 2, max_days: 3 },
{ pincode: 383010, min_days: 1, max_days: 2 },
{ pincode: 383030, min_days: 1, max_days: 2 },
{ pincode: 383110, min_days: 1, max_days: 2 },
{ pincode: 383120, min_days: 1, max_days: 2 },
{ pincode: 383205, min_days: 1, max_days: 2 },
{ pincode: 383210, min_days: 1, max_days: 2 },
{ pincode: 383215, min_days: 1, max_days: 2 },
{ pincode: 383220, min_days: 1, max_days: 2 },
{ pincode: 383225, min_days: 1, max_days: 2 },
{ pincode: 383230, min_days: 1, max_days: 2 },
{ pincode: 383235, min_days: 1, max_days: 2 },
{ pincode: 383240, min_days: 1, max_days: 2 },
{ pincode: 383245, min_days: 1, max_days: 2 },
{ pincode: 383246, min_days: 1, max_days: 2 },
{ pincode: 383250, min_days: 1, max_days: 2 },
{ pincode: 383251, min_days: 1, max_days: 2 },
{ pincode: 383255, min_days: 1, max_days: 2 },
{ pincode: 383260, min_days: 1, max_days: 2 },
{ pincode: 383270, min_days: 2, max_days: 3 },
{ pincode: 383275, min_days: 1, max_days: 2 },
{ pincode: 383276, min_days: 1, max_days: 2 },
{ pincode: 383305, min_days: 1, max_days: 2 },
{ pincode: 383307, min_days: 1, max_days: 2 },
{ pincode: 383310, min_days: 1, max_days: 2 },
{ pincode: 383315, min_days: 1, max_days: 2 },
{ pincode: 383316, min_days: 1, max_days: 2 },
{ pincode: 383317, min_days: 1, max_days: 2 },
{ pincode: 383320, min_days: 1, max_days: 2 },
{ pincode: 383325, min_days: 1, max_days: 2 },
{ pincode: 383327, min_days: 1, max_days: 2 },
{ pincode: 383330, min_days: 1, max_days: 2 },
{ pincode: 383335, min_days: 1, max_days: 2 },
{ pincode: 383340, min_days: 1, max_days: 2 },
{ pincode: 383341, min_days: 1, max_days: 2 },
{ pincode: 383345, min_days: 1, max_days: 2 },
{ pincode: 383350, min_days: 1, max_days: 2 },
{ pincode: 383354, min_days: 2, max_days: 3 },
{ pincode: 383355, min_days: 1, max_days: 2 },
{ pincode: 383410, min_days: 1, max_days: 2 },
{ pincode: 383421, min_days: 1, max_days: 2 },
{ pincode: 383422, min_days: 2, max_days: 3 },
{ pincode: 383430, min_days: 1, max_days: 2 },
{ pincode: 383434, min_days: 1, max_days: 2 },
{ pincode: 383440, min_days: 1, max_days: 2 },
{ pincode: 383450, min_days: 1, max_days: 2 },
{ pincode: 383460, min_days: 1, max_days: 2 },
{ pincode: 383462, min_days: 1, max_days: 2 },
{ pincode: 384001, min_days: 1, max_days: 2 },
{ pincode: 384002, min_days: 1, max_days: 2 },
{ pincode: 384003, min_days: 1, max_days: 2 },
{ pincode: 384004, min_days: 1, max_days: 2 },
{ pincode: 384005, min_days: 1, max_days: 2 },
{ pincode: 384011, min_days: 1, max_days: 2 },
{ pincode: 384012, min_days: 1, max_days: 2 },
{ pincode: 384110, min_days: 1, max_days: 2 },
{ pincode: 384120, min_days: 1, max_days: 2 },
{ pincode: 384121, min_days: 1, max_days: 2 },
{ pincode: 384122, min_days: 1, max_days: 2 },
{ pincode: 384130, min_days: 1, max_days: 2 },
{ pincode: 384131, min_days: 1, max_days: 2 },
{ pincode: 384135, min_days: 1, max_days: 2 },
{ pincode: 384140, min_days: 1, max_days: 2 },
{ pincode: 384151, min_days: 1, max_days: 2 },
{ pincode: 384152, min_days: 1, max_days: 2 },
{ pincode: 384153, min_days: 1, max_days: 2 },
{ pincode: 384154, min_days: 1, max_days: 2 },
{ pincode: 384160, min_days: 1, max_days: 2 },
{ pincode: 384165, min_days: 1, max_days: 2 },
{ pincode: 384170, min_days: 1, max_days: 2 },
{ pincode: 384171, min_days: 1, max_days: 2 },
{ pincode: 384172, min_days: 1, max_days: 2 },
{ pincode: 384174, min_days: 1, max_days: 2 },
{ pincode: 384175, min_days: 1, max_days: 2 },
{ pincode: 384176, min_days: 1, max_days: 2 },
{ pincode: 384177, min_days: 1, max_days: 2 },
{ pincode: 384178, min_days: 1, max_days: 2 },
{ pincode: 384205, min_days: 1, max_days: 2 },
{ pincode: 384206, min_days: 1, max_days: 2 },
{ pincode: 384207, min_days: 1, max_days: 2 },
{ pincode: 384210, min_days: 1, max_days: 2 },
{ pincode: 384211, min_days: 1, max_days: 2 },
{ pincode: 384212, min_days: 1, max_days: 2 },
{ pincode: 384213, min_days: 1, max_days: 2 },
{ pincode: 384215, min_days: 1, max_days: 2 },
{ pincode: 384220, min_days: 1, max_days: 2 },
{ pincode: 384221, min_days: 1, max_days: 2 },
{ pincode: 384225, min_days: 1, max_days: 2 },
{ pincode: 384229, min_days: 1, max_days: 2 },
{ pincode: 384230, min_days: 1, max_days: 2 },
{ pincode: 384231, min_days: 1, max_days: 2 },
{ pincode: 384240, min_days: 1, max_days: 2 },
{ pincode: 384241, min_days: 1, max_days: 2 },
{ pincode: 384245, min_days: 1, max_days: 2 },
{ pincode: 384246, min_days: 1, max_days: 2 },
{ pincode: 384250, min_days: 1, max_days: 2 },
{ pincode: 384255, min_days: 1, max_days: 2 },
{ pincode: 384256, min_days: 1, max_days: 2 },
{ pincode: 384257, min_days: 1, max_days: 2 },
{ pincode: 384260, min_days: 1, max_days: 2 },
{ pincode: 384261, min_days: 1, max_days: 2 },
{ pincode: 384265, min_days: 1, max_days: 2 },
{ pincode: 384266, min_days: 2, max_days: 3 },
{ pincode: 384270, min_days: 1, max_days: 2 },
{ pincode: 384271, min_days: 1, max_days: 2 },
{ pincode: 384272, min_days: 1, max_days: 2 },
{ pincode: 384273, min_days: 1, max_days: 2 },
{ pincode: 384274, min_days: 1, max_days: 2 },
{ pincode: 384275, min_days: 1, max_days: 2 },
{ pincode: 384276, min_days: 1, max_days: 2 },
{ pincode: 384277, min_days: 1, max_days: 2 },
{ pincode: 384278, min_days: 1, max_days: 2 },
{ pincode: 384280, min_days: 1, max_days: 2 },
{ pincode: 384285, min_days: 1, max_days: 2 },
{ pincode: 384290, min_days: 1, max_days: 2 },
{ pincode: 384291, min_days: 1, max_days: 2 },
{ pincode: 384292, min_days: 1, max_days: 2 },
{ pincode: 384305, min_days: 1, max_days: 2 },
{ pincode: 384310, min_days: 1, max_days: 2 },
{ pincode: 384311, min_days: 1, max_days: 2 },
{ pincode: 384312, min_days: 1, max_days: 2 },
{ pincode: 384315, min_days: 1, max_days: 2 },
{ pincode: 384318, min_days: 1, max_days: 2 },
{ pincode: 384319, min_days: 1, max_days: 2 },
{ pincode: 384320, min_days: 1, max_days: 2 },
{ pincode: 384325, min_days: 1, max_days: 2 },
{ pincode: 384330, min_days: 1, max_days: 2 },
{ pincode: 384335, min_days: 1, max_days: 2 },
{ pincode: 384340, min_days: 1, max_days: 2 },
{ pincode: 384345, min_days: 1, max_days: 2 },
{ pincode: 384350, min_days: 1, max_days: 2 },
{ pincode: 384355, min_days: 1, max_days: 2 },
{ pincode: 384360, min_days: 1, max_days: 2 },
{ pincode: 384410, min_days: 1, max_days: 2 },
{ pincode: 384411, min_days: 1, max_days: 2 },
{ pincode: 384412, min_days: 2, max_days: 3 },
{ pincode: 384415, min_days: 1, max_days: 2 },
{ pincode: 384421, min_days: 1, max_days: 2 },
{ pincode: 384430, min_days: 1, max_days: 2 },
{ pincode: 384435, min_days: 1, max_days: 2 },
{ pincode: 384440, min_days: 1, max_days: 2 },
{ pincode: 384441, min_days: 2, max_days: 3 },
{ pincode: 384445, min_days: 1, max_days: 2 },
{ pincode: 384450, min_days: 2, max_days: 3 },
{ pincode: 384455, min_days: 2, max_days: 3 },
{ pincode: 384460, min_days: 1, max_days: 2 },
{ pincode: 384465, min_days: 1, max_days: 2 },
{ pincode: 384470, min_days: 1, max_days: 2 },
{ pincode: 384515, min_days: 2, max_days: 3 },
{ pincode: 384520, min_days: 2, max_days: 3 },
{ pincode: 384530, min_days: 2, max_days: 3 },
{ pincode: 384540, min_days: 2, max_days: 3 },
{ pincode: 384550, min_days: 1, max_days: 2 },
{ pincode: 384560, min_days: 2, max_days: 3 },
{ pincode: 384565, min_days: 1, max_days: 2 },
{ pincode: 384570, min_days: 1, max_days: 2 },
{ pincode: 385001, min_days: 1, max_days: 2 },
{ pincode: 385002, min_days: 1, max_days: 2 },
{ pincode: 385007, min_days: 1, max_days: 2 },
{ pincode: 385010, min_days: 1, max_days: 2 },
{ pincode: 385011, min_days: 1, max_days: 2 },
{ pincode: 385012, min_days: 1, max_days: 2 },
{ pincode: 385110, min_days: 1, max_days: 2 },
{ pincode: 385111, min_days: 1, max_days: 2 },
{ pincode: 385112, min_days: 1, max_days: 2 },
{ pincode: 385120, min_days: 1, max_days: 2 },
{ pincode: 385130, min_days: 2, max_days: 3 },
{ pincode: 385135, min_days: 2, max_days: 3 },
{ pincode: 385210, min_days: 1, max_days: 2 },
{ pincode: 385215, min_days: 1, max_days: 2 },
{ pincode: 385310, min_days: 1, max_days: 2 },
{ pincode: 385315, min_days: 1, max_days: 2 },
{ pincode: 385320, min_days: 1, max_days: 2 },
{ pincode: 385325, min_days: 1, max_days: 2 },
{ pincode: 385326, min_days: 1, max_days: 2 },
{ pincode: 385330, min_days: 1, max_days: 2 },
{ pincode: 385340, min_days: 1, max_days: 2 },
{ pincode: 385350, min_days: 1, max_days: 2 },
{ pincode: 385360, min_days: 1, max_days: 2 },
{ pincode: 385410, min_days: 1, max_days: 2 },
{ pincode: 385421, min_days: 1, max_days: 2 },
{ pincode: 385505, min_days: 1, max_days: 2 },
{ pincode: 385506, min_days: 1, max_days: 2 },
{ pincode: 385510, min_days: 1, max_days: 2 },
{ pincode: 385515, min_days: 1, max_days: 2 },
{ pincode: 385519, min_days: 1, max_days: 2 },
{ pincode: 385520, min_days: 1, max_days: 2 },
{ pincode: 385521, min_days: 1, max_days: 2 },
{ pincode: 385526, min_days: 1, max_days: 2 },
{ pincode: 385530, min_days: 1, max_days: 2 },
{ pincode: 385535, min_days: 1, max_days: 2 },
{ pincode: 385540, min_days: 1, max_days: 2 },
{ pincode: 385541, min_days: 1, max_days: 2 },
{ pincode: 385543, min_days: 1, max_days: 2 },
{ pincode: 385545, min_days: 1, max_days: 2 },
{ pincode: 385550, min_days: 1, max_days: 2 },
{ pincode: 385555, min_days: 1, max_days: 2 },
{ pincode: 385560, min_days: 1, max_days: 2 },
{ pincode: 385565, min_days: 1, max_days: 2 },
{ pincode: 385566, min_days: 1, max_days: 2 },
{ pincode: 385570, min_days: 1, max_days: 2 },
{ pincode: 385575, min_days: 1, max_days: 2 },
{ pincode: 385581, min_days: 2, max_days: 3 },
{ pincode: 387001, min_days: 1, max_days: 2 },
{ pincode: 387002, min_days: 1, max_days: 2 },
{ pincode: 387003, min_days: 1, max_days: 2 },
{ pincode: 387100, min_days: 1, max_days: 2 },
{ pincode: 387110, min_days: 1, max_days: 2 },
{ pincode: 387113, min_days: 1, max_days: 2 },
{ pincode: 387115, min_days: 1, max_days: 2 },
{ pincode: 387120, min_days: 1, max_days: 2 },
{ pincode: 387130, min_days: 1, max_days: 2 },
{ pincode: 387135, min_days: 1, max_days: 2 },
{ pincode: 387140, min_days: 1, max_days: 2 },
{ pincode: 387210, min_days: 1, max_days: 2 },
{ pincode: 387220, min_days: 1, max_days: 2 },
{ pincode: 387230, min_days: 1, max_days: 2 },
{ pincode: 387240, min_days: 1, max_days: 2 },
{ pincode: 387305, min_days: 1, max_days: 2 },
{ pincode: 387310, min_days: 1, max_days: 2 },
{ pincode: 387315, min_days: 1, max_days: 2 },
{ pincode: 387320, min_days: 1, max_days: 2 },
{ pincode: 387325, min_days: 1, max_days: 2 },
{ pincode: 387330, min_days: 1, max_days: 2 },
{ pincode: 387331, min_days: 1, max_days: 2 },
{ pincode: 387335, min_days: 1, max_days: 2 },
{ pincode: 387340, min_days: 1, max_days: 2 },
{ pincode: 387345, min_days: 1, max_days: 2 },
{ pincode: 387350, min_days: 1, max_days: 2 },
{ pincode: 387355, min_days: 1, max_days: 2 },
{ pincode: 387360, min_days: 1, max_days: 2 },
{ pincode: 387365, min_days: 1, max_days: 2 },
{ pincode: 387370, min_days: 1, max_days: 2 },
{ pincode: 387375, min_days: 1, max_days: 2 },
{ pincode: 387380, min_days: 1, max_days: 2 },
{ pincode: 387382, min_days: 1, max_days: 2 },
{ pincode: 387385, min_days: 1, max_days: 2 },
{ pincode: 387411, min_days: 1, max_days: 2 },
{ pincode: 387420, min_days: 1, max_days: 2 },
{ pincode: 387421, min_days: 1, max_days: 2 },
{ pincode: 387430, min_days: 1, max_days: 2 },
{ pincode: 387435, min_days: 1, max_days: 2 },
{ pincode: 387510, min_days: 1, max_days: 2 },
{ pincode: 387515, min_days: 1, max_days: 2 },
{ pincode: 387520, min_days: 1, max_days: 2 },
{ pincode: 387530, min_days: 1, max_days: 2 },
{ pincode: 387531, min_days: 1, max_days: 2 },
{ pincode: 387540, min_days: 1, max_days: 2 },
{ pincode: 387550, min_days: 1, max_days: 2 },
{ pincode: 387560, min_days: 1, max_days: 2 },
{ pincode: 387570, min_days: 1, max_days: 2 },
{ pincode: 387610, min_days: 1, max_days: 2 },
{ pincode: 387620, min_days: 1, max_days: 2 },
{ pincode: 387630, min_days: 1, max_days: 2 },
{ pincode: 387635, min_days: 1, max_days: 2 },
{ pincode: 387640, min_days: 1, max_days: 2 },
{ pincode: 387650, min_days: 1, max_days: 2 },
{ pincode: 387710, min_days: 1, max_days: 2 },
{ pincode: 387810, min_days: 1, max_days: 2 },
{ pincode: 388001, min_days: 1, max_days: 2 },
{ pincode: 388011, min_days: 1, max_days: 2 },
{ pincode: 388020, min_days: 1, max_days: 2 },
{ pincode: 388051, min_days: 1, max_days: 2 },
{ pincode: 388052, min_days: 1, max_days: 2 },
{ pincode: 388105, min_days: 1, max_days: 2 },
{ pincode: 388110, min_days: 1, max_days: 2 },
{ pincode: 388120, min_days: 1, max_days: 2 },
{ pincode: 388121, min_days: 1, max_days: 2 },
{ pincode: 388122, min_days: 1, max_days: 2 },
{ pincode: 388130, min_days: 1, max_days: 2 },
{ pincode: 388131, min_days: 1, max_days: 2 },
{ pincode: 388132, min_days: 1, max_days: 2 },
{ pincode: 388140, min_days: 1, max_days: 2 },
{ pincode: 388150, min_days: 1, max_days: 2 },
{ pincode: 388160, min_days: 1, max_days: 2 },
{ pincode: 388170, min_days: 1, max_days: 2 },
{ pincode: 388180, min_days: 1, max_days: 2 },
{ pincode: 388201, min_days: 1, max_days: 2 },
{ pincode: 388205, min_days: 1, max_days: 2 },
{ pincode: 388210, min_days: 1, max_days: 2 },
{ pincode: 388211, min_days: 1, max_days: 2 },
{ pincode: 388215, min_days: 1, max_days: 2 },
{ pincode: 388220, min_days: 1, max_days: 2 },
{ pincode: 388225, min_days: 1, max_days: 2 },
{ pincode: 388230, min_days: 1, max_days: 2 },
{ pincode: 388235, min_days: 1, max_days: 2 },
{ pincode: 388239, min_days: 1, max_days: 2 },
{ pincode: 388240, min_days: 1, max_days: 2 },
{ pincode: 388245, min_days: 1, max_days: 2 },
{ pincode: 388250, min_days: 1, max_days: 2 },
{ pincode: 388254, min_days: 1, max_days: 2 },
{ pincode: 388255, min_days: 1, max_days: 2 },
{ pincode: 388260, min_days: 1, max_days: 2 },
{ pincode: 388265, min_days: 1, max_days: 2 },
{ pincode: 388270, min_days: 1, max_days: 2 },
{ pincode: 388275, min_days: 1, max_days: 2 },
{ pincode: 388305, min_days: 1, max_days: 2 },
{ pincode: 388306, min_days: 1, max_days: 2 },
{ pincode: 388307, min_days: 1, max_days: 2 },
{ pincode: 388308, min_days: 1, max_days: 2 },
{ pincode: 388310, min_days: 1, max_days: 2 },
{ pincode: 388315, min_days: 1, max_days: 2 },
{ pincode: 388320, min_days: 1, max_days: 2 },
{ pincode: 388321, min_days: 1, max_days: 2 },
{ pincode: 388325, min_days: 1, max_days: 2 },
{ pincode: 388330, min_days: 1, max_days: 2 },
{ pincode: 388335, min_days: 1, max_days: 2 },
{ pincode: 388336, min_days: 1, max_days: 2 },
{ pincode: 388340, min_days: 1, max_days: 2 },
{ pincode: 388345, min_days: 1, max_days: 2 },
{ pincode: 388350, min_days: 1, max_days: 2 },
{ pincode: 388355, min_days: 1, max_days: 2 },
{ pincode: 388360, min_days: 1, max_days: 2 },
{ pincode: 388365, min_days: 1, max_days: 2 },
{ pincode: 388370, min_days: 1, max_days: 2 },
{ pincode: 388410, min_days: 1, max_days: 2 },
{ pincode: 388421, min_days: 1, max_days: 2 },
{ pincode: 388430, min_days: 1, max_days: 2 },
{ pincode: 388435, min_days: 1, max_days: 2 },
{ pincode: 388440, min_days: 1, max_days: 2 },
{ pincode: 388445, min_days: 1, max_days: 2 },
{ pincode: 388450, min_days: 1, max_days: 2 },
{ pincode: 388460, min_days: 1, max_days: 2 },
{ pincode: 388465, min_days: 1, max_days: 2 },
{ pincode: 388470, min_days: 1, max_days: 2 },
{ pincode: 388480, min_days: 1, max_days: 2 },
{ pincode: 388510, min_days: 1, max_days: 2 },
{ pincode: 388515, min_days: 1, max_days: 2 },
{ pincode: 388520, min_days: 1, max_days: 2 },
{ pincode: 388530, min_days: 1, max_days: 2 },
{ pincode: 388540, min_days: 1, max_days: 2 },
{ pincode: 388543, min_days: 1, max_days: 2 },
{ pincode: 388544, min_days: 1, max_days: 2 },
{ pincode: 388545, min_days: 1, max_days: 2 },
{ pincode: 388550, min_days: 1, max_days: 2 },
{ pincode: 388560, min_days: 1, max_days: 2 },
{ pincode: 388570, min_days: 1, max_days: 2 },
{ pincode: 388580, min_days: 1, max_days: 2 },
{ pincode: 388590, min_days: 1, max_days: 2 },
{ pincode: 388610, min_days: 1, max_days: 2 },
{ pincode: 388620, min_days: 1, max_days: 2 },
{ pincode: 388625, min_days: 1, max_days: 2 },
{ pincode: 388630, min_days: 1, max_days: 2 },
{ pincode: 388640, min_days: 1, max_days: 2 },
{ pincode: 388710, min_days: 1, max_days: 2 },
{ pincode: 388713, min_days: 1, max_days: 2 },
{ pincode: 388715, min_days: 1, max_days: 2 },
{ pincode: 388888, min_days: 1, max_days: 2 },
{ pincode: 389001, min_days: 1, max_days: 2 },
{ pincode: 389002, min_days: 1, max_days: 2 },
{ pincode: 389110, min_days: 1, max_days: 2 },
{ pincode: 389115, min_days: 1, max_days: 2 },
{ pincode: 389120, min_days: 1, max_days: 2 },
{ pincode: 389122, min_days: 1, max_days: 2 },
{ pincode: 389123, min_days: 1, max_days: 2 },
{ pincode: 389130, min_days: 2, max_days: 3 },
{ pincode: 389140, min_days: 2, max_days: 3 },
{ pincode: 389146, min_days: 2, max_days: 3 },
{ pincode: 389150, min_days: 1, max_days: 2 },
{ pincode: 389151, min_days: 1, max_days: 2 },
{ pincode: 389152, min_days: 1, max_days: 2 },
{ pincode: 389154, min_days: 1, max_days: 2 },
{ pincode: 389155, min_days: 1, max_days: 2 },
{ pincode: 389157, min_days: 1, max_days: 2 },
{ pincode: 389158, min_days: 1, max_days: 2 },
{ pincode: 389160, min_days: 1, max_days: 2 },
{ pincode: 389170, min_days: 1, max_days: 2 },
{ pincode: 389172, min_days: 1, max_days: 2 },
{ pincode: 389175, min_days: 1, max_days: 2 },
{ pincode: 389180, min_days: 1, max_days: 2 },
{ pincode: 389190, min_days: 1, max_days: 2 },
{ pincode: 389210, min_days: 1, max_days: 2 },
{ pincode: 389220, min_days: 1, max_days: 2 },
{ pincode: 389230, min_days: 1, max_days: 2 },
{ pincode: 389232, min_days: 1, max_days: 2 },
{ pincode: 389235, min_days: 1, max_days: 2 },
{ pincode: 389240, min_days: 1, max_days: 2 },
{ pincode: 389250, min_days: 1, max_days: 2 },
{ pincode: 389260, min_days: 1, max_days: 2 },
{ pincode: 389265, min_days: 1, max_days: 2 },
{ pincode: 389310, min_days: 1, max_days: 2 },
{ pincode: 389320, min_days: 1, max_days: 2 },
{ pincode: 389322, min_days: 1, max_days: 2 },
{ pincode: 389325, min_days: 1, max_days: 2 },
{ pincode: 389330, min_days: 1, max_days: 2 },
{ pincode: 389340, min_days: 1, max_days: 2 },
{ pincode: 389341, min_days: 1, max_days: 2 },
{ pincode: 389344, min_days: 1, max_days: 2 },
{ pincode: 389347, min_days: 1, max_days: 2 },
{ pincode: 389348, min_days: 1, max_days: 2 },
{ pincode: 389350, min_days: 1, max_days: 2 },
{ pincode: 389351, min_days: 1, max_days: 2 },
{ pincode: 389352, min_days: 1, max_days: 2 },
{ pincode: 389355, min_days: 1, max_days: 2 },
{ pincode: 389360, min_days: 1, max_days: 2 },
{ pincode: 389365, min_days: 1, max_days: 2 },
{ pincode: 389370, min_days: 1, max_days: 2 },
{ pincode: 389380, min_days: 2, max_days: 3 },
{ pincode: 389382, min_days: 2, max_days: 3 },
{ pincode: 389390, min_days: 1, max_days: 2 },
{ pincode: 390001, min_days: 1, max_days: 2 },
{ pincode: 390002, min_days: 1, max_days: 2 },
{ pincode: 390003, min_days: 1, max_days: 2 },
{ pincode: 390004, min_days: 1, max_days: 2 },
{ pincode: 390005, min_days: 1, max_days: 2 },
{ pincode: 390006, min_days: 1, max_days: 2 },
{ pincode: 390007, min_days: 1, max_days: 2 },
{ pincode: 390008, min_days: 1, max_days: 2 },
{ pincode: 390009, min_days: 1, max_days: 2 },
{ pincode: 390010, min_days: 1, max_days: 2 },
{ pincode: 390011, min_days: 1, max_days: 2 },
{ pincode: 390012, min_days: 1, max_days: 2 },
{ pincode: 390013, min_days: 1, max_days: 2 },
{ pincode: 390014, min_days: 1, max_days: 2 },
{ pincode: 390015, min_days: 1, max_days: 2 },
{ pincode: 390016, min_days: 1, max_days: 2 },
{ pincode: 390017, min_days: 1, max_days: 2 },
{ pincode: 390018, min_days: 1, max_days: 2 },
{ pincode: 390019, min_days: 1, max_days: 2 },
{ pincode: 390020, min_days: 1, max_days: 2 },
{ pincode: 390021, min_days: 1, max_days: 2 },
{ pincode: 390022, min_days: 1, max_days: 2 },
{ pincode: 390023, min_days: 1, max_days: 2 },
{ pincode: 390024, min_days: 1, max_days: 2 },
{ pincode: 390025, min_days: 1, max_days: 2 },
{ pincode: 390915, min_days: 1, max_days: 2 },
{ pincode: 391101, min_days: 1, max_days: 2 },
{ pincode: 391105, min_days: 1, max_days: 2 },
{ pincode: 391107, min_days: 1, max_days: 2 },
{ pincode: 391110, min_days: 1, max_days: 2 },
{ pincode: 391111, min_days: 1, max_days: 2 },
{ pincode: 391115, min_days: 1, max_days: 2 },
{ pincode: 391120, min_days: 1, max_days: 2 },
{ pincode: 391121, min_days: 1, max_days: 2 },
{ pincode: 391125, min_days: 1, max_days: 2 },
{ pincode: 391130, min_days: 1, max_days: 2 },
{ pincode: 391135, min_days: 1, max_days: 2 },
{ pincode: 391140, min_days: 1, max_days: 2 },
{ pincode: 391145, min_days: 1, max_days: 2 },
{ pincode: 391150, min_days: 1, max_days: 2 },
{ pincode: 391151, min_days: 1, max_days: 2 },
{ pincode: 391152, min_days: 1, max_days: 2 },
{ pincode: 391155, min_days: 1, max_days: 2 },
{ pincode: 391156, min_days: 1, max_days: 2 },
{ pincode: 391160, min_days: 1, max_days: 2 },
{ pincode: 391165, min_days: 1, max_days: 2 },
{ pincode: 391168, min_days: 1, max_days: 2 },
{ pincode: 391170, min_days: 1, max_days: 2 },
{ pincode: 391175, min_days: 1, max_days: 2 },
{ pincode: 391210, min_days: 1, max_days: 2 },
{ pincode: 391220, min_days: 1, max_days: 2 },
{ pincode: 391230, min_days: 1, max_days: 2 },
{ pincode: 391240, min_days: 1, max_days: 2 },
{ pincode: 391241, min_days: 1, max_days: 2 },
{ pincode: 391242, min_days: 1, max_days: 2 },
{ pincode: 391243, min_days: 1, max_days: 2 },
{ pincode: 391244, min_days: 1, max_days: 2 },
{ pincode: 391245, min_days: 1, max_days: 2 },
{ pincode: 391250, min_days: 1, max_days: 2 },
{ pincode: 391310, min_days: 1, max_days: 2 },
{ pincode: 391320, min_days: 1, max_days: 2 },
{ pincode: 391330, min_days: 1, max_days: 2 },
{ pincode: 391340, min_days: 1, max_days: 2 },
{ pincode: 391345, min_days: 1, max_days: 2 },
{ pincode: 391346, min_days: 1, max_days: 2 },
{ pincode: 391347, min_days: 1, max_days: 2 },
{ pincode: 391350, min_days: 1, max_days: 2 },
{ pincode: 391351, min_days: 1, max_days: 2 },
{ pincode: 391352, min_days: 1, max_days: 2 },
{ pincode: 391353, min_days: 1, max_days: 2 },
{ pincode: 391354, min_days: 1, max_days: 2 },
{ pincode: 391380, min_days: 1, max_days: 2 },
{ pincode: 391410, min_days: 1, max_days: 2 },
{ pincode: 391411, min_days: 1, max_days: 2 },
{ pincode: 391421, min_days: 1, max_days: 2 },
{ pincode: 391430, min_days: 1, max_days: 2 },
{ pincode: 391440, min_days: 1, max_days: 2 },
{ pincode: 391441, min_days: 1, max_days: 2 },
{ pincode: 391442, min_days: 1, max_days: 2 },
{ pincode: 391445, min_days: 1, max_days: 2 },
{ pincode: 391447, min_days: 1, max_days: 2 },
{ pincode: 391450, min_days: 1, max_days: 2 },
{ pincode: 391460, min_days: 1, max_days: 2 },
{ pincode: 391510, min_days: 1, max_days: 2 },
{ pincode: 391520, min_days: 1, max_days: 2 },
{ pincode: 391530, min_days: 1, max_days: 2 },
{ pincode: 391535, min_days: 1, max_days: 2 },
{ pincode: 391740, min_days: 1, max_days: 2 },
{ pincode: 391745, min_days: 1, max_days: 2 },
{ pincode: 391750, min_days: 1, max_days: 2 },
{ pincode: 391760, min_days: 1, max_days: 2 },
{ pincode: 391761, min_days: 1, max_days: 2 },
{ pincode: 391770, min_days: 1, max_days: 2 },
{ pincode: 391773, min_days: 1, max_days: 2 },
{ pincode: 391774, min_days: 1, max_days: 2 },
{ pincode: 391775, min_days: 1, max_days: 2 },
{ pincode: 391776, min_days: 1, max_days: 2 },
{ pincode: 391780, min_days: 1, max_days: 2 },
{ pincode: 391810, min_days: 1, max_days: 2 },
{ pincode: 392001, min_days: 1, max_days: 2 },
{ pincode: 392002, min_days: 1, max_days: 2 },
{ pincode: 392003, min_days: 1, max_days: 2 },
{ pincode: 392004, min_days: 1, max_days: 2 },
{ pincode: 392005, min_days: 1, max_days: 2 },
{ pincode: 392011, min_days: 1, max_days: 2 },
{ pincode: 392012, min_days: 1, max_days: 2 },
{ pincode: 392013, min_days: 1, max_days: 2 },
{ pincode: 392014, min_days: 1, max_days: 2 },
{ pincode: 392015, min_days: 1, max_days: 2 },
{ pincode: 392020, min_days: 1, max_days: 2 },
{ pincode: 392021, min_days: 1, max_days: 2 },
{ pincode: 392025, min_days: 1, max_days: 2 },
{ pincode: 392030, min_days: 1, max_days: 2 },
{ pincode: 392031, min_days: 1, max_days: 2 },
{ pincode: 392035, min_days: 1, max_days: 2 },
{ pincode: 392040, min_days: 1, max_days: 2 },
{ pincode: 392105, min_days: 1, max_days: 2 },
{ pincode: 392110, min_days: 1, max_days: 2 },
{ pincode: 392111, min_days: 1, max_days: 2 },
{ pincode: 392115, min_days: 1, max_days: 2 },
{ pincode: 392130, min_days: 1, max_days: 2 },
{ pincode: 392135, min_days: 1, max_days: 2 },
{ pincode: 392140, min_days: 1, max_days: 2 },
{ pincode: 392150, min_days: 1, max_days: 2 },
{ pincode: 392155, min_days: 1, max_days: 2 },
{ pincode: 392160, min_days: 1, max_days: 2 },
{ pincode: 392161, min_days: 1, max_days: 2 },
{ pincode: 392162, min_days: 1, max_days: 2 },
{ pincode: 392163, min_days: 1, max_days: 2 },
{ pincode: 392165, min_days: 1, max_days: 2 },
{ pincode: 392170, min_days: 1, max_days: 2 },
{ pincode: 392180, min_days: 1, max_days: 2 },
{ pincode: 392210, min_days: 1, max_days: 2 },
{ pincode: 392215, min_days: 1, max_days: 2 },
{ pincode: 392220, min_days: 1, max_days: 2 },
{ pincode: 392221, min_days: 1, max_days: 2 },
{ pincode: 392230, min_days: 1, max_days: 2 },
{ pincode: 392240, min_days: 1, max_days: 2 },
{ pincode: 392310, min_days: 1, max_days: 2 },
{ pincode: 393001, min_days: 1, max_days: 2 },
{ pincode: 393002, min_days: 1, max_days: 2 },
{ pincode: 393003, min_days: 1, max_days: 2 },
{ pincode: 393004, min_days: 1, max_days: 2 },
{ pincode: 393005, min_days: 1, max_days: 2 },
{ pincode: 393006, min_days: 1, max_days: 2 },
{ pincode: 393010, min_days: 1, max_days: 2 },
{ pincode: 393016, min_days: 1, max_days: 2 },
{ pincode: 393017, min_days: 1, max_days: 2 },
{ pincode: 393018, min_days: 1, max_days: 2 },
{ pincode: 393020, min_days: 1, max_days: 2 },
{ pincode: 393021, min_days: 1, max_days: 2 },
{ pincode: 393025, min_days: 1, max_days: 2 },
{ pincode: 393030, min_days: 1, max_days: 2 },
{ pincode: 393040, min_days: 1, max_days: 2 },
{ pincode: 393041, min_days: 1, max_days: 2 },
{ pincode: 393050, min_days: 1, max_days: 2 },
{ pincode: 393105, min_days: 1, max_days: 2 },
{ pincode: 393110, min_days: 1, max_days: 2 },
{ pincode: 393111, min_days: 1, max_days: 2 },
{ pincode: 393115, min_days: 1, max_days: 2 },
{ pincode: 393120, min_days: 1, max_days: 2 },
{ pincode: 393125, min_days: 1, max_days: 2 },
{ pincode: 393130, min_days: 1, max_days: 2 },
{ pincode: 393133, min_days: 1, max_days: 2 },
{ pincode: 393135, min_days: 1, max_days: 2 },
{ pincode: 393140, min_days: 1, max_days: 2 },
{ pincode: 393145, min_days: 1, max_days: 2 },
{ pincode: 393150, min_days: 1, max_days: 2 },
{ pincode: 393151, min_days: 1, max_days: 2 },
{ pincode: 393155, min_days: 1, max_days: 2 },
{ pincode: 393236, min_days: 1, max_days: 2 },
{ pincode: 394010, min_days: 1, max_days: 2 },
{ pincode: 394101, min_days: 1, max_days: 2 },
{ pincode: 394105, min_days: 1, max_days: 2 },
{ pincode: 394107, min_days: 1, max_days: 2 },
{ pincode: 394110, min_days: 1, max_days: 2 },
{ pincode: 394111, min_days: 1, max_days: 2 },
{ pincode: 394114, min_days: 1, max_days: 2 },
{ pincode: 394115, min_days: 1, max_days: 2 },
{ pincode: 394116, min_days: 1, max_days: 2 },
{ pincode: 394120, min_days: 1, max_days: 2 },
{ pincode: 394125, min_days: 1, max_days: 2 },
{ pincode: 394130, min_days: 1, max_days: 2 },
{ pincode: 394140, min_days: 1, max_days: 2 },
{ pincode: 394150, min_days: 1, max_days: 2 },
{ pincode: 394155, min_days: 1, max_days: 2 },
{ pincode: 394160, min_days: 1, max_days: 2 },
{ pincode: 394163, min_days: 1, max_days: 2 },
{ pincode: 394170, min_days: 1, max_days: 2 },
{ pincode: 394180, min_days: 1, max_days: 2 },
{ pincode: 394185, min_days: 1, max_days: 2 },
{ pincode: 394190, min_days: 1, max_days: 2 },
{ pincode: 394210, min_days: 1, max_days: 2 },
{ pincode: 394211, min_days: 1, max_days: 2 },
{ pincode: 394212, min_days: 1, max_days: 2 },
{ pincode: 394218, min_days: 1, max_days: 2 },
{ pincode: 394220, min_days: 1, max_days: 2 },
{ pincode: 394221, min_days: 1, max_days: 2 },
{ pincode: 394230, min_days: 1, max_days: 2 },
{ pincode: 394235, min_days: 1, max_days: 2 },
{ pincode: 394240, min_days: 1, max_days: 2 },
{ pincode: 394241, min_days: 1, max_days: 2 },
{ pincode: 394243, min_days: 1, max_days: 2 },
{ pincode: 394244, min_days: 1, max_days: 2 },
{ pincode: 394245, min_days: 1, max_days: 2 },
{ pincode: 394246, min_days: 1, max_days: 2 },
{ pincode: 394248, min_days: 1, max_days: 2 },
{ pincode: 394250, min_days: 1, max_days: 2 },
{ pincode: 394270, min_days: 1, max_days: 2 },
{ pincode: 394296, min_days: 1, max_days: 2 },
{ pincode: 394305, min_days: 1, max_days: 2 },
{ pincode: 394307, min_days: 1, max_days: 2 },
{ pincode: 394310, min_days: 1, max_days: 2 },
{ pincode: 394315, min_days: 1, max_days: 2 },
{ pincode: 394317, min_days: 1, max_days: 2 },
{ pincode: 394320, min_days: 1, max_days: 2 },
{ pincode: 394325, min_days: 1, max_days: 2 },
{ pincode: 394326, min_days: 1, max_days: 2 },
{ pincode: 394327, min_days: 1, max_days: 2 },
{ pincode: 394330, min_days: 1, max_days: 2 },
{ pincode: 394335, min_days: 1, max_days: 2 },
{ pincode: 394340, min_days: 1, max_days: 2 },
{ pincode: 394345, min_days: 1, max_days: 2 },
{ pincode: 394350, min_days: 1, max_days: 2 },
{ pincode: 394352, min_days: 1, max_days: 2 },
{ pincode: 394355, min_days: 1, max_days: 2 },
{ pincode: 394360, min_days: 1, max_days: 2 },
{ pincode: 394365, min_days: 1, max_days: 2 },
{ pincode: 394370, min_days: 1, max_days: 2 },
{ pincode: 394375, min_days: 1, max_days: 2 },
{ pincode: 394380, min_days: 1, max_days: 2 },
{ pincode: 394405, min_days: 1, max_days: 2 },
{ pincode: 394410, min_days: 1, max_days: 2 },
{ pincode: 394421, min_days: 1, max_days: 2 },
{ pincode: 394430, min_days: 1, max_days: 2 },
{ pincode: 394440, min_days: 1, max_days: 2 },
{ pincode: 394445, min_days: 1, max_days: 2 },
{ pincode: 394510, min_days: 1, max_days: 2 },
{ pincode: 394515, min_days: 1, max_days: 2 },
{ pincode: 394516, min_days: 1, max_days: 2 },
{ pincode: 394517, min_days: 1, max_days: 2 },
{ pincode: 394518, min_days: 1, max_days: 2 },
{ pincode: 394520, min_days: 1, max_days: 2 },
{ pincode: 394530, min_days: 1, max_days: 2 },
{ pincode: 394540, min_days: 1, max_days: 2 },
{ pincode: 394541, min_days: 1, max_days: 2 },
{ pincode: 394550, min_days: 1, max_days: 2 },
{ pincode: 394601, min_days: 1, max_days: 2 },
{ pincode: 394602, min_days: 1, max_days: 2 },
{ pincode: 394620, min_days: 1, max_days: 2 },
{ pincode: 394630, min_days: 1, max_days: 2 },
{ pincode: 394633, min_days: 1, max_days: 2 },
{ pincode: 394635, min_days: 1, max_days: 2 },
{ pincode: 394640, min_days: 1, max_days: 2 },
{ pincode: 394641, min_days: 1, max_days: 2 },
{ pincode: 394650, min_days: 1, max_days: 2 },
{ pincode: 394651, min_days: 1, max_days: 2 },
{ pincode: 394652, min_days: 1, max_days: 2 },
{ pincode: 394655, min_days: 1, max_days: 2 },
{ pincode: 394660, min_days: 1, max_days: 2 },
{ pincode: 394670, min_days: 1, max_days: 2 },
{ pincode: 394680, min_days: 1, max_days: 2 },
{ pincode: 394690, min_days: 1, max_days: 2 },
{ pincode: 394710, min_days: 1, max_days: 2 },
{ pincode: 394715, min_days: 1, max_days: 2 },
{ pincode: 394716, min_days: 1, max_days: 2 },
{ pincode: 394720, min_days: 1, max_days: 2 },
{ pincode: 394730, min_days: 1, max_days: 2 },
{ pincode: 394810, min_days: 1, max_days: 2 },
{ pincode: 395001, min_days: 1, max_days: 2 },
{ pincode: 395002, min_days: 1, max_days: 2 },
{ pincode: 395003, min_days: 1, max_days: 2 },
{ pincode: 395004, min_days: 1, max_days: 2 },
{ pincode: 395005, min_days: 1, max_days: 2 },
{ pincode: 395006, min_days: 1, max_days: 2 },
{ pincode: 395007, min_days: 1, max_days: 2 },
{ pincode: 395008, min_days: 1, max_days: 2 },
{ pincode: 395009, min_days: 1, max_days: 2 },
{ pincode: 395010, min_days: 1, max_days: 2 },
{ pincode: 395011, min_days: 1, max_days: 2 },
{ pincode: 395012, min_days: 1, max_days: 2 },
{ pincode: 395013, min_days: 1, max_days: 2 },
{ pincode: 395016, min_days: 1, max_days: 2 },
{ pincode: 395017, min_days: 1, max_days: 2 },
{ pincode: 395018, min_days: 1, max_days: 2 },
{ pincode: 395021, min_days: 1, max_days: 2 },
{ pincode: 395023, min_days: 1, max_days: 2 },
{ pincode: 395101, min_days: 1, max_days: 2 },
{ pincode: 395210, min_days: 1, max_days: 2 },
{ pincode: 395345, min_days: 1, max_days: 2 },
{ pincode: 395375, min_days: 1, max_days: 2 },
{ pincode: 395620, min_days: 1, max_days: 2 },
{ pincode: 395650, min_days: 1, max_days: 2 },
{ pincode: 396001, min_days: 1, max_days: 2 },
{ pincode: 396002, min_days: 1, max_days: 2 },
{ pincode: 396006, min_days: 1, max_days: 2 },
{ pincode: 396007, min_days: 1, max_days: 2 },
{ pincode: 396015, min_days: 1, max_days: 2 },
{ pincode: 396020, min_days: 1, max_days: 2 },
{ pincode: 396021, min_days: 1, max_days: 2 },
{ pincode: 396030, min_days: 1, max_days: 2 },
{ pincode: 396031, min_days: 1, max_days: 2 },
{ pincode: 396035, min_days: 1, max_days: 2 },
{ pincode: 396040, min_days: 1, max_days: 2 },
{ pincode: 396045, min_days: 1, max_days: 2 },
{ pincode: 396050, min_days: 1, max_days: 2 },
{ pincode: 396051, min_days: 1, max_days: 2 },
{ pincode: 396055, min_days: 1, max_days: 2 },
{ pincode: 396060, min_days: 1, max_days: 2 },
{ pincode: 396065, min_days: 1, max_days: 2 },
{ pincode: 396067, min_days: 1, max_days: 2 },
{ pincode: 396091, min_days: 1, max_days: 2 },
{ pincode: 396101, min_days: 1, max_days: 2 },
{ pincode: 396105, min_days: 1, max_days: 2 },
{ pincode: 396106, min_days: 1, max_days: 2 },
{ pincode: 396107, min_days: 1, max_days: 2 },
{ pincode: 396108, min_days: 1, max_days: 2 },
{ pincode: 396110, min_days: 1, max_days: 2 },
{ pincode: 396112, min_days: 1, max_days: 2 },
{ pincode: 396115, min_days: 1, max_days: 2 },
{ pincode: 396120, min_days: 1, max_days: 2 },
{ pincode: 396125, min_days: 1, max_days: 2 },
{ pincode: 396126, min_days: 1, max_days: 2 },
{ pincode: 396130, min_days: 1, max_days: 2 },
{ pincode: 396135, min_days: 1, max_days: 2 },
{ pincode: 396140, min_days: 1, max_days: 2 },
{ pincode: 396145, min_days: 1, max_days: 2 },
{ pincode: 396150, min_days: 1, max_days: 2 },
{ pincode: 396155, min_days: 1, max_days: 2 },
{ pincode: 396165, min_days: 1, max_days: 2 },
{ pincode: 396170, min_days: 1, max_days: 2 },
{ pincode: 396171, min_days: 1, max_days: 2 },
{ pincode: 396175, min_days: 1, max_days: 2 },
{ pincode: 396180, min_days: 1, max_days: 2 },
{ pincode: 396185, min_days: 1, max_days: 2 },
{ pincode: 396191, min_days: 1, max_days: 2 },
{ pincode: 396192, min_days: 2, max_days: 3 },
{ pincode: 396193, min_days: 1, max_days: 2 },
{ pincode: 396194, min_days: 1, max_days: 2 },
{ pincode: 396195, min_days: 1, max_days: 2 },
{ pincode: 396196, min_days: 1, max_days: 2 },
{ pincode: 396197, min_days: 1, max_days: 2 },
{ pincode: 396200, min_days: 1, max_days: 2 },
{ pincode: 396201, min_days: 1, max_days: 2 },
{ pincode: 396202, min_days: 1, max_days: 2 },
{ pincode: 396209, min_days: 1, max_days: 2 },
{ pincode: 396210, min_days: 1, max_days: 2 },
{ pincode: 396211, min_days: 1, max_days: 2 },
{ pincode: 396215, min_days: 1, max_days: 2 },
{ pincode: 396217, min_days: 1, max_days: 2 },
{ pincode: 396220, min_days: 1, max_days: 2 },
{ pincode: 396223, min_days: 1, max_days: 2 },
{ pincode: 396230, min_days: 1, max_days: 2 },
{ pincode: 396235, min_days: 1, max_days: 2 },
{ pincode: 396236, min_days: 1, max_days: 2 },
{ pincode: 396238, min_days: 2, max_days: 3 },
{ pincode: 396240, min_days: 1, max_days: 2 },
{ pincode: 396245, min_days: 2, max_days: 3 },
{ pincode: 396301, min_days: 1, max_days: 2 },
{ pincode: 396310, min_days: 1, max_days: 2 },
{ pincode: 396321, min_days: 1, max_days: 2 },
{ pincode: 396325, min_days: 1, max_days: 2 },
{ pincode: 396330, min_days: 1, max_days: 2 },
{ pincode: 396331, min_days: 1, max_days: 2 },
{ pincode: 396350, min_days: 1, max_days: 2 },
{ pincode: 396360, min_days: 1, max_days: 2 },
{ pincode: 396370, min_days: 1, max_days: 2 },
{ pincode: 396375, min_days: 1, max_days: 2 },
{ pincode: 396380, min_days: 1, max_days: 2 },
{ pincode: 396385, min_days: 1, max_days: 2 },
{ pincode: 396403, min_days: 1, max_days: 2 },
{ pincode: 396406, min_days: 1, max_days: 2 },
{ pincode: 396409, min_days: 1, max_days: 2 },
{ pincode: 396412, min_days: 1, max_days: 2 },
{ pincode: 396415, min_days: 1, max_days: 2 },
{ pincode: 396418, min_days: 1, max_days: 2 },
{ pincode: 396421, min_days: 1, max_days: 2 },
{ pincode: 396424, min_days: 1, max_days: 2 },
{ pincode: 396425, min_days: 1, max_days: 2 },
{ pincode: 396427, min_days: 1, max_days: 2 },
{ pincode: 396430, min_days: 1, max_days: 2 },
{ pincode: 396433, min_days: 1, max_days: 2 },
{ pincode: 396436, min_days: 1, max_days: 2 },
{ pincode: 396439, min_days: 1, max_days: 2 },
{ pincode: 396440, min_days: 1, max_days: 2 },
{ pincode: 396443, min_days: 1, max_days: 2 },
{ pincode: 396445, min_days: 1, max_days: 2 },
{ pincode: 396450, min_days: 1, max_days: 2 },
{ pincode: 396452, min_days: 1, max_days: 2 },
{ pincode: 396460, min_days: 1, max_days: 2 },
{ pincode: 396463, min_days: 1, max_days: 2 },
{ pincode: 396466, min_days: 1, max_days: 2 },
{ pincode: 396469, min_days: 1, max_days: 2 },
{ pincode: 396472, min_days: 1, max_days: 2 },
{ pincode: 396475, min_days: 1, max_days: 2 },
{ pincode: 396480, min_days: 1, max_days: 2 },
{ pincode: 396510, min_days: 1, max_days: 2 },
{ pincode: 396521, min_days: 1, max_days: 2 },
{ pincode: 396523, min_days: 1, max_days: 2 },
{ pincode: 396525, min_days: 1, max_days: 2 },
{ pincode: 396530, min_days: 1, max_days: 2 },
{ pincode: 396540, min_days: 1, max_days: 2 },
{ pincode: 396560, min_days: 1, max_days: 2 },
{ pincode: 396570, min_days: 1, max_days: 2 },
{ pincode: 396580, min_days: 1, max_days: 2 },
{ pincode: 396590, min_days: 1, max_days: 2 },
{ pincode: 400001, min_days: 2, max_days: 3 },
{ pincode: 400002, min_days: 2, max_days: 3 },
{ pincode: 400003, min_days: 2, max_days: 3 },
{ pincode: 400004, min_days: 2, max_days: 3 },
{ pincode: 400005, min_days: 2, max_days: 3 },
{ pincode: 400006, min_days: 2, max_days: 3 },
{ pincode: 400007, min_days: 2, max_days: 3 },
{ pincode: 400008, min_days: 2, max_days: 3 },
{ pincode: 400009, min_days: 2, max_days: 3 },
{ pincode: 400010, min_days: 2, max_days: 3 },
{ pincode: 400011, min_days: 2, max_days: 3 },
{ pincode: 400012, min_days: 2, max_days: 3 },
{ pincode: 400013, min_days: 2, max_days: 3 },
{ pincode: 400014, min_days: 2, max_days: 3 },
{ pincode: 400015, min_days: 2, max_days: 3 },
{ pincode: 400016, min_days: 2, max_days: 3 },
{ pincode: 400017, min_days: 2, max_days: 3 },
{ pincode: 400018, min_days: 2, max_days: 3 },
{ pincode: 400019, min_days: 2, max_days: 3 },
{ pincode: 400020, min_days: 2, max_days: 3 },
{ pincode: 400021, min_days: 2, max_days: 3 },
{ pincode: 400022, min_days: 2, max_days: 3 },
{ pincode: 400023, min_days: 2, max_days: 3 },
{ pincode: 400024, min_days: 2, max_days: 3 },
{ pincode: 400025, min_days: 2, max_days: 3 },
{ pincode: 400026, min_days: 2, max_days: 3 },
{ pincode: 400027, min_days: 2, max_days: 3 },
{ pincode: 400028, min_days: 2, max_days: 3 },
{ pincode: 400029, min_days: 2, max_days: 3 },
{ pincode: 400030, min_days: 2, max_days: 3 },
{ pincode: 400031, min_days: 2, max_days: 3 },
{ pincode: 400032, min_days: 2, max_days: 3 },
{ pincode: 400033, min_days: 2, max_days: 3 },
{ pincode: 400034, min_days: 2, max_days: 3 },
{ pincode: 400035, min_days: 2, max_days: 3 },
{ pincode: 400036, min_days: 2, max_days: 3 },
{ pincode: 400037, min_days: 2, max_days: 3 },
{ pincode: 400038, min_days: 2, max_days: 3 },
{ pincode: 400039, min_days: 2, max_days: 3 },
{ pincode: 400040, min_days: 2, max_days: 3 },
{ pincode: 400041, min_days: 2, max_days: 3 },
{ pincode: 400042, min_days: 2, max_days: 3 },
{ pincode: 400043, min_days: 2, max_days: 3 },
{ pincode: 400044, min_days: 2, max_days: 3 },
{ pincode: 400045, min_days: 2, max_days: 3 },
{ pincode: 400046, min_days: 2, max_days: 3 },
{ pincode: 400047, min_days: 2, max_days: 3 },
{ pincode: 400048, min_days: 2, max_days: 3 },
{ pincode: 400049, min_days: 2, max_days: 3 },
{ pincode: 400050, min_days: 2, max_days: 3 },
{ pincode: 400051, min_days: 2, max_days: 3 },
{ pincode: 400052, min_days: 2, max_days: 3 },
{ pincode: 400053, min_days: 2, max_days: 3 },
{ pincode: 400054, min_days: 2, max_days: 3 },
{ pincode: 400055, min_days: 2, max_days: 3 },
{ pincode: 400056, min_days: 2, max_days: 3 },
{ pincode: 400057, min_days: 2, max_days: 3 },
{ pincode: 400058, min_days: 2, max_days: 3 },
{ pincode: 400059, min_days: 2, max_days: 3 },
{ pincode: 400060, min_days: 2, max_days: 3 },
{ pincode: 400061, min_days: 2, max_days: 3 },
{ pincode: 400062, min_days: 2, max_days: 3 },
{ pincode: 400063, min_days: 2, max_days: 3 },
{ pincode: 400064, min_days: 2, max_days: 3 },
{ pincode: 400065, min_days: 2, max_days: 3 },
{ pincode: 400066, min_days: 2, max_days: 3 },
{ pincode: 400067, min_days: 2, max_days: 3 },
{ pincode: 400068, min_days: 2, max_days: 3 },
{ pincode: 400069, min_days: 2, max_days: 3 },
{ pincode: 400070, min_days: 2, max_days: 3 },
{ pincode: 400071, min_days: 2, max_days: 3 },
{ pincode: 400072, min_days: 2, max_days: 3 },
{ pincode: 400073, min_days: 2, max_days: 3 },
{ pincode: 400074, min_days: 2, max_days: 3 },
{ pincode: 400075, min_days: 2, max_days: 3 },
{ pincode: 400076, min_days: 2, max_days: 3 },
{ pincode: 400077, min_days: 2, max_days: 3 },
{ pincode: 400078, min_days: 2, max_days: 3 },
{ pincode: 400079, min_days: 2, max_days: 3 },
{ pincode: 400080, min_days: 2, max_days: 3 },
{ pincode: 400081, min_days: 2, max_days: 3 },
{ pincode: 400082, min_days: 2, max_days: 3 },
{ pincode: 400083, min_days: 2, max_days: 3 },
{ pincode: 400084, min_days: 2, max_days: 3 },
{ pincode: 400085, min_days: 2, max_days: 3 },
{ pincode: 400086, min_days: 2, max_days: 3 },
{ pincode: 400087, min_days: 2, max_days: 3 },
{ pincode: 400088, min_days: 2, max_days: 3 },
{ pincode: 400089, min_days: 2, max_days: 3 },
{ pincode: 400090, min_days: 2, max_days: 3 },
{ pincode: 400091, min_days: 2, max_days: 3 },
{ pincode: 400092, min_days: 2, max_days: 3 },
{ pincode: 400093, min_days: 2, max_days: 3 },
{ pincode: 400094, min_days: 2, max_days: 3 },
{ pincode: 400095, min_days: 2, max_days: 3 },
{ pincode: 400096, min_days: 2, max_days: 3 },
{ pincode: 400097, min_days: 2, max_days: 3 },
{ pincode: 400098, min_days: 2, max_days: 3 },
{ pincode: 400099, min_days: 2, max_days: 3 },
{ pincode: 400100, min_days: 2, max_days: 3 },
{ pincode: 400101, min_days: 2, max_days: 3 },
{ pincode: 400102, min_days: 2, max_days: 3 },
{ pincode: 400103, min_days: 2, max_days: 3 },
{ pincode: 400104, min_days: 2, max_days: 3 },
{ pincode: 400105, min_days: 2, max_days: 3 },
{ pincode: 400106, min_days: 2, max_days: 3 },
{ pincode: 400107, min_days: 2, max_days: 3 },
{ pincode: 400108, min_days: 2, max_days: 3 },
{ pincode: 400109, min_days: 2, max_days: 3 },
{ pincode: 400110, min_days: 2, max_days: 3 },
{ pincode: 400111, min_days: 2, max_days: 3 },
{ pincode: 400112, min_days: 2, max_days: 3 },
{ pincode: 400113, min_days: 2, max_days: 3 },
{ pincode: 400114, min_days: 2, max_days: 3 },
{ pincode: 400125, min_days: 2, max_days: 3 },
{ pincode: 400162, min_days: 2, max_days: 3 },
{ pincode: 400167, min_days: 2, max_days: 3 },
{ pincode: 400201, min_days: 2, max_days: 3 },
{ pincode: 400202, min_days: 2, max_days: 3 },
{ pincode: 400206, min_days: 2, max_days: 3 },
{ pincode: 400207, min_days: 2, max_days: 3 },
{ pincode: 400208, min_days: 2, max_days: 3 },
{ pincode: 400209, min_days: 2, max_days: 3 },
{ pincode: 400210, min_days: 2, max_days: 3 },
{ pincode: 400218, min_days: 2, max_days: 3 },
{ pincode: 400401, min_days: 2, max_days: 3 },
{ pincode: 400410, min_days: 2, max_days: 3 },
{ pincode: 400547, min_days: 2, max_days: 3 },
{ pincode: 400601, min_days: 2, max_days: 3 },
{ pincode: 400602, min_days: 2, max_days: 3 },
{ pincode: 400603, min_days: 2, max_days: 3 },
{ pincode: 400604, min_days: 2, max_days: 3 },
{ pincode: 400605, min_days: 2, max_days: 3 },
{ pincode: 400606, min_days: 2, max_days: 3 },
{ pincode: 400607, min_days: 2, max_days: 3 },
{ pincode: 400608, min_days: 2, max_days: 3 },
{ pincode: 400609, min_days: 2, max_days: 3 },
{ pincode: 400610, min_days: 2, max_days: 3 },
{ pincode: 400611, min_days: 2, max_days: 3 },
{ pincode: 400612, min_days: 2, max_days: 3 },
{ pincode: 400613, min_days: 2, max_days: 3 },
{ pincode: 400614, min_days: 2, max_days: 3 },
{ pincode: 400615, min_days: 2, max_days: 3 },
{ pincode: 400617, min_days: 2, max_days: 3 },
{ pincode: 400700, min_days: 2, max_days: 3 },
{ pincode: 400701, min_days: 2, max_days: 3 },
{ pincode: 400702, min_days: 2, max_days: 3 },
{ pincode: 400703, min_days: 2, max_days: 3 },
{ pincode: 400704, min_days: 2, max_days: 3 },
{ pincode: 400705, min_days: 2, max_days: 3 },
{ pincode: 400706, min_days: 2, max_days: 3 },
{ pincode: 400707, min_days: 2, max_days: 3 },
{ pincode: 400708, min_days: 2, max_days: 3 },
{ pincode: 400709, min_days: 2, max_days: 3 },
{ pincode: 400710, min_days: 2, max_days: 3 },
{ pincode: 400713, min_days: 2, max_days: 3 },
{ pincode: 400901, min_days: 2, max_days: 3 },
{ pincode: 401016, min_days: 2, max_days: 3 },
{ pincode: 401100, min_days: 2, max_days: 3 },
{ pincode: 401101, min_days: 2, max_days: 3 },
{ pincode: 401102, min_days: 1, max_days: 2 },
{ pincode: 401103, min_days: 1, max_days: 2 },
{ pincode: 401104, min_days: 2, max_days: 3 },
{ pincode: 401105, min_days: 2, max_days: 3 },
{ pincode: 401106, min_days: 2, max_days: 3 },
{ pincode: 401107, min_days: 2, max_days: 3 },
{ pincode: 401200, min_days: 2, max_days: 3 },
{ pincode: 401201, min_days: 2, max_days: 3 },
{ pincode: 401202, min_days: 2, max_days: 3 },
{ pincode: 401203, min_days: 1, max_days: 2 },
{ pincode: 401204, min_days: 1, max_days: 2 },
{ pincode: 401205, min_days: 2, max_days: 3 },
{ pincode: 401206, min_days: 1, max_days: 2 },
{ pincode: 401207, min_days: 2, max_days: 3 },
{ pincode: 401208, min_days: 2, max_days: 3 },
{ pincode: 401209, min_days: 1, max_days: 2 },
{ pincode: 401210, min_days: 2, max_days: 3 },
{ pincode: 401214, min_days: 2, max_days: 3 },
{ pincode: 401301, min_days: 1, max_days: 2 },
{ pincode: 401302, min_days: 1, max_days: 2 },
{ pincode: 401303, min_days: 1, max_days: 2 },
{ pincode: 401304, min_days: 2, max_days: 3 },
{ pincode: 401305, min_days: 1, max_days: 2 },
{ pincode: 401400, min_days: 2, max_days: 3 },
{ pincode: 401401, min_days: 2, max_days: 3 },
{ pincode: 401402, min_days: 1, max_days: 2 },
{ pincode: 401403, min_days: 1, max_days: 2 },
{ pincode: 401404, min_days: 1, max_days: 2 },
{ pincode: 401405, min_days: 1, max_days: 2 },
{ pincode: 401406, min_days: 2, max_days: 3 },
{ pincode: 401407, min_days: 2, max_days: 3 },
{ pincode: 401501, min_days: 1, max_days: 2 },
{ pincode: 401502, min_days: 2, max_days: 3 },
{ pincode: 401503, min_days: 1, max_days: 2 },
{ pincode: 401504, min_days: 1, max_days: 2 },
{ pincode: 401505, min_days: 2, max_days: 3 },
{ pincode: 401506, min_days: 1, max_days: 2 },
{ pincode: 401601, min_days: 1, max_days: 2 },
{ pincode: 401602, min_days: 1, max_days: 2 },
{ pincode: 401603, min_days: 1, max_days: 2 },
{ pincode: 401604, min_days: 1, max_days: 2 },
{ pincode: 401605, min_days: 1, max_days: 2 },
{ pincode: 401606, min_days: 1, max_days: 2 },
{ pincode: 401607, min_days: 1, max_days: 2 },
{ pincode: 401608, min_days: 1, max_days: 2 },
{ pincode: 401609, min_days: 2, max_days: 3 },
{ pincode: 401610, min_days: 2, max_days: 3 },
{ pincode: 401701, min_days: 1, max_days: 2 },
{ pincode: 401702, min_days: 1, max_days: 2 },
{ pincode: 401703, min_days: 1, max_days: 2 },
{ pincode: 402100, min_days: 2, max_days: 3 },
{ pincode: 402101, min_days: 2, max_days: 3 },
{ pincode: 402102, min_days: 2, max_days: 3 },
{ pincode: 402103, min_days: 2, max_days: 3 },
{ pincode: 402104, min_days: 2, max_days: 3 },
{ pincode: 402105, min_days: 2, max_days: 3 },
{ pincode: 402106, min_days: 2, max_days: 3 },
{ pincode: 402107, min_days: 2, max_days: 3 },
{ pincode: 402108, min_days: 2, max_days: 3 },
{ pincode: 402109, min_days: 2, max_days: 3 },
{ pincode: 402110, min_days: 2, max_days: 3 },
{ pincode: 402111, min_days: 2, max_days: 3 },
{ pincode: 402112, min_days: 2, max_days: 3 },
{ pincode: 402113, min_days: 2, max_days: 3 },
{ pincode: 402114, min_days: 2, max_days: 3 },
{ pincode: 402115, min_days: 2, max_days: 3 },
{ pincode: 402116, min_days: 2, max_days: 3 },
{ pincode: 402117, min_days: 2, max_days: 3 },
{ pincode: 402118, min_days: 2, max_days: 3 },
{ pincode: 402120, min_days: 2, max_days: 3 },
{ pincode: 402121, min_days: 2, max_days: 3 },
{ pincode: 402122, min_days: 2, max_days: 3 },
{ pincode: 402123, min_days: 2, max_days: 3 },
{ pincode: 402124, min_days: 2, max_days: 3 },
{ pincode: 402125, min_days: 2, max_days: 3 },
{ pincode: 402126, min_days: 2, max_days: 3 },
{ pincode: 402201, min_days: 2, max_days: 3 },
{ pincode: 402202, min_days: 2, max_days: 3 },
{ pincode: 402203, min_days: 2, max_days: 3 },
{ pincode: 402204, min_days: 2, max_days: 3 },
{ pincode: 402205, min_days: 2, max_days: 3 },
{ pincode: 402206, min_days: 2, max_days: 3 },
{ pincode: 402207, min_days: 2, max_days: 3 },
{ pincode: 402208, min_days: 2, max_days: 3 },
{ pincode: 402209, min_days: 2, max_days: 3 },
{ pincode: 402225, min_days: 2, max_days: 3 },
{ pincode: 402301, min_days: 2, max_days: 3 },
{ pincode: 402302, min_days: 2, max_days: 3 },
{ pincode: 402303, min_days: 2, max_days: 3 },
{ pincode: 402304, min_days: 2, max_days: 3 },
{ pincode: 402305, min_days: 2, max_days: 3 },
{ pincode: 402306, min_days: 2, max_days: 3 },
{ pincode: 402307, min_days: 2, max_days: 3 },
{ pincode: 402308, min_days: 2, max_days: 3 },
{ pincode: 402309, min_days: 2, max_days: 3 },
{ pincode: 402401, min_days: 2, max_days: 3 },
{ pincode: 402402, min_days: 2, max_days: 3 },
{ pincode: 402403, min_days: 2, max_days: 3 },
{ pincode: 402404, min_days: 2, max_days: 3 },
{ pincode: 402405, min_days: 2, max_days: 3 },
{ pincode: 402406, min_days: 2, max_days: 3 },
{ pincode: 402601, min_days: 2, max_days: 3 },
{ pincode: 403001, min_days: 2, max_days: 3 },
{ pincode: 403002, min_days: 2, max_days: 3 },
{ pincode: 403003, min_days: 2, max_days: 3 },
{ pincode: 403004, min_days: 2, max_days: 3 },
{ pincode: 403005, min_days: 2, max_days: 3 },
{ pincode: 403006, min_days: 2, max_days: 3 },
{ pincode: 403101, min_days: 2, max_days: 3 },
{ pincode: 403102, min_days: 2, max_days: 3 },
{ pincode: 403103, min_days: 2, max_days: 3 },
{ pincode: 403104, min_days: 2, max_days: 3 },
{ pincode: 403105, min_days: 2, max_days: 3 },
{ pincode: 403106, min_days: 2, max_days: 3 },
{ pincode: 403107, min_days: 2, max_days: 3 },
{ pincode: 403108, min_days: 2, max_days: 3 },
{ pincode: 403109, min_days: 2, max_days: 3 },
{ pincode: 403110, min_days: 2, max_days: 3 },
{ pincode: 403111, min_days: 2, max_days: 3 },
{ pincode: 403112, min_days: 2, max_days: 3 },
{ pincode: 403114, min_days: 2, max_days: 3 },
{ pincode: 403115, min_days: 2, max_days: 3 },
{ pincode: 403201, min_days: 2, max_days: 3 },
{ pincode: 403202, min_days: 2, max_days: 3 },
{ pincode: 403203, min_days: 2, max_days: 3 },
{ pincode: 403204, min_days: 2, max_days: 3 },
{ pincode: 403206, min_days: 2, max_days: 3 },
{ pincode: 403401, min_days: 2, max_days: 3 },
{ pincode: 403402, min_days: 2, max_days: 3 },
{ pincode: 403403, min_days: 2, max_days: 3 },
{ pincode: 403404, min_days: 2, max_days: 3 },
{ pincode: 403405, min_days: 2, max_days: 3 },
{ pincode: 403406, min_days: 2, max_days: 3 },
{ pincode: 403407, min_days: 2, max_days: 3 },
{ pincode: 403408, min_days: 2, max_days: 3 },
{ pincode: 403409, min_days: 2, max_days: 3 },
{ pincode: 403410, min_days: 2, max_days: 3 },
{ pincode: 403501, min_days: 2, max_days: 3 },
{ pincode: 403502, min_days: 2, max_days: 3 },
{ pincode: 403503, min_days: 2, max_days: 3 },
{ pincode: 403504, min_days: 2, max_days: 3 },
{ pincode: 403505, min_days: 2, max_days: 3 },
{ pincode: 403506, min_days: 2, max_days: 3 },
{ pincode: 403507, min_days: 2, max_days: 3 },
{ pincode: 403508, min_days: 2, max_days: 3 },
{ pincode: 403509, min_days: 2, max_days: 3 },
{ pincode: 403510, min_days: 2, max_days: 3 },
{ pincode: 403511, min_days: 2, max_days: 3 },
{ pincode: 403512, min_days: 2, max_days: 3 },
{ pincode: 403513, min_days: 2, max_days: 3 },
{ pincode: 403514, min_days: 2, max_days: 3 },
{ pincode: 403515, min_days: 2, max_days: 3 },
{ pincode: 403516, min_days: 2, max_days: 3 },
{ pincode: 403517, min_days: 2, max_days: 3 },
{ pincode: 403518, min_days: 2, max_days: 3 },
{ pincode: 403519, min_days: 2, max_days: 3 },
{ pincode: 403520, min_days: 2, max_days: 3 },
{ pincode: 403521, min_days: 2, max_days: 3 },
{ pincode: 403523, min_days: 2, max_days: 3 },
{ pincode: 403524, min_days: 2, max_days: 3 },
{ pincode: 403525, min_days: 2, max_days: 3 },
{ pincode: 403526, min_days: 2, max_days: 3 },
{ pincode: 403527, min_days: 2, max_days: 3 },
{ pincode: 403529, min_days: 2, max_days: 3 },
{ pincode: 403530, min_days: 2, max_days: 3 },
{ pincode: 403531, min_days: 2, max_days: 3 },
{ pincode: 403601, min_days: 2, max_days: 3 },
{ pincode: 403602, min_days: 2, max_days: 3 },
{ pincode: 403603, min_days: 2, max_days: 3 },
{ pincode: 403604, min_days: 2, max_days: 3 },
{ pincode: 403701, min_days: 2, max_days: 3 },
{ pincode: 403702, min_days: 2, max_days: 3 },
{ pincode: 403703, min_days: 2, max_days: 3 },
{ pincode: 403704, min_days: 2, max_days: 3 },
{ pincode: 403705, min_days: 2, max_days: 3 },
{ pincode: 403706, min_days: 2, max_days: 3 },
{ pincode: 403707, min_days: 2, max_days: 3 },
{ pincode: 403708, min_days: 2, max_days: 3 },
{ pincode: 403709, min_days: 2, max_days: 3 },
{ pincode: 403710, min_days: 2, max_days: 3 },
{ pincode: 403711, min_days: 2, max_days: 3 },
{ pincode: 403712, min_days: 2, max_days: 3 },
{ pincode: 403713, min_days: 2, max_days: 3 },
{ pincode: 403714, min_days: 2, max_days: 3 },
{ pincode: 403715, min_days: 2, max_days: 3 },
{ pincode: 403716, min_days: 2, max_days: 3 },
{ pincode: 403717, min_days: 2, max_days: 3 },
{ pincode: 403718, min_days: 2, max_days: 3 },
{ pincode: 403719, min_days: 2, max_days: 3 },
{ pincode: 403720, min_days: 2, max_days: 3 },
{ pincode: 403721, min_days: 2, max_days: 3 },
{ pincode: 403722, min_days: 2, max_days: 3 },
{ pincode: 403723, min_days: 2, max_days: 3 },
{ pincode: 403724, min_days: 2, max_days: 3 },
{ pincode: 403725, min_days: 2, max_days: 3 },
{ pincode: 403726, min_days: 2, max_days: 3 },
{ pincode: 403727, min_days: 2, max_days: 3 },
{ pincode: 403728, min_days: 2, max_days: 3 },
{ pincode: 403729, min_days: 2, max_days: 3 },
{ pincode: 403730, min_days: 2, max_days: 3 },
{ pincode: 403731, min_days: 2, max_days: 3 },
{ pincode: 403801, min_days: 2, max_days: 3 },
{ pincode: 403802, min_days: 2, max_days: 3 },
{ pincode: 403803, min_days: 2, max_days: 3 },
{ pincode: 403804, min_days: 2, max_days: 3 },
{ pincode: 403806, min_days: 2, max_days: 3 },
{ pincode: 404404, min_days: 2, max_days: 3 },
{ pincode: 404502, min_days: 2, max_days: 3 },
{ pincode: 407001, min_days: 2, max_days: 3 },
{ pincode: 410005, min_days: 2, max_days: 3 },
{ pincode: 410062, min_days: 2, max_days: 3 },
{ pincode: 410101, min_days: 2, max_days: 3 },
{ pincode: 410102, min_days: 2, max_days: 3 },
{ pincode: 410105, min_days: 2, max_days: 3 },
{ pincode: 410107, min_days: 2, max_days: 3 },
{ pincode: 410200, min_days: 2, max_days: 3 },
{ pincode: 410201, min_days: 2, max_days: 3 },
{ pincode: 410202, min_days: 2, max_days: 3 },
{ pincode: 410203, min_days: 2, max_days: 3 },
{ pincode: 410204, min_days: 2, max_days: 3 },
{ pincode: 410205, min_days: 2, max_days: 3 },
{ pincode: 410206, min_days: 2, max_days: 3 },
{ pincode: 410207, min_days: 2, max_days: 3 },
{ pincode: 410208, min_days: 2, max_days: 3 },
{ pincode: 410209, min_days: 2, max_days: 3 },
{ pincode: 410210, min_days: 2, max_days: 3 },
{ pincode: 410211, min_days: 2, max_days: 3 },
{ pincode: 410213, min_days: 2, max_days: 3 },
{ pincode: 410216, min_days: 2, max_days: 3 },
{ pincode: 410217, min_days: 2, max_days: 3 },
{ pincode: 410218, min_days: 2, max_days: 3 },
{ pincode: 410219, min_days: 2, max_days: 3 },
{ pincode: 410220, min_days: 2, max_days: 3 },
{ pincode: 410221, min_days: 2, max_days: 3 },
{ pincode: 410222, min_days: 2, max_days: 3 },
{ pincode: 410301, min_days: 2, max_days: 3 },
{ pincode: 410302, min_days: 2, max_days: 3 },
{ pincode: 410303, min_days: 2, max_days: 3 },
{ pincode: 410401, min_days: 2, max_days: 3 },
{ pincode: 410402, min_days: 2, max_days: 3 },
{ pincode: 410403, min_days: 2, max_days: 3 },
{ pincode: 410405, min_days: 2, max_days: 3 },
{ pincode: 410406, min_days: 2, max_days: 3 },
{ pincode: 410410, min_days: 2, max_days: 3 },
{ pincode: 410501, min_days: 2, max_days: 3 },
{ pincode: 410502, min_days: 2, max_days: 3 },
{ pincode: 410503, min_days: 2, max_days: 3 },
{ pincode: 410504, min_days: 2, max_days: 3 },
{ pincode: 410505, min_days: 2, max_days: 3 },
{ pincode: 410506, min_days: 2, max_days: 3 },
{ pincode: 410507, min_days: 2, max_days: 3 },
{ pincode: 410508, min_days: 2, max_days: 3 },
{ pincode: 410509, min_days: 2, max_days: 3 },
{ pincode: 410510, min_days: 2, max_days: 3 },
{ pincode: 410511, min_days: 2, max_days: 3 },
{ pincode: 410512, min_days: 2, max_days: 3 },
{ pincode: 410513, min_days: 2, max_days: 3 },
{ pincode: 410515, min_days: 2, max_days: 3 },
{ pincode: 410516, min_days: 2, max_days: 3 },
{ pincode: 410520, min_days: 2, max_days: 3 },
{ pincode: 410613, min_days: 2, max_days: 3 },
{ pincode: 410615, min_days: 2, max_days: 3 },
{ pincode: 410707, min_days: 2, max_days: 3 },
{ pincode: 410708, min_days: 2, max_days: 3 },
{ pincode: 411000, min_days: 2, max_days: 3 },
{ pincode: 411001, min_days: 2, max_days: 3 },
{ pincode: 411002, min_days: 2, max_days: 3 },
{ pincode: 411003, min_days: 2, max_days: 3 },
{ pincode: 411004, min_days: 2, max_days: 3 },
{ pincode: 411005, min_days: 2, max_days: 3 },
{ pincode: 411006, min_days: 2, max_days: 3 },
{ pincode: 411007, min_days: 2, max_days: 3 },
{ pincode: 411008, min_days: 2, max_days: 3 },
{ pincode: 411009, min_days: 2, max_days: 3 },
{ pincode: 411010, min_days: 2, max_days: 3 },
{ pincode: 411011, min_days: 2, max_days: 3 },
{ pincode: 411012, min_days: 2, max_days: 3 },
{ pincode: 411013, min_days: 2, max_days: 3 },
{ pincode: 411014, min_days: 2, max_days: 3 },
{ pincode: 411015, min_days: 2, max_days: 3 },
{ pincode: 411016, min_days: 2, max_days: 3 },
{ pincode: 411017, min_days: 2, max_days: 3 },
{ pincode: 411018, min_days: 2, max_days: 3 },
{ pincode: 411019, min_days: 2, max_days: 3 },
{ pincode: 411020, min_days: 2, max_days: 3 },
{ pincode: 411021, min_days: 2, max_days: 3 },
{ pincode: 411022, min_days: 2, max_days: 3 },
{ pincode: 411023, min_days: 2, max_days: 3 },
{ pincode: 411024, min_days: 2, max_days: 3 },
{ pincode: 411025, min_days: 2, max_days: 3 },
{ pincode: 411026, min_days: 2, max_days: 3 },
{ pincode: 411027, min_days: 2, max_days: 3 },
{ pincode: 411028, min_days: 2, max_days: 3 },
{ pincode: 411029, min_days: 2, max_days: 3 },
{ pincode: 411030, min_days: 2, max_days: 3 },
{ pincode: 411031, min_days: 2, max_days: 3 },
{ pincode: 411032, min_days: 2, max_days: 3 },
{ pincode: 411033, min_days: 2, max_days: 3 },
{ pincode: 411034, min_days: 2, max_days: 3 },
{ pincode: 411035, min_days: 2, max_days: 3 },
{ pincode: 411036, min_days: 2, max_days: 3 },
{ pincode: 411037, min_days: 2, max_days: 3 },
{ pincode: 411038, min_days: 2, max_days: 3 },
{ pincode: 411039, min_days: 2, max_days: 3 },
{ pincode: 411040, min_days: 2, max_days: 3 },
{ pincode: 411041, min_days: 2, max_days: 3 },
{ pincode: 411042, min_days: 2, max_days: 3 },
{ pincode: 411043, min_days: 2, max_days: 3 },
{ pincode: 411044, min_days: 2, max_days: 3 },
{ pincode: 411045, min_days: 2, max_days: 3 },
{ pincode: 411046, min_days: 2, max_days: 3 },
{ pincode: 411047, min_days: 2, max_days: 3 },
{ pincode: 411048, min_days: 2, max_days: 3 },
{ pincode: 411049, min_days: 2, max_days: 3 },
{ pincode: 411050, min_days: 2, max_days: 3 },
{ pincode: 411051, min_days: 2, max_days: 3 },
{ pincode: 411052, min_days: 2, max_days: 3 },
{ pincode: 411053, min_days: 2, max_days: 3 },
{ pincode: 411054, min_days: 2, max_days: 3 },
{ pincode: 411055, min_days: 2, max_days: 3 },
{ pincode: 411056, min_days: 2, max_days: 3 },
{ pincode: 411057, min_days: 2, max_days: 3 },
{ pincode: 411058, min_days: 2, max_days: 3 },
{ pincode: 411060, min_days: 2, max_days: 3 },
{ pincode: 411061, min_days: 2, max_days: 3 },
{ pincode: 411062, min_days: 2, max_days: 3 },
{ pincode: 411067, min_days: 2, max_days: 3 },
{ pincode: 411068, min_days: 2, max_days: 3 },
{ pincode: 411069, min_days: 2, max_days: 3 },
{ pincode: 411070, min_days: 2, max_days: 3 },
{ pincode: 411099, min_days: 2, max_days: 3 },
{ pincode: 411100, min_days: 2, max_days: 3 },
{ pincode: 411105, min_days: 2, max_days: 3 },
{ pincode: 411107, min_days: 2, max_days: 3 },
{ pincode: 411125, min_days: 2, max_days: 3 },
{ pincode: 411201, min_days: 2, max_days: 3 },
{ pincode: 411208, min_days: 2, max_days: 3 },
{ pincode: 411220, min_days: 2, max_days: 3 },
{ pincode: 411230, min_days: 2, max_days: 3 },
{ pincode: 411406, min_days: 2, max_days: 3 },
{ pincode: 411412, min_days: 2, max_days: 3 },
{ pincode: 411501, min_days: 2, max_days: 3 },
{ pincode: 411925, min_days: 2, max_days: 3 },
{ pincode: 412001, min_days: 2, max_days: 3 },
{ pincode: 412042, min_days: 2, max_days: 3 },
{ pincode: 412101, min_days: 2, max_days: 3 },
{ pincode: 412102, min_days: 2, max_days: 3 },
{ pincode: 412103, min_days: 2, max_days: 3 },
{ pincode: 412104, min_days: 2, max_days: 3 },
{ pincode: 412105, min_days: 2, max_days: 3 },
{ pincode: 412106, min_days: 2, max_days: 3 },
{ pincode: 412107, min_days: 2, max_days: 3 },
{ pincode: 412108, min_days: 2, max_days: 3 },
{ pincode: 412109, min_days: 2, max_days: 3 },
{ pincode: 412110, min_days: 2, max_days: 3 },
{ pincode: 412111, min_days: 2, max_days: 3 },
{ pincode: 412112, min_days: 2, max_days: 3 },
{ pincode: 412113, min_days: 2, max_days: 3 },
{ pincode: 412114, min_days: 2, max_days: 3 },
{ pincode: 412115, min_days: 2, max_days: 3 },
{ pincode: 412119, min_days: 2, max_days: 3 },
{ pincode: 412201, min_days: 2, max_days: 3 },
{ pincode: 412202, min_days: 2, max_days: 3 },
{ pincode: 412203, min_days: 2, max_days: 3 },
{ pincode: 412204, min_days: 2, max_days: 3 },
{ pincode: 412205, min_days: 2, max_days: 3 },
{ pincode: 412206, min_days: 2, max_days: 3 },
{ pincode: 412207, min_days: 2, max_days: 3 },
{ pincode: 412208, min_days: 2, max_days: 3 },
{ pincode: 412209, min_days: 2, max_days: 3 },
{ pincode: 412210, min_days: 2, max_days: 3 },
{ pincode: 412211, min_days: 2, max_days: 3 },
{ pincode: 412212, min_days: 2, max_days: 3 },
{ pincode: 412213, min_days: 2, max_days: 3 },
{ pincode: 412214, min_days: 2, max_days: 3 },
{ pincode: 412215, min_days: 2, max_days: 3 },
{ pincode: 412216, min_days: 2, max_days: 3 },
{ pincode: 412217, min_days: 2, max_days: 3 },
{ pincode: 412218, min_days: 2, max_days: 3 },
{ pincode: 412219, min_days: 2, max_days: 3 },
{ pincode: 412220, min_days: 2, max_days: 3 },
{ pincode: 412301, min_days: 2, max_days: 3 },
{ pincode: 412302, min_days: 2, max_days: 3 },
{ pincode: 412303, min_days: 2, max_days: 3 },
{ pincode: 412304, min_days: 2, max_days: 3 },
{ pincode: 412305, min_days: 2, max_days: 3 },
{ pincode: 412306, min_days: 2, max_days: 3 },
{ pincode: 412307, min_days: 2, max_days: 3 },
{ pincode: 412308, min_days: 2, max_days: 3 },
{ pincode: 412309, min_days: 2, max_days: 3 },
{ pincode: 412310, min_days: 2, max_days: 3 },
{ pincode: 412311, min_days: 2, max_days: 3 },
{ pincode: 412312, min_days: 2, max_days: 3 },
{ pincode: 412401, min_days: 2, max_days: 3 },
{ pincode: 412402, min_days: 2, max_days: 3 },
{ pincode: 412403, min_days: 2, max_days: 3 },
{ pincode: 412404, min_days: 2, max_days: 3 },
{ pincode: 412405, min_days: 2, max_days: 3 },
{ pincode: 412406, min_days: 2, max_days: 3 },
{ pincode: 412407, min_days: 2, max_days: 3 },
{ pincode: 412408, min_days: 2, max_days: 3 },
{ pincode: 412409, min_days: 1, max_days: 2 },
{ pincode: 412410, min_days: 2, max_days: 3 },
{ pincode: 412411, min_days: 2, max_days: 3 },
{ pincode: 412412, min_days: 2, max_days: 3 },
{ pincode: 412413, min_days: 2, max_days: 3 },
{ pincode: 412415, min_days: 2, max_days: 3 },
{ pincode: 412501, min_days: 2, max_days: 3 },
{ pincode: 412801, min_days: 2, max_days: 3 },
{ pincode: 412802, min_days: 2, max_days: 3 },
{ pincode: 412803, min_days: 2, max_days: 3 },
{ pincode: 412804, min_days: 2, max_days: 3 },
{ pincode: 412805, min_days: 2, max_days: 3 },
{ pincode: 412806, min_days: 2, max_days: 3 },
{ pincode: 413001, min_days: 2, max_days: 3 },
{ pincode: 413002, min_days: 2, max_days: 3 },
{ pincode: 413003, min_days: 2, max_days: 3 },
{ pincode: 413004, min_days: 2, max_days: 3 },
{ pincode: 413005, min_days: 2, max_days: 3 },
{ pincode: 413006, min_days: 2, max_days: 3 },
{ pincode: 413007, min_days: 2, max_days: 3 },
{ pincode: 413008, min_days: 2, max_days: 3 },
{ pincode: 413009, min_days: 2, max_days: 3 },
{ pincode: 413010, min_days: 2, max_days: 3 },
{ pincode: 413019, min_days: 2, max_days: 3 },
{ pincode: 413101, min_days: 2, max_days: 3 },
{ pincode: 413102, min_days: 2, max_days: 3 },
{ pincode: 413103, min_days: 2, max_days: 3 },
{ pincode: 413104, min_days: 2, max_days: 3 },
{ pincode: 413105, min_days: 2, max_days: 3 },
{ pincode: 413106, min_days: 2, max_days: 3 },
{ pincode: 413107, min_days: 2, max_days: 3 },
{ pincode: 413108, min_days: 2, max_days: 3 },
{ pincode: 413109, min_days: 2, max_days: 3 },
{ pincode: 413110, min_days: 2, max_days: 3 },
{ pincode: 413111, min_days: 2, max_days: 3 },
{ pincode: 413112, min_days: 2, max_days: 3 },
{ pincode: 413113, min_days: 2, max_days: 3 },
{ pincode: 413114, min_days: 2, max_days: 3 },
{ pincode: 413115, min_days: 2, max_days: 3 },
{ pincode: 413116, min_days: 2, max_days: 3 },
{ pincode: 413117, min_days: 2, max_days: 3 },
{ pincode: 413118, min_days: 2, max_days: 3 },
{ pincode: 413120, min_days: 2, max_days: 3 },
{ pincode: 413121, min_days: 2, max_days: 3 },
{ pincode: 413122, min_days: 2, max_days: 3 },
{ pincode: 413123, min_days: 2, max_days: 3 },
{ pincode: 413124, min_days: 2, max_days: 3 },
{ pincode: 413125, min_days: 2, max_days: 3 },
{ pincode: 413126, min_days: 2, max_days: 3 },
{ pincode: 413127, min_days: 2, max_days: 3 },
{ pincode: 413128, min_days: 2, max_days: 3 },
{ pincode: 413129, min_days: 2, max_days: 3 },
{ pincode: 413130, min_days: 2, max_days: 3 },
{ pincode: 413132, min_days: 2, max_days: 3 },
{ pincode: 413133, min_days: 2, max_days: 3 },
{ pincode: 413201, min_days: 2, max_days: 3 },
{ pincode: 413202, min_days: 2, max_days: 3 },
{ pincode: 413203, min_days: 2, max_days: 3 },
{ pincode: 413204, min_days: 2, max_days: 3 },
{ pincode: 413205, min_days: 2, max_days: 3 },
{ pincode: 413206, min_days: 2, max_days: 3 },
{ pincode: 413207, min_days: 2, max_days: 3 },
{ pincode: 413208, min_days: 2, max_days: 3 },
{ pincode: 413209, min_days: 2, max_days: 3 },
{ pincode: 413210, min_days: 2, max_days: 3 },
{ pincode: 413211, min_days: 2, max_days: 3 },
{ pincode: 413212, min_days: 2, max_days: 3 },
{ pincode: 413213, min_days: 2, max_days: 3 },
{ pincode: 413214, min_days: 2, max_days: 3 },
{ pincode: 413215, min_days: 2, max_days: 3 },
{ pincode: 413216, min_days: 2, max_days: 3 },
{ pincode: 413217, min_days: 2, max_days: 3 },
{ pincode: 413218, min_days: 2, max_days: 3 },
{ pincode: 413219, min_days: 2, max_days: 3 },
{ pincode: 413220, min_days: 2, max_days: 3 },
{ pincode: 413221, min_days: 2, max_days: 3 },
{ pincode: 413222, min_days: 2, max_days: 3 },
{ pincode: 413223, min_days: 2, max_days: 3 },
{ pincode: 413224, min_days: 2, max_days: 3 },
{ pincode: 413225, min_days: 2, max_days: 3 },
{ pincode: 413226, min_days: 2, max_days: 3 },
{ pincode: 413227, min_days: 2, max_days: 3 },
{ pincode: 413228, min_days: 2, max_days: 3 },
{ pincode: 413229, min_days: 2, max_days: 3 },
{ pincode: 413237, min_days: 2, max_days: 3 },
{ pincode: 413240, min_days: 2, max_days: 3 },
{ pincode: 413241, min_days: 2, max_days: 3 },
{ pincode: 413242, min_days: 2, max_days: 3 },
{ pincode: 413243, min_days: 2, max_days: 3 },
{ pincode: 413244, min_days: 2, max_days: 3 },
{ pincode: 413245, min_days: 2, max_days: 3 },
{ pincode: 413248, min_days: 2, max_days: 3 },
{ pincode: 413249, min_days: 2, max_days: 3 },
{ pincode: 413250, min_days: 2, max_days: 3 },
{ pincode: 413251, min_days: 2, max_days: 3 },
{ pincode: 413252, min_days: 2, max_days: 3 },
{ pincode: 413253, min_days: 2, max_days: 3 },
{ pincode: 413254, min_days: 2, max_days: 3 },
{ pincode: 413255, min_days: 2, max_days: 3 },
{ pincode: 413270, min_days: 2, max_days: 3 },
{ pincode: 413301, min_days: 2, max_days: 3 },
{ pincode: 413302, min_days: 2, max_days: 3 },
{ pincode: 413303, min_days: 2, max_days: 3 },
{ pincode: 413304, min_days: 2, max_days: 3 },
{ pincode: 413305, min_days: 2, max_days: 3 },
{ pincode: 413306, min_days: 2, max_days: 3 },
{ pincode: 413307, min_days: 2, max_days: 3 },
{ pincode: 413308, min_days: 2, max_days: 3 },
{ pincode: 413309, min_days: 2, max_days: 3 },
{ pincode: 413310, min_days: 2, max_days: 3 },
{ pincode: 413314, min_days: 2, max_days: 3 },
{ pincode: 413315, min_days: 2, max_days: 3 },
{ pincode: 413316, min_days: 2, max_days: 3 },
{ pincode: 413317, min_days: 2, max_days: 3 },
{ pincode: 413319, min_days: 2, max_days: 3 },
{ pincode: 413322, min_days: 2, max_days: 3 },
{ pincode: 413324, min_days: 2, max_days: 3 },
{ pincode: 413401, min_days: 2, max_days: 3 },
{ pincode: 413402, min_days: 2, max_days: 3 },
{ pincode: 413403, min_days: 2, max_days: 3 },
{ pincode: 413404, min_days: 2, max_days: 3 },
{ pincode: 413405, min_days: 2, max_days: 3 },
{ pincode: 413406, min_days: 2, max_days: 3 },
{ pincode: 413409, min_days: 2, max_days: 3 },
{ pincode: 413410, min_days: 2, max_days: 3 },
{ pincode: 413411, min_days: 2, max_days: 3 },
{ pincode: 413412, min_days: 2, max_days: 3 },
{ pincode: 413413, min_days: 2, max_days: 3 },
{ pincode: 413501, min_days: 2, max_days: 3 },
{ pincode: 413502, min_days: 2, max_days: 3 },
{ pincode: 413503, min_days: 2, max_days: 3 },
{ pincode: 413504, min_days: 2, max_days: 3 },
{ pincode: 413505, min_days: 2, max_days: 3 },
{ pincode: 413506, min_days: 2, max_days: 3 },
{ pincode: 413507, min_days: 2, max_days: 3 },
{ pincode: 413508, min_days: 2, max_days: 3 },
{ pincode: 413509, min_days: 2, max_days: 3 },
{ pincode: 413510, min_days: 2, max_days: 3 },
{ pincode: 413511, min_days: 2, max_days: 3 },
{ pincode: 413512, min_days: 1, max_days: 2 },
{ pincode: 413513, min_days: 2, max_days: 3 },
{ pincode: 413514, min_days: 2, max_days: 3 },
{ pincode: 413515, min_days: 1, max_days: 2 },
{ pincode: 413516, min_days: 2, max_days: 3 },
{ pincode: 413517, min_days: 2, max_days: 3 },
{ pincode: 413518, min_days: 2, max_days: 3 },
{ pincode: 413519, min_days: 2, max_days: 3 },
{ pincode: 413520, min_days: 2, max_days: 3 },
{ pincode: 413521, min_days: 2, max_days: 3 },
{ pincode: 413522, min_days: 2, max_days: 3 },
{ pincode: 413523, min_days: 2, max_days: 3 },
{ pincode: 413524, min_days: 2, max_days: 3 },
{ pincode: 413525, min_days: 2, max_days: 3 },
{ pincode: 413526, min_days: 2, max_days: 3 },
{ pincode: 413527, min_days: 2, max_days: 3 },
{ pincode: 413528, min_days: 2, max_days: 3 },
{ pincode: 413529, min_days: 2, max_days: 3 },
{ pincode: 413530, min_days: 2, max_days: 3 },
{ pincode: 413531, min_days: 2, max_days: 3 },
{ pincode: 413532, min_days: 2, max_days: 3 },
{ pincode: 413534, min_days: 2, max_days: 3 },
{ pincode: 413535, min_days: 2, max_days: 3 },
{ pincode: 413539, min_days: 2, max_days: 3 },
{ pincode: 413540, min_days: 2, max_days: 3 },
{ pincode: 413541, min_days: 2, max_days: 3 },
{ pincode: 413542, min_days: 2, max_days: 3 },
{ pincode: 413543, min_days: 2, max_days: 3 },
{ pincode: 413544, min_days: 2, max_days: 3 },
{ pincode: 413547, min_days: 2, max_days: 3 },
{ pincode: 413560, min_days: 2, max_days: 3 },
{ pincode: 413563, min_days: 2, max_days: 3 },
{ pincode: 413565, min_days: 2, max_days: 3 },
{ pincode: 413566, min_days: 2, max_days: 3 },
{ pincode: 413567, min_days: 2, max_days: 3 },
{ pincode: 413568, min_days: 2, max_days: 3 },
{ pincode: 413569, min_days: 2, max_days: 3 },
{ pincode: 413570, min_days: 2, max_days: 3 },
{ pincode: 413572, min_days: 2, max_days: 3 },
{ pincode: 413573, min_days: 2, max_days: 3 },
{ pincode: 413574, min_days: 2, max_days: 3 },
{ pincode: 413579, min_days: 2, max_days: 3 },
{ pincode: 413580, min_days: 2, max_days: 3 },
{ pincode: 413581, min_days: 2, max_days: 3 },
{ pincode: 413582, min_days: 2, max_days: 3 },
{ pincode: 413601, min_days: 2, max_days: 3 },
{ pincode: 413602, min_days: 2, max_days: 3 },
{ pincode: 413603, min_days: 2, max_days: 3 },
{ pincode: 413604, min_days: 2, max_days: 3 },
{ pincode: 413605, min_days: 2, max_days: 3 },
{ pincode: 413606, min_days: 2, max_days: 3 },
{ pincode: 413607, min_days: 2, max_days: 3 },
{ pincode: 413608, min_days: 2, max_days: 3 },
{ pincode: 413612, min_days: 2, max_days: 3 },
{ pincode: 413613, min_days: 2, max_days: 3 },
{ pincode: 413615, min_days: 2, max_days: 3 },
{ pincode: 413623, min_days: 2, max_days: 3 },
{ pincode: 413624, min_days: 2, max_days: 3 },
{ pincode: 413701, min_days: 2, max_days: 3 },
{ pincode: 413702, min_days: 2, max_days: 3 },
{ pincode: 413703, min_days: 2, max_days: 3 },
{ pincode: 413704, min_days: 2, max_days: 3 },
{ pincode: 413705, min_days: 2, max_days: 3 },
{ pincode: 413706, min_days: 2, max_days: 3 },
{ pincode: 413707, min_days: 2, max_days: 3 },
{ pincode: 413708, min_days: 2, max_days: 3 },
{ pincode: 413709, min_days: 2, max_days: 3 },
{ pincode: 413710, min_days: 2, max_days: 3 },
{ pincode: 413711, min_days: 2, max_days: 3 },
{ pincode: 413712, min_days: 2, max_days: 3 },
{ pincode: 413713, min_days: 2, max_days: 3 },
{ pincode: 413714, min_days: 2, max_days: 3 },
{ pincode: 413715, min_days: 2, max_days: 3 },
{ pincode: 413716, min_days: 2, max_days: 3 },
{ pincode: 413717, min_days: 2, max_days: 3 },
{ pincode: 413718, min_days: 2, max_days: 3 },
{ pincode: 413719, min_days: 2, max_days: 3 },
{ pincode: 413720, min_days: 2, max_days: 3 },
{ pincode: 413721, min_days: 2, max_days: 3 },
{ pincode: 413722, min_days: 2, max_days: 3 },
{ pincode: 413723, min_days: 2, max_days: 3 },
{ pincode: 413725, min_days: 2, max_days: 3 },
{ pincode: 413726, min_days: 2, max_days: 3 },
{ pincode: 413728, min_days: 2, max_days: 3 },
{ pincode: 413736, min_days: 2, max_days: 3 },
{ pincode: 413737, min_days: 2, max_days: 3 },
{ pincode: 413738, min_days: 2, max_days: 3 },
{ pincode: 413739, min_days: 2, max_days: 3 },
{ pincode: 413801, min_days: 2, max_days: 3 },
{ pincode: 413802, min_days: 2, max_days: 3 },
{ pincode: 414001, min_days: 2, max_days: 3 },
{ pincode: 414002, min_days: 2, max_days: 3 },
{ pincode: 414003, min_days: 2, max_days: 3 },
{ pincode: 414004, min_days: 2, max_days: 3 },
{ pincode: 414005, min_days: 2, max_days: 3 },
{ pincode: 414006, min_days: 2, max_days: 3 },
{ pincode: 414011, min_days: 2, max_days: 3 },
{ pincode: 414101, min_days: 2, max_days: 3 },
{ pincode: 414102, min_days: 2, max_days: 3 },
{ pincode: 414103, min_days: 2, max_days: 3 },
{ pincode: 414104, min_days: 2, max_days: 3 },
{ pincode: 414105, min_days: 2, max_days: 3 },
{ pincode: 414106, min_days: 2, max_days: 3 },
{ pincode: 414107, min_days: 2, max_days: 3 },
{ pincode: 414109, min_days: 2, max_days: 3 },
{ pincode: 414110, min_days: 2, max_days: 3 },
{ pincode: 414111, min_days: 2, max_days: 3 },
{ pincode: 414112, min_days: 2, max_days: 3 },
{ pincode: 414113, min_days: 2, max_days: 3 },
{ pincode: 414201, min_days: 2, max_days: 3 },
{ pincode: 414202, min_days: 2, max_days: 3 },
{ pincode: 414203, min_days: 2, max_days: 3 },
{ pincode: 414204, min_days: 2, max_days: 3 },
{ pincode: 414205, min_days: 2, max_days: 3 },
{ pincode: 414206, min_days: 2, max_days: 3 },
{ pincode: 414208, min_days: 2, max_days: 3 },
{ pincode: 414301, min_days: 2, max_days: 3 },
{ pincode: 414302, min_days: 2, max_days: 3 },
{ pincode: 414303, min_days: 2, max_days: 3 },
{ pincode: 414304, min_days: 2, max_days: 3 },
{ pincode: 414305, min_days: 2, max_days: 3 },
{ pincode: 414306, min_days: 2, max_days: 3 },
{ pincode: 414307, min_days: 2, max_days: 3 },
{ pincode: 414401, min_days: 2, max_days: 3 },
{ pincode: 414402, min_days: 2, max_days: 3 },
{ pincode: 414403, min_days: 2, max_days: 3 },
{ pincode: 414404, min_days: 2, max_days: 3 },
{ pincode: 414405, min_days: 2, max_days: 3 },
{ pincode: 414501, min_days: 2, max_days: 3 },
{ pincode: 414502, min_days: 2, max_days: 3 },
{ pincode: 414503, min_days: 2, max_days: 3 },
{ pincode: 414504, min_days: 2, max_days: 3 },
{ pincode: 414505, min_days: 2, max_days: 3 },
{ pincode: 414578, min_days: 2, max_days: 3 },
{ pincode: 414601, min_days: 2, max_days: 3 },
{ pincode: 414602, min_days: 2, max_days: 3 },
{ pincode: 414603, min_days: 2, max_days: 3 },
{ pincode: 414604, min_days: 2, max_days: 3 },
{ pincode: 414605, min_days: 2, max_days: 3 },
{ pincode: 414606, min_days: 2, max_days: 3 },
{ pincode: 414607, min_days: 2, max_days: 3 },
{ pincode: 414609, min_days: 2, max_days: 3 },
{ pincode: 414701, min_days: 2, max_days: 3 },
{ pincode: 414702, min_days: 2, max_days: 3 },
{ pincode: 414703, min_days: 2, max_days: 3 },
{ pincode: 414709, min_days: 2, max_days: 3 },
{ pincode: 415001, min_days: 2, max_days: 3 },
{ pincode: 415002, min_days: 2, max_days: 3 },
{ pincode: 415003, min_days: 2, max_days: 3 },
{ pincode: 415004, min_days: 2, max_days: 3 },
{ pincode: 415005, min_days: 2, max_days: 3 },
{ pincode: 415010, min_days: 2, max_days: 3 },
{ pincode: 415011, min_days: 2, max_days: 3 },
{ pincode: 415012, min_days: 2, max_days: 3 },
{ pincode: 415013, min_days: 2, max_days: 3 },
{ pincode: 415014, min_days: 2, max_days: 3 },
{ pincode: 415015, min_days: 2, max_days: 3 },
{ pincode: 415016, min_days: 2, max_days: 3 },
{ pincode: 415017, min_days: 2, max_days: 3 },
{ pincode: 415019, min_days: 2, max_days: 3 },
{ pincode: 415020, min_days: 2, max_days: 3 },
{ pincode: 415021, min_days: 2, max_days: 3 },
{ pincode: 415022, min_days: 2, max_days: 3 },
{ pincode: 415023, min_days: 2, max_days: 3 },
{ pincode: 415101, min_days: 2, max_days: 3 },
{ pincode: 415102, min_days: 2, max_days: 3 },
{ pincode: 415103, min_days: 2, max_days: 3 },
{ pincode: 415104, min_days: 2, max_days: 3 },
{ pincode: 415105, min_days: 2, max_days: 3 },
{ pincode: 415106, min_days: 2, max_days: 3 },
{ pincode: 415107, min_days: 2, max_days: 3 },
{ pincode: 415108, min_days: 2, max_days: 3 },
{ pincode: 415109, min_days: 2, max_days: 3 },
{ pincode: 415110, min_days: 2, max_days: 3 },
{ pincode: 415111, min_days: 2, max_days: 3 },
{ pincode: 415112, min_days: 2, max_days: 3 },
{ pincode: 415114, min_days: 2, max_days: 3 },
{ pincode: 415115, min_days: 2, max_days: 3 },
{ pincode: 415116, min_days: 2, max_days: 3 },
{ pincode: 415119, min_days: 2, max_days: 3 },
{ pincode: 415120, min_days: 2, max_days: 3 },
{ pincode: 415122, min_days: 2, max_days: 3 },
{ pincode: 415124, min_days: 2, max_days: 3 },
{ pincode: 415202, min_days: 2, max_days: 3 },
{ pincode: 415203, min_days: 2, max_days: 3 },
{ pincode: 415205, min_days: 2, max_days: 3 },
{ pincode: 415206, min_days: 2, max_days: 3 },
{ pincode: 415207, min_days: 2, max_days: 3 },
{ pincode: 415208, min_days: 2, max_days: 3 },
{ pincode: 415209, min_days: 2, max_days: 3 },
{ pincode: 415210, min_days: 2, max_days: 3 },
{ pincode: 415211, min_days: 2, max_days: 3 },
{ pincode: 415212, min_days: 2, max_days: 3 },
{ pincode: 415213, min_days: 2, max_days: 3 },
{ pincode: 415214, min_days: 2, max_days: 3 },
{ pincode: 415301, min_days: 2, max_days: 3 },
{ pincode: 415302, min_days: 2, max_days: 3 },
{ pincode: 415303, min_days: 2, max_days: 3 },
{ pincode: 415304, min_days: 2, max_days: 3 },
{ pincode: 415305, min_days: 2, max_days: 3 },
{ pincode: 415306, min_days: 2, max_days: 3 },
{ pincode: 415307, min_days: 2, max_days: 3 },
{ pincode: 415308, min_days: 2, max_days: 3 },
{ pincode: 415309, min_days: 2, max_days: 3 },
{ pincode: 415310, min_days: 2, max_days: 3 },
{ pincode: 415311, min_days: 2, max_days: 3 },
{ pincode: 415312, min_days: 2, max_days: 3 },
{ pincode: 415313, min_days: 2, max_days: 3 },
{ pincode: 415315, min_days: 2, max_days: 3 },
{ pincode: 415401, min_days: 2, max_days: 3 },
{ pincode: 415402, min_days: 2, max_days: 3 },
{ pincode: 415403, min_days: 2, max_days: 3 },
{ pincode: 415404, min_days: 2, max_days: 3 },
{ pincode: 415405, min_days: 2, max_days: 3 },
{ pincode: 415406, min_days: 2, max_days: 3 },
{ pincode: 415407, min_days: 2, max_days: 3 },
{ pincode: 415408, min_days: 2, max_days: 3 },
{ pincode: 415409, min_days: 2, max_days: 3 },
{ pincode: 415410, min_days: 2, max_days: 3 },
{ pincode: 415411, min_days: 2, max_days: 3 },
{ pincode: 415412, min_days: 2, max_days: 3 },
{ pincode: 415413, min_days: 2, max_days: 3 },
{ pincode: 415414, min_days: 2, max_days: 3 },
{ pincode: 415415, min_days: 2, max_days: 3 },
{ pincode: 415417, min_days: 2, max_days: 3 },
{ pincode: 415501, min_days: 2, max_days: 3 },
{ pincode: 415502, min_days: 2, max_days: 3 },
{ pincode: 415503, min_days: 2, max_days: 3 },
{ pincode: 415504, min_days: 2, max_days: 3 },
{ pincode: 415505, min_days: 2, max_days: 3 },
{ pincode: 415506, min_days: 2, max_days: 3 },
{ pincode: 415507, min_days: 2, max_days: 3 },
{ pincode: 415508, min_days: 2, max_days: 3 },
{ pincode: 415509, min_days: 2, max_days: 3 },
{ pincode: 415510, min_days: 2, max_days: 3 },
{ pincode: 415511, min_days: 2, max_days: 3 },
{ pincode: 415512, min_days: 2, max_days: 3 },
{ pincode: 415513, min_days: 2, max_days: 3 },
{ pincode: 415514, min_days: 2, max_days: 3 },
{ pincode: 415515, min_days: 2, max_days: 3 },
{ pincode: 415516, min_days: 2, max_days: 3 },
{ pincode: 415517, min_days: 2, max_days: 3 },
{ pincode: 415518, min_days: 2, max_days: 3 },
{ pincode: 415519, min_days: 2, max_days: 3 },
{ pincode: 415520, min_days: 2, max_days: 3 },
{ pincode: 415521, min_days: 2, max_days: 3 },
{ pincode: 415522, min_days: 2, max_days: 3 },
{ pincode: 415523, min_days: 2, max_days: 3 },
{ pincode: 415524, min_days: 2, max_days: 3 },
{ pincode: 415525, min_days: 2, max_days: 3 },
{ pincode: 415526, min_days: 2, max_days: 3 },
{ pincode: 415527, min_days: 2, max_days: 3 },
{ pincode: 415528, min_days: 2, max_days: 3 },
{ pincode: 415529, min_days: 2, max_days: 3 },
{ pincode: 415530, min_days: 2, max_days: 3 },
{ pincode: 415531, min_days: 2, max_days: 3 },
{ pincode: 415532, min_days: 2, max_days: 3 },
{ pincode: 415536, min_days: 2, max_days: 3 },
{ pincode: 415537, min_days: 2, max_days: 3 },
{ pincode: 415538, min_days: 2, max_days: 3 },
{ pincode: 415539, min_days: 2, max_days: 3 },
{ pincode: 415540, min_days: 2, max_days: 3 },
{ pincode: 415570, min_days: 2, max_days: 3 },
{ pincode: 415601, min_days: 2, max_days: 3 },
{ pincode: 415602, min_days: 2, max_days: 3 },
{ pincode: 415603, min_days: 2, max_days: 3 },
{ pincode: 415604, min_days: 2, max_days: 3 },
{ pincode: 415605, min_days: 2, max_days: 3 },
{ pincode: 415606, min_days: 2, max_days: 3 },
{ pincode: 415607, min_days: 2, max_days: 3 },
{ pincode: 415608, min_days: 2, max_days: 3 },
{ pincode: 415609, min_days: 2, max_days: 3 },
{ pincode: 415610, min_days: 2, max_days: 3 },
{ pincode: 415611, min_days: 2, max_days: 3 },
{ pincode: 415612, min_days: 2, max_days: 3 },
{ pincode: 415613, min_days: 2, max_days: 3 },
{ pincode: 415614, min_days: 2, max_days: 3 },
{ pincode: 415615, min_days: 2, max_days: 3 },
{ pincode: 415616, min_days: 2, max_days: 3 },
{ pincode: 415617, min_days: 2, max_days: 3 },
{ pincode: 415618, min_days: 2, max_days: 3 },
{ pincode: 415619, min_days: 2, max_days: 3 },
{ pincode: 415620, min_days: 2, max_days: 3 },
{ pincode: 415621, min_days: 2, max_days: 3 },
{ pincode: 415622, min_days: 2, max_days: 3 },
{ pincode: 415626, min_days: 2, max_days: 3 },
{ pincode: 415628, min_days: 2, max_days: 3 },
{ pincode: 415629, min_days: 2, max_days: 3 },
{ pincode: 415630, min_days: 2, max_days: 3 },
{ pincode: 415631, min_days: 2, max_days: 3 },
{ pincode: 415634, min_days: 2, max_days: 3 },
{ pincode: 415637, min_days: 2, max_days: 3 },
{ pincode: 415639, min_days: 2, max_days: 3 },
{ pincode: 415640, min_days: 2, max_days: 3 },
{ pincode: 415641, min_days: 2, max_days: 3 },
{ pincode: 415643, min_days: 2, max_days: 3 },
{ pincode: 415701, min_days: 2, max_days: 3 },
{ pincode: 415702, min_days: 2, max_days: 3 },
{ pincode: 415703, min_days: 2, max_days: 3 },
{ pincode: 415704, min_days: 2, max_days: 3 },
{ pincode: 415705, min_days: 2, max_days: 3 },
{ pincode: 415706, min_days: 2, max_days: 3 },
{ pincode: 415707, min_days: 2, max_days: 3 },
{ pincode: 415708, min_days: 2, max_days: 3 },
{ pincode: 415709, min_days: 2, max_days: 3 },
{ pincode: 415710, min_days: 2, max_days: 3 },
{ pincode: 415711, min_days: 2, max_days: 3 },
{ pincode: 415712, min_days: 2, max_days: 3 },
{ pincode: 415713, min_days: 2, max_days: 3 },
{ pincode: 415714, min_days: 2, max_days: 3 },
{ pincode: 415715, min_days: 2, max_days: 3 },
{ pincode: 415716, min_days: 2, max_days: 3 },
{ pincode: 415717, min_days: 2, max_days: 3 },
{ pincode: 415718, min_days: 2, max_days: 3 },
{ pincode: 415719, min_days: 2, max_days: 3 },
{ pincode: 415720, min_days: 2, max_days: 3 },
{ pincode: 415722, min_days: 2, max_days: 3 },
{ pincode: 415724, min_days: 2, max_days: 3 },
{ pincode: 415726, min_days: 2, max_days: 3 },
{ pincode: 415727, min_days: 2, max_days: 3 },
{ pincode: 415728, min_days: 2, max_days: 3 },
{ pincode: 415729, min_days: 2, max_days: 3 },
{ pincode: 415730, min_days: 2, max_days: 3 },
{ pincode: 415801, min_days: 2, max_days: 3 },
{ pincode: 415802, min_days: 2, max_days: 3 },
{ pincode: 415803, min_days: 2, max_days: 3 },
{ pincode: 415804, min_days: 2, max_days: 3 },
{ pincode: 415805, min_days: 2, max_days: 3 },
{ pincode: 415806, min_days: 2, max_days: 3 },
{ pincode: 415807, min_days: 2, max_days: 3 },
{ pincode: 416001, min_days: 2, max_days: 3 },
{ pincode: 416002, min_days: 2, max_days: 3 },
{ pincode: 416003, min_days: 2, max_days: 3 },
{ pincode: 416004, min_days: 2, max_days: 3 },
{ pincode: 416005, min_days: 2, max_days: 3 },
{ pincode: 416006, min_days: 2, max_days: 3 },
{ pincode: 416007, min_days: 2, max_days: 3 },
{ pincode: 416008, min_days: 2, max_days: 3 },
{ pincode: 416009, min_days: 2, max_days: 3 },
{ pincode: 416010, min_days: 2, max_days: 3 },
{ pincode: 416011, min_days: 2, max_days: 3 },
{ pincode: 416012, min_days: 2, max_days: 3 },
{ pincode: 416013, min_days: 2, max_days: 3 },
{ pincode: 416014, min_days: 2, max_days: 3 },
{ pincode: 416015, min_days: 2, max_days: 3 },
{ pincode: 416019, min_days: 2, max_days: 3 },
{ pincode: 416022, min_days: 2, max_days: 3 },
{ pincode: 416034, min_days: 2, max_days: 3 },
{ pincode: 416101, min_days: 2, max_days: 3 },
{ pincode: 416102, min_days: 2, max_days: 3 },
{ pincode: 416103, min_days: 2, max_days: 3 },
{ pincode: 416104, min_days: 2, max_days: 3 },
{ pincode: 416105, min_days: 2, max_days: 3 },
{ pincode: 416106, min_days: 2, max_days: 3 },
{ pincode: 416107, min_days: 2, max_days: 3 },
{ pincode: 416108, min_days: 2, max_days: 3 },
{ pincode: 416109, min_days: 2, max_days: 3 },
{ pincode: 416110, min_days: 2, max_days: 3 },
{ pincode: 416111, min_days: 2, max_days: 3 },
{ pincode: 416112, min_days: 2, max_days: 3 },
{ pincode: 416113, min_days: 2, max_days: 3 },
{ pincode: 416114, min_days: 2, max_days: 3 },
{ pincode: 416115, min_days: 2, max_days: 3 },
{ pincode: 416116, min_days: 2, max_days: 3 },
{ pincode: 416117, min_days: 2, max_days: 3 },
{ pincode: 416118, min_days: 2, max_days: 3 },
{ pincode: 416119, min_days: 2, max_days: 3 },
{ pincode: 416120, min_days: 2, max_days: 3 },
{ pincode: 416121, min_days: 2, max_days: 3 },
{ pincode: 416122, min_days: 2, max_days: 3 },
{ pincode: 416123, min_days: 2, max_days: 3 },
{ pincode: 416125, min_days: 2, max_days: 3 },
{ pincode: 416127, min_days: 2, max_days: 3 },
{ pincode: 416129, min_days: 2, max_days: 3 },
{ pincode: 416130, min_days: 2, max_days: 3 },
{ pincode: 416132, min_days: 2, max_days: 3 },
{ pincode: 416134, min_days: 2, max_days: 3 },
{ pincode: 416137, min_days: 2, max_days: 3 },
{ pincode: 416138, min_days: 2, max_days: 3 },
{ pincode: 416143, min_days: 2, max_days: 3 },
{ pincode: 416144, min_days: 2, max_days: 3 },
{ pincode: 416145, min_days: 2, max_days: 3 },
{ pincode: 416146, min_days: 2, max_days: 3 },
{ pincode: 416201, min_days: 2, max_days: 3 },
{ pincode: 416202, min_days: 2, max_days: 3 },
{ pincode: 416203, min_days: 2, max_days: 3 },
{ pincode: 416204, min_days: 2, max_days: 3 },
{ pincode: 416205, min_days: 2, max_days: 3 },
{ pincode: 416206, min_days: 2, max_days: 3 },
{ pincode: 416207, min_days: 2, max_days: 3 },
{ pincode: 416208, min_days: 2, max_days: 3 },
{ pincode: 416209, min_days: 2, max_days: 3 },
{ pincode: 416210, min_days: 2, max_days: 3 },
{ pincode: 416211, min_days: 2, max_days: 3 },
{ pincode: 416212, min_days: 2, max_days: 3 },
{ pincode: 416213, min_days: 2, max_days: 3 },
{ pincode: 416214, min_days: 2, max_days: 3 },
{ pincode: 416215, min_days: 2, max_days: 3 },
{ pincode: 416216, min_days: 2, max_days: 3 },
{ pincode: 416217, min_days: 2, max_days: 3 },
{ pincode: 416218, min_days: 2, max_days: 3 },
{ pincode: 416219, min_days: 2, max_days: 3 },
{ pincode: 416220, min_days: 2, max_days: 3 },
{ pincode: 416221, min_days: 2, max_days: 3 },
{ pincode: 416222, min_days: 2, max_days: 3 },
{ pincode: 416223, min_days: 2, max_days: 3 },
{ pincode: 416224, min_days: 2, max_days: 3 },
{ pincode: 416227, min_days: 2, max_days: 3 },
{ pincode: 416228, min_days: 2, max_days: 3 },
{ pincode: 416229, min_days: 2, max_days: 3 },
{ pincode: 416230, min_days: 2, max_days: 3 },
{ pincode: 416231, min_days: 2, max_days: 3 },
{ pincode: 416232, min_days: 2, max_days: 3 },
{ pincode: 416234, min_days: 2, max_days: 3 },
{ pincode: 416235, min_days: 2, max_days: 3 },
{ pincode: 416236, min_days: 2, max_days: 3 },
{ pincode: 416301, min_days: 2, max_days: 3 },
{ pincode: 416302, min_days: 2, max_days: 3 },
{ pincode: 416303, min_days: 2, max_days: 3 },
{ pincode: 416304, min_days: 2, max_days: 3 },
{ pincode: 416305, min_days: 2, max_days: 3 },
{ pincode: 416306, min_days: 2, max_days: 3 },
{ pincode: 416307, min_days: 2, max_days: 3 },
{ pincode: 416308, min_days: 2, max_days: 3 },
{ pincode: 416309, min_days: 2, max_days: 3 },
{ pincode: 416310, min_days: 2, max_days: 3 },
{ pincode: 416311, min_days: 2, max_days: 3 },
{ pincode: 416312, min_days: 2, max_days: 3 },
{ pincode: 416313, min_days: 2, max_days: 3 },
{ pincode: 416314, min_days: 2, max_days: 3 },
{ pincode: 416315, min_days: 2, max_days: 3 },
{ pincode: 416316, min_days: 2, max_days: 3 },
{ pincode: 416317, min_days: 2, max_days: 3 },
{ pincode: 416320, min_days: 2, max_days: 3 },
{ pincode: 416321, min_days: 2, max_days: 3 },
{ pincode: 416322, min_days: 2, max_days: 3 },
{ pincode: 416401, min_days: 2, max_days: 3 },
{ pincode: 416402, min_days: 2, max_days: 3 },
{ pincode: 416403, min_days: 2, max_days: 3 },
{ pincode: 416404, min_days: 2, max_days: 3 },
{ pincode: 416405, min_days: 2, max_days: 3 },
{ pincode: 416406, min_days: 2, max_days: 3 },
{ pincode: 416407, min_days: 2, max_days: 3 },
{ pincode: 416408, min_days: 2, max_days: 3 },
{ pincode: 416409, min_days: 2, max_days: 3 },
{ pincode: 416410, min_days: 2, max_days: 3 },
{ pincode: 416411, min_days: 2, max_days: 3 },
{ pincode: 416412, min_days: 2, max_days: 3 },
{ pincode: 416413, min_days: 2, max_days: 3 },
{ pincode: 416414, min_days: 2, max_days: 3 },
{ pincode: 416415, min_days: 2, max_days: 3 },
{ pincode: 416416, min_days: 2, max_days: 3 },
{ pincode: 416417, min_days: 2, max_days: 3 },
{ pincode: 416418, min_days: 2, max_days: 3 },
{ pincode: 416419, min_days: 2, max_days: 3 },
{ pincode: 416420, min_days: 2, max_days: 3 },
{ pincode: 416421, min_days: 2, max_days: 3 },
{ pincode: 416422, min_days: 2, max_days: 3 },
{ pincode: 416423, min_days: 2, max_days: 3 },
{ pincode: 416425, min_days: 2, max_days: 3 },
{ pincode: 416426, min_days: 2, max_days: 3 },
{ pincode: 416428, min_days: 2, max_days: 3 },
{ pincode: 416429, min_days: 2, max_days: 3 },
{ pincode: 416435, min_days: 2, max_days: 3 },
{ pincode: 416436, min_days: 2, max_days: 3 },
{ pincode: 416437, min_days: 2, max_days: 3 },
{ pincode: 416501, min_days: 2, max_days: 3 },
{ pincode: 416502, min_days: 2, max_days: 3 },
{ pincode: 416503, min_days: 2, max_days: 3 },
{ pincode: 416504, min_days: 2, max_days: 3 },
{ pincode: 416505, min_days: 2, max_days: 3 },
{ pincode: 416506, min_days: 2, max_days: 3 },
{ pincode: 416507, min_days: 2, max_days: 3 },
{ pincode: 416508, min_days: 2, max_days: 3 },
{ pincode: 416509, min_days: 2, max_days: 3 },
{ pincode: 416510, min_days: 2, max_days: 3 },
{ pincode: 416511, min_days: 2, max_days: 3 },
{ pincode: 416512, min_days: 2, max_days: 3 },
{ pincode: 416513, min_days: 2, max_days: 3 },
{ pincode: 416514, min_days: 2, max_days: 3 },
{ pincode: 416515, min_days: 2, max_days: 3 },
{ pincode: 416516, min_days: 2, max_days: 3 },
{ pincode: 416517, min_days: 2, max_days: 3 },
{ pincode: 416518, min_days: 2, max_days: 3 },
{ pincode: 416519, min_days: 2, max_days: 3 },
{ pincode: 416520, min_days: 2, max_days: 3 },
{ pincode: 416521, min_days: 2, max_days: 3 },
{ pincode: 416522, min_days: 2, max_days: 3 },
{ pincode: 416523, min_days: 2, max_days: 3 },
{ pincode: 416524, min_days: 2, max_days: 3 },
{ pincode: 416525, min_days: 2, max_days: 3 },
{ pincode: 416526, min_days: 2, max_days: 3 },
{ pincode: 416527, min_days: 2, max_days: 3 },
{ pincode: 416528, min_days: 2, max_days: 3 },
{ pincode: 416529, min_days: 2, max_days: 3 },
{ pincode: 416531, min_days: 2, max_days: 3 },
{ pincode: 416532, min_days: 2, max_days: 3 },
{ pincode: 416534, min_days: 2, max_days: 3 },
{ pincode: 416536, min_days: 2, max_days: 3 },
{ pincode: 416540, min_days: 2, max_days: 3 },
{ pincode: 416541, min_days: 2, max_days: 3 },
{ pincode: 416549, min_days: 2, max_days: 3 },
{ pincode: 416550, min_days: 2, max_days: 3 },
{ pincode: 416551, min_days: 2, max_days: 3 },
{ pincode: 416552, min_days: 2, max_days: 3 },
{ pincode: 416601, min_days: 2, max_days: 3 },
{ pincode: 416602, min_days: 2, max_days: 3 },
{ pincode: 416603, min_days: 2, max_days: 3 },
{ pincode: 416604, min_days: 2, max_days: 3 },
{ pincode: 416605, min_days: 2, max_days: 3 },
{ pincode: 416606, min_days: 2, max_days: 3 },
{ pincode: 416607, min_days: 2, max_days: 3 },
{ pincode: 416608, min_days: 2, max_days: 3 },
{ pincode: 416609, min_days: 2, max_days: 3 },
{ pincode: 416610, min_days: 2, max_days: 3 },
{ pincode: 416611, min_days: 2, max_days: 3 },
{ pincode: 416612, min_days: 2, max_days: 3 },
{ pincode: 416613, min_days: 2, max_days: 3 },
{ pincode: 416614, min_days: 2, max_days: 3 },
{ pincode: 416615, min_days: 2, max_days: 3 },
{ pincode: 416616, min_days: 2, max_days: 3 },
{ pincode: 416618, min_days: 2, max_days: 3 },
{ pincode: 416620, min_days: 2, max_days: 3 },
{ pincode: 416621, min_days: 2, max_days: 3 },
{ pincode: 416622, min_days: 2, max_days: 3 },
{ pincode: 416623, min_days: 2, max_days: 3 },
{ pincode: 416624, min_days: 2, max_days: 3 },
{ pincode: 416625, min_days: 2, max_days: 3 },
{ pincode: 416626, min_days: 2, max_days: 3 },
{ pincode: 416628, min_days: 2, max_days: 3 },
{ pincode: 416630, min_days: 2, max_days: 3 },
{ pincode: 416632, min_days: 2, max_days: 3 },
{ pincode: 416701, min_days: 2, max_days: 3 },
{ pincode: 416702, min_days: 2, max_days: 3 },
{ pincode: 416703, min_days: 2, max_days: 3 },
{ pincode: 416704, min_days: 2, max_days: 3 },
{ pincode: 416705, min_days: 2, max_days: 3 },
{ pincode: 416707, min_days: 2, max_days: 3 },
{ pincode: 416709, min_days: 2, max_days: 3 },
{ pincode: 416712, min_days: 2, max_days: 3 },
{ pincode: 416713, min_days: 2, max_days: 3 },
{ pincode: 416801, min_days: 2, max_days: 3 },
{ pincode: 416802, min_days: 2, max_days: 3 },
{ pincode: 416803, min_days: 2, max_days: 3 },
{ pincode: 416804, min_days: 2, max_days: 3 },
{ pincode: 416805, min_days: 2, max_days: 3 },
{ pincode: 416806, min_days: 2, max_days: 3 },
{ pincode: 416807, min_days: 2, max_days: 3 },
{ pincode: 416809, min_days: 2, max_days: 3 },
{ pincode: 416810, min_days: 2, max_days: 3 },
{ pincode: 416811, min_days: 2, max_days: 3 },
{ pincode: 416812, min_days: 2, max_days: 3 },
{ pincode: 416813, min_days: 2, max_days: 3 },
{ pincode: 418010, min_days: 2, max_days: 3 },
{ pincode: 418101, min_days: 2, max_days: 3 },
{ pincode: 418110, min_days: 2, max_days: 3 },
{ pincode: 418115, min_days: 2, max_days: 3 },
{ pincode: 420421, min_days: 2, max_days: 3 },
{ pincode: 421001, min_days: 2, max_days: 3 },
{ pincode: 421002, min_days: 2, max_days: 3 },
{ pincode: 421003, min_days: 2, max_days: 3 },
{ pincode: 421004, min_days: 2, max_days: 3 },
{ pincode: 421005, min_days: 2, max_days: 3 },
{ pincode: 421006, min_days: 2, max_days: 3 },
{ pincode: 421032, min_days: 2, max_days: 3 },
{ pincode: 421051, min_days: 2, max_days: 3 },
{ pincode: 421101, min_days: 2, max_days: 3 },
{ pincode: 421102, min_days: 2, max_days: 3 },
{ pincode: 421103, min_days: 2, max_days: 3 },
{ pincode: 421201, min_days: 2, max_days: 3 },
{ pincode: 421202, min_days: 2, max_days: 3 },
{ pincode: 421203, min_days: 2, max_days: 3 },
{ pincode: 421204, min_days: 2, max_days: 3 },
{ pincode: 421205, min_days: 2, max_days: 3 },
{ pincode: 421206, min_days: 2, max_days: 3 },
{ pincode: 421300, min_days: 2, max_days: 3 },
{ pincode: 421301, min_days: 2, max_days: 3 },
{ pincode: 421302, min_days: 2, max_days: 3 },
{ pincode: 421303, min_days: 1, max_days: 2 },
{ pincode: 421304, min_days: 2, max_days: 3 },
{ pincode: 421305, min_days: 2, max_days: 3 },
{ pincode: 421306, min_days: 2, max_days: 3 },
{ pincode: 421307, min_days: 2, max_days: 3 },
{ pincode: 421308, min_days: 2, max_days: 3 },
{ pincode: 421311, min_days: 2, max_days: 3 },
{ pincode: 421312, min_days: 1, max_days: 2 },
{ pincode: 421313, min_days: 2, max_days: 3 },
{ pincode: 421401, min_days: 2, max_days: 3 },
{ pincode: 421402, min_days: 2, max_days: 3 },
{ pincode: 421403, min_days: 2, max_days: 3 },
{ pincode: 421405, min_days: 2, max_days: 3 },
{ pincode: 421501, min_days: 2, max_days: 3 },
{ pincode: 421502, min_days: 2, max_days: 3 },
{ pincode: 421503, min_days: 2, max_days: 3 },
{ pincode: 421504, min_days: 2, max_days: 3 },
{ pincode: 421505, min_days: 2, max_days: 3 },
{ pincode: 421506, min_days: 2, max_days: 3 },
{ pincode: 421507, min_days: 2, max_days: 3 },
{ pincode: 421601, min_days: 2, max_days: 3 },
{ pincode: 421602, min_days: 2, max_days: 3 },
{ pincode: 421603, min_days: 1, max_days: 2 },
{ pincode: 421604, min_days: 2, max_days: 3 },
{ pincode: 421605, min_days: 2, max_days: 3 },
{ pincode: 421607, min_days: 2, max_days: 3 },
{ pincode: 422001, min_days: 1, max_days: 2 },
{ pincode: 422002, min_days: 2, max_days: 3 },
{ pincode: 422003, min_days: 1, max_days: 2 },
{ pincode: 422004, min_days: 1, max_days: 2 },
{ pincode: 422005, min_days: 1, max_days: 2 },
{ pincode: 422006, min_days: 1, max_days: 2 },
{ pincode: 422007, min_days: 1, max_days: 2 },
{ pincode: 422008, min_days: 1, max_days: 2 },
{ pincode: 422009, min_days: 2, max_days: 3 },
{ pincode: 422010, min_days: 2, max_days: 3 },
{ pincode: 422011, min_days: 1, max_days: 2 },
{ pincode: 422012, min_days: 1, max_days: 2 },
{ pincode: 422013, min_days: 1, max_days: 2 },
{ pincode: 422101, min_days: 1, max_days: 2 },
{ pincode: 422102, min_days: 1, max_days: 2 },
{ pincode: 422103, min_days: 1, max_days: 2 },
{ pincode: 422104, min_days: 1, max_days: 2 },
{ pincode: 422105, min_days: 1, max_days: 2 },
{ pincode: 422106, min_days: 2, max_days: 3 },
{ pincode: 422107, min_days: 2, max_days: 3 },
{ pincode: 422108, min_days: 2, max_days: 3 },
{ pincode: 422109, min_days: 2, max_days: 3 },
{ pincode: 422110, min_days: 2, max_days: 3 },
{ pincode: 422111, min_days: 2, max_days: 3 },
{ pincode: 422112, min_days: 1, max_days: 2 },
{ pincode: 422113, min_days: 1, max_days: 2 },
{ pincode: 422201, min_days: 1, max_days: 2 },
{ pincode: 422202, min_days: 1, max_days: 2 },
{ pincode: 422203, min_days: 1, max_days: 2 },
{ pincode: 422204, min_days: 1, max_days: 2 },
{ pincode: 422205, min_days: 1, max_days: 2 },
{ pincode: 422206, min_days: 1, max_days: 2 },
{ pincode: 422207, min_days: 1, max_days: 2 },
{ pincode: 422208, min_days: 1, max_days: 2 },
{ pincode: 422209, min_days: 1, max_days: 2 },
{ pincode: 422210, min_days: 1, max_days: 2 },
{ pincode: 422211, min_days: 1, max_days: 2 },
{ pincode: 422212, min_days: 1, max_days: 2 },
{ pincode: 422213, min_days: 1, max_days: 2 },
{ pincode: 422214, min_days: 1, max_days: 2 },
{ pincode: 422215, min_days: 1, max_days: 2 },
{ pincode: 422216, min_days: 2, max_days: 3 },
{ pincode: 422217, min_days: 2, max_days: 3 },
{ pincode: 422220, min_days: 2, max_days: 3 },
{ pincode: 422221, min_days: 1, max_days: 2 },
{ pincode: 422222, min_days: 1, max_days: 2 },
{ pincode: 422301, min_days: 1, max_days: 2 },
{ pincode: 422302, min_days: 1, max_days: 2 },
{ pincode: 422303, min_days: 1, max_days: 2 },
{ pincode: 422304, min_days: 1, max_days: 2 },
{ pincode: 422305, min_days: 1, max_days: 2 },
{ pincode: 422306, min_days: 1, max_days: 2 },
{ pincode: 422308, min_days: 1, max_days: 2 },
{ pincode: 422401, min_days: 1, max_days: 2 },
{ pincode: 422402, min_days: 1, max_days: 2 },
{ pincode: 422403, min_days: 1, max_days: 2 },
{ pincode: 422405, min_days: 2, max_days: 3 },
{ pincode: 422501, min_days: 1, max_days: 2 },
{ pincode: 422502, min_days: 1, max_days: 2 },
{ pincode: 422503, min_days: 2, max_days: 3 },
{ pincode: 422601, min_days: 2, max_days: 3 },
{ pincode: 422602, min_days: 2, max_days: 3 },
{ pincode: 422603, min_days: 2, max_days: 3 },
{ pincode: 422604, min_days: 2, max_days: 3 },
{ pincode: 422605, min_days: 2, max_days: 3 },
{ pincode: 422606, min_days: 2, max_days: 3 },
{ pincode: 422607, min_days: 2, max_days: 3 },
{ pincode: 422608, min_days: 2, max_days: 3 },
{ pincode: 422610, min_days: 2, max_days: 3 },
{ pincode: 422611, min_days: 2, max_days: 3 },
{ pincode: 422615, min_days: 2, max_days: 3 },
{ pincode: 422620, min_days: 2, max_days: 3 },
{ pincode: 422622, min_days: 2, max_days: 3 },
{ pincode: 423101, min_days: 1, max_days: 2 },
{ pincode: 423102, min_days: 1, max_days: 2 },
{ pincode: 423103, min_days: 2, max_days: 3 },
{ pincode: 423104, min_days: 1, max_days: 2 },
{ pincode: 423105, min_days: 1, max_days: 2 },
{ pincode: 423106, min_days: 1, max_days: 2 },
{ pincode: 423107, min_days: 2, max_days: 3 },
{ pincode: 423108, min_days: 1, max_days: 2 },
{ pincode: 423109, min_days: 2, max_days: 3 },
{ pincode: 423110, min_days: 1, max_days: 2 },
{ pincode: 423111, min_days: 1, max_days: 2 },
{ pincode: 423116, min_days: 2, max_days: 3 },
{ pincode: 423117, min_days: 1, max_days: 2 },
{ pincode: 423201, min_days: 1, max_days: 2 },
{ pincode: 423202, min_days: 1, max_days: 2 },
{ pincode: 423203, min_days: 2, max_days: 3 },
{ pincode: 423204, min_days: 1, max_days: 2 },
{ pincode: 423205, min_days: 1, max_days: 2 },
{ pincode: 423206, min_days: 1, max_days: 2 },
{ pincode: 423207, min_days: 2, max_days: 3 },
{ pincode: 423208, min_days: 1, max_days: 2 },
{ pincode: 423209, min_days: 2, max_days: 3 },
{ pincode: 423210, min_days: 2, max_days: 3 },
{ pincode: 423211, min_days: 2, max_days: 3 },
{ pincode: 423212, min_days: 1, max_days: 2 },
{ pincode: 423213, min_days: 1, max_days: 2 },
{ pincode: 423301, min_days: 1, max_days: 2 },
{ pincode: 423302, min_days: 1, max_days: 2 },
{ pincode: 423303, min_days: 1, max_days: 2 },
{ pincode: 423304, min_days: 2, max_days: 3 },
{ pincode: 423305, min_days: 2, max_days: 3 },
{ pincode: 423401, min_days: 1, max_days: 2 },
{ pincode: 423402, min_days: 1, max_days: 2 },
{ pincode: 423403, min_days: 1, max_days: 2 },
{ pincode: 423501, min_days: 1, max_days: 2 },
{ pincode: 423502, min_days: 2, max_days: 3 },
{ pincode: 423601, min_days: 2, max_days: 3 },
{ pincode: 423602, min_days: 2, max_days: 3 },
{ pincode: 423603, min_days: 2, max_days: 3 },
{ pincode: 423604, min_days: 2, max_days: 3 },
{ pincode: 423605, min_days: 2, max_days: 3 },
{ pincode: 423607, min_days: 2, max_days: 3 },
{ pincode: 423701, min_days: 2, max_days: 3 },
{ pincode: 423702, min_days: 2, max_days: 3 },
{ pincode: 423703, min_days: 2, max_days: 3 },
{ pincode: 423704, min_days: 2, max_days: 3 },
{ pincode: 424001, min_days: 2, max_days: 3 },
{ pincode: 424002, min_days: 2, max_days: 3 },
{ pincode: 424003, min_days: 2, max_days: 3 },
{ pincode: 424004, min_days: 2, max_days: 3 },
{ pincode: 424005, min_days: 2, max_days: 3 },
{ pincode: 424006, min_days: 2, max_days: 3 },
{ pincode: 424026, min_days: 2, max_days: 3 },
{ pincode: 424027, min_days: 2, max_days: 3 },
{ pincode: 424101, min_days: 2, max_days: 3 },
{ pincode: 424102, min_days: 2, max_days: 3 },
{ pincode: 424103, min_days: 2, max_days: 3 },
{ pincode: 424104, min_days: 2, max_days: 3 },
{ pincode: 424105, min_days: 2, max_days: 3 },
{ pincode: 424106, min_days: 2, max_days: 3 },
{ pincode: 424107, min_days: 2, max_days: 3 },
{ pincode: 424108, min_days: 2, max_days: 3 },
{ pincode: 424109, min_days: 1, max_days: 2 },
{ pincode: 424113, min_days: 2, max_days: 3 },
{ pincode: 424116, min_days: 2, max_days: 3 },
{ pincode: 424117, min_days: 2, max_days: 3 },
{ pincode: 424119, min_days: 2, max_days: 3 },
{ pincode: 424201, min_days: 2, max_days: 3 },
{ pincode: 424202, min_days: 2, max_days: 3 },
{ pincode: 424203, min_days: 2, max_days: 3 },
{ pincode: 424204, min_days: 2, max_days: 3 },
{ pincode: 424205, min_days: 2, max_days: 3 },
{ pincode: 424206, min_days: 2, max_days: 3 },
{ pincode: 424207, min_days: 2, max_days: 3 },
{ pincode: 424208, min_days: 2, max_days: 3 },
{ pincode: 424209, min_days: 2, max_days: 3 },
{ pincode: 424301, min_days: 2, max_days: 3 },
{ pincode: 424302, min_days: 2, max_days: 3 },
{ pincode: 424303, min_days: 1, max_days: 2 },
{ pincode: 424304, min_days: 1, max_days: 2 },
{ pincode: 424305, min_days: 1, max_days: 2 },
{ pincode: 424306, min_days: 1, max_days: 2 },
{ pincode: 424307, min_days: 2, max_days: 3 },
{ pincode: 424308, min_days: 2, max_days: 3 },
{ pincode: 424309, min_days: 2, max_days: 3 },
{ pincode: 424310, min_days: 1, max_days: 2 },
{ pincode: 424311, min_days: 2, max_days: 3 },
{ pincode: 424312, min_days: 2, max_days: 3 },
{ pincode: 424313, min_days: 2, max_days: 3 },
{ pincode: 424315, min_days: 2, max_days: 3 },
{ pincode: 424316, min_days: 2, max_days: 3 },
{ pincode: 424318, min_days: 2, max_days: 3 },
{ pincode: 425001, min_days: 2, max_days: 3 },
{ pincode: 425002, min_days: 2, max_days: 3 },
{ pincode: 425003, min_days: 2, max_days: 3 },
{ pincode: 425004, min_days: 2, max_days: 3 },
{ pincode: 425101, min_days: 2, max_days: 3 },
{ pincode: 425102, min_days: 2, max_days: 3 },
{ pincode: 425103, min_days: 2, max_days: 3 },
{ pincode: 425104, min_days: 2, max_days: 3 },
{ pincode: 425105, min_days: 2, max_days: 3 },
{ pincode: 425106, min_days: 2, max_days: 3 },
{ pincode: 425107, min_days: 2, max_days: 3 },
{ pincode: 425108, min_days: 2, max_days: 3 },
{ pincode: 425109, min_days: 2, max_days: 3 },
{ pincode: 425110, min_days: 2, max_days: 3 },
{ pincode: 425111, min_days: 2, max_days: 3 },
{ pincode: 425112, min_days: 2, max_days: 3 },
{ pincode: 425113, min_days: 2, max_days: 3 },
{ pincode: 425114, min_days: 2, max_days: 3 },
{ pincode: 425115, min_days: 2, max_days: 3 },
{ pincode: 425116, min_days: 2, max_days: 3 },
{ pincode: 425117, min_days: 2, max_days: 3 },
{ pincode: 425118, min_days: 2, max_days: 3 },
{ pincode: 425119, min_days: 2, max_days: 3 },
{ pincode: 425120, min_days: 2, max_days: 3 },
{ pincode: 425121, min_days: 2, max_days: 3 },
{ pincode: 425122, min_days: 2, max_days: 3 },
{ pincode: 425123, min_days: 2, max_days: 3 },
{ pincode: 425124, min_days: 2, max_days: 3 },
{ pincode: 425125, min_days: 2, max_days: 3 },
{ pincode: 425126, min_days: 2, max_days: 3 },
{ pincode: 425127, min_days: 2, max_days: 3 },
{ pincode: 425128, min_days: 2, max_days: 3 },
{ pincode: 425129, min_days: 2, max_days: 3 },
{ pincode: 425130, min_days: 2, max_days: 3 },
{ pincode: 425131, min_days: 2, max_days: 3 },
{ pincode: 425132, min_days: 2, max_days: 3 },
{ pincode: 425133, min_days: 2, max_days: 3 },
{ pincode: 425134, min_days: 2, max_days: 3 },
{ pincode: 425135, min_days: 2, max_days: 3 },
{ pincode: 425136, min_days: 2, max_days: 3 },
{ pincode: 425201, min_days: 2, max_days: 3 },
{ pincode: 425202, min_days: 2, max_days: 3 },
{ pincode: 425203, min_days: 2, max_days: 3 },
{ pincode: 425204, min_days: 2, max_days: 3 },
{ pincode: 425211, min_days: 2, max_days: 3 },
{ pincode: 425301, min_days: 2, max_days: 3 },
{ pincode: 425302, min_days: 2, max_days: 3 },
{ pincode: 425303, min_days: 2, max_days: 3 },
{ pincode: 425304, min_days: 2, max_days: 3 },
{ pincode: 425305, min_days: 2, max_days: 3 },
{ pincode: 425306, min_days: 2, max_days: 3 },
{ pincode: 425307, min_days: 2, max_days: 3 },
{ pincode: 425308, min_days: 2, max_days: 3 },
{ pincode: 425309, min_days: 2, max_days: 3 },
{ pincode: 425310, min_days: 2, max_days: 3 },
{ pincode: 425311, min_days: 2, max_days: 3 },
{ pincode: 425312, min_days: 2, max_days: 3 },
{ pincode: 425313, min_days: 2, max_days: 3 },
{ pincode: 425314, min_days: 2, max_days: 3 },
{ pincode: 425316, min_days: 2, max_days: 3 },
{ pincode: 425317, min_days: 2, max_days: 3 },
{ pincode: 425318, min_days: 2, max_days: 3 },
{ pincode: 425319, min_days: 2, max_days: 3 },
{ pincode: 425321, min_days: 2, max_days: 3 },
{ pincode: 425322, min_days: 2, max_days: 3 },
{ pincode: 425323, min_days: 2, max_days: 3 },
{ pincode: 425324, min_days: 2, max_days: 3 },
{ pincode: 425325, min_days: 2, max_days: 3 },
{ pincode: 425326, min_days: 2, max_days: 3 },
{ pincode: 425327, min_days: 2, max_days: 3 },
{ pincode: 425336, min_days: 2, max_days: 3 },
{ pincode: 425401, min_days: 2, max_days: 3 },
{ pincode: 425402, min_days: 2, max_days: 3 },
{ pincode: 425403, min_days: 2, max_days: 3 },
{ pincode: 425404, min_days: 2, max_days: 3 },
{ pincode: 425405, min_days: 2, max_days: 3 },
{ pincode: 425406, min_days: 1, max_days: 2 },
{ pincode: 425407, min_days: 1, max_days: 2 },
{ pincode: 425408, min_days: 1, max_days: 2 },
{ pincode: 425409, min_days: 1, max_days: 2 },
{ pincode: 425410, min_days: 1, max_days: 2 },
{ pincode: 425411, min_days: 1, max_days: 2 },
{ pincode: 425412, min_days: 1, max_days: 2 },
{ pincode: 425413, min_days: 1, max_days: 2 },
{ pincode: 425414, min_days: 1, max_days: 2 },
{ pincode: 425415, min_days: 1, max_days: 2 },
{ pincode: 425416, min_days: 1, max_days: 2 },
{ pincode: 425417, min_days: 1, max_days: 2 },
{ pincode: 425418, min_days: 1, max_days: 2 },
{ pincode: 425419, min_days: 1, max_days: 2 },
{ pincode: 425420, min_days: 2, max_days: 3 },
{ pincode: 425421, min_days: 2, max_days: 3 },
{ pincode: 425422, min_days: 1, max_days: 2 },
{ pincode: 425423, min_days: 1, max_days: 2 },
{ pincode: 425424, min_days: 1, max_days: 2 },
{ pincode: 425426, min_days: 1, max_days: 2 },
{ pincode: 425427, min_days: 2, max_days: 3 },
{ pincode: 425428, min_days: 2, max_days: 3 },
{ pincode: 425429, min_days: 2, max_days: 3 },
{ pincode: 425432, min_days: 1, max_days: 2 },
{ pincode: 425434, min_days: 2, max_days: 3 },
{ pincode: 425436, min_days: 2, max_days: 3 },
{ pincode: 425437, min_days: 2, max_days: 3 },
{ pincode: 425438, min_days: 2, max_days: 3 },
{ pincode: 425439, min_days: 2, max_days: 3 },
{ pincode: 425440, min_days: 2, max_days: 3 },
{ pincode: 425442, min_days: 2, max_days: 3 },
{ pincode: 425443, min_days: 2, max_days: 3 },
{ pincode: 425444, min_days: 1, max_days: 2 },
{ pincode: 425445, min_days: 2, max_days: 3 },
{ pincode: 425448, min_days: 2, max_days: 3 },
{ pincode: 425449, min_days: 2, max_days: 3 },
{ pincode: 425451, min_days: 2, max_days: 3 },
{ pincode: 425452, min_days: 1, max_days: 2 },
{ pincode: 425453, min_days: 2, max_days: 3 },
{ pincode: 425501, min_days: 2, max_days: 3 },
{ pincode: 425502, min_days: 2, max_days: 3 },
{ pincode: 425503, min_days: 2, max_days: 3 },
{ pincode: 425504, min_days: 2, max_days: 3 },
{ pincode: 425505, min_days: 2, max_days: 3 },
{ pincode: 425506, min_days: 2, max_days: 3 },
{ pincode: 425507, min_days: 2, max_days: 3 },
{ pincode: 425508, min_days: 2, max_days: 3 },
{ pincode: 425509, min_days: 2, max_days: 3 },
{ pincode: 425510, min_days: 2, max_days: 3 },
{ pincode: 425511, min_days: 2, max_days: 3 },
{ pincode: 425512, min_days: 2, max_days: 3 },
{ pincode: 425515, min_days: 2, max_days: 3 },
{ pincode: 425516, min_days: 2, max_days: 3 },
{ pincode: 425517, min_days: 2, max_days: 3 },
{ pincode: 425518, min_days: 2, max_days: 3 },
{ pincode: 425519, min_days: 2, max_days: 3 },
{ pincode: 425520, min_days: 2, max_days: 3 },
{ pincode: 425521, min_days: 2, max_days: 3 },
{ pincode: 425522, min_days: 2, max_days: 3 },
{ pincode: 425523, min_days: 2, max_days: 3 },
{ pincode: 425524, min_days: 2, max_days: 3 },
{ pincode: 430005, min_days: 2, max_days: 3 },
{ pincode: 430006, min_days: 2, max_days: 3 },
{ pincode: 430007, min_days: 2, max_days: 3 },
{ pincode: 430507, min_days: 2, max_days: 3 },
{ pincode: 431001, min_days: 2, max_days: 3 },
{ pincode: 431002, min_days: 2, max_days: 3 },
{ pincode: 431003, min_days: 2, max_days: 3 },
{ pincode: 431004, min_days: 2, max_days: 3 },
{ pincode: 431005, min_days: 2, max_days: 3 },
{ pincode: 431006, min_days: 2, max_days: 3 },
{ pincode: 431007, min_days: 2, max_days: 3 },
{ pincode: 431008, min_days: 2, max_days: 3 },
{ pincode: 431009, min_days: 2, max_days: 3 },
{ pincode: 431010, min_days: 2, max_days: 3 },
{ pincode: 431011, min_days: 2, max_days: 3 },
{ pincode: 431100, min_days: 2, max_days: 3 },
{ pincode: 431101, min_days: 2, max_days: 3 },
{ pincode: 431102, min_days: 2, max_days: 3 },
{ pincode: 431103, min_days: 2, max_days: 3 },
{ pincode: 431104, min_days: 2, max_days: 3 },
{ pincode: 431105, min_days: 2, max_days: 3 },
{ pincode: 431106, min_days: 2, max_days: 3 },
{ pincode: 431107, min_days: 2, max_days: 3 },
{ pincode: 431108, min_days: 2, max_days: 3 },
{ pincode: 431109, min_days: 2, max_days: 3 },
{ pincode: 431110, min_days: 2, max_days: 3 },
{ pincode: 431111, min_days: 2, max_days: 3 },
{ pincode: 431112, min_days: 2, max_days: 3 },
{ pincode: 431113, min_days: 2, max_days: 3 },
{ pincode: 431114, min_days: 2, max_days: 3 },
{ pincode: 431115, min_days: 2, max_days: 3 },
{ pincode: 431116, min_days: 2, max_days: 3 },
{ pincode: 431117, min_days: 2, max_days: 3 },
{ pincode: 431118, min_days: 2, max_days: 3 },
{ pincode: 431119, min_days: 2, max_days: 3 },
{ pincode: 431120, min_days: 2, max_days: 3 },
{ pincode: 431121, min_days: 2, max_days: 3 },
{ pincode: 431122, min_days: 2, max_days: 3 },
{ pincode: 431123, min_days: 2, max_days: 3 },
{ pincode: 431124, min_days: 2, max_days: 3 },
{ pincode: 431125, min_days: 2, max_days: 3 },
{ pincode: 431126, min_days: 2, max_days: 3 },
{ pincode: 431127, min_days: 2, max_days: 3 },
{ pincode: 431128, min_days: 2, max_days: 3 },
{ pincode: 431129, min_days: 2, max_days: 3 },
{ pincode: 431130, min_days: 2, max_days: 3 },
{ pincode: 431131, min_days: 2, max_days: 3 },
{ pincode: 431132, min_days: 2, max_days: 3 },
{ pincode: 431133, min_days: 2, max_days: 3 },
{ pincode: 431134, min_days: 2, max_days: 3 },
{ pincode: 431135, min_days: 2, max_days: 3 },
{ pincode: 431136, min_days: 2, max_days: 3 },
{ pincode: 431137, min_days: 2, max_days: 3 },
{ pincode: 431138, min_days: 2, max_days: 3 },
{ pincode: 431139, min_days: 2, max_days: 3 },
{ pincode: 431142, min_days: 2, max_days: 3 },
{ pincode: 431143, min_days: 2, max_days: 3 },
{ pincode: 431144, min_days: 2, max_days: 3 },
{ pincode: 431146, min_days: 2, max_days: 3 },
{ pincode: 431147, min_days: 2, max_days: 3 },
{ pincode: 431148, min_days: 2, max_days: 3 },
{ pincode: 431150, min_days: 2, max_days: 3 },
{ pincode: 431151, min_days: 2, max_days: 3 },
{ pincode: 431152, min_days: 1, max_days: 2 },
{ pincode: 431153, min_days: 1, max_days: 2 },
{ pincode: 431154, min_days: 2, max_days: 3 },
{ pincode: 431200, min_days: 2, max_days: 3 },
{ pincode: 431201, min_days: 2, max_days: 3 },
{ pincode: 431202, min_days: 2, max_days: 3 },
{ pincode: 431203, min_days: 2, max_days: 3 },
{ pincode: 431204, min_days: 2, max_days: 3 },
{ pincode: 431205, min_days: 2, max_days: 3 },
{ pincode: 431206, min_days: 2, max_days: 3 },
{ pincode: 431207, min_days: 2, max_days: 3 },
{ pincode: 431208, min_days: 2, max_days: 3 },
{ pincode: 431209, min_days: 2, max_days: 3 },
{ pincode: 431210, min_days: 2, max_days: 3 },
{ pincode: 431211, min_days: 2, max_days: 3 },
{ pincode: 431212, min_days: 2, max_days: 3 },
{ pincode: 431213, min_days: 2, max_days: 3 },
{ pincode: 431214, min_days: 2, max_days: 3 },
{ pincode: 431215, min_days: 2, max_days: 3 },
{ pincode: 431302, min_days: 2, max_days: 3 },
{ pincode: 431401, min_days: 2, max_days: 3 },
{ pincode: 431402, min_days: 2, max_days: 3 },
{ pincode: 431406, min_days: 2, max_days: 3 },
{ pincode: 431501, min_days: 2, max_days: 3 },
{ pincode: 431502, min_days: 2, max_days: 3 },
{ pincode: 431503, min_days: 2, max_days: 3 },
{ pincode: 431504, min_days: 2, max_days: 3 },
{ pincode: 431505, min_days: 2, max_days: 3 },
{ pincode: 431506, min_days: 2, max_days: 3 },
{ pincode: 431507, min_days: 2, max_days: 3 },
{ pincode: 431508, min_days: 2, max_days: 3 },
{ pincode: 431509, min_days: 2, max_days: 3 },
{ pincode: 431510, min_days: 2, max_days: 3 },
{ pincode: 431511, min_days: 2, max_days: 3 },
{ pincode: 431512, min_days: 2, max_days: 3 },
{ pincode: 431513, min_days: 2, max_days: 3 },
{ pincode: 431514, min_days: 2, max_days: 3 },
{ pincode: 431515, min_days: 2, max_days: 3 },
{ pincode: 431516, min_days: 2, max_days: 3 },
{ pincode: 431517, min_days: 2, max_days: 3 },
{ pincode: 431518, min_days: 2, max_days: 3 },
{ pincode: 431519, min_days: 2, max_days: 3 },
{ pincode: 431520, min_days: 2, max_days: 3 },
{ pincode: 431521, min_days: 2, max_days: 3 },
{ pincode: 431522, min_days: 2, max_days: 3 },
{ pincode: 431523, min_days: 2, max_days: 3 },
{ pincode: 431525, min_days: 2, max_days: 3 },
{ pincode: 431526, min_days: 2, max_days: 3 },
{ pincode: 431528, min_days: 2, max_days: 3 },
{ pincode: 431530, min_days: 2, max_days: 3 },
{ pincode: 431531, min_days: 2, max_days: 3 },
{ pincode: 431536, min_days: 2, max_days: 3 },
{ pincode: 431537, min_days: 2, max_days: 3 },
{ pincode: 431539, min_days: 2, max_days: 3 },
{ pincode: 431540, min_days: 2, max_days: 3 },
{ pincode: 431541, min_days: 2, max_days: 3 },
{ pincode: 431542, min_days: 2, max_days: 3 },
{ pincode: 431601, min_days: 1, max_days: 2 },
{ pincode: 431602, min_days: 2, max_days: 3 },
{ pincode: 431603, min_days: 2, max_days: 3 },
{ pincode: 431604, min_days: 2, max_days: 3 },
{ pincode: 431605, min_days: 2, max_days: 3 },
{ pincode: 431606, min_days: 2, max_days: 3 },
{ pincode: 431646, min_days: 2, max_days: 3 },
{ pincode: 431701, min_days: 2, max_days: 3 },
{ pincode: 431702, min_days: 2, max_days: 3 },
{ pincode: 431703, min_days: 2, max_days: 3 },
{ pincode: 431704, min_days: 1, max_days: 2 },
{ pincode: 431705, min_days: 2, max_days: 3 },
{ pincode: 431707, min_days: 2, max_days: 3 },
{ pincode: 431708, min_days: 2, max_days: 3 },
{ pincode: 431709, min_days: 2, max_days: 3 },
{ pincode: 431710, min_days: 2, max_days: 3 },
{ pincode: 431711, min_days: 2, max_days: 3 },
{ pincode: 431712, min_days: 2, max_days: 3 },
{ pincode: 431713, min_days: 2, max_days: 3 },
{ pincode: 431714, min_days: 2, max_days: 3 },
{ pincode: 431715, min_days: 2, max_days: 3 },
{ pincode: 431716, min_days: 2, max_days: 3 },
{ pincode: 431717, min_days: 2, max_days: 3 },
{ pincode: 431718, min_days: 2, max_days: 3 },
{ pincode: 431719, min_days: 2, max_days: 3 },
{ pincode: 431720, min_days: 2, max_days: 3 },
{ pincode: 431721, min_days: 2, max_days: 3 },
{ pincode: 431722, min_days: 2, max_days: 3 },
{ pincode: 431723, min_days: 2, max_days: 3 },
{ pincode: 431724, min_days: 2, max_days: 3 },
{ pincode: 431725, min_days: 2, max_days: 3 },
{ pincode: 431731, min_days: 2, max_days: 3 },
{ pincode: 431736, min_days: 2, max_days: 3 },
{ pincode: 431738, min_days: 2, max_days: 3 },
{ pincode: 431741, min_days: 2, max_days: 3 },
{ pincode: 431742, min_days: 2, max_days: 3 },
{ pincode: 431743, min_days: 2, max_days: 3 },
{ pincode: 431745, min_days: 2, max_days: 3 },
{ pincode: 431746, min_days: 2, max_days: 3 },
{ pincode: 431750, min_days: 2, max_days: 3 },
{ pincode: 431801, min_days: 2, max_days: 3 },
{ pincode: 431802, min_days: 2, max_days: 3 },
{ pincode: 431803, min_days: 2, max_days: 3 },
{ pincode: 431804, min_days: 2, max_days: 3 },
{ pincode: 431805, min_days: 2, max_days: 3 },
{ pincode: 431806, min_days: 2, max_days: 3 },
{ pincode: 431807, min_days: 2, max_days: 3 },
{ pincode: 431808, min_days: 2, max_days: 3 },
{ pincode: 431809, min_days: 2, max_days: 3 },
{ pincode: 431810, min_days: 2, max_days: 3 },
{ pincode: 431811, min_days: 2, max_days: 3 },
{ pincode: 431812, min_days: 2, max_days: 3 },
{ pincode: 440001, min_days: 2, max_days: 3 },
{ pincode: 440002, min_days: 2, max_days: 3 },
{ pincode: 440003, min_days: 2, max_days: 3 },
{ pincode: 440004, min_days: 2, max_days: 3 },
{ pincode: 440005, min_days: 2, max_days: 3 },
{ pincode: 440006, min_days: 2, max_days: 3 },
{ pincode: 440007, min_days: 2, max_days: 3 },
{ pincode: 440008, min_days: 2, max_days: 3 },
{ pincode: 440009, min_days: 2, max_days: 3 },
{ pincode: 440010, min_days: 2, max_days: 3 },
{ pincode: 440011, min_days: 2, max_days: 3 },
{ pincode: 440012, min_days: 2, max_days: 3 },
{ pincode: 440013, min_days: 2, max_days: 3 },
{ pincode: 440014, min_days: 2, max_days: 3 },
{ pincode: 440015, min_days: 2, max_days: 3 },
{ pincode: 440016, min_days: 2, max_days: 3 },
{ pincode: 440017, min_days: 2, max_days: 3 },
{ pincode: 440018, min_days: 2, max_days: 3 },
{ pincode: 440019, min_days: 2, max_days: 3 },
{ pincode: 440020, min_days: 2, max_days: 3 },
{ pincode: 440021, min_days: 2, max_days: 3 },
{ pincode: 440022, min_days: 2, max_days: 3 },
{ pincode: 440023, min_days: 2, max_days: 3 },
{ pincode: 440024, min_days: 2, max_days: 3 },
{ pincode: 440025, min_days: 2, max_days: 3 },
{ pincode: 440026, min_days: 2, max_days: 3 },
{ pincode: 440027, min_days: 2, max_days: 3 },
{ pincode: 440028, min_days: 2, max_days: 3 },
{ pincode: 440029, min_days: 2, max_days: 3 },
{ pincode: 440030, min_days: 2, max_days: 3 },
{ pincode: 440031, min_days: 2, max_days: 3 },
{ pincode: 440032, min_days: 2, max_days: 3 },
{ pincode: 440033, min_days: 2, max_days: 3 },
{ pincode: 440034, min_days: 2, max_days: 3 },
{ pincode: 440035, min_days: 2, max_days: 3 },
{ pincode: 440036, min_days: 2, max_days: 3 },
{ pincode: 440037, min_days: 2, max_days: 3 },
{ pincode: 440038, min_days: 2, max_days: 3 },
{ pincode: 440104, min_days: 2, max_days: 3 },
{ pincode: 440531, min_days: 2, max_days: 3 },
{ pincode: 440705, min_days: 2, max_days: 3 },
{ pincode: 441001, min_days: 2, max_days: 3 },
{ pincode: 441002, min_days: 2, max_days: 3 },
{ pincode: 441008, min_days: 2, max_days: 3 },
{ pincode: 441101, min_days: 2, max_days: 3 },
{ pincode: 441102, min_days: 2, max_days: 3 },
{ pincode: 441103, min_days: 2, max_days: 3 },
{ pincode: 441104, min_days: 2, max_days: 3 },
{ pincode: 441105, min_days: 2, max_days: 3 },
{ pincode: 441106, min_days: 2, max_days: 3 },
{ pincode: 441107, min_days: 2, max_days: 3 },
{ pincode: 441108, min_days: 2, max_days: 3 },
{ pincode: 441109, min_days: 2, max_days: 3 },
{ pincode: 441110, min_days: 2, max_days: 3 },
{ pincode: 441111, min_days: 2, max_days: 3 },
{ pincode: 441112, min_days: 2, max_days: 3 },
{ pincode: 441113, min_days: 2, max_days: 3 },
{ pincode: 441114, min_days: 2, max_days: 3 },
{ pincode: 441115, min_days: 2, max_days: 3 },
{ pincode: 441116, min_days: 2, max_days: 3 },
{ pincode: 441117, min_days: 2, max_days: 3 },
{ pincode: 441118, min_days: 2, max_days: 3 },
{ pincode: 441121, min_days: 2, max_days: 3 },
{ pincode: 441122, min_days: 2, max_days: 3 },
{ pincode: 441123, min_days: 2, max_days: 3 },
{ pincode: 441125, min_days: 2, max_days: 3 },
{ pincode: 441201, min_days: 2, max_days: 3 },
{ pincode: 441202, min_days: 2, max_days: 3 },
{ pincode: 441203, min_days: 2, max_days: 3 },
{ pincode: 441204, min_days: 2, max_days: 3 },
{ pincode: 441205, min_days: 2, max_days: 3 },
{ pincode: 441206, min_days: 2, max_days: 3 },
{ pincode: 441207, min_days: 2, max_days: 3 },
{ pincode: 441208, min_days: 2, max_days: 3 },
{ pincode: 441209, min_days: 2, max_days: 3 },
{ pincode: 441210, min_days: 2, max_days: 3 },
{ pincode: 441212, min_days: 2, max_days: 3 },
{ pincode: 441213, min_days: 2, max_days: 3 },
{ pincode: 441214, min_days: 2, max_days: 3 },
{ pincode: 441215, min_days: 2, max_days: 3 },
{ pincode: 441216, min_days: 2, max_days: 3 },
{ pincode: 441217, min_days: 2, max_days: 3 },
{ pincode: 441221, min_days: 2, max_days: 3 },
{ pincode: 441222, min_days: 2, max_days: 3 },
{ pincode: 441223, min_days: 2, max_days: 3 },
{ pincode: 441224, min_days: 2, max_days: 3 },
{ pincode: 441225, min_days: 2, max_days: 3 },
{ pincode: 441226, min_days: 2, max_days: 3 },
{ pincode: 441228, min_days: 2, max_days: 3 },
{ pincode: 441301, min_days: 2, max_days: 3 },
{ pincode: 441302, min_days: 2, max_days: 3 },
{ pincode: 441303, min_days: 2, max_days: 3 },
{ pincode: 441304, min_days: 2, max_days: 3 },
{ pincode: 441305, min_days: 2, max_days: 3 },
{ pincode: 441306, min_days: 2, max_days: 3 },
{ pincode: 441400, min_days: 2, max_days: 3 },
{ pincode: 441401, min_days: 2, max_days: 3 },
{ pincode: 441404, min_days: 2, max_days: 3 },
{ pincode: 441406, min_days: 2, max_days: 3 },
{ pincode: 441408, min_days: 2, max_days: 3 },
{ pincode: 441409, min_days: 2, max_days: 3 },
{ pincode: 441501, min_days: 2, max_days: 3 },
{ pincode: 441502, min_days: 2, max_days: 3 },
{ pincode: 441503, min_days: 2, max_days: 3 },
{ pincode: 441504, min_days: 2, max_days: 3 },
{ pincode: 441601, min_days: 2, max_days: 3 },
{ pincode: 441602, min_days: 2, max_days: 3 },
{ pincode: 441603, min_days: 2, max_days: 3 },
{ pincode: 441604, min_days: 2, max_days: 3 },
{ pincode: 441605, min_days: 2, max_days: 3 },
{ pincode: 441606, min_days: 2, max_days: 3 },
{ pincode: 441607, min_days: 2, max_days: 3 },
{ pincode: 441608, min_days: 2, max_days: 3 },
{ pincode: 441609, min_days: 2, max_days: 3 },
{ pincode: 441611, min_days: 2, max_days: 3 },
{ pincode: 441612, min_days: 2, max_days: 3 },
{ pincode: 441613, min_days: 2, max_days: 3 },
{ pincode: 441614, min_days: 2, max_days: 3 },
{ pincode: 441701, min_days: 2, max_days: 3 },
{ pincode: 441702, min_days: 2, max_days: 3 },
{ pincode: 441801, min_days: 2, max_days: 3 },
{ pincode: 441802, min_days: 2, max_days: 3 },
{ pincode: 441803, min_days: 2, max_days: 3 },
{ pincode: 441804, min_days: 2, max_days: 3 },
{ pincode: 441805, min_days: 2, max_days: 3 },
{ pincode: 441806, min_days: 2, max_days: 3 },
{ pincode: 441807, min_days: 2, max_days: 3 },
{ pincode: 441808, min_days: 2, max_days: 3 },
{ pincode: 441809, min_days: 2, max_days: 3 },
{ pincode: 441811, min_days: 2, max_days: 3 },
{ pincode: 441901, min_days: 2, max_days: 3 },
{ pincode: 441902, min_days: 2, max_days: 3 },
{ pincode: 441903, min_days: 2, max_days: 3 },
{ pincode: 441904, min_days: 2, max_days: 3 },
{ pincode: 441905, min_days: 2, max_days: 3 },
{ pincode: 441906, min_days: 2, max_days: 3 },
{ pincode: 441907, min_days: 2, max_days: 3 },
{ pincode: 441908, min_days: 2, max_days: 3 },
{ pincode: 441909, min_days: 2, max_days: 3 },
{ pincode: 441910, min_days: 2, max_days: 3 },
{ pincode: 441911, min_days: 2, max_days: 3 },
{ pincode: 441912, min_days: 2, max_days: 3 },
{ pincode: 441913, min_days: 2, max_days: 3 },
{ pincode: 441914, min_days: 2, max_days: 3 },
{ pincode: 441915, min_days: 2, max_days: 3 },
{ pincode: 441916, min_days: 2, max_days: 3 },
{ pincode: 441919, min_days: 2, max_days: 3 },
{ pincode: 441920, min_days: 2, max_days: 3 },
{ pincode: 441923, min_days: 2, max_days: 3 },
{ pincode: 441924, min_days: 2, max_days: 3 },
{ pincode: 441930, min_days: 2, max_days: 3 },
{ pincode: 442001, min_days: 2, max_days: 3 },
{ pincode: 442002, min_days: 2, max_days: 3 },
{ pincode: 442003, min_days: 2, max_days: 3 },
{ pincode: 442004, min_days: 2, max_days: 3 },
{ pincode: 442005, min_days: 2, max_days: 3 },
{ pincode: 442006, min_days: 2, max_days: 3 },
{ pincode: 442101, min_days: 2, max_days: 3 },
{ pincode: 442102, min_days: 2, max_days: 3 },
{ pincode: 442103, min_days: 2, max_days: 3 },
{ pincode: 442104, min_days: 2, max_days: 3 },
{ pincode: 442105, min_days: 2, max_days: 3 },
{ pincode: 442106, min_days: 2, max_days: 3 },
{ pincode: 442107, min_days: 2, max_days: 3 },
{ pincode: 442108, min_days: 2, max_days: 3 },
{ pincode: 442109, min_days: 2, max_days: 3 },
{ pincode: 442110, min_days: 2, max_days: 3 },
{ pincode: 442111, min_days: 2, max_days: 3 },
{ pincode: 442112, min_days: 2, max_days: 3 },
{ pincode: 442201, min_days: 2, max_days: 3 },
{ pincode: 442202, min_days: 2, max_days: 3 },
{ pincode: 442203, min_days: 2, max_days: 3 },
{ pincode: 442204, min_days: 2, max_days: 3 },
{ pincode: 442205, min_days: 2, max_days: 3 },
{ pincode: 442207, min_days: 2, max_days: 3 },
{ pincode: 442301, min_days: 2, max_days: 3 },
{ pincode: 442302, min_days: 2, max_days: 3 },
{ pincode: 442303, min_days: 2, max_days: 3 },
{ pincode: 442304, min_days: 2, max_days: 3 },
{ pincode: 442305, min_days: 2, max_days: 3 },
{ pincode: 442306, min_days: 2, max_days: 3 },
{ pincode: 442307, min_days: 2, max_days: 3 },
{ pincode: 442308, min_days: 2, max_days: 3 },
{ pincode: 442310, min_days: 2, max_days: 3 },
{ pincode: 442401, min_days: 2, max_days: 3 },
{ pincode: 442402, min_days: 2, max_days: 3 },
{ pincode: 442403, min_days: 2, max_days: 3 },
{ pincode: 442404, min_days: 2, max_days: 3 },
{ pincode: 442405, min_days: 2, max_days: 3 },
{ pincode: 442406, min_days: 2, max_days: 3 },
{ pincode: 442501, min_days: 2, max_days: 3 },
{ pincode: 442502, min_days: 2, max_days: 3 },
{ pincode: 442503, min_days: 2, max_days: 3 },
{ pincode: 442504, min_days: 2, max_days: 3 },
{ pincode: 442505, min_days: 2, max_days: 3 },
{ pincode: 442506, min_days: 2, max_days: 3 },
{ pincode: 442507, min_days: 2, max_days: 3 },
{ pincode: 442603, min_days: 2, max_days: 3 },
{ pincode: 442604, min_days: 2, max_days: 3 },
{ pincode: 442605, min_days: 2, max_days: 3 },
{ pincode: 442606, min_days: 2, max_days: 3 },
{ pincode: 442701, min_days: 2, max_days: 3 },
{ pincode: 442702, min_days: 2, max_days: 3 },
{ pincode: 442703, min_days: 2, max_days: 3 },
{ pincode: 442704, min_days: 2, max_days: 3 },
{ pincode: 442705, min_days: 2, max_days: 3 },
{ pincode: 442706, min_days: 2, max_days: 3 },
{ pincode: 442707, min_days: 2, max_days: 3 },
{ pincode: 442708, min_days: 2, max_days: 3 },
{ pincode: 442709, min_days: 2, max_days: 3 },
{ pincode: 442710, min_days: 2, max_days: 3 },
{ pincode: 442901, min_days: 2, max_days: 3 },
{ pincode: 442902, min_days: 2, max_days: 3 },
{ pincode: 442903, min_days: 2, max_days: 3 },
{ pincode: 442904, min_days: 2, max_days: 3 },
{ pincode: 442905, min_days: 2, max_days: 3 },
{ pincode: 442906, min_days: 2, max_days: 3 },
{ pincode: 442907, min_days: 2, max_days: 3 },
{ pincode: 442908, min_days: 2, max_days: 3 },
{ pincode: 442909, min_days: 2, max_days: 3 },
{ pincode: 442910, min_days: 2, max_days: 3 },
{ pincode: 442911, min_days: 2, max_days: 3 },
{ pincode: 442912, min_days: 2, max_days: 3 },
{ pincode: 442913, min_days: 2, max_days: 3 },
{ pincode: 442914, min_days: 2, max_days: 3 },
{ pincode: 442916, min_days: 2, max_days: 3 },
{ pincode: 442917, min_days: 2, max_days: 3 },
{ pincode: 442918, min_days: 2, max_days: 3 },
{ pincode: 442919, min_days: 2, max_days: 3 },
{ pincode: 443001, min_days: 2, max_days: 3 },
{ pincode: 443002, min_days: 2, max_days: 3 },
{ pincode: 443101, min_days: 2, max_days: 3 },
{ pincode: 443102, min_days: 2, max_days: 3 },
{ pincode: 443103, min_days: 2, max_days: 3 },
{ pincode: 443104, min_days: 2, max_days: 3 },
{ pincode: 443105, min_days: 2, max_days: 3 },
{ pincode: 443106, min_days: 2, max_days: 3 },
{ pincode: 443109, min_days: 2, max_days: 3 },
{ pincode: 443110, min_days: 2, max_days: 3 },
{ pincode: 443111, min_days: 2, max_days: 3 },
{ pincode: 443112, min_days: 2, max_days: 3 },
{ pincode: 443201, min_days: 2, max_days: 3 },
{ pincode: 443202, min_days: 2, max_days: 3 },
{ pincode: 443203, min_days: 2, max_days: 3 },
{ pincode: 443204, min_days: 2, max_days: 3 },
{ pincode: 443206, min_days: 2, max_days: 3 },
{ pincode: 443207, min_days: 2, max_days: 3 },
{ pincode: 443209, min_days: 2, max_days: 3 },
{ pincode: 443301, min_days: 2, max_days: 3 },
{ pincode: 443302, min_days: 2, max_days: 3 },
{ pincode: 443303, min_days: 2, max_days: 3 },
{ pincode: 443304, min_days: 2, max_days: 3 },
{ pincode: 443305, min_days: 2, max_days: 3 },
{ pincode: 443306, min_days: 2, max_days: 3 },
{ pincode: 443307, min_days: 2, max_days: 3 },
{ pincode: 443308, min_days: 2, max_days: 3 },
{ pincode: 443401, min_days: 2, max_days: 3 },
{ pincode: 443402, min_days: 2, max_days: 3 },
{ pincode: 443403, min_days: 2, max_days: 3 },
{ pincode: 443404, min_days: 2, max_days: 3 },
{ pincode: 443405, min_days: 2, max_days: 3 },
{ pincode: 443406, min_days: 2, max_days: 3 },
{ pincode: 444001, min_days: 2, max_days: 3 },
{ pincode: 444002, min_days: 2, max_days: 3 },
{ pincode: 444003, min_days: 2, max_days: 3 },
{ pincode: 444004, min_days: 2, max_days: 3 },
{ pincode: 444005, min_days: 2, max_days: 3 },
{ pincode: 444006, min_days: 2, max_days: 3 },
{ pincode: 444007, min_days: 2, max_days: 3 },
{ pincode: 444101, min_days: 2, max_days: 3 },
{ pincode: 444102, min_days: 2, max_days: 3 },
{ pincode: 444103, min_days: 2, max_days: 3 },
{ pincode: 444104, min_days: 2, max_days: 3 },
{ pincode: 444105, min_days: 2, max_days: 3 },
{ pincode: 444106, min_days: 2, max_days: 3 },
{ pincode: 444107, min_days: 2, max_days: 3 },
{ pincode: 444108, min_days: 2, max_days: 3 },
{ pincode: 444109, min_days: 2, max_days: 3 },
{ pincode: 444110, min_days: 2, max_days: 3 },
{ pincode: 444111, min_days: 2, max_days: 3 },
{ pincode: 444112, min_days: 2, max_days: 3 },
{ pincode: 444113, min_days: 2, max_days: 3 },
{ pincode: 444114, min_days: 2, max_days: 3 },
{ pincode: 444116, min_days: 2, max_days: 3 },
{ pincode: 444117, min_days: 2, max_days: 3 },
{ pincode: 444119, min_days: 2, max_days: 3 },
{ pincode: 444122, min_days: 2, max_days: 3 },
{ pincode: 444123, min_days: 2, max_days: 3 },
{ pincode: 444124, min_days: 2, max_days: 3 },
{ pincode: 444125, min_days: 2, max_days: 3 },
{ pincode: 444126, min_days: 2, max_days: 3 },
{ pincode: 444129, min_days: 2, max_days: 3 },
{ pincode: 444201, min_days: 2, max_days: 3 },
{ pincode: 444202, min_days: 2, max_days: 3 },
{ pincode: 444203, min_days: 2, max_days: 3 },
{ pincode: 444204, min_days: 2, max_days: 3 },
{ pincode: 444301, min_days: 2, max_days: 3 },
{ pincode: 444302, min_days: 2, max_days: 3 },
{ pincode: 444303, min_days: 2, max_days: 3 },
{ pincode: 444304, min_days: 2, max_days: 3 },
{ pincode: 444306, min_days: 2, max_days: 3 },
{ pincode: 444307, min_days: 2, max_days: 3 },
{ pincode: 444308, min_days: 2, max_days: 3 },
{ pincode: 444309, min_days: 2, max_days: 3 },
{ pincode: 444311, min_days: 2, max_days: 3 },
{ pincode: 444312, min_days: 2, max_days: 3 },
{ pincode: 444401, min_days: 2, max_days: 3 },
{ pincode: 444402, min_days: 2, max_days: 3 },
{ pincode: 444403, min_days: 2, max_days: 3 },
{ pincode: 444404, min_days: 2, max_days: 3 },
{ pincode: 444405, min_days: 2, max_days: 3 },
{ pincode: 444407, min_days: 2, max_days: 3 },
{ pincode: 444409, min_days: 2, max_days: 3 },
{ pincode: 444501, min_days: 2, max_days: 3 },
{ pincode: 444502, min_days: 2, max_days: 3 },
{ pincode: 444503, min_days: 2, max_days: 3 },
{ pincode: 444504, min_days: 2, max_days: 3 },
{ pincode: 444505, min_days: 2, max_days: 3 },
{ pincode: 444506, min_days: 2, max_days: 3 },
{ pincode: 444507, min_days: 2, max_days: 3 },
{ pincode: 444508, min_days: 2, max_days: 3 },
{ pincode: 444509, min_days: 2, max_days: 3 },
{ pincode: 444510, min_days: 2, max_days: 3 },
{ pincode: 444511, min_days: 2, max_days: 3 },
{ pincode: 444512, min_days: 2, max_days: 3 },
{ pincode: 444601, min_days: 2, max_days: 3 },
{ pincode: 444602, min_days: 2, max_days: 3 },
{ pincode: 444603, min_days: 2, max_days: 3 },
{ pincode: 444604, min_days: 2, max_days: 3 },
{ pincode: 444605, min_days: 2, max_days: 3 },
{ pincode: 444606, min_days: 2, max_days: 3 },
{ pincode: 444607, min_days: 2, max_days: 3 },
{ pincode: 444608, min_days: 2, max_days: 3 },
{ pincode: 444609, min_days: 2, max_days: 3 },
{ pincode: 444701, min_days: 2, max_days: 3 },
{ pincode: 444702, min_days: 2, max_days: 3 },
{ pincode: 444703, min_days: 2, max_days: 3 },
{ pincode: 444704, min_days: 2, max_days: 3 },
{ pincode: 444705, min_days: 2, max_days: 3 },
{ pincode: 444706, min_days: 2, max_days: 3 },
{ pincode: 444707, min_days: 2, max_days: 3 },
{ pincode: 444708, min_days: 2, max_days: 3 },
{ pincode: 444709, min_days: 2, max_days: 3 },
{ pincode: 444710, min_days: 2, max_days: 3 },
{ pincode: 444711, min_days: 2, max_days: 3 },
{ pincode: 444712, min_days: 2, max_days: 3 },
{ pincode: 444713, min_days: 2, max_days: 3 },
{ pincode: 444714, min_days: 2, max_days: 3 },
{ pincode: 444716, min_days: 2, max_days: 3 },
{ pincode: 444717, min_days: 2, max_days: 3 },
{ pincode: 444718, min_days: 2, max_days: 3 },
{ pincode: 444719, min_days: 2, max_days: 3 },
{ pincode: 444720, min_days: 2, max_days: 3 },
{ pincode: 444721, min_days: 2, max_days: 3 },
{ pincode: 444723, min_days: 2, max_days: 3 },
{ pincode: 444726, min_days: 2, max_days: 3 },
{ pincode: 444727, min_days: 2, max_days: 3 },
{ pincode: 444728, min_days: 2, max_days: 3 },
{ pincode: 444801, min_days: 2, max_days: 3 },
{ pincode: 444802, min_days: 2, max_days: 3 },
{ pincode: 444803, min_days: 2, max_days: 3 },
{ pincode: 444804, min_days: 2, max_days: 3 },
{ pincode: 444805, min_days: 2, max_days: 3 },
{ pincode: 444806, min_days: 2, max_days: 3 },
{ pincode: 444807, min_days: 2, max_days: 3 },
{ pincode: 444808, min_days: 2, max_days: 3 },
{ pincode: 444809, min_days: 2, max_days: 3 },
{ pincode: 444810, min_days: 2, max_days: 3 },
{ pincode: 444811, min_days: 2, max_days: 3 },
{ pincode: 444812, min_days: 2, max_days: 3 },
{ pincode: 444813, min_days: 2, max_days: 3 },
{ pincode: 444814, min_days: 2, max_days: 3 },
{ pincode: 444815, min_days: 2, max_days: 3 },
{ pincode: 444818, min_days: 2, max_days: 3 },
{ pincode: 444819, min_days: 2, max_days: 3 },
{ pincode: 444821, min_days: 2, max_days: 3 },
{ pincode: 444826, min_days: 2, max_days: 3 },
{ pincode: 444827, min_days: 2, max_days: 3 },
{ pincode: 444900, min_days: 2, max_days: 3 },
{ pincode: 444901, min_days: 2, max_days: 3 },
{ pincode: 444902, min_days: 2, max_days: 3 },
{ pincode: 444903, min_days: 2, max_days: 3 },
{ pincode: 444904, min_days: 2, max_days: 3 },
{ pincode: 444905, min_days: 2, max_days: 3 },
{ pincode: 444906, min_days: 2, max_days: 3 },
{ pincode: 444907, min_days: 2, max_days: 3 },
{ pincode: 444908, min_days: 2, max_days: 3 },
{ pincode: 444909, min_days: 2, max_days: 3 },
{ pincode: 444910, min_days: 2, max_days: 3 },
{ pincode: 444911, min_days: 2, max_days: 3 },
{ pincode: 444913, min_days: 2, max_days: 3 },
{ pincode: 444914, min_days: 2, max_days: 3 },
{ pincode: 444915, min_days: 2, max_days: 3 },
{ pincode: 445001, min_days: 2, max_days: 3 },
{ pincode: 445002, min_days: 2, max_days: 3 },
{ pincode: 445003, min_days: 2, max_days: 3 },
{ pincode: 445101, min_days: 2, max_days: 3 },
{ pincode: 445102, min_days: 2, max_days: 3 },
{ pincode: 445103, min_days: 2, max_days: 3 },
{ pincode: 445105, min_days: 2, max_days: 3 },
{ pincode: 445106, min_days: 2, max_days: 3 },
{ pincode: 445109, min_days: 2, max_days: 3 },
{ pincode: 445110, min_days: 2, max_days: 3 },
{ pincode: 445201, min_days: 2, max_days: 3 },
{ pincode: 445202, min_days: 2, max_days: 3 },
{ pincode: 445203, min_days: 2, max_days: 3 },
{ pincode: 445204, min_days: 2, max_days: 3 },
{ pincode: 445205, min_days: 2, max_days: 3 },
{ pincode: 445206, min_days: 2, max_days: 3 },
{ pincode: 445207, min_days: 2, max_days: 3 },
{ pincode: 445209, min_days: 2, max_days: 3 },
{ pincode: 445210, min_days: 2, max_days: 3 },
{ pincode: 445211, min_days: 2, max_days: 3 },
{ pincode: 445212, min_days: 2, max_days: 3 },
{ pincode: 445213, min_days: 2, max_days: 3 },
{ pincode: 445215, min_days: 2, max_days: 3 },
{ pincode: 445216, min_days: 2, max_days: 3 },
{ pincode: 445217, min_days: 2, max_days: 3 },
{ pincode: 445230, min_days: 2, max_days: 3 },
{ pincode: 445301, min_days: 2, max_days: 3 },
{ pincode: 445302, min_days: 2, max_days: 3 },
{ pincode: 445303, min_days: 2, max_days: 3 },
{ pincode: 445304, min_days: 2, max_days: 3 },
{ pincode: 445305, min_days: 2, max_days: 3 },
{ pincode: 445306, min_days: 2, max_days: 3 },
{ pincode: 445307, min_days: 2, max_days: 3 },
{ pincode: 445308, min_days: 2, max_days: 3 },
{ pincode: 445309, min_days: 2, max_days: 3 },
{ pincode: 445311, min_days: 2, max_days: 3 },
{ pincode: 445322, min_days: 2, max_days: 3 },
{ pincode: 445323, min_days: 2, max_days: 3 },
{ pincode: 445324, min_days: 2, max_days: 3 },
{ pincode: 445401, min_days: 2, max_days: 3 },
{ pincode: 445402, min_days: 2, max_days: 3 },
{ pincode: 450001, min_days: 2, max_days: 3 },
{ pincode: 450003, min_days: 2, max_days: 3 },
{ pincode: 450006, min_days: 2, max_days: 3 },
{ pincode: 450017, min_days: 2, max_days: 3 },
{ pincode: 450051, min_days: 2, max_days: 3 },
{ pincode: 450052, min_days: 2, max_days: 3 },
{ pincode: 450053, min_days: 2, max_days: 3 },
{ pincode: 450110, min_days: 2, max_days: 3 },
{ pincode: 450112, min_days: 2, max_days: 3 },
{ pincode: 450114, min_days: 2, max_days: 3 },
{ pincode: 450115, min_days: 2, max_days: 3 },
{ pincode: 450116, min_days: 2, max_days: 3 },
{ pincode: 450117, min_days: 2, max_days: 3 },
{ pincode: 450118, min_days: 2, max_days: 3 },
{ pincode: 450119, min_days: 2, max_days: 3 },
{ pincode: 450124, min_days: 2, max_days: 3 },
{ pincode: 450220, min_days: 2, max_days: 3 },
{ pincode: 450221, min_days: 2, max_days: 3 },
{ pincode: 450223, min_days: 2, max_days: 3 },
{ pincode: 450331, min_days: 2, max_days: 3 },
{ pincode: 450332, min_days: 2, max_days: 3 },
{ pincode: 450333, min_days: 2, max_days: 3 },
{ pincode: 450334, min_days: 2, max_days: 3 },
{ pincode: 450335, min_days: 2, max_days: 3 },
{ pincode: 450337, min_days: 2, max_days: 3 },
{ pincode: 450341, min_days: 2, max_days: 3 },
{ pincode: 450343, min_days: 2, max_days: 3 },
{ pincode: 450445, min_days: 2, max_days: 3 },
{ pincode: 450551, min_days: 2, max_days: 3 },
{ pincode: 450554, min_days: 2, max_days: 3 },
{ pincode: 450661, min_days: 2, max_days: 3 },
{ pincode: 450771, min_days: 2, max_days: 3 },
{ pincode: 450881, min_days: 2, max_days: 3 },
{ pincode: 450991, min_days: 2, max_days: 3 },
{ pincode: 450992, min_days: 2, max_days: 3 },
{ pincode: 451001, min_days: 2, max_days: 3 },
{ pincode: 451010, min_days: 2, max_days: 3 },
{ pincode: 451110, min_days: 2, max_days: 3 },
{ pincode: 451111, min_days: 2, max_days: 3 },
{ pincode: 451112, min_days: 2, max_days: 3 },
{ pincode: 451113, min_days: 2, max_days: 3 },
{ pincode: 451114, min_days: 2, max_days: 3 },
{ pincode: 451115, min_days: 2, max_days: 3 },
{ pincode: 451117, min_days: 2, max_days: 3 },
{ pincode: 451220, min_days: 2, max_days: 3 },
{ pincode: 451221, min_days: 2, max_days: 3 },
{ pincode: 451222, min_days: 2, max_days: 3 },
{ pincode: 451223, min_days: 2, max_days: 3 },
{ pincode: 451224, min_days: 2, max_days: 3 },
{ pincode: 451225, min_days: 2, max_days: 3 },
{ pincode: 451228, min_days: 2, max_days: 3 },
{ pincode: 451229, min_days: 2, max_days: 3 },
{ pincode: 451327, min_days: 2, max_days: 3 },
{ pincode: 451331, min_days: 2, max_days: 3 },
{ pincode: 451332, min_days: 2, max_days: 3 },
{ pincode: 451335, min_days: 2, max_days: 3 },
{ pincode: 451337, min_days: 2, max_days: 3 },
{ pincode: 451435, min_days: 2, max_days: 3 },
{ pincode: 451440, min_days: 2, max_days: 3 },
{ pincode: 451441, min_days: 2, max_days: 3 },
{ pincode: 451442, min_days: 2, max_days: 3 },
{ pincode: 451443, min_days: 2, max_days: 3 },
{ pincode: 451447, min_days: 2, max_days: 3 },
{ pincode: 451448, min_days: 2, max_days: 3 },
{ pincode: 451449, min_days: 2, max_days: 3 },
{ pincode: 451451, min_days: 2, max_days: 3 },
{ pincode: 451550, min_days: 2, max_days: 3 },
{ pincode: 451551, min_days: 2, max_days: 3 },
{ pincode: 451552, min_days: 2, max_days: 3 },
{ pincode: 451555, min_days: 2, max_days: 3 },
{ pincode: 451556, min_days: 2, max_days: 3 },
{ pincode: 451557, min_days: 2, max_days: 3 },
{ pincode: 451559, min_days: 2, max_days: 3 },
{ pincode: 451659, min_days: 2, max_days: 3 },
{ pincode: 451660, min_days: 2, max_days: 3 },
{ pincode: 451661, min_days: 2, max_days: 3 },
{ pincode: 451663, min_days: 2, max_days: 3 },
{ pincode: 451664, min_days: 2, max_days: 3 },
{ pincode: 451665, min_days: 2, max_days: 3 },
{ pincode: 451666, min_days: 2, max_days: 3 },
{ pincode: 451667, min_days: 2, max_days: 3 },
{ pincode: 451669, min_days: 2, max_days: 3 },
{ pincode: 451695, min_days: 2, max_days: 3 },
{ pincode: 451770, min_days: 2, max_days: 3 },
{ pincode: 451877, min_days: 2, max_days: 3 },
{ pincode: 451881, min_days: 2, max_days: 3 },
{ pincode: 452001, min_days: 2, max_days: 3 },
{ pincode: 452002, min_days: 2, max_days: 3 },
{ pincode: 452003, min_days: 2, max_days: 3 },
{ pincode: 452004, min_days: 2, max_days: 3 },
{ pincode: 452005, min_days: 2, max_days: 3 },
{ pincode: 452006, min_days: 2, max_days: 3 },
{ pincode: 452007, min_days: 2, max_days: 3 },
{ pincode: 452008, min_days: 2, max_days: 3 },
{ pincode: 452009, min_days: 2, max_days: 3 },
{ pincode: 452010, min_days: 2, max_days: 3 },
{ pincode: 452011, min_days: 2, max_days: 3 },
{ pincode: 452012, min_days: 2, max_days: 3 },
{ pincode: 452013, min_days: 2, max_days: 3 },
{ pincode: 452014, min_days: 2, max_days: 3 },
{ pincode: 452015, min_days: 2, max_days: 3 },
{ pincode: 452016, min_days: 2, max_days: 3 },
{ pincode: 452017, min_days: 2, max_days: 3 },
{ pincode: 452018, min_days: 2, max_days: 3 },
{ pincode: 452019, min_days: 2, max_days: 3 },
{ pincode: 452020, min_days: 2, max_days: 3 },
{ pincode: 452023, min_days: 2, max_days: 3 },
{ pincode: 452056, min_days: 2, max_days: 3 },
{ pincode: 453001, min_days: 2, max_days: 3 },
{ pincode: 453111, min_days: 2, max_days: 3 },
{ pincode: 453112, min_days: 2, max_days: 3 },
{ pincode: 453115, min_days: 2, max_days: 3 },
{ pincode: 453220, min_days: 2, max_days: 3 },
{ pincode: 453331, min_days: 2, max_days: 3 },
{ pincode: 453332, min_days: 2, max_days: 3 },
{ pincode: 453441, min_days: 2, max_days: 3 },
{ pincode: 453446, min_days: 2, max_days: 3 },
{ pincode: 453463, min_days: 2, max_days: 3 },
{ pincode: 453551, min_days: 2, max_days: 3 },
{ pincode: 453552, min_days: 2, max_days: 3 },
{ pincode: 453555, min_days: 2, max_days: 3 },
{ pincode: 453556, min_days: 2, max_days: 3 },
{ pincode: 453562, min_days: 2, max_days: 3 },
{ pincode: 453576, min_days: 2, max_days: 3 },
{ pincode: 453643, min_days: 2, max_days: 3 },
{ pincode: 453652, min_days: 2, max_days: 3 },
{ pincode: 453661, min_days: 2, max_days: 3 },
{ pincode: 453771, min_days: 2, max_days: 3 },
{ pincode: 453777, min_days: 2, max_days: 3 },
{ pincode: 454001, min_days: 2, max_days: 3 },
{ pincode: 454010, min_days: 2, max_days: 3 },
{ pincode: 454020, min_days: 2, max_days: 3 },
{ pincode: 454051, min_days: 2, max_days: 3 },
{ pincode: 454111, min_days: 2, max_days: 3 },
{ pincode: 454116, min_days: 2, max_days: 3 },
{ pincode: 454221, min_days: 2, max_days: 3 },
{ pincode: 454276, min_days: 2, max_days: 3 },
{ pincode: 454331, min_days: 2, max_days: 3 },
{ pincode: 454333, min_days: 2, max_days: 3 },
{ pincode: 454334, min_days: 2, max_days: 3 },
{ pincode: 454335, min_days: 2, max_days: 3 },
{ pincode: 454341, min_days: 2, max_days: 3 },
{ pincode: 454345, min_days: 2, max_days: 3 },
{ pincode: 454350, min_days: 2, max_days: 3 },
{ pincode: 454365, min_days: 2, max_days: 3 },
{ pincode: 454435, min_days: 2, max_days: 3 },
{ pincode: 454441, min_days: 2, max_days: 3 },
{ pincode: 454446, min_days: 2, max_days: 3 },
{ pincode: 454448, min_days: 2, max_days: 3 },
{ pincode: 454449, min_days: 2, max_days: 3 },
{ pincode: 454552, min_days: 2, max_days: 3 },
{ pincode: 454648, min_days: 2, max_days: 3 },
{ pincode: 454660, min_days: 2, max_days: 3 },
{ pincode: 454665, min_days: 2, max_days: 3 },
{ pincode: 454667, min_days: 2, max_days: 3 },
{ pincode: 454730, min_days: 2, max_days: 3 },
{ pincode: 454749, min_days: 2, max_days: 3 },
{ pincode: 454773, min_days: 2, max_days: 3 },
{ pincode: 454774, min_days: 2, max_days: 3 },
{ pincode: 454775, min_days: 2, max_days: 3 },
{ pincode: 455001, min_days: 2, max_days: 3 },
{ pincode: 455002, min_days: 2, max_days: 3 },
{ pincode: 455003, min_days: 2, max_days: 3 },
{ pincode: 455048, min_days: 2, max_days: 3 },
{ pincode: 455111, min_days: 2, max_days: 3 },
{ pincode: 455112, min_days: 2, max_days: 3 },
{ pincode: 455113, min_days: 2, max_days: 3 },
{ pincode: 455114, min_days: 2, max_days: 3 },
{ pincode: 455115, min_days: 2, max_days: 3 },
{ pincode: 455116, min_days: 2, max_days: 3 },
{ pincode: 455117, min_days: 2, max_days: 3 },
{ pincode: 455118, min_days: 2, max_days: 3 },
{ pincode: 455119, min_days: 2, max_days: 3 },
{ pincode: 455221, min_days: 2, max_days: 3 },
{ pincode: 455223, min_days: 2, max_days: 3 },
{ pincode: 455224, min_days: 2, max_days: 3 },
{ pincode: 455225, min_days: 2, max_days: 3 },
{ pincode: 455227, min_days: 2, max_days: 3 },
{ pincode: 455302, min_days: 2, max_days: 3 },
{ pincode: 455332, min_days: 2, max_days: 3 },
{ pincode: 455336, min_days: 2, max_days: 3 },
{ pincode: 455339, min_days: 2, max_days: 3 },
{ pincode: 455440, min_days: 2, max_days: 3 },
{ pincode: 455459, min_days: 2, max_days: 3 },
{ pincode: 456001, min_days: 2, max_days: 3 },
{ pincode: 456002, min_days: 2, max_days: 3 },
{ pincode: 456003, min_days: 2, max_days: 3 },
{ pincode: 456004, min_days: 2, max_days: 3 },
{ pincode: 456005, min_days: 2, max_days: 3 },
{ pincode: 456006, min_days: 2, max_days: 3 },
{ pincode: 456007, min_days: 2, max_days: 3 },
{ pincode: 456008, min_days: 2, max_days: 3 },
{ pincode: 456009, min_days: 2, max_days: 3 },
{ pincode: 456010, min_days: 2, max_days: 3 },
{ pincode: 456221, min_days: 2, max_days: 3 },
{ pincode: 456222, min_days: 2, max_days: 3 },
{ pincode: 456224, min_days: 2, max_days: 3 },
{ pincode: 456300, min_days: 2, max_days: 3 },
{ pincode: 456313, min_days: 2, max_days: 3 },
{ pincode: 456331, min_days: 2, max_days: 3 },
{ pincode: 456335, min_days: 2, max_days: 3 },
{ pincode: 456337, min_days: 2, max_days: 3 },
{ pincode: 456440, min_days: 2, max_days: 3 },
{ pincode: 456441, min_days: 2, max_days: 3 },
{ pincode: 456443, min_days: 2, max_days: 3 },
{ pincode: 456550, min_days: 2, max_days: 3 },
{ pincode: 456661, min_days: 2, max_days: 3 },
{ pincode: 456662, min_days: 2, max_days: 3 },
{ pincode: 456664, min_days: 2, max_days: 3 },
{ pincode: 456665, min_days: 2, max_days: 3 },
{ pincode: 456668, min_days: 2, max_days: 3 },
{ pincode: 456770, min_days: 2, max_days: 3 },
{ pincode: 456771, min_days: 2, max_days: 3 },
{ pincode: 456776, min_days: 2, max_days: 3 },
{ pincode: 457001, min_days: 2, max_days: 3 },
{ pincode: 457002, min_days: 2, max_days: 3 },
{ pincode: 457003, min_days: 2, max_days: 3 },
{ pincode: 457111, min_days: 2, max_days: 3 },
{ pincode: 457112, min_days: 2, max_days: 3 },
{ pincode: 457114, min_days: 2, max_days: 3 },
{ pincode: 457118, min_days: 2, max_days: 3 },
{ pincode: 457119, min_days: 2, max_days: 3 },
{ pincode: 457222, min_days: 2, max_days: 3 },
{ pincode: 457226, min_days: 2, max_days: 3 },
{ pincode: 457227, min_days: 2, max_days: 3 },
{ pincode: 457331, min_days: 2, max_days: 3 },
{ pincode: 457333, min_days: 2, max_days: 3 },
{ pincode: 457336, min_days: 2, max_days: 3 },
{ pincode: 457339, min_days: 2, max_days: 3 },
{ pincode: 457340, min_days: 2, max_days: 3 },
{ pincode: 457440, min_days: 2, max_days: 3 },
{ pincode: 457441, min_days: 2, max_days: 3 },
{ pincode: 457550, min_days: 2, max_days: 3 },
{ pincode: 457551, min_days: 2, max_days: 3 },
{ pincode: 457552, min_days: 2, max_days: 3 },
{ pincode: 457555, min_days: 2, max_days: 3 },
{ pincode: 457661, min_days: 2, max_days: 3 },
{ pincode: 457769, min_days: 2, max_days: 3 },
{ pincode: 457770, min_days: 2, max_days: 3 },
{ pincode: 457772, min_days: 2, max_days: 3 },
{ pincode: 457773, min_days: 2, max_days: 3 },
{ pincode: 457775, min_days: 2, max_days: 3 },
{ pincode: 457777, min_days: 2, max_days: 3 },
{ pincode: 457778, min_days: 2, max_days: 3 },
{ pincode: 457779, min_days: 2, max_days: 3 },
{ pincode: 457780, min_days: 2, max_days: 3 },
{ pincode: 457880, min_days: 2, max_days: 3 },
{ pincode: 457882, min_days: 2, max_days: 3 },
{ pincode: 457885, min_days: 2, max_days: 3 },
{ pincode: 457886, min_days: 2, max_days: 3 },
{ pincode: 457887, min_days: 1, max_days: 2 },
{ pincode: 457888, min_days: 1, max_days: 2 },
{ pincode: 457893, min_days: 2, max_days: 3 },
{ pincode: 457990, min_days: 2, max_days: 3 },
{ pincode: 457993, min_days: 2, max_days: 3 },
{ pincode: 458001, min_days: 2, max_days: 3 },
{ pincode: 458002, min_days: 2, max_days: 3 },
{ pincode: 458110, min_days: 2, max_days: 3 },
{ pincode: 458113, min_days: 2, max_days: 3 },
{ pincode: 458116, min_days: 2, max_days: 3 },
{ pincode: 458118, min_days: 2, max_days: 3 },
{ pincode: 458220, min_days: 2, max_days: 3 },
{ pincode: 458226, min_days: 2, max_days: 3 },
{ pincode: 458228, min_days: 2, max_days: 3 },
{ pincode: 458330, min_days: 2, max_days: 3 },
{ pincode: 458336, min_days: 2, max_days: 3 },
{ pincode: 458339, min_days: 2, max_days: 3 },
{ pincode: 458389, min_days: 2, max_days: 3 },
{ pincode: 458441, min_days: 2, max_days: 3 },
{ pincode: 458442, min_days: 2, max_days: 3 },
{ pincode: 458468, min_days: 2, max_days: 3 },
{ pincode: 458470, min_days: 2, max_days: 3 },
{ pincode: 458474, min_days: 2, max_days: 3 },
{ pincode: 458553, min_days: 2, max_days: 3 },
{ pincode: 458556, min_days: 2, max_days: 3 },
{ pincode: 458558, min_days: 2, max_days: 3 },
{ pincode: 458588, min_days: 2, max_days: 3 },
{ pincode: 458660, min_days: 2, max_days: 3 },
{ pincode: 458664, min_days: 2, max_days: 3 },
{ pincode: 458667, min_days: 2, max_days: 3 },
{ pincode: 458668, min_days: 2, max_days: 3 },
{ pincode: 458669, min_days: 2, max_days: 3 },
{ pincode: 458676, min_days: 2, max_days: 3 },
{ pincode: 458771, min_days: 2, max_days: 3 },
{ pincode: 458775, min_days: 2, max_days: 3 },
{ pincode: 458778, min_days: 2, max_days: 3 },
{ pincode: 458880, min_days: 2, max_days: 3 },
{ pincode: 458883, min_days: 2, max_days: 3 },
{ pincode: 458888, min_days: 2, max_days: 3 },
{ pincode: 458895, min_days: 2, max_days: 3 },
{ pincode: 458990, min_days: 2, max_days: 3 },
{ pincode: 460001, min_days: 2, max_days: 3 },
{ pincode: 460002, min_days: 2, max_days: 3 },
{ pincode: 460004, min_days: 2, max_days: 3 },
{ pincode: 460005, min_days: 2, max_days: 3 },
{ pincode: 460008, min_days: 2, max_days: 3 },
{ pincode: 460110, min_days: 2, max_days: 3 },
{ pincode: 460220, min_days: 2, max_days: 3 },
{ pincode: 460225, min_days: 2, max_days: 3 },
{ pincode: 460330, min_days: 2, max_days: 3 },
{ pincode: 460440, min_days: 2, max_days: 3 },
{ pincode: 460443, min_days: 2, max_days: 3 },
{ pincode: 460447, min_days: 2, max_days: 3 },
{ pincode: 460449, min_days: 2, max_days: 3 },
{ pincode: 460551, min_days: 2, max_days: 3 },
{ pincode: 460553, min_days: 2, max_days: 3 },
{ pincode: 460554, min_days: 2, max_days: 3 },
{ pincode: 460557, min_days: 2, max_days: 3 },
{ pincode: 460660, min_days: 2, max_days: 3 },
{ pincode: 460661, min_days: 2, max_days: 3 },
{ pincode: 460663, min_days: 2, max_days: 3 },
{ pincode: 460665, min_days: 2, max_days: 3 },
{ pincode: 460666, min_days: 2, max_days: 3 },
{ pincode: 460668, min_days: 2, max_days: 3 },
{ pincode: 460669, min_days: 2, max_days: 3 },
{ pincode: 461001, min_days: 2, max_days: 3 },
{ pincode: 461005, min_days: 2, max_days: 3 },
{ pincode: 461110, min_days: 2, max_days: 3 },
{ pincode: 461111, min_days: 2, max_days: 3 },
{ pincode: 461114, min_days: 2, max_days: 3 },
{ pincode: 461115, min_days: 2, max_days: 3 },
{ pincode: 461116, min_days: 2, max_days: 3 },
{ pincode: 461122, min_days: 2, max_days: 3 },
{ pincode: 461221, min_days: 2, max_days: 3 },
{ pincode: 461222, min_days: 2, max_days: 3 },
{ pincode: 461223, min_days: 2, max_days: 3 },
{ pincode: 461224, min_days: 2, max_days: 3 },
{ pincode: 461225, min_days: 2, max_days: 3 },
{ pincode: 461228, min_days: 2, max_days: 3 },
{ pincode: 461251, min_days: 2, max_days: 3 },
{ pincode: 461331, min_days: 2, max_days: 3 },
{ pincode: 461335, min_days: 2, max_days: 3 },
{ pincode: 461427, min_days: 2, max_days: 3 },
{ pincode: 461441, min_days: 2, max_days: 3 },
{ pincode: 461444, min_days: 2, max_days: 3 },
{ pincode: 461445, min_days: 2, max_days: 3 },
{ pincode: 461446, min_days: 2, max_days: 3 },
{ pincode: 461551, min_days: 2, max_days: 3 },
{ pincode: 461555, min_days: 2, max_days: 3 },
{ pincode: 461661, min_days: 2, max_days: 3 },
{ pincode: 461668, min_days: 2, max_days: 3 },
{ pincode: 461771, min_days: 2, max_days: 3 },
{ pincode: 461772, min_days: 2, max_days: 3 },
{ pincode: 461775, min_days: 2, max_days: 3 },
{ pincode: 461881, min_days: 2, max_days: 3 },
{ pincode: 461990, min_days: 2, max_days: 3 },
{ pincode: 462001, min_days: 2, max_days: 3 },
{ pincode: 462002, min_days: 2, max_days: 3 },
{ pincode: 462003, min_days: 2, max_days: 3 },
{ pincode: 462004, min_days: 2, max_days: 3 },
{ pincode: 462005, min_days: 2, max_days: 3 },
{ pincode: 462006, min_days: 2, max_days: 3 },
{ pincode: 462007, min_days: 2, max_days: 3 },
{ pincode: 462008, min_days: 2, max_days: 3 },
{ pincode: 462010, min_days: 2, max_days: 3 },
{ pincode: 462011, min_days: 2, max_days: 3 },
{ pincode: 462012, min_days: 2, max_days: 3 },
{ pincode: 462013, min_days: 2, max_days: 3 },
{ pincode: 462014, min_days: 2, max_days: 3 },
{ pincode: 462015, min_days: 2, max_days: 3 },
{ pincode: 462016, min_days: 2, max_days: 3 },
{ pincode: 462017, min_days: 2, max_days: 3 },
{ pincode: 462018, min_days: 2, max_days: 3 },
{ pincode: 462019, min_days: 2, max_days: 3 },
{ pincode: 462020, min_days: 2, max_days: 3 },
{ pincode: 462021, min_days: 2, max_days: 3 },
{ pincode: 462022, min_days: 2, max_days: 3 },
{ pincode: 462023, min_days: 2, max_days: 3 },
{ pincode: 462024, min_days: 2, max_days: 3 },
{ pincode: 462025, min_days: 2, max_days: 3 },
{ pincode: 462026, min_days: 2, max_days: 3 },
{ pincode: 462027, min_days: 2, max_days: 3 },
{ pincode: 462028, min_days: 2, max_days: 3 },
{ pincode: 462029, min_days: 2, max_days: 3 },
{ pincode: 462030, min_days: 2, max_days: 3 },
{ pincode: 462031, min_days: 2, max_days: 3 },
{ pincode: 462032, min_days: 2, max_days: 3 },
{ pincode: 462033, min_days: 2, max_days: 3 },
{ pincode: 462034, min_days: 2, max_days: 3 },
{ pincode: 462035, min_days: 2, max_days: 3 },
{ pincode: 462036, min_days: 2, max_days: 3 },
{ pincode: 462037, min_days: 2, max_days: 3 },
{ pincode: 462038, min_days: 2, max_days: 3 },
{ pincode: 462039, min_days: 2, max_days: 3 },
{ pincode: 462040, min_days: 2, max_days: 3 },
{ pincode: 462041, min_days: 2, max_days: 3 },
{ pincode: 462042, min_days: 2, max_days: 3 },
{ pincode: 462043, min_days: 2, max_days: 3 },
{ pincode: 462044, min_days: 2, max_days: 3 },
{ pincode: 462045, min_days: 2, max_days: 3 },
{ pincode: 462046, min_days: 2, max_days: 3 },
{ pincode: 462047, min_days: 2, max_days: 3 },
{ pincode: 462048, min_days: 2, max_days: 3 },
{ pincode: 462066, min_days: 2, max_days: 3 },
{ pincode: 462100, min_days: 2, max_days: 3 },
{ pincode: 462101, min_days: 2, max_days: 3 },
{ pincode: 462120, min_days: 2, max_days: 3 },
{ pincode: 463106, min_days: 2, max_days: 3 },
{ pincode: 463111, min_days: 2, max_days: 3 },
{ pincode: 464001, min_days: 2, max_days: 3 },
{ pincode: 464002, min_days: 2, max_days: 3 },
{ pincode: 464111, min_days: 2, max_days: 3 },
{ pincode: 464113, min_days: 2, max_days: 3 },
{ pincode: 464114, min_days: 2, max_days: 3 },
{ pincode: 464220, min_days: 2, max_days: 3 },
{ pincode: 464221, min_days: 2, max_days: 3 },
{ pincode: 464224, min_days: 2, max_days: 3 },
{ pincode: 464226, min_days: 2, max_days: 3 },
{ pincode: 464228, min_days: 2, max_days: 3 },
{ pincode: 464240, min_days: 2, max_days: 3 },
{ pincode: 464258, min_days: 2, max_days: 3 },
{ pincode: 464331, min_days: 2, max_days: 3 },
{ pincode: 464334, min_days: 2, max_days: 3 },
{ pincode: 464337, min_days: 2, max_days: 3 },
{ pincode: 464551, min_days: 2, max_days: 3 },
{ pincode: 464556, min_days: 2, max_days: 3 },
{ pincode: 464570, min_days: 2, max_days: 3 },
{ pincode: 464573, min_days: 2, max_days: 3 },
{ pincode: 464651, min_days: 2, max_days: 3 },
{ pincode: 464661, min_days: 2, max_days: 3 },
{ pincode: 464665, min_days: 2, max_days: 3 },
{ pincode: 464668, min_days: 2, max_days: 3 },
{ pincode: 464670, min_days: 2, max_days: 3 },
{ pincode: 464671, min_days: 2, max_days: 3 },
{ pincode: 464672, min_days: 2, max_days: 3 },
{ pincode: 464676, min_days: 2, max_days: 3 },
{ pincode: 464770, min_days: 2, max_days: 3 },
{ pincode: 464774, min_days: 2, max_days: 3 },
{ pincode: 464776, min_days: 2, max_days: 3 },
{ pincode: 464881, min_days: 2, max_days: 3 },
{ pincode: 464884, min_days: 2, max_days: 3 },
{ pincode: 464886, min_days: 2, max_days: 3 },
{ pincode: 464986, min_days: 2, max_days: 3 },
{ pincode: 464990, min_days: 2, max_days: 3 },
{ pincode: 464993, min_days: 2, max_days: 3 },
{ pincode: 464995, min_days: 2, max_days: 3 },
{ pincode: 465001, min_days: 2, max_days: 3 },
{ pincode: 465106, min_days: 2, max_days: 3 },
{ pincode: 465110, min_days: 2, max_days: 3 },
{ pincode: 465113, min_days: 2, max_days: 3 },
{ pincode: 465116, min_days: 2, max_days: 3 },
{ pincode: 465118, min_days: 2, max_days: 3 },
{ pincode: 465220, min_days: 2, max_days: 3 },
{ pincode: 465223, min_days: 2, max_days: 3 },
{ pincode: 465226, min_days: 2, max_days: 3 },
{ pincode: 465227, min_days: 2, max_days: 3 },
{ pincode: 465230, min_days: 2, max_days: 3 },
{ pincode: 465331, min_days: 2, max_days: 3 },
{ pincode: 465333, min_days: 2, max_days: 3 },
{ pincode: 465335, min_days: 2, max_days: 3 },
{ pincode: 465336, min_days: 2, max_days: 3 },
{ pincode: 465337, min_days: 2, max_days: 3 },
{ pincode: 465339, min_days: 2, max_days: 3 },
{ pincode: 465418, min_days: 2, max_days: 3 },
{ pincode: 465441, min_days: 2, max_days: 3 },
{ pincode: 465445, min_days: 2, max_days: 3 },
{ pincode: 465447, min_days: 2, max_days: 3 },
{ pincode: 465449, min_days: 2, max_days: 3 },
{ pincode: 465550, min_days: 2, max_days: 3 },
{ pincode: 465661, min_days: 2, max_days: 3 },
{ pincode: 465667, min_days: 2, max_days: 3 },
{ pincode: 465669, min_days: 2, max_days: 3 },
{ pincode: 465672, min_days: 2, max_days: 3 },
{ pincode: 465674, min_days: 2, max_days: 3 },
{ pincode: 465677, min_days: 2, max_days: 3 },
{ pincode: 465679, min_days: 2, max_days: 3 },
{ pincode: 465680, min_days: 2, max_days: 3 },
{ pincode: 465683, min_days: 2, max_days: 3 },
{ pincode: 465685, min_days: 2, max_days: 3 },
{ pincode: 465687, min_days: 2, max_days: 3 },
{ pincode: 465689, min_days: 2, max_days: 3 },
{ pincode: 465691, min_days: 2, max_days: 3 },
{ pincode: 465693, min_days: 2, max_days: 3 },
{ pincode: 465695, min_days: 2, max_days: 3 },
{ pincode: 465697, min_days: 2, max_days: 3 },
{ pincode: 466001, min_days: 2, max_days: 3 },
{ pincode: 466002, min_days: 2, max_days: 3 },
{ pincode: 466003, min_days: 2, max_days: 3 },
{ pincode: 466111, min_days: 2, max_days: 3 },
{ pincode: 466112, min_days: 2, max_days: 3 },
{ pincode: 466113, min_days: 2, max_days: 3 },
{ pincode: 466114, min_days: 2, max_days: 3 },
{ pincode: 466115, min_days: 2, max_days: 3 },
{ pincode: 466116, min_days: 2, max_days: 3 },
{ pincode: 466117, min_days: 2, max_days: 3 },
{ pincode: 466118, min_days: 2, max_days: 3 },
{ pincode: 466119, min_days: 2, max_days: 3 },
{ pincode: 466120, min_days: 2, max_days: 3 },
{ pincode: 466125, min_days: 2, max_days: 3 },
{ pincode: 466221, min_days: 2, max_days: 3 },
{ pincode: 466331, min_days: 2, max_days: 3 },
{ pincode: 466445, min_days: 2, max_days: 3 },
{ pincode: 466446, min_days: 2, max_days: 3 },
{ pincode: 466448, min_days: 2, max_days: 3 },
{ pincode: 466554, min_days: 2, max_days: 3 },
{ pincode: 466651, min_days: 2, max_days: 3 },
{ pincode: 466661, min_days: 2, max_days: 3 },
{ pincode: 466665, min_days: 2, max_days: 3 },
{ pincode: 466666, min_days: 2, max_days: 3 },
{ pincode: 470000, min_days: 2, max_days: 3 },
{ pincode: 470001, min_days: 2, max_days: 3 },
{ pincode: 470002, min_days: 2, max_days: 3 },
{ pincode: 470003, min_days: 2, max_days: 3 },
{ pincode: 470004, min_days: 2, max_days: 3 },
{ pincode: 470021, min_days: 2, max_days: 3 },
{ pincode: 470051, min_days: 2, max_days: 3 },
{ pincode: 470113, min_days: 2, max_days: 3 },
{ pincode: 470115, min_days: 2, max_days: 3 },
{ pincode: 470117, min_days: 2, max_days: 3 },
{ pincode: 470118, min_days: 2, max_days: 3 },
{ pincode: 470119, min_days: 2, max_days: 3 },
{ pincode: 470120, min_days: 2, max_days: 3 },
{ pincode: 470124, min_days: 2, max_days: 3 },
{ pincode: 470125, min_days: 2, max_days: 3 },
{ pincode: 470221, min_days: 2, max_days: 3 },
{ pincode: 470223, min_days: 2, max_days: 3 },
{ pincode: 470226, min_days: 2, max_days: 3 },
{ pincode: 470227, min_days: 2, max_days: 3 },
{ pincode: 470228, min_days: 2, max_days: 3 },
{ pincode: 470229, min_days: 2, max_days: 3 },
{ pincode: 470232, min_days: 2, max_days: 3 },
{ pincode: 470235, min_days: 2, max_days: 3 },
{ pincode: 470335, min_days: 2, max_days: 3 },
{ pincode: 470337, min_days: 2, max_days: 3 },
{ pincode: 470339, min_days: 2, max_days: 3 },
{ pincode: 470340, min_days: 2, max_days: 3 },
{ pincode: 470441, min_days: 2, max_days: 3 },
{ pincode: 470442, min_days: 2, max_days: 3 },
{ pincode: 470661, min_days: 2, max_days: 3 },
{ pincode: 470662, min_days: 2, max_days: 3 },
{ pincode: 470663, min_days: 2, max_days: 3 },
{ pincode: 470664, min_days: 2, max_days: 3 },
{ pincode: 470666, min_days: 2, max_days: 3 },
{ pincode: 470669, min_days: 2, max_days: 3 },
{ pincode: 470672, min_days: 2, max_days: 3 },
{ pincode: 470673, min_days: 2, max_days: 3 },
{ pincode: 470675, min_days: 2, max_days: 3 },
{ pincode: 470771, min_days: 2, max_days: 3 },
{ pincode: 470772, min_days: 2, max_days: 3 },
{ pincode: 470775, min_days: 2, max_days: 3 },
{ pincode: 470880, min_days: 2, max_days: 3 },
{ pincode: 470881, min_days: 2, max_days: 3 },
{ pincode: 471001, min_days: 2, max_days: 3 },
{ pincode: 471101, min_days: 2, max_days: 3 },
{ pincode: 471105, min_days: 2, max_days: 3 },
{ pincode: 471111, min_days: 2, max_days: 3 },
{ pincode: 471201, min_days: 2, max_days: 3 },
{ pincode: 471202, min_days: 2, max_days: 3 },
{ pincode: 471301, min_days: 2, max_days: 3 },
{ pincode: 471311, min_days: 2, max_days: 3 },
{ pincode: 471313, min_days: 2, max_days: 3 },
{ pincode: 471315, min_days: 2, max_days: 3 },
{ pincode: 471318, min_days: 2, max_days: 3 },
{ pincode: 471401, min_days: 2, max_days: 3 },
{ pincode: 471405, min_days: 2, max_days: 3 },
{ pincode: 471408, min_days: 2, max_days: 3 },
{ pincode: 471411, min_days: 2, max_days: 3 },
{ pincode: 471501, min_days: 2, max_days: 3 },
{ pincode: 471505, min_days: 2, max_days: 3 },
{ pincode: 471510, min_days: 2, max_days: 3 },
{ pincode: 471515, min_days: 2, max_days: 3 },
{ pincode: 471516, min_days: 2, max_days: 3 },
{ pincode: 471525, min_days: 2, max_days: 3 },
{ pincode: 471606, min_days: 2, max_days: 3 },
{ pincode: 471625, min_days: 2, max_days: 3 },
{ pincode: 472001, min_days: 2, max_days: 3 },
{ pincode: 472005, min_days: 2, max_days: 3 },
{ pincode: 472010, min_days: 2, max_days: 3 },
{ pincode: 472101, min_days: 2, max_days: 3 },
{ pincode: 472111, min_days: 2, max_days: 3 },
{ pincode: 472115, min_days: 2, max_days: 3 },
{ pincode: 472118, min_days: 2, max_days: 3 },
{ pincode: 472221, min_days: 2, max_days: 3 },
{ pincode: 472246, min_days: 2, max_days: 3 },
{ pincode: 472331, min_days: 2, max_days: 3 },
{ pincode: 472336, min_days: 2, max_days: 3 },
{ pincode: 472337, min_days: 2, max_days: 3 },
{ pincode: 472338, min_days: 2, max_days: 3 },
{ pincode: 472339, min_days: 2, max_days: 3 },
{ pincode: 472442, min_days: 2, max_days: 3 },
{ pincode: 472445, min_days: 2, max_days: 3 },
{ pincode: 472446, min_days: 2, max_days: 3 },
{ pincode: 472447, min_days: 2, max_days: 3 },
{ pincode: 473001, min_days: 2, max_days: 3 },
{ pincode: 473002, min_days: 2, max_days: 3 },
{ pincode: 473101, min_days: 2, max_days: 3 },
{ pincode: 473105, min_days: 2, max_days: 3 },
{ pincode: 473110, min_days: 2, max_days: 3 },
{ pincode: 473111, min_days: 2, max_days: 3 },
{ pincode: 473112, min_days: 2, max_days: 3 },
{ pincode: 473113, min_days: 2, max_days: 3 },
{ pincode: 473115, min_days: 2, max_days: 3 },
{ pincode: 473118, min_days: 2, max_days: 3 },
{ pincode: 473222, min_days: 2, max_days: 3 },
{ pincode: 473226, min_days: 2, max_days: 3 },
{ pincode: 473229, min_days: 2, max_days: 3 },
{ pincode: 473249, min_days: 2, max_days: 3 },
{ pincode: 473287, min_days: 2, max_days: 3 },
{ pincode: 473330, min_days: 2, max_days: 3 },
{ pincode: 473331, min_days: 2, max_days: 3 },
{ pincode: 473332, min_days: 2, max_days: 3 },
{ pincode: 473333, min_days: 2, max_days: 3 },
{ pincode: 473335, min_days: 2, max_days: 3 },
{ pincode: 473338, min_days: 2, max_days: 3 },
{ pincode: 473440, min_days: 2, max_days: 3 },
{ pincode: 473443, min_days: 2, max_days: 3 },
{ pincode: 473444, min_days: 2, max_days: 3 },
{ pincode: 473445, min_days: 2, max_days: 3 },
{ pincode: 473446, min_days: 2, max_days: 3 },
{ pincode: 473551, min_days: 2, max_days: 3 },
{ pincode: 473554, min_days: 2, max_days: 3 },
{ pincode: 473583, min_days: 2, max_days: 3 },
{ pincode: 473585, min_days: 2, max_days: 3 },
{ pincode: 473638, min_days: 2, max_days: 3 },
{ pincode: 473660, min_days: 2, max_days: 3 },
{ pincode: 473662, min_days: 2, max_days: 3 },
{ pincode: 473665, min_days: 2, max_days: 3 },
{ pincode: 473670, min_days: 2, max_days: 3 },
{ pincode: 473770, min_days: 2, max_days: 3 },
{ pincode: 473774, min_days: 2, max_days: 3 },
{ pincode: 473775, min_days: 2, max_days: 3 },
{ pincode: 473781, min_days: 2, max_days: 3 },
{ pincode: 473785, min_days: 2, max_days: 3 },
{ pincode: 473793, min_days: 2, max_days: 3 },
{ pincode: 473865, min_days: 2, max_days: 3 },
{ pincode: 473880, min_days: 2, max_days: 3 },
{ pincode: 473885, min_days: 2, max_days: 3 },
{ pincode: 473990, min_days: 2, max_days: 3 },
{ pincode: 473993, min_days: 2, max_days: 3 },
{ pincode: 473995, min_days: 2, max_days: 3 },
{ pincode: 474001, min_days: 2, max_days: 3 },
{ pincode: 474002, min_days: 2, max_days: 3 },
{ pincode: 474003, min_days: 2, max_days: 3 },
{ pincode: 474004, min_days: 2, max_days: 3 },
{ pincode: 474005, min_days: 2, max_days: 3 },
{ pincode: 474006, min_days: 2, max_days: 3 },
{ pincode: 474007, min_days: 2, max_days: 3 },
{ pincode: 474008, min_days: 2, max_days: 3 },
{ pincode: 474009, min_days: 2, max_days: 3 },
{ pincode: 474010, min_days: 2, max_days: 3 },
{ pincode: 474011, min_days: 2, max_days: 3 },
{ pincode: 474012, min_days: 2, max_days: 3 },
{ pincode: 474015, min_days: 2, max_days: 3 },
{ pincode: 474020, min_days: 2, max_days: 3 },
{ pincode: 474040, min_days: 2, max_days: 3 },
{ pincode: 474042, min_days: 2, max_days: 3 },
{ pincode: 474050, min_days: 2, max_days: 3 },
{ pincode: 474055, min_days: 2, max_days: 3 },
{ pincode: 475001, min_days: 2, max_days: 3 },
{ pincode: 475002, min_days: 2, max_days: 3 },
{ pincode: 475003, min_days: 2, max_days: 3 },
{ pincode: 475005, min_days: 2, max_days: 3 },
{ pincode: 475110, min_days: 2, max_days: 3 },
{ pincode: 475112, min_days: 2, max_days: 3 },
{ pincode: 475115, min_days: 2, max_days: 3 },
{ pincode: 475220, min_days: 2, max_days: 3 },
{ pincode: 475330, min_days: 2, max_days: 3 },
{ pincode: 475335, min_days: 2, max_days: 3 },
{ pincode: 475336, min_days: 2, max_days: 3 },
{ pincode: 475533, min_days: 2, max_days: 3 },
{ pincode: 475661, min_days: 2, max_days: 3 },
{ pincode: 475671, min_days: 2, max_days: 3 },
{ pincode: 475673, min_days: 2, max_days: 3 },
{ pincode: 475675, min_days: 2, max_days: 3 },
{ pincode: 475677, min_days: 2, max_days: 3 },
{ pincode: 475682, min_days: 2, max_days: 3 },
{ pincode: 475684, min_days: 2, max_days: 3 },
{ pincode: 475685, min_days: 2, max_days: 3 },
{ pincode: 475686, min_days: 2, max_days: 3 },
{ pincode: 476001, min_days: 2, max_days: 3 },
{ pincode: 476111, min_days: 2, max_days: 3 },
{ pincode: 476115, min_days: 2, max_days: 3 },
{ pincode: 476134, min_days: 2, max_days: 3 },
{ pincode: 476219, min_days: 2, max_days: 3 },
{ pincode: 476221, min_days: 2, max_days: 3 },
{ pincode: 476224, min_days: 2, max_days: 3 },
{ pincode: 476228, min_days: 2, max_days: 3 },
{ pincode: 476229, min_days: 2, max_days: 3 },
{ pincode: 476235, min_days: 2, max_days: 3 },
{ pincode: 476332, min_days: 2, max_days: 3 },
{ pincode: 476335, min_days: 2, max_days: 3 },
{ pincode: 476337, min_days: 2, max_days: 3 },
{ pincode: 476339, min_days: 2, max_days: 3 },
{ pincode: 476355, min_days: 2, max_days: 3 },
{ pincode: 476444, min_days: 2, max_days: 3 },
{ pincode: 476554, min_days: 2, max_days: 3 },
{ pincode: 477001, min_days: 2, max_days: 3 },
{ pincode: 477105, min_days: 2, max_days: 3 },
{ pincode: 477111, min_days: 2, max_days: 3 },
{ pincode: 477116, min_days: 2, max_days: 3 },
{ pincode: 477117, min_days: 2, max_days: 3 },
{ pincode: 477222, min_days: 2, max_days: 3 },
{ pincode: 477227, min_days: 2, max_days: 3 },
{ pincode: 477331, min_days: 2, max_days: 3 },
{ pincode: 477332, min_days: 2, max_days: 3 },
{ pincode: 477333, min_days: 2, max_days: 3 },
{ pincode: 477335, min_days: 2, max_days: 3 },
{ pincode: 477441, min_days: 2, max_days: 3 },
{ pincode: 477445, min_days: 2, max_days: 3 },
{ pincode: 477446, min_days: 2, max_days: 3 },
{ pincode: 477447, min_days: 2, max_days: 3 },
{ pincode: 477449, min_days: 2, max_days: 3 },
{ pincode: 477450, min_days: 2, max_days: 3 },
{ pincode: 477555, min_days: 2, max_days: 3 },
{ pincode: 477557, min_days: 2, max_days: 3 },
{ pincode: 477566, min_days: 2, max_days: 3 },
{ pincode: 477660, min_days: 2, max_days: 3 },
{ pincode: 480000, min_days: 2, max_days: 3 },
{ pincode: 480001, min_days: 2, max_days: 3 },
{ pincode: 480002, min_days: 2, max_days: 3 },
{ pincode: 480003, min_days: 2, max_days: 3 },
{ pincode: 480004, min_days: 2, max_days: 3 },
{ pincode: 480102, min_days: 2, max_days: 3 },
{ pincode: 480105, min_days: 2, max_days: 3 },
{ pincode: 480106, min_days: 2, max_days: 3 },
{ pincode: 480107, min_days: 2, max_days: 3 },
{ pincode: 480108, min_days: 2, max_days: 3 },
{ pincode: 480109, min_days: 2, max_days: 3 },
{ pincode: 480110, min_days: 2, max_days: 3 },
{ pincode: 480111, min_days: 2, max_days: 3 },
{ pincode: 480112, min_days: 2, max_days: 3 },
{ pincode: 480115, min_days: 2, max_days: 3 },
{ pincode: 480116, min_days: 2, max_days: 3 },
{ pincode: 480221, min_days: 2, max_days: 3 },
{ pincode: 480223, min_days: 2, max_days: 3 },
{ pincode: 480224, min_days: 2, max_days: 3 },
{ pincode: 480331, min_days: 2, max_days: 3 },
{ pincode: 480334, min_days: 2, max_days: 3 },
{ pincode: 480337, min_days: 2, max_days: 3 },
{ pincode: 480338, min_days: 2, max_days: 3 },
{ pincode: 480357, min_days: 2, max_days: 3 },
{ pincode: 480441, min_days: 2, max_days: 3 },
{ pincode: 480447, min_days: 2, max_days: 3 },
{ pincode: 480449, min_days: 2, max_days: 3 },
{ pincode: 480551, min_days: 2, max_days: 3 },
{ pincode: 480553, min_days: 2, max_days: 3 },
{ pincode: 480554, min_days: 2, max_days: 3 },
{ pincode: 480555, min_days: 2, max_days: 3 },
{ pincode: 480557, min_days: 2, max_days: 3 },
{ pincode: 480559, min_days: 2, max_days: 3 },
{ pincode: 480661, min_days: 2, max_days: 3 },
{ pincode: 480664, min_days: 2, max_days: 3 },
{ pincode: 480667, min_days: 2, max_days: 3 },
{ pincode: 480771, min_days: 2, max_days: 3 },
{ pincode: 480880, min_days: 2, max_days: 3 },
{ pincode: 480881, min_days: 2, max_days: 3 },
{ pincode: 480882, min_days: 2, max_days: 3 },
{ pincode: 480884, min_days: 2, max_days: 3 },
{ pincode: 480886, min_days: 2, max_days: 3 },
{ pincode: 480887, min_days: 2, max_days: 3 },
{ pincode: 480888, min_days: 2, max_days: 3 },
{ pincode: 480990, min_days: 2, max_days: 3 },
{ pincode: 480991, min_days: 2, max_days: 3 },
{ pincode: 480994, min_days: 2, max_days: 3 },
{ pincode: 480996, min_days: 2, max_days: 3 },
{ pincode: 480997, min_days: 2, max_days: 3 },
{ pincode: 480999, min_days: 2, max_days: 3 },
{ pincode: 481001, min_days: 2, max_days: 3 },
{ pincode: 481051, min_days: 2, max_days: 3 },
{ pincode: 481101, min_days: 2, max_days: 3 },
{ pincode: 481102, min_days: 2, max_days: 3 },
{ pincode: 481105, min_days: 2, max_days: 3 },
{ pincode: 481111, min_days: 2, max_days: 3 },
{ pincode: 481115, min_days: 2, max_days: 3 },
{ pincode: 481116, min_days: 2, max_days: 3 },
{ pincode: 481117, min_days: 2, max_days: 3 },
{ pincode: 481222, min_days: 2, max_days: 3 },
{ pincode: 481224, min_days: 2, max_days: 3 },
{ pincode: 481226, min_days: 2, max_days: 3 },
{ pincode: 481331, min_days: 2, max_days: 3 },
{ pincode: 481332, min_days: 2, max_days: 3 },
{ pincode: 481335, min_days: 2, max_days: 3 },
{ pincode: 481337, min_days: 2, max_days: 3 },
{ pincode: 481441, min_days: 2, max_days: 3 },
{ pincode: 481445, min_days: 2, max_days: 3 },
{ pincode: 481449, min_days: 2, max_days: 3 },
{ pincode: 481551, min_days: 2, max_days: 3 },
{ pincode: 481556, min_days: 2, max_days: 3 },
{ pincode: 481661, min_days: 2, max_days: 3 },
{ pincode: 481662, min_days: 2, max_days: 3 },
{ pincode: 481663, min_days: 2, max_days: 3 },
{ pincode: 481664, min_days: 2, max_days: 3 },
{ pincode: 481665, min_days: 2, max_days: 3 },
{ pincode: 481666, min_days: 2, max_days: 3 },
{ pincode: 481668, min_days: 2, max_days: 3 },
{ pincode: 481672, min_days: 2, max_days: 3 },
{ pincode: 481768, min_days: 2, max_days: 3 },
{ pincode: 481771, min_days: 2, max_days: 3 },
{ pincode: 481776, min_days: 2, max_days: 3 },
{ pincode: 481778, min_days: 2, max_days: 3 },
{ pincode: 481879, min_days: 2, max_days: 3 },
{ pincode: 481880, min_days: 2, max_days: 3 },
{ pincode: 481882, min_days: 2, max_days: 3 },
{ pincode: 481883, min_days: 2, max_days: 3 },
{ pincode: 481884, min_days: 2, max_days: 3 },
{ pincode: 481885, min_days: 2, max_days: 3 },
{ pincode: 481990, min_days: 2, max_days: 3 },
{ pincode: 481995, min_days: 2, max_days: 3 },
{ pincode: 481996, min_days: 2, max_days: 3 },
{ pincode: 481998, min_days: 2, max_days: 3 },
{ pincode: 482001, min_days: 2, max_days: 3 },
{ pincode: 482002, min_days: 2, max_days: 3 },
{ pincode: 482003, min_days: 2, max_days: 3 },
{ pincode: 482004, min_days: 2, max_days: 3 },
{ pincode: 482005, min_days: 2, max_days: 3 },
{ pincode: 482006, min_days: 2, max_days: 3 },
{ pincode: 482007, min_days: 2, max_days: 3 },
{ pincode: 482008, min_days: 2, max_days: 3 },
{ pincode: 482009, min_days: 2, max_days: 3 },
{ pincode: 482010, min_days: 2, max_days: 3 },
{ pincode: 482011, min_days: 2, max_days: 3 },
{ pincode: 482016, min_days: 2, max_days: 3 },
{ pincode: 482020, min_days: 2, max_days: 3 },
{ pincode: 482021, min_days: 2, max_days: 3 },
{ pincode: 482050, min_days: 2, max_days: 3 },
{ pincode: 482051, min_days: 2, max_days: 3 },
{ pincode: 482053, min_days: 2, max_days: 3 },
{ pincode: 482056, min_days: 2, max_days: 3 },
{ pincode: 483001, min_days: 2, max_days: 3 },
{ pincode: 483053, min_days: 2, max_days: 3 },
{ pincode: 483105, min_days: 2, max_days: 3 },
{ pincode: 483110, min_days: 2, max_days: 3 },
{ pincode: 483113, min_days: 2, max_days: 3 },
{ pincode: 483119, min_days: 2, max_days: 3 },
{ pincode: 483220, min_days: 2, max_days: 3 },
{ pincode: 483222, min_days: 2, max_days: 3 },
{ pincode: 483225, min_days: 2, max_days: 3 },
{ pincode: 483330, min_days: 2, max_days: 3 },
{ pincode: 483331, min_days: 2, max_days: 3 },
{ pincode: 483332, min_days: 2, max_days: 3 },
{ pincode: 483334, min_days: 2, max_days: 3 },
{ pincode: 483336, min_days: 2, max_days: 3 },
{ pincode: 483440, min_days: 2, max_days: 3 },
{ pincode: 483442, min_days: 2, max_days: 3 },
{ pincode: 483501, min_days: 2, max_days: 3 },
{ pincode: 483503, min_days: 2, max_days: 3 },
{ pincode: 483504, min_days: 2, max_days: 3 },
{ pincode: 483770, min_days: 2, max_days: 3 },
{ pincode: 483773, min_days: 2, max_days: 3 },
{ pincode: 483775, min_days: 2, max_days: 3 },
{ pincode: 483880, min_days: 2, max_days: 3 },
{ pincode: 483990, min_days: 2, max_days: 3 },
{ pincode: 484001, min_days: 2, max_days: 3 },
{ pincode: 484002, min_days: 2, max_days: 3 },
{ pincode: 484110, min_days: 2, max_days: 3 },
{ pincode: 484113, min_days: 2, max_days: 3 },
{ pincode: 484114, min_days: 2, max_days: 3 },
{ pincode: 484116, min_days: 2, max_days: 3 },
{ pincode: 484117, min_days: 2, max_days: 3 },
{ pincode: 484120, min_days: 2, max_days: 3 },
{ pincode: 484220, min_days: 2, max_days: 3 },
{ pincode: 484224, min_days: 2, max_days: 3 },
{ pincode: 484330, min_days: 2, max_days: 3 },
{ pincode: 484334, min_days: 2, max_days: 3 },
{ pincode: 484336, min_days: 2, max_days: 3 },
{ pincode: 484440, min_days: 2, max_days: 3 },
{ pincode: 484444, min_days: 2, max_days: 3 },
{ pincode: 484446, min_days: 2, max_days: 3 },
{ pincode: 484447, min_days: 2, max_days: 3 },
{ pincode: 484551, min_days: 2, max_days: 3 },
{ pincode: 484552, min_days: 2, max_days: 3 },
{ pincode: 484555, min_days: 2, max_days: 3 },
{ pincode: 484660, min_days: 2, max_days: 3 },
{ pincode: 484661, min_days: 2, max_days: 3 },
{ pincode: 484664, min_days: 2, max_days: 3 },
{ pincode: 484665, min_days: 2, max_days: 3 },
{ pincode: 484669, min_days: 2, max_days: 3 },
{ pincode: 484770, min_days: 2, max_days: 3 },
{ pincode: 484771, min_days: 2, max_days: 3 },
{ pincode: 484774, min_days: 2, max_days: 3 },
{ pincode: 484776, min_days: 2, max_days: 3 },
{ pincode: 484881, min_days: 2, max_days: 3 },
{ pincode: 484886, min_days: 2, max_days: 3 },
{ pincode: 484887, min_days: 2, max_days: 3 },
{ pincode: 485001, min_days: 2, max_days: 3 },
{ pincode: 485002, min_days: 2, max_days: 3 },
{ pincode: 485003, min_days: 2, max_days: 3 },
{ pincode: 485004, min_days: 2, max_days: 3 },
{ pincode: 485005, min_days: 2, max_days: 3 },
{ pincode: 485081, min_days: 2, max_days: 3 },
{ pincode: 485111, min_days: 2, max_days: 3 },
{ pincode: 485112, min_days: 2, max_days: 3 },
{ pincode: 485113, min_days: 2, max_days: 3 },
{ pincode: 485114, min_days: 2, max_days: 3 },
{ pincode: 485115, min_days: 2, max_days: 3 },
{ pincode: 485221, min_days: 2, max_days: 3 },
{ pincode: 485226, min_days: 2, max_days: 3 },
{ pincode: 485227, min_days: 2, max_days: 3 },
{ pincode: 485331, min_days: 2, max_days: 3 },
{ pincode: 485334, min_days: 2, max_days: 3 },
{ pincode: 485336, min_days: 2, max_days: 3 },
{ pincode: 485441, min_days: 2, max_days: 3 },
{ pincode: 485446, min_days: 2, max_days: 3 },
{ pincode: 485447, min_days: 2, max_days: 3 },
{ pincode: 485551, min_days: 2, max_days: 3 },
{ pincode: 485661, min_days: 2, max_days: 3 },
{ pincode: 485666, min_days: 2, max_days: 3 },
{ pincode: 485771, min_days: 2, max_days: 3 },
{ pincode: 485772, min_days: 2, max_days: 3 },
{ pincode: 485773, min_days: 2, max_days: 3 },
{ pincode: 485774, min_days: 2, max_days: 3 },
{ pincode: 485775, min_days: 2, max_days: 3 },
{ pincode: 485778, min_days: 2, max_days: 3 },
{ pincode: 485881, min_days: 2, max_days: 3 },
{ pincode: 486001, min_days: 2, max_days: 3 },
{ pincode: 486002, min_days: 2, max_days: 3 },
{ pincode: 486003, min_days: 2, max_days: 3 },
{ pincode: 486004, min_days: 2, max_days: 3 },
{ pincode: 486005, min_days: 2, max_days: 3 },
{ pincode: 486006, min_days: 2, max_days: 3 },
{ pincode: 486008, min_days: 2, max_days: 3 },
{ pincode: 486111, min_days: 2, max_days: 3 },
{ pincode: 486114, min_days: 2, max_days: 3 },
{ pincode: 486115, min_days: 2, max_days: 3 },
{ pincode: 486117, min_days: 2, max_days: 3 },
{ pincode: 486123, min_days: 2, max_days: 3 },
{ pincode: 486220, min_days: 2, max_days: 3 },
{ pincode: 486223, min_days: 2, max_days: 3 },
{ pincode: 486226, min_days: 2, max_days: 3 },
{ pincode: 486331, min_days: 2, max_days: 3 },
{ pincode: 486333, min_days: 2, max_days: 3 },
{ pincode: 486335, min_days: 2, max_days: 3 },
{ pincode: 486338, min_days: 2, max_days: 3 },
{ pincode: 486340, min_days: 2, max_days: 3 },
{ pincode: 486341, min_days: 2, max_days: 3 },
{ pincode: 486342, min_days: 2, max_days: 3 },
{ pincode: 486343, min_days: 2, max_days: 3 },
{ pincode: 486440, min_days: 2, max_days: 3 },
{ pincode: 486441, min_days: 2, max_days: 3 },
{ pincode: 486445, min_days: 2, max_days: 3 },
{ pincode: 486446, min_days: 2, max_days: 3 },
{ pincode: 486447, min_days: 2, max_days: 3 },
{ pincode: 486448, min_days: 2, max_days: 3 },
{ pincode: 486450, min_days: 2, max_days: 3 },
{ pincode: 486550, min_days: 2, max_days: 3 },
{ pincode: 486553, min_days: 2, max_days: 3 },
{ pincode: 486556, min_days: 2, max_days: 3 },
{ pincode: 486661, min_days: 2, max_days: 3 },
{ pincode: 486666, min_days: 2, max_days: 3 },
{ pincode: 486669, min_days: 2, max_days: 3 },
{ pincode: 486670, min_days: 2, max_days: 3 },
{ pincode: 486675, min_days: 2, max_days: 3 },
{ pincode: 486771, min_days: 2, max_days: 3 },
{ pincode: 486775, min_days: 2, max_days: 3 },
{ pincode: 486776, min_days: 2, max_days: 3 },
{ pincode: 486881, min_days: 2, max_days: 3 },
{ pincode: 486882, min_days: 2, max_days: 3 },
{ pincode: 486884, min_days: 2, max_days: 3 },
{ pincode: 486885, min_days: 2, max_days: 3 },
{ pincode: 486886, min_days: 2, max_days: 3 },
{ pincode: 486887, min_days: 2, max_days: 3 },
{ pincode: 486888, min_days: 2, max_days: 3 },
{ pincode: 486889, min_days: 2, max_days: 3 },
{ pincode: 486890, min_days: 2, max_days: 3 },
{ pincode: 486892, min_days: 2, max_days: 3 },
{ pincode: 487001, min_days: 2, max_days: 3 },
{ pincode: 487110, min_days: 2, max_days: 3 },
{ pincode: 487114, min_days: 2, max_days: 3 },
{ pincode: 487118, min_days: 2, max_days: 3 },
{ pincode: 487221, min_days: 2, max_days: 3 },
{ pincode: 487225, min_days: 2, max_days: 3 },
{ pincode: 487330, min_days: 2, max_days: 3 },
{ pincode: 487334, min_days: 2, max_days: 3 },
{ pincode: 487337, min_days: 2, max_days: 3 },
{ pincode: 487441, min_days: 2, max_days: 3 },
{ pincode: 487551, min_days: 2, max_days: 3 },
{ pincode: 487555, min_days: 2, max_days: 3 },
{ pincode: 487661, min_days: 2, max_days: 3 },
{ pincode: 487770, min_days: 2, max_days: 3 },
{ pincode: 487771, min_days: 2, max_days: 3 },
{ pincode: 487881, min_days: 2, max_days: 3 },
{ pincode: 488001, min_days: 2, max_days: 3 },
{ pincode: 488050, min_days: 2, max_days: 3 },
{ pincode: 488051, min_days: 2, max_days: 3 },
{ pincode: 488058, min_days: 2, max_days: 3 },
{ pincode: 488059, min_days: 2, max_days: 3 },
{ pincode: 488101, min_days: 2, max_days: 3 },
{ pincode: 488220, min_days: 2, max_days: 3 },
{ pincode: 488222, min_days: 2, max_days: 3 },
{ pincode: 488333, min_days: 2, max_days: 3 },
{ pincode: 488441, min_days: 2, max_days: 3 },
{ pincode: 488442, min_days: 2, max_days: 3 },
{ pincode: 488443, min_days: 2, max_days: 3 },
{ pincode: 488446, min_days: 2, max_days: 3 },
{ pincode: 488448, min_days: 2, max_days: 3 },
{ pincode: 490001, min_days: 2, max_days: 3 },
{ pincode: 490002, min_days: 2, max_days: 3 },
{ pincode: 490003, min_days: 2, max_days: 3 },
{ pincode: 490004, min_days: 2, max_days: 3 },
{ pincode: 490005, min_days: 2, max_days: 3 },
{ pincode: 490006, min_days: 2, max_days: 3 },
{ pincode: 490007, min_days: 2, max_days: 3 },
{ pincode: 490008, min_days: 2, max_days: 3 },
{ pincode: 490009, min_days: 2, max_days: 3 },
{ pincode: 490010, min_days: 2, max_days: 3 },
{ pincode: 490011, min_days: 2, max_days: 3 },
{ pincode: 490012, min_days: 2, max_days: 3 },
{ pincode: 490013, min_days: 2, max_days: 3 },
{ pincode: 490015, min_days: 2, max_days: 3 },
{ pincode: 490020, min_days: 2, max_days: 3 },
{ pincode: 490021, min_days: 2, max_days: 3 },
{ pincode: 490022, min_days: 2, max_days: 3 },
{ pincode: 490023, min_days: 2, max_days: 3 },
{ pincode: 490024, min_days: 2, max_days: 3 },
{ pincode: 490025, min_days: 2, max_days: 3 },
{ pincode: 490026, min_days: 2, max_days: 3 },
{ pincode: 490027, min_days: 2, max_days: 3 },
{ pincode: 490028, min_days: 2, max_days: 3 },
{ pincode: 490036, min_days: 2, max_days: 3 },
{ pincode: 490042, min_days: 2, max_days: 3 },
{ pincode: 490054, min_days: 2, max_days: 3 },
{ pincode: 491001, min_days: 2, max_days: 3 },
{ pincode: 491002, min_days: 2, max_days: 3 },
{ pincode: 491003, min_days: 2, max_days: 3 },
{ pincode: 491004, min_days: 2, max_days: 3 },
{ pincode: 491009, min_days: 2, max_days: 3 },
{ pincode: 491107, min_days: 2, max_days: 3 },
{ pincode: 491111, min_days: 2, max_days: 3 },
{ pincode: 491113, min_days: 2, max_days: 3 },
{ pincode: 491221, min_days: 2, max_days: 3 },
{ pincode: 491222, min_days: 2, max_days: 3 },
{ pincode: 491223, min_days: 2, max_days: 3 },
{ pincode: 491225, min_days: 2, max_days: 3 },
{ pincode: 491226, min_days: 2, max_days: 3 },
{ pincode: 491227, min_days: 2, max_days: 3 },
{ pincode: 491228, min_days: 2, max_days: 3 },
{ pincode: 491229, min_days: 2, max_days: 3 },
{ pincode: 491230, min_days: 2, max_days: 3 },
{ pincode: 491331, min_days: 2, max_days: 3 },
{ pincode: 491332, min_days: 2, max_days: 3 },
{ pincode: 491335, min_days: 2, max_days: 3 },
{ pincode: 491336, min_days: 2, max_days: 3 },
{ pincode: 491337, min_days: 2, max_days: 3 },
{ pincode: 491338, min_days: 2, max_days: 3 },
{ pincode: 491340, min_days: 2, max_days: 3 },
{ pincode: 491441, min_days: 2, max_days: 3 },
{ pincode: 491443, min_days: 2, max_days: 3 },
{ pincode: 491444, min_days: 2, max_days: 3 },
{ pincode: 491445, min_days: 2, max_days: 3 },
{ pincode: 491557, min_days: 2, max_days: 3 },
{ pincode: 491558, min_days: 2, max_days: 3 },
{ pincode: 491559, min_days: 2, max_days: 3 },
{ pincode: 491661, min_days: 2, max_days: 3 },
{ pincode: 491665, min_days: 2, max_days: 3 },
{ pincode: 491666, min_days: 2, max_days: 3 },
{ pincode: 491668, min_days: 2, max_days: 3 },
{ pincode: 491771, min_days: 2, max_days: 3 },
{ pincode: 491881, min_days: 2, max_days: 3 },
{ pincode: 491885, min_days: 2, max_days: 3 },
{ pincode: 491888, min_days: 2, max_days: 3 },
{ pincode: 491993, min_days: 2, max_days: 3 },
{ pincode: 491995, min_days: 2, max_days: 3 },
{ pincode: 491996, min_days: 2, max_days: 3 },
{ pincode: 492001, min_days: 2, max_days: 3 },
{ pincode: 492002, min_days: 2, max_days: 3 },
{ pincode: 492003, min_days: 2, max_days: 3 },
{ pincode: 492004, min_days: 2, max_days: 3 },
{ pincode: 492005, min_days: 2, max_days: 3 },
{ pincode: 492006, min_days: 2, max_days: 3 },
{ pincode: 492007, min_days: 2, max_days: 3 },
{ pincode: 492008, min_days: 2, max_days: 3 },
{ pincode: 492009, min_days: 2, max_days: 3 },
{ pincode: 492010, min_days: 2, max_days: 3 },
{ pincode: 492011, min_days: 2, max_days: 3 },
{ pincode: 492012, min_days: 2, max_days: 3 },
{ pincode: 492013, min_days: 2, max_days: 3 },
{ pincode: 492014, min_days: 2, max_days: 3 },
{ pincode: 492015, min_days: 2, max_days: 3 },
{ pincode: 492016, min_days: 2, max_days: 3 },
{ pincode: 492017, min_days: 2, max_days: 3 },
{ pincode: 492018, min_days: 2, max_days: 3 },
{ pincode: 492021, min_days: 2, max_days: 3 },
{ pincode: 492075, min_days: 2, max_days: 3 },
{ pincode: 492099, min_days: 2, max_days: 3 },
{ pincode: 492101, min_days: 2, max_days: 3 },
{ pincode: 492102, min_days: 2, max_days: 3 },
{ pincode: 492104, min_days: 2, max_days: 3 },
{ pincode: 492109, min_days: 2, max_days: 3 },
{ pincode: 492112, min_days: 2, max_days: 3 },
{ pincode: 493002, min_days: 2, max_days: 3 },
{ pincode: 493101, min_days: 2, max_days: 3 },
{ pincode: 493109, min_days: 2, max_days: 3 },
{ pincode: 493111, min_days: 2, max_days: 3 },
{ pincode: 493113, min_days: 2, max_days: 3 },
{ pincode: 493114, min_days: 2, max_days: 3 },
{ pincode: 493116, min_days: 2, max_days: 3 },
{ pincode: 493118, min_days: 2, max_days: 3 },
{ pincode: 493195, min_days: 2, max_days: 3 },
{ pincode: 493196, min_days: 2, max_days: 3 },
{ pincode: 493211, min_days: 2, max_days: 3 },
{ pincode: 493221, min_days: 2, max_days: 3 },
{ pincode: 493222, min_days: 2, max_days: 3 },
{ pincode: 493225, min_days: 2, max_days: 3 },
{ pincode: 493228, min_days: 2, max_days: 3 },
{ pincode: 493229, min_days: 2, max_days: 3 },
{ pincode: 493330, min_days: 2, max_days: 3 },
{ pincode: 493331, min_days: 2, max_days: 3 },
{ pincode: 493332, min_days: 2, max_days: 3 },
{ pincode: 493335, min_days: 2, max_days: 3 },
{ pincode: 493338, min_days: 2, max_days: 3 },
{ pincode: 493344, min_days: 2, max_days: 3 },
{ pincode: 493441, min_days: 2, max_days: 3 },
{ pincode: 493445, min_days: 2, max_days: 3 },
{ pincode: 493448, min_days: 2, max_days: 3 },
{ pincode: 493449, min_days: 2, max_days: 3 },
{ pincode: 493526, min_days: 2, max_days: 3 },
{ pincode: 493551, min_days: 2, max_days: 3 },
{ pincode: 493554, min_days: 2, max_days: 3 },
{ pincode: 493555, min_days: 2, max_days: 3 },
{ pincode: 493558, min_days: 2, max_days: 3 },
{ pincode: 493559, min_days: 2, max_days: 3 },
{ pincode: 493562, min_days: 2, max_days: 3 },
{ pincode: 493661, min_days: 2, max_days: 3 },
{ pincode: 493662, min_days: 2, max_days: 3 },
{ pincode: 493663, min_days: 2, max_days: 3 },
{ pincode: 493770, min_days: 2, max_days: 3 },
{ pincode: 493773, min_days: 2, max_days: 3 },
{ pincode: 493776, min_days: 2, max_days: 3 },
{ pincode: 493778, min_days: 2, max_days: 3 },
{ pincode: 493881, min_days: 2, max_days: 3 },
{ pincode: 493885, min_days: 2, max_days: 3 },
{ pincode: 493887, min_days: 2, max_days: 3 },
{ pincode: 493888, min_days: 2, max_days: 3 },
{ pincode: 493889, min_days: 2, max_days: 3 },
{ pincode: 493890, min_days: 2, max_days: 3 },
{ pincode: 493891, min_days: 2, max_days: 3 },
{ pincode: 493895, min_days: 2, max_days: 3 },
{ pincode: 493992, min_days: 2, max_days: 3 },
{ pincode: 493996, min_days: 2, max_days: 3 },
{ pincode: 494001, min_days: 2, max_days: 3 },
{ pincode: 494002, min_days: 2, max_days: 3 },
{ pincode: 494004, min_days: 2, max_days: 3 },
{ pincode: 494005, min_days: 2, max_days: 3 },
{ pincode: 494010, min_days: 2, max_days: 3 },
{ pincode: 494111, min_days: 2, max_days: 3 },
{ pincode: 494114, min_days: 2, max_days: 3 },
{ pincode: 494115, min_days: 2, max_days: 3 },
{ pincode: 494122, min_days: 2, max_days: 3 },
{ pincode: 494221, min_days: 2, max_days: 3 },
{ pincode: 494222, min_days: 2, max_days: 3 },
{ pincode: 494223, min_days: 2, max_days: 3 },
{ pincode: 494224, min_days: 2, max_days: 3 },
{ pincode: 494225, min_days: 2, max_days: 3 },
{ pincode: 494226, min_days: 2, max_days: 3 },
{ pincode: 494227, min_days: 2, max_days: 3 },
{ pincode: 494228, min_days: 2, max_days: 3 },
{ pincode: 494229, min_days: 2, max_days: 3 },
{ pincode: 494230, min_days: 2, max_days: 3 },
{ pincode: 494237, min_days: 2, max_days: 3 },
{ pincode: 494331, min_days: 2, max_days: 3 },
{ pincode: 494332, min_days: 2, max_days: 3 },
{ pincode: 494333, min_days: 2, max_days: 3 },
{ pincode: 494334, min_days: 2, max_days: 3 },
{ pincode: 494335, min_days: 2, max_days: 3 },
{ pincode: 494336, min_days: 2, max_days: 3 },
{ pincode: 494337, min_days: 2, max_days: 3 },
{ pincode: 494347, min_days: 2, max_days: 3 },
{ pincode: 494435, min_days: 2, max_days: 3 },
{ pincode: 494441, min_days: 2, max_days: 3 },
{ pincode: 494442, min_days: 2, max_days: 3 },
{ pincode: 494444, min_days: 2, max_days: 3 },
{ pincode: 494445, min_days: 2, max_days: 3 },
{ pincode: 494446, min_days: 2, max_days: 3 },
{ pincode: 494447, min_days: 2, max_days: 3 },
{ pincode: 494448, min_days: 2, max_days: 3 },
{ pincode: 494449, min_days: 2, max_days: 3 },
{ pincode: 494450, min_days: 2, max_days: 3 },
{ pincode: 494551, min_days: 2, max_days: 3 },
{ pincode: 494552, min_days: 2, max_days: 3 },
{ pincode: 494553, min_days: 2, max_days: 3 },
{ pincode: 494556, min_days: 2, max_days: 3 },
{ pincode: 494635, min_days: 2, max_days: 3 },
{ pincode: 494661, min_days: 2, max_days: 3 },
{ pincode: 494665, min_days: 2, max_days: 3 },
{ pincode: 494669, min_days: 2, max_days: 3 },
{ pincode: 494670, min_days: 2, max_days: 3 },
{ pincode: 494771, min_days: 2, max_days: 3 },
{ pincode: 494775, min_days: 2, max_days: 3 },
{ pincode: 494776, min_days: 2, max_days: 3 },
{ pincode: 494777, min_days: 2, max_days: 3 },
{ pincode: 495001, min_days: 2, max_days: 3 },
{ pincode: 495002, min_days: 2, max_days: 3 },
{ pincode: 495003, min_days: 2, max_days: 3 },
{ pincode: 495004, min_days: 2, max_days: 3 },
{ pincode: 495005, min_days: 2, max_days: 3 },
{ pincode: 495006, min_days: 2, max_days: 3 },
{ pincode: 495007, min_days: 2, max_days: 3 },
{ pincode: 495009, min_days: 2, max_days: 3 },
{ pincode: 495112, min_days: 2, max_days: 3 },
{ pincode: 495113, min_days: 2, max_days: 3 },
{ pincode: 495115, min_days: 2, max_days: 3 },
{ pincode: 495116, min_days: 2, max_days: 3 },
{ pincode: 495117, min_days: 2, max_days: 3 },
{ pincode: 495118, min_days: 2, max_days: 3 },
{ pincode: 495119, min_days: 2, max_days: 3 },
{ pincode: 495220, min_days: 2, max_days: 3 },
{ pincode: 495222, min_days: 2, max_days: 3 },
{ pincode: 495223, min_days: 2, max_days: 3 },
{ pincode: 495224, min_days: 2, max_days: 3 },
{ pincode: 495330, min_days: 2, max_days: 3 },
{ pincode: 495334, min_days: 2, max_days: 3 },
{ pincode: 495335, min_days: 2, max_days: 3 },
{ pincode: 495442, min_days: 2, max_days: 3 },
{ pincode: 495444, min_days: 2, max_days: 3 },
{ pincode: 495445, min_days: 2, max_days: 3 },
{ pincode: 495446, min_days: 2, max_days: 3 },
{ pincode: 495447, min_days: 2, max_days: 3 },
{ pincode: 495448, min_days: 2, max_days: 3 },
{ pincode: 495449, min_days: 2, max_days: 3 },
{ pincode: 495450, min_days: 2, max_days: 3 },
{ pincode: 495452, min_days: 2, max_days: 3 },
{ pincode: 495453, min_days: 2, max_days: 3 },
{ pincode: 495454, min_days: 2, max_days: 3 },
{ pincode: 495455, min_days: 2, max_days: 3 },
{ pincode: 495549, min_days: 2, max_days: 3 },
{ pincode: 495550, min_days: 2, max_days: 3 },
{ pincode: 495551, min_days: 2, max_days: 3 },
{ pincode: 495552, min_days: 2, max_days: 3 },
{ pincode: 495553, min_days: 2, max_days: 3 },
{ pincode: 495554, min_days: 2, max_days: 3 },
{ pincode: 495555, min_days: 2, max_days: 3 },
{ pincode: 495556, min_days: 2, max_days: 3 },
{ pincode: 495557, min_days: 2, max_days: 3 },
{ pincode: 495559, min_days: 2, max_days: 3 },
{ pincode: 495660, min_days: 2, max_days: 3 },
{ pincode: 495661, min_days: 2, max_days: 3 },
{ pincode: 495663, min_days: 2, max_days: 3 },
{ pincode: 495668, min_days: 2, max_days: 3 },
{ pincode: 495669, min_days: 2, max_days: 3 },
{ pincode: 495671, min_days: 2, max_days: 3 },
{ pincode: 495674, min_days: 2, max_days: 3 },
{ pincode: 495677, min_days: 2, max_days: 3 },
{ pincode: 495678, min_days: 2, max_days: 3 },
{ pincode: 495679, min_days: 2, max_days: 3 },
{ pincode: 495680, min_days: 2, max_days: 3 },
{ pincode: 495682, min_days: 2, max_days: 3 },
{ pincode: 495683, min_days: 2, max_days: 3 },
{ pincode: 495684, min_days: 2, max_days: 3 },
{ pincode: 495685, min_days: 2, max_days: 3 },
{ pincode: 495686, min_days: 2, max_days: 3 },
{ pincode: 495687, min_days: 2, max_days: 3 },
{ pincode: 495688, min_days: 2, max_days: 3 },
{ pincode: 495689, min_days: 2, max_days: 3 },
{ pincode: 495690, min_days: 2, max_days: 3 },
{ pincode: 495691, min_days: 2, max_days: 3 },
{ pincode: 495692, min_days: 2, max_days: 3 },
{ pincode: 495695, min_days: 2, max_days: 3 },
{ pincode: 496001, min_days: 2, max_days: 3 },
{ pincode: 496004, min_days: 2, max_days: 3 },
{ pincode: 496005, min_days: 2, max_days: 3 },
{ pincode: 496100, min_days: 2, max_days: 3 },
{ pincode: 496107, min_days: 2, max_days: 3 },
{ pincode: 496108, min_days: 2, max_days: 3 },
{ pincode: 496109, min_days: 2, max_days: 3 },
{ pincode: 496111, min_days: 2, max_days: 3 },
{ pincode: 496113, min_days: 2, max_days: 3 },
{ pincode: 496115, min_days: 2, max_days: 3 },
{ pincode: 496116, min_days: 2, max_days: 3 },
{ pincode: 496118, min_days: 2, max_days: 3 },
{ pincode: 496197, min_days: 2, max_days: 3 },
{ pincode: 496220, min_days: 2, max_days: 3 },
{ pincode: 496223, min_days: 2, max_days: 3 },
{ pincode: 496224, min_days: 2, max_days: 3 },
{ pincode: 496225, min_days: 2, max_days: 3 },
{ pincode: 496227, min_days: 2, max_days: 3 },
{ pincode: 496242, min_days: 2, max_days: 3 },
{ pincode: 496245, min_days: 2, max_days: 3 },
{ pincode: 496330, min_days: 2, max_days: 3 },
{ pincode: 496331, min_days: 2, max_days: 3 },
{ pincode: 496334, min_days: 2, max_days: 3 },
{ pincode: 496336, min_days: 2, max_days: 3 },
{ pincode: 496338, min_days: 2, max_days: 3 },
{ pincode: 496440, min_days: 2, max_days: 3 },
{ pincode: 496445, min_days: 2, max_days: 3 },
{ pincode: 496450, min_days: 2, max_days: 3 },
{ pincode: 496551, min_days: 2, max_days: 3 },
{ pincode: 496554, min_days: 2, max_days: 3 },
{ pincode: 496661, min_days: 2, max_days: 3 },
{ pincode: 496665, min_days: 2, max_days: 3 },
{ pincode: 497001, min_days: 2, max_days: 3 },
{ pincode: 497101, min_days: 2, max_days: 3 },
{ pincode: 497111, min_days: 2, max_days: 3 },
{ pincode: 497114, min_days: 2, max_days: 3 },
{ pincode: 497116, min_days: 2, max_days: 3 },
{ pincode: 497117, min_days: 2, max_days: 3 },
{ pincode: 497118, min_days: 2, max_days: 3 },
{ pincode: 497119, min_days: 2, max_days: 3 },
{ pincode: 497210, min_days: 2, max_days: 3 },
{ pincode: 497220, min_days: 2, max_days: 3 },
{ pincode: 497223, min_days: 2, max_days: 3 },
{ pincode: 497224, min_days: 2, max_days: 3 },
{ pincode: 497225, min_days: 2, max_days: 3 },
{ pincode: 497226, min_days: 2, max_days: 3 },
{ pincode: 497229, min_days: 2, max_days: 3 },
{ pincode: 497231, min_days: 2, max_days: 3 },
{ pincode: 497235, min_days: 2, max_days: 3 },
{ pincode: 497331, min_days: 2, max_days: 3 },
{ pincode: 497333, min_days: 2, max_days: 3 },
{ pincode: 497335, min_days: 2, max_days: 3 },
{ pincode: 497339, min_days: 2, max_days: 3 },
{ pincode: 497437, min_days: 2, max_days: 3 },
{ pincode: 497442, min_days: 2, max_days: 3 },
{ pincode: 497446, min_days: 2, max_days: 3 },
{ pincode: 497447, min_days: 2, max_days: 3 },
{ pincode: 497448, min_days: 2, max_days: 3 },
{ pincode: 497449, min_days: 2, max_days: 3 },
{ pincode: 497450, min_days: 2, max_days: 3 },
{ pincode: 497451, min_days: 2, max_days: 3 },
{ pincode: 497553, min_days: 2, max_days: 3 },
{ pincode: 497555, min_days: 2, max_days: 3 },
{ pincode: 497557, min_days: 2, max_days: 3 },
{ pincode: 497559, min_days: 2, max_days: 3 },
{ pincode: 497773, min_days: 2, max_days: 3 },
{ pincode: 497778, min_days: 2, max_days: 3 },
{ pincode: 500000, min_days: 2, max_days: 3 },
{ pincode: 500001, min_days: 2, max_days: 3 },
{ pincode: 500002, min_days: 2, max_days: 3 },
{ pincode: 500003, min_days: 2, max_days: 3 },
{ pincode: 500004, min_days: 2, max_days: 3 },
{ pincode: 500005, min_days: 2, max_days: 3 },
{ pincode: 500006, min_days: 2, max_days: 3 },
{ pincode: 500007, min_days: 2, max_days: 3 },
{ pincode: 500008, min_days: 2, max_days: 3 },
{ pincode: 500009, min_days: 2, max_days: 3 },
{ pincode: 500010, min_days: 2, max_days: 3 },
{ pincode: 500011, min_days: 2, max_days: 3 },
{ pincode: 500012, min_days: 2, max_days: 3 },
{ pincode: 500013, min_days: 2, max_days: 3 },
{ pincode: 500014, min_days: 2, max_days: 3 },
{ pincode: 500015, min_days: 2, max_days: 3 },
{ pincode: 500016, min_days: 2, max_days: 3 },
{ pincode: 500017, min_days: 2, max_days: 3 },
{ pincode: 500018, min_days: 2, max_days: 3 },
{ pincode: 500019, min_days: 2, max_days: 3 },
{ pincode: 500020, min_days: 2, max_days: 3 },
{ pincode: 500021, min_days: 2, max_days: 3 },
{ pincode: 500022, min_days: 2, max_days: 3 },
{ pincode: 500023, min_days: 2, max_days: 3 },
{ pincode: 500024, min_days: 2, max_days: 3 },
{ pincode: 500025, min_days: 2, max_days: 3 },
{ pincode: 500026, min_days: 2, max_days: 3 },
{ pincode: 500027, min_days: 2, max_days: 3 },
{ pincode: 500028, min_days: 2, max_days: 3 },
{ pincode: 500029, min_days: 2, max_days: 3 },
{ pincode: 500030, min_days: 2, max_days: 3 },
{ pincode: 500031, min_days: 2, max_days: 3 },
{ pincode: 500032, min_days: 2, max_days: 3 },
{ pincode: 500033, min_days: 2, max_days: 3 },
{ pincode: 500034, min_days: 2, max_days: 3 },
{ pincode: 500035, min_days: 2, max_days: 3 },
{ pincode: 500036, min_days: 2, max_days: 3 },
{ pincode: 500037, min_days: 2, max_days: 3 },
{ pincode: 500038, min_days: 2, max_days: 3 },
{ pincode: 500039, min_days: 2, max_days: 3 },
{ pincode: 500040, min_days: 2, max_days: 3 },
{ pincode: 500041, min_days: 2, max_days: 3 },
{ pincode: 500042, min_days: 2, max_days: 3 },
{ pincode: 500043, min_days: 2, max_days: 3 },
{ pincode: 500044, min_days: 2, max_days: 3 },
{ pincode: 500045, min_days: 2, max_days: 3 },
{ pincode: 500046, min_days: 2, max_days: 3 },
{ pincode: 500047, min_days: 2, max_days: 3 },
{ pincode: 500048, min_days: 2, max_days: 3 },
{ pincode: 500049, min_days: 2, max_days: 3 },
{ pincode: 500050, min_days: 2, max_days: 3 },
{ pincode: 500051, min_days: 2, max_days: 3 },
{ pincode: 500052, min_days: 2, max_days: 3 },
{ pincode: 500053, min_days: 2, max_days: 3 },
{ pincode: 500054, min_days: 2, max_days: 3 },
{ pincode: 500055, min_days: 2, max_days: 3 },
{ pincode: 500056, min_days: 2, max_days: 3 },
{ pincode: 500057, min_days: 2, max_days: 3 },
{ pincode: 500058, min_days: 2, max_days: 3 },
{ pincode: 500059, min_days: 2, max_days: 3 },
{ pincode: 500060, min_days: 2, max_days: 3 },
{ pincode: 500061, min_days: 2, max_days: 3 },
{ pincode: 500062, min_days: 2, max_days: 3 },
{ pincode: 500063, min_days: 2, max_days: 3 },
{ pincode: 500064, min_days: 2, max_days: 3 },
{ pincode: 500065, min_days: 2, max_days: 3 },
{ pincode: 500066, min_days: 2, max_days: 3 },
{ pincode: 500067, min_days: 2, max_days: 3 },
{ pincode: 500068, min_days: 2, max_days: 3 },
{ pincode: 500069, min_days: 2, max_days: 3 },
{ pincode: 500070, min_days: 2, max_days: 3 },
{ pincode: 500071, min_days: 2, max_days: 3 },
{ pincode: 500072, min_days: 2, max_days: 3 },
{ pincode: 500073, min_days: 2, max_days: 3 },
{ pincode: 500074, min_days: 2, max_days: 3 },
{ pincode: 500075, min_days: 2, max_days: 3 },
{ pincode: 500076, min_days: 2, max_days: 3 },
{ pincode: 500077, min_days: 2, max_days: 3 },
{ pincode: 500078, min_days: 2, max_days: 3 },
{ pincode: 500079, min_days: 2, max_days: 3 },
{ pincode: 500080, min_days: 2, max_days: 3 },
{ pincode: 500081, min_days: 2, max_days: 3 },
{ pincode: 500082, min_days: 2, max_days: 3 },
{ pincode: 500083, min_days: 2, max_days: 3 },
{ pincode: 500084, min_days: 2, max_days: 3 },
{ pincode: 500085, min_days: 2, max_days: 3 },
{ pincode: 500086, min_days: 2, max_days: 3 },
{ pincode: 500087, min_days: 2, max_days: 3 },
{ pincode: 500088, min_days: 2, max_days: 3 },
{ pincode: 500089, min_days: 2, max_days: 3 },
{ pincode: 500090, min_days: 2, max_days: 3 },
{ pincode: 500091, min_days: 2, max_days: 3 },
{ pincode: 500092, min_days: 2, max_days: 3 },
{ pincode: 500093, min_days: 2, max_days: 3 },
{ pincode: 500094, min_days: 2, max_days: 3 },
{ pincode: 500095, min_days: 2, max_days: 3 },
{ pincode: 500096, min_days: 2, max_days: 3 },
{ pincode: 500097, min_days: 2, max_days: 3 },
{ pincode: 500098, min_days: 2, max_days: 3 },
{ pincode: 500100, min_days: 2, max_days: 3 },
{ pincode: 500101, min_days: 2, max_days: 3 },
{ pincode: 500102, min_days: 2, max_days: 3 },
{ pincode: 500103, min_days: 2, max_days: 3 },
{ pincode: 500104, min_days: 2, max_days: 3 },
{ pincode: 500105, min_days: 2, max_days: 3 },
{ pincode: 500107, min_days: 2, max_days: 3 },
{ pincode: 500108, min_days: 2, max_days: 3 },
{ pincode: 500110, min_days: 2, max_days: 3 },
{ pincode: 500111, min_days: 2, max_days: 3 },
{ pincode: 500112, min_days: 2, max_days: 3 },
{ pincode: 500113, min_days: 2, max_days: 3 },
{ pincode: 500114, min_days: 2, max_days: 3 },
{ pincode: 500117, min_days: 2, max_days: 3 },
{ pincode: 500123, min_days: 2, max_days: 3 },
{ pincode: 500133, min_days: 2, max_days: 3 },
{ pincode: 500146, min_days: 2, max_days: 3 },
{ pincode: 500170, min_days: 2, max_days: 3 },
{ pincode: 500177, min_days: 2, max_days: 3 },
{ pincode: 500178, min_days: 2, max_days: 3 },
{ pincode: 500195, min_days: 2, max_days: 3 },
{ pincode: 500252, min_days: 2, max_days: 3 },
{ pincode: 500253, min_days: 2, max_days: 3 },
{ pincode: 500264, min_days: 2, max_days: 3 },
{ pincode: 500265, min_days: 2, max_days: 3 },
{ pincode: 500267, min_days: 2, max_days: 3 },
{ pincode: 500361, min_days: 2, max_days: 3 },
{ pincode: 500380, min_days: 2, max_days: 3 },
{ pincode: 500409, min_days: 2, max_days: 3 },
{ pincode: 500457, min_days: 2, max_days: 3 },
{ pincode: 500472, min_days: 2, max_days: 3 },
{ pincode: 500475, min_days: 2, max_days: 3 },
{ pincode: 500476, min_days: 2, max_days: 3 },
{ pincode: 500482, min_days: 2, max_days: 3 },
{ pincode: 500484, min_days: 2, max_days: 3 },
{ pincode: 500486, min_days: 2, max_days: 3 },
{ pincode: 500488, min_days: 2, max_days: 3 },
{ pincode: 500594, min_days: 2, max_days: 3 },
{ pincode: 500605, min_days: 2, max_days: 3 },
{ pincode: 500609, min_days: 2, max_days: 3 },
{ pincode: 500659, min_days: 2, max_days: 3 },
{ pincode: 500660, min_days: 2, max_days: 3 },
{ pincode: 500762, min_days: 2, max_days: 3 },
{ pincode: 500768, min_days: 2, max_days: 3 },
{ pincode: 500873, min_days: 2, max_days: 3 },
{ pincode: 500890, min_days: 2, max_days: 3 },
{ pincode: 500960, min_days: 2, max_days: 3 },
{ pincode: 500991, min_days: 2, max_days: 3 },
{ pincode: 501101, min_days: 2, max_days: 3 },
{ pincode: 501102, min_days: 2, max_days: 3 },
{ pincode: 501106, min_days: 2, max_days: 3 },
{ pincode: 501111, min_days: 2, max_days: 3 },
{ pincode: 501121, min_days: 2, max_days: 3 },
{ pincode: 501141, min_days: 2, max_days: 3 },
{ pincode: 501142, min_days: 2, max_days: 3 },
{ pincode: 501143, min_days: 2, max_days: 3 },
{ pincode: 501144, min_days: 2, max_days: 3 },
{ pincode: 501157, min_days: 2, max_days: 3 },
{ pincode: 501158, min_days: 2, max_days: 3 },
{ pincode: 501201, min_days: 2, max_days: 3 },
{ pincode: 501202, min_days: 2, max_days: 3 },
{ pincode: 501203, min_days: 2, max_days: 3 },
{ pincode: 501218, min_days: 2, max_days: 3 },
{ pincode: 501301, min_days: 2, max_days: 3 },
{ pincode: 501302, min_days: 2, max_days: 3 },
{ pincode: 501323, min_days: 2, max_days: 3 },
{ pincode: 501359, min_days: 2, max_days: 3 },
{ pincode: 501401, min_days: 2, max_days: 3 },
{ pincode: 501403, min_days: 2, max_days: 3 },
{ pincode: 501501, min_days: 2, max_days: 3 },
{ pincode: 501502, min_days: 2, max_days: 3 },
{ pincode: 501503, min_days: 2, max_days: 3 },
{ pincode: 501504, min_days: 2, max_days: 3 },
{ pincode: 501505, min_days: 2, max_days: 3 },
{ pincode: 501506, min_days: 2, max_days: 3 },
{ pincode: 501507, min_days: 2, max_days: 3 },
{ pincode: 501508, min_days: 2, max_days: 3 },
{ pincode: 501509, min_days: 2, max_days: 3 },
{ pincode: 501510, min_days: 2, max_days: 3 },
{ pincode: 501511, min_days: 2, max_days: 3 },
{ pincode: 501512, min_days: 2, max_days: 3 },
{ pincode: 501513, min_days: 2, max_days: 3 },
{ pincode: 501539, min_days: 2, max_days: 3 },
{ pincode: 502001, min_days: 2, max_days: 3 },
{ pincode: 502032, min_days: 2, max_days: 3 },
{ pincode: 502101, min_days: 2, max_days: 3 },
{ pincode: 502102, min_days: 2, max_days: 3 },
{ pincode: 502103, min_days: 2, max_days: 3 },
{ pincode: 502107, min_days: 2, max_days: 3 },
{ pincode: 502108, min_days: 2, max_days: 3 },
{ pincode: 502109, min_days: 2, max_days: 3 },
{ pincode: 502110, min_days: 2, max_days: 3 },
{ pincode: 502113, min_days: 2, max_days: 3 },
{ pincode: 502114, min_days: 2, max_days: 3 },
{ pincode: 502115, min_days: 2, max_days: 3 },
{ pincode: 502117, min_days: 2, max_days: 3 },
{ pincode: 502125, min_days: 2, max_days: 3 },
{ pincode: 502130, min_days: 2, max_days: 3 },
{ pincode: 502205, min_days: 2, max_days: 3 },
{ pincode: 502210, min_days: 2, max_days: 3 },
{ pincode: 502220, min_days: 2, max_days: 3 },
{ pincode: 502221, min_days: 2, max_days: 3 },
{ pincode: 502228, min_days: 2, max_days: 3 },
{ pincode: 502246, min_days: 2, max_days: 3 },
{ pincode: 502247, min_days: 2, max_days: 3 },
{ pincode: 502248, min_days: 2, max_days: 3 },
{ pincode: 502249, min_days: 2, max_days: 3 },
{ pincode: 502251, min_days: 2, max_days: 3 },
{ pincode: 502255, min_days: 2, max_days: 3 },
{ pincode: 502256, min_days: 2, max_days: 3 },
{ pincode: 502257, min_days: 2, max_days: 3 },
{ pincode: 502267, min_days: 2, max_days: 3 },
{ pincode: 502269, min_days: 2, max_days: 3 },
{ pincode: 502270, min_days: 2, max_days: 3 },
{ pincode: 502271, min_days: 2, max_days: 3 },
{ pincode: 502273, min_days: 2, max_days: 3 },
{ pincode: 502276, min_days: 2, max_days: 3 },
{ pincode: 502277, min_days: 2, max_days: 3 },
{ pincode: 502278, min_days: 2, max_days: 3 },
{ pincode: 502279, min_days: 2, max_days: 3 },
{ pincode: 502280, min_days: 2, max_days: 3 },
{ pincode: 502281, min_days: 2, max_days: 3 },
{ pincode: 502284, min_days: 2, max_days: 3 },
{ pincode: 502285, min_days: 2, max_days: 3 },
{ pincode: 502286, min_days: 2, max_days: 3 },
{ pincode: 502287, min_days: 2, max_days: 3 },
{ pincode: 502290, min_days: 2, max_days: 3 },
{ pincode: 502291, min_days: 2, max_days: 3 },
{ pincode: 502293, min_days: 2, max_days: 3 },
{ pincode: 502294, min_days: 2, max_days: 3 },
{ pincode: 502295, min_days: 2, max_days: 3 },
{ pincode: 502296, min_days: 2, max_days: 3 },
{ pincode: 502300, min_days: 2, max_days: 3 },
{ pincode: 502301, min_days: 2, max_days: 3 },
{ pincode: 502302, min_days: 2, max_days: 3 },
{ pincode: 502303, min_days: 2, max_days: 3 },
{ pincode: 502305, min_days: 2, max_days: 3 },
{ pincode: 502306, min_days: 2, max_days: 3 },
{ pincode: 502307, min_days: 2, max_days: 3 },
{ pincode: 502310, min_days: 2, max_days: 3 },
{ pincode: 502311, min_days: 2, max_days: 3 },
{ pincode: 502312, min_days: 2, max_days: 3 },
{ pincode: 502313, min_days: 2, max_days: 3 },
{ pincode: 502314, min_days: 2, max_days: 3 },
{ pincode: 502316, min_days: 2, max_days: 3 },
{ pincode: 502318, min_days: 2, max_days: 3 },
{ pincode: 502319, min_days: 2, max_days: 3 },
{ pincode: 502320, min_days: 2, max_days: 3 },
{ pincode: 502321, min_days: 2, max_days: 3 },
{ pincode: 502324, min_days: 2, max_days: 3 },
{ pincode: 502325, min_days: 2, max_days: 3 },
{ pincode: 502329, min_days: 2, max_days: 3 },
{ pincode: 502331, min_days: 2, max_days: 3 },
{ pincode: 502334, min_days: 2, max_days: 3 },
{ pincode: 502335, min_days: 2, max_days: 3 },
{ pincode: 502336, min_days: 2, max_days: 3 },
{ pincode: 502345, min_days: 2, max_days: 3 },
{ pincode: 502371, min_days: 2, max_days: 3 },
{ pincode: 502372, min_days: 2, max_days: 3 },
{ pincode: 502375, min_days: 2, max_days: 3 },
{ pincode: 502381, min_days: 2, max_days: 3 },
{ pincode: 502779, min_days: 2, max_days: 3 },
{ pincode: 503001, min_days: 2, max_days: 3 },
{ pincode: 503002, min_days: 2, max_days: 3 },
{ pincode: 503003, min_days: 2, max_days: 3 },
{ pincode: 503004, min_days: 2, max_days: 3 },
{ pincode: 503101, min_days: 2, max_days: 3 },
{ pincode: 503102, min_days: 2, max_days: 3 },
{ pincode: 503108, min_days: 2, max_days: 3 },
{ pincode: 503110, min_days: 2, max_days: 3 },
{ pincode: 503111, min_days: 2, max_days: 3 },
{ pincode: 503112, min_days: 2, max_days: 3 },
{ pincode: 503114, min_days: 2, max_days: 3 },
{ pincode: 503120, min_days: 2, max_days: 3 },
{ pincode: 503122, min_days: 2, max_days: 3 },
{ pincode: 503123, min_days: 2, max_days: 3 },
{ pincode: 503124, min_days: 2, max_days: 3 },
{ pincode: 503125, min_days: 2, max_days: 3 },
{ pincode: 503144, min_days: 2, max_days: 3 },
{ pincode: 503145, min_days: 2, max_days: 3 },
{ pincode: 503164, min_days: 2, max_days: 3 },
{ pincode: 503165, min_days: 2, max_days: 3 },
{ pincode: 503174, min_days: 2, max_days: 3 },
{ pincode: 503175, min_days: 2, max_days: 3 },
{ pincode: 503180, min_days: 2, max_days: 3 },
{ pincode: 503185, min_days: 2, max_days: 3 },
{ pincode: 503186, min_days: 2, max_days: 3 },
{ pincode: 503187, min_days: 2, max_days: 3 },
{ pincode: 503188, min_days: 2, max_days: 3 },
{ pincode: 503201, min_days: 2, max_days: 3 },
{ pincode: 503202, min_days: 2, max_days: 3 },
{ pincode: 503206, min_days: 2, max_days: 3 },
{ pincode: 503207, min_days: 2, max_days: 3 },
{ pincode: 503212, min_days: 2, max_days: 3 },
{ pincode: 503213, min_days: 2, max_days: 3 },
{ pincode: 503217, min_days: 2, max_days: 3 },
{ pincode: 503218, min_days: 2, max_days: 3 },
{ pincode: 503219, min_days: 2, max_days: 3 },
{ pincode: 503223, min_days: 2, max_days: 3 },
{ pincode: 503224, min_days: 2, max_days: 3 },
{ pincode: 503225, min_days: 2, max_days: 3 },
{ pincode: 503230, min_days: 2, max_days: 3 },
{ pincode: 503235, min_days: 2, max_days: 3 },
{ pincode: 503245, min_days: 2, max_days: 3 },
{ pincode: 503246, min_days: 2, max_days: 3 },
{ pincode: 503301, min_days: 2, max_days: 3 },
{ pincode: 503302, min_days: 2, max_days: 3 },
{ pincode: 503305, min_days: 2, max_days: 3 },
{ pincode: 503306, min_days: 2, max_days: 3 },
{ pincode: 503307, min_days: 2, max_days: 3 },
{ pincode: 503308, min_days: 2, max_days: 3 },
{ pincode: 503309, min_days: 2, max_days: 3 },
{ pincode: 503310, min_days: 2, max_days: 3 },
{ pincode: 503311, min_days: 2, max_days: 3 },
{ pincode: 503321, min_days: 2, max_days: 3 },
{ pincode: 503322, min_days: 2, max_days: 3 },
{ pincode: 503501, min_days: 2, max_days: 3 },
{ pincode: 504001, min_days: 2, max_days: 3 },
{ pincode: 504002, min_days: 2, max_days: 3 },
{ pincode: 504101, min_days: 2, max_days: 3 },
{ pincode: 504102, min_days: 2, max_days: 3 },
{ pincode: 504103, min_days: 2, max_days: 3 },
{ pincode: 504104, min_days: 2, max_days: 3 },
{ pincode: 504105, min_days: 2, max_days: 3 },
{ pincode: 504106, min_days: 2, max_days: 3 },
{ pincode: 504107, min_days: 2, max_days: 3 },
{ pincode: 504109, min_days: 2, max_days: 3 },
{ pincode: 504110, min_days: 2, max_days: 3 },
{ pincode: 504201, min_days: 2, max_days: 3 },
{ pincode: 504202, min_days: 2, max_days: 3 },
{ pincode: 504203, min_days: 2, max_days: 3 },
{ pincode: 504204, min_days: 2, max_days: 3 },
{ pincode: 504205, min_days: 2, max_days: 3 },
{ pincode: 504206, min_days: 2, max_days: 3 },
{ pincode: 504207, min_days: 2, max_days: 3 },
{ pincode: 504208, min_days: 2, max_days: 3 },
{ pincode: 504209, min_days: 2, max_days: 3 },
{ pincode: 504214, min_days: 2, max_days: 3 },
{ pincode: 504215, min_days: 2, max_days: 3 },
{ pincode: 504216, min_days: 2, max_days: 3 },
{ pincode: 504217, min_days: 2, max_days: 3 },
{ pincode: 504218, min_days: 2, max_days: 3 },
{ pincode: 504219, min_days: 2, max_days: 3 },
{ pincode: 504220, min_days: 2, max_days: 3 },
{ pincode: 504231, min_days: 2, max_days: 3 },
{ pincode: 504251, min_days: 2, max_days: 3 },
{ pincode: 504272, min_days: 2, max_days: 3 },
{ pincode: 504273, min_days: 2, max_days: 3 },
{ pincode: 504292, min_days: 2, max_days: 3 },
{ pincode: 504293, min_days: 2, max_days: 3 },
{ pincode: 504294, min_days: 2, max_days: 3 },
{ pincode: 504295, min_days: 2, max_days: 3 },
{ pincode: 504296, min_days: 2, max_days: 3 },
{ pincode: 504297, min_days: 2, max_days: 3 },
{ pincode: 504299, min_days: 2, max_days: 3 },
{ pincode: 504301, min_days: 2, max_days: 3 },
{ pincode: 504302, min_days: 2, max_days: 3 },
{ pincode: 504303, min_days: 2, max_days: 3 },
{ pincode: 504304, min_days: 2, max_days: 3 },
{ pincode: 504305, min_days: 2, max_days: 3 },
{ pincode: 504306, min_days: 2, max_days: 3 },
{ pincode: 504307, min_days: 2, max_days: 3 },
{ pincode: 504308, min_days: 2, max_days: 3 },
{ pincode: 504309, min_days: 2, max_days: 3 },
{ pincode: 504310, min_days: 2, max_days: 3 },
{ pincode: 504311, min_days: 2, max_days: 3 },
{ pincode: 504312, min_days: 2, max_days: 3 },
{ pincode: 504313, min_days: 2, max_days: 3 },
{ pincode: 504323, min_days: 2, max_days: 3 },
{ pincode: 504346, min_days: 2, max_days: 3 },
{ pincode: 505001, min_days: 2, max_days: 3 },
{ pincode: 505002, min_days: 2, max_days: 3 },
{ pincode: 505101, min_days: 2, max_days: 3 },
{ pincode: 505102, min_days: 2, max_days: 3 },
{ pincode: 505122, min_days: 2, max_days: 3 },
{ pincode: 505129, min_days: 2, max_days: 3 },
{ pincode: 505152, min_days: 2, max_days: 3 },
{ pincode: 505153, min_days: 2, max_days: 3 },
{ pincode: 505162, min_days: 2, max_days: 3 },
{ pincode: 505172, min_days: 2, max_days: 3 },
{ pincode: 505174, min_days: 2, max_days: 3 },
{ pincode: 505184, min_days: 2, max_days: 3 },
{ pincode: 505185, min_days: 2, max_days: 3 },
{ pincode: 505186, min_days: 2, max_days: 3 },
{ pincode: 505187, min_days: 2, max_days: 3 },
{ pincode: 505188, min_days: 2, max_days: 3 },
{ pincode: 505208, min_days: 2, max_days: 3 },
{ pincode: 505209, min_days: 2, max_days: 3 },
{ pincode: 505210, min_days: 2, max_days: 3 },
{ pincode: 505211, min_days: 2, max_days: 3 },
{ pincode: 505212, min_days: 2, max_days: 3 },
{ pincode: 505214, min_days: 2, max_days: 3 },
{ pincode: 505215, min_days: 2, max_days: 3 },
{ pincode: 505301, min_days: 2, max_days: 3 },
{ pincode: 505302, min_days: 2, max_days: 3 },
{ pincode: 505303, min_days: 2, max_days: 3 },
{ pincode: 505304, min_days: 2, max_days: 3 },
{ pincode: 505305, min_days: 2, max_days: 3 },
{ pincode: 505306, min_days: 2, max_days: 3 },
{ pincode: 505307, min_days: 2, max_days: 3 },
{ pincode: 505325, min_days: 2, max_days: 3 },
{ pincode: 505326, min_days: 2, max_days: 3 },
{ pincode: 505327, min_days: 2, max_days: 3 },
{ pincode: 505330, min_days: 2, max_days: 3 },
{ pincode: 505331, min_days: 2, max_days: 3 },
{ pincode: 505401, min_days: 2, max_days: 3 },
{ pincode: 505402, min_days: 2, max_days: 3 },
{ pincode: 505403, min_days: 2, max_days: 3 },
{ pincode: 505404, min_days: 2, max_days: 3 },
{ pincode: 505405, min_days: 2, max_days: 3 },
{ pincode: 505407, min_days: 2, max_days: 3 },
{ pincode: 505415, min_days: 2, max_days: 3 },
{ pincode: 505416, min_days: 2, max_days: 3 },
{ pincode: 505425, min_days: 2, max_days: 3 },
{ pincode: 505445, min_days: 2, max_days: 3 },
{ pincode: 505450, min_days: 2, max_days: 3 },
{ pincode: 505451, min_days: 2, max_days: 3 },
{ pincode: 505452, min_days: 2, max_days: 3 },
{ pincode: 505453, min_days: 2, max_days: 3 },
{ pincode: 505454, min_days: 2, max_days: 3 },
{ pincode: 505455, min_days: 2, max_days: 3 },
{ pincode: 505460, min_days: 2, max_days: 3 },
{ pincode: 505462, min_days: 2, max_days: 3 },
{ pincode: 505466, min_days: 2, max_days: 3 },
{ pincode: 505467, min_days: 2, max_days: 3 },
{ pincode: 505468, min_days: 2, max_days: 3 },
{ pincode: 505469, min_days: 2, max_days: 3 },
{ pincode: 505470, min_days: 2, max_days: 3 },
{ pincode: 505471, min_days: 2, max_days: 3 },
{ pincode: 505472, min_days: 2, max_days: 3 },
{ pincode: 505473, min_days: 2, max_days: 3 },
{ pincode: 505474, min_days: 2, max_days: 3 },
{ pincode: 505475, min_days: 2, max_days: 3 },
{ pincode: 505476, min_days: 2, max_days: 3 },
{ pincode: 505480, min_days: 2, max_days: 3 },
{ pincode: 505481, min_days: 2, max_days: 3 },
{ pincode: 505490, min_days: 2, max_days: 3 },
{ pincode: 505497, min_days: 2, max_days: 3 },
{ pincode: 505498, min_days: 2, max_days: 3 },
{ pincode: 505501, min_days: 2, max_days: 3 },
{ pincode: 505502, min_days: 2, max_days: 3 },
{ pincode: 505503, min_days: 2, max_days: 3 },
{ pincode: 505504, min_days: 2, max_days: 3 },
{ pincode: 505505, min_days: 2, max_days: 3 },
{ pincode: 505514, min_days: 2, max_days: 3 },
{ pincode: 505524, min_days: 2, max_days: 3 },
{ pincode: 505525, min_days: 2, max_days: 3 },
{ pincode: 505526, min_days: 2, max_days: 3 },
{ pincode: 505527, min_days: 2, max_days: 3 },
{ pincode: 505528, min_days: 2, max_days: 3 },
{ pincode: 505529, min_days: 2, max_days: 3 },
{ pincode: 505530, min_days: 2, max_days: 3 },
{ pincode: 505531, min_days: 2, max_days: 3 },
{ pincode: 505532, min_days: 2, max_days: 3 },
{ pincode: 506001, min_days: 2, max_days: 3 },
{ pincode: 506002, min_days: 2, max_days: 3 },
{ pincode: 506003, min_days: 2, max_days: 3 },
{ pincode: 506004, min_days: 2, max_days: 3 },
{ pincode: 506005, min_days: 2, max_days: 3 },
{ pincode: 506006, min_days: 2, max_days: 3 },
{ pincode: 506007, min_days: 2, max_days: 3 },
{ pincode: 506008, min_days: 2, max_days: 3 },
{ pincode: 506009, min_days: 2, max_days: 3 },
{ pincode: 506010, min_days: 2, max_days: 3 },
{ pincode: 506011, min_days: 2, max_days: 3 },
{ pincode: 506012, min_days: 2, max_days: 3 },
{ pincode: 506013, min_days: 2, max_days: 3 },
{ pincode: 506015, min_days: 2, max_days: 3 },
{ pincode: 506101, min_days: 2, max_days: 3 },
{ pincode: 506102, min_days: 2, max_days: 3 },
{ pincode: 506103, min_days: 2, max_days: 3 },
{ pincode: 506104, min_days: 2, max_days: 3 },
{ pincode: 506105, min_days: 2, max_days: 3 },
{ pincode: 506112, min_days: 2, max_days: 3 },
{ pincode: 506122, min_days: 2, max_days: 3 },
{ pincode: 506132, min_days: 2, max_days: 3 },
{ pincode: 506134, min_days: 2, max_days: 3 },
{ pincode: 506135, min_days: 2, max_days: 3 },
{ pincode: 506142, min_days: 2, max_days: 3 },
{ pincode: 506143, min_days: 2, max_days: 3 },
{ pincode: 506144, min_days: 2, max_days: 3 },
{ pincode: 506145, min_days: 2, max_days: 3 },
{ pincode: 506146, min_days: 2, max_days: 3 },
{ pincode: 506151, min_days: 2, max_days: 3 },
{ pincode: 506163, min_days: 2, max_days: 3 },
{ pincode: 506164, min_days: 2, max_days: 3 },
{ pincode: 506165, min_days: 2, max_days: 3 },
{ pincode: 506166, min_days: 2, max_days: 3 },
{ pincode: 506167, min_days: 2, max_days: 3 },
{ pincode: 506168, min_days: 2, max_days: 3 },
{ pincode: 506169, min_days: 2, max_days: 3 },
{ pincode: 506170, min_days: 2, max_days: 3 },
{ pincode: 506172, min_days: 2, max_days: 3 },
{ pincode: 506175, min_days: 2, max_days: 3 },
{ pincode: 506201, min_days: 2, max_days: 3 },
{ pincode: 506221, min_days: 2, max_days: 3 },
{ pincode: 506222, min_days: 2, max_days: 3 },
{ pincode: 506223, min_days: 2, max_days: 3 },
{ pincode: 506224, min_days: 2, max_days: 3 },
{ pincode: 506244, min_days: 2, max_days: 3 },
{ pincode: 506252, min_days: 2, max_days: 3 },
{ pincode: 506301, min_days: 2, max_days: 3 },
{ pincode: 506302, min_days: 2, max_days: 3 },
{ pincode: 506303, min_days: 2, max_days: 3 },
{ pincode: 506310, min_days: 2, max_days: 3 },
{ pincode: 506313, min_days: 2, max_days: 3 },
{ pincode: 506314, min_days: 2, max_days: 3 },
{ pincode: 506315, min_days: 2, max_days: 3 },
{ pincode: 506316, min_days: 2, max_days: 3 },
{ pincode: 506317, min_days: 2, max_days: 3 },
{ pincode: 506318, min_days: 2, max_days: 3 },
{ pincode: 506319, min_days: 2, max_days: 3 },
{ pincode: 506324, min_days: 2, max_days: 3 },
{ pincode: 506329, min_days: 2, max_days: 3 },
{ pincode: 506330, min_days: 2, max_days: 3 },
{ pincode: 506331, min_days: 2, max_days: 3 },
{ pincode: 506332, min_days: 2, max_days: 3 },
{ pincode: 506333, min_days: 2, max_days: 3 },
{ pincode: 506342, min_days: 2, max_days: 3 },
{ pincode: 506343, min_days: 2, max_days: 3 },
{ pincode: 506344, min_days: 2, max_days: 3 },
{ pincode: 506345, min_days: 2, max_days: 3 },
{ pincode: 506347, min_days: 2, max_days: 3 },
{ pincode: 506348, min_days: 2, max_days: 3 },
{ pincode: 506349, min_days: 2, max_days: 3 },
{ pincode: 506350, min_days: 2, max_days: 3 },
{ pincode: 506352, min_days: 2, max_days: 3 },
{ pincode: 506355, min_days: 2, max_days: 3 },
{ pincode: 506356, min_days: 2, max_days: 3 },
{ pincode: 506365, min_days: 2, max_days: 3 },
{ pincode: 506366, min_days: 2, max_days: 3 },
{ pincode: 506367, min_days: 2, max_days: 3 },
{ pincode: 506368, min_days: 2, max_days: 3 },
{ pincode: 506369, min_days: 2, max_days: 3 },
{ pincode: 506370, min_days: 2, max_days: 3 },
{ pincode: 506371, min_days: 2, max_days: 3 },
{ pincode: 506381, min_days: 2, max_days: 3 },
{ pincode: 506391, min_days: 2, max_days: 3 },
{ pincode: 507001, min_days: 2, max_days: 3 },
{ pincode: 507002, min_days: 2, max_days: 3 },
{ pincode: 507003, min_days: 2, max_days: 3 },
{ pincode: 507004, min_days: 2, max_days: 3 },
{ pincode: 507101, min_days: 2, max_days: 3 },
{ pincode: 507102, min_days: 2, max_days: 3 },
{ pincode: 507103, min_days: 2, max_days: 3 },
{ pincode: 507111, min_days: 2, max_days: 3 },
{ pincode: 507112, min_days: 2, max_days: 3 },
{ pincode: 507113, min_days: 2, max_days: 3 },
{ pincode: 507114, min_days: 2, max_days: 3 },
{ pincode: 507115, min_days: 2, max_days: 3 },
{ pincode: 507116, min_days: 2, max_days: 3 },
{ pincode: 507117, min_days: 2, max_days: 3 },
{ pincode: 507118, min_days: 2, max_days: 3 },
{ pincode: 507119, min_days: 2, max_days: 3 },
{ pincode: 507120, min_days: 2, max_days: 3 },
{ pincode: 507122, min_days: 2, max_days: 3 },
{ pincode: 507123, min_days: 2, max_days: 3 },
{ pincode: 507124, min_days: 2, max_days: 3 },
{ pincode: 507125, min_days: 2, max_days: 3 },
{ pincode: 507126, min_days: 2, max_days: 3 },
{ pincode: 507127, min_days: 2, max_days: 3 },
{ pincode: 507128, min_days: 2, max_days: 3 },
{ pincode: 507129, min_days: 2, max_days: 3 },
{ pincode: 507133, min_days: 2, max_days: 3 },
{ pincode: 507134, min_days: 2, max_days: 3 },
{ pincode: 507135, min_days: 2, max_days: 3 },
{ pincode: 507136, min_days: 2, max_days: 3 },
{ pincode: 507137, min_days: 2, max_days: 3 },
{ pincode: 507138, min_days: 2, max_days: 3 },
{ pincode: 507140, min_days: 2, max_days: 3 },
{ pincode: 507154, min_days: 2, max_days: 3 },
{ pincode: 507157, min_days: 2, max_days: 3 },
{ pincode: 507158, min_days: 2, max_days: 3 },
{ pincode: 507159, min_days: 2, max_days: 3 },
{ pincode: 507160, min_days: 2, max_days: 3 },
{ pincode: 507161, min_days: 2, max_days: 3 },
{ pincode: 507163, min_days: 2, max_days: 3 },
{ pincode: 507164, min_days: 2, max_days: 3 },
{ pincode: 507165, min_days: 2, max_days: 3 },
{ pincode: 507166, min_days: 2, max_days: 3 },
{ pincode: 507167, min_days: 2, max_days: 3 },
{ pincode: 507168, min_days: 2, max_days: 3 },
{ pincode: 507169, min_days: 2, max_days: 3 },
{ pincode: 507170, min_days: 2, max_days: 3 },
{ pincode: 507171, min_days: 2, max_days: 3 },
{ pincode: 507182, min_days: 2, max_days: 3 },
{ pincode: 507183, min_days: 2, max_days: 3 },
{ pincode: 507201, min_days: 2, max_days: 3 },
{ pincode: 507202, min_days: 2, max_days: 3 },
{ pincode: 507203, min_days: 2, max_days: 3 },
{ pincode: 507204, min_days: 2, max_days: 3 },
{ pincode: 507208, min_days: 2, max_days: 3 },
{ pincode: 507209, min_days: 2, max_days: 3 },
{ pincode: 507210, min_days: 2, max_days: 3 },
{ pincode: 507211, min_days: 2, max_days: 3 },
{ pincode: 507301, min_days: 2, max_days: 3 },
{ pincode: 507302, min_days: 2, max_days: 3 },
{ pincode: 507303, min_days: 2, max_days: 3 },
{ pincode: 507304, min_days: 2, max_days: 3 },
{ pincode: 507305, min_days: 2, max_days: 3 },
{ pincode: 507306, min_days: 2, max_days: 3 },
{ pincode: 507315, min_days: 2, max_days: 3 },
{ pincode: 507316, min_days: 2, max_days: 3 },
{ pincode: 507318, min_days: 2, max_days: 3 },
{ pincode: 508001, min_days: 2, max_days: 3 },
{ pincode: 508002, min_days: 2, max_days: 3 },
{ pincode: 508004, min_days: 2, max_days: 3 },
{ pincode: 508101, min_days: 2, max_days: 3 },
{ pincode: 508105, min_days: 2, max_days: 3 },
{ pincode: 508111, min_days: 2, max_days: 3 },
{ pincode: 508112, min_days: 2, max_days: 3 },
{ pincode: 508113, min_days: 2, max_days: 3 },
{ pincode: 508114, min_days: 2, max_days: 3 },
{ pincode: 508115, min_days: 2, max_days: 3 },
{ pincode: 508116, min_days: 2, max_days: 3 },
{ pincode: 508117, min_days: 2, max_days: 3 },
{ pincode: 508126, min_days: 2, max_days: 3 },
{ pincode: 508201, min_days: 2, max_days: 3 },
{ pincode: 508202, min_days: 2, max_days: 3 },
{ pincode: 508204, min_days: 2, max_days: 3 },
{ pincode: 508205, min_days: 2, max_days: 3 },
{ pincode: 508206, min_days: 2, max_days: 3 },
{ pincode: 508207, min_days: 2, max_days: 3 },
{ pincode: 508208, min_days: 2, max_days: 3 },
{ pincode: 508210, min_days: 2, max_days: 3 },
{ pincode: 508211, min_days: 2, max_days: 3 },
{ pincode: 508212, min_days: 2, max_days: 3 },
{ pincode: 508213, min_days: 2, max_days: 3 },
{ pincode: 508214, min_days: 2, max_days: 3 },
{ pincode: 508216, min_days: 2, max_days: 3 },
{ pincode: 508217, min_days: 2, max_days: 3 },
{ pincode: 508218, min_days: 2, max_days: 3 },
{ pincode: 508221, min_days: 2, max_days: 3 },
{ pincode: 508222, min_days: 2, max_days: 3 },
{ pincode: 508223, min_days: 2, max_days: 3 },
{ pincode: 508224, min_days: 2, max_days: 3 },
{ pincode: 508233, min_days: 2, max_days: 3 },
{ pincode: 508234, min_days: 2, max_days: 3 },
{ pincode: 508238, min_days: 2, max_days: 3 },
{ pincode: 508243, min_days: 2, max_days: 3 },
{ pincode: 508244, min_days: 2, max_days: 3 },
{ pincode: 508245, min_days: 2, max_days: 3 },
{ pincode: 508246, min_days: 2, max_days: 3 },
{ pincode: 508247, min_days: 2, max_days: 3 },
{ pincode: 508248, min_days: 2, max_days: 3 },
{ pincode: 508250, min_days: 2, max_days: 3 },
{ pincode: 508252, min_days: 2, max_days: 3 },
{ pincode: 508253, min_days: 2, max_days: 3 },
{ pincode: 508254, min_days: 2, max_days: 3 },
{ pincode: 508255, min_days: 2, max_days: 3 },
{ pincode: 508256, min_days: 2, max_days: 3 },
{ pincode: 508257, min_days: 2, max_days: 3 },
{ pincode: 508258, min_days: 2, max_days: 3 },
{ pincode: 508266, min_days: 2, max_days: 3 },
{ pincode: 508277, min_days: 2, max_days: 3 },
{ pincode: 508278, min_days: 2, max_days: 3 },
{ pincode: 508279, min_days: 2, max_days: 3 },
{ pincode: 508280, min_days: 2, max_days: 3 },
{ pincode: 508284, min_days: 2, max_days: 3 },
{ pincode: 508285, min_days: 2, max_days: 3 },
{ pincode: 508286, min_days: 2, max_days: 3 },
{ pincode: 508287, min_days: 2, max_days: 3 },
{ pincode: 508355, min_days: 2, max_days: 3 },
{ pincode: 508373, min_days: 2, max_days: 3 },
{ pincode: 508374, min_days: 2, max_days: 3 },
{ pincode: 508376, min_days: 2, max_days: 3 },
{ pincode: 508377, min_days: 2, max_days: 3 },
{ pincode: 509001, min_days: 2, max_days: 3 },
{ pincode: 509002, min_days: 2, max_days: 3 },
{ pincode: 509102, min_days: 2, max_days: 3 },
{ pincode: 509103, min_days: 2, max_days: 3 },
{ pincode: 509104, min_days: 2, max_days: 3 },
{ pincode: 509105, min_days: 2, max_days: 3 },
{ pincode: 509106, min_days: 2, max_days: 3 },
{ pincode: 509110, min_days: 2, max_days: 3 },
{ pincode: 509120, min_days: 2, max_days: 3 },
{ pincode: 509125, min_days: 2, max_days: 3 },
{ pincode: 509126, min_days: 2, max_days: 3 },
{ pincode: 509127, min_days: 2, max_days: 3 },
{ pincode: 509128, min_days: 2, max_days: 3 },
{ pincode: 509129, min_days: 2, max_days: 3 },
{ pincode: 509130, min_days: 2, max_days: 3 },
{ pincode: 509131, min_days: 2, max_days: 3 },
{ pincode: 509132, min_days: 2, max_days: 3 },
{ pincode: 509133, min_days: 2, max_days: 3 },
{ pincode: 509135, min_days: 2, max_days: 3 },
{ pincode: 509136, min_days: 2, max_days: 3 },
{ pincode: 509152, min_days: 2, max_days: 3 },
{ pincode: 509153, min_days: 2, max_days: 3 },
{ pincode: 509201, min_days: 2, max_days: 3 },
{ pincode: 509202, min_days: 2, max_days: 3 },
{ pincode: 509203, min_days: 2, max_days: 3 },
{ pincode: 509204, min_days: 2, max_days: 3 },
{ pincode: 509205, min_days: 2, max_days: 3 },
{ pincode: 509206, min_days: 2, max_days: 3 },
{ pincode: 509207, min_days: 2, max_days: 3 },
{ pincode: 509208, min_days: 2, max_days: 3 },
{ pincode: 509209, min_days: 2, max_days: 3 },
{ pincode: 509210, min_days: 2, max_days: 3 },
{ pincode: 509215, min_days: 2, max_days: 3 },
{ pincode: 509216, min_days: 2, max_days: 3 },
{ pincode: 509217, min_days: 2, max_days: 3 },
{ pincode: 509218, min_days: 2, max_days: 3 },
{ pincode: 509219, min_days: 2, max_days: 3 },
{ pincode: 509223, min_days: 2, max_days: 3 },
{ pincode: 509228, min_days: 2, max_days: 3 },
{ pincode: 509235, min_days: 2, max_days: 3 },
{ pincode: 509301, min_days: 2, max_days: 3 },
{ pincode: 509302, min_days: 2, max_days: 3 },
{ pincode: 509311, min_days: 2, max_days: 3 },
{ pincode: 509320, min_days: 2, max_days: 3 },
{ pincode: 509321, min_days: 2, max_days: 3 },
{ pincode: 509324, min_days: 2, max_days: 3 },
{ pincode: 509325, min_days: 2, max_days: 3 },
{ pincode: 509326, min_days: 2, max_days: 3 },
{ pincode: 509327, min_days: 2, max_days: 3 },
{ pincode: 509334, min_days: 2, max_days: 3 },
{ pincode: 509335, min_days: 2, max_days: 3 },
{ pincode: 509336, min_days: 2, max_days: 3 },
{ pincode: 509337, min_days: 2, max_days: 3 },
{ pincode: 509338, min_days: 2, max_days: 3 },
{ pincode: 509339, min_days: 2, max_days: 3 },
{ pincode: 509340, min_days: 2, max_days: 3 },
{ pincode: 509347, min_days: 2, max_days: 3 },
{ pincode: 509349, min_days: 2, max_days: 3 },
{ pincode: 509350, min_days: 2, max_days: 3 },
{ pincode: 509351, min_days: 2, max_days: 3 },
{ pincode: 509352, min_days: 2, max_days: 3 },
{ pincode: 509353, min_days: 2, max_days: 3 },
{ pincode: 509357, min_days: 2, max_days: 3 },
{ pincode: 509358, min_days: 2, max_days: 3 },
{ pincode: 509360, min_days: 2, max_days: 3 },
{ pincode: 509371, min_days: 2, max_days: 3 },
{ pincode: 509375, min_days: 2, max_days: 3 },
{ pincode: 509376, min_days: 2, max_days: 3 },
{ pincode: 509380, min_days: 2, max_days: 3 },
{ pincode: 509381, min_days: 2, max_days: 3 },
{ pincode: 509382, min_days: 2, max_days: 3 },
{ pincode: 509385, min_days: 2, max_days: 3 },
{ pincode: 509401, min_days: 2, max_days: 3 },
{ pincode: 509406, min_days: 2, max_days: 3 },
{ pincode: 509407, min_days: 2, max_days: 3 },
{ pincode: 509408, min_days: 2, max_days: 3 },
{ pincode: 509409, min_days: 2, max_days: 3 },
{ pincode: 509410, min_days: 2, max_days: 3 },
{ pincode: 509411, min_days: 2, max_days: 3 },
{ pincode: 509412, min_days: 2, max_days: 3 },
{ pincode: 510510, min_days: 2, max_days: 3 },
{ pincode: 512200, min_days: 2, max_days: 3 },
{ pincode: 512501, min_days: 2, max_days: 3 },
{ pincode: 512503, min_days: 2, max_days: 3 },
{ pincode: 515001, min_days: 2, max_days: 3 },
{ pincode: 515002, min_days: 2, max_days: 3 },
{ pincode: 515003, min_days: 2, max_days: 3 },
{ pincode: 515004, min_days: 2, max_days: 3 },
{ pincode: 515005, min_days: 2, max_days: 3 },
{ pincode: 515101, min_days: 2, max_days: 3 },
{ pincode: 515110, min_days: 2, max_days: 3 },
{ pincode: 515122, min_days: 2, max_days: 3 },
{ pincode: 515123, min_days: 2, max_days: 3 },
{ pincode: 515124, min_days: 2, max_days: 3 },
{ pincode: 515132, min_days: 2, max_days: 3 },
{ pincode: 515133, min_days: 2, max_days: 3 },
{ pincode: 515134, min_days: 2, max_days: 3 },
{ pincode: 515144, min_days: 2, max_days: 3 },
{ pincode: 515154, min_days: 2, max_days: 3 },
{ pincode: 515159, min_days: 2, max_days: 3 },
{ pincode: 515164, min_days: 2, max_days: 3 },
{ pincode: 515201, min_days: 2, max_days: 3 },
{ pincode: 515202, min_days: 2, max_days: 3 },
{ pincode: 515211, min_days: 2, max_days: 3 },
{ pincode: 515212, min_days: 2, max_days: 3 },
{ pincode: 515213, min_days: 2, max_days: 3 },
{ pincode: 515214, min_days: 2, max_days: 3 },
{ pincode: 515231, min_days: 2, max_days: 3 },
{ pincode: 515232, min_days: 2, max_days: 3 },
{ pincode: 515233, min_days: 2, max_days: 3 },
{ pincode: 515241, min_days: 2, max_days: 3 },
{ pincode: 515261, min_days: 2, max_days: 3 },
{ pincode: 515271, min_days: 2, max_days: 3 },
{ pincode: 515281, min_days: 2, max_days: 3 },
{ pincode: 515286, min_days: 2, max_days: 3 },
{ pincode: 515291, min_days: 2, max_days: 3 },
{ pincode: 515301, min_days: 2, max_days: 3 },
{ pincode: 515303, min_days: 2, max_days: 3 },
{ pincode: 515305, min_days: 2, max_days: 3 },
{ pincode: 515306, min_days: 2, max_days: 3 },
{ pincode: 515311, min_days: 2, max_days: 3 },
{ pincode: 515321, min_days: 2, max_days: 3 },
{ pincode: 515331, min_days: 2, max_days: 3 },
{ pincode: 515341, min_days: 2, max_days: 3 },
{ pincode: 515401, min_days: 2, max_days: 3 },
{ pincode: 515402, min_days: 2, max_days: 3 },
{ pincode: 515404, min_days: 2, max_days: 3 },
{ pincode: 515405, min_days: 2, max_days: 3 },
{ pincode: 515408, min_days: 2, max_days: 3 },
{ pincode: 515411, min_days: 2, max_days: 3 },
{ pincode: 515413, min_days: 2, max_days: 3 },
{ pincode: 515414, min_days: 2, max_days: 3 },
{ pincode: 515415, min_days: 2, max_days: 3 },
{ pincode: 515416, min_days: 2, max_days: 3 },
{ pincode: 515419, min_days: 2, max_days: 3 },
{ pincode: 515421, min_days: 2, max_days: 3 },
{ pincode: 515422, min_days: 2, max_days: 3 },
{ pincode: 515425, min_days: 2, max_days: 3 },
{ pincode: 515426, min_days: 2, max_days: 3 },
{ pincode: 515427, min_days: 2, max_days: 3 },
{ pincode: 515435, min_days: 2, max_days: 3 },
{ pincode: 515445, min_days: 2, max_days: 3 },
{ pincode: 515455, min_days: 2, max_days: 3 },
{ pincode: 515456, min_days: 2, max_days: 3 },
{ pincode: 515465, min_days: 2, max_days: 3 },
{ pincode: 515501, min_days: 2, max_days: 3 },
{ pincode: 515511, min_days: 2, max_days: 3 },
{ pincode: 515521, min_days: 2, max_days: 3 },
{ pincode: 515531, min_days: 2, max_days: 3 },
{ pincode: 515541, min_days: 2, max_days: 3 },
{ pincode: 515551, min_days: 2, max_days: 3 },
{ pincode: 515556, min_days: 2, max_days: 3 },
{ pincode: 515561, min_days: 2, max_days: 3 },
{ pincode: 515571, min_days: 2, max_days: 3 },
{ pincode: 515581, min_days: 2, max_days: 3 },
{ pincode: 515591, min_days: 2, max_days: 3 },
{ pincode: 515592, min_days: 2, max_days: 3 },
{ pincode: 515601, min_days: 2, max_days: 3 },
{ pincode: 515611, min_days: 2, max_days: 3 },
{ pincode: 515621, min_days: 2, max_days: 3 },
{ pincode: 515631, min_days: 2, max_days: 3 },
{ pincode: 515641, min_days: 2, max_days: 3 },
{ pincode: 515651, min_days: 2, max_days: 3 },
{ pincode: 515661, min_days: 2, max_days: 3 },
{ pincode: 515662, min_days: 2, max_days: 3 },
{ pincode: 515671, min_days: 2, max_days: 3 },
{ pincode: 515672, min_days: 2, max_days: 3 },
{ pincode: 515701, min_days: 2, max_days: 3 },
{ pincode: 515711, min_days: 2, max_days: 3 },
{ pincode: 515721, min_days: 2, max_days: 3 },
{ pincode: 515722, min_days: 2, max_days: 3 },
{ pincode: 515731, min_days: 2, max_days: 3 },
{ pincode: 515736, min_days: 2, max_days: 3 },
{ pincode: 515741, min_days: 2, max_days: 3 },
{ pincode: 515751, min_days: 2, max_days: 3 },
{ pincode: 515752, min_days: 2, max_days: 3 },
{ pincode: 515761, min_days: 2, max_days: 3 },
{ pincode: 515762, min_days: 2, max_days: 3 },
{ pincode: 515763, min_days: 2, max_days: 3 },
{ pincode: 515765, min_days: 2, max_days: 3 },
{ pincode: 515766, min_days: 2, max_days: 3 },
{ pincode: 515767, min_days: 2, max_days: 3 },
{ pincode: 515774, min_days: 2, max_days: 3 },
{ pincode: 515775, min_days: 2, max_days: 3 },
{ pincode: 515787, min_days: 2, max_days: 3 },
{ pincode: 515801, min_days: 2, max_days: 3 },
{ pincode: 515802, min_days: 2, max_days: 3 },
{ pincode: 515803, min_days: 2, max_days: 3 },
{ pincode: 515804, min_days: 2, max_days: 3 },
{ pincode: 515809, min_days: 2, max_days: 3 },
{ pincode: 515812, min_days: 2, max_days: 3 },
{ pincode: 515813, min_days: 2, max_days: 3 },
{ pincode: 515814, min_days: 2, max_days: 3 },
{ pincode: 515822, min_days: 2, max_days: 3 },
{ pincode: 515832, min_days: 2, max_days: 3 },
{ pincode: 515833, min_days: 2, max_days: 3 },
{ pincode: 515834, min_days: 2, max_days: 3 },
{ pincode: 515835, min_days: 2, max_days: 3 },
{ pincode: 515842, min_days: 2, max_days: 3 },
{ pincode: 515843, min_days: 2, max_days: 3 },
{ pincode: 515844, min_days: 2, max_days: 3 },
{ pincode: 515862, min_days: 2, max_days: 3 },
{ pincode: 515863, min_days: 2, max_days: 3 },
{ pincode: 515865, min_days: 2, max_days: 3 },
{ pincode: 515866, min_days: 2, max_days: 3 },
{ pincode: 515867, min_days: 2, max_days: 3 },
{ pincode: 515870, min_days: 2, max_days: 3 },
{ pincode: 515871, min_days: 2, max_days: 3 },
{ pincode: 515872, min_days: 2, max_days: 3 },
{ pincode: 516001, min_days: 2, max_days: 3 },
{ pincode: 516002, min_days: 2, max_days: 3 },
{ pincode: 516003, min_days: 2, max_days: 3 },
{ pincode: 516004, min_days: 2, max_days: 3 },
{ pincode: 516005, min_days: 2, max_days: 3 },
{ pincode: 516006, min_days: 2, max_days: 3 },
{ pincode: 516101, min_days: 2, max_days: 3 },
{ pincode: 516102, min_days: 2, max_days: 3 },
{ pincode: 516103, min_days: 2, max_days: 3 },
{ pincode: 516104, min_days: 2, max_days: 3 },
{ pincode: 516105, min_days: 2, max_days: 3 },
{ pincode: 516106, min_days: 2, max_days: 3 },
{ pincode: 516107, min_days: 2, max_days: 3 },
{ pincode: 516108, min_days: 2, max_days: 3 },
{ pincode: 516110, min_days: 2, max_days: 3 },
{ pincode: 516115, min_days: 2, max_days: 3 },
{ pincode: 516116, min_days: 2, max_days: 3 },
{ pincode: 516126, min_days: 2, max_days: 3 },
{ pincode: 516127, min_days: 2, max_days: 3 },
{ pincode: 516128, min_days: 2, max_days: 3 },
{ pincode: 516129, min_days: 2, max_days: 3 },
{ pincode: 516130, min_days: 2, max_days: 3 },
{ pincode: 516131, min_days: 2, max_days: 3 },
{ pincode: 516150, min_days: 2, max_days: 3 },
{ pincode: 516151, min_days: 2, max_days: 3 },
{ pincode: 516152, min_days: 2, max_days: 3 },
{ pincode: 516153, min_days: 2, max_days: 3 },
{ pincode: 516162, min_days: 2, max_days: 3 },
{ pincode: 516163, min_days: 2, max_days: 3 },
{ pincode: 516165, min_days: 2, max_days: 3 },
{ pincode: 516166, min_days: 2, max_days: 3 },
{ pincode: 516172, min_days: 2, max_days: 3 },
{ pincode: 516173, min_days: 2, max_days: 3 },
{ pincode: 516175, min_days: 2, max_days: 3 },
{ pincode: 516193, min_days: 2, max_days: 3 },
{ pincode: 516203, min_days: 2, max_days: 3 },
{ pincode: 516213, min_days: 2, max_days: 3 },
{ pincode: 516214, min_days: 2, max_days: 3 },
{ pincode: 516215, min_days: 2, max_days: 3 },
{ pincode: 516216, min_days: 2, max_days: 3 },
{ pincode: 516217, min_days: 2, max_days: 3 },
{ pincode: 516218, min_days: 2, max_days: 3 },
{ pincode: 516223, min_days: 2, max_days: 3 },
{ pincode: 516227, min_days: 2, max_days: 3 },
{ pincode: 516228, min_days: 2, max_days: 3 },
{ pincode: 516233, min_days: 2, max_days: 3 },
{ pincode: 516237, min_days: 2, max_days: 3 },
{ pincode: 516247, min_days: 2, max_days: 3 },
{ pincode: 516257, min_days: 2, max_days: 3 },
{ pincode: 516259, min_days: 2, max_days: 3 },
{ pincode: 516267, min_days: 2, max_days: 3 },
{ pincode: 516268, min_days: 2, max_days: 3 },
{ pincode: 516269, min_days: 2, max_days: 3 },
{ pincode: 516270, min_days: 2, max_days: 3 },
{ pincode: 516271, min_days: 2, max_days: 3 },
{ pincode: 516272, min_days: 2, max_days: 3 },
{ pincode: 516289, min_days: 2, max_days: 3 },
{ pincode: 516293, min_days: 2, max_days: 3 },
{ pincode: 516297, min_days: 2, max_days: 3 },
{ pincode: 516309, min_days: 2, max_days: 3 },
{ pincode: 516310, min_days: 2, max_days: 3 },
{ pincode: 516311, min_days: 2, max_days: 3 },
{ pincode: 516312, min_days: 2, max_days: 3 },
{ pincode: 516319, min_days: 2, max_days: 3 },
{ pincode: 516321, min_days: 2, max_days: 3 },
{ pincode: 516326, min_days: 2, max_days: 3 },
{ pincode: 516329, min_days: 2, max_days: 3 },
{ pincode: 516330, min_days: 2, max_days: 3 },
{ pincode: 516339, min_days: 2, max_days: 3 },
{ pincode: 516349, min_days: 2, max_days: 3 },
{ pincode: 516350, min_days: 2, max_days: 3 },
{ pincode: 516355, min_days: 2, max_days: 3 },
{ pincode: 516356, min_days: 2, max_days: 3 },
{ pincode: 516359, min_days: 2, max_days: 3 },
{ pincode: 516360, min_days: 2, max_days: 3 },
{ pincode: 516361, min_days: 2, max_days: 3 },
{ pincode: 516362, min_days: 2, max_days: 3 },
{ pincode: 516380, min_days: 2, max_days: 3 },
{ pincode: 516390, min_days: 2, max_days: 3 },
{ pincode: 516391, min_days: 2, max_days: 3 },
{ pincode: 516396, min_days: 2, max_days: 3 },
{ pincode: 516401, min_days: 2, max_days: 3 },
{ pincode: 516411, min_days: 2, max_days: 3 },
{ pincode: 516421, min_days: 2, max_days: 3 },
{ pincode: 516431, min_days: 2, max_days: 3 },
{ pincode: 516432, min_days: 2, max_days: 3 },
{ pincode: 516433, min_days: 2, max_days: 3 },
{ pincode: 516434, min_days: 2, max_days: 3 },
{ pincode: 516437, min_days: 2, max_days: 3 },
{ pincode: 516439, min_days: 2, max_days: 3 },
{ pincode: 516441, min_days: 2, max_days: 3 },
{ pincode: 516444, min_days: 2, max_days: 3 },
{ pincode: 516454, min_days: 2, max_days: 3 },
{ pincode: 516464, min_days: 2, max_days: 3 },
{ pincode: 516474, min_days: 2, max_days: 3 },
{ pincode: 516484, min_days: 2, max_days: 3 },
{ pincode: 516501, min_days: 2, max_days: 3 },
{ pincode: 516502, min_days: 2, max_days: 3 },
{ pincode: 516503, min_days: 2, max_days: 3 },
{ pincode: 516504, min_days: 2, max_days: 3 },
{ pincode: 516505, min_days: 2, max_days: 3 },
{ pincode: 516506, min_days: 2, max_days: 3 },
{ pincode: 517001, min_days: 2, max_days: 3 },
{ pincode: 517002, min_days: 2, max_days: 3 },
{ pincode: 517003, min_days: 2, max_days: 3 },
{ pincode: 517004, min_days: 2, max_days: 3 },
{ pincode: 517101, min_days: 2, max_days: 3 },
{ pincode: 517102, min_days: 2, max_days: 3 },
{ pincode: 517112, min_days: 2, max_days: 3 },
{ pincode: 517113, min_days: 2, max_days: 3 },
{ pincode: 517123, min_days: 2, max_days: 3 },
{ pincode: 517124, min_days: 2, max_days: 3 },
{ pincode: 517125, min_days: 2, max_days: 3 },
{ pincode: 517126, min_days: 2, max_days: 3 },
{ pincode: 517127, min_days: 2, max_days: 3 },
{ pincode: 517128, min_days: 2, max_days: 3 },
{ pincode: 517129, min_days: 2, max_days: 3 },
{ pincode: 517130, min_days: 2, max_days: 3 },
{ pincode: 517131, min_days: 2, max_days: 3 },
{ pincode: 517132, min_days: 2, max_days: 3 },
{ pincode: 517139, min_days: 2, max_days: 3 },
{ pincode: 517143, min_days: 2, max_days: 3 },
{ pincode: 517152, min_days: 2, max_days: 3 },
{ pincode: 517167, min_days: 2, max_days: 3 },
{ pincode: 517172, min_days: 2, max_days: 3 },
{ pincode: 517192, min_days: 2, max_days: 3 },
{ pincode: 517193, min_days: 2, max_days: 3 },
{ pincode: 517194, min_days: 2, max_days: 3 },
{ pincode: 517213, min_days: 2, max_days: 3 },
{ pincode: 517214, min_days: 2, max_days: 3 },
{ pincode: 517234, min_days: 2, max_days: 3 },
{ pincode: 517235, min_days: 2, max_days: 3 },
{ pincode: 517236, min_days: 2, max_days: 3 },
{ pincode: 517237, min_days: 2, max_days: 3 },
{ pincode: 517247, min_days: 2, max_days: 3 },
{ pincode: 517257, min_days: 2, max_days: 3 },
{ pincode: 517277, min_days: 2, max_days: 3 },
{ pincode: 517280, min_days: 2, max_days: 3 },
{ pincode: 517291, min_days: 2, max_days: 3 },
{ pincode: 517292, min_days: 2, max_days: 3 },
{ pincode: 517297, min_days: 2, max_days: 3 },
{ pincode: 517299, min_days: 2, max_days: 3 },
{ pincode: 517305, min_days: 2, max_days: 3 },
{ pincode: 517319, min_days: 2, max_days: 3 },
{ pincode: 517325, min_days: 2, max_days: 3 },
{ pincode: 517326, min_days: 2, max_days: 3 },
{ pincode: 517327, min_days: 2, max_days: 3 },
{ pincode: 517330, min_days: 2, max_days: 3 },
{ pincode: 517350, min_days: 2, max_days: 3 },
{ pincode: 517351, min_days: 2, max_days: 3 },
{ pincode: 517352, min_days: 2, max_days: 3 },
{ pincode: 517370, min_days: 2, max_days: 3 },
{ pincode: 517390, min_days: 2, max_days: 3 },
{ pincode: 517391, min_days: 2, max_days: 3 },
{ pincode: 517401, min_days: 2, max_days: 3 },
{ pincode: 517403, min_days: 2, max_days: 3 },
{ pincode: 517408, min_days: 2, max_days: 3 },
{ pincode: 517414, min_days: 2, max_days: 3 },
{ pincode: 517415, min_days: 2, max_days: 3 },
{ pincode: 517416, min_days: 2, max_days: 3 },
{ pincode: 517417, min_days: 2, max_days: 3 },
{ pincode: 517418, min_days: 2, max_days: 3 },
{ pincode: 517419, min_days: 2, max_days: 3 },
{ pincode: 517421, min_days: 2, max_days: 3 },
{ pincode: 517422, min_days: 2, max_days: 3 },
{ pincode: 517423, min_days: 2, max_days: 3 },
{ pincode: 517424, min_days: 2, max_days: 3 },
{ pincode: 517425, min_days: 2, max_days: 3 },
{ pincode: 517426, min_days: 2, max_days: 3 },
{ pincode: 517429, min_days: 2, max_days: 3 },
{ pincode: 517432, min_days: 2, max_days: 3 },
{ pincode: 517501, min_days: 2, max_days: 3 },
{ pincode: 517502, min_days: 2, max_days: 3 },
{ pincode: 517503, min_days: 2, max_days: 3 },
{ pincode: 517504, min_days: 2, max_days: 3 },
{ pincode: 517505, min_days: 2, max_days: 3 },
{ pincode: 517506, min_days: 2, max_days: 3 },
{ pincode: 517507, min_days: 2, max_days: 3 },
{ pincode: 517508, min_days: 2, max_days: 3 },
{ pincode: 517520, min_days: 2, max_days: 3 },
{ pincode: 517526, min_days: 2, max_days: 3 },
{ pincode: 517536, min_days: 2, max_days: 3 },
{ pincode: 517541, min_days: 2, max_days: 3 },
{ pincode: 517551, min_days: 2, max_days: 3 },
{ pincode: 517561, min_days: 2, max_days: 3 },
{ pincode: 517563, min_days: 2, max_days: 3 },
{ pincode: 517569, min_days: 2, max_days: 3 },
{ pincode: 517571, min_days: 2, max_days: 3 },
{ pincode: 517581, min_days: 2, max_days: 3 },
{ pincode: 517582, min_days: 2, max_days: 3 },
{ pincode: 517583, min_days: 2, max_days: 3 },
{ pincode: 517584, min_days: 2, max_days: 3 },
{ pincode: 517585, min_days: 2, max_days: 3 },
{ pincode: 517586, min_days: 2, max_days: 3 },
{ pincode: 517587, min_days: 2, max_days: 3 },
{ pincode: 517588, min_days: 2, max_days: 3 },
{ pincode: 517589, min_days: 2, max_days: 3 },
{ pincode: 517590, min_days: 2, max_days: 3 },
{ pincode: 517591, min_days: 2, max_days: 3 },
{ pincode: 517592, min_days: 2, max_days: 3 },
{ pincode: 517599, min_days: 2, max_days: 3 },
{ pincode: 517619, min_days: 2, max_days: 3 },
{ pincode: 517620, min_days: 2, max_days: 3 },
{ pincode: 517621, min_days: 2, max_days: 3 },
{ pincode: 517640, min_days: 2, max_days: 3 },
{ pincode: 517641, min_days: 2, max_days: 3 },
{ pincode: 517642, min_days: 2, max_days: 3 },
{ pincode: 517643, min_days: 2, max_days: 3 },
{ pincode: 517644, min_days: 2, max_days: 3 },
{ pincode: 517645, min_days: 2, max_days: 3 },
{ pincode: 517646, min_days: 2, max_days: 3 },
{ pincode: 518001, min_days: 2, max_days: 3 },
{ pincode: 518002, min_days: 2, max_days: 3 },
{ pincode: 518003, min_days: 2, max_days: 3 },
{ pincode: 518004, min_days: 2, max_days: 3 },
{ pincode: 518005, min_days: 2, max_days: 3 },
{ pincode: 518006, min_days: 2, max_days: 3 },
{ pincode: 518007, min_days: 2, max_days: 3 },
{ pincode: 518008, min_days: 2, max_days: 3 },
{ pincode: 518010, min_days: 2, max_days: 3 },
{ pincode: 518011, min_days: 2, max_days: 3 },
{ pincode: 518015, min_days: 2, max_days: 3 },
{ pincode: 518016, min_days: 2, max_days: 3 },
{ pincode: 518017, min_days: 2, max_days: 3 },
{ pincode: 518018, min_days: 2, max_days: 3 },
{ pincode: 518019, min_days: 2, max_days: 3 },
{ pincode: 518020, min_days: 2, max_days: 3 },
{ pincode: 518021, min_days: 2, max_days: 3 },
{ pincode: 518022, min_days: 2, max_days: 3 },
{ pincode: 518023, min_days: 2, max_days: 3 },
{ pincode: 518101, min_days: 2, max_days: 3 },
{ pincode: 518102, min_days: 2, max_days: 3 },
{ pincode: 518112, min_days: 2, max_days: 3 },
{ pincode: 518115, min_days: 2, max_days: 3 },
{ pincode: 518122, min_days: 2, max_days: 3 },
{ pincode: 518123, min_days: 2, max_days: 3 },
{ pincode: 518124, min_days: 2, max_days: 3 },
{ pincode: 518134, min_days: 2, max_days: 3 },
{ pincode: 518135, min_days: 2, max_days: 3 },
{ pincode: 518137, min_days: 2, max_days: 3 },
{ pincode: 518138, min_days: 2, max_days: 3 },
{ pincode: 518145, min_days: 2, max_days: 3 },
{ pincode: 518150, min_days: 2, max_days: 3 },
{ pincode: 518155, min_days: 2, max_days: 3 },
{ pincode: 518165, min_days: 2, max_days: 3 },
{ pincode: 518166, min_days: 2, max_days: 3 },
{ pincode: 518176, min_days: 2, max_days: 3 },
{ pincode: 518186, min_days: 2, max_days: 3 },
{ pincode: 518196, min_days: 2, max_days: 3 },
{ pincode: 518206, min_days: 2, max_days: 3 },
{ pincode: 518216, min_days: 2, max_days: 3 },
{ pincode: 518217, min_days: 2, max_days: 3 },
{ pincode: 518218, min_days: 2, max_days: 3 },
{ pincode: 518220, min_days: 2, max_days: 3 },
{ pincode: 518221, min_days: 2, max_days: 3 },
{ pincode: 518222, min_days: 2, max_days: 3 },
{ pincode: 518225, min_days: 2, max_days: 3 },
{ pincode: 518301, min_days: 2, max_days: 3 },
{ pincode: 518302, min_days: 2, max_days: 3 },
{ pincode: 518308, min_days: 2, max_days: 3 },
{ pincode: 518313, min_days: 2, max_days: 3 },
{ pincode: 518323, min_days: 2, max_days: 3 },
{ pincode: 518333, min_days: 2, max_days: 3 },
{ pincode: 518343, min_days: 2, max_days: 3 },
{ pincode: 518344, min_days: 2, max_days: 3 },
{ pincode: 518345, min_days: 2, max_days: 3 },
{ pincode: 518346, min_days: 2, max_days: 3 },
{ pincode: 518347, min_days: 2, max_days: 3 },
{ pincode: 518348, min_days: 2, max_days: 3 },
{ pincode: 518349, min_days: 2, max_days: 3 },
{ pincode: 518350, min_days: 2, max_days: 3 },
{ pincode: 518360, min_days: 2, max_days: 3 },
{ pincode: 518380, min_days: 2, max_days: 3 },
{ pincode: 518382, min_days: 2, max_days: 3 },
{ pincode: 518385, min_days: 2, max_days: 3 },
{ pincode: 518390, min_days: 2, max_days: 3 },
{ pincode: 518395, min_days: 2, max_days: 3 },
{ pincode: 518396, min_days: 2, max_days: 3 },
{ pincode: 518397, min_days: 2, max_days: 3 },
{ pincode: 518401, min_days: 2, max_days: 3 },
{ pincode: 518405, min_days: 2, max_days: 3 },
{ pincode: 518411, min_days: 2, max_days: 3 },
{ pincode: 518412, min_days: 2, max_days: 3 },
{ pincode: 518422, min_days: 2, max_days: 3 },
{ pincode: 518426, min_days: 2, max_days: 3 },
{ pincode: 518432, min_days: 2, max_days: 3 },
{ pincode: 518442, min_days: 2, max_days: 3 },
{ pincode: 518452, min_days: 2, max_days: 3 },
{ pincode: 518462, min_days: 2, max_days: 3 },
{ pincode: 518463, min_days: 2, max_days: 3 },
{ pincode: 518464, min_days: 2, max_days: 3 },
{ pincode: 518465, min_days: 2, max_days: 3 },
{ pincode: 518466, min_days: 2, max_days: 3 },
{ pincode: 518467, min_days: 2, max_days: 3 },
{ pincode: 518468, min_days: 2, max_days: 3 },
{ pincode: 518501, min_days: 2, max_days: 3 },
{ pincode: 518502, min_days: 2, max_days: 3 },
{ pincode: 518503, min_days: 2, max_days: 3 },
{ pincode: 518508, min_days: 2, max_days: 3 },
{ pincode: 518510, min_days: 2, max_days: 3 },
{ pincode: 518511, min_days: 2, max_days: 3 },
{ pincode: 518512, min_days: 2, max_days: 3 },
{ pincode: 518513, min_days: 2, max_days: 3 },
{ pincode: 518515, min_days: 2, max_days: 3 },
{ pincode: 518523, min_days: 2, max_days: 3 },
{ pincode: 518533, min_days: 2, max_days: 3 },
{ pincode: 518543, min_days: 2, max_days: 3 },
{ pincode: 518550, min_days: 2, max_days: 3 },
{ pincode: 518553, min_days: 2, max_days: 3 },
{ pincode: 518555, min_days: 2, max_days: 3 },
{ pincode: 518563, min_days: 2, max_days: 3 },
{ pincode: 518573, min_days: 2, max_days: 3 },
{ pincode: 518583, min_days: 2, max_days: 3 },
{ pincode: 518593, min_days: 2, max_days: 3 },
{ pincode: 518594, min_days: 2, max_days: 3 },
{ pincode: 518598, min_days: 2, max_days: 3 },
{ pincode: 518599, min_days: 2, max_days: 3 },
{ pincode: 518674, min_days: 2, max_days: 3 },
{ pincode: 518675, min_days: 2, max_days: 3 },
{ pincode: 520001, min_days: 2, max_days: 3 },
{ pincode: 520002, min_days: 2, max_days: 3 },
{ pincode: 520003, min_days: 2, max_days: 3 },
{ pincode: 520004, min_days: 2, max_days: 3 },
{ pincode: 520005, min_days: 2, max_days: 3 },
{ pincode: 520006, min_days: 2, max_days: 3 },
{ pincode: 520007, min_days: 2, max_days: 3 },
{ pincode: 520008, min_days: 2, max_days: 3 },
{ pincode: 520009, min_days: 2, max_days: 3 },
{ pincode: 520010, min_days: 2, max_days: 3 },
{ pincode: 520011, min_days: 2, max_days: 3 },
{ pincode: 520012, min_days: 2, max_days: 3 },
{ pincode: 520013, min_days: 2, max_days: 3 },
{ pincode: 520014, min_days: 2, max_days: 3 },
{ pincode: 520015, min_days: 2, max_days: 3 },
{ pincode: 520016, min_days: 2, max_days: 3 },
{ pincode: 520040, min_days: 2, max_days: 3 },
{ pincode: 520307, min_days: 2, max_days: 3 },
{ pincode: 521001, min_days: 2, max_days: 3 },
{ pincode: 521002, min_days: 2, max_days: 3 },
{ pincode: 521003, min_days: 2, max_days: 3 },
{ pincode: 521004, min_days: 2, max_days: 3 },
{ pincode: 521035, min_days: 2, max_days: 3 },
{ pincode: 521101, min_days: 2, max_days: 3 },
{ pincode: 521102, min_days: 2, max_days: 3 },
{ pincode: 521103, min_days: 2, max_days: 3 },
{ pincode: 521104, min_days: 2, max_days: 3 },
{ pincode: 521105, min_days: 2, max_days: 3 },
{ pincode: 521106, min_days: 2, max_days: 3 },
{ pincode: 521107, min_days: 2, max_days: 3 },
{ pincode: 521108, min_days: 2, max_days: 3 },
{ pincode: 521109, min_days: 2, max_days: 3 },
{ pincode: 521110, min_days: 2, max_days: 3 },
{ pincode: 521111, min_days: 2, max_days: 3 },
{ pincode: 521112, min_days: 2, max_days: 3 },
{ pincode: 521117, min_days: 2, max_days: 3 },
{ pincode: 521120, min_days: 2, max_days: 3 },
{ pincode: 521121, min_days: 2, max_days: 3 },
{ pincode: 521122, min_days: 2, max_days: 3 },
{ pincode: 521123, min_days: 2, max_days: 3 },
{ pincode: 521124, min_days: 2, max_days: 3 },
{ pincode: 521125, min_days: 2, max_days: 3 },
{ pincode: 521126, min_days: 2, max_days: 3 },
{ pincode: 521129, min_days: 2, max_days: 3 },
{ pincode: 521130, min_days: 2, max_days: 3 },
{ pincode: 521131, min_days: 2, max_days: 3 },
{ pincode: 521132, min_days: 2, max_days: 3 },
{ pincode: 521133, min_days: 2, max_days: 3 },
{ pincode: 521134, min_days: 2, max_days: 3 },
{ pincode: 521135, min_days: 2, max_days: 3 },
{ pincode: 521136, min_days: 2, max_days: 3 },
{ pincode: 521137, min_days: 2, max_days: 3 },
{ pincode: 521138, min_days: 2, max_days: 3 },
{ pincode: 521139, min_days: 2, max_days: 3 },
{ pincode: 521144, min_days: 2, max_days: 3 },
{ pincode: 521148, min_days: 2, max_days: 3 },
{ pincode: 521149, min_days: 2, max_days: 3 },
{ pincode: 521150, min_days: 2, max_days: 3 },
{ pincode: 521151, min_days: 2, max_days: 3 },
{ pincode: 521153, min_days: 2, max_days: 3 },
{ pincode: 521155, min_days: 2, max_days: 3 },
{ pincode: 521156, min_days: 2, max_days: 3 },
{ pincode: 521157, min_days: 2, max_days: 3 },
{ pincode: 521158, min_days: 2, max_days: 3 },
{ pincode: 521162, min_days: 2, max_days: 3 },
{ pincode: 521163, min_days: 2, max_days: 3 },
{ pincode: 521164, min_days: 2, max_days: 3 },
{ pincode: 521165, min_days: 2, max_days: 3 },
{ pincode: 521169, min_days: 2, max_days: 3 },
{ pincode: 521170, min_days: 2, max_days: 3 },
{ pincode: 521175, min_days: 2, max_days: 3 },
{ pincode: 521176, min_days: 2, max_days: 3 },
{ pincode: 521178, min_days: 2, max_days: 3 },
{ pincode: 521179, min_days: 2, max_days: 3 },
{ pincode: 521180, min_days: 2, max_days: 3 },
{ pincode: 521181, min_days: 2, max_days: 3 },
{ pincode: 521182, min_days: 2, max_days: 3 },
{ pincode: 521183, min_days: 2, max_days: 3 },
{ pincode: 521184, min_days: 2, max_days: 3 },
{ pincode: 521185, min_days: 2, max_days: 3 },
{ pincode: 521190, min_days: 2, max_days: 3 },
{ pincode: 521201, min_days: 2, max_days: 3 },
{ pincode: 521202, min_days: 2, max_days: 3 },
{ pincode: 521207, min_days: 2, max_days: 3 },
{ pincode: 521211, min_days: 2, max_days: 3 },
{ pincode: 521212, min_days: 2, max_days: 3 },
{ pincode: 521213, min_days: 2, max_days: 3 },
{ pincode: 521214, min_days: 2, max_days: 3 },
{ pincode: 521215, min_days: 2, max_days: 3 },
{ pincode: 521224, min_days: 2, max_days: 3 },
{ pincode: 521225, min_days: 2, max_days: 3 },
{ pincode: 521226, min_days: 2, max_days: 3 },
{ pincode: 521227, min_days: 2, max_days: 3 },
{ pincode: 521228, min_days: 2, max_days: 3 },
{ pincode: 521229, min_days: 2, max_days: 3 },
{ pincode: 521230, min_days: 2, max_days: 3 },
{ pincode: 521231, min_days: 2, max_days: 3 },
{ pincode: 521235, min_days: 2, max_days: 3 },
{ pincode: 521241, min_days: 2, max_days: 3 },
{ pincode: 521245, min_days: 2, max_days: 3 },
{ pincode: 521246, min_days: 2, max_days: 3 },
{ pincode: 521247, min_days: 2, max_days: 3 },
{ pincode: 521250, min_days: 2, max_days: 3 },
{ pincode: 521255, min_days: 2, max_days: 3 },
{ pincode: 521256, min_days: 2, max_days: 3 },
{ pincode: 521260, min_days: 2, max_days: 3 },
{ pincode: 521261, min_days: 2, max_days: 3 },
{ pincode: 521263, min_days: 2, max_days: 3 },
{ pincode: 521265, min_days: 2, max_days: 3 },
{ pincode: 521286, min_days: 2, max_days: 3 },
{ pincode: 521301, min_days: 2, max_days: 3 },
{ pincode: 521311, min_days: 2, max_days: 3 },
{ pincode: 521312, min_days: 2, max_days: 3 },
{ pincode: 521320, min_days: 2, max_days: 3 },
{ pincode: 521321, min_days: 2, max_days: 3 },
{ pincode: 521322, min_days: 2, max_days: 3 },
{ pincode: 521323, min_days: 2, max_days: 3 },
{ pincode: 521324, min_days: 2, max_days: 3 },
{ pincode: 521325, min_days: 2, max_days: 3 },
{ pincode: 521326, min_days: 2, max_days: 3 },
{ pincode: 521327, min_days: 2, max_days: 3 },
{ pincode: 521328, min_days: 2, max_days: 3 },
{ pincode: 521329, min_days: 2, max_days: 3 },
{ pincode: 521330, min_days: 2, max_days: 3 },
{ pincode: 521331, min_days: 2, max_days: 3 },
{ pincode: 521332, min_days: 2, max_days: 3 },
{ pincode: 521333, min_days: 2, max_days: 3 },
{ pincode: 521338, min_days: 2, max_days: 3 },
{ pincode: 521340, min_days: 2, max_days: 3 },
{ pincode: 521343, min_days: 2, max_days: 3 },
{ pincode: 521344, min_days: 2, max_days: 3 },
{ pincode: 521345, min_days: 2, max_days: 3 },
{ pincode: 521356, min_days: 2, max_days: 3 },
{ pincode: 521366, min_days: 2, max_days: 3 },
{ pincode: 521369, min_days: 2, max_days: 3 },
{ pincode: 521370, min_days: 2, max_days: 3 },
{ pincode: 521390, min_days: 2, max_days: 3 },
{ pincode: 521391, min_days: 2, max_days: 3 },
{ pincode: 521401, min_days: 2, max_days: 3 },
{ pincode: 521402, min_days: 2, max_days: 3 },
{ pincode: 521403, min_days: 2, max_days: 3 },
{ pincode: 521436, min_days: 2, max_days: 3 },
{ pincode: 521456, min_days: 2, max_days: 3 },
{ pincode: 521457, min_days: 2, max_days: 3 },
{ pincode: 522001, min_days: 2, max_days: 3 },
{ pincode: 522002, min_days: 2, max_days: 3 },
{ pincode: 522003, min_days: 2, max_days: 3 },
{ pincode: 522004, min_days: 2, max_days: 3 },
{ pincode: 522005, min_days: 2, max_days: 3 },
{ pincode: 522006, min_days: 2, max_days: 3 },
{ pincode: 522007, min_days: 2, max_days: 3 },
{ pincode: 522008, min_days: 2, max_days: 3 },
{ pincode: 522009, min_days: 2, max_days: 3 },
{ pincode: 522010, min_days: 2, max_days: 3 },
{ pincode: 522013, min_days: 2, max_days: 3 },
{ pincode: 522015, min_days: 2, max_days: 3 },
{ pincode: 522016, min_days: 2, max_days: 3 },
{ pincode: 522017, min_days: 2, max_days: 3 },
{ pincode: 522018, min_days: 2, max_days: 3 },
{ pincode: 522019, min_days: 2, max_days: 3 },
{ pincode: 522020, min_days: 2, max_days: 3 },
{ pincode: 522022, min_days: 2, max_days: 3 },
{ pincode: 522024, min_days: 2, max_days: 3 },
{ pincode: 522026, min_days: 2, max_days: 3 },
{ pincode: 522034, min_days: 2, max_days: 3 },
{ pincode: 522035, min_days: 2, max_days: 3 },
{ pincode: 522036, min_days: 2, max_days: 3 },
{ pincode: 522050, min_days: 2, max_days: 3 },
{ pincode: 522101, min_days: 2, max_days: 3 },
{ pincode: 522102, min_days: 2, max_days: 3 },
{ pincode: 522111, min_days: 2, max_days: 3 },
{ pincode: 522112, min_days: 2, max_days: 3 },
{ pincode: 522113, min_days: 2, max_days: 3 },
{ pincode: 522116, min_days: 2, max_days: 3 },
{ pincode: 522123, min_days: 2, max_days: 3 },
{ pincode: 522124, min_days: 2, max_days: 3 },
{ pincode: 522125, min_days: 2, max_days: 3 },
{ pincode: 522180, min_days: 2, max_days: 3 },
{ pincode: 522201, min_days: 2, max_days: 3 },
{ pincode: 522202, min_days: 2, max_days: 3 },
{ pincode: 522203, min_days: 2, max_days: 3 },
{ pincode: 522211, min_days: 2, max_days: 3 },
{ pincode: 522212, min_days: 2, max_days: 3 },
{ pincode: 522213, min_days: 2, max_days: 3 },
{ pincode: 522233, min_days: 2, max_days: 3 },
{ pincode: 522234, min_days: 2, max_days: 3 },
{ pincode: 522235, min_days: 2, max_days: 3 },
{ pincode: 522236, min_days: 2, max_days: 3 },
{ pincode: 522237, min_days: 2, max_days: 3 },
{ pincode: 522238, min_days: 2, max_days: 3 },
{ pincode: 522239, min_days: 2, max_days: 3 },
{ pincode: 522240, min_days: 2, max_days: 3 },
{ pincode: 522256, min_days: 2, max_days: 3 },
{ pincode: 522257, min_days: 2, max_days: 3 },
{ pincode: 522258, min_days: 2, max_days: 3 },
{ pincode: 522259, min_days: 2, max_days: 3 },
{ pincode: 522261, min_days: 2, max_days: 3 },
{ pincode: 522262, min_days: 2, max_days: 3 },
{ pincode: 522263, min_days: 2, max_days: 3 },
{ pincode: 522264, min_days: 2, max_days: 3 },
{ pincode: 522265, min_days: 2, max_days: 3 },
{ pincode: 522267, min_days: 2, max_days: 3 },
{ pincode: 522268, min_days: 2, max_days: 3 },
{ pincode: 522274, min_days: 2, max_days: 3 },
{ pincode: 522278, min_days: 2, max_days: 3 },
{ pincode: 522279, min_days: 2, max_days: 3 },
{ pincode: 522280, min_days: 2, max_days: 3 },
{ pincode: 522282, min_days: 2, max_days: 3 },
{ pincode: 522294, min_days: 2, max_days: 3 },
{ pincode: 522297, min_days: 2, max_days: 3 },
{ pincode: 522298, min_days: 2, max_days: 3 },
{ pincode: 522301, min_days: 2, max_days: 3 },
{ pincode: 522302, min_days: 2, max_days: 3 },
{ pincode: 522303, min_days: 2, max_days: 3 },
{ pincode: 522304, min_days: 2, max_days: 3 },
{ pincode: 522305, min_days: 2, max_days: 3 },
{ pincode: 522306, min_days: 2, max_days: 3 },
{ pincode: 522307, min_days: 2, max_days: 3 },
{ pincode: 522308, min_days: 2, max_days: 3 },
{ pincode: 522309, min_days: 2, max_days: 3 },
{ pincode: 522310, min_days: 2, max_days: 3 },
{ pincode: 522311, min_days: 2, max_days: 3 },
{ pincode: 522312, min_days: 2, max_days: 3 },
{ pincode: 522313, min_days: 2, max_days: 3 },
{ pincode: 522314, min_days: 2, max_days: 3 },
{ pincode: 522315, min_days: 2, max_days: 3 },
{ pincode: 522316, min_days: 2, max_days: 3 },
{ pincode: 522317, min_days: 2, max_days: 3 },
{ pincode: 522318, min_days: 2, max_days: 3 },
{ pincode: 522321, min_days: 2, max_days: 3 },
{ pincode: 522324, min_days: 2, max_days: 3 },
{ pincode: 522325, min_days: 2, max_days: 3 },
{ pincode: 522329, min_days: 2, max_days: 3 },
{ pincode: 522330, min_days: 2, max_days: 3 },
{ pincode: 522332, min_days: 2, max_days: 3 },
{ pincode: 522341, min_days: 2, max_days: 3 },
{ pincode: 522354, min_days: 2, max_days: 3 },
{ pincode: 522401, min_days: 2, max_days: 3 },
{ pincode: 522402, min_days: 2, max_days: 3 },
{ pincode: 522403, min_days: 2, max_days: 3 },
{ pincode: 522407, min_days: 2, max_days: 3 },
{ pincode: 522408, min_days: 2, max_days: 3 },
{ pincode: 522409, min_days: 2, max_days: 3 },
{ pincode: 522410, min_days: 2, max_days: 3 },
{ pincode: 522411, min_days: 2, max_days: 3 },
{ pincode: 522412, min_days: 2, max_days: 3 },
{ pincode: 522413, min_days: 2, max_days: 3 },
{ pincode: 522414, min_days: 2, max_days: 3 },
{ pincode: 522415, min_days: 2, max_days: 3 },
{ pincode: 522419, min_days: 2, max_days: 3 },
{ pincode: 522421, min_days: 2, max_days: 3 },
{ pincode: 522426, min_days: 2, max_days: 3 },
{ pincode: 522435, min_days: 2, max_days: 3 },
{ pincode: 522436, min_days: 2, max_days: 3 },
{ pincode: 522437, min_days: 2, max_days: 3 },
{ pincode: 522438, min_days: 2, max_days: 3 },
{ pincode: 522439, min_days: 2, max_days: 3 },
{ pincode: 522501, min_days: 2, max_days: 3 },
{ pincode: 522502, min_days: 2, max_days: 3 },
{ pincode: 522503, min_days: 2, max_days: 3 },
{ pincode: 522505, min_days: 2, max_days: 3 },
{ pincode: 522508, min_days: 2, max_days: 3 },
{ pincode: 522509, min_days: 2, max_days: 3 },
{ pincode: 522510, min_days: 2, max_days: 3 },
{ pincode: 522511, min_days: 2, max_days: 3 },
{ pincode: 522515, min_days: 2, max_days: 3 },
{ pincode: 522529, min_days: 2, max_days: 3 },
{ pincode: 522549, min_days: 2, max_days: 3 },
{ pincode: 522601, min_days: 2, max_days: 3 },
{ pincode: 522602, min_days: 2, max_days: 3 },
{ pincode: 522603, min_days: 2, max_days: 3 },
{ pincode: 522608, min_days: 2, max_days: 3 },
{ pincode: 522611, min_days: 2, max_days: 3 },
{ pincode: 522612, min_days: 2, max_days: 3 },
{ pincode: 522613, min_days: 2, max_days: 3 },
{ pincode: 522614, min_days: 2, max_days: 3 },
{ pincode: 522615, min_days: 2, max_days: 3 },
{ pincode: 522616, min_days: 2, max_days: 3 },
{ pincode: 522617, min_days: 2, max_days: 3 },
{ pincode: 522619, min_days: 2, max_days: 3 },
{ pincode: 522620, min_days: 2, max_days: 3 },
{ pincode: 522626, min_days: 2, max_days: 3 },
{ pincode: 522630, min_days: 2, max_days: 3 },
{ pincode: 522631, min_days: 2, max_days: 3 },
{ pincode: 522646, min_days: 2, max_days: 3 },
{ pincode: 522647, min_days: 2, max_days: 3 },
{ pincode: 522649, min_days: 2, max_days: 3 },
{ pincode: 522657, min_days: 2, max_days: 3 },
{ pincode: 522658, min_days: 2, max_days: 3 },
{ pincode: 522659, min_days: 2, max_days: 3 },
{ pincode: 522660, min_days: 2, max_days: 3 },
{ pincode: 522661, min_days: 2, max_days: 3 },
{ pincode: 522663, min_days: 2, max_days: 3 },
{ pincode: 523001, min_days: 2, max_days: 3 },
{ pincode: 523002, min_days: 2, max_days: 3 },
{ pincode: 523003, min_days: 2, max_days: 3 },
{ pincode: 523101, min_days: 2, max_days: 3 },
{ pincode: 523104, min_days: 2, max_days: 3 },
{ pincode: 523105, min_days: 2, max_days: 3 },
{ pincode: 523108, min_days: 2, max_days: 3 },
{ pincode: 523109, min_days: 2, max_days: 3 },
{ pincode: 523110, min_days: 2, max_days: 3 },
{ pincode: 523111, min_days: 2, max_days: 3 },
{ pincode: 523112, min_days: 2, max_days: 3 },
{ pincode: 523113, min_days: 2, max_days: 3 },
{ pincode: 523114, min_days: 2, max_days: 3 },
{ pincode: 523115, min_days: 2, max_days: 3 },
{ pincode: 523116, min_days: 2, max_days: 3 },
{ pincode: 523117, min_days: 2, max_days: 3 },
{ pincode: 523121, min_days: 2, max_days: 3 },
{ pincode: 523125, min_days: 2, max_days: 3 },
{ pincode: 523135, min_days: 2, max_days: 3 },
{ pincode: 523155, min_days: 2, max_days: 3 },
{ pincode: 523156, min_days: 2, max_days: 3 },
{ pincode: 523157, min_days: 2, max_days: 3 },
{ pincode: 523165, min_days: 2, max_days: 3 },
{ pincode: 523166, min_days: 2, max_days: 3 },
{ pincode: 523167, min_days: 2, max_days: 3 },
{ pincode: 523168, min_days: 2, max_days: 3 },
{ pincode: 523169, min_days: 2, max_days: 3 },
{ pincode: 523170, min_days: 2, max_days: 3 },
{ pincode: 523171, min_days: 2, max_days: 3 },
{ pincode: 523180, min_days: 2, max_days: 3 },
{ pincode: 523181, min_days: 2, max_days: 3 },
{ pincode: 523182, min_days: 2, max_days: 3 },
{ pincode: 523183, min_days: 2, max_days: 3 },
{ pincode: 523184, min_days: 2, max_days: 3 },
{ pincode: 523185, min_days: 2, max_days: 3 },
{ pincode: 523186, min_days: 2, max_days: 3 },
{ pincode: 523187, min_days: 2, max_days: 3 },
{ pincode: 523189, min_days: 2, max_days: 3 },
{ pincode: 523190, min_days: 2, max_days: 3 },
{ pincode: 523194, min_days: 2, max_days: 3 },
{ pincode: 523201, min_days: 2, max_days: 3 },
{ pincode: 523205, min_days: 2, max_days: 3 },
{ pincode: 523211, min_days: 2, max_days: 3 },
{ pincode: 523212, min_days: 2, max_days: 3 },
{ pincode: 523213, min_days: 2, max_days: 3 },
{ pincode: 523214, min_days: 2, max_days: 3 },
{ pincode: 523219, min_days: 2, max_days: 3 },
{ pincode: 523223, min_days: 2, max_days: 3 },
{ pincode: 523224, min_days: 2, max_days: 3 },
{ pincode: 523225, min_days: 2, max_days: 3 },
{ pincode: 523226, min_days: 2, max_days: 3 },
{ pincode: 523227, min_days: 2, max_days: 3 },
{ pincode: 523228, min_days: 2, max_days: 3 },
{ pincode: 523230, min_days: 2, max_days: 3 },
{ pincode: 523240, min_days: 2, max_days: 3 },
{ pincode: 523241, min_days: 2, max_days: 3 },
{ pincode: 523243, min_days: 2, max_days: 3 },
{ pincode: 523245, min_days: 2, max_days: 3 },
{ pincode: 523246, min_days: 2, max_days: 3 },
{ pincode: 523247, min_days: 2, max_days: 3 },
{ pincode: 523252, min_days: 2, max_days: 3 },
{ pincode: 523253, min_days: 2, max_days: 3 },
{ pincode: 523254, min_days: 2, max_days: 3 },
{ pincode: 523260, min_days: 2, max_days: 3 },
{ pincode: 523261, min_days: 2, max_days: 3 },
{ pincode: 523262, min_days: 2, max_days: 3 },
{ pincode: 523263, min_days: 2, max_days: 3 },
{ pincode: 523264, min_days: 2, max_days: 3 },
{ pincode: 523265, min_days: 2, max_days: 3 },
{ pincode: 523267, min_days: 2, max_days: 3 },
{ pincode: 523269, min_days: 2, max_days: 3 },
{ pincode: 523270, min_days: 2, max_days: 3 },
{ pincode: 523271, min_days: 2, max_days: 3 },
{ pincode: 523272, min_days: 2, max_days: 3 },
{ pincode: 523273, min_days: 2, max_days: 3 },
{ pincode: 523274, min_days: 2, max_days: 3 },
{ pincode: 523277, min_days: 2, max_days: 3 },
{ pincode: 523279, min_days: 2, max_days: 3 },
{ pincode: 523280, min_days: 2, max_days: 3 },
{ pincode: 523281, min_days: 2, max_days: 3 },
{ pincode: 523286, min_days: 2, max_days: 3 },
{ pincode: 523291, min_days: 2, max_days: 3 },
{ pincode: 523292, min_days: 2, max_days: 3 },
{ pincode: 523297, min_days: 2, max_days: 3 },
{ pincode: 523301, min_days: 2, max_days: 3 },
{ pincode: 523302, min_days: 2, max_days: 3 },
{ pincode: 523303, min_days: 2, max_days: 3 },
{ pincode: 523304, min_days: 2, max_days: 3 },
{ pincode: 523305, min_days: 2, max_days: 3 },
{ pincode: 523315, min_days: 2, max_days: 3 },
{ pincode: 523316, min_days: 2, max_days: 3 },
{ pincode: 523320, min_days: 2, max_days: 3 },
{ pincode: 523325, min_days: 2, max_days: 3 },
{ pincode: 523326, min_days: 2, max_days: 3 },
{ pincode: 523327, min_days: 2, max_days: 3 },
{ pincode: 523328, min_days: 2, max_days: 3 },
{ pincode: 523329, min_days: 2, max_days: 3 },
{ pincode: 523330, min_days: 2, max_days: 3 },
{ pincode: 523331, min_days: 2, max_days: 3 },
{ pincode: 523332, min_days: 2, max_days: 3 },
{ pincode: 523333, min_days: 2, max_days: 3 },
{ pincode: 523334, min_days: 2, max_days: 3 },
{ pincode: 523335, min_days: 2, max_days: 3 },
{ pincode: 523336, min_days: 2, max_days: 3 },
{ pincode: 523345, min_days: 2, max_days: 3 },
{ pincode: 523346, min_days: 2, max_days: 3 },
{ pincode: 523356, min_days: 2, max_days: 3 },
{ pincode: 523357, min_days: 2, max_days: 3 },
{ pincode: 523367, min_days: 2, max_days: 3 },
{ pincode: 523368, min_days: 2, max_days: 3 },
{ pincode: 523369, min_days: 2, max_days: 3 },
{ pincode: 523370, min_days: 2, max_days: 3 },
{ pincode: 523371, min_days: 2, max_days: 3 },
{ pincode: 523372, min_days: 2, max_days: 3 },
{ pincode: 523373, min_days: 2, max_days: 3 },
{ pincode: 523502, min_days: 2, max_days: 3 },
{ pincode: 524001, min_days: 2, max_days: 3 },
{ pincode: 524002, min_days: 2, max_days: 3 },
{ pincode: 524003, min_days: 2, max_days: 3 },
{ pincode: 524004, min_days: 2, max_days: 3 },
{ pincode: 524005, min_days: 2, max_days: 3 },
{ pincode: 524101, min_days: 2, max_days: 3 },
{ pincode: 524102, min_days: 2, max_days: 3 },
{ pincode: 524121, min_days: 2, max_days: 3 },
{ pincode: 524123, min_days: 2, max_days: 3 },
{ pincode: 524124, min_days: 2, max_days: 3 },
{ pincode: 524126, min_days: 2, max_days: 3 },
{ pincode: 524127, min_days: 2, max_days: 3 },
{ pincode: 524129, min_days: 2, max_days: 3 },
{ pincode: 524131, min_days: 2, max_days: 3 },
{ pincode: 524132, min_days: 2, max_days: 3 },
{ pincode: 524134, min_days: 2, max_days: 3 },
{ pincode: 524137, min_days: 2, max_days: 3 },
{ pincode: 524142, min_days: 2, max_days: 3 },
{ pincode: 524152, min_days: 2, max_days: 3 },
{ pincode: 524201, min_days: 2, max_days: 3 },
{ pincode: 524202, min_days: 2, max_days: 3 },
{ pincode: 524203, min_days: 2, max_days: 3 },
{ pincode: 524221, min_days: 2, max_days: 3 },
{ pincode: 524222, min_days: 2, max_days: 3 },
{ pincode: 524223, min_days: 2, max_days: 3 },
{ pincode: 524224, min_days: 2, max_days: 3 },
{ pincode: 524225, min_days: 2, max_days: 3 },
{ pincode: 524226, min_days: 2, max_days: 3 },
{ pincode: 524227, min_days: 2, max_days: 3 },
{ pincode: 524228, min_days: 2, max_days: 3 },
{ pincode: 524230, min_days: 2, max_days: 3 },
{ pincode: 524234, min_days: 2, max_days: 3 },
{ pincode: 524236, min_days: 2, max_days: 3 },
{ pincode: 524239, min_days: 2, max_days: 3 },
{ pincode: 524240, min_days: 2, max_days: 3 },
{ pincode: 524300, min_days: 2, max_days: 3 },
{ pincode: 524301, min_days: 2, max_days: 3 },
{ pincode: 524302, min_days: 2, max_days: 3 },
{ pincode: 524303, min_days: 2, max_days: 3 },
{ pincode: 524304, min_days: 2, max_days: 3 },
{ pincode: 524305, min_days: 2, max_days: 3 },
{ pincode: 524306, min_days: 2, max_days: 3 },
{ pincode: 524307, min_days: 2, max_days: 3 },
{ pincode: 524308, min_days: 2, max_days: 3 },
{ pincode: 524309, min_days: 2, max_days: 3 },
{ pincode: 524310, min_days: 2, max_days: 3 },
{ pincode: 524311, min_days: 2, max_days: 3 },
{ pincode: 524312, min_days: 2, max_days: 3 },
{ pincode: 524313, min_days: 2, max_days: 3 },
{ pincode: 524314, min_days: 2, max_days: 3 },
{ pincode: 524315, min_days: 2, max_days: 3 },
{ pincode: 524316, min_days: 2, max_days: 3 },
{ pincode: 524317, min_days: 2, max_days: 3 },
{ pincode: 524318, min_days: 2, max_days: 3 },
{ pincode: 524319, min_days: 2, max_days: 3 },
{ pincode: 524320, min_days: 2, max_days: 3 },
{ pincode: 524321, min_days: 2, max_days: 3 },
{ pincode: 524322, min_days: 2, max_days: 3 },
{ pincode: 524323, min_days: 2, max_days: 3 },
{ pincode: 524324, min_days: 2, max_days: 3 },
{ pincode: 524341, min_days: 2, max_days: 3 },
{ pincode: 524342, min_days: 2, max_days: 3 },
{ pincode: 524343, min_days: 2, max_days: 3 },
{ pincode: 524344, min_days: 2, max_days: 3 },
{ pincode: 524345, min_days: 2, max_days: 3 },
{ pincode: 524346, min_days: 2, max_days: 3 },
{ pincode: 524347, min_days: 2, max_days: 3 },
{ pincode: 524366, min_days: 2, max_days: 3 },
{ pincode: 524401, min_days: 2, max_days: 3 },
{ pincode: 524402, min_days: 2, max_days: 3 },
{ pincode: 524403, min_days: 2, max_days: 3 },
{ pincode: 524404, min_days: 2, max_days: 3 },
{ pincode: 524405, min_days: 2, max_days: 3 },
{ pincode: 524406, min_days: 2, max_days: 3 },
{ pincode: 524407, min_days: 2, max_days: 3 },
{ pincode: 524408, min_days: 2, max_days: 3 },
{ pincode: 524409, min_days: 2, max_days: 3 },
{ pincode: 524410, min_days: 2, max_days: 3 },
{ pincode: 524411, min_days: 2, max_days: 3 },
{ pincode: 524412, min_days: 2, max_days: 3 },
{ pincode: 524413, min_days: 2, max_days: 3 },
{ pincode: 524414, min_days: 2, max_days: 3 },
{ pincode: 524415, min_days: 2, max_days: 3 },
{ pincode: 524421, min_days: 2, max_days: 3 },
{ pincode: 524449, min_days: 2, max_days: 3 },
{ pincode: 530001, min_days: 2, max_days: 3 },
{ pincode: 530002, min_days: 2, max_days: 3 },
{ pincode: 530003, min_days: 2, max_days: 3 },
{ pincode: 530004, min_days: 2, max_days: 3 },
{ pincode: 530005, min_days: 2, max_days: 3 },
{ pincode: 530006, min_days: 2, max_days: 3 },
{ pincode: 530007, min_days: 2, max_days: 3 },
{ pincode: 530008, min_days: 2, max_days: 3 },
{ pincode: 530009, min_days: 2, max_days: 3 },
{ pincode: 530010, min_days: 2, max_days: 3 },
{ pincode: 530011, min_days: 2, max_days: 3 },
{ pincode: 530012, min_days: 2, max_days: 3 },
{ pincode: 530013, min_days: 2, max_days: 3 },
{ pincode: 530014, min_days: 2, max_days: 3 },
{ pincode: 530015, min_days: 2, max_days: 3 },
{ pincode: 530016, min_days: 2, max_days: 3 },
{ pincode: 530017, min_days: 2, max_days: 3 },
{ pincode: 530018, min_days: 2, max_days: 3 },
{ pincode: 530019, min_days: 2, max_days: 3 },
{ pincode: 530020, min_days: 2, max_days: 3 },
{ pincode: 530021, min_days: 2, max_days: 3 },
{ pincode: 530022, min_days: 2, max_days: 3 },
{ pincode: 530023, min_days: 2, max_days: 3 },
{ pincode: 530024, min_days: 2, max_days: 3 },
{ pincode: 530025, min_days: 2, max_days: 3 },
{ pincode: 530026, min_days: 2, max_days: 3 },
{ pincode: 530027, min_days: 2, max_days: 3 },
{ pincode: 530028, min_days: 2, max_days: 3 },
{ pincode: 530029, min_days: 2, max_days: 3 },
{ pincode: 530030, min_days: 2, max_days: 3 },
{ pincode: 530031, min_days: 2, max_days: 3 },
{ pincode: 530032, min_days: 2, max_days: 3 },
{ pincode: 530035, min_days: 2, max_days: 3 },
{ pincode: 530037, min_days: 2, max_days: 3 },
{ pincode: 530039, min_days: 2, max_days: 3 },
{ pincode: 530040, min_days: 2, max_days: 3 },
{ pincode: 530041, min_days: 2, max_days: 3 },
{ pincode: 530042, min_days: 2, max_days: 3 },
{ pincode: 530043, min_days: 2, max_days: 3 },
{ pincode: 530044, min_days: 2, max_days: 3 },
{ pincode: 530045, min_days: 2, max_days: 3 },
{ pincode: 530046, min_days: 2, max_days: 3 },
{ pincode: 530047, min_days: 2, max_days: 3 },
{ pincode: 530048, min_days: 2, max_days: 3 },
{ pincode: 530049, min_days: 2, max_days: 3 },
{ pincode: 530051, min_days: 2, max_days: 3 },
{ pincode: 530052, min_days: 2, max_days: 3 },
{ pincode: 530053, min_days: 2, max_days: 3 },
{ pincode: 530057, min_days: 2, max_days: 3 },
{ pincode: 530058, min_days: 2, max_days: 3 },
{ pincode: 531001, min_days: 2, max_days: 3 },
{ pincode: 531002, min_days: 2, max_days: 3 },
{ pincode: 531011, min_days: 2, max_days: 3 },
{ pincode: 531019, min_days: 2, max_days: 3 },
{ pincode: 531020, min_days: 2, max_days: 3 },
{ pincode: 531021, min_days: 2, max_days: 3 },
{ pincode: 531022, min_days: 2, max_days: 3 },
{ pincode: 531023, min_days: 2, max_days: 3 },
{ pincode: 531024, min_days: 2, max_days: 3 },
{ pincode: 531025, min_days: 2, max_days: 3 },
{ pincode: 531026, min_days: 2, max_days: 3 },
{ pincode: 531027, min_days: 2, max_days: 3 },
{ pincode: 531028, min_days: 2, max_days: 3 },
{ pincode: 531029, min_days: 2, max_days: 3 },
{ pincode: 531030, min_days: 2, max_days: 3 },
{ pincode: 531031, min_days: 2, max_days: 3 },
{ pincode: 531032, min_days: 2, max_days: 3 },
{ pincode: 531033, min_days: 2, max_days: 3 },
{ pincode: 531034, min_days: 2, max_days: 3 },
{ pincode: 531035, min_days: 2, max_days: 3 },
{ pincode: 531036, min_days: 2, max_days: 3 },
{ pincode: 531040, min_days: 2, max_days: 3 },
{ pincode: 531053, min_days: 2, max_days: 3 },
{ pincode: 531055, min_days: 2, max_days: 3 },
{ pincode: 531060, min_days: 2, max_days: 3 },
{ pincode: 531061, min_days: 2, max_days: 3 },
{ pincode: 531075, min_days: 2, max_days: 3 },
{ pincode: 531077, min_days: 2, max_days: 3 },
{ pincode: 531081, min_days: 2, max_days: 3 },
{ pincode: 531082, min_days: 2, max_days: 3 },
{ pincode: 531083, min_days: 2, max_days: 3 },
{ pincode: 531084, min_days: 2, max_days: 3 },
{ pincode: 531085, min_days: 2, max_days: 3 },
{ pincode: 531087, min_days: 2, max_days: 3 },
{ pincode: 531105, min_days: 2, max_days: 3 },
{ pincode: 531110, min_days: 2, max_days: 3 },
{ pincode: 531111, min_days: 2, max_days: 3 },
{ pincode: 531113, min_days: 2, max_days: 3 },
{ pincode: 531114, min_days: 2, max_days: 3 },
{ pincode: 531115, min_days: 2, max_days: 3 },
{ pincode: 531116, min_days: 2, max_days: 3 },
{ pincode: 531117, min_days: 2, max_days: 3 },
{ pincode: 531118, min_days: 2, max_days: 3 },
{ pincode: 531126, min_days: 2, max_days: 3 },
{ pincode: 531127, min_days: 2, max_days: 3 },
{ pincode: 531133, min_days: 2, max_days: 3 },
{ pincode: 531145, min_days: 2, max_days: 3 },
{ pincode: 531148, min_days: 2, max_days: 3 },
{ pincode: 531149, min_days: 2, max_days: 3 },
{ pincode: 531151, min_days: 2, max_days: 3 },
{ pincode: 531161, min_days: 2, max_days: 3 },
{ pincode: 531162, min_days: 2, max_days: 3 },
{ pincode: 531163, min_days: 2, max_days: 3 },
{ pincode: 531173, min_days: 2, max_days: 3 },
{ pincode: 531201, min_days: 2, max_days: 3 },
{ pincode: 531203, min_days: 2, max_days: 3 },
{ pincode: 531204, min_days: 2, max_days: 3 },
{ pincode: 531208, min_days: 2, max_days: 3 },
{ pincode: 531211, min_days: 2, max_days: 3 },
{ pincode: 531212, min_days: 2, max_days: 3 },
{ pincode: 531213, min_days: 2, max_days: 3 },
{ pincode: 531214, min_days: 2, max_days: 3 },
{ pincode: 531215, min_days: 2, max_days: 3 },
{ pincode: 531217, min_days: 2, max_days: 3 },
{ pincode: 531218, min_days: 2, max_days: 3 },
{ pincode: 531219, min_days: 2, max_days: 3 },
{ pincode: 531220, min_days: 2, max_days: 3 },
{ pincode: 531270, min_days: 2, max_days: 3 },
{ pincode: 531303, min_days: 2, max_days: 3 },
{ pincode: 532001, min_days: 2, max_days: 3 },
{ pincode: 532002, min_days: 2, max_days: 3 },
{ pincode: 532003, min_days: 2, max_days: 3 },
{ pincode: 532004, min_days: 2, max_days: 3 },
{ pincode: 532005, min_days: 2, max_days: 3 },
{ pincode: 532101, min_days: 2, max_days: 3 },
{ pincode: 532122, min_days: 2, max_days: 3 },
{ pincode: 532123, min_days: 2, max_days: 3 },
{ pincode: 532125, min_days: 2, max_days: 3 },
{ pincode: 532127, min_days: 2, max_days: 3 },
{ pincode: 532128, min_days: 2, max_days: 3 },
{ pincode: 532148, min_days: 2, max_days: 3 },
{ pincode: 532168, min_days: 2, max_days: 3 },
{ pincode: 532185, min_days: 2, max_days: 3 },
{ pincode: 532186, min_days: 2, max_days: 3 },
{ pincode: 532187, min_days: 2, max_days: 3 },
{ pincode: 532189, min_days: 2, max_days: 3 },
{ pincode: 532190, min_days: 2, max_days: 3 },
{ pincode: 532195, min_days: 2, max_days: 3 },
{ pincode: 532201, min_days: 2, max_days: 3 },
{ pincode: 532202, min_days: 2, max_days: 3 },
{ pincode: 532203, min_days: 2, max_days: 3 },
{ pincode: 532204, min_days: 2, max_days: 3 },
{ pincode: 532211, min_days: 2, max_days: 3 },
{ pincode: 532212, min_days: 2, max_days: 3 },
{ pincode: 532213, min_days: 2, max_days: 3 },
{ pincode: 532214, min_days: 2, max_days: 3 },
{ pincode: 532215, min_days: 2, max_days: 3 },
{ pincode: 532216, min_days: 2, max_days: 3 },
{ pincode: 532218, min_days: 2, max_days: 3 },
{ pincode: 532219, min_days: 2, max_days: 3 },
{ pincode: 532220, min_days: 2, max_days: 3 },
{ pincode: 532221, min_days: 2, max_days: 3 },
{ pincode: 532222, min_days: 2, max_days: 3 },
{ pincode: 532242, min_days: 2, max_days: 3 },
{ pincode: 532243, min_days: 2, max_days: 3 },
{ pincode: 532263, min_days: 2, max_days: 3 },
{ pincode: 532264, min_days: 2, max_days: 3 },
{ pincode: 532270, min_days: 2, max_days: 3 },
{ pincode: 532284, min_days: 2, max_days: 3 },
{ pincode: 532290, min_days: 2, max_days: 3 },
{ pincode: 532291, min_days: 2, max_days: 3 },
{ pincode: 532292, min_days: 2, max_days: 3 },
{ pincode: 532312, min_days: 2, max_days: 3 },
{ pincode: 532313, min_days: 2, max_days: 3 },
{ pincode: 532322, min_days: 2, max_days: 3 },
{ pincode: 532401, min_days: 2, max_days: 3 },
{ pincode: 532402, min_days: 2, max_days: 3 },
{ pincode: 532403, min_days: 2, max_days: 3 },
{ pincode: 532404, min_days: 2, max_days: 3 },
{ pincode: 532405, min_days: 2, max_days: 3 },
{ pincode: 532406, min_days: 2, max_days: 3 },
{ pincode: 532407, min_days: 2, max_days: 3 },
{ pincode: 532408, min_days: 2, max_days: 3 },
{ pincode: 532409, min_days: 2, max_days: 3 },
{ pincode: 532410, min_days: 2, max_days: 3 },
{ pincode: 532417, min_days: 2, max_days: 3 },
{ pincode: 532421, min_days: 2, max_days: 3 },
{ pincode: 532425, min_days: 2, max_days: 3 },
{ pincode: 532426, min_days: 2, max_days: 3 },
{ pincode: 532427, min_days: 2, max_days: 3 },
{ pincode: 532428, min_days: 2, max_days: 3 },
{ pincode: 532429, min_days: 2, max_days: 3 },
{ pincode: 532430, min_days: 2, max_days: 3 },
{ pincode: 532432, min_days: 2, max_days: 3 },
{ pincode: 532440, min_days: 2, max_days: 3 },
{ pincode: 532443, min_days: 2, max_days: 3 },
{ pincode: 532445, min_days: 2, max_days: 3 },
{ pincode: 532455, min_days: 2, max_days: 3 },
{ pincode: 532456, min_days: 2, max_days: 3 },
{ pincode: 532457, min_days: 2, max_days: 3 },
{ pincode: 532458, min_days: 2, max_days: 3 },
{ pincode: 532459, min_days: 2, max_days: 3 },
{ pincode: 532460, min_days: 2, max_days: 3 },
{ pincode: 532461, min_days: 2, max_days: 3 },
{ pincode: 532462, min_days: 2, max_days: 3 },
{ pincode: 532474, min_days: 2, max_days: 3 },
{ pincode: 532484, min_days: 2, max_days: 3 },
{ pincode: 532485, min_days: 2, max_days: 3 },
{ pincode: 532501, min_days: 2, max_days: 3 },
{ pincode: 532524, min_days: 2, max_days: 3 },
{ pincode: 532550, min_days: 2, max_days: 3 },
{ pincode: 532557, min_days: 2, max_days: 3 },
{ pincode: 532558, min_days: 2, max_days: 3 },
{ pincode: 532573, min_days: 2, max_days: 3 },
{ pincode: 532579, min_days: 2, max_days: 3 },
{ pincode: 532591, min_days: 2, max_days: 3 },
{ pincode: 532599, min_days: 2, max_days: 3 },
{ pincode: 532612, min_days: 2, max_days: 3 },
{ pincode: 532617, min_days: 2, max_days: 3 },
{ pincode: 532663, min_days: 2, max_days: 3 },
{ pincode: 533001, min_days: 2, max_days: 3 },
{ pincode: 533002, min_days: 2, max_days: 3 },
{ pincode: 533003, min_days: 2, max_days: 3 },
{ pincode: 533004, min_days: 2, max_days: 3 },
{ pincode: 533005, min_days: 2, max_days: 3 },
{ pincode: 533006, min_days: 2, max_days: 3 },
{ pincode: 533007, min_days: 2, max_days: 3 },
{ pincode: 533008, min_days: 2, max_days: 3 },
{ pincode: 533014, min_days: 2, max_days: 3 },
{ pincode: 533016, min_days: 2, max_days: 3 },
{ pincode: 533101, min_days: 2, max_days: 3 },
{ pincode: 533102, min_days: 2, max_days: 3 },
{ pincode: 533103, min_days: 2, max_days: 3 },
{ pincode: 533104, min_days: 2, max_days: 3 },
{ pincode: 533105, min_days: 2, max_days: 3 },
{ pincode: 533106, min_days: 2, max_days: 3 },
{ pincode: 533107, min_days: 2, max_days: 3 },
{ pincode: 533108, min_days: 2, max_days: 3 },
{ pincode: 533109, min_days: 2, max_days: 3 },
{ pincode: 533124, min_days: 2, max_days: 3 },
{ pincode: 533125, min_days: 2, max_days: 3 },
{ pincode: 533126, min_days: 2, max_days: 3 },
{ pincode: 533133, min_days: 2, max_days: 3 },
{ pincode: 533201, min_days: 2, max_days: 3 },
{ pincode: 533202, min_days: 2, max_days: 3 },
{ pincode: 533203, min_days: 2, max_days: 3 },
{ pincode: 533210, min_days: 2, max_days: 3 },
{ pincode: 533211, min_days: 2, max_days: 3 },
{ pincode: 533212, min_days: 2, max_days: 3 },
{ pincode: 533213, min_days: 2, max_days: 3 },
{ pincode: 533214, min_days: 2, max_days: 3 },
{ pincode: 533215, min_days: 2, max_days: 3 },
{ pincode: 533216, min_days: 2, max_days: 3 },
{ pincode: 533217, min_days: 2, max_days: 3 },
{ pincode: 533218, min_days: 2, max_days: 3 },
{ pincode: 533220, min_days: 2, max_days: 3 },
{ pincode: 533221, min_days: 2, max_days: 3 },
{ pincode: 533222, min_days: 2, max_days: 3 },
{ pincode: 533223, min_days: 2, max_days: 3 },
{ pincode: 533224, min_days: 2, max_days: 3 },
{ pincode: 533225, min_days: 2, max_days: 3 },
{ pincode: 533226, min_days: 2, max_days: 3 },
{ pincode: 533228, min_days: 2, max_days: 3 },
{ pincode: 533229, min_days: 2, max_days: 3 },
{ pincode: 533232, min_days: 2, max_days: 3 },
{ pincode: 533233, min_days: 2, max_days: 3 },
{ pincode: 533234, min_days: 2, max_days: 3 },
{ pincode: 533235, min_days: 2, max_days: 3 },
{ pincode: 533236, min_days: 2, max_days: 3 },
{ pincode: 533237, min_days: 2, max_days: 3 },
{ pincode: 533238, min_days: 2, max_days: 3 },
{ pincode: 533239, min_days: 2, max_days: 3 },
{ pincode: 533240, min_days: 2, max_days: 3 },
{ pincode: 533241, min_days: 2, max_days: 3 },
{ pincode: 533242, min_days: 2, max_days: 3 },
{ pincode: 533244, min_days: 2, max_days: 3 },
{ pincode: 533247, min_days: 2, max_days: 3 },
{ pincode: 533248, min_days: 2, max_days: 3 },
{ pincode: 533249, min_days: 2, max_days: 3 },
{ pincode: 533250, min_days: 2, max_days: 3 },
{ pincode: 533251, min_days: 2, max_days: 3 },
{ pincode: 533252, min_days: 2, max_days: 3 },
{ pincode: 533253, min_days: 2, max_days: 3 },
{ pincode: 533254, min_days: 2, max_days: 3 },
{ pincode: 533255, min_days: 2, max_days: 3 },
{ pincode: 533256, min_days: 2, max_days: 3 },
{ pincode: 533258, min_days: 2, max_days: 3 },
{ pincode: 533260, min_days: 2, max_days: 3 },
{ pincode: 533261, min_days: 2, max_days: 3 },
{ pincode: 533262, min_days: 2, max_days: 3 },
{ pincode: 533263, min_days: 2, max_days: 3 },
{ pincode: 533264, min_days: 2, max_days: 3 },
{ pincode: 533274, min_days: 2, max_days: 3 },
{ pincode: 533284, min_days: 2, max_days: 3 },
{ pincode: 533285, min_days: 2, max_days: 3 },
{ pincode: 533286, min_days: 2, max_days: 3 },
{ pincode: 533287, min_days: 2, max_days: 3 },
{ pincode: 533288, min_days: 2, max_days: 3 },
{ pincode: 533289, min_days: 2, max_days: 3 },
{ pincode: 533290, min_days: 2, max_days: 3 },
{ pincode: 533291, min_days: 2, max_days: 3 },
{ pincode: 533292, min_days: 2, max_days: 3 },
{ pincode: 533293, min_days: 2, max_days: 3 },
{ pincode: 533294, min_days: 2, max_days: 3 },
{ pincode: 533295, min_days: 2, max_days: 3 },
{ pincode: 533296, min_days: 2, max_days: 3 },
{ pincode: 533297, min_days: 2, max_days: 3 },
{ pincode: 533305, min_days: 2, max_days: 3 },
{ pincode: 533306, min_days: 2, max_days: 3 },
{ pincode: 533307, min_days: 2, max_days: 3 },
{ pincode: 533308, min_days: 2, max_days: 3 },
{ pincode: 533309, min_days: 2, max_days: 3 },
{ pincode: 533333, min_days: 2, max_days: 3 },
{ pincode: 533340, min_days: 2, max_days: 3 },
{ pincode: 533341, min_days: 2, max_days: 3 },
{ pincode: 533342, min_days: 2, max_days: 3 },
{ pincode: 533343, min_days: 2, max_days: 3 },
{ pincode: 533344, min_days: 2, max_days: 3 },
{ pincode: 533345, min_days: 2, max_days: 3 },
{ pincode: 533346, min_days: 2, max_days: 3 },
{ pincode: 533347, min_days: 2, max_days: 3 },
{ pincode: 533348, min_days: 2, max_days: 3 },
{ pincode: 533349, min_days: 2, max_days: 3 },
{ pincode: 533350, min_days: 2, max_days: 3 },
{ pincode: 533351, min_days: 2, max_days: 3 },
{ pincode: 533352, min_days: 2, max_days: 3 },
{ pincode: 533353, min_days: 2, max_days: 3 },
{ pincode: 533354, min_days: 2, max_days: 3 },
{ pincode: 533355, min_days: 2, max_days: 3 },
{ pincode: 533401, min_days: 2, max_days: 3 },
{ pincode: 533406, min_days: 2, max_days: 3 },
{ pincode: 533407, min_days: 2, max_days: 3 },
{ pincode: 533408, min_days: 2, max_days: 3 },
{ pincode: 533409, min_days: 2, max_days: 3 },
{ pincode: 533410, min_days: 2, max_days: 3 },
{ pincode: 533428, min_days: 2, max_days: 3 },
{ pincode: 533429, min_days: 2, max_days: 3 },
{ pincode: 533430, min_days: 2, max_days: 3 },
{ pincode: 533431, min_days: 2, max_days: 3 },
{ pincode: 533432, min_days: 2, max_days: 3 },
{ pincode: 533433, min_days: 2, max_days: 3 },
{ pincode: 533434, min_days: 2, max_days: 3 },
{ pincode: 533435, min_days: 2, max_days: 3 },
{ pincode: 533436, min_days: 2, max_days: 3 },
{ pincode: 533437, min_days: 2, max_days: 3 },
{ pincode: 533439, min_days: 2, max_days: 3 },
{ pincode: 533440, min_days: 2, max_days: 3 },
{ pincode: 533444, min_days: 2, max_days: 3 },
{ pincode: 533445, min_days: 2, max_days: 3 },
{ pincode: 533446, min_days: 2, max_days: 3 },
{ pincode: 533447, min_days: 2, max_days: 3 },
{ pincode: 533448, min_days: 2, max_days: 3 },
{ pincode: 533449, min_days: 2, max_days: 3 },
{ pincode: 533450, min_days: 2, max_days: 3 },
{ pincode: 533451, min_days: 2, max_days: 3 },
{ pincode: 533457, min_days: 2, max_days: 3 },
{ pincode: 533460, min_days: 2, max_days: 3 },
{ pincode: 533461, min_days: 2, max_days: 3 },
{ pincode: 533462, min_days: 2, max_days: 3 },
{ pincode: 533463, min_days: 2, max_days: 3 },
{ pincode: 533464, min_days: 2, max_days: 3 },
{ pincode: 533468, min_days: 2, max_days: 3 },
{ pincode: 533483, min_days: 2, max_days: 3 },
{ pincode: 533503, min_days: 2, max_days: 3 },
{ pincode: 533566, min_days: 2, max_days: 3 },
{ pincode: 533577, min_days: 2, max_days: 3 },
{ pincode: 534000, min_days: 2, max_days: 3 },
{ pincode: 534001, min_days: 2, max_days: 3 },
{ pincode: 534002, min_days: 2, max_days: 3 },
{ pincode: 534003, min_days: 2, max_days: 3 },
{ pincode: 534004, min_days: 2, max_days: 3 },
{ pincode: 534005, min_days: 2, max_days: 3 },
{ pincode: 534006, min_days: 2, max_days: 3 },
{ pincode: 534007, min_days: 2, max_days: 3 },
{ pincode: 534008, min_days: 2, max_days: 3 },
{ pincode: 534015, min_days: 2, max_days: 3 },
{ pincode: 534101, min_days: 2, max_days: 3 },
{ pincode: 534102, min_days: 2, max_days: 3 },
{ pincode: 534108, min_days: 2, max_days: 3 },
{ pincode: 534111, min_days: 2, max_days: 3 },
{ pincode: 534112, min_days: 2, max_days: 3 },
{ pincode: 534122, min_days: 2, max_days: 3 },
{ pincode: 534123, min_days: 2, max_days: 3 },
{ pincode: 534124, min_days: 2, max_days: 3 },
{ pincode: 534126, min_days: 2, max_days: 3 },
{ pincode: 534127, min_days: 2, max_days: 3 },
{ pincode: 534134, min_days: 2, max_days: 3 },
{ pincode: 534137, min_days: 2, max_days: 3 },
{ pincode: 534145, min_days: 2, max_days: 3 },
{ pincode: 534146, min_days: 2, max_days: 3 },
{ pincode: 534156, min_days: 2, max_days: 3 },
{ pincode: 534165, min_days: 2, max_days: 3 },
{ pincode: 534166, min_days: 2, max_days: 3 },
{ pincode: 534176, min_days: 2, max_days: 3 },
{ pincode: 534186, min_days: 2, max_days: 3 },
{ pincode: 534195, min_days: 2, max_days: 3 },
{ pincode: 534196, min_days: 2, max_days: 3 },
{ pincode: 534197, min_days: 2, max_days: 3 },
{ pincode: 534198, min_days: 2, max_days: 3 },
{ pincode: 534199, min_days: 2, max_days: 3 },
{ pincode: 534201, min_days: 2, max_days: 3 },
{ pincode: 534202, min_days: 2, max_days: 3 },
{ pincode: 534203, min_days: 2, max_days: 3 },
{ pincode: 534204, min_days: 2, max_days: 3 },
{ pincode: 534206, min_days: 2, max_days: 3 },
{ pincode: 534207, min_days: 2, max_days: 3 },
{ pincode: 534208, min_days: 2, max_days: 3 },
{ pincode: 534209, min_days: 2, max_days: 3 },
{ pincode: 534210, min_days: 2, max_days: 3 },
{ pincode: 534211, min_days: 2, max_days: 3 },
{ pincode: 534212, min_days: 2, max_days: 3 },
{ pincode: 534213, min_days: 2, max_days: 3 },
{ pincode: 534214, min_days: 2, max_days: 3 },
{ pincode: 534215, min_days: 2, max_days: 3 },
{ pincode: 534216, min_days: 2, max_days: 3 },
{ pincode: 534217, min_days: 2, max_days: 3 },
{ pincode: 534218, min_days: 2, max_days: 3 },
{ pincode: 534222, min_days: 2, max_days: 3 },
{ pincode: 534225, min_days: 2, max_days: 3 },
{ pincode: 534227, min_days: 2, max_days: 3 },
{ pincode: 534229, min_days: 2, max_days: 3 },
{ pincode: 534230, min_days: 2, max_days: 3 },
{ pincode: 534235, min_days: 2, max_days: 3 },
{ pincode: 534236, min_days: 2, max_days: 3 },
{ pincode: 534237, min_days: 2, max_days: 3 },
{ pincode: 534238, min_days: 2, max_days: 3 },
{ pincode: 534239, min_days: 2, max_days: 3 },
{ pincode: 534240, min_days: 2, max_days: 3 },
{ pincode: 534243, min_days: 2, max_days: 3 },
{ pincode: 534244, min_days: 2, max_days: 3 },
{ pincode: 534245, min_days: 2, max_days: 3 },
{ pincode: 534247, min_days: 2, max_days: 3 },
{ pincode: 534250, min_days: 2, max_days: 3 },
{ pincode: 534251, min_days: 2, max_days: 3 },
{ pincode: 534260, min_days: 2, max_days: 3 },
{ pincode: 534261, min_days: 2, max_days: 3 },
{ pincode: 534265, min_days: 2, max_days: 3 },
{ pincode: 534266, min_days: 2, max_days: 3 },
{ pincode: 534267, min_days: 2, max_days: 3 },
{ pincode: 534268, min_days: 2, max_days: 3 },
{ pincode: 534269, min_days: 2, max_days: 3 },
{ pincode: 534271, min_days: 2, max_days: 3 },
{ pincode: 534272, min_days: 2, max_days: 3 },
{ pincode: 534275, min_days: 2, max_days: 3 },
{ pincode: 534280, min_days: 2, max_days: 3 },
{ pincode: 534281, min_days: 2, max_days: 3 },
{ pincode: 534291, min_days: 2, max_days: 3 },
{ pincode: 534301, min_days: 2, max_days: 3 },
{ pincode: 534302, min_days: 2, max_days: 3 },
{ pincode: 534303, min_days: 2, max_days: 3 },
{ pincode: 534305, min_days: 2, max_days: 3 },
{ pincode: 534311, min_days: 2, max_days: 3 },
{ pincode: 534312, min_days: 2, max_days: 3 },
{ pincode: 534313, min_days: 2, max_days: 3 },
{ pincode: 534314, min_days: 2, max_days: 3 },
{ pincode: 534315, min_days: 2, max_days: 3 },
{ pincode: 534316, min_days: 2, max_days: 3 },
{ pincode: 534318, min_days: 2, max_days: 3 },
{ pincode: 534320, min_days: 2, max_days: 3 },
{ pincode: 534324, min_days: 2, max_days: 3 },
{ pincode: 534326, min_days: 2, max_days: 3 },
{ pincode: 534327, min_days: 2, max_days: 3 },
{ pincode: 534328, min_days: 2, max_days: 3 },
{ pincode: 534329, min_days: 2, max_days: 3 },
{ pincode: 534330, min_days: 2, max_days: 3 },
{ pincode: 534331, min_days: 2, max_days: 3 },
{ pincode: 534338, min_days: 2, max_days: 3 },
{ pincode: 534339, min_days: 2, max_days: 3 },
{ pincode: 534340, min_days: 2, max_days: 3 },
{ pincode: 534341, min_days: 2, max_days: 3 },
{ pincode: 534342, min_days: 2, max_days: 3 },
{ pincode: 534343, min_days: 2, max_days: 3 },
{ pincode: 534350, min_days: 2, max_days: 3 },
{ pincode: 534351, min_days: 2, max_days: 3 },
{ pincode: 534392, min_days: 2, max_days: 3 },
{ pincode: 534401, min_days: 2, max_days: 3 },
{ pincode: 534406, min_days: 2, max_days: 3 },
{ pincode: 534407, min_days: 2, max_days: 3 },
{ pincode: 534411, min_days: 2, max_days: 3 },
{ pincode: 534416, min_days: 2, max_days: 3 },
{ pincode: 534425, min_days: 2, max_days: 3 },
{ pincode: 534426, min_days: 2, max_days: 3 },
{ pincode: 534427, min_days: 2, max_days: 3 },
{ pincode: 534432, min_days: 2, max_days: 3 },
{ pincode: 534435, min_days: 2, max_days: 3 },
{ pincode: 534437, min_days: 2, max_days: 3 },
{ pincode: 534442, min_days: 2, max_days: 3 },
{ pincode: 534444, min_days: 2, max_days: 3 },
{ pincode: 534447, min_days: 2, max_days: 3 },
{ pincode: 534448, min_days: 2, max_days: 3 },
{ pincode: 534449, min_days: 2, max_days: 3 },
{ pincode: 534450, min_days: 2, max_days: 3 },
{ pincode: 534451, min_days: 2, max_days: 3 },
{ pincode: 534452, min_days: 2, max_days: 3 },
{ pincode: 534455, min_days: 2, max_days: 3 },
{ pincode: 534456, min_days: 2, max_days: 3 },
{ pincode: 534460, min_days: 2, max_days: 3 },
{ pincode: 534461, min_days: 2, max_days: 3 },
{ pincode: 534462, min_days: 2, max_days: 3 },
{ pincode: 534467, min_days: 2, max_days: 3 },
{ pincode: 534475, min_days: 2, max_days: 3 },
{ pincode: 535001, min_days: 2, max_days: 3 },
{ pincode: 535002, min_days: 2, max_days: 3 },
{ pincode: 535003, min_days: 2, max_days: 3 },
{ pincode: 535004, min_days: 2, max_days: 3 },
{ pincode: 535005, min_days: 2, max_days: 3 },
{ pincode: 535006, min_days: 2, max_days: 3 },
{ pincode: 535101, min_days: 2, max_days: 3 },
{ pincode: 535102, min_days: 2, max_days: 3 },
{ pincode: 535124, min_days: 2, max_days: 3 },
{ pincode: 535125, min_days: 2, max_days: 3 },
{ pincode: 535126, min_days: 2, max_days: 3 },
{ pincode: 535128, min_days: 2, max_days: 3 },
{ pincode: 535145, min_days: 2, max_days: 3 },
{ pincode: 535148, min_days: 2, max_days: 3 },
{ pincode: 535160, min_days: 2, max_days: 3 },
{ pincode: 535161, min_days: 2, max_days: 3 },
{ pincode: 535183, min_days: 2, max_days: 3 },
{ pincode: 535202, min_days: 2, max_days: 3 },
{ pincode: 535204, min_days: 2, max_days: 3 },
{ pincode: 535213, min_days: 2, max_days: 3 },
{ pincode: 535214, min_days: 2, max_days: 3 },
{ pincode: 535215, min_days: 2, max_days: 3 },
{ pincode: 535216, min_days: 2, max_days: 3 },
{ pincode: 535217, min_days: 2, max_days: 3 },
{ pincode: 535218, min_days: 2, max_days: 3 },
{ pincode: 535220, min_days: 2, max_days: 3 },
{ pincode: 535221, min_days: 2, max_days: 3 },
{ pincode: 535240, min_days: 2, max_days: 3 },
{ pincode: 535250, min_days: 2, max_days: 3 },
{ pincode: 535260, min_days: 2, max_days: 3 },
{ pincode: 535270, min_days: 2, max_days: 3 },
{ pincode: 535273, min_days: 2, max_days: 3 },
{ pincode: 535280, min_days: 2, max_days: 3 },
{ pincode: 535281, min_days: 2, max_days: 3 },
{ pincode: 535350, min_days: 2, max_days: 3 },
{ pincode: 535463, min_days: 2, max_days: 3 },
{ pincode: 535501, min_days: 2, max_days: 3 },
{ pincode: 535502, min_days: 2, max_days: 3 },
{ pincode: 535521, min_days: 2, max_days: 3 },
{ pincode: 535522, min_days: 2, max_days: 3 },
{ pincode: 535523, min_days: 2, max_days: 3 },
{ pincode: 535524, min_days: 2, max_days: 3 },
{ pincode: 535525, min_days: 2, max_days: 3 },
{ pincode: 535526, min_days: 2, max_days: 3 },
{ pincode: 535527, min_days: 2, max_days: 3 },
{ pincode: 535532, min_days: 2, max_days: 3 },
{ pincode: 535534, min_days: 2, max_days: 3 },
{ pincode: 535546, min_days: 2, max_days: 3 },
{ pincode: 535547, min_days: 2, max_days: 3 },
{ pincode: 535557, min_days: 2, max_days: 3 },
{ pincode: 535558, min_days: 2, max_days: 3 },
{ pincode: 535559, min_days: 2, max_days: 3 },
{ pincode: 535568, min_days: 2, max_days: 3 },
{ pincode: 535569, min_days: 2, max_days: 3 },
{ pincode: 535573, min_days: 2, max_days: 3 },
{ pincode: 535578, min_days: 2, max_days: 3 },
{ pincode: 535579, min_days: 2, max_days: 3 },
{ pincode: 535580, min_days: 2, max_days: 3 },
{ pincode: 535581, min_days: 2, max_days: 3 },
{ pincode: 535582, min_days: 2, max_days: 3 },
{ pincode: 535591, min_days: 2, max_days: 3 },
{ pincode: 535592, min_days: 2, max_days: 3 },
{ pincode: 535593, min_days: 2, max_days: 3 },
{ pincode: 535594, min_days: 2, max_days: 3 },
{ pincode: 538101, min_days: 2, max_days: 3 },
{ pincode: 560001, min_days: 2, max_days: 3 },
{ pincode: 560002, min_days: 2, max_days: 3 },
{ pincode: 560003, min_days: 2, max_days: 3 },
{ pincode: 560004, min_days: 2, max_days: 3 },
{ pincode: 560005, min_days: 2, max_days: 3 },
{ pincode: 560006, min_days: 2, max_days: 3 },
{ pincode: 560007, min_days: 2, max_days: 3 },
{ pincode: 560008, min_days: 2, max_days: 3 },
{ pincode: 560009, min_days: 2, max_days: 3 },
{ pincode: 560010, min_days: 2, max_days: 3 },
{ pincode: 560011, min_days: 2, max_days: 3 },
{ pincode: 560012, min_days: 2, max_days: 3 },
{ pincode: 560013, min_days: 2, max_days: 3 },
{ pincode: 560014, min_days: 2, max_days: 3 },
{ pincode: 560015, min_days: 2, max_days: 3 },
{ pincode: 560016, min_days: 2, max_days: 3 },
{ pincode: 560017, min_days: 2, max_days: 3 },
{ pincode: 560018, min_days: 2, max_days: 3 },
{ pincode: 560019, min_days: 2, max_days: 3 },
{ pincode: 560020, min_days: 2, max_days: 3 },
{ pincode: 560021, min_days: 2, max_days: 3 },
{ pincode: 560022, min_days: 2, max_days: 3 },
{ pincode: 560023, min_days: 2, max_days: 3 },
{ pincode: 560024, min_days: 2, max_days: 3 },
{ pincode: 560025, min_days: 2, max_days: 3 },
{ pincode: 560026, min_days: 2, max_days: 3 },
{ pincode: 560027, min_days: 2, max_days: 3 },
{ pincode: 560028, min_days: 2, max_days: 3 },
{ pincode: 560029, min_days: 2, max_days: 3 },
{ pincode: 560030, min_days: 2, max_days: 3 },
{ pincode: 560031, min_days: 2, max_days: 3 },
{ pincode: 560032, min_days: 2, max_days: 3 },
{ pincode: 560033, min_days: 2, max_days: 3 },
{ pincode: 560034, min_days: 2, max_days: 3 },
{ pincode: 560035, min_days: 2, max_days: 3 },
{ pincode: 560036, min_days: 2, max_days: 3 },
{ pincode: 560037, min_days: 2, max_days: 3 },
{ pincode: 560038, min_days: 2, max_days: 3 },
{ pincode: 560039, min_days: 2, max_days: 3 },
{ pincode: 560040, min_days: 2, max_days: 3 },
{ pincode: 560041, min_days: 2, max_days: 3 },
{ pincode: 560042, min_days: 2, max_days: 3 },
{ pincode: 560043, min_days: 2, max_days: 3 },
{ pincode: 560044, min_days: 2, max_days: 3 },
{ pincode: 560045, min_days: 2, max_days: 3 },
{ pincode: 560046, min_days: 2, max_days: 3 },
{ pincode: 560047, min_days: 2, max_days: 3 },
{ pincode: 560048, min_days: 2, max_days: 3 },
{ pincode: 560049, min_days: 2, max_days: 3 },
{ pincode: 560050, min_days: 2, max_days: 3 },
{ pincode: 560051, min_days: 2, max_days: 3 },
{ pincode: 560052, min_days: 2, max_days: 3 },
{ pincode: 560053, min_days: 2, max_days: 3 },
{ pincode: 560054, min_days: 2, max_days: 3 },
{ pincode: 560055, min_days: 2, max_days: 3 },
{ pincode: 560056, min_days: 2, max_days: 3 },
{ pincode: 560057, min_days: 2, max_days: 3 },
{ pincode: 560058, min_days: 2, max_days: 3 },
{ pincode: 560059, min_days: 2, max_days: 3 },
{ pincode: 560060, min_days: 2, max_days: 3 },
{ pincode: 560061, min_days: 2, max_days: 3 },
{ pincode: 560062, min_days: 2, max_days: 3 },
{ pincode: 560063, min_days: 2, max_days: 3 },
{ pincode: 560064, min_days: 2, max_days: 3 },
{ pincode: 560065, min_days: 2, max_days: 3 },
{ pincode: 560066, min_days: 2, max_days: 3 },
{ pincode: 560067, min_days: 2, max_days: 3 },
{ pincode: 560068, min_days: 2, max_days: 3 },
{ pincode: 560069, min_days: 2, max_days: 3 },
{ pincode: 560070, min_days: 2, max_days: 3 },
{ pincode: 560071, min_days: 2, max_days: 3 },
{ pincode: 560072, min_days: 2, max_days: 3 },
{ pincode: 560073, min_days: 2, max_days: 3 },
{ pincode: 560074, min_days: 2, max_days: 3 },
{ pincode: 560075, min_days: 2, max_days: 3 },
{ pincode: 560076, min_days: 2, max_days: 3 },
{ pincode: 560077, min_days: 2, max_days: 3 },
{ pincode: 560078, min_days: 2, max_days: 3 },
{ pincode: 560079, min_days: 2, max_days: 3 },
{ pincode: 560080, min_days: 2, max_days: 3 },
{ pincode: 560081, min_days: 2, max_days: 3 },
{ pincode: 560082, min_days: 2, max_days: 3 },
{ pincode: 560083, min_days: 2, max_days: 3 },
{ pincode: 560084, min_days: 2, max_days: 3 },
{ pincode: 560085, min_days: 2, max_days: 3 },
{ pincode: 560086, min_days: 2, max_days: 3 },
{ pincode: 560087, min_days: 2, max_days: 3 },
{ pincode: 560088, min_days: 2, max_days: 3 },
{ pincode: 560089, min_days: 2, max_days: 3 },
{ pincode: 560090, min_days: 2, max_days: 3 },
{ pincode: 560091, min_days: 2, max_days: 3 },
{ pincode: 560092, min_days: 2, max_days: 3 },
{ pincode: 560093, min_days: 2, max_days: 3 },
{ pincode: 560094, min_days: 2, max_days: 3 },
{ pincode: 560095, min_days: 2, max_days: 3 },
{ pincode: 560096, min_days: 2, max_days: 3 },
{ pincode: 560097, min_days: 2, max_days: 3 },
{ pincode: 560098, min_days: 2, max_days: 3 },
{ pincode: 560099, min_days: 2, max_days: 3 },
{ pincode: 560100, min_days: 2, max_days: 3 },
{ pincode: 560101, min_days: 2, max_days: 3 },
{ pincode: 560102, min_days: 2, max_days: 3 },
{ pincode: 560103, min_days: 2, max_days: 3 },
{ pincode: 560104, min_days: 2, max_days: 3 },
{ pincode: 560105, min_days: 2, max_days: 3 },
{ pincode: 560106, min_days: 2, max_days: 3 },
{ pincode: 560107, min_days: 2, max_days: 3 },
{ pincode: 560108, min_days: 2, max_days: 3 },
{ pincode: 560109, min_days: 2, max_days: 3 },
{ pincode: 560110, min_days: 2, max_days: 3 },
{ pincode: 560111, min_days: 2, max_days: 3 },
{ pincode: 560112, min_days: 2, max_days: 3 },
{ pincode: 560113, min_days: 2, max_days: 3 },
{ pincode: 560114, min_days: 2, max_days: 3 },
{ pincode: 560115, min_days: 2, max_days: 3 },
{ pincode: 560116, min_days: 2, max_days: 3 },
{ pincode: 560117, min_days: 2, max_days: 3 },
{ pincode: 560122, min_days: 2, max_days: 3 },
{ pincode: 560125, min_days: 2, max_days: 3 },
{ pincode: 560149, min_days: 2, max_days: 3 },
{ pincode: 560203, min_days: 2, max_days: 3 },
{ pincode: 560204, min_days: 2, max_days: 3 },
{ pincode: 560242, min_days: 2, max_days: 3 },
{ pincode: 560300, min_days: 2, max_days: 3 },
{ pincode: 560500, min_days: 2, max_days: 3 },
{ pincode: 561101, min_days: 2, max_days: 3 },
{ pincode: 561201, min_days: 2, max_days: 3 },
{ pincode: 561202, min_days: 2, max_days: 3 },
{ pincode: 561203, min_days: 2, max_days: 3 },
{ pincode: 561204, min_days: 2, max_days: 3 },
{ pincode: 561205, min_days: 2, max_days: 3 },
{ pincode: 561206, min_days: 2, max_days: 3 },
{ pincode: 561207, min_days: 2, max_days: 3 },
{ pincode: 561208, min_days: 2, max_days: 3 },
{ pincode: 561209, min_days: 2, max_days: 3 },
{ pincode: 561210, min_days: 2, max_days: 3 },
{ pincode: 561211, min_days: 2, max_days: 3 },
{ pincode: 561212, min_days: 2, max_days: 3 },
{ pincode: 561213, min_days: 2, max_days: 3 },
{ pincode: 561219, min_days: 2, max_days: 3 },
{ pincode: 561224, min_days: 2, max_days: 3 },
{ pincode: 561228, min_days: 2, max_days: 3 },
{ pincode: 561230, min_days: 2, max_days: 3 },
{ pincode: 562101, min_days: 2, max_days: 3 },
{ pincode: 562102, min_days: 2, max_days: 3 },
{ pincode: 562103, min_days: 2, max_days: 3 },
{ pincode: 562104, min_days: 2, max_days: 3 },
{ pincode: 562105, min_days: 2, max_days: 3 },
{ pincode: 562106, min_days: 2, max_days: 3 },
{ pincode: 562107, min_days: 2, max_days: 3 },
{ pincode: 562108, min_days: 2, max_days: 3 },
{ pincode: 562109, min_days: 2, max_days: 3 },
{ pincode: 562110, min_days: 2, max_days: 3 },
{ pincode: 562111, min_days: 2, max_days: 3 },
{ pincode: 562112, min_days: 2, max_days: 3 },
{ pincode: 562114, min_days: 2, max_days: 3 },
{ pincode: 562117, min_days: 2, max_days: 3 },
{ pincode: 562119, min_days: 2, max_days: 3 },
{ pincode: 562120, min_days: 2, max_days: 3 },
{ pincode: 562121, min_days: 2, max_days: 3 },
{ pincode: 562122, min_days: 2, max_days: 3 },
{ pincode: 562123, min_days: 2, max_days: 3 },
{ pincode: 562125, min_days: 2, max_days: 3 },
{ pincode: 562126, min_days: 2, max_days: 3 },
{ pincode: 562127, min_days: 2, max_days: 3 },
{ pincode: 562128, min_days: 2, max_days: 3 },
{ pincode: 562129, min_days: 2, max_days: 3 },
{ pincode: 562130, min_days: 2, max_days: 3 },
{ pincode: 562131, min_days: 2, max_days: 3 },
{ pincode: 562132, min_days: 2, max_days: 3 },
{ pincode: 562135, min_days: 2, max_days: 3 },
{ pincode: 562137, min_days: 2, max_days: 3 },
{ pincode: 562138, min_days: 2, max_days: 3 },
{ pincode: 562145, min_days: 2, max_days: 3 },
{ pincode: 562149, min_days: 2, max_days: 3 },
{ pincode: 562152, min_days: 2, max_days: 3 },
{ pincode: 562157, min_days: 2, max_days: 3 },
{ pincode: 562158, min_days: 2, max_days: 3 },
{ pincode: 562159, min_days: 2, max_days: 3 },
{ pincode: 562160, min_days: 2, max_days: 3 },
{ pincode: 562161, min_days: 2, max_days: 3 },
{ pincode: 562162, min_days: 2, max_days: 3 },
{ pincode: 562163, min_days: 2, max_days: 3 },
{ pincode: 562164, min_days: 2, max_days: 3 },
{ pincode: 562165, min_days: 2, max_days: 3 },
{ pincode: 562166, min_days: 2, max_days: 3 },
{ pincode: 562201, min_days: 2, max_days: 3 },
{ pincode: 562203, min_days: 2, max_days: 3 },
{ pincode: 562300, min_days: 2, max_days: 3 },
{ pincode: 563101, min_days: 2, max_days: 3 },
{ pincode: 563102, min_days: 2, max_days: 3 },
{ pincode: 563103, min_days: 2, max_days: 3 },
{ pincode: 563113, min_days: 2, max_days: 3 },
{ pincode: 563114, min_days: 2, max_days: 3 },
{ pincode: 563115, min_days: 2, max_days: 3 },
{ pincode: 563116, min_days: 2, max_days: 3 },
{ pincode: 563117, min_days: 2, max_days: 3 },
{ pincode: 563118, min_days: 2, max_days: 3 },
{ pincode: 563119, min_days: 2, max_days: 3 },
{ pincode: 563120, min_days: 2, max_days: 3 },
{ pincode: 563121, min_days: 2, max_days: 3 },
{ pincode: 563122, min_days: 2, max_days: 3 },
{ pincode: 563123, min_days: 2, max_days: 3 },
{ pincode: 563124, min_days: 2, max_days: 3 },
{ pincode: 563125, min_days: 2, max_days: 3 },
{ pincode: 563126, min_days: 2, max_days: 3 },
{ pincode: 563127, min_days: 2, max_days: 3 },
{ pincode: 563128, min_days: 2, max_days: 3 },
{ pincode: 563129, min_days: 2, max_days: 3 },
{ pincode: 563130, min_days: 2, max_days: 3 },
{ pincode: 563131, min_days: 2, max_days: 3 },
{ pincode: 563132, min_days: 2, max_days: 3 },
{ pincode: 563133, min_days: 2, max_days: 3 },
{ pincode: 563134, min_days: 2, max_days: 3 },
{ pincode: 563135, min_days: 2, max_days: 3 },
{ pincode: 563136, min_days: 2, max_days: 3 },
{ pincode: 563137, min_days: 2, max_days: 3 },
{ pincode: 563138, min_days: 2, max_days: 3 },
{ pincode: 563139, min_days: 2, max_days: 3 },
{ pincode: 563146, min_days: 2, max_days: 3 },
{ pincode: 563147, min_days: 2, max_days: 3 },
{ pincode: 563152, min_days: 2, max_days: 3 },
{ pincode: 563155, min_days: 2, max_days: 3 },
{ pincode: 563156, min_days: 2, max_days: 3 },
{ pincode: 563157, min_days: 2, max_days: 3 },
{ pincode: 563159, min_days: 2, max_days: 3 },
{ pincode: 563160, min_days: 2, max_days: 3 },
{ pincode: 563161, min_days: 2, max_days: 3 },
{ pincode: 563162, min_days: 2, max_days: 3 },
{ pincode: 563163, min_days: 2, max_days: 3 },
{ pincode: 570001, min_days: 2, max_days: 3 },
{ pincode: 570002, min_days: 2, max_days: 3 },
{ pincode: 570003, min_days: 2, max_days: 3 },
{ pincode: 570004, min_days: 2, max_days: 3 },
{ pincode: 570005, min_days: 2, max_days: 3 },
{ pincode: 570006, min_days: 2, max_days: 3 },
{ pincode: 570007, min_days: 2, max_days: 3 },
{ pincode: 570008, min_days: 2, max_days: 3 },
{ pincode: 570009, min_days: 2, max_days: 3 },
{ pincode: 570010, min_days: 2, max_days: 3 },
{ pincode: 570011, min_days: 2, max_days: 3 },
{ pincode: 570012, min_days: 2, max_days: 3 },
{ pincode: 570013, min_days: 2, max_days: 3 },
{ pincode: 570014, min_days: 2, max_days: 3 },
{ pincode: 570015, min_days: 2, max_days: 3 },
{ pincode: 570016, min_days: 2, max_days: 3 },
{ pincode: 570017, min_days: 2, max_days: 3 },
{ pincode: 570018, min_days: 2, max_days: 3 },
{ pincode: 570019, min_days: 2, max_days: 3 },
{ pincode: 570020, min_days: 2, max_days: 3 },
{ pincode: 570021, min_days: 2, max_days: 3 },
{ pincode: 570022, min_days: 2, max_days: 3 },
{ pincode: 570023, min_days: 2, max_days: 3 },
{ pincode: 570024, min_days: 2, max_days: 3 },
{ pincode: 570025, min_days: 2, max_days: 3 },
{ pincode: 570026, min_days: 2, max_days: 3 },
{ pincode: 570027, min_days: 2, max_days: 3 },
{ pincode: 570028, min_days: 2, max_days: 3 },
{ pincode: 570029, min_days: 2, max_days: 3 },
{ pincode: 570030, min_days: 2, max_days: 3 },
{ pincode: 570031, min_days: 2, max_days: 3 },
{ pincode: 570032, min_days: 2, max_days: 3 },
{ pincode: 570033, min_days: 2, max_days: 3 },
{ pincode: 570034, min_days: 2, max_days: 3 },
{ pincode: 571101, min_days: 2, max_days: 3 },
{ pincode: 571102, min_days: 2, max_days: 3 },
{ pincode: 571103, min_days: 2, max_days: 3 },
{ pincode: 571104, min_days: 2, max_days: 3 },
{ pincode: 571105, min_days: 2, max_days: 3 },
{ pincode: 571106, min_days: 2, max_days: 3 },
{ pincode: 571107, min_days: 2, max_days: 3 },
{ pincode: 571108, min_days: 2, max_days: 3 },
{ pincode: 571109, min_days: 2, max_days: 3 },
{ pincode: 571110, min_days: 2, max_days: 3 },
{ pincode: 571111, min_days: 2, max_days: 3 },
{ pincode: 571114, min_days: 2, max_days: 3 },
{ pincode: 571115, min_days: 2, max_days: 3 },
{ pincode: 571116, min_days: 2, max_days: 3 },
{ pincode: 571117, min_days: 2, max_days: 3 },
{ pincode: 571118, min_days: 2, max_days: 3 },
{ pincode: 571119, min_days: 2, max_days: 3 },
{ pincode: 571120, min_days: 2, max_days: 3 },
{ pincode: 571121, min_days: 2, max_days: 3 },
{ pincode: 571122, min_days: 2, max_days: 3 },
{ pincode: 571123, min_days: 2, max_days: 3 },
{ pincode: 571124, min_days: 2, max_days: 3 },
{ pincode: 571125, min_days: 2, max_days: 3 },
{ pincode: 571126, min_days: 2, max_days: 3 },
{ pincode: 571127, min_days: 2, max_days: 3 },
{ pincode: 571128, min_days: 2, max_days: 3 },
{ pincode: 571129, min_days: 2, max_days: 3 },
{ pincode: 571130, min_days: 2, max_days: 3 },
{ pincode: 571132, min_days: 2, max_days: 3 },
{ pincode: 571133, min_days: 2, max_days: 3 },
{ pincode: 571134, min_days: 2, max_days: 3 },
{ pincode: 571137, min_days: 2, max_days: 3 },
{ pincode: 571139, min_days: 2, max_days: 3 },
{ pincode: 571146, min_days: 2, max_days: 3 },
{ pincode: 571154, min_days: 2, max_days: 3 },
{ pincode: 571156, min_days: 2, max_days: 3 },
{ pincode: 571160, min_days: 2, max_days: 3 },
{ pincode: 571174, min_days: 2, max_days: 3 },
{ pincode: 571183, min_days: 2, max_days: 3 },
{ pincode: 571184, min_days: 2, max_days: 3 },
{ pincode: 571185, min_days: 2, max_days: 3 },
{ pincode: 571186, min_days: 2, max_days: 3 },
{ pincode: 571187, min_days: 2, max_days: 3 },
{ pincode: 571189, min_days: 2, max_days: 3 },
{ pincode: 571201, min_days: 2, max_days: 3 },
{ pincode: 571211, min_days: 2, max_days: 3 },
{ pincode: 571212, min_days: 2, max_days: 3 },
{ pincode: 571213, min_days: 2, max_days: 3 },
{ pincode: 571214, min_days: 2, max_days: 3 },
{ pincode: 571215, min_days: 2, max_days: 3 },
{ pincode: 571216, min_days: 2, max_days: 3 },
{ pincode: 571217, min_days: 2, max_days: 3 },
{ pincode: 571218, min_days: 2, max_days: 3 },
{ pincode: 571219, min_days: 2, max_days: 3 },
{ pincode: 571231, min_days: 2, max_days: 3 },
{ pincode: 571232, min_days: 2, max_days: 3 },
{ pincode: 571234, min_days: 2, max_days: 3 },
{ pincode: 571235, min_days: 2, max_days: 3 },
{ pincode: 571236, min_days: 2, max_days: 3 },
{ pincode: 571237, min_days: 2, max_days: 3 },
{ pincode: 571247, min_days: 2, max_days: 3 },
{ pincode: 571248, min_days: 2, max_days: 3 },
{ pincode: 571249, min_days: 2, max_days: 3 },
{ pincode: 571250, min_days: 2, max_days: 3 },
{ pincode: 571251, min_days: 2, max_days: 3 },
{ pincode: 571252, min_days: 2, max_days: 3 },
{ pincode: 571253, min_days: 2, max_days: 3 },
{ pincode: 571254, min_days: 2, max_days: 3 },
{ pincode: 571264, min_days: 2, max_days: 3 },
{ pincode: 571301, min_days: 2, max_days: 3 },
{ pincode: 571302, min_days: 2, max_days: 3 },
{ pincode: 571311, min_days: 2, max_days: 3 },
{ pincode: 571312, min_days: 2, max_days: 3 },
{ pincode: 571313, min_days: 2, max_days: 3 },
{ pincode: 571314, min_days: 2, max_days: 3 },
{ pincode: 571315, min_days: 2, max_days: 3 },
{ pincode: 571316, min_days: 2, max_days: 3 },
{ pincode: 571319, min_days: 2, max_days: 3 },
{ pincode: 571320, min_days: 2, max_days: 3 },
{ pincode: 571321, min_days: 2, max_days: 3 },
{ pincode: 571322, min_days: 2, max_days: 3 },
{ pincode: 571325, min_days: 2, max_days: 3 },
{ pincode: 571327, min_days: 2, max_days: 3 },
{ pincode: 571328, min_days: 2, max_days: 3 },
{ pincode: 571331, min_days: 2, max_days: 3 },
{ pincode: 571332, min_days: 2, max_days: 3 },
{ pincode: 571334, min_days: 2, max_days: 3 },
{ pincode: 571337, min_days: 2, max_days: 3 },
{ pincode: 571342, min_days: 2, max_days: 3 },
{ pincode: 571401, min_days: 2, max_days: 3 },
{ pincode: 571402, min_days: 2, max_days: 3 },
{ pincode: 571403, min_days: 2, max_days: 3 },
{ pincode: 571404, min_days: 2, max_days: 3 },
{ pincode: 571405, min_days: 2, max_days: 3 },
{ pincode: 571415, min_days: 2, max_days: 3 },
{ pincode: 571416, min_days: 2, max_days: 3 },
{ pincode: 571417, min_days: 2, max_days: 3 },
{ pincode: 571418, min_days: 2, max_days: 3 },
{ pincode: 571419, min_days: 2, max_days: 3 },
{ pincode: 571421, min_days: 2, max_days: 3 },
{ pincode: 571422, min_days: 2, max_days: 3 },
{ pincode: 571423, min_days: 2, max_days: 3 },
{ pincode: 571424, min_days: 2, max_days: 3 },
{ pincode: 571425, min_days: 2, max_days: 3 },
{ pincode: 571426, min_days: 2, max_days: 3 },
{ pincode: 571427, min_days: 2, max_days: 3 },
{ pincode: 571428, min_days: 2, max_days: 3 },
{ pincode: 571429, min_days: 2, max_days: 3 },
{ pincode: 571430, min_days: 2, max_days: 3 },
{ pincode: 571431, min_days: 2, max_days: 3 },
{ pincode: 571432, min_days: 2, max_days: 3 },
{ pincode: 571433, min_days: 2, max_days: 3 },
{ pincode: 571434, min_days: 2, max_days: 3 },
{ pincode: 571435, min_days: 2, max_days: 3 },
{ pincode: 571436, min_days: 2, max_days: 3 },
{ pincode: 571437, min_days: 2, max_days: 3 },
{ pincode: 571438, min_days: 2, max_days: 3 },
{ pincode: 571439, min_days: 2, max_days: 3 },
{ pincode: 571440, min_days: 2, max_days: 3 },
{ pincode: 571441, min_days: 2, max_days: 3 },
{ pincode: 571442, min_days: 2, max_days: 3 },
{ pincode: 571443, min_days: 2, max_days: 3 },
{ pincode: 571444, min_days: 2, max_days: 3 },
{ pincode: 571445, min_days: 2, max_days: 3 },
{ pincode: 571446, min_days: 2, max_days: 3 },
{ pincode: 571448, min_days: 2, max_days: 3 },
{ pincode: 571450, min_days: 2, max_days: 3 },
{ pincode: 571454, min_days: 2, max_days: 3 },
{ pincode: 571455, min_days: 2, max_days: 3 },
{ pincode: 571457, min_days: 2, max_days: 3 },
{ pincode: 571463, min_days: 2, max_days: 3 },
{ pincode: 571474, min_days: 2, max_days: 3 },
{ pincode: 571475, min_days: 2, max_days: 3 },
{ pincode: 571476, min_days: 2, max_days: 3 },
{ pincode: 571477, min_days: 2, max_days: 3 },
{ pincode: 571478, min_days: 2, max_days: 3 },
{ pincode: 571479, min_days: 2, max_days: 3 },
{ pincode: 571490, min_days: 2, max_days: 3 },
{ pincode: 571493, min_days: 2, max_days: 3 },
{ pincode: 571495, min_days: 2, max_days: 3 },
{ pincode: 571498, min_days: 2, max_days: 3 },
{ pincode: 571499, min_days: 2, max_days: 3 },
{ pincode: 571501, min_days: 2, max_days: 3 },
{ pincode: 571502, min_days: 2, max_days: 3 },
{ pincode: 571511, min_days: 2, max_days: 3 },
{ pincode: 571601, min_days: 2, max_days: 3 },
{ pincode: 571602, min_days: 2, max_days: 3 },
{ pincode: 571603, min_days: 2, max_days: 3 },
{ pincode: 571604, min_days: 2, max_days: 3 },
{ pincode: 571605, min_days: 2, max_days: 3 },
{ pincode: 571606, min_days: 2, max_days: 3 },
{ pincode: 571607, min_days: 2, max_days: 3 },
{ pincode: 571608, min_days: 2, max_days: 3 },
{ pincode: 571610, min_days: 2, max_days: 3 },
{ pincode: 571613, min_days: 2, max_days: 3 },
{ pincode: 571616, min_days: 2, max_days: 3 },
{ pincode: 571617, min_days: 2, max_days: 3 },
{ pincode: 571801, min_days: 2, max_days: 3 },
{ pincode: 571802, min_days: 2, max_days: 3 },
{ pincode: 571807, min_days: 2, max_days: 3 },
{ pincode: 571811, min_days: 2, max_days: 3 },
{ pincode: 571812, min_days: 2, max_days: 3 },
{ pincode: 572101, min_days: 2, max_days: 3 },
{ pincode: 572102, min_days: 2, max_days: 3 },
{ pincode: 572103, min_days: 2, max_days: 3 },
{ pincode: 572104, min_days: 2, max_days: 3 },
{ pincode: 572105, min_days: 2, max_days: 3 },
{ pincode: 572106, min_days: 2, max_days: 3 },
{ pincode: 572107, min_days: 2, max_days: 3 },
{ pincode: 572108, min_days: 2, max_days: 3 },
{ pincode: 572110, min_days: 2, max_days: 3 },
{ pincode: 572111, min_days: 2, max_days: 3 },
{ pincode: 572112, min_days: 2, max_days: 3 },
{ pincode: 572113, min_days: 2, max_days: 3 },
{ pincode: 572114, min_days: 2, max_days: 3 },
{ pincode: 572115, min_days: 2, max_days: 3 },
{ pincode: 572116, min_days: 2, max_days: 3 },
{ pincode: 572117, min_days: 2, max_days: 3 },
{ pincode: 572118, min_days: 2, max_days: 3 },
{ pincode: 572119, min_days: 2, max_days: 3 },
{ pincode: 572120, min_days: 2, max_days: 3 },
{ pincode: 572121, min_days: 2, max_days: 3 },
{ pincode: 572122, min_days: 2, max_days: 3 },
{ pincode: 572123, min_days: 2, max_days: 3 },
{ pincode: 572124, min_days: 2, max_days: 3 },
{ pincode: 572125, min_days: 2, max_days: 3 },
{ pincode: 572126, min_days: 2, max_days: 3 },
{ pincode: 572127, min_days: 2, max_days: 3 },
{ pincode: 572128, min_days: 2, max_days: 3 },
{ pincode: 572129, min_days: 2, max_days: 3 },
{ pincode: 572130, min_days: 2, max_days: 3 },
{ pincode: 572132, min_days: 2, max_days: 3 },
{ pincode: 572133, min_days: 2, max_days: 3 },
{ pincode: 572134, min_days: 2, max_days: 3 },
{ pincode: 572135, min_days: 2, max_days: 3 },
{ pincode: 572136, min_days: 2, max_days: 3 },
{ pincode: 572137, min_days: 2, max_days: 3 },
{ pincode: 572138, min_days: 2, max_days: 3 },
{ pincode: 572139, min_days: 2, max_days: 3 },
{ pincode: 572140, min_days: 2, max_days: 3 },
{ pincode: 572141, min_days: 2, max_days: 3 },
{ pincode: 572142, min_days: 2, max_days: 3 },
{ pincode: 572143, min_days: 2, max_days: 3 },
{ pincode: 572144, min_days: 2, max_days: 3 },
{ pincode: 572145, min_days: 2, max_days: 3 },
{ pincode: 572160, min_days: 2, max_days: 3 },
{ pincode: 572161, min_days: 2, max_days: 3 },
{ pincode: 572168, min_days: 2, max_days: 3 },
{ pincode: 572175, min_days: 2, max_days: 3 },
{ pincode: 572201, min_days: 2, max_days: 3 },
{ pincode: 572202, min_days: 2, max_days: 3 },
{ pincode: 572211, min_days: 2, max_days: 3 },
{ pincode: 572212, min_days: 2, max_days: 3 },
{ pincode: 572213, min_days: 2, max_days: 3 },
{ pincode: 572214, min_days: 2, max_days: 3 },
{ pincode: 572215, min_days: 2, max_days: 3 },
{ pincode: 572216, min_days: 2, max_days: 3 },
{ pincode: 572217, min_days: 2, max_days: 3 },
{ pincode: 572218, min_days: 2, max_days: 3 },
{ pincode: 572219, min_days: 2, max_days: 3 },
{ pincode: 572220, min_days: 2, max_days: 3 },
{ pincode: 572221, min_days: 2, max_days: 3 },
{ pincode: 572222, min_days: 2, max_days: 3 },
{ pincode: 572223, min_days: 2, max_days: 3 },
{ pincode: 572224, min_days: 2, max_days: 3 },
{ pincode: 572225, min_days: 2, max_days: 3 },
{ pincode: 572226, min_days: 2, max_days: 3 },
{ pincode: 572227, min_days: 2, max_days: 3 },
{ pincode: 572228, min_days: 2, max_days: 3 },
{ pincode: 573101, min_days: 2, max_days: 3 },
{ pincode: 573102, min_days: 2, max_days: 3 },
{ pincode: 573103, min_days: 2, max_days: 3 },
{ pincode: 573111, min_days: 2, max_days: 3 },
{ pincode: 573112, min_days: 2, max_days: 3 },
{ pincode: 573113, min_days: 2, max_days: 3 },
{ pincode: 573114, min_days: 2, max_days: 3 },
{ pincode: 573115, min_days: 2, max_days: 3 },
{ pincode: 573116, min_days: 2, max_days: 3 },
{ pincode: 573117, min_days: 2, max_days: 3 },
{ pincode: 573118, min_days: 2, max_days: 3 },
{ pincode: 573119, min_days: 2, max_days: 3 },
{ pincode: 573120, min_days: 2, max_days: 3 },
{ pincode: 573121, min_days: 2, max_days: 3 },
{ pincode: 573122, min_days: 2, max_days: 3 },
{ pincode: 573123, min_days: 2, max_days: 3 },
{ pincode: 573124, min_days: 2, max_days: 3 },
{ pincode: 573125, min_days: 2, max_days: 3 },
{ pincode: 573126, min_days: 2, max_days: 3 },
{ pincode: 573127, min_days: 2, max_days: 3 },
{ pincode: 573128, min_days: 2, max_days: 3 },
{ pincode: 573129, min_days: 2, max_days: 3 },
{ pincode: 573130, min_days: 2, max_days: 3 },
{ pincode: 573131, min_days: 2, max_days: 3 },
{ pincode: 573132, min_days: 2, max_days: 3 },
{ pincode: 573133, min_days: 2, max_days: 3 },
{ pincode: 573134, min_days: 2, max_days: 3 },
{ pincode: 573135, min_days: 2, max_days: 3 },
{ pincode: 573136, min_days: 2, max_days: 3 },
{ pincode: 573137, min_days: 2, max_days: 3 },
{ pincode: 573141, min_days: 2, max_days: 3 },
{ pincode: 573142, min_days: 2, max_days: 3 },
{ pincode: 573144, min_days: 2, max_days: 3 },
{ pincode: 573145, min_days: 2, max_days: 3 },
{ pincode: 573147, min_days: 2, max_days: 3 },
{ pincode: 573149, min_days: 2, max_days: 3 },
{ pincode: 573150, min_days: 2, max_days: 3 },
{ pincode: 573160, min_days: 2, max_days: 3 },
{ pincode: 573162, min_days: 2, max_days: 3 },
{ pincode: 573164, min_days: 2, max_days: 3 },
{ pincode: 573165, min_days: 2, max_days: 3 },
{ pincode: 573201, min_days: 2, max_days: 3 },
{ pincode: 573202, min_days: 2, max_days: 3 },
{ pincode: 573210, min_days: 2, max_days: 3 },
{ pincode: 573211, min_days: 2, max_days: 3 },
{ pincode: 573212, min_days: 2, max_days: 3 },
{ pincode: 573213, min_days: 2, max_days: 3 },
{ pincode: 573214, min_days: 2, max_days: 3 },
{ pincode: 573215, min_days: 2, max_days: 3 },
{ pincode: 573216, min_days: 2, max_days: 3 },
{ pincode: 573217, min_days: 2, max_days: 3 },
{ pincode: 573218, min_days: 2, max_days: 3 },
{ pincode: 573219, min_days: 2, max_days: 3 },
{ pincode: 573220, min_days: 2, max_days: 3 },
{ pincode: 573225, min_days: 2, max_days: 3 },
{ pincode: 573226, min_days: 2, max_days: 3 },
{ pincode: 574101, min_days: 2, max_days: 3 },
{ pincode: 574102, min_days: 2, max_days: 3 },
{ pincode: 574103, min_days: 2, max_days: 3 },
{ pincode: 574104, min_days: 2, max_days: 3 },
{ pincode: 574105, min_days: 2, max_days: 3 },
{ pincode: 574106, min_days: 2, max_days: 3 },
{ pincode: 574107, min_days: 2, max_days: 3 },
{ pincode: 574108, min_days: 2, max_days: 3 },
{ pincode: 574109, min_days: 2, max_days: 3 },
{ pincode: 574110, min_days: 2, max_days: 3 },
{ pincode: 574111, min_days: 2, max_days: 3 },
{ pincode: 574112, min_days: 2, max_days: 3 },
{ pincode: 574113, min_days: 2, max_days: 3 },
{ pincode: 574114, min_days: 2, max_days: 3 },
{ pincode: 574115, min_days: 2, max_days: 3 },
{ pincode: 574116, min_days: 2, max_days: 3 },
{ pincode: 574117, min_days: 2, max_days: 3 },
{ pincode: 574118, min_days: 2, max_days: 3 },
{ pincode: 574119, min_days: 2, max_days: 3 },
{ pincode: 574121, min_days: 2, max_days: 3 },
{ pincode: 574122, min_days: 2, max_days: 3 },
{ pincode: 574123, min_days: 2, max_days: 3 },
{ pincode: 574129, min_days: 2, max_days: 3 },
{ pincode: 574138, min_days: 2, max_days: 3 },
{ pincode: 574139, min_days: 2, max_days: 3 },
{ pincode: 574141, min_days: 2, max_days: 3 },
{ pincode: 574142, min_days: 2, max_days: 3 },
{ pincode: 574143, min_days: 2, max_days: 3 },
{ pincode: 574144, min_days: 2, max_days: 3 },
{ pincode: 574145, min_days: 2, max_days: 3 },
{ pincode: 574146, min_days: 2, max_days: 3 },
{ pincode: 574148, min_days: 2, max_days: 3 },
{ pincode: 574149, min_days: 2, max_days: 3 },
{ pincode: 574150, min_days: 2, max_days: 3 },
{ pincode: 574151, min_days: 2, max_days: 3 },
{ pincode: 574153, min_days: 2, max_days: 3 },
{ pincode: 574154, min_days: 2, max_days: 3 },
{ pincode: 574157, min_days: 2, max_days: 3 },
{ pincode: 574158, min_days: 2, max_days: 3 },
{ pincode: 574159, min_days: 2, max_days: 3 },
{ pincode: 574160, min_days: 2, max_days: 3 },
{ pincode: 574161, min_days: 2, max_days: 3 },
{ pincode: 574162, min_days: 2, max_days: 3 },
{ pincode: 574164, min_days: 2, max_days: 3 },
{ pincode: 574165, min_days: 2, max_days: 3 },
{ pincode: 574166, min_days: 2, max_days: 3 },
{ pincode: 574169, min_days: 2, max_days: 3 },
{ pincode: 574170, min_days: 2, max_days: 3 },
{ pincode: 574173, min_days: 2, max_days: 3 },
{ pincode: 574179, min_days: 2, max_days: 3 },
{ pincode: 574180, min_days: 2, max_days: 3 },
{ pincode: 574189, min_days: 2, max_days: 3 },
{ pincode: 574197, min_days: 2, max_days: 3 },
{ pincode: 574198, min_days: 2, max_days: 3 },
{ pincode: 574199, min_days: 2, max_days: 3 },
{ pincode: 574201, min_days: 2, max_days: 3 },
{ pincode: 574202, min_days: 2, max_days: 3 },
{ pincode: 574203, min_days: 2, max_days: 3 },
{ pincode: 574210, min_days: 2, max_days: 3 },
{ pincode: 574211, min_days: 2, max_days: 3 },
{ pincode: 574212, min_days: 2, max_days: 3 },
{ pincode: 574213, min_days: 2, max_days: 3 },
{ pincode: 574214, min_days: 2, max_days: 3 },
{ pincode: 574216, min_days: 2, max_days: 3 },
{ pincode: 574217, min_days: 2, max_days: 3 },
{ pincode: 574218, min_days: 2, max_days: 3 },
{ pincode: 574219, min_days: 2, max_days: 3 },
{ pincode: 574220, min_days: 2, max_days: 3 },
{ pincode: 574221, min_days: 2, max_days: 3 },
{ pincode: 574222, min_days: 2, max_days: 3 },
{ pincode: 574223, min_days: 2, max_days: 3 },
{ pincode: 574224, min_days: 2, max_days: 3 },
{ pincode: 574225, min_days: 2, max_days: 3 },
{ pincode: 574226, min_days: 2, max_days: 3 },
{ pincode: 574227, min_days: 2, max_days: 3 },
{ pincode: 574228, min_days: 2, max_days: 3 },
{ pincode: 574229, min_days: 2, max_days: 3 },
{ pincode: 574230, min_days: 2, max_days: 3 },
{ pincode: 574231, min_days: 2, max_days: 3 },
{ pincode: 574232, min_days: 2, max_days: 3 },
{ pincode: 574233, min_days: 2, max_days: 3 },
{ pincode: 574234, min_days: 2, max_days: 3 },
{ pincode: 574235, min_days: 2, max_days: 3 },
{ pincode: 574236, min_days: 2, max_days: 3 },
{ pincode: 574237, min_days: 2, max_days: 3 },
{ pincode: 574238, min_days: 2, max_days: 3 },
{ pincode: 574239, min_days: 2, max_days: 3 },
{ pincode: 574240, min_days: 2, max_days: 3 },
{ pincode: 574241, min_days: 2, max_days: 3 },
{ pincode: 574242, min_days: 2, max_days: 3 },
{ pincode: 574243, min_days: 2, max_days: 3 },
{ pincode: 574244, min_days: 2, max_days: 3 },
{ pincode: 574248, min_days: 2, max_days: 3 },
{ pincode: 574253, min_days: 2, max_days: 3 },
{ pincode: 574258, min_days: 2, max_days: 3 },
{ pincode: 574259, min_days: 2, max_days: 3 },
{ pincode: 574260, min_days: 2, max_days: 3 },
{ pincode: 574264, min_days: 2, max_days: 3 },
{ pincode: 574265, min_days: 2, max_days: 3 },
{ pincode: 574266, min_days: 2, max_days: 3 },
{ pincode: 574267, min_days: 2, max_days: 3 },
{ pincode: 574272, min_days: 2, max_days: 3 },
{ pincode: 574274, min_days: 2, max_days: 3 },
{ pincode: 574279, min_days: 2, max_days: 3 },
{ pincode: 574285, min_days: 2, max_days: 3 },
{ pincode: 574299, min_days: 2, max_days: 3 },
{ pincode: 574301, min_days: 2, max_days: 3 },
{ pincode: 574313, min_days: 2, max_days: 3 },
{ pincode: 574314, min_days: 2, max_days: 3 },
{ pincode: 574323, min_days: 2, max_days: 3 },
{ pincode: 574324, min_days: 2, max_days: 3 },
{ pincode: 574325, min_days: 2, max_days: 3 },
{ pincode: 574326, min_days: 2, max_days: 3 },
{ pincode: 574327, min_days: 2, max_days: 3 },
{ pincode: 574328, min_days: 2, max_days: 3 },
{ pincode: 574339, min_days: 2, max_days: 3 },
{ pincode: 574504, min_days: 2, max_days: 3 },
{ pincode: 574509, min_days: 2, max_days: 3 },
{ pincode: 575001, min_days: 2, max_days: 3 },
{ pincode: 575002, min_days: 2, max_days: 3 },
{ pincode: 575003, min_days: 2, max_days: 3 },
{ pincode: 575004, min_days: 2, max_days: 3 },
{ pincode: 575005, min_days: 2, max_days: 3 },
{ pincode: 575006, min_days: 2, max_days: 3 },
{ pincode: 575007, min_days: 2, max_days: 3 },
{ pincode: 575008, min_days: 2, max_days: 3 },
{ pincode: 575009, min_days: 2, max_days: 3 },
{ pincode: 575010, min_days: 2, max_days: 3 },
{ pincode: 575011, min_days: 2, max_days: 3 },
{ pincode: 575012, min_days: 2, max_days: 3 },
{ pincode: 575013, min_days: 2, max_days: 3 },
{ pincode: 575014, min_days: 2, max_days: 3 },
{ pincode: 575015, min_days: 2, max_days: 3 },
{ pincode: 575016, min_days: 2, max_days: 3 },
{ pincode: 575017, min_days: 2, max_days: 3 },
{ pincode: 575018, min_days: 2, max_days: 3 },
{ pincode: 575019, min_days: 2, max_days: 3 },
{ pincode: 575020, min_days: 2, max_days: 3 },
{ pincode: 575021, min_days: 2, max_days: 3 },
{ pincode: 575022, min_days: 2, max_days: 3 },
{ pincode: 575023, min_days: 2, max_days: 3 },
{ pincode: 575024, min_days: 2, max_days: 3 },
{ pincode: 575025, min_days: 2, max_days: 3 },
{ pincode: 575026, min_days: 2, max_days: 3 },
{ pincode: 575027, min_days: 2, max_days: 3 },
{ pincode: 575028, min_days: 2, max_days: 3 },
{ pincode: 575029, min_days: 2, max_days: 3 },
{ pincode: 575030, min_days: 2, max_days: 3 },
{ pincode: 575219, min_days: 2, max_days: 3 },
{ pincode: 576001, min_days: 2, max_days: 3 },
{ pincode: 576101, min_days: 2, max_days: 3 },
{ pincode: 576102, min_days: 2, max_days: 3 },
{ pincode: 576103, min_days: 2, max_days: 3 },
{ pincode: 576104, min_days: 2, max_days: 3 },
{ pincode: 576105, min_days: 2, max_days: 3 },
{ pincode: 576106, min_days: 2, max_days: 3 },
{ pincode: 576107, min_days: 2, max_days: 3 },
{ pincode: 576108, min_days: 2, max_days: 3 },
{ pincode: 576111, min_days: 2, max_days: 3 },
{ pincode: 576112, min_days: 2, max_days: 3 },
{ pincode: 576113, min_days: 2, max_days: 3 },
{ pincode: 576114, min_days: 2, max_days: 3 },
{ pincode: 576115, min_days: 2, max_days: 3 },
{ pincode: 576117, min_days: 2, max_days: 3 },
{ pincode: 576118, min_days: 2, max_days: 3 },
{ pincode: 576119, min_days: 2, max_days: 3 },
{ pincode: 576120, min_days: 2, max_days: 3 },
{ pincode: 576121, min_days: 2, max_days: 3 },
{ pincode: 576122, min_days: 2, max_days: 3 },
{ pincode: 576124, min_days: 2, max_days: 3 },
{ pincode: 576125, min_days: 2, max_days: 3 },
{ pincode: 576126, min_days: 2, max_days: 3 },
{ pincode: 576127, min_days: 2, max_days: 3 },
{ pincode: 576143, min_days: 2, max_days: 3 },
{ pincode: 576201, min_days: 2, max_days: 3 },
{ pincode: 576210, min_days: 2, max_days: 3 },
{ pincode: 576211, min_days: 2, max_days: 3 },
{ pincode: 576212, min_days: 2, max_days: 3 },
{ pincode: 576213, min_days: 2, max_days: 3 },
{ pincode: 576214, min_days: 2, max_days: 3 },
{ pincode: 576215, min_days: 2, max_days: 3 },
{ pincode: 576216, min_days: 2, max_days: 3 },
{ pincode: 576217, min_days: 2, max_days: 3 },
{ pincode: 576218, min_days: 2, max_days: 3 },
{ pincode: 576219, min_days: 2, max_days: 3 },
{ pincode: 576220, min_days: 2, max_days: 3 },
{ pincode: 576221, min_days: 2, max_days: 3 },
{ pincode: 576222, min_days: 2, max_days: 3 },
{ pincode: 576223, min_days: 2, max_days: 3 },
{ pincode: 576224, min_days: 2, max_days: 3 },
{ pincode: 576225, min_days: 2, max_days: 3 },
{ pincode: 576226, min_days: 2, max_days: 3 },
{ pincode: 576227, min_days: 2, max_days: 3 },
{ pincode: 576228, min_days: 2, max_days: 3 },
{ pincode: 576229, min_days: 2, max_days: 3 },
{ pincode: 576230, min_days: 2, max_days: 3 },
{ pincode: 576231, min_days: 2, max_days: 3 },
{ pincode: 576232, min_days: 2, max_days: 3 },
{ pincode: 576233, min_days: 2, max_days: 3 },
{ pincode: 576234, min_days: 2, max_days: 3 },
{ pincode: 576235, min_days: 2, max_days: 3 },
{ pincode: 576244, min_days: 2, max_days: 3 },
{ pincode: 576247, min_days: 2, max_days: 3 },
{ pincode: 576254, min_days: 2, max_days: 3 },
{ pincode: 576257, min_days: 2, max_days: 3 },
{ pincode: 576282, min_days: 2, max_days: 3 },
{ pincode: 576283, min_days: 2, max_days: 3 },
{ pincode: 577001, min_days: 2, max_days: 3 },
{ pincode: 577002, min_days: 2, max_days: 3 },
{ pincode: 577003, min_days: 2, max_days: 3 },
{ pincode: 577004, min_days: 2, max_days: 3 },
{ pincode: 577005, min_days: 2, max_days: 3 },
{ pincode: 577006, min_days: 2, max_days: 3 },
{ pincode: 577007, min_days: 2, max_days: 3 },
{ pincode: 577008, min_days: 2, max_days: 3 },
{ pincode: 577101, min_days: 2, max_days: 3 },
{ pincode: 577102, min_days: 2, max_days: 3 },
{ pincode: 577111, min_days: 2, max_days: 3 },
{ pincode: 577112, min_days: 2, max_days: 3 },
{ pincode: 577113, min_days: 2, max_days: 3 },
{ pincode: 577114, min_days: 2, max_days: 3 },
{ pincode: 577115, min_days: 2, max_days: 3 },
{ pincode: 577116, min_days: 2, max_days: 3 },
{ pincode: 577117, min_days: 2, max_days: 3 },
{ pincode: 577118, min_days: 2, max_days: 3 },
{ pincode: 577120, min_days: 2, max_days: 3 },
{ pincode: 577121, min_days: 2, max_days: 3 },
{ pincode: 577122, min_days: 2, max_days: 3 },
{ pincode: 577123, min_days: 2, max_days: 3 },
{ pincode: 577124, min_days: 2, max_days: 3 },
{ pincode: 577125, min_days: 2, max_days: 3 },
{ pincode: 577126, min_days: 2, max_days: 3 },
{ pincode: 577127, min_days: 2, max_days: 3 },
{ pincode: 577128, min_days: 2, max_days: 3 },
{ pincode: 577129, min_days: 2, max_days: 3 },
{ pincode: 577130, min_days: 2, max_days: 3 },
{ pincode: 577131, min_days: 2, max_days: 3 },
{ pincode: 577132, min_days: 2, max_days: 3 },
{ pincode: 577133, min_days: 2, max_days: 3 },
{ pincode: 577134, min_days: 2, max_days: 3 },
{ pincode: 577135, min_days: 2, max_days: 3 },
{ pincode: 577136, min_days: 2, max_days: 3 },
{ pincode: 577137, min_days: 2, max_days: 3 },
{ pincode: 577138, min_days: 2, max_days: 3 },
{ pincode: 577139, min_days: 2, max_days: 3 },
{ pincode: 577140, min_days: 2, max_days: 3 },
{ pincode: 577142, min_days: 2, max_days: 3 },
{ pincode: 577144, min_days: 2, max_days: 3 },
{ pincode: 577145, min_days: 2, max_days: 3 },
{ pincode: 577146, min_days: 2, max_days: 3 },
{ pincode: 577147, min_days: 2, max_days: 3 },
{ pincode: 577148, min_days: 2, max_days: 3 },
{ pincode: 577149, min_days: 2, max_days: 3 },
{ pincode: 577150, min_days: 2, max_days: 3 },
{ pincode: 577152, min_days: 2, max_days: 3 },
{ pincode: 577153, min_days: 2, max_days: 3 },
{ pincode: 577157, min_days: 2, max_days: 3 },
{ pincode: 577159, min_days: 2, max_days: 3 },
{ pincode: 577160, min_days: 2, max_days: 3 },
{ pincode: 577161, min_days: 2, max_days: 3 },
{ pincode: 577165, min_days: 2, max_days: 3 },
{ pincode: 577168, min_days: 2, max_days: 3 },
{ pincode: 577175, min_days: 2, max_days: 3 },
{ pincode: 577177, min_days: 2, max_days: 3 },
{ pincode: 577179, min_days: 2, max_days: 3 },
{ pincode: 577180, min_days: 2, max_days: 3 },
{ pincode: 577181, min_days: 2, max_days: 3 },
{ pincode: 577182, min_days: 2, max_days: 3 },
{ pincode: 577201, min_days: 2, max_days: 3 },
{ pincode: 577202, min_days: 2, max_days: 3 },
{ pincode: 577203, min_days: 2, max_days: 3 },
{ pincode: 577204, min_days: 2, max_days: 3 },
{ pincode: 577205, min_days: 2, max_days: 3 },
{ pincode: 577211, min_days: 2, max_days: 3 },
{ pincode: 577212, min_days: 2, max_days: 3 },
{ pincode: 577213, min_days: 2, max_days: 3 },
{ pincode: 577214, min_days: 2, max_days: 3 },
{ pincode: 577215, min_days: 2, max_days: 3 },
{ pincode: 577216, min_days: 2, max_days: 3 },
{ pincode: 577217, min_days: 2, max_days: 3 },
{ pincode: 577218, min_days: 2, max_days: 3 },
{ pincode: 577219, min_days: 2, max_days: 3 },
{ pincode: 577220, min_days: 2, max_days: 3 },
{ pincode: 577221, min_days: 2, max_days: 3 },
{ pincode: 577222, min_days: 2, max_days: 3 },
{ pincode: 577223, min_days: 2, max_days: 3 },
{ pincode: 577224, min_days: 2, max_days: 3 },
{ pincode: 577225, min_days: 2, max_days: 3 },
{ pincode: 577226, min_days: 2, max_days: 3 },
{ pincode: 577227, min_days: 2, max_days: 3 },
{ pincode: 577228, min_days: 2, max_days: 3 },
{ pincode: 577229, min_days: 2, max_days: 3 },
{ pincode: 577230, min_days: 2, max_days: 3 },
{ pincode: 577231, min_days: 2, max_days: 3 },
{ pincode: 577232, min_days: 2, max_days: 3 },
{ pincode: 577233, min_days: 2, max_days: 3 },
{ pincode: 577234, min_days: 2, max_days: 3 },
{ pincode: 577235, min_days: 2, max_days: 3 },
{ pincode: 577243, min_days: 2, max_days: 3 },
{ pincode: 577244, min_days: 2, max_days: 3 },
{ pincode: 577245, min_days: 2, max_days: 3 },
{ pincode: 577246, min_days: 2, max_days: 3 },
{ pincode: 577247, min_days: 2, max_days: 3 },
{ pincode: 577301, min_days: 2, max_days: 3 },
{ pincode: 577302, min_days: 2, max_days: 3 },
{ pincode: 577303, min_days: 2, max_days: 3 },
{ pincode: 577321, min_days: 2, max_days: 3 },
{ pincode: 577401, min_days: 2, max_days: 3 },
{ pincode: 577411, min_days: 2, max_days: 3 },
{ pincode: 577412, min_days: 2, max_days: 3 },
{ pincode: 577413, min_days: 2, max_days: 3 },
{ pincode: 577414, min_days: 2, max_days: 3 },
{ pincode: 577415, min_days: 2, max_days: 3 },
{ pincode: 577416, min_days: 2, max_days: 3 },
{ pincode: 577417, min_days: 2, max_days: 3 },
{ pincode: 577418, min_days: 2, max_days: 3 },
{ pincode: 577419, min_days: 2, max_days: 3 },
{ pincode: 577421, min_days: 2, max_days: 3 },
{ pincode: 577422, min_days: 2, max_days: 3 },
{ pincode: 577423, min_days: 2, max_days: 3 },
{ pincode: 577424, min_days: 2, max_days: 3 },
{ pincode: 577425, min_days: 2, max_days: 3 },
{ pincode: 577426, min_days: 2, max_days: 3 },
{ pincode: 577427, min_days: 2, max_days: 3 },
{ pincode: 577428, min_days: 2, max_days: 3 },
{ pincode: 577429, min_days: 2, max_days: 3 },
{ pincode: 577430, min_days: 2, max_days: 3 },
{ pincode: 577431, min_days: 2, max_days: 3 },
{ pincode: 577432, min_days: 2, max_days: 3 },
{ pincode: 577433, min_days: 2, max_days: 3 },
{ pincode: 577434, min_days: 2, max_days: 3 },
{ pincode: 577435, min_days: 2, max_days: 3 },
{ pincode: 577436, min_days: 2, max_days: 3 },
{ pincode: 577440, min_days: 2, max_days: 3 },
{ pincode: 577442, min_days: 2, max_days: 3 },
{ pincode: 577444, min_days: 2, max_days: 3 },
{ pincode: 577447, min_days: 2, max_days: 3 },
{ pincode: 577448, min_days: 2, max_days: 3 },
{ pincode: 577450, min_days: 2, max_days: 3 },
{ pincode: 577451, min_days: 2, max_days: 3 },
{ pincode: 577452, min_days: 2, max_days: 3 },
{ pincode: 577453, min_days: 2, max_days: 3 },
{ pincode: 577501, min_days: 2, max_days: 3 },
{ pincode: 577502, min_days: 2, max_days: 3 },
{ pincode: 577503, min_days: 2, max_days: 3 },
{ pincode: 577511, min_days: 2, max_days: 3 },
{ pincode: 577512, min_days: 2, max_days: 3 },
{ pincode: 577513, min_days: 2, max_days: 3 },
{ pincode: 577514, min_days: 2, max_days: 3 },
{ pincode: 577515, min_days: 2, max_days: 3 },
{ pincode: 577516, min_days: 2, max_days: 3 },
{ pincode: 577517, min_days: 2, max_days: 3 },
{ pincode: 577518, min_days: 2, max_days: 3 },
{ pincode: 577519, min_days: 2, max_days: 3 },
{ pincode: 577520, min_days: 2, max_days: 3 },
{ pincode: 577521, min_days: 2, max_days: 3 },
{ pincode: 577522, min_days: 2, max_days: 3 },
{ pincode: 577523, min_days: 2, max_days: 3 },
{ pincode: 577524, min_days: 2, max_days: 3 },
{ pincode: 577525, min_days: 2, max_days: 3 },
{ pincode: 577526, min_days: 2, max_days: 3 },
{ pincode: 577527, min_days: 2, max_days: 3 },
{ pincode: 577528, min_days: 2, max_days: 3 },
{ pincode: 577529, min_days: 2, max_days: 3 },
{ pincode: 577530, min_days: 2, max_days: 3 },
{ pincode: 577531, min_days: 2, max_days: 3 },
{ pincode: 577532, min_days: 2, max_days: 3 },
{ pincode: 577533, min_days: 2, max_days: 3 },
{ pincode: 577534, min_days: 2, max_days: 3 },
{ pincode: 577535, min_days: 2, max_days: 3 },
{ pincode: 577536, min_days: 2, max_days: 3 },
{ pincode: 577537, min_days: 2, max_days: 3 },
{ pincode: 577538, min_days: 2, max_days: 3 },
{ pincode: 577539, min_days: 2, max_days: 3 },
{ pincode: 577540, min_days: 2, max_days: 3 },
{ pincode: 577541, min_days: 2, max_days: 3 },
{ pincode: 577542, min_days: 2, max_days: 3 },
{ pincode: 577543, min_days: 2, max_days: 3 },
{ pincode: 577544, min_days: 2, max_days: 3 },
{ pincode: 577545, min_days: 2, max_days: 3 },
{ pincode: 577546, min_days: 2, max_days: 3 },
{ pincode: 577547, min_days: 2, max_days: 3 },
{ pincode: 577548, min_days: 2, max_days: 3 },
{ pincode: 577549, min_days: 2, max_days: 3 },
{ pincode: 577550, min_days: 2, max_days: 3 },
{ pincode: 577551, min_days: 2, max_days: 3 },
{ pincode: 577552, min_days: 2, max_days: 3 },
{ pincode: 577553, min_days: 2, max_days: 3 },
{ pincode: 577554, min_days: 2, max_days: 3 },
{ pincode: 577555, min_days: 2, max_days: 3 },
{ pincode: 577556, min_days: 2, max_days: 3 },
{ pincode: 577557, min_days: 2, max_days: 3 },
{ pincode: 577558, min_days: 2, max_days: 3 },
{ pincode: 577566, min_days: 2, max_days: 3 },
{ pincode: 577567, min_days: 2, max_days: 3 },
{ pincode: 577568, min_days: 2, max_days: 3 },
{ pincode: 577571, min_days: 2, max_days: 3 },
{ pincode: 577572, min_days: 2, max_days: 3 },
{ pincode: 577577, min_days: 2, max_days: 3 },
{ pincode: 577580, min_days: 2, max_days: 3 },
{ pincode: 577582, min_days: 2, max_days: 3 },
{ pincode: 577588, min_days: 2, max_days: 3 },
{ pincode: 577589, min_days: 2, max_days: 3 },
{ pincode: 577591, min_days: 2, max_days: 3 },
{ pincode: 577596, min_days: 2, max_days: 3 },
{ pincode: 577597, min_days: 2, max_days: 3 },
{ pincode: 577598, min_days: 2, max_days: 3 },
{ pincode: 577599, min_days: 2, max_days: 3 },
{ pincode: 577601, min_days: 2, max_days: 3 },
{ pincode: 577602, min_days: 2, max_days: 3 },
{ pincode: 580001, min_days: 2, max_days: 3 },
{ pincode: 580002, min_days: 2, max_days: 3 },
{ pincode: 580003, min_days: 2, max_days: 3 },
{ pincode: 580004, min_days: 2, max_days: 3 },
{ pincode: 580005, min_days: 2, max_days: 3 },
{ pincode: 580006, min_days: 2, max_days: 3 },
{ pincode: 580007, min_days: 2, max_days: 3 },
{ pincode: 580008, min_days: 2, max_days: 3 },
{ pincode: 580009, min_days: 2, max_days: 3 },
{ pincode: 580010, min_days: 2, max_days: 3 },
{ pincode: 580011, min_days: 2, max_days: 3 },
{ pincode: 580020, min_days: 2, max_days: 3 },
{ pincode: 580021, min_days: 2, max_days: 3 },
{ pincode: 580022, min_days: 2, max_days: 3 },
{ pincode: 580023, min_days: 2, max_days: 3 },
{ pincode: 580024, min_days: 2, max_days: 3 },
{ pincode: 580025, min_days: 2, max_days: 3 },
{ pincode: 580026, min_days: 2, max_days: 3 },
{ pincode: 580027, min_days: 2, max_days: 3 },
{ pincode: 580028, min_days: 2, max_days: 3 },
{ pincode: 580029, min_days: 2, max_days: 3 },
{ pincode: 580030, min_days: 2, max_days: 3 },
{ pincode: 580031, min_days: 2, max_days: 3 },
{ pincode: 580032, min_days: 2, max_days: 3 },
{ pincode: 580102, min_days: 2, max_days: 3 },
{ pincode: 580110, min_days: 2, max_days: 3 },
{ pincode: 580112, min_days: 2, max_days: 3 },
{ pincode: 580114, min_days: 2, max_days: 3 },
{ pincode: 580115, min_days: 2, max_days: 3 },
{ pincode: 580116, min_days: 2, max_days: 3 },
{ pincode: 580117, min_days: 2, max_days: 3 },
{ pincode: 580118, min_days: 2, max_days: 3 },
{ pincode: 580212, min_days: 2, max_days: 3 },
{ pincode: 580213, min_days: 2, max_days: 3 },
{ pincode: 580214, min_days: 2, max_days: 3 },
{ pincode: 580216, min_days: 2, max_days: 3 },
{ pincode: 581101, min_days: 2, max_days: 3 },
{ pincode: 581102, min_days: 2, max_days: 3 },
{ pincode: 581103, min_days: 2, max_days: 3 },
{ pincode: 581104, min_days: 2, max_days: 3 },
{ pincode: 581105, min_days: 2, max_days: 3 },
{ pincode: 581106, min_days: 2, max_days: 3 },
{ pincode: 581107, min_days: 2, max_days: 3 },
{ pincode: 581108, min_days: 2, max_days: 3 },
{ pincode: 581109, min_days: 2, max_days: 3 },
{ pincode: 581110, min_days: 2, max_days: 3 },
{ pincode: 581111, min_days: 2, max_days: 3 },
{ pincode: 581112, min_days: 2, max_days: 3 },
{ pincode: 581113, min_days: 2, max_days: 3 },
{ pincode: 581115, min_days: 2, max_days: 3 },
{ pincode: 581116, min_days: 2, max_days: 3 },
{ pincode: 581117, min_days: 2, max_days: 3 },
{ pincode: 581118, min_days: 2, max_days: 3 },
{ pincode: 581119, min_days: 2, max_days: 3 },
{ pincode: 581120, min_days: 2, max_days: 3 },
{ pincode: 581121, min_days: 2, max_days: 3 },
{ pincode: 581123, min_days: 2, max_days: 3 },
{ pincode: 581124, min_days: 2, max_days: 3 },
{ pincode: 581125, min_days: 2, max_days: 3 },
{ pincode: 581126, min_days: 2, max_days: 3 },
{ pincode: 581127, min_days: 2, max_days: 3 },
{ pincode: 581128, min_days: 2, max_days: 3 },
{ pincode: 581129, min_days: 2, max_days: 3 },
{ pincode: 581131, min_days: 2, max_days: 3 },
{ pincode: 581132, min_days: 2, max_days: 3 },
{ pincode: 581136, min_days: 2, max_days: 3 },
{ pincode: 581140, min_days: 2, max_days: 3 },
{ pincode: 581141, min_days: 2, max_days: 3 },
{ pincode: 581142, min_days: 2, max_days: 3 },
{ pincode: 581143, min_days: 2, max_days: 3 },
{ pincode: 581145, min_days: 2, max_days: 3 },
{ pincode: 581148, min_days: 2, max_days: 3 },
{ pincode: 581150, min_days: 2, max_days: 3 },
{ pincode: 581152, min_days: 2, max_days: 3 },
{ pincode: 581153, min_days: 2, max_days: 3 },
{ pincode: 581158, min_days: 2, max_days: 3 },
{ pincode: 581159, min_days: 2, max_days: 3 },
{ pincode: 581161, min_days: 2, max_days: 3 },
{ pincode: 581165, min_days: 2, max_days: 3 },
{ pincode: 581166, min_days: 2, max_days: 3 },
{ pincode: 581167, min_days: 2, max_days: 3 },
{ pincode: 581170, min_days: 2, max_days: 3 },
{ pincode: 581172, min_days: 2, max_days: 3 },
{ pincode: 581175, min_days: 2, max_days: 3 },
{ pincode: 581176, min_days: 2, max_days: 3 },
{ pincode: 581177, min_days: 2, max_days: 3 },
{ pincode: 581178, min_days: 2, max_days: 3 },
{ pincode: 581179, min_days: 2, max_days: 3 },
{ pincode: 581183, min_days: 2, max_days: 3 },
{ pincode: 581185, min_days: 2, max_days: 3 },
{ pincode: 581186, min_days: 2, max_days: 3 },
{ pincode: 581187, min_days: 2, max_days: 3 },
{ pincode: 581190, min_days: 2, max_days: 3 },
{ pincode: 581191, min_days: 2, max_days: 3 },
{ pincode: 581192, min_days: 2, max_days: 3 },
{ pincode: 581193, min_days: 2, max_days: 3 },
{ pincode: 581195, min_days: 2, max_days: 3 },
{ pincode: 581196, min_days: 2, max_days: 3 },
{ pincode: 581197, min_days: 2, max_days: 3 },
{ pincode: 581198, min_days: 2, max_days: 3 },
{ pincode: 581199, min_days: 2, max_days: 3 },
{ pincode: 581201, min_days: 2, max_days: 3 },
{ pincode: 581202, min_days: 2, max_days: 3 },
{ pincode: 581203, min_days: 2, max_days: 3 },
{ pincode: 581204, min_days: 2, max_days: 3 },
{ pincode: 581205, min_days: 2, max_days: 3 },
{ pincode: 581206, min_days: 2, max_days: 3 },
{ pincode: 581207, min_days: 2, max_days: 3 },
{ pincode: 581208, min_days: 2, max_days: 3 },
{ pincode: 581209, min_days: 2, max_days: 3 },
{ pincode: 581210, min_days: 2, max_days: 3 },
{ pincode: 581211, min_days: 2, max_days: 3 },
{ pincode: 581212, min_days: 2, max_days: 3 },
{ pincode: 581213, min_days: 2, max_days: 3 },
{ pincode: 581223, min_days: 2, max_days: 3 },
{ pincode: 581224, min_days: 2, max_days: 3 },
{ pincode: 581225, min_days: 2, max_days: 3 },
{ pincode: 581226, min_days: 2, max_days: 3 },
{ pincode: 581228, min_days: 2, max_days: 3 },
{ pincode: 581229, min_days: 2, max_days: 3 },
{ pincode: 581230, min_days: 2, max_days: 3 },
{ pincode: 581231, min_days: 2, max_days: 3 },
{ pincode: 581234, min_days: 2, max_days: 3 },
{ pincode: 581236, min_days: 2, max_days: 3 },
{ pincode: 581237, min_days: 2, max_days: 3 },
{ pincode: 581301, min_days: 2, max_days: 3 },
{ pincode: 581302, min_days: 2, max_days: 3 },
{ pincode: 581303, min_days: 2, max_days: 3 },
{ pincode: 581304, min_days: 2, max_days: 3 },
{ pincode: 581305, min_days: 2, max_days: 3 },
{ pincode: 581306, min_days: 2, max_days: 3 },
{ pincode: 581307, min_days: 2, max_days: 3 },
{ pincode: 581308, min_days: 2, max_days: 3 },
{ pincode: 581314, min_days: 2, max_days: 3 },
{ pincode: 581315, min_days: 2, max_days: 3 },
{ pincode: 581316, min_days: 2, max_days: 3 },
{ pincode: 581317, min_days: 2, max_days: 3 },
{ pincode: 581318, min_days: 2, max_days: 3 },
{ pincode: 581319, min_days: 2, max_days: 3 },
{ pincode: 581320, min_days: 2, max_days: 3 },
{ pincode: 581321, min_days: 2, max_days: 3 },
{ pincode: 581322, min_days: 2, max_days: 3 },
{ pincode: 581323, min_days: 2, max_days: 3 },
{ pincode: 581324, min_days: 2, max_days: 3 },
{ pincode: 581325, min_days: 2, max_days: 3 },
{ pincode: 581326, min_days: 2, max_days: 3 },
{ pincode: 581327, min_days: 2, max_days: 3 },
{ pincode: 581328, min_days: 2, max_days: 3 },
{ pincode: 581329, min_days: 2, max_days: 3 },
{ pincode: 581330, min_days: 2, max_days: 3 },
{ pincode: 581331, min_days: 2, max_days: 3 },
{ pincode: 581332, min_days: 2, max_days: 3 },
{ pincode: 581333, min_days: 2, max_days: 3 },
{ pincode: 581334, min_days: 2, max_days: 3 },
{ pincode: 581335, min_days: 2, max_days: 3 },
{ pincode: 581336, min_days: 2, max_days: 3 },
{ pincode: 581337, min_days: 2, max_days: 3 },
{ pincode: 581338, min_days: 2, max_days: 3 },
{ pincode: 581339, min_days: 2, max_days: 3 },
{ pincode: 581340, min_days: 2, max_days: 3 },
{ pincode: 581341, min_days: 2, max_days: 3 },
{ pincode: 581342, min_days: 2, max_days: 3 },
{ pincode: 581343, min_days: 2, max_days: 3 },
{ pincode: 581344, min_days: 2, max_days: 3 },
{ pincode: 581345, min_days: 2, max_days: 3 },
{ pincode: 581346, min_days: 2, max_days: 3 },
{ pincode: 581347, min_days: 2, max_days: 3 },
{ pincode: 581348, min_days: 2, max_days: 3 },
{ pincode: 581349, min_days: 2, max_days: 3 },
{ pincode: 581350, min_days: 2, max_days: 3 },
{ pincode: 581351, min_days: 2, max_days: 3 },
{ pincode: 581352, min_days: 2, max_days: 3 },
{ pincode: 581353, min_days: 2, max_days: 3 },
{ pincode: 581354, min_days: 2, max_days: 3 },
{ pincode: 581355, min_days: 2, max_days: 3 },
{ pincode: 581356, min_days: 2, max_days: 3 },
{ pincode: 581357, min_days: 2, max_days: 3 },
{ pincode: 581358, min_days: 2, max_days: 3 },
{ pincode: 581359, min_days: 2, max_days: 3 },
{ pincode: 581360, min_days: 2, max_days: 3 },
{ pincode: 581361, min_days: 2, max_days: 3 },
{ pincode: 581362, min_days: 2, max_days: 3 },
{ pincode: 581363, min_days: 2, max_days: 3 },
{ pincode: 581365, min_days: 2, max_days: 3 },
{ pincode: 581384, min_days: 2, max_days: 3 },
{ pincode: 581396, min_days: 2, max_days: 3 },
{ pincode: 581400, min_days: 2, max_days: 3 },
{ pincode: 581401, min_days: 2, max_days: 3 },
{ pincode: 581402, min_days: 2, max_days: 3 },
{ pincode: 581403, min_days: 2, max_days: 3 },
{ pincode: 581411, min_days: 2, max_days: 3 },
{ pincode: 581412, min_days: 2, max_days: 3 },
{ pincode: 581421, min_days: 2, max_days: 3 },
{ pincode: 581423, min_days: 2, max_days: 3 },
{ pincode: 581426, min_days: 2, max_days: 3 },
{ pincode: 581440, min_days: 2, max_days: 3 },
{ pincode: 581450, min_days: 2, max_days: 3 },
{ pincode: 581453, min_days: 2, max_days: 3 },
{ pincode: 582101, min_days: 2, max_days: 3 },
{ pincode: 582102, min_days: 2, max_days: 3 },
{ pincode: 582103, min_days: 2, max_days: 3 },
{ pincode: 582109, min_days: 2, max_days: 3 },
{ pincode: 582111, min_days: 2, max_days: 3 },
{ pincode: 582112, min_days: 2, max_days: 3 },
{ pincode: 582113, min_days: 2, max_days: 3 },
{ pincode: 582114, min_days: 2, max_days: 3 },
{ pincode: 582115, min_days: 2, max_days: 3 },
{ pincode: 582116, min_days: 2, max_days: 3 },
{ pincode: 582117, min_days: 2, max_days: 3 },
{ pincode: 582118, min_days: 2, max_days: 3 },
{ pincode: 582119, min_days: 2, max_days: 3 },
{ pincode: 582120, min_days: 2, max_days: 3 },
{ pincode: 582123, min_days: 2, max_days: 3 },
{ pincode: 582124, min_days: 2, max_days: 3 },
{ pincode: 582131, min_days: 2, max_days: 3 },
{ pincode: 582135, min_days: 2, max_days: 3 },
{ pincode: 582201, min_days: 2, max_days: 3 },
{ pincode: 582202, min_days: 2, max_days: 3 },
{ pincode: 582203, min_days: 2, max_days: 3 },
{ pincode: 582204, min_days: 2, max_days: 3 },
{ pincode: 582205, min_days: 2, max_days: 3 },
{ pincode: 582206, min_days: 2, max_days: 3 },
{ pincode: 582207, min_days: 2, max_days: 3 },
{ pincode: 582208, min_days: 2, max_days: 3 },
{ pincode: 582209, min_days: 2, max_days: 3 },
{ pincode: 582210, min_days: 2, max_days: 3 },
{ pincode: 582211, min_days: 2, max_days: 3 },
{ pincode: 582212, min_days: 2, max_days: 3 },
{ pincode: 582214, min_days: 2, max_days: 3 },
{ pincode: 582216, min_days: 2, max_days: 3 },
{ pincode: 582217, min_days: 2, max_days: 3 },
{ pincode: 582220, min_days: 2, max_days: 3 },
{ pincode: 582221, min_days: 2, max_days: 3 },
{ pincode: 582222, min_days: 2, max_days: 3 },
{ pincode: 582227, min_days: 2, max_days: 3 },
{ pincode: 582228, min_days: 2, max_days: 3 },
{ pincode: 582230, min_days: 2, max_days: 3 },
{ pincode: 582231, min_days: 2, max_days: 3 },
{ pincode: 582232, min_days: 2, max_days: 3 },
{ pincode: 582234, min_days: 2, max_days: 3 },
{ pincode: 582236, min_days: 2, max_days: 3 },
{ pincode: 582237, min_days: 2, max_days: 3 },
{ pincode: 582238, min_days: 2, max_days: 3 },
{ pincode: 582241, min_days: 2, max_days: 3 },
{ pincode: 582243, min_days: 2, max_days: 3 },
{ pincode: 582614, min_days: 2, max_days: 3 },
{ pincode: 583101, min_days: 2, max_days: 3 },
{ pincode: 583102, min_days: 2, max_days: 3 },
{ pincode: 583103, min_days: 2, max_days: 3 },
{ pincode: 583104, min_days: 2, max_days: 3 },
{ pincode: 583105, min_days: 2, max_days: 3 },
{ pincode: 583111, min_days: 2, max_days: 3 },
{ pincode: 583112, min_days: 2, max_days: 3 },
{ pincode: 583113, min_days: 2, max_days: 3 },
{ pincode: 583114, min_days: 2, max_days: 3 },
{ pincode: 583115, min_days: 2, max_days: 3 },
{ pincode: 583116, min_days: 2, max_days: 3 },
{ pincode: 583117, min_days: 2, max_days: 3 },
{ pincode: 583118, min_days: 2, max_days: 3 },
{ pincode: 583119, min_days: 2, max_days: 3 },
{ pincode: 583120, min_days: 2, max_days: 3 },
{ pincode: 583121, min_days: 2, max_days: 3 },
{ pincode: 583122, min_days: 2, max_days: 3 },
{ pincode: 583123, min_days: 2, max_days: 3 },
{ pincode: 583124, min_days: 2, max_days: 3 },
{ pincode: 583125, min_days: 2, max_days: 3 },
{ pincode: 583126, min_days: 2, max_days: 3 },
{ pincode: 583127, min_days: 2, max_days: 3 },
{ pincode: 583128, min_days: 2, max_days: 3 },
{ pincode: 583129, min_days: 2, max_days: 3 },
{ pincode: 583130, min_days: 2, max_days: 3 },
{ pincode: 583131, min_days: 2, max_days: 3 },
{ pincode: 583132, min_days: 2, max_days: 3 },
{ pincode: 583133, min_days: 2, max_days: 3 },
{ pincode: 583134, min_days: 2, max_days: 3 },
{ pincode: 583135, min_days: 2, max_days: 3 },
{ pincode: 583136, min_days: 2, max_days: 3 },
{ pincode: 583137, min_days: 2, max_days: 3 },
{ pincode: 583138, min_days: 2, max_days: 3 },
{ pincode: 583139, min_days: 2, max_days: 3 },
{ pincode: 583140, min_days: 2, max_days: 3 },
{ pincode: 583141, min_days: 2, max_days: 3 },
{ pincode: 583144, min_days: 2, max_days: 3 },
{ pincode: 583148, min_days: 2, max_days: 3 },
{ pincode: 583149, min_days: 2, max_days: 3 },
{ pincode: 583151, min_days: 2, max_days: 3 },
{ pincode: 583152, min_days: 2, max_days: 3 },
{ pincode: 583153, min_days: 2, max_days: 3 },
{ pincode: 583154, min_days: 2, max_days: 3 },
{ pincode: 583155, min_days: 2, max_days: 3 },
{ pincode: 583201, min_days: 2, max_days: 3 },
{ pincode: 583202, min_days: 2, max_days: 3 },
{ pincode: 583203, min_days: 2, max_days: 3 },
{ pincode: 583204, min_days: 2, max_days: 3 },
{ pincode: 583211, min_days: 2, max_days: 3 },
{ pincode: 583212, min_days: 2, max_days: 3 },
{ pincode: 583213, min_days: 2, max_days: 3 },
{ pincode: 583214, min_days: 2, max_days: 3 },
{ pincode: 583215, min_days: 2, max_days: 3 },
{ pincode: 583216, min_days: 2, max_days: 3 },
{ pincode: 583217, min_days: 2, max_days: 3 },
{ pincode: 583218, min_days: 2, max_days: 3 },
{ pincode: 583219, min_days: 2, max_days: 3 },
{ pincode: 583220, min_days: 2, max_days: 3 },
{ pincode: 583221, min_days: 2, max_days: 3 },
{ pincode: 583222, min_days: 2, max_days: 3 },
{ pincode: 583223, min_days: 2, max_days: 3 },
{ pincode: 583224, min_days: 2, max_days: 3 },
{ pincode: 583225, min_days: 2, max_days: 3 },
{ pincode: 583226, min_days: 2, max_days: 3 },
{ pincode: 583227, min_days: 2, max_days: 3 },
{ pincode: 583228, min_days: 2, max_days: 3 },
{ pincode: 583229, min_days: 2, max_days: 3 },
{ pincode: 583230, min_days: 2, max_days: 3 },
{ pincode: 583231, min_days: 2, max_days: 3 },
{ pincode: 583232, min_days: 2, max_days: 3 },
{ pincode: 583233, min_days: 2, max_days: 3 },
{ pincode: 583234, min_days: 2, max_days: 3 },
{ pincode: 583235, min_days: 2, max_days: 3 },
{ pincode: 583236, min_days: 2, max_days: 3 },
{ pincode: 583237, min_days: 2, max_days: 3 },
{ pincode: 583238, min_days: 2, max_days: 3 },
{ pincode: 583239, min_days: 2, max_days: 3 },
{ pincode: 583241, min_days: 2, max_days: 3 },
{ pincode: 583265, min_days: 2, max_days: 3 },
{ pincode: 583266, min_days: 2, max_days: 3 },
{ pincode: 583268, min_days: 2, max_days: 3 },
{ pincode: 583270, min_days: 2, max_days: 3 },
{ pincode: 583273, min_days: 2, max_days: 3 },
{ pincode: 583275, min_days: 2, max_days: 3 },
{ pincode: 583276, min_days: 2, max_days: 3 },
{ pincode: 583277, min_days: 2, max_days: 3 },
{ pincode: 583278, min_days: 2, max_days: 3 },
{ pincode: 583279, min_days: 2, max_days: 3 },
{ pincode: 583280, min_days: 2, max_days: 3 },
{ pincode: 583281, min_days: 2, max_days: 3 },
{ pincode: 583282, min_days: 2, max_days: 3 },
{ pincode: 583283, min_days: 2, max_days: 3 },
{ pincode: 583284, min_days: 2, max_days: 3 },
{ pincode: 583285, min_days: 2, max_days: 3 },
{ pincode: 583286, min_days: 2, max_days: 3 },
{ pincode: 583287, min_days: 2, max_days: 3 },
{ pincode: 583288, min_days: 2, max_days: 3 },
{ pincode: 584101, min_days: 2, max_days: 3 },
{ pincode: 584102, min_days: 2, max_days: 3 },
{ pincode: 584103, min_days: 2, max_days: 3 },
{ pincode: 584104, min_days: 2, max_days: 3 },
{ pincode: 584110, min_days: 2, max_days: 3 },
{ pincode: 584111, min_days: 2, max_days: 3 },
{ pincode: 584112, min_days: 2, max_days: 3 },
{ pincode: 584113, min_days: 2, max_days: 3 },
{ pincode: 584114, min_days: 2, max_days: 3 },
{ pincode: 584115, min_days: 2, max_days: 3 },
{ pincode: 584116, min_days: 2, max_days: 3 },
{ pincode: 584118, min_days: 2, max_days: 3 },
{ pincode: 584119, min_days: 2, max_days: 3 },
{ pincode: 584120, min_days: 2, max_days: 3 },
{ pincode: 584121, min_days: 2, max_days: 3 },
{ pincode: 584122, min_days: 2, max_days: 3 },
{ pincode: 584123, min_days: 2, max_days: 3 },
{ pincode: 584124, min_days: 2, max_days: 3 },
{ pincode: 584125, min_days: 2, max_days: 3 },
{ pincode: 584126, min_days: 2, max_days: 3 },
{ pincode: 584127, min_days: 2, max_days: 3 },
{ pincode: 584128, min_days: 2, max_days: 3 },
{ pincode: 584129, min_days: 2, max_days: 3 },
{ pincode: 584130, min_days: 2, max_days: 3 },
{ pincode: 584131, min_days: 2, max_days: 3 },
{ pincode: 584132, min_days: 2, max_days: 3 },
{ pincode: 584133, min_days: 2, max_days: 3 },
{ pincode: 584134, min_days: 2, max_days: 3 },
{ pincode: 584135, min_days: 2, max_days: 3 },
{ pincode: 584136, min_days: 2, max_days: 3 },
{ pincode: 584138, min_days: 2, max_days: 3 },
{ pincode: 584139, min_days: 2, max_days: 3 },
{ pincode: 584140, min_days: 2, max_days: 3 },
{ pincode: 584143, min_days: 2, max_days: 3 },
{ pincode: 584144, min_days: 2, max_days: 3 },
{ pincode: 584150, min_days: 2, max_days: 3 },
{ pincode: 584151, min_days: 2, max_days: 3 },
{ pincode: 584153, min_days: 2, max_days: 3 },
{ pincode: 584159, min_days: 2, max_days: 3 },
{ pincode: 584166, min_days: 2, max_days: 3 },
{ pincode: 584167, min_days: 2, max_days: 3 },
{ pincode: 584170, min_days: 2, max_days: 3 },
{ pincode: 584201, min_days: 2, max_days: 3 },
{ pincode: 584202, min_days: 2, max_days: 3 },
{ pincode: 584203, min_days: 2, max_days: 3 },
{ pincode: 585101, min_days: 2, max_days: 3 },
{ pincode: 585102, min_days: 2, max_days: 3 },
{ pincode: 585103, min_days: 2, max_days: 3 },
{ pincode: 585104, min_days: 2, max_days: 3 },
{ pincode: 585105, min_days: 2, max_days: 3 },
{ pincode: 585106, min_days: 2, max_days: 3 },
{ pincode: 585107, min_days: 2, max_days: 3 },
{ pincode: 585109, min_days: 2, max_days: 3 },
{ pincode: 585201, min_days: 2, max_days: 3 },
{ pincode: 585202, min_days: 2, max_days: 3 },
{ pincode: 585210, min_days: 2, max_days: 3 },
{ pincode: 585211, min_days: 2, max_days: 3 },
{ pincode: 585212, min_days: 2, max_days: 3 },
{ pincode: 585213, min_days: 2, max_days: 3 },
{ pincode: 585214, min_days: 2, max_days: 3 },
{ pincode: 585215, min_days: 2, max_days: 3 },
{ pincode: 585216, min_days: 2, max_days: 3 },
{ pincode: 585217, min_days: 2, max_days: 3 },
{ pincode: 585218, min_days: 2, max_days: 3 },
{ pincode: 585219, min_days: 2, max_days: 3 },
{ pincode: 585220, min_days: 2, max_days: 3 },
{ pincode: 585221, min_days: 2, max_days: 3 },
{ pincode: 585222, min_days: 2, max_days: 3 },
{ pincode: 585223, min_days: 2, max_days: 3 },
{ pincode: 585224, min_days: 2, max_days: 3 },
{ pincode: 585225, min_days: 2, max_days: 3 },
{ pincode: 585226, min_days: 2, max_days: 3 },
{ pincode: 585227, min_days: 2, max_days: 3 },
{ pincode: 585228, min_days: 2, max_days: 3 },
{ pincode: 585229, min_days: 2, max_days: 3 },
{ pincode: 585236, min_days: 2, max_days: 3 },
{ pincode: 585237, min_days: 2, max_days: 3 },
{ pincode: 585238, min_days: 2, max_days: 3 },
{ pincode: 585240, min_days: 2, max_days: 3 },
{ pincode: 585241, min_days: 2, max_days: 3 },
{ pincode: 585244, min_days: 2, max_days: 3 },
{ pincode: 585249, min_days: 2, max_days: 3 },
{ pincode: 585250, min_days: 2, max_days: 3 },
{ pincode: 585251, min_days: 2, max_days: 3 },
{ pincode: 585257, min_days: 2, max_days: 3 },
{ pincode: 585259, min_days: 2, max_days: 3 },
{ pincode: 585260, min_days: 2, max_days: 3 },
{ pincode: 585261, min_days: 2, max_days: 3 },
{ pincode: 585263, min_days: 2, max_days: 3 },
{ pincode: 585264, min_days: 2, max_days: 3 },
{ pincode: 585265, min_days: 2, max_days: 3 },
{ pincode: 585266, min_days: 2, max_days: 3 },
{ pincode: 585268, min_days: 2, max_days: 3 },
{ pincode: 585269, min_days: 2, max_days: 3 },
{ pincode: 585270, min_days: 2, max_days: 3 },
{ pincode: 585272, min_days: 2, max_days: 3 },
{ pincode: 585273, min_days: 2, max_days: 3 },
{ pincode: 585275, min_days: 2, max_days: 3 },
{ pincode: 585276, min_days: 2, max_days: 3 },
{ pincode: 585279, min_days: 2, max_days: 3 },
{ pincode: 585280, min_days: 2, max_days: 3 },
{ pincode: 585283, min_days: 2, max_days: 3 },
{ pincode: 585284, min_days: 2, max_days: 3 },
{ pincode: 585285, min_days: 2, max_days: 3 },
{ pincode: 585286, min_days: 2, max_days: 3 },
{ pincode: 585287, min_days: 2, max_days: 3 },
{ pincode: 585289, min_days: 2, max_days: 3 },
{ pincode: 585290, min_days: 2, max_days: 3 },
{ pincode: 585291, min_days: 2, max_days: 3 },
{ pincode: 585292, min_days: 2, max_days: 3 },
{ pincode: 585301, min_days: 2, max_days: 3 },
{ pincode: 585302, min_days: 2, max_days: 3 },
{ pincode: 585303, min_days: 2, max_days: 3 },
{ pincode: 585304, min_days: 2, max_days: 3 },
{ pincode: 585305, min_days: 2, max_days: 3 },
{ pincode: 585306, min_days: 2, max_days: 3 },
{ pincode: 585307, min_days: 2, max_days: 3 },
{ pincode: 585308, min_days: 2, max_days: 3 },
{ pincode: 585309, min_days: 2, max_days: 3 },
{ pincode: 585310, min_days: 2, max_days: 3 },
{ pincode: 585311, min_days: 2, max_days: 3 },
{ pincode: 585312, min_days: 2, max_days: 3 },
{ pincode: 585313, min_days: 2, max_days: 3 },
{ pincode: 585314, min_days: 2, max_days: 3 },
{ pincode: 585315, min_days: 2, max_days: 3 },
{ pincode: 585316, min_days: 2, max_days: 3 },
{ pincode: 585317, min_days: 2, max_days: 3 },
{ pincode: 585318, min_days: 2, max_days: 3 },
{ pincode: 585319, min_days: 2, max_days: 3 },
{ pincode: 585320, min_days: 2, max_days: 3 },
{ pincode: 585321, min_days: 2, max_days: 3 },
{ pincode: 585322, min_days: 2, max_days: 3 },
{ pincode: 585323, min_days: 2, max_days: 3 },
{ pincode: 585324, min_days: 2, max_days: 3 },
{ pincode: 585325, min_days: 2, max_days: 3 },
{ pincode: 585326, min_days: 2, max_days: 3 },
{ pincode: 585327, min_days: 2, max_days: 3 },
{ pincode: 585328, min_days: 2, max_days: 3 },
{ pincode: 585329, min_days: 2, max_days: 3 },
{ pincode: 585330, min_days: 2, max_days: 3 },
{ pincode: 585331, min_days: 2, max_days: 3 },
{ pincode: 585333, min_days: 2, max_days: 3 },
{ pincode: 585334, min_days: 2, max_days: 3 },
{ pincode: 585336, min_days: 2, max_days: 3 },
{ pincode: 585339, min_days: 2, max_days: 3 },
{ pincode: 585340, min_days: 2, max_days: 3 },
{ pincode: 585341, min_days: 2, max_days: 3 },
{ pincode: 585342, min_days: 2, max_days: 3 },
{ pincode: 585344, min_days: 2, max_days: 3 },
{ pincode: 585345, min_days: 2, max_days: 3 },
{ pincode: 585346, min_days: 2, max_days: 3 },
{ pincode: 585347, min_days: 2, max_days: 3 },
{ pincode: 585349, min_days: 2, max_days: 3 },
{ pincode: 585350, min_days: 2, max_days: 3 },
{ pincode: 585352, min_days: 2, max_days: 3 },
{ pincode: 585353, min_days: 2, max_days: 3 },
{ pincode: 585355, min_days: 2, max_days: 3 },
{ pincode: 585360, min_days: 2, max_days: 3 },
{ pincode: 585361, min_days: 2, max_days: 3 },
{ pincode: 585362, min_days: 2, max_days: 3 },
{ pincode: 585364, min_days: 2, max_days: 3 },
{ pincode: 585367, min_days: 2, max_days: 3 },
{ pincode: 585378, min_days: 2, max_days: 3 },
{ pincode: 585401, min_days: 2, max_days: 3 },
{ pincode: 585402, min_days: 2, max_days: 3 },
{ pincode: 585403, min_days: 2, max_days: 3 },
{ pincode: 585404, min_days: 2, max_days: 3 },
{ pincode: 585411, min_days: 2, max_days: 3 },
{ pincode: 585412, min_days: 2, max_days: 3 },
{ pincode: 585413, min_days: 2, max_days: 3 },
{ pincode: 585414, min_days: 2, max_days: 3 },
{ pincode: 585415, min_days: 2, max_days: 3 },
{ pincode: 585416, min_days: 2, max_days: 3 },
{ pincode: 585417, min_days: 2, max_days: 3 },
{ pincode: 585418, min_days: 2, max_days: 3 },
{ pincode: 585419, min_days: 2, max_days: 3 },
{ pincode: 585421, min_days: 2, max_days: 3 },
{ pincode: 585422, min_days: 2, max_days: 3 },
{ pincode: 585423, min_days: 2, max_days: 3 },
{ pincode: 585424, min_days: 2, max_days: 3 },
{ pincode: 585425, min_days: 2, max_days: 3 },
{ pincode: 585427, min_days: 2, max_days: 3 },
{ pincode: 585428, min_days: 2, max_days: 3 },
{ pincode: 585429, min_days: 2, max_days: 3 },
{ pincode: 585431, min_days: 2, max_days: 3 },
{ pincode: 585432, min_days: 2, max_days: 3 },
{ pincode: 585433, min_days: 2, max_days: 3 },
{ pincode: 585436, min_days: 2, max_days: 3 },
{ pincode: 585437, min_days: 2, max_days: 3 },
{ pincode: 585441, min_days: 2, max_days: 3 },
{ pincode: 585442, min_days: 2, max_days: 3 },
{ pincode: 585443, min_days: 2, max_days: 3 },
{ pincode: 585444, min_days: 2, max_days: 3 },
{ pincode: 585445, min_days: 2, max_days: 3 },
{ pincode: 585446, min_days: 2, max_days: 3 },
{ pincode: 585447, min_days: 2, max_days: 3 },
{ pincode: 585448, min_days: 2, max_days: 3 },
{ pincode: 586101, min_days: 2, max_days: 3 },
{ pincode: 586102, min_days: 2, max_days: 3 },
{ pincode: 586103, min_days: 2, max_days: 3 },
{ pincode: 586104, min_days: 2, max_days: 3 },
{ pincode: 586105, min_days: 2, max_days: 3 },
{ pincode: 586106, min_days: 2, max_days: 3 },
{ pincode: 586107, min_days: 2, max_days: 3 },
{ pincode: 586108, min_days: 2, max_days: 3 },
{ pincode: 586109, min_days: 2, max_days: 3 },
{ pincode: 586111, min_days: 2, max_days: 3 },
{ pincode: 586112, min_days: 2, max_days: 3 },
{ pincode: 586113, min_days: 2, max_days: 3 },
{ pincode: 586114, min_days: 2, max_days: 3 },
{ pincode: 586115, min_days: 2, max_days: 3 },
{ pincode: 586116, min_days: 2, max_days: 3 },
{ pincode: 586117, min_days: 2, max_days: 3 },
{ pincode: 586118, min_days: 2, max_days: 3 },
{ pincode: 586119, min_days: 2, max_days: 3 },
{ pincode: 586120, min_days: 2, max_days: 3 },
{ pincode: 586121, min_days: 2, max_days: 3 },
{ pincode: 586122, min_days: 2, max_days: 3 },
{ pincode: 586123, min_days: 2, max_days: 3 },
{ pincode: 586124, min_days: 2, max_days: 3 },
{ pincode: 586125, min_days: 2, max_days: 3 },
{ pincode: 586126, min_days: 2, max_days: 3 },
{ pincode: 586127, min_days: 2, max_days: 3 },
{ pincode: 586128, min_days: 2, max_days: 3 },
{ pincode: 586129, min_days: 2, max_days: 3 },
{ pincode: 586130, min_days: 2, max_days: 3 },
{ pincode: 586136, min_days: 2, max_days: 3 },
{ pincode: 586138, min_days: 2, max_days: 3 },
{ pincode: 586142, min_days: 2, max_days: 3 },
{ pincode: 586150, min_days: 2, max_days: 3 },
{ pincode: 586157, min_days: 2, max_days: 3 },
{ pincode: 586166, min_days: 2, max_days: 3 },
{ pincode: 586168, min_days: 2, max_days: 3 },
{ pincode: 586201, min_days: 2, max_days: 3 },
{ pincode: 586202, min_days: 2, max_days: 3 },
{ pincode: 586203, min_days: 2, max_days: 3 },
{ pincode: 586204, min_days: 2, max_days: 3 },
{ pincode: 586205, min_days: 2, max_days: 3 },
{ pincode: 586206, min_days: 2, max_days: 3 },
{ pincode: 586207, min_days: 2, max_days: 3 },
{ pincode: 586208, min_days: 2, max_days: 3 },
{ pincode: 586209, min_days: 2, max_days: 3 },
{ pincode: 586210, min_days: 2, max_days: 3 },
{ pincode: 586211, min_days: 2, max_days: 3 },
{ pincode: 586212, min_days: 2, max_days: 3 },
{ pincode: 586213, min_days: 2, max_days: 3 },
{ pincode: 586214, min_days: 2, max_days: 3 },
{ pincode: 586215, min_days: 2, max_days: 3 },
{ pincode: 586216, min_days: 2, max_days: 3 },
{ pincode: 586217, min_days: 2, max_days: 3 },
{ pincode: 586220, min_days: 2, max_days: 3 },
{ pincode: 586227, min_days: 2, max_days: 3 },
{ pincode: 586229, min_days: 2, max_days: 3 },
{ pincode: 586235, min_days: 2, max_days: 3 },
{ pincode: 586241, min_days: 2, max_days: 3 },
{ pincode: 586242, min_days: 2, max_days: 3 },
{ pincode: 586245, min_days: 2, max_days: 3 },
{ pincode: 587101, min_days: 2, max_days: 3 },
{ pincode: 587102, min_days: 2, max_days: 3 },
{ pincode: 587103, min_days: 2, max_days: 3 },
{ pincode: 587104, min_days: 2, max_days: 3 },
{ pincode: 587111, min_days: 2, max_days: 3 },
{ pincode: 587112, min_days: 2, max_days: 3 },
{ pincode: 587113, min_days: 2, max_days: 3 },
{ pincode: 587114, min_days: 2, max_days: 3 },
{ pincode: 587115, min_days: 2, max_days: 3 },
{ pincode: 587116, min_days: 2, max_days: 3 },
{ pincode: 587117, min_days: 2, max_days: 3 },
{ pincode: 587118, min_days: 2, max_days: 3 },
{ pincode: 587119, min_days: 2, max_days: 3 },
{ pincode: 587120, min_days: 2, max_days: 3 },
{ pincode: 587121, min_days: 2, max_days: 3 },
{ pincode: 587122, min_days: 2, max_days: 3 },
{ pincode: 587123, min_days: 2, max_days: 3 },
{ pincode: 587124, min_days: 2, max_days: 3 },
{ pincode: 587125, min_days: 2, max_days: 3 },
{ pincode: 587126, min_days: 2, max_days: 3 },
{ pincode: 587128, min_days: 2, max_days: 3 },
{ pincode: 587133, min_days: 2, max_days: 3 },
{ pincode: 587134, min_days: 2, max_days: 3 },
{ pincode: 587135, min_days: 2, max_days: 3 },
{ pincode: 587145, min_days: 2, max_days: 3 },
{ pincode: 587146, min_days: 2, max_days: 3 },
{ pincode: 587147, min_days: 2, max_days: 3 },
{ pincode: 587154, min_days: 2, max_days: 3 },
{ pincode: 587155, min_days: 2, max_days: 3 },
{ pincode: 587156, min_days: 2, max_days: 3 },
{ pincode: 587157, min_days: 2, max_days: 3 },
{ pincode: 587201, min_days: 2, max_days: 3 },
{ pincode: 587202, min_days: 2, max_days: 3 },
{ pincode: 587203, min_days: 2, max_days: 3 },
{ pincode: 587204, min_days: 2, max_days: 3 },
{ pincode: 587205, min_days: 2, max_days: 3 },
{ pincode: 587206, min_days: 2, max_days: 3 },
{ pincode: 587207, min_days: 2, max_days: 3 },
{ pincode: 587209, min_days: 2, max_days: 3 },
{ pincode: 587210, min_days: 2, max_days: 3 },
{ pincode: 587211, min_days: 2, max_days: 3 },
{ pincode: 587213, min_days: 2, max_days: 3 },
{ pincode: 587215, min_days: 2, max_days: 3 },
{ pincode: 587242, min_days: 2, max_days: 3 },
{ pincode: 587301, min_days: 2, max_days: 3 },
{ pincode: 587302, min_days: 2, max_days: 3 },
{ pincode: 587303, min_days: 2, max_days: 3 },
{ pincode: 587304, min_days: 2, max_days: 3 },
{ pincode: 587305, min_days: 2, max_days: 3 },
{ pincode: 587310, min_days: 2, max_days: 3 },
{ pincode: 587311, min_days: 2, max_days: 3 },
{ pincode: 587312, min_days: 2, max_days: 3 },
{ pincode: 587313, min_days: 2, max_days: 3 },
{ pincode: 587314, min_days: 2, max_days: 3 },
{ pincode: 587315, min_days: 2, max_days: 3 },
{ pincode: 587316, min_days: 2, max_days: 3 },
{ pincode: 587317, min_days: 2, max_days: 3 },
{ pincode: 587319, min_days: 2, max_days: 3 },
{ pincode: 587320, min_days: 2, max_days: 3 },
{ pincode: 587321, min_days: 2, max_days: 3 },
{ pincode: 587323, min_days: 2, max_days: 3 },
{ pincode: 587328, min_days: 2, max_days: 3 },
{ pincode: 587330, min_days: 2, max_days: 3 },
{ pincode: 587331, min_days: 2, max_days: 3 },
{ pincode: 589112, min_days: 2, max_days: 3 },
{ pincode: 589301, min_days: 2, max_days: 3 },
{ pincode: 590001, min_days: 2, max_days: 3 },
{ pincode: 590002, min_days: 2, max_days: 3 },
{ pincode: 590003, min_days: 2, max_days: 3 },
{ pincode: 590004, min_days: 2, max_days: 3 },
{ pincode: 590005, min_days: 2, max_days: 3 },
{ pincode: 590006, min_days: 2, max_days: 3 },
{ pincode: 590007, min_days: 2, max_days: 3 },
{ pincode: 590008, min_days: 2, max_days: 3 },
{ pincode: 590009, min_days: 2, max_days: 3 },
{ pincode: 590010, min_days: 2, max_days: 3 },
{ pincode: 590011, min_days: 2, max_days: 3 },
{ pincode: 590012, min_days: 2, max_days: 3 },
{ pincode: 590013, min_days: 2, max_days: 3 },
{ pincode: 590014, min_days: 2, max_days: 3 },
{ pincode: 590015, min_days: 2, max_days: 3 },
{ pincode: 590016, min_days: 2, max_days: 3 },
{ pincode: 590017, min_days: 2, max_days: 3 },
{ pincode: 590018, min_days: 2, max_days: 3 },
{ pincode: 590019, min_days: 2, max_days: 3 },
{ pincode: 590020, min_days: 2, max_days: 3 },
{ pincode: 591001, min_days: 2, max_days: 3 },
{ pincode: 591002, min_days: 2, max_days: 3 },
{ pincode: 591003, min_days: 2, max_days: 3 },
{ pincode: 591004, min_days: 2, max_days: 3 },
{ pincode: 591101, min_days: 2, max_days: 3 },
{ pincode: 591102, min_days: 2, max_days: 3 },
{ pincode: 591103, min_days: 2, max_days: 3 },
{ pincode: 591104, min_days: 2, max_days: 3 },
{ pincode: 591106, min_days: 2, max_days: 3 },
{ pincode: 591107, min_days: 2, max_days: 3 },
{ pincode: 591108, min_days: 2, max_days: 3 },
{ pincode: 591109, min_days: 2, max_days: 3 },
{ pincode: 591110, min_days: 2, max_days: 3 },
{ pincode: 591111, min_days: 2, max_days: 3 },
{ pincode: 591112, min_days: 2, max_days: 3 },
{ pincode: 591113, min_days: 2, max_days: 3 },
{ pincode: 591114, min_days: 2, max_days: 3 },
{ pincode: 591115, min_days: 2, max_days: 3 },
{ pincode: 591116, min_days: 2, max_days: 3 },
{ pincode: 591117, min_days: 2, max_days: 3 },
{ pincode: 591118, min_days: 2, max_days: 3 },
{ pincode: 591119, min_days: 2, max_days: 3 },
{ pincode: 591120, min_days: 2, max_days: 3 },
{ pincode: 591121, min_days: 2, max_days: 3 },
{ pincode: 591122, min_days: 2, max_days: 3 },
{ pincode: 591123, min_days: 2, max_days: 3 },
{ pincode: 591124, min_days: 2, max_days: 3 },
{ pincode: 591125, min_days: 2, max_days: 3 },
{ pincode: 591126, min_days: 2, max_days: 3 },
{ pincode: 591127, min_days: 2, max_days: 3 },
{ pincode: 591128, min_days: 2, max_days: 3 },
{ pincode: 591129, min_days: 2, max_days: 3 },
{ pincode: 591130, min_days: 2, max_days: 3 },
{ pincode: 591131, min_days: 2, max_days: 3 },
{ pincode: 591133, min_days: 2, max_days: 3 },
{ pincode: 591136, min_days: 2, max_days: 3 },
{ pincode: 591137, min_days: 2, max_days: 3 },
{ pincode: 591139, min_days: 2, max_days: 3 },
{ pincode: 591140, min_days: 2, max_days: 3 },
{ pincode: 591143, min_days: 2, max_days: 3 },
{ pincode: 591147, min_days: 2, max_days: 3 },
{ pincode: 591151, min_days: 2, max_days: 3 },
{ pincode: 591153, min_days: 2, max_days: 3 },
{ pincode: 591155, min_days: 2, max_days: 3 },
{ pincode: 591156, min_days: 2, max_days: 3 },
{ pincode: 591159, min_days: 2, max_days: 3 },
{ pincode: 591162, min_days: 2, max_days: 3 },
{ pincode: 591163, min_days: 2, max_days: 3 },
{ pincode: 591168, min_days: 2, max_days: 3 },
{ pincode: 591169, min_days: 2, max_days: 3 },
{ pincode: 591173, min_days: 2, max_days: 3 },
{ pincode: 591175, min_days: 2, max_days: 3 },
{ pincode: 591177, min_days: 2, max_days: 3 },
{ pincode: 591180, min_days: 2, max_days: 3 },
{ pincode: 591181, min_days: 2, max_days: 3 },
{ pincode: 591183, min_days: 2, max_days: 3 },
{ pincode: 591188, min_days: 2, max_days: 3 },
{ pincode: 591189, min_days: 2, max_days: 3 },
{ pincode: 591190, min_days: 2, max_days: 3 },
{ pincode: 591191, min_days: 2, max_days: 3 },
{ pincode: 591194, min_days: 2, max_days: 3 },
{ pincode: 591198, min_days: 2, max_days: 3 },
{ pincode: 591201, min_days: 2, max_days: 3 },
{ pincode: 591211, min_days: 2, max_days: 3 },
{ pincode: 591212, min_days: 2, max_days: 3 },
{ pincode: 591213, min_days: 2, max_days: 3 },
{ pincode: 591214, min_days: 2, max_days: 3 },
{ pincode: 591215, min_days: 2, max_days: 3 },
{ pincode: 591216, min_days: 2, max_days: 3 },
{ pincode: 591217, min_days: 2, max_days: 3 },
{ pincode: 591218, min_days: 2, max_days: 3 },
{ pincode: 591219, min_days: 2, max_days: 3 },
{ pincode: 591220, min_days: 2, max_days: 3 },
{ pincode: 591221, min_days: 2, max_days: 3 },
{ pincode: 591222, min_days: 2, max_days: 3 },
{ pincode: 591223, min_days: 2, max_days: 3 },
{ pincode: 591224, min_days: 2, max_days: 3 },
{ pincode: 591225, min_days: 2, max_days: 3 },
{ pincode: 591226, min_days: 2, max_days: 3 },
{ pincode: 591227, min_days: 2, max_days: 3 },
{ pincode: 591228, min_days: 2, max_days: 3 },
{ pincode: 591229, min_days: 2, max_days: 3 },
{ pincode: 591230, min_days: 2, max_days: 3 },
{ pincode: 591231, min_days: 2, max_days: 3 },
{ pincode: 591232, min_days: 2, max_days: 3 },
{ pincode: 591233, min_days: 2, max_days: 3 },
{ pincode: 591234, min_days: 2, max_days: 3 },
{ pincode: 591235, min_days: 2, max_days: 3 },
{ pincode: 591236, min_days: 2, max_days: 3 },
{ pincode: 591237, min_days: 2, max_days: 3 },
{ pincode: 591238, min_days: 2, max_days: 3 },
{ pincode: 591239, min_days: 2, max_days: 3 },
{ pincode: 591240, min_days: 2, max_days: 3 },
{ pincode: 591241, min_days: 2, max_days: 3 },
{ pincode: 591242, min_days: 2, max_days: 3 },
{ pincode: 591243, min_days: 2, max_days: 3 },
{ pincode: 591244, min_days: 2, max_days: 3 },
{ pincode: 591245, min_days: 2, max_days: 3 },
{ pincode: 591246, min_days: 2, max_days: 3 },
{ pincode: 591247, min_days: 2, max_days: 3 },
{ pincode: 591248, min_days: 2, max_days: 3 },
{ pincode: 591249, min_days: 2, max_days: 3 },
{ pincode: 591253, min_days: 2, max_days: 3 },
{ pincode: 591254, min_days: 2, max_days: 3 },
{ pincode: 591255, min_days: 2, max_days: 3 },
{ pincode: 591256, min_days: 2, max_days: 3 },
{ pincode: 591262, min_days: 2, max_days: 3 },
{ pincode: 591263, min_days: 2, max_days: 3 },
{ pincode: 591264, min_days: 2, max_days: 3 },
{ pincode: 591265, min_days: 2, max_days: 3 },
{ pincode: 591268, min_days: 2, max_days: 3 },
{ pincode: 591269, min_days: 2, max_days: 3 },
{ pincode: 591273, min_days: 2, max_days: 3 },
{ pincode: 591280, min_days: 2, max_days: 3 },
{ pincode: 591281, min_days: 2, max_days: 3 },
{ pincode: 591283, min_days: 2, max_days: 3 },
{ pincode: 591284, min_days: 2, max_days: 3 },
{ pincode: 591287, min_days: 2, max_days: 3 },
{ pincode: 591292, min_days: 2, max_days: 3 },
{ pincode: 591297, min_days: 2, max_days: 3 },
{ pincode: 591299, min_days: 2, max_days: 3 },
{ pincode: 591301, min_days: 2, max_days: 3 },
{ pincode: 591302, min_days: 2, max_days: 3 },
{ pincode: 591303, min_days: 2, max_days: 3 },
{ pincode: 591304, min_days: 2, max_days: 3 },
{ pincode: 591305, min_days: 2, max_days: 3 },
{ pincode: 591306, min_days: 2, max_days: 3 },
{ pincode: 591307, min_days: 2, max_days: 3 },
{ pincode: 591308, min_days: 2, max_days: 3 },
{ pincode: 591309, min_days: 2, max_days: 3 },
{ pincode: 591310, min_days: 2, max_days: 3 },
{ pincode: 591311, min_days: 2, max_days: 3 },
{ pincode: 591312, min_days: 2, max_days: 3 },
{ pincode: 591313, min_days: 2, max_days: 3 },
{ pincode: 591314, min_days: 2, max_days: 3 },
{ pincode: 591315, min_days: 2, max_days: 3 },
{ pincode: 591316, min_days: 2, max_days: 3 },
{ pincode: 591317, min_days: 2, max_days: 3 },
{ pincode: 591318, min_days: 2, max_days: 3 },
{ pincode: 591319, min_days: 2, max_days: 3 },
{ pincode: 591320, min_days: 2, max_days: 3 },
{ pincode: 591322, min_days: 2, max_days: 3 },
{ pincode: 591327, min_days: 2, max_days: 3 },
{ pincode: 591328, min_days: 2, max_days: 3 },
{ pincode: 591332, min_days: 2, max_days: 3 },
{ pincode: 591333, min_days: 2, max_days: 3 },
{ pincode: 591339, min_days: 2, max_days: 3 },
{ pincode: 591340, min_days: 2, max_days: 3 },
{ pincode: 591342, min_days: 2, max_days: 3 },
{ pincode: 591343, min_days: 2, max_days: 3 },
{ pincode: 591344, min_days: 2, max_days: 3 },
{ pincode: 591345, min_days: 2, max_days: 3 },
{ pincode: 591346, min_days: 2, max_days: 3 },
{ pincode: 591503, min_days: 2, max_days: 3 },
{ pincode: 591504, min_days: 2, max_days: 3 },
{ pincode: 591506, min_days: 2, max_days: 3 },
{ pincode: 591507, min_days: 2, max_days: 3 },
{ pincode: 591510, min_days: 2, max_days: 3 },
{ pincode: 591512, min_days: 2, max_days: 3 },
{ pincode: 591516, min_days: 2, max_days: 3 },
{ pincode: 591701, min_days: 2, max_days: 3 },
{ pincode: 599991, min_days: 2, max_days: 3 },
{ pincode: 600001, min_days: 2, max_days: 3 },
{ pincode: 600002, min_days: 2, max_days: 3 },
{ pincode: 600003, min_days: 2, max_days: 3 },
{ pincode: 600004, min_days: 2, max_days: 3 },
{ pincode: 600005, min_days: 2, max_days: 3 },
{ pincode: 600006, min_days: 2, max_days: 3 },
{ pincode: 600007, min_days: 2, max_days: 3 },
{ pincode: 600008, min_days: 2, max_days: 3 },
{ pincode: 600009, min_days: 2, max_days: 3 },
{ pincode: 600010, min_days: 2, max_days: 3 },
{ pincode: 600011, min_days: 2, max_days: 3 },
{ pincode: 600012, min_days: 2, max_days: 3 },
{ pincode: 600013, min_days: 2, max_days: 3 },
{ pincode: 600014, min_days: 2, max_days: 3 },
{ pincode: 600015, min_days: 2, max_days: 3 },
{ pincode: 600016, min_days: 2, max_days: 3 },
{ pincode: 600017, min_days: 2, max_days: 3 },
{ pincode: 600018, min_days: 2, max_days: 3 },
{ pincode: 600019, min_days: 2, max_days: 3 },
{ pincode: 600020, min_days: 2, max_days: 3 },
{ pincode: 600021, min_days: 2, max_days: 3 },
{ pincode: 600022, min_days: 2, max_days: 3 },
{ pincode: 600023, min_days: 2, max_days: 3 },
{ pincode: 600024, min_days: 2, max_days: 3 },
{ pincode: 600025, min_days: 2, max_days: 3 },
{ pincode: 600026, min_days: 2, max_days: 3 },
{ pincode: 600027, min_days: 2, max_days: 3 },
{ pincode: 600028, min_days: 2, max_days: 3 },
{ pincode: 600029, min_days: 2, max_days: 3 },
{ pincode: 600030, min_days: 2, max_days: 3 },
{ pincode: 600031, min_days: 2, max_days: 3 },
{ pincode: 600032, min_days: 2, max_days: 3 },
{ pincode: 600033, min_days: 2, max_days: 3 },
{ pincode: 600034, min_days: 2, max_days: 3 },
{ pincode: 600035, min_days: 2, max_days: 3 },
{ pincode: 600036, min_days: 2, max_days: 3 },
{ pincode: 600037, min_days: 2, max_days: 3 },
{ pincode: 600038, min_days: 2, max_days: 3 },
{ pincode: 600039, min_days: 2, max_days: 3 },
{ pincode: 600040, min_days: 2, max_days: 3 },
{ pincode: 600041, min_days: 2, max_days: 3 },
{ pincode: 600042, min_days: 2, max_days: 3 },
{ pincode: 600043, min_days: 2, max_days: 3 },
{ pincode: 600044, min_days: 2, max_days: 3 },
{ pincode: 600045, min_days: 2, max_days: 3 },
{ pincode: 600046, min_days: 2, max_days: 3 },
{ pincode: 600047, min_days: 2, max_days: 3 },
{ pincode: 600048, min_days: 2, max_days: 3 },
{ pincode: 600049, min_days: 2, max_days: 3 },
{ pincode: 600050, min_days: 2, max_days: 3 },
{ pincode: 600051, min_days: 2, max_days: 3 },
{ pincode: 600052, min_days: 2, max_days: 3 },
{ pincode: 600053, min_days: 2, max_days: 3 },
{ pincode: 600054, min_days: 2, max_days: 3 },
{ pincode: 600055, min_days: 2, max_days: 3 },
{ pincode: 600056, min_days: 2, max_days: 3 },
{ pincode: 600057, min_days: 2, max_days: 3 },
{ pincode: 600058, min_days: 2, max_days: 3 },
{ pincode: 600059, min_days: 2, max_days: 3 },
{ pincode: 600060, min_days: 2, max_days: 3 },
{ pincode: 600061, min_days: 2, max_days: 3 },
{ pincode: 600062, min_days: 2, max_days: 3 },
{ pincode: 600063, min_days: 2, max_days: 3 },
{ pincode: 600064, min_days: 2, max_days: 3 },
{ pincode: 600065, min_days: 2, max_days: 3 },
{ pincode: 600066, min_days: 2, max_days: 3 },
{ pincode: 600067, min_days: 2, max_days: 3 },
{ pincode: 600068, min_days: 2, max_days: 3 },
{ pincode: 600069, min_days: 2, max_days: 3 },
{ pincode: 600070, min_days: 2, max_days: 3 },
{ pincode: 600071, min_days: 2, max_days: 3 },
{ pincode: 600072, min_days: 2, max_days: 3 },
{ pincode: 600073, min_days: 2, max_days: 3 },
{ pincode: 600074, min_days: 2, max_days: 3 },
{ pincode: 600075, min_days: 2, max_days: 3 },
{ pincode: 600076, min_days: 2, max_days: 3 },
{ pincode: 600077, min_days: 2, max_days: 3 },
{ pincode: 600078, min_days: 2, max_days: 3 },
{ pincode: 600079, min_days: 2, max_days: 3 },
{ pincode: 600080, min_days: 2, max_days: 3 },
{ pincode: 600081, min_days: 2, max_days: 3 },
{ pincode: 600082, min_days: 2, max_days: 3 },
{ pincode: 600083, min_days: 2, max_days: 3 },
{ pincode: 600084, min_days: 2, max_days: 3 },
{ pincode: 600085, min_days: 2, max_days: 3 },
{ pincode: 600086, min_days: 2, max_days: 3 },
{ pincode: 600087, min_days: 2, max_days: 3 },
{ pincode: 600088, min_days: 2, max_days: 3 },
{ pincode: 600089, min_days: 2, max_days: 3 },
{ pincode: 600090, min_days: 2, max_days: 3 },
{ pincode: 600091, min_days: 2, max_days: 3 },
{ pincode: 600092, min_days: 2, max_days: 3 },
{ pincode: 600093, min_days: 2, max_days: 3 },
{ pincode: 600094, min_days: 2, max_days: 3 },
{ pincode: 600095, min_days: 2, max_days: 3 },
{ pincode: 600096, min_days: 2, max_days: 3 },
{ pincode: 600097, min_days: 2, max_days: 3 },
{ pincode: 600098, min_days: 2, max_days: 3 },
{ pincode: 600099, min_days: 2, max_days: 3 },
{ pincode: 600100, min_days: 2, max_days: 3 },
{ pincode: 600101, min_days: 2, max_days: 3 },
{ pincode: 600102, min_days: 2, max_days: 3 },
{ pincode: 600103, min_days: 2, max_days: 3 },
{ pincode: 600104, min_days: 2, max_days: 3 },
{ pincode: 600105, min_days: 2, max_days: 3 },
{ pincode: 600106, min_days: 2, max_days: 3 },
{ pincode: 600107, min_days: 2, max_days: 3 },
{ pincode: 600108, min_days: 2, max_days: 3 },
{ pincode: 600109, min_days: 2, max_days: 3 },
{ pincode: 600110, min_days: 2, max_days: 3 },
{ pincode: 600111, min_days: 2, max_days: 3 },
{ pincode: 600112, min_days: 2, max_days: 3 },
{ pincode: 600113, min_days: 2, max_days: 3 },
{ pincode: 600114, min_days: 2, max_days: 3 },
{ pincode: 600115, min_days: 2, max_days: 3 },
{ pincode: 600116, min_days: 2, max_days: 3 },
{ pincode: 600117, min_days: 2, max_days: 3 },
{ pincode: 600118, min_days: 2, max_days: 3 },
{ pincode: 600119, min_days: 2, max_days: 3 },
{ pincode: 600120, min_days: 2, max_days: 3 },
{ pincode: 600121, min_days: 2, max_days: 3 },
{ pincode: 600122, min_days: 2, max_days: 3 },
{ pincode: 600123, min_days: 2, max_days: 3 },
{ pincode: 600124, min_days: 2, max_days: 3 },
{ pincode: 600125, min_days: 2, max_days: 3 },
{ pincode: 600126, min_days: 2, max_days: 3 },
{ pincode: 600127, min_days: 2, max_days: 3 },
{ pincode: 600128, min_days: 2, max_days: 3 },
{ pincode: 600129, min_days: 2, max_days: 3 },
{ pincode: 600130, min_days: 2, max_days: 3 },
{ pincode: 600131, min_days: 2, max_days: 3 },
{ pincode: 600132, min_days: 2, max_days: 3 },
{ pincode: 600140, min_days: 2, max_days: 3 },
{ pincode: 600186, min_days: 2, max_days: 3 },
{ pincode: 601101, min_days: 2, max_days: 3 },
{ pincode: 601102, min_days: 2, max_days: 3 },
{ pincode: 601103, min_days: 2, max_days: 3 },
{ pincode: 601104, min_days: 2, max_days: 3 },
{ pincode: 601105, min_days: 2, max_days: 3 },
{ pincode: 601201, min_days: 2, max_days: 3 },
{ pincode: 601202, min_days: 2, max_days: 3 },
{ pincode: 601203, min_days: 2, max_days: 3 },
{ pincode: 601204, min_days: 2, max_days: 3 },
{ pincode: 601205, min_days: 2, max_days: 3 },
{ pincode: 601206, min_days: 2, max_days: 3 },
{ pincode: 601207, min_days: 2, max_days: 3 },
{ pincode: 601208, min_days: 2, max_days: 3 },
{ pincode: 601209, min_days: 2, max_days: 3 },
{ pincode: 601210, min_days: 2, max_days: 3 },
{ pincode: 601211, min_days: 2, max_days: 3 },
{ pincode: 601212, min_days: 2, max_days: 3 },
{ pincode: 601213, min_days: 2, max_days: 3 },
{ pincode: 601214, min_days: 2, max_days: 3 },
{ pincode: 601295, min_days: 2, max_days: 3 },
{ pincode: 601301, min_days: 2, max_days: 3 },
{ pincode: 601302, min_days: 2, max_days: 3 },
{ pincode: 601303, min_days: 2, max_days: 3 },
{ pincode: 601304, min_days: 2, max_days: 3 },
{ pincode: 601506, min_days: 2, max_days: 3 },
{ pincode: 601802, min_days: 2, max_days: 3 },
{ pincode: 602001, min_days: 2, max_days: 3 },
{ pincode: 602002, min_days: 2, max_days: 3 },
{ pincode: 602003, min_days: 2, max_days: 3 },
{ pincode: 602004, min_days: 2, max_days: 3 },
{ pincode: 602021, min_days: 2, max_days: 3 },
{ pincode: 602022, min_days: 2, max_days: 3 },
{ pincode: 602023, min_days: 2, max_days: 3 },
{ pincode: 602024, min_days: 2, max_days: 3 },
{ pincode: 602025, min_days: 2, max_days: 3 },
{ pincode: 602026, min_days: 2, max_days: 3 },
{ pincode: 602027, min_days: 2, max_days: 3 },
{ pincode: 602028, min_days: 2, max_days: 3 },
{ pincode: 602029, min_days: 2, max_days: 3 },
{ pincode: 602030, min_days: 2, max_days: 3 },
{ pincode: 602031, min_days: 2, max_days: 3 },
{ pincode: 602087, min_days: 2, max_days: 3 },
{ pincode: 602088, min_days: 2, max_days: 3 },
{ pincode: 602089, min_days: 2, max_days: 3 },
{ pincode: 602101, min_days: 2, max_days: 3 },
{ pincode: 602102, min_days: 2, max_days: 3 },
{ pincode: 602103, min_days: 2, max_days: 3 },
{ pincode: 602104, min_days: 2, max_days: 3 },
{ pincode: 602105, min_days: 2, max_days: 3 },
{ pincode: 602106, min_days: 2, max_days: 3 },
{ pincode: 602107, min_days: 2, max_days: 3 },
{ pincode: 602108, min_days: 2, max_days: 3 },
{ pincode: 602109, min_days: 2, max_days: 3 },
{ pincode: 602111, min_days: 2, max_days: 3 },
{ pincode: 602112, min_days: 2, max_days: 3 },
{ pincode: 602113, min_days: 2, max_days: 3 },
{ pincode: 602114, min_days: 2, max_days: 3 },
{ pincode: 602117, min_days: 2, max_days: 3 },
{ pincode: 603001, min_days: 2, max_days: 3 },
{ pincode: 603002, min_days: 2, max_days: 3 },
{ pincode: 603003, min_days: 2, max_days: 3 },
{ pincode: 603004, min_days: 2, max_days: 3 },
{ pincode: 603011, min_days: 2, max_days: 3 },
{ pincode: 603048, min_days: 2, max_days: 3 },
{ pincode: 603101, min_days: 2, max_days: 3 },
{ pincode: 603102, min_days: 2, max_days: 3 },
{ pincode: 603103, min_days: 2, max_days: 3 },
{ pincode: 603104, min_days: 2, max_days: 3 },
{ pincode: 603105, min_days: 2, max_days: 3 },
{ pincode: 603106, min_days: 2, max_days: 3 },
{ pincode: 603107, min_days: 2, max_days: 3 },
{ pincode: 603108, min_days: 2, max_days: 3 },
{ pincode: 603109, min_days: 2, max_days: 3 },
{ pincode: 603110, min_days: 2, max_days: 3 },
{ pincode: 603111, min_days: 2, max_days: 3 },
{ pincode: 603112, min_days: 2, max_days: 3 },
{ pincode: 603113, min_days: 2, max_days: 3 },
{ pincode: 603114, min_days: 2, max_days: 3 },
{ pincode: 603115, min_days: 2, max_days: 3 },
{ pincode: 603117, min_days: 2, max_days: 3 },
{ pincode: 603118, min_days: 2, max_days: 3 },
{ pincode: 603119, min_days: 2, max_days: 3 },
{ pincode: 603120, min_days: 2, max_days: 3 },
{ pincode: 603121, min_days: 2, max_days: 3 },
{ pincode: 603122, min_days: 2, max_days: 3 },
{ pincode: 603127, min_days: 2, max_days: 3 },
{ pincode: 603201, min_days: 2, max_days: 3 },
{ pincode: 603202, min_days: 2, max_days: 3 },
{ pincode: 603203, min_days: 2, max_days: 3 },
{ pincode: 603204, min_days: 2, max_days: 3 },
{ pincode: 603209, min_days: 2, max_days: 3 },
{ pincode: 603210, min_days: 2, max_days: 3 },
{ pincode: 603211, min_days: 2, max_days: 3 },
{ pincode: 603301, min_days: 2, max_days: 3 },
{ pincode: 603302, min_days: 2, max_days: 3 },
{ pincode: 603303, min_days: 2, max_days: 3 },
{ pincode: 603304, min_days: 2, max_days: 3 },
{ pincode: 603305, min_days: 2, max_days: 3 },
{ pincode: 603306, min_days: 2, max_days: 3 },
{ pincode: 603307, min_days: 2, max_days: 3 },
{ pincode: 603308, min_days: 2, max_days: 3 },
{ pincode: 603309, min_days: 2, max_days: 3 },
{ pincode: 603310, min_days: 2, max_days: 3 },
{ pincode: 603311, min_days: 2, max_days: 3 },
{ pincode: 603312, min_days: 2, max_days: 3 },
{ pincode: 603313, min_days: 2, max_days: 3 },
{ pincode: 603314, min_days: 2, max_days: 3 },
{ pincode: 603315, min_days: 2, max_days: 3 },
{ pincode: 603316, min_days: 2, max_days: 3 },
{ pincode: 603317, min_days: 2, max_days: 3 },
{ pincode: 603318, min_days: 2, max_days: 3 },
{ pincode: 603319, min_days: 2, max_days: 3 },
{ pincode: 603320, min_days: 2, max_days: 3 },
{ pincode: 603401, min_days: 2, max_days: 3 },
{ pincode: 603402, min_days: 2, max_days: 3 },
{ pincode: 603403, min_days: 2, max_days: 3 },
{ pincode: 603404, min_days: 2, max_days: 3 },
{ pincode: 603405, min_days: 2, max_days: 3 },
{ pincode: 603406, min_days: 2, max_days: 3 },
{ pincode: 603408, min_days: 2, max_days: 3 },
{ pincode: 603602, min_days: 2, max_days: 3 },
{ pincode: 603603, min_days: 2, max_days: 3 },
{ pincode: 604001, min_days: 2, max_days: 3 },
{ pincode: 604002, min_days: 2, max_days: 3 },
{ pincode: 604101, min_days: 2, max_days: 3 },
{ pincode: 604102, min_days: 2, max_days: 3 },
{ pincode: 604103, min_days: 2, max_days: 3 },
{ pincode: 604151, min_days: 2, max_days: 3 },
{ pincode: 604152, min_days: 2, max_days: 3 },
{ pincode: 604153, min_days: 2, max_days: 3 },
{ pincode: 604154, min_days: 2, max_days: 3 },
{ pincode: 604155, min_days: 2, max_days: 3 },
{ pincode: 604201, min_days: 2, max_days: 3 },
{ pincode: 604202, min_days: 2, max_days: 3 },
{ pincode: 604203, min_days: 2, max_days: 3 },
{ pincode: 604204, min_days: 2, max_days: 3 },
{ pincode: 604205, min_days: 2, max_days: 3 },
{ pincode: 604206, min_days: 2, max_days: 3 },
{ pincode: 604207, min_days: 2, max_days: 3 },
{ pincode: 604208, min_days: 2, max_days: 3 },
{ pincode: 604210, min_days: 2, max_days: 3 },
{ pincode: 604211, min_days: 2, max_days: 3 },
{ pincode: 604212, min_days: 2, max_days: 3 },
{ pincode: 604213, min_days: 2, max_days: 3 },
{ pincode: 604301, min_days: 2, max_days: 3 },
{ pincode: 604302, min_days: 2, max_days: 3 },
{ pincode: 604303, min_days: 2, max_days: 3 },
{ pincode: 604304, min_days: 2, max_days: 3 },
{ pincode: 604305, min_days: 2, max_days: 3 },
{ pincode: 604306, min_days: 2, max_days: 3 },
{ pincode: 604307, min_days: 2, max_days: 3 },
{ pincode: 604401, min_days: 2, max_days: 3 },
{ pincode: 604402, min_days: 2, max_days: 3 },
{ pincode: 604403, min_days: 2, max_days: 3 },
{ pincode: 604404, min_days: 2, max_days: 3 },
{ pincode: 604405, min_days: 2, max_days: 3 },
{ pincode: 604406, min_days: 2, max_days: 3 },
{ pincode: 604407, min_days: 2, max_days: 3 },
{ pincode: 604408, min_days: 2, max_days: 3 },
{ pincode: 604409, min_days: 2, max_days: 3 },
{ pincode: 604410, min_days: 2, max_days: 3 },
{ pincode: 604412, min_days: 2, max_days: 3 },
{ pincode: 604501, min_days: 2, max_days: 3 },
{ pincode: 604502, min_days: 2, max_days: 3 },
{ pincode: 604503, min_days: 2, max_days: 3 },
{ pincode: 604504, min_days: 2, max_days: 3 },
{ pincode: 604505, min_days: 2, max_days: 3 },
{ pincode: 604601, min_days: 2, max_days: 3 },
{ pincode: 604914, min_days: 2, max_days: 3 },
{ pincode: 605001, min_days: 2, max_days: 3 },
{ pincode: 605002, min_days: 2, max_days: 3 },
{ pincode: 605003, min_days: 2, max_days: 3 },
{ pincode: 605004, min_days: 2, max_days: 3 },
{ pincode: 605005, min_days: 2, max_days: 3 },
{ pincode: 605006, min_days: 2, max_days: 3 },
{ pincode: 605007, min_days: 2, max_days: 3 },
{ pincode: 605008, min_days: 2, max_days: 3 },
{ pincode: 605009, min_days: 2, max_days: 3 },
{ pincode: 605010, min_days: 2, max_days: 3 },
{ pincode: 605011, min_days: 2, max_days: 3 },
{ pincode: 605012, min_days: 2, max_days: 3 },
{ pincode: 605013, min_days: 2, max_days: 3 },
{ pincode: 605014, min_days: 2, max_days: 3 },
{ pincode: 605051, min_days: 2, max_days: 3 },
{ pincode: 605101, min_days: 2, max_days: 3 },
{ pincode: 605102, min_days: 2, max_days: 3 },
{ pincode: 605103, min_days: 2, max_days: 3 },
{ pincode: 605104, min_days: 2, max_days: 3 },
{ pincode: 605105, min_days: 2, max_days: 3 },
{ pincode: 605106, min_days: 2, max_days: 3 },
{ pincode: 605107, min_days: 2, max_days: 3 },
{ pincode: 605108, min_days: 2, max_days: 3 },
{ pincode: 605109, min_days: 2, max_days: 3 },
{ pincode: 605110, min_days: 2, max_days: 3 },
{ pincode: 605111, min_days: 2, max_days: 3 },
{ pincode: 605113, min_days: 2, max_days: 3 },
{ pincode: 605116, min_days: 2, max_days: 3 },
{ pincode: 605118, min_days: 2, max_days: 3 },
{ pincode: 605201, min_days: 2, max_days: 3 },
{ pincode: 605202, min_days: 2, max_days: 3 },
{ pincode: 605203, min_days: 2, max_days: 3 },
{ pincode: 605301, min_days: 2, max_days: 3 },
{ pincode: 605302, min_days: 2, max_days: 3 },
{ pincode: 605401, min_days: 2, max_days: 3 },
{ pincode: 605402, min_days: 2, max_days: 3 },
{ pincode: 605403, min_days: 2, max_days: 3 },
{ pincode: 605501, min_days: 2, max_days: 3 },
{ pincode: 605502, min_days: 2, max_days: 3 },
{ pincode: 605503, min_days: 2, max_days: 3 },
{ pincode: 605601, min_days: 2, max_days: 3 },
{ pincode: 605602, min_days: 2, max_days: 3 },
{ pincode: 605604, min_days: 2, max_days: 3 },
{ pincode: 605605, min_days: 2, max_days: 3 },
{ pincode: 605606, min_days: 2, max_days: 3 },
{ pincode: 605651, min_days: 2, max_days: 3 },
{ pincode: 605652, min_days: 2, max_days: 3 },
{ pincode: 605655, min_days: 2, max_days: 3 },
{ pincode: 605701, min_days: 2, max_days: 3 },
{ pincode: 605702, min_days: 2, max_days: 3 },
{ pincode: 605751, min_days: 2, max_days: 3 },
{ pincode: 605752, min_days: 2, max_days: 3 },
{ pincode: 605753, min_days: 2, max_days: 3 },
{ pincode: 605754, min_days: 2, max_days: 3 },
{ pincode: 605755, min_days: 2, max_days: 3 },
{ pincode: 605756, min_days: 2, max_days: 3 },
{ pincode: 605757, min_days: 2, max_days: 3 },
{ pincode: 605758, min_days: 2, max_days: 3 },
{ pincode: 605759, min_days: 2, max_days: 3 },
{ pincode: 605766, min_days: 2, max_days: 3 },
{ pincode: 605801, min_days: 2, max_days: 3 },
{ pincode: 605802, min_days: 2, max_days: 3 },
{ pincode: 605803, min_days: 2, max_days: 3 },
{ pincode: 605809, min_days: 2, max_days: 3 },
{ pincode: 606001, min_days: 2, max_days: 3 },
{ pincode: 606002, min_days: 2, max_days: 3 },
{ pincode: 606003, min_days: 2, max_days: 3 },
{ pincode: 606006, min_days: 2, max_days: 3 },
{ pincode: 606016, min_days: 2, max_days: 3 },
{ pincode: 606102, min_days: 2, max_days: 3 },
{ pincode: 606103, min_days: 2, max_days: 3 },
{ pincode: 606104, min_days: 2, max_days: 3 },
{ pincode: 606105, min_days: 2, max_days: 3 },
{ pincode: 606106, min_days: 2, max_days: 3 },
{ pincode: 606107, min_days: 2, max_days: 3 },
{ pincode: 606108, min_days: 2, max_days: 3 },
{ pincode: 606109, min_days: 2, max_days: 3 },
{ pincode: 606110, min_days: 2, max_days: 3 },
{ pincode: 606111, min_days: 2, max_days: 3 },
{ pincode: 606112, min_days: 2, max_days: 3 },
{ pincode: 606115, min_days: 2, max_days: 3 },
{ pincode: 606120, min_days: 2, max_days: 3 },
{ pincode: 606123, min_days: 2, max_days: 3 },
{ pincode: 606201, min_days: 2, max_days: 3 },
{ pincode: 606202, min_days: 2, max_days: 3 },
{ pincode: 606203, min_days: 2, max_days: 3 },
{ pincode: 606204, min_days: 2, max_days: 3 },
{ pincode: 606205, min_days: 2, max_days: 3 },
{ pincode: 606206, min_days: 2, max_days: 3 },
{ pincode: 606207, min_days: 2, max_days: 3 },
{ pincode: 606208, min_days: 2, max_days: 3 },
{ pincode: 606209, min_days: 2, max_days: 3 },
{ pincode: 606213, min_days: 2, max_days: 3 },
{ pincode: 606221, min_days: 2, max_days: 3 },
{ pincode: 606223, min_days: 2, max_days: 3 },
{ pincode: 606301, min_days: 2, max_days: 3 },
{ pincode: 606302, min_days: 2, max_days: 3 },
{ pincode: 606303, min_days: 2, max_days: 3 },
{ pincode: 606304, min_days: 2, max_days: 3 },
{ pincode: 606305, min_days: 2, max_days: 3 },
{ pincode: 606306, min_days: 2, max_days: 3 },
{ pincode: 606307, min_days: 2, max_days: 3 },
{ pincode: 606401, min_days: 2, max_days: 3 },
{ pincode: 606402, min_days: 2, max_days: 3 },
{ pincode: 606601, min_days: 2, max_days: 3 },
{ pincode: 606602, min_days: 2, max_days: 3 },
{ pincode: 606603, min_days: 2, max_days: 3 },
{ pincode: 606604, min_days: 2, max_days: 3 },
{ pincode: 606611, min_days: 2, max_days: 3 },
{ pincode: 606701, min_days: 2, max_days: 3 },
{ pincode: 606702, min_days: 2, max_days: 3 },
{ pincode: 606703, min_days: 2, max_days: 3 },
{ pincode: 606704, min_days: 2, max_days: 3 },
{ pincode: 606705, min_days: 2, max_days: 3 },
{ pincode: 606706, min_days: 2, max_days: 3 },
{ pincode: 606707, min_days: 2, max_days: 3 },
{ pincode: 606708, min_days: 2, max_days: 3 },
{ pincode: 606709, min_days: 2, max_days: 3 },
{ pincode: 606710, min_days: 2, max_days: 3 },
{ pincode: 606711, min_days: 2, max_days: 3 },
{ pincode: 606713, min_days: 2, max_days: 3 },
{ pincode: 606714, min_days: 2, max_days: 3 },
{ pincode: 606715, min_days: 2, max_days: 3 },
{ pincode: 606716, min_days: 2, max_days: 3 },
{ pincode: 606718, min_days: 2, max_days: 3 },
{ pincode: 606751, min_days: 2, max_days: 3 },
{ pincode: 606752, min_days: 2, max_days: 3 },
{ pincode: 606753, min_days: 2, max_days: 3 },
{ pincode: 606754, min_days: 2, max_days: 3 },
{ pincode: 606755, min_days: 2, max_days: 3 },
{ pincode: 606801, min_days: 2, max_days: 3 },
{ pincode: 606802, min_days: 2, max_days: 3 },
{ pincode: 606803, min_days: 2, max_days: 3 },
{ pincode: 606804, min_days: 2, max_days: 3 },
{ pincode: 606805, min_days: 2, max_days: 3 },
{ pincode: 606806, min_days: 2, max_days: 3 },
{ pincode: 606807, min_days: 2, max_days: 3 },
{ pincode: 606808, min_days: 2, max_days: 3 },
{ pincode: 606810, min_days: 2, max_days: 3 },
{ pincode: 606811, min_days: 2, max_days: 3 },
{ pincode: 606901, min_days: 2, max_days: 3 },
{ pincode: 606902, min_days: 2, max_days: 3 },
{ pincode: 606903, min_days: 2, max_days: 3 },
{ pincode: 606904, min_days: 2, max_days: 3 },
{ pincode: 606905, min_days: 2, max_days: 3 },
{ pincode: 606906, min_days: 2, max_days: 3 },
{ pincode: 606907, min_days: 2, max_days: 3 },
{ pincode: 606908, min_days: 2, max_days: 3 },
{ pincode: 606910, min_days: 2, max_days: 3 },
{ pincode: 606911, min_days: 2, max_days: 3 },
{ pincode: 606914, min_days: 2, max_days: 3 },
{ pincode: 606915, min_days: 2, max_days: 3 },
{ pincode: 607001, min_days: 2, max_days: 3 },
{ pincode: 607002, min_days: 2, max_days: 3 },
{ pincode: 607003, min_days: 2, max_days: 3 },
{ pincode: 607004, min_days: 2, max_days: 3 },
{ pincode: 607005, min_days: 2, max_days: 3 },
{ pincode: 607006, min_days: 2, max_days: 3 },
{ pincode: 607051, min_days: 2, max_days: 3 },
{ pincode: 607101, min_days: 2, max_days: 3 },
{ pincode: 607102, min_days: 2, max_days: 3 },
{ pincode: 607103, min_days: 2, max_days: 3 },
{ pincode: 607104, min_days: 2, max_days: 3 },
{ pincode: 607105, min_days: 2, max_days: 3 },
{ pincode: 607106, min_days: 2, max_days: 3 },
{ pincode: 607107, min_days: 2, max_days: 3 },
{ pincode: 607108, min_days: 2, max_days: 3 },
{ pincode: 607109, min_days: 2, max_days: 3 },
{ pincode: 607111, min_days: 2, max_days: 3 },
{ pincode: 607112, min_days: 2, max_days: 3 },
{ pincode: 607113, min_days: 2, max_days: 3 },
{ pincode: 607116, min_days: 2, max_days: 3 },
{ pincode: 607201, min_days: 2, max_days: 3 },
{ pincode: 607202, min_days: 2, max_days: 3 },
{ pincode: 607203, min_days: 2, max_days: 3 },
{ pincode: 607204, min_days: 2, max_days: 3 },
{ pincode: 607205, min_days: 2, max_days: 3 },
{ pincode: 607207, min_days: 2, max_days: 3 },
{ pincode: 607209, min_days: 2, max_days: 3 },
{ pincode: 607301, min_days: 2, max_days: 3 },
{ pincode: 607302, min_days: 2, max_days: 3 },
{ pincode: 607303, min_days: 2, max_days: 3 },
{ pincode: 607305, min_days: 2, max_days: 3 },
{ pincode: 607307, min_days: 2, max_days: 3 },
{ pincode: 607308, min_days: 2, max_days: 3 },
{ pincode: 607401, min_days: 2, max_days: 3 },
{ pincode: 607402, min_days: 2, max_days: 3 },
{ pincode: 607403, min_days: 2, max_days: 3 },
{ pincode: 607404, min_days: 2, max_days: 3 },
{ pincode: 607801, min_days: 2, max_days: 3 },
{ pincode: 607802, min_days: 2, max_days: 3 },
{ pincode: 607803, min_days: 2, max_days: 3 },
{ pincode: 607804, min_days: 2, max_days: 3 },
{ pincode: 607805, min_days: 2, max_days: 3 },
{ pincode: 607807, min_days: 2, max_days: 3 },
{ pincode: 608001, min_days: 2, max_days: 3 },
{ pincode: 608002, min_days: 2, max_days: 3 },
{ pincode: 608102, min_days: 2, max_days: 3 },
{ pincode: 608109, min_days: 2, max_days: 3 },
{ pincode: 608201, min_days: 2, max_days: 3 },
{ pincode: 608301, min_days: 2, max_days: 3 },
{ pincode: 608302, min_days: 2, max_days: 3 },
{ pincode: 608303, min_days: 2, max_days: 3 },
{ pincode: 608304, min_days: 2, max_days: 3 },
{ pincode: 608305, min_days: 2, max_days: 3 },
{ pincode: 608306, min_days: 2, max_days: 3 },
{ pincode: 608401, min_days: 2, max_days: 3 },
{ pincode: 608501, min_days: 2, max_days: 3 },
{ pincode: 608502, min_days: 2, max_days: 3 },
{ pincode: 608601, min_days: 2, max_days: 3 },
{ pincode: 608602, min_days: 2, max_days: 3 },
{ pincode: 608701, min_days: 2, max_days: 3 },
{ pincode: 608702, min_days: 2, max_days: 3 },
{ pincode: 608703, min_days: 2, max_days: 3 },
{ pincode: 608704, min_days: 2, max_days: 3 },
{ pincode: 608801, min_days: 2, max_days: 3 },
{ pincode: 608803, min_days: 2, max_days: 3 },
{ pincode: 608901, min_days: 2, max_days: 3 },
{ pincode: 609001, min_days: 2, max_days: 3 },
{ pincode: 609002, min_days: 2, max_days: 3 },
{ pincode: 609003, min_days: 2, max_days: 3 },
{ pincode: 609101, min_days: 2, max_days: 3 },
{ pincode: 609102, min_days: 2, max_days: 3 },
{ pincode: 609103, min_days: 2, max_days: 3 },
{ pincode: 609104, min_days: 2, max_days: 3 },
{ pincode: 609105, min_days: 2, max_days: 3 },
{ pincode: 609106, min_days: 2, max_days: 3 },
{ pincode: 609107, min_days: 2, max_days: 3 },
{ pincode: 609108, min_days: 2, max_days: 3 },
{ pincode: 609109, min_days: 2, max_days: 3 },
{ pincode: 609110, min_days: 2, max_days: 3 },
{ pincode: 609111, min_days: 2, max_days: 3 },
{ pincode: 609112, min_days: 2, max_days: 3 },
{ pincode: 609113, min_days: 2, max_days: 3 },
{ pincode: 609114, min_days: 2, max_days: 3 },
{ pincode: 609115, min_days: 2, max_days: 3 },
{ pincode: 609116, min_days: 2, max_days: 3 },
{ pincode: 609117, min_days: 2, max_days: 3 },
{ pincode: 609118, min_days: 2, max_days: 3 },
{ pincode: 609119, min_days: 2, max_days: 3 },
{ pincode: 609120, min_days: 2, max_days: 3 },
{ pincode: 609121, min_days: 2, max_days: 3 },
{ pincode: 609122, min_days: 2, max_days: 3 },
{ pincode: 609125, min_days: 2, max_days: 3 },
{ pincode: 609126, min_days: 2, max_days: 3 },
{ pincode: 609128, min_days: 2, max_days: 3 },
{ pincode: 609129, min_days: 2, max_days: 3 },
{ pincode: 609130, min_days: 2, max_days: 3 },
{ pincode: 609131, min_days: 2, max_days: 3 },
{ pincode: 609201, min_days: 2, max_days: 3 },
{ pincode: 609202, min_days: 2, max_days: 3 },
{ pincode: 609203, min_days: 2, max_days: 3 },
{ pincode: 609204, min_days: 2, max_days: 3 },
{ pincode: 609205, min_days: 2, max_days: 3 },
{ pincode: 609301, min_days: 2, max_days: 3 },
{ pincode: 609302, min_days: 2, max_days: 3 },
{ pincode: 609303, min_days: 2, max_days: 3 },
{ pincode: 609304, min_days: 2, max_days: 3 },
{ pincode: 609305, min_days: 2, max_days: 3 },
{ pincode: 609306, min_days: 2, max_days: 3 },
{ pincode: 609307, min_days: 2, max_days: 3 },
{ pincode: 609308, min_days: 2, max_days: 3 },
{ pincode: 609309, min_days: 2, max_days: 3 },
{ pincode: 609310, min_days: 2, max_days: 3 },
{ pincode: 609311, min_days: 2, max_days: 3 },
{ pincode: 609312, min_days: 2, max_days: 3 },
{ pincode: 609313, min_days: 2, max_days: 3 },
{ pincode: 609314, min_days: 2, max_days: 3 },
{ pincode: 609401, min_days: 2, max_days: 3 },
{ pincode: 609402, min_days: 2, max_days: 3 },
{ pincode: 609403, min_days: 2, max_days: 3 },
{ pincode: 609404, min_days: 2, max_days: 3 },
{ pincode: 609405, min_days: 2, max_days: 3 },
{ pincode: 609501, min_days: 2, max_days: 3 },
{ pincode: 609502, min_days: 2, max_days: 3 },
{ pincode: 609503, min_days: 2, max_days: 3 },
{ pincode: 609504, min_days: 2, max_days: 3 },
{ pincode: 609505, min_days: 2, max_days: 3 },
{ pincode: 609601, min_days: 2, max_days: 3 },
{ pincode: 609602, min_days: 2, max_days: 3 },
{ pincode: 609603, min_days: 2, max_days: 3 },
{ pincode: 609604, min_days: 2, max_days: 3 },
{ pincode: 609605, min_days: 2, max_days: 3 },
{ pincode: 609606, min_days: 2, max_days: 3 },
{ pincode: 609607, min_days: 2, max_days: 3 },
{ pincode: 609608, min_days: 2, max_days: 3 },
{ pincode: 609609, min_days: 2, max_days: 3 },
{ pincode: 609610, min_days: 2, max_days: 3 },
{ pincode: 609701, min_days: 2, max_days: 3 },
{ pincode: 609702, min_days: 2, max_days: 3 },
{ pincode: 609703, min_days: 2, max_days: 3 },
{ pincode: 609704, min_days: 2, max_days: 3 },
{ pincode: 609801, min_days: 2, max_days: 3 },
{ pincode: 609802, min_days: 2, max_days: 3 },
{ pincode: 609803, min_days: 2, max_days: 3 },
{ pincode: 609804, min_days: 2, max_days: 3 },
{ pincode: 609805, min_days: 2, max_days: 3 },
{ pincode: 609806, min_days: 2, max_days: 3 },
{ pincode: 609807, min_days: 2, max_days: 3 },
{ pincode: 609808, min_days: 2, max_days: 3 },
{ pincode: 609809, min_days: 2, max_days: 3 },
{ pincode: 609810, min_days: 2, max_days: 3 },
{ pincode: 609811, min_days: 2, max_days: 3 },
{ pincode: 609812, min_days: 2, max_days: 3 },
{ pincode: 609813, min_days: 2, max_days: 3 },
{ pincode: 610001, min_days: 2, max_days: 3 },
{ pincode: 610002, min_days: 2, max_days: 3 },
{ pincode: 610003, min_days: 2, max_days: 3 },
{ pincode: 610004, min_days: 2, max_days: 3 },
{ pincode: 610005, min_days: 2, max_days: 3 },
{ pincode: 610051, min_days: 2, max_days: 3 },
{ pincode: 610101, min_days: 2, max_days: 3 },
{ pincode: 610102, min_days: 2, max_days: 3 },
{ pincode: 610103, min_days: 2, max_days: 3 },
{ pincode: 610104, min_days: 2, max_days: 3 },
{ pincode: 610105, min_days: 2, max_days: 3 },
{ pincode: 610106, min_days: 2, max_days: 3 },
{ pincode: 610107, min_days: 2, max_days: 3 },
{ pincode: 610109, min_days: 2, max_days: 3 },
{ pincode: 610111, min_days: 2, max_days: 3 },
{ pincode: 610114, min_days: 2, max_days: 3 },
{ pincode: 610201, min_days: 2, max_days: 3 },
{ pincode: 610202, min_days: 2, max_days: 3 },
{ pincode: 610203, min_days: 2, max_days: 3 },
{ pincode: 610204, min_days: 2, max_days: 3 },
{ pincode: 610205, min_days: 2, max_days: 3 },
{ pincode: 610206, min_days: 2, max_days: 3 },
{ pincode: 610207, min_days: 2, max_days: 3 },
{ pincode: 610210, min_days: 2, max_days: 3 },
{ pincode: 610211, min_days: 2, max_days: 3 },
{ pincode: 611001, min_days: 2, max_days: 3 },
{ pincode: 611002, min_days: 2, max_days: 3 },
{ pincode: 611003, min_days: 2, max_days: 3 },
{ pincode: 611006, min_days: 2, max_days: 3 },
{ pincode: 611008, min_days: 2, max_days: 3 },
{ pincode: 611101, min_days: 2, max_days: 3 },
{ pincode: 611102, min_days: 2, max_days: 3 },
{ pincode: 611103, min_days: 2, max_days: 3 },
{ pincode: 611104, min_days: 2, max_days: 3 },
{ pincode: 611105, min_days: 2, max_days: 3 },
{ pincode: 611106, min_days: 2, max_days: 3 },
{ pincode: 611108, min_days: 2, max_days: 3 },
{ pincode: 611109, min_days: 2, max_days: 3 },
{ pincode: 611110, min_days: 2, max_days: 3 },
{ pincode: 611111, min_days: 2, max_days: 3 },
{ pincode: 611112, min_days: 2, max_days: 3 },
{ pincode: 611114, min_days: 2, max_days: 3 },
{ pincode: 611116, min_days: 2, max_days: 3 },
{ pincode: 611117, min_days: 2, max_days: 3 },
{ pincode: 612001, min_days: 2, max_days: 3 },
{ pincode: 612002, min_days: 2, max_days: 3 },
{ pincode: 612006, min_days: 2, max_days: 3 },
{ pincode: 612101, min_days: 2, max_days: 3 },
{ pincode: 612102, min_days: 2, max_days: 3 },
{ pincode: 612103, min_days: 2, max_days: 3 },
{ pincode: 612104, min_days: 2, max_days: 3 },
{ pincode: 612105, min_days: 2, max_days: 3 },
{ pincode: 612106, min_days: 2, max_days: 3 },
{ pincode: 612107, min_days: 2, max_days: 3 },
{ pincode: 612108, min_days: 2, max_days: 3 },
{ pincode: 612201, min_days: 2, max_days: 3 },
{ pincode: 612202, min_days: 2, max_days: 3 },
{ pincode: 612203, min_days: 2, max_days: 3 },
{ pincode: 612204, min_days: 2, max_days: 3 },
{ pincode: 612205, min_days: 2, max_days: 3 },
{ pincode: 612206, min_days: 2, max_days: 3 },
{ pincode: 612301, min_days: 2, max_days: 3 },
{ pincode: 612302, min_days: 2, max_days: 3 },
{ pincode: 612303, min_days: 2, max_days: 3 },
{ pincode: 612401, min_days: 2, max_days: 3 },
{ pincode: 612402, min_days: 2, max_days: 3 },
{ pincode: 612501, min_days: 2, max_days: 3 },
{ pincode: 612502, min_days: 2, max_days: 3 },
{ pincode: 612503, min_days: 2, max_days: 3 },
{ pincode: 612504, min_days: 2, max_days: 3 },
{ pincode: 612505, min_days: 2, max_days: 3 },
{ pincode: 612601, min_days: 2, max_days: 3 },
{ pincode: 612602, min_days: 2, max_days: 3 },
{ pincode: 612603, min_days: 2, max_days: 3 },
{ pincode: 612604, min_days: 2, max_days: 3 },
{ pincode: 612605, min_days: 2, max_days: 3 },
{ pincode: 612608, min_days: 2, max_days: 3 },
{ pincode: 612610, min_days: 2, max_days: 3 },
{ pincode: 612701, min_days: 2, max_days: 3 },
{ pincode: 612702, min_days: 2, max_days: 3 },
{ pincode: 612703, min_days: 2, max_days: 3 },
{ pincode: 612704, min_days: 2, max_days: 3 },
{ pincode: 612801, min_days: 2, max_days: 3 },
{ pincode: 612802, min_days: 2, max_days: 3 },
{ pincode: 612803, min_days: 2, max_days: 3 },
{ pincode: 612804, min_days: 2, max_days: 3 },
{ pincode: 612806, min_days: 2, max_days: 3 },
{ pincode: 612807, min_days: 2, max_days: 3 },
{ pincode: 612901, min_days: 2, max_days: 3 },
{ pincode: 612902, min_days: 2, max_days: 3 },
{ pincode: 612903, min_days: 2, max_days: 3 },
{ pincode: 612904, min_days: 2, max_days: 3 },
{ pincode: 612905, min_days: 2, max_days: 3 },
{ pincode: 612906, min_days: 2, max_days: 3 },
{ pincode: 613001, min_days: 2, max_days: 3 },
{ pincode: 613002, min_days: 2, max_days: 3 },
{ pincode: 613003, min_days: 2, max_days: 3 },
{ pincode: 613004, min_days: 2, max_days: 3 },
{ pincode: 613005, min_days: 2, max_days: 3 },
{ pincode: 613006, min_days: 2, max_days: 3 },
{ pincode: 613007, min_days: 2, max_days: 3 },
{ pincode: 613008, min_days: 2, max_days: 3 },
{ pincode: 613009, min_days: 2, max_days: 3 },
{ pincode: 613010, min_days: 2, max_days: 3 },
{ pincode: 613051, min_days: 2, max_days: 3 },
{ pincode: 613052, min_days: 2, max_days: 3 },
{ pincode: 613054, min_days: 2, max_days: 3 },
{ pincode: 613101, min_days: 2, max_days: 3 },
{ pincode: 613102, min_days: 2, max_days: 3 },
{ pincode: 613103, min_days: 2, max_days: 3 },
{ pincode: 613104, min_days: 2, max_days: 3 },
{ pincode: 613105, min_days: 2, max_days: 3 },
{ pincode: 613106, min_days: 2, max_days: 3 },
{ pincode: 613107, min_days: 2, max_days: 3 },
{ pincode: 613201, min_days: 2, max_days: 3 },
{ pincode: 613202, min_days: 2, max_days: 3 },
{ pincode: 613203, min_days: 2, max_days: 3 },
{ pincode: 613204, min_days: 2, max_days: 3 },
{ pincode: 613205, min_days: 2, max_days: 3 },
{ pincode: 613206, min_days: 2, max_days: 3 },
{ pincode: 613207, min_days: 2, max_days: 3 },
{ pincode: 613301, min_days: 2, max_days: 3 },
{ pincode: 613302, min_days: 2, max_days: 3 },
{ pincode: 613303, min_days: 2, max_days: 3 },
{ pincode: 613304, min_days: 2, max_days: 3 },
{ pincode: 613305, min_days: 2, max_days: 3 },
{ pincode: 613401, min_days: 2, max_days: 3 },
{ pincode: 613402, min_days: 2, max_days: 3 },
{ pincode: 613403, min_days: 2, max_days: 3 },
{ pincode: 613406, min_days: 2, max_days: 3 },
{ pincode: 613501, min_days: 2, max_days: 3 },
{ pincode: 613502, min_days: 2, max_days: 3 },
{ pincode: 613503, min_days: 2, max_days: 3 },
{ pincode: 613504, min_days: 2, max_days: 3 },
{ pincode: 613601, min_days: 2, max_days: 3 },
{ pincode: 613602, min_days: 2, max_days: 3 },
{ pincode: 613701, min_days: 2, max_days: 3 },
{ pincode: 613702, min_days: 2, max_days: 3 },
{ pincode: 613703, min_days: 2, max_days: 3 },
{ pincode: 613704, min_days: 2, max_days: 3 },
{ pincode: 613705, min_days: 2, max_days: 3 },
{ pincode: 613706, min_days: 2, max_days: 3 },
{ pincode: 613707, min_days: 2, max_days: 3 },
{ pincode: 614001, min_days: 2, max_days: 3 },
{ pincode: 614012, min_days: 2, max_days: 3 },
{ pincode: 614013, min_days: 2, max_days: 3 },
{ pincode: 614014, min_days: 2, max_days: 3 },
{ pincode: 614015, min_days: 2, max_days: 3 },
{ pincode: 614016, min_days: 2, max_days: 3 },
{ pincode: 614017, min_days: 2, max_days: 3 },
{ pincode: 614018, min_days: 2, max_days: 3 },
{ pincode: 614019, min_days: 2, max_days: 3 },
{ pincode: 614020, min_days: 2, max_days: 3 },
{ pincode: 614022, min_days: 2, max_days: 3 },
{ pincode: 614028, min_days: 2, max_days: 3 },
{ pincode: 614030, min_days: 2, max_days: 3 },
{ pincode: 614101, min_days: 2, max_days: 3 },
{ pincode: 614102, min_days: 2, max_days: 3 },
{ pincode: 614103, min_days: 2, max_days: 3 },
{ pincode: 614201, min_days: 2, max_days: 3 },
{ pincode: 614202, min_days: 2, max_days: 3 },
{ pincode: 614203, min_days: 2, max_days: 3 },
{ pincode: 614204, min_days: 2, max_days: 3 },
{ pincode: 614205, min_days: 2, max_days: 3 },
{ pincode: 614206, min_days: 2, max_days: 3 },
{ pincode: 614207, min_days: 2, max_days: 3 },
{ pincode: 614208, min_days: 2, max_days: 3 },
{ pincode: 614209, min_days: 2, max_days: 3 },
{ pincode: 614210, min_days: 2, max_days: 3 },
{ pincode: 614211, min_days: 2, max_days: 3 },
{ pincode: 614301, min_days: 2, max_days: 3 },
{ pincode: 614302, min_days: 2, max_days: 3 },
{ pincode: 614303, min_days: 2, max_days: 3 },
{ pincode: 614401, min_days: 2, max_days: 3 },
{ pincode: 614402, min_days: 2, max_days: 3 },
{ pincode: 614403, min_days: 2, max_days: 3 },
{ pincode: 614404, min_days: 2, max_days: 3 },
{ pincode: 614601, min_days: 2, max_days: 3 },
{ pincode: 614602, min_days: 2, max_days: 3 },
{ pincode: 614604, min_days: 2, max_days: 3 },
{ pincode: 614612, min_days: 2, max_days: 3 },
{ pincode: 614613, min_days: 2, max_days: 3 },
{ pincode: 614614, min_days: 2, max_days: 3 },
{ pincode: 614615, min_days: 2, max_days: 3 },
{ pincode: 614616, min_days: 2, max_days: 3 },
{ pincode: 614617, min_days: 2, max_days: 3 },
{ pincode: 614618, min_days: 2, max_days: 3 },
{ pincode: 614619, min_days: 2, max_days: 3 },
{ pincode: 614620, min_days: 2, max_days: 3 },
{ pincode: 614621, min_days: 2, max_days: 3 },
{ pincode: 614622, min_days: 2, max_days: 3 },
{ pincode: 614623, min_days: 2, max_days: 3 },
{ pincode: 614624, min_days: 2, max_days: 3 },
{ pincode: 614625, min_days: 2, max_days: 3 },
{ pincode: 614626, min_days: 2, max_days: 3 },
{ pincode: 614628, min_days: 2, max_days: 3 },
{ pincode: 614629, min_days: 2, max_days: 3 },
{ pincode: 614630, min_days: 2, max_days: 3 },
{ pincode: 614631, min_days: 2, max_days: 3 },
{ pincode: 614632, min_days: 2, max_days: 3 },
{ pincode: 614701, min_days: 2, max_days: 3 },
{ pincode: 614702, min_days: 2, max_days: 3 },
{ pincode: 614703, min_days: 2, max_days: 3 },
{ pincode: 614704, min_days: 2, max_days: 3 },
{ pincode: 614705, min_days: 2, max_days: 3 },
{ pincode: 614706, min_days: 2, max_days: 3 },
{ pincode: 614707, min_days: 2, max_days: 3 },
{ pincode: 614708, min_days: 2, max_days: 3 },
{ pincode: 614710, min_days: 2, max_days: 3 },
{ pincode: 614711, min_days: 2, max_days: 3 },
{ pincode: 614712, min_days: 2, max_days: 3 },
{ pincode: 614713, min_days: 2, max_days: 3 },
{ pincode: 614714, min_days: 2, max_days: 3 },
{ pincode: 614715, min_days: 2, max_days: 3 },
{ pincode: 614716, min_days: 2, max_days: 3 },
{ pincode: 614717, min_days: 2, max_days: 3 },
{ pincode: 614721, min_days: 2, max_days: 3 },
{ pincode: 614723, min_days: 2, max_days: 3 },
{ pincode: 614728, min_days: 2, max_days: 3 },
{ pincode: 614731, min_days: 2, max_days: 3 },
{ pincode: 614738, min_days: 2, max_days: 3 },
{ pincode: 614801, min_days: 2, max_days: 3 },
{ pincode: 614802, min_days: 2, max_days: 3 },
{ pincode: 614803, min_days: 2, max_days: 3 },
{ pincode: 614804, min_days: 2, max_days: 3 },
{ pincode: 614805, min_days: 2, max_days: 3 },
{ pincode: 614806, min_days: 2, max_days: 3 },
{ pincode: 614807, min_days: 2, max_days: 3 },
{ pincode: 614808, min_days: 2, max_days: 3 },
{ pincode: 614809, min_days: 2, max_days: 3 },
{ pincode: 614810, min_days: 2, max_days: 3 },
{ pincode: 614818, min_days: 2, max_days: 3 },
{ pincode: 614820, min_days: 2, max_days: 3 },
{ pincode: 614901, min_days: 2, max_days: 3 },
{ pincode: 614902, min_days: 2, max_days: 3 },
{ pincode: 614903, min_days: 2, max_days: 3 },
{ pincode: 614904, min_days: 2, max_days: 3 },
{ pincode: 614905, min_days: 2, max_days: 3 },
{ pincode: 614906, min_days: 2, max_days: 3 },
{ pincode: 620001, min_days: 2, max_days: 3 },
{ pincode: 620002, min_days: 2, max_days: 3 },
{ pincode: 620003, min_days: 2, max_days: 3 },
{ pincode: 620004, min_days: 2, max_days: 3 },
{ pincode: 620005, min_days: 2, max_days: 3 },
{ pincode: 620006, min_days: 2, max_days: 3 },
{ pincode: 620007, min_days: 2, max_days: 3 },
{ pincode: 620008, min_days: 2, max_days: 3 },
{ pincode: 620009, min_days: 2, max_days: 3 },
{ pincode: 620010, min_days: 2, max_days: 3 },
{ pincode: 620011, min_days: 2, max_days: 3 },
{ pincode: 620012, min_days: 2, max_days: 3 },
{ pincode: 620013, min_days: 2, max_days: 3 },
{ pincode: 620014, min_days: 2, max_days: 3 },
{ pincode: 620015, min_days: 2, max_days: 3 },
{ pincode: 620016, min_days: 2, max_days: 3 },
{ pincode: 620017, min_days: 2, max_days: 3 },
{ pincode: 620018, min_days: 2, max_days: 3 },
{ pincode: 620019, min_days: 2, max_days: 3 },
{ pincode: 620020, min_days: 2, max_days: 3 },
{ pincode: 620021, min_days: 2, max_days: 3 },
{ pincode: 620022, min_days: 2, max_days: 3 },
{ pincode: 620023, min_days: 2, max_days: 3 },
{ pincode: 620024, min_days: 2, max_days: 3 },
{ pincode: 620025, min_days: 2, max_days: 3 },
{ pincode: 620026, min_days: 2, max_days: 3 },
{ pincode: 620027, min_days: 2, max_days: 3 },
{ pincode: 620051, min_days: 2, max_days: 3 },
{ pincode: 620052, min_days: 2, max_days: 3 },
{ pincode: 620101, min_days: 2, max_days: 3 },
{ pincode: 620102, min_days: 2, max_days: 3 },
{ pincode: 620106, min_days: 2, max_days: 3 },
{ pincode: 620108, min_days: 2, max_days: 3 },
{ pincode: 620110, min_days: 2, max_days: 3 },
{ pincode: 620602, min_days: 2, max_days: 3 },
{ pincode: 621001, min_days: 2, max_days: 3 },
{ pincode: 621002, min_days: 2, max_days: 3 },
{ pincode: 621003, min_days: 2, max_days: 3 },
{ pincode: 621004, min_days: 2, max_days: 3 },
{ pincode: 621005, min_days: 2, max_days: 3 },
{ pincode: 621006, min_days: 2, max_days: 3 },
{ pincode: 621007, min_days: 2, max_days: 3 },
{ pincode: 621008, min_days: 2, max_days: 3 },
{ pincode: 621009, min_days: 2, max_days: 3 },
{ pincode: 621010, min_days: 2, max_days: 3 },
{ pincode: 621011, min_days: 2, max_days: 3 },
{ pincode: 621012, min_days: 2, max_days: 3 },
{ pincode: 621014, min_days: 2, max_days: 3 },
{ pincode: 621015, min_days: 2, max_days: 3 },
{ pincode: 621016, min_days: 2, max_days: 3 },
{ pincode: 621017, min_days: 2, max_days: 3 },
{ pincode: 621018, min_days: 2, max_days: 3 },
{ pincode: 621022, min_days: 2, max_days: 3 },
{ pincode: 621023, min_days: 2, max_days: 3 },
{ pincode: 621101, min_days: 2, max_days: 3 },
{ pincode: 621102, min_days: 2, max_days: 3 },
{ pincode: 621103, min_days: 2, max_days: 3 },
{ pincode: 621104, min_days: 2, max_days: 3 },
{ pincode: 621105, min_days: 2, max_days: 3 },
{ pincode: 621106, min_days: 2, max_days: 3 },
{ pincode: 621107, min_days: 2, max_days: 3 },
{ pincode: 621108, min_days: 2, max_days: 3 },
{ pincode: 621109, min_days: 2, max_days: 3 },
{ pincode: 621110, min_days: 2, max_days: 3 },
{ pincode: 621111, min_days: 2, max_days: 3 },
{ pincode: 621112, min_days: 2, max_days: 3 },
{ pincode: 621113, min_days: 2, max_days: 3 },
{ pincode: 621114, min_days: 2, max_days: 3 },
{ pincode: 621115, min_days: 2, max_days: 3 },
{ pincode: 621116, min_days: 2, max_days: 3 },
{ pincode: 621117, min_days: 2, max_days: 3 },
{ pincode: 621118, min_days: 2, max_days: 3 },
{ pincode: 621119, min_days: 2, max_days: 3 },
{ pincode: 621120, min_days: 2, max_days: 3 },
{ pincode: 621121, min_days: 2, max_days: 3 },
{ pincode: 621126, min_days: 2, max_days: 3 },
{ pincode: 621127, min_days: 2, max_days: 3 },
{ pincode: 621128, min_days: 2, max_days: 3 },
{ pincode: 621129, min_days: 2, max_days: 3 },
{ pincode: 621132, min_days: 2, max_days: 3 },
{ pincode: 621133, min_days: 2, max_days: 3 },
{ pincode: 621201, min_days: 2, max_days: 3 },
{ pincode: 621202, min_days: 2, max_days: 3 },
{ pincode: 621203, min_days: 2, max_days: 3 },
{ pincode: 621204, min_days: 2, max_days: 3 },
{ pincode: 621205, min_days: 2, max_days: 3 },
{ pincode: 621206, min_days: 2, max_days: 3 },
{ pincode: 621207, min_days: 2, max_days: 3 },
{ pincode: 621208, min_days: 2, max_days: 3 },
{ pincode: 621209, min_days: 2, max_days: 3 },
{ pincode: 621210, min_days: 2, max_days: 3 },
{ pincode: 621211, min_days: 2, max_days: 3 },
{ pincode: 621212, min_days: 2, max_days: 3 },
{ pincode: 621213, min_days: 2, max_days: 3 },
{ pincode: 621214, min_days: 2, max_days: 3 },
{ pincode: 621215, min_days: 2, max_days: 3 },
{ pincode: 621216, min_days: 2, max_days: 3 },
{ pincode: 621217, min_days: 2, max_days: 3 },
{ pincode: 621218, min_days: 2, max_days: 3 },
{ pincode: 621219, min_days: 2, max_days: 3 },
{ pincode: 621220, min_days: 2, max_days: 3 },
{ pincode: 621221, min_days: 2, max_days: 3 },
{ pincode: 621229, min_days: 2, max_days: 3 },
{ pincode: 621301, min_days: 2, max_days: 3 },
{ pincode: 621302, min_days: 2, max_days: 3 },
{ pincode: 621305, min_days: 2, max_days: 3 },
{ pincode: 621306, min_days: 2, max_days: 3 },
{ pincode: 621307, min_days: 2, max_days: 3 },
{ pincode: 621308, min_days: 2, max_days: 3 },
{ pincode: 621310, min_days: 2, max_days: 3 },
{ pincode: 621311, min_days: 2, max_days: 3 },
{ pincode: 621312, min_days: 2, max_days: 3 },
{ pincode: 621313, min_days: 2, max_days: 3 },
{ pincode: 621314, min_days: 2, max_days: 3 },
{ pincode: 621315, min_days: 2, max_days: 3 },
{ pincode: 621316, min_days: 2, max_days: 3 },
{ pincode: 621591, min_days: 2, max_days: 3 },
{ pincode: 621601, min_days: 2, max_days: 3 },
{ pincode: 621619, min_days: 2, max_days: 3 },
{ pincode: 621651, min_days: 2, max_days: 3 },
{ pincode: 621652, min_days: 2, max_days: 3 },
{ pincode: 621653, min_days: 2, max_days: 3 },
{ pincode: 621701, min_days: 2, max_days: 3 },
{ pincode: 621702, min_days: 2, max_days: 3 },
{ pincode: 621703, min_days: 2, max_days: 3 },
{ pincode: 621704, min_days: 2, max_days: 3 },
{ pincode: 621705, min_days: 2, max_days: 3 },
{ pincode: 621706, min_days: 2, max_days: 3 },
{ pincode: 621707, min_days: 2, max_days: 3 },
{ pincode: 621708, min_days: 2, max_days: 3 },
{ pincode: 621709, min_days: 2, max_days: 3 },
{ pincode: 621710, min_days: 2, max_days: 3 },
{ pincode: 621711, min_days: 2, max_days: 3 },
{ pincode: 621712, min_days: 2, max_days: 3 },
{ pincode: 621713, min_days: 2, max_days: 3 },
{ pincode: 621714, min_days: 2, max_days: 3 },
{ pincode: 621715, min_days: 2, max_days: 3 },
{ pincode: 621716, min_days: 2, max_days: 3 },
{ pincode: 621717, min_days: 2, max_days: 3 },
{ pincode: 621718, min_days: 2, max_days: 3 },
{ pincode: 621719, min_days: 2, max_days: 3 },
{ pincode: 621722, min_days: 2, max_days: 3 },
{ pincode: 621729, min_days: 2, max_days: 3 },
{ pincode: 621730, min_days: 2, max_days: 3 },
{ pincode: 621731, min_days: 2, max_days: 3 },
{ pincode: 621801, min_days: 2, max_days: 3 },
{ pincode: 621802, min_days: 2, max_days: 3 },
{ pincode: 621803, min_days: 2, max_days: 3 },
{ pincode: 621804, min_days: 2, max_days: 3 },
{ pincode: 621805, min_days: 2, max_days: 3 },
{ pincode: 621806, min_days: 2, max_days: 3 },
{ pincode: 621851, min_days: 2, max_days: 3 },
{ pincode: 622001, min_days: 2, max_days: 3 },
{ pincode: 622002, min_days: 2, max_days: 3 },
{ pincode: 622003, min_days: 2, max_days: 3 },
{ pincode: 622004, min_days: 2, max_days: 3 },
{ pincode: 622005, min_days: 2, max_days: 3 },
{ pincode: 622052, min_days: 2, max_days: 3 },
{ pincode: 622053, min_days: 2, max_days: 3 },
{ pincode: 622056, min_days: 2, max_days: 3 },
{ pincode: 622101, min_days: 2, max_days: 3 },
{ pincode: 622102, min_days: 2, max_days: 3 },
{ pincode: 622103, min_days: 2, max_days: 3 },
{ pincode: 622104, min_days: 2, max_days: 3 },
{ pincode: 622105, min_days: 2, max_days: 3 },
{ pincode: 622106, min_days: 2, max_days: 3 },
{ pincode: 622107, min_days: 2, max_days: 3 },
{ pincode: 622201, min_days: 2, max_days: 3 },
{ pincode: 622202, min_days: 2, max_days: 3 },
{ pincode: 622203, min_days: 2, max_days: 3 },
{ pincode: 622204, min_days: 2, max_days: 3 },
{ pincode: 622205, min_days: 2, max_days: 3 },
{ pincode: 622206, min_days: 2, max_days: 3 },
{ pincode: 622207, min_days: 2, max_days: 3 },
{ pincode: 622208, min_days: 2, max_days: 3 },
{ pincode: 622209, min_days: 2, max_days: 3 },
{ pincode: 622301, min_days: 2, max_days: 3 },
{ pincode: 622302, min_days: 2, max_days: 3 },
{ pincode: 622303, min_days: 2, max_days: 3 },
{ pincode: 622304, min_days: 2, max_days: 3 },
{ pincode: 622305, min_days: 2, max_days: 3 },
{ pincode: 622306, min_days: 2, max_days: 3 },
{ pincode: 622307, min_days: 2, max_days: 3 },
{ pincode: 622312, min_days: 2, max_days: 3 },
{ pincode: 622313, min_days: 2, max_days: 3 },
{ pincode: 622314, min_days: 2, max_days: 3 },
{ pincode: 622315, min_days: 2, max_days: 3 },
{ pincode: 622317, min_days: 2, max_days: 3 },
{ pincode: 622401, min_days: 2, max_days: 3 },
{ pincode: 622402, min_days: 2, max_days: 3 },
{ pincode: 622403, min_days: 2, max_days: 3 },
{ pincode: 622404, min_days: 2, max_days: 3 },
{ pincode: 622406, min_days: 2, max_days: 3 },
{ pincode: 622407, min_days: 2, max_days: 3 },
{ pincode: 622408, min_days: 2, max_days: 3 },
{ pincode: 622409, min_days: 2, max_days: 3 },
{ pincode: 622410, min_days: 2, max_days: 3 },
{ pincode: 622411, min_days: 2, max_days: 3 },
{ pincode: 622412, min_days: 2, max_days: 3 },
{ pincode: 622414, min_days: 2, max_days: 3 },
{ pincode: 622415, min_days: 2, max_days: 3 },
{ pincode: 622416, min_days: 2, max_days: 3 },
{ pincode: 622419, min_days: 2, max_days: 3 },
{ pincode: 622422, min_days: 2, max_days: 3 },
{ pincode: 622501, min_days: 2, max_days: 3 },
{ pincode: 622502, min_days: 2, max_days: 3 },
{ pincode: 622503, min_days: 2, max_days: 3 },
{ pincode: 622504, min_days: 2, max_days: 3 },
{ pincode: 622505, min_days: 2, max_days: 3 },
{ pincode: 622506, min_days: 2, max_days: 3 },
{ pincode: 622507, min_days: 2, max_days: 3 },
{ pincode: 622508, min_days: 2, max_days: 3 },
{ pincode: 622509, min_days: 2, max_days: 3 },
{ pincode: 622510, min_days: 2, max_days: 3 },
{ pincode: 622513, min_days: 2, max_days: 3 },
{ pincode: 622514, min_days: 2, max_days: 3 },
{ pincode: 622515, min_days: 2, max_days: 3 },
{ pincode: 623001, min_days: 2, max_days: 3 },
{ pincode: 623002, min_days: 2, max_days: 3 },
{ pincode: 623003, min_days: 2, max_days: 3 },
{ pincode: 623004, min_days: 2, max_days: 3 },
{ pincode: 623005, min_days: 2, max_days: 3 },
{ pincode: 623006, min_days: 2, max_days: 3 },
{ pincode: 623101, min_days: 2, max_days: 3 },
{ pincode: 623102, min_days: 2, max_days: 3 },
{ pincode: 623103, min_days: 2, max_days: 3 },
{ pincode: 623104, min_days: 2, max_days: 3 },
{ pincode: 623105, min_days: 2, max_days: 3 },
{ pincode: 623106, min_days: 2, max_days: 3 },
{ pincode: 623107, min_days: 2, max_days: 3 },
{ pincode: 623108, min_days: 2, max_days: 3 },
{ pincode: 623109, min_days: 2, max_days: 3 },
{ pincode: 623110, min_days: 2, max_days: 3 },
{ pincode: 623111, min_days: 2, max_days: 3 },
{ pincode: 623115, min_days: 2, max_days: 3 },
{ pincode: 623120, min_days: 2, max_days: 3 },
{ pincode: 623135, min_days: 2, max_days: 3 },
{ pincode: 623201, min_days: 2, max_days: 3 },
{ pincode: 623202, min_days: 2, max_days: 3 },
{ pincode: 623203, min_days: 2, max_days: 3 },
{ pincode: 623204, min_days: 2, max_days: 3 },
{ pincode: 623205, min_days: 2, max_days: 3 },
{ pincode: 623206, min_days: 2, max_days: 3 },
{ pincode: 623208, min_days: 2, max_days: 3 },
{ pincode: 623209, min_days: 2, max_days: 3 },
{ pincode: 623210, min_days: 2, max_days: 3 },
{ pincode: 623211, min_days: 2, max_days: 3 },
{ pincode: 623213, min_days: 2, max_days: 3 },
{ pincode: 623216, min_days: 2, max_days: 3 },
{ pincode: 623302, min_days: 2, max_days: 3 },
{ pincode: 623303, min_days: 2, max_days: 3 },
{ pincode: 623304, min_days: 2, max_days: 3 },
{ pincode: 623307, min_days: 2, max_days: 3 },
{ pincode: 623308, min_days: 2, max_days: 3 },
{ pincode: 623309, min_days: 2, max_days: 3 },
{ pincode: 623313, min_days: 2, max_days: 3 },
{ pincode: 623314, min_days: 2, max_days: 3 },
{ pincode: 623315, min_days: 2, max_days: 3 },
{ pincode: 623317, min_days: 2, max_days: 3 },
{ pincode: 623318, min_days: 2, max_days: 3 },
{ pincode: 623319, min_days: 2, max_days: 3 },
{ pincode: 623320, min_days: 2, max_days: 3 },
{ pincode: 623401, min_days: 2, max_days: 3 },
{ pincode: 623402, min_days: 2, max_days: 3 },
{ pincode: 623403, min_days: 2, max_days: 3 },
{ pincode: 623404, min_days: 2, max_days: 3 },
{ pincode: 623406, min_days: 2, max_days: 3 },
{ pincode: 623407, min_days: 2, max_days: 3 },
{ pincode: 623409, min_days: 2, max_days: 3 },
{ pincode: 623501, min_days: 2, max_days: 3 },
{ pincode: 623502, min_days: 2, max_days: 3 },
{ pincode: 623503, min_days: 2, max_days: 3 },
{ pincode: 623504, min_days: 2, max_days: 3 },
{ pincode: 623505, min_days: 2, max_days: 3 },
{ pincode: 623512, min_days: 2, max_days: 3 },
{ pincode: 623513, min_days: 2, max_days: 3 },
{ pincode: 623514, min_days: 2, max_days: 3 },
{ pincode: 623515, min_days: 2, max_days: 3 },
{ pincode: 623516, min_days: 2, max_days: 3 },
{ pincode: 623517, min_days: 2, max_days: 3 },
{ pincode: 623518, min_days: 2, max_days: 3 },
{ pincode: 623519, min_days: 2, max_days: 3 },
{ pincode: 623520, min_days: 2, max_days: 3 },
{ pincode: 623521, min_days: 2, max_days: 3 },
{ pincode: 623522, min_days: 2, max_days: 3 },
{ pincode: 623523, min_days: 2, max_days: 3 },
{ pincode: 623524, min_days: 2, max_days: 3 },
{ pincode: 623525, min_days: 2, max_days: 3 },
{ pincode: 623526, min_days: 2, max_days: 3 },
{ pincode: 623527, min_days: 2, max_days: 3 },
{ pincode: 623528, min_days: 2, max_days: 3 },
{ pincode: 623529, min_days: 2, max_days: 3 },
{ pincode: 623530, min_days: 2, max_days: 3 },
{ pincode: 623531, min_days: 2, max_days: 3 },
{ pincode: 623532, min_days: 2, max_days: 3 },
{ pincode: 623533, min_days: 2, max_days: 3 },
{ pincode: 623534, min_days: 2, max_days: 3 },
{ pincode: 623535, min_days: 2, max_days: 3 },
{ pincode: 623536, min_days: 2, max_days: 3 },
{ pincode: 623537, min_days: 2, max_days: 3 },
{ pincode: 623538, min_days: 2, max_days: 3 },
{ pincode: 623539, min_days: 2, max_days: 3 },
{ pincode: 623544, min_days: 2, max_days: 3 },
{ pincode: 623545, min_days: 2, max_days: 3 },
{ pincode: 623546, min_days: 2, max_days: 3 },
{ pincode: 623551, min_days: 2, max_days: 3 },
{ pincode: 623554, min_days: 2, max_days: 3 },
{ pincode: 623560, min_days: 2, max_days: 3 },
{ pincode: 623561, min_days: 2, max_days: 3 },
{ pincode: 623562, min_days: 2, max_days: 3 },
{ pincode: 623565, min_days: 2, max_days: 3 },
{ pincode: 623566, min_days: 2, max_days: 3 },
{ pincode: 623601, min_days: 2, max_days: 3 },
{ pincode: 623603, min_days: 2, max_days: 3 },
{ pincode: 623604, min_days: 2, max_days: 3 },
{ pincode: 623605, min_days: 2, max_days: 3 },
{ pincode: 623606, min_days: 2, max_days: 3 },
{ pincode: 623608, min_days: 2, max_days: 3 },
{ pincode: 623611, min_days: 2, max_days: 3 },
{ pincode: 623612, min_days: 2, max_days: 3 },
{ pincode: 623613, min_days: 2, max_days: 3 },
{ pincode: 623617, min_days: 2, max_days: 3 },
{ pincode: 623701, min_days: 2, max_days: 3 },
{ pincode: 623702, min_days: 2, max_days: 3 },
{ pincode: 623703, min_days: 2, max_days: 3 },
{ pincode: 623704, min_days: 2, max_days: 3 },
{ pincode: 623705, min_days: 2, max_days: 3 },
{ pincode: 623706, min_days: 2, max_days: 3 },
{ pincode: 623707, min_days: 2, max_days: 3 },
{ pincode: 623708, min_days: 2, max_days: 3 },
{ pincode: 623711, min_days: 2, max_days: 3 },
{ pincode: 623712, min_days: 2, max_days: 3 },
{ pincode: 623713, min_days: 2, max_days: 3 },
{ pincode: 623719, min_days: 2, max_days: 3 },
{ pincode: 623721, min_days: 2, max_days: 3 },
{ pincode: 623801, min_days: 2, max_days: 3 },
{ pincode: 623802, min_days: 2, max_days: 3 },
{ pincode: 623804, min_days: 2, max_days: 3 },
{ pincode: 623806, min_days: 2, max_days: 3 },
{ pincode: 623807, min_days: 2, max_days: 3 },
{ pincode: 623808, min_days: 2, max_days: 3 },
{ pincode: 624001, min_days: 2, max_days: 3 },
{ pincode: 624002, min_days: 2, max_days: 3 },
{ pincode: 624003, min_days: 2, max_days: 3 },
{ pincode: 624004, min_days: 2, max_days: 3 },
{ pincode: 624005, min_days: 2, max_days: 3 },
{ pincode: 624006, min_days: 2, max_days: 3 },
{ pincode: 624007, min_days: 2, max_days: 3 },
{ pincode: 624008, min_days: 2, max_days: 3 },
{ pincode: 624009, min_days: 2, max_days: 3 },
{ pincode: 624010, min_days: 2, max_days: 3 },
{ pincode: 624051, min_days: 2, max_days: 3 },
{ pincode: 624052, min_days: 2, max_days: 3 },
{ pincode: 624053, min_days: 2, max_days: 3 },
{ pincode: 624054, min_days: 2, max_days: 3 },
{ pincode: 624101, min_days: 2, max_days: 3 },
{ pincode: 624102, min_days: 2, max_days: 3 },
{ pincode: 624103, min_days: 2, max_days: 3 },
{ pincode: 624104, min_days: 2, max_days: 3 },
{ pincode: 624105, min_days: 2, max_days: 3 },
{ pincode: 624106, min_days: 2, max_days: 3 },
{ pincode: 624107, min_days: 2, max_days: 3 },
{ pincode: 624108, min_days: 2, max_days: 3 },
{ pincode: 624126, min_days: 2, max_days: 3 },
{ pincode: 624201, min_days: 2, max_days: 3 },
{ pincode: 624202, min_days: 2, max_days: 3 },
{ pincode: 624203, min_days: 2, max_days: 3 },
{ pincode: 624204, min_days: 2, max_days: 3 },
{ pincode: 624205, min_days: 2, max_days: 3 },
{ pincode: 624206, min_days: 2, max_days: 3 },
{ pincode: 624207, min_days: 2, max_days: 3 },
{ pincode: 624208, min_days: 2, max_days: 3 },
{ pincode: 624209, min_days: 2, max_days: 3 },
{ pincode: 624210, min_days: 2, max_days: 3 },
{ pincode: 624211, min_days: 2, max_days: 3 },
{ pincode: 624212, min_days: 2, max_days: 3 },
{ pincode: 624213, min_days: 2, max_days: 3 },
{ pincode: 624214, min_days: 2, max_days: 3 },
{ pincode: 624215, min_days: 2, max_days: 3 },
{ pincode: 624216, min_days: 2, max_days: 3 },
{ pincode: 624217, min_days: 2, max_days: 3 },
{ pincode: 624218, min_days: 2, max_days: 3 },
{ pincode: 624219, min_days: 2, max_days: 3 },
{ pincode: 624220, min_days: 2, max_days: 3 },
{ pincode: 624221, min_days: 2, max_days: 3 },
{ pincode: 624222, min_days: 2, max_days: 3 },
{ pincode: 624223, min_days: 2, max_days: 3 },
{ pincode: 624224, min_days: 2, max_days: 3 },
{ pincode: 624225, min_days: 2, max_days: 3 },
{ pincode: 624227, min_days: 2, max_days: 3 },
{ pincode: 624228, min_days: 2, max_days: 3 },
{ pincode: 624230, min_days: 2, max_days: 3 },
{ pincode: 624231, min_days: 2, max_days: 3 },
{ pincode: 624232, min_days: 2, max_days: 3 },
{ pincode: 624233, min_days: 2, max_days: 3 },
{ pincode: 624234, min_days: 2, max_days: 3 },
{ pincode: 624301, min_days: 2, max_days: 3 },
{ pincode: 624302, min_days: 2, max_days: 3 },
{ pincode: 624303, min_days: 2, max_days: 3 },
{ pincode: 624304, min_days: 2, max_days: 3 },
{ pincode: 624305, min_days: 2, max_days: 3 },
{ pincode: 624306, min_days: 2, max_days: 3 },
{ pincode: 624307, min_days: 2, max_days: 3 },
{ pincode: 624308, min_days: 2, max_days: 3 },
{ pincode: 624309, min_days: 2, max_days: 3 },
{ pincode: 624310, min_days: 2, max_days: 3 },
{ pincode: 624312, min_days: 2, max_days: 3 },
{ pincode: 624314, min_days: 2, max_days: 3 },
{ pincode: 624316, min_days: 2, max_days: 3 },
{ pincode: 624317, min_days: 2, max_days: 3 },
{ pincode: 624318, min_days: 2, max_days: 3 },
{ pincode: 624401, min_days: 2, max_days: 3 },
{ pincode: 624402, min_days: 2, max_days: 3 },
{ pincode: 624403, min_days: 2, max_days: 3 },
{ pincode: 624414, min_days: 2, max_days: 3 },
{ pincode: 624502, min_days: 2, max_days: 3 },
{ pincode: 624503, min_days: 2, max_days: 3 },
{ pincode: 624504, min_days: 2, max_days: 3 },
{ pincode: 624507, min_days: 2, max_days: 3 },
{ pincode: 624513, min_days: 2, max_days: 3 },
{ pincode: 624601, min_days: 2, max_days: 3 },
{ pincode: 624602, min_days: 2, max_days: 3 },
{ pincode: 624610, min_days: 2, max_days: 3 },
{ pincode: 624611, min_days: 2, max_days: 3 },
{ pincode: 624612, min_days: 2, max_days: 3 },
{ pincode: 624613, min_days: 2, max_days: 3 },
{ pincode: 624614, min_days: 2, max_days: 3 },
{ pincode: 624615, min_days: 2, max_days: 3 },
{ pincode: 624616, min_days: 2, max_days: 3 },
{ pincode: 624617, min_days: 2, max_days: 3 },
{ pincode: 624618, min_days: 2, max_days: 3 },
{ pincode: 624619, min_days: 2, max_days: 3 },
{ pincode: 624620, min_days: 2, max_days: 3 },
{ pincode: 624621, min_days: 2, max_days: 3 },
{ pincode: 624622, min_days: 2, max_days: 3 },
{ pincode: 624623, min_days: 2, max_days: 3 },
{ pincode: 624624, min_days: 2, max_days: 3 },
{ pincode: 624625, min_days: 2, max_days: 3 },
{ pincode: 624627, min_days: 2, max_days: 3 },
{ pincode: 624628, min_days: 2, max_days: 3 },
{ pincode: 624701, min_days: 2, max_days: 3 },
{ pincode: 624702, min_days: 2, max_days: 3 },
{ pincode: 624703, min_days: 2, max_days: 3 },
{ pincode: 624704, min_days: 2, max_days: 3 },
{ pincode: 624705, min_days: 2, max_days: 3 },
{ pincode: 624706, min_days: 2, max_days: 3 },
{ pincode: 624707, min_days: 2, max_days: 3 },
{ pincode: 624708, min_days: 2, max_days: 3 },
{ pincode: 624709, min_days: 2, max_days: 3 },
{ pincode: 624710, min_days: 2, max_days: 3 },
{ pincode: 624711, min_days: 2, max_days: 3 },
{ pincode: 624712, min_days: 2, max_days: 3 },
{ pincode: 624714, min_days: 2, max_days: 3 },
{ pincode: 624801, min_days: 2, max_days: 3 },
{ pincode: 624802, min_days: 2, max_days: 3 },
{ pincode: 624803, min_days: 2, max_days: 3 },
{ pincode: 624804, min_days: 2, max_days: 3 },
{ pincode: 625001, min_days: 2, max_days: 3 },
{ pincode: 625002, min_days: 2, max_days: 3 },
{ pincode: 625003, min_days: 2, max_days: 3 },
{ pincode: 625004, min_days: 2, max_days: 3 },
{ pincode: 625005, min_days: 2, max_days: 3 },
{ pincode: 625006, min_days: 2, max_days: 3 },
{ pincode: 625007, min_days: 2, max_days: 3 },
{ pincode: 625008, min_days: 2, max_days: 3 },
{ pincode: 625009, min_days: 2, max_days: 3 },
{ pincode: 625010, min_days: 2, max_days: 3 },
{ pincode: 625011, min_days: 2, max_days: 3 },
{ pincode: 625012, min_days: 2, max_days: 3 },
{ pincode: 625013, min_days: 2, max_days: 3 },
{ pincode: 625014, min_days: 2, max_days: 3 },
{ pincode: 625015, min_days: 2, max_days: 3 },
{ pincode: 625016, min_days: 2, max_days: 3 },
{ pincode: 625017, min_days: 2, max_days: 3 },
{ pincode: 625018, min_days: 2, max_days: 3 },
{ pincode: 625019, min_days: 2, max_days: 3 },
{ pincode: 625020, min_days: 2, max_days: 3 },
{ pincode: 625021, min_days: 2, max_days: 3 },
{ pincode: 625022, min_days: 2, max_days: 3 },
{ pincode: 625023, min_days: 2, max_days: 3 },
{ pincode: 625051, min_days: 2, max_days: 3 },
{ pincode: 625052, min_days: 2, max_days: 3 },
{ pincode: 625101, min_days: 2, max_days: 3 },
{ pincode: 625102, min_days: 2, max_days: 3 },
{ pincode: 625103, min_days: 2, max_days: 3 },
{ pincode: 625104, min_days: 2, max_days: 3 },
{ pincode: 625105, min_days: 2, max_days: 3 },
{ pincode: 625106, min_days: 2, max_days: 3 },
{ pincode: 625107, min_days: 2, max_days: 3 },
{ pincode: 625108, min_days: 2, max_days: 3 },
{ pincode: 625109, min_days: 2, max_days: 3 },
{ pincode: 625110, min_days: 2, max_days: 3 },
{ pincode: 625111, min_days: 2, max_days: 3 },
{ pincode: 625112, min_days: 2, max_days: 3 },
{ pincode: 625113, min_days: 2, max_days: 3 },
{ pincode: 625114, min_days: 2, max_days: 3 },
{ pincode: 625115, min_days: 2, max_days: 3 },
{ pincode: 625116, min_days: 2, max_days: 3 },
{ pincode: 625117, min_days: 2, max_days: 3 },
{ pincode: 625118, min_days: 2, max_days: 3 },
{ pincode: 625119, min_days: 2, max_days: 3 },
{ pincode: 625120, min_days: 2, max_days: 3 },
{ pincode: 625121, min_days: 2, max_days: 3 },
{ pincode: 625122, min_days: 2, max_days: 3 },
{ pincode: 625123, min_days: 2, max_days: 3 },
{ pincode: 625124, min_days: 2, max_days: 3 },
{ pincode: 625125, min_days: 2, max_days: 3 },
{ pincode: 625126, min_days: 2, max_days: 3 },
{ pincode: 625127, min_days: 2, max_days: 3 },
{ pincode: 625129, min_days: 2, max_days: 3 },
{ pincode: 625160, min_days: 2, max_days: 3 },
{ pincode: 625201, min_days: 2, max_days: 3 },
{ pincode: 625203, min_days: 2, max_days: 3 },
{ pincode: 625205, min_days: 2, max_days: 3 },
{ pincode: 625207, min_days: 2, max_days: 3 },
{ pincode: 625214, min_days: 2, max_days: 3 },
{ pincode: 625217, min_days: 2, max_days: 3 },
{ pincode: 625218, min_days: 2, max_days: 3 },
{ pincode: 625220, min_days: 2, max_days: 3 },
{ pincode: 625221, min_days: 2, max_days: 3 },
{ pincode: 625234, min_days: 2, max_days: 3 },
{ pincode: 625301, min_days: 2, max_days: 3 },
{ pincode: 625302, min_days: 2, max_days: 3 },
{ pincode: 625304, min_days: 2, max_days: 3 },
{ pincode: 625305, min_days: 2, max_days: 3 },
{ pincode: 625307, min_days: 2, max_days: 3 },
{ pincode: 625401, min_days: 2, max_days: 3 },
{ pincode: 625402, min_days: 2, max_days: 3 },
{ pincode: 625403, min_days: 2, max_days: 3 },
{ pincode: 625404, min_days: 2, max_days: 3 },
{ pincode: 625418, min_days: 2, max_days: 3 },
{ pincode: 625501, min_days: 2, max_days: 3 },
{ pincode: 625502, min_days: 2, max_days: 3 },
{ pincode: 625503, min_days: 2, max_days: 3 },
{ pincode: 625504, min_days: 2, max_days: 3 },
{ pincode: 625512, min_days: 2, max_days: 3 },
{ pincode: 625513, min_days: 2, max_days: 3 },
{ pincode: 625514, min_days: 2, max_days: 3 },
{ pincode: 625515, min_days: 2, max_days: 3 },
{ pincode: 625516, min_days: 2, max_days: 3 },
{ pincode: 625517, min_days: 2, max_days: 3 },
{ pincode: 625518, min_days: 2, max_days: 3 },
{ pincode: 625519, min_days: 2, max_days: 3 },
{ pincode: 625520, min_days: 2, max_days: 3 },
{ pincode: 625521, min_days: 2, max_days: 3 },
{ pincode: 625522, min_days: 2, max_days: 3 },
{ pincode: 625523, min_days: 2, max_days: 3 },
{ pincode: 625524, min_days: 2, max_days: 3 },
{ pincode: 625525, min_days: 2, max_days: 3 },
{ pincode: 625526, min_days: 2, max_days: 3 },
{ pincode: 625527, min_days: 2, max_days: 3 },
{ pincode: 625528, min_days: 2, max_days: 3 },
{ pincode: 625529, min_days: 2, max_days: 3 },
{ pincode: 625530, min_days: 2, max_days: 3 },
{ pincode: 625531, min_days: 2, max_days: 3 },
{ pincode: 625532, min_days: 2, max_days: 3 },
{ pincode: 625533, min_days: 2, max_days: 3 },
{ pincode: 625534, min_days: 2, max_days: 3 },
{ pincode: 625535, min_days: 2, max_days: 3 },
{ pincode: 625536, min_days: 2, max_days: 3 },
{ pincode: 625537, min_days: 2, max_days: 3 },
{ pincode: 625538, min_days: 2, max_days: 3 },
{ pincode: 625540, min_days: 2, max_days: 3 },
{ pincode: 625547, min_days: 2, max_days: 3 },
{ pincode: 625552, min_days: 2, max_days: 3 },
{ pincode: 625556, min_days: 2, max_days: 3 },
{ pincode: 625562, min_days: 2, max_days: 3 },
{ pincode: 625566, min_days: 2, max_days: 3 },
{ pincode: 625572, min_days: 2, max_days: 3 },
{ pincode: 625577, min_days: 2, max_days: 3 },
{ pincode: 625579, min_days: 2, max_days: 3 },
{ pincode: 625582, min_days: 2, max_days: 3 },
{ pincode: 625601, min_days: 2, max_days: 3 },
{ pincode: 625602, min_days: 2, max_days: 3 },
{ pincode: 625603, min_days: 2, max_days: 3 },
{ pincode: 625604, min_days: 2, max_days: 3 },
{ pincode: 625605, min_days: 2, max_days: 3 },
{ pincode: 625701, min_days: 2, max_days: 3 },
{ pincode: 625702, min_days: 2, max_days: 3 },
{ pincode: 625703, min_days: 2, max_days: 3 },
{ pincode: 625704, min_days: 2, max_days: 3 },
{ pincode: 625705, min_days: 2, max_days: 3 },
{ pincode: 625706, min_days: 2, max_days: 3 },
{ pincode: 625707, min_days: 2, max_days: 3 },
{ pincode: 625708, min_days: 2, max_days: 3 },
{ pincode: 625905, min_days: 2, max_days: 3 },
{ pincode: 626001, min_days: 2, max_days: 3 },
{ pincode: 626002, min_days: 2, max_days: 3 },
{ pincode: 626003, min_days: 2, max_days: 3 },
{ pincode: 626004, min_days: 2, max_days: 3 },
{ pincode: 626005, min_days: 2, max_days: 3 },
{ pincode: 626008, min_days: 2, max_days: 3 },
{ pincode: 626052, min_days: 2, max_days: 3 },
{ pincode: 626053, min_days: 2, max_days: 3 },
{ pincode: 626055, min_days: 2, max_days: 3 },
{ pincode: 626058, min_days: 2, max_days: 3 },
{ pincode: 626101, min_days: 2, max_days: 3 },
{ pincode: 626102, min_days: 2, max_days: 3 },
{ pincode: 626103, min_days: 2, max_days: 3 },
{ pincode: 626104, min_days: 2, max_days: 3 },
{ pincode: 626105, min_days: 2, max_days: 3 },
{ pincode: 626106, min_days: 2, max_days: 3 },
{ pincode: 626107, min_days: 2, max_days: 3 },
{ pincode: 626108, min_days: 2, max_days: 3 },
{ pincode: 626109, min_days: 2, max_days: 3 },
{ pincode: 626110, min_days: 2, max_days: 3 },
{ pincode: 626111, min_days: 2, max_days: 3 },
{ pincode: 626112, min_days: 2, max_days: 3 },
{ pincode: 626113, min_days: 2, max_days: 3 },
{ pincode: 626114, min_days: 2, max_days: 3 },
{ pincode: 626115, min_days: 2, max_days: 3 },
{ pincode: 626116, min_days: 2, max_days: 3 },
{ pincode: 626117, min_days: 2, max_days: 3 },
{ pincode: 626118, min_days: 2, max_days: 3 },
{ pincode: 626119, min_days: 2, max_days: 3 },
{ pincode: 626121, min_days: 2, max_days: 3 },
{ pincode: 626122, min_days: 2, max_days: 3 },
{ pincode: 626123, min_days: 2, max_days: 3 },
{ pincode: 626124, min_days: 2, max_days: 3 },
{ pincode: 626125, min_days: 2, max_days: 3 },
{ pincode: 626126, min_days: 2, max_days: 3 },
{ pincode: 626127, min_days: 2, max_days: 3 },
{ pincode: 626128, min_days: 2, max_days: 3 },
{ pincode: 626129, min_days: 2, max_days: 3 },
{ pincode: 626130, min_days: 2, max_days: 3 },
{ pincode: 626131, min_days: 2, max_days: 3 },
{ pincode: 626132, min_days: 2, max_days: 3 },
{ pincode: 626133, min_days: 2, max_days: 3 },
{ pincode: 626134, min_days: 2, max_days: 3 },
{ pincode: 626135, min_days: 2, max_days: 3 },
{ pincode: 626136, min_days: 2, max_days: 3 },
{ pincode: 626137, min_days: 2, max_days: 3 },
{ pincode: 626138, min_days: 2, max_days: 3 },
{ pincode: 626139, min_days: 2, max_days: 3 },
{ pincode: 626140, min_days: 2, max_days: 3 },
{ pincode: 626141, min_days: 2, max_days: 3 },
{ pincode: 626142, min_days: 2, max_days: 3 },
{ pincode: 626143, min_days: 2, max_days: 3 },
{ pincode: 626144, min_days: 2, max_days: 3 },
{ pincode: 626145, min_days: 2, max_days: 3 },
{ pincode: 626146, min_days: 2, max_days: 3 },
{ pincode: 626147, min_days: 2, max_days: 3 },
{ pincode: 626148, min_days: 2, max_days: 3 },
{ pincode: 626149, min_days: 2, max_days: 3 },
{ pincode: 626150, min_days: 2, max_days: 3 },
{ pincode: 626151, min_days: 2, max_days: 3 },
{ pincode: 626152, min_days: 2, max_days: 3 },
{ pincode: 626154, min_days: 2, max_days: 3 },
{ pincode: 626155, min_days: 2, max_days: 3 },
{ pincode: 626157, min_days: 2, max_days: 3 },
{ pincode: 626159, min_days: 2, max_days: 3 },
{ pincode: 626160, min_days: 2, max_days: 3 },
{ pincode: 626161, min_days: 2, max_days: 3 },
{ pincode: 626162, min_days: 2, max_days: 3 },
{ pincode: 626164, min_days: 2, max_days: 3 },
{ pincode: 626165, min_days: 2, max_days: 3 },
{ pincode: 626167, min_days: 2, max_days: 3 },
{ pincode: 626170, min_days: 2, max_days: 3 },
{ pincode: 626171, min_days: 2, max_days: 3 },
{ pincode: 626173, min_days: 2, max_days: 3 },
{ pincode: 626175, min_days: 2, max_days: 3 },
{ pincode: 626176, min_days: 2, max_days: 3 },
{ pincode: 626177, min_days: 2, max_days: 3 },
{ pincode: 626178, min_days: 2, max_days: 3 },
{ pincode: 626179, min_days: 2, max_days: 3 },
{ pincode: 626180, min_days: 2, max_days: 3 },
{ pincode: 626181, min_days: 2, max_days: 3 },
{ pincode: 626182, min_days: 2, max_days: 3 },
{ pincode: 626183, min_days: 2, max_days: 3 },
{ pincode: 626184, min_days: 2, max_days: 3 },
{ pincode: 626186, min_days: 2, max_days: 3 },
{ pincode: 626188, min_days: 2, max_days: 3 },
{ pincode: 626189, min_days: 2, max_days: 3 },
{ pincode: 626190, min_days: 2, max_days: 3 },
{ pincode: 626195, min_days: 2, max_days: 3 },
{ pincode: 626201, min_days: 2, max_days: 3 },
{ pincode: 626202, min_days: 2, max_days: 3 },
{ pincode: 626203, min_days: 2, max_days: 3 },
{ pincode: 626204, min_days: 2, max_days: 3 },
{ pincode: 626205, min_days: 2, max_days: 3 },
{ pincode: 626206, min_days: 2, max_days: 3 },
{ pincode: 626207, min_days: 2, max_days: 3 },
{ pincode: 626208, min_days: 2, max_days: 3 },
{ pincode: 626209, min_days: 2, max_days: 3 },
{ pincode: 626210, min_days: 2, max_days: 3 },
{ pincode: 626211, min_days: 2, max_days: 3 },
{ pincode: 626213, min_days: 2, max_days: 3 },
{ pincode: 626501, min_days: 2, max_days: 3 },
{ pincode: 626512, min_days: 2, max_days: 3 },
{ pincode: 626513, min_days: 2, max_days: 3 },
{ pincode: 626514, min_days: 2, max_days: 3 },
{ pincode: 626515, min_days: 2, max_days: 3 },
{ pincode: 626516, min_days: 2, max_days: 3 },
{ pincode: 626517, min_days: 2, max_days: 3 },
{ pincode: 626518, min_days: 2, max_days: 3 },
{ pincode: 626519, min_days: 2, max_days: 3 },
{ pincode: 626520, min_days: 2, max_days: 3 },
{ pincode: 626521, min_days: 2, max_days: 3 },
{ pincode: 626522, min_days: 2, max_days: 3 },
{ pincode: 626523, min_days: 2, max_days: 3 },
{ pincode: 626524, min_days: 2, max_days: 3 },
{ pincode: 626525, min_days: 2, max_days: 3 },
{ pincode: 626526, min_days: 2, max_days: 3 },
{ pincode: 626527, min_days: 2, max_days: 3 },
{ pincode: 626528, min_days: 2, max_days: 3 },
{ pincode: 626529, min_days: 2, max_days: 3 },
{ pincode: 626530, min_days: 2, max_days: 3 },
{ pincode: 626531, min_days: 2, max_days: 3 },
{ pincode: 626533, min_days: 2, max_days: 3 },
{ pincode: 626536, min_days: 2, max_days: 3 },
{ pincode: 626540, min_days: 2, max_days: 3 },
{ pincode: 626541, min_days: 2, max_days: 3 },
{ pincode: 626544, min_days: 2, max_days: 3 },
{ pincode: 626547, min_days: 2, max_days: 3 },
{ pincode: 626549, min_days: 2, max_days: 3 },
{ pincode: 626553, min_days: 2, max_days: 3 },
{ pincode: 626569, min_days: 2, max_days: 3 },
{ pincode: 626571, min_days: 2, max_days: 3 },
{ pincode: 626572, min_days: 2, max_days: 3 },
{ pincode: 626579, min_days: 2, max_days: 3 },
{ pincode: 626582, min_days: 2, max_days: 3 },
{ pincode: 626601, min_days: 2, max_days: 3 },
{ pincode: 626607, min_days: 2, max_days: 3 },
{ pincode: 626612, min_days: 2, max_days: 3 },
{ pincode: 626639, min_days: 2, max_days: 3 },
{ pincode: 626704, min_days: 2, max_days: 3 },
{ pincode: 626705, min_days: 2, max_days: 3 },
{ pincode: 626706, min_days: 2, max_days: 3 },
{ pincode: 626709, min_days: 2, max_days: 3 },
{ pincode: 626712, min_days: 2, max_days: 3 },
{ pincode: 626716, min_days: 2, max_days: 3 },
{ pincode: 626717, min_days: 2, max_days: 3 },
{ pincode: 626719, min_days: 2, max_days: 3 },
{ pincode: 627001, min_days: 2, max_days: 3 },
{ pincode: 627002, min_days: 2, max_days: 3 },
{ pincode: 627003, min_days: 2, max_days: 3 },
{ pincode: 627004, min_days: 2, max_days: 3 },
{ pincode: 627005, min_days: 2, max_days: 3 },
{ pincode: 627006, min_days: 2, max_days: 3 },
{ pincode: 627007, min_days: 2, max_days: 3 },
{ pincode: 627008, min_days: 2, max_days: 3 },
{ pincode: 627009, min_days: 2, max_days: 3 },
{ pincode: 627010, min_days: 2, max_days: 3 },
{ pincode: 627011, min_days: 2, max_days: 3 },
{ pincode: 627012, min_days: 2, max_days: 3 },
{ pincode: 627051, min_days: 2, max_days: 3 },
{ pincode: 627101, min_days: 2, max_days: 3 },
{ pincode: 627102, min_days: 2, max_days: 3 },
{ pincode: 627103, min_days: 2, max_days: 3 },
{ pincode: 627104, min_days: 2, max_days: 3 },
{ pincode: 627105, min_days: 2, max_days: 3 },
{ pincode: 627106, min_days: 2, max_days: 3 },
{ pincode: 627107, min_days: 2, max_days: 3 },
{ pincode: 627108, min_days: 2, max_days: 3 },
{ pincode: 627109, min_days: 2, max_days: 3 },
{ pincode: 627110, min_days: 2, max_days: 3 },
{ pincode: 627111, min_days: 2, max_days: 3 },
{ pincode: 627112, min_days: 2, max_days: 3 },
{ pincode: 627113, min_days: 2, max_days: 3 },
{ pincode: 627114, min_days: 2, max_days: 3 },
{ pincode: 627115, min_days: 2, max_days: 3 },
{ pincode: 627116, min_days: 2, max_days: 3 },
{ pincode: 627117, min_days: 2, max_days: 3 },
{ pincode: 627118, min_days: 2, max_days: 3 },
{ pincode: 627119, min_days: 2, max_days: 3 },
{ pincode: 627120, min_days: 2, max_days: 3 },
{ pincode: 627121, min_days: 2, max_days: 3 },
{ pincode: 627122, min_days: 2, max_days: 3 },
{ pincode: 627123, min_days: 2, max_days: 3 },
{ pincode: 627124, min_days: 2, max_days: 3 },
{ pincode: 627126, min_days: 2, max_days: 3 },
{ pincode: 627127, min_days: 2, max_days: 3 },
{ pincode: 627128, min_days: 2, max_days: 3 },
{ pincode: 627129, min_days: 2, max_days: 3 },
{ pincode: 627130, min_days: 2, max_days: 3 },
{ pincode: 627131, min_days: 2, max_days: 3 },
{ pincode: 627132, min_days: 2, max_days: 3 },
{ pincode: 627133, min_days: 2, max_days: 3 },
{ pincode: 627151, min_days: 2, max_days: 3 },
{ pincode: 627152, min_days: 2, max_days: 3 },
{ pincode: 627153, min_days: 2, max_days: 3 },
{ pincode: 627154, min_days: 2, max_days: 3 },
{ pincode: 627201, min_days: 2, max_days: 3 },
{ pincode: 627202, min_days: 2, max_days: 3 },
{ pincode: 627251, min_days: 2, max_days: 3 },
{ pincode: 627252, min_days: 2, max_days: 3 },
{ pincode: 627253, min_days: 2, max_days: 3 },
{ pincode: 627254, min_days: 2, max_days: 3 },
{ pincode: 627301, min_days: 2, max_days: 3 },
{ pincode: 627302, min_days: 2, max_days: 3 },
{ pincode: 627303, min_days: 2, max_days: 3 },
{ pincode: 627304, min_days: 2, max_days: 3 },
{ pincode: 627305, min_days: 2, max_days: 3 },
{ pincode: 627351, min_days: 2, max_days: 3 },
{ pincode: 627352, min_days: 2, max_days: 3 },
{ pincode: 627353, min_days: 2, max_days: 3 },
{ pincode: 627354, min_days: 2, max_days: 3 },
{ pincode: 627355, min_days: 2, max_days: 3 },
{ pincode: 627356, min_days: 2, max_days: 3 },
{ pincode: 627357, min_days: 2, max_days: 3 },
{ pincode: 627358, min_days: 2, max_days: 3 },
{ pincode: 627359, min_days: 2, max_days: 3 },
{ pincode: 627360, min_days: 2, max_days: 3 },
{ pincode: 627361, min_days: 2, max_days: 3 },
{ pincode: 627401, min_days: 2, max_days: 3 },
{ pincode: 627405, min_days: 2, max_days: 3 },
{ pincode: 627412, min_days: 2, max_days: 3 },
{ pincode: 627413, min_days: 2, max_days: 3 },
{ pincode: 627414, min_days: 2, max_days: 3 },
{ pincode: 627415, min_days: 2, max_days: 3 },
{ pincode: 627416, min_days: 2, max_days: 3 },
{ pincode: 627417, min_days: 2, max_days: 3 },
{ pincode: 627418, min_days: 2, max_days: 3 },
{ pincode: 627419, min_days: 2, max_days: 3 },
{ pincode: 627420, min_days: 2, max_days: 3 },
{ pincode: 627421, min_days: 2, max_days: 3 },
{ pincode: 627422, min_days: 2, max_days: 3 },
{ pincode: 627423, min_days: 2, max_days: 3 },
{ pincode: 627424, min_days: 2, max_days: 3 },
{ pincode: 627425, min_days: 2, max_days: 3 },
{ pincode: 627426, min_days: 2, max_days: 3 },
{ pincode: 627427, min_days: 2, max_days: 3 },
{ pincode: 627428, min_days: 2, max_days: 3 },
{ pincode: 627430, min_days: 2, max_days: 3 },
{ pincode: 627431, min_days: 2, max_days: 3 },
{ pincode: 627432, min_days: 2, max_days: 3 },
{ pincode: 627433, min_days: 2, max_days: 3 },
{ pincode: 627434, min_days: 2, max_days: 3 },
{ pincode: 627435, min_days: 2, max_days: 3 },
{ pincode: 627436, min_days: 2, max_days: 3 },
{ pincode: 627451, min_days: 2, max_days: 3 },
{ pincode: 627452, min_days: 2, max_days: 3 },
{ pincode: 627453, min_days: 2, max_days: 3 },
{ pincode: 627501, min_days: 2, max_days: 3 },
{ pincode: 627502, min_days: 2, max_days: 3 },
{ pincode: 627545, min_days: 2, max_days: 3 },
{ pincode: 627551, min_days: 2, max_days: 3 },
{ pincode: 627555, min_days: 2, max_days: 3 },
{ pincode: 627556, min_days: 2, max_days: 3 },
{ pincode: 627601, min_days: 2, max_days: 3 },
{ pincode: 627602, min_days: 2, max_days: 3 },
{ pincode: 627603, min_days: 2, max_days: 3 },
{ pincode: 627604, min_days: 2, max_days: 3 },
{ pincode: 627651, min_days: 2, max_days: 3 },
{ pincode: 627652, min_days: 2, max_days: 3 },
{ pincode: 627654, min_days: 2, max_days: 3 },
{ pincode: 627657, min_days: 2, max_days: 3 },
{ pincode: 627658, min_days: 2, max_days: 3 },
{ pincode: 627659, min_days: 2, max_days: 3 },
{ pincode: 627701, min_days: 2, max_days: 3 },
{ pincode: 627702, min_days: 2, max_days: 3 },
{ pincode: 627706, min_days: 2, max_days: 3 },
{ pincode: 627712, min_days: 2, max_days: 3 },
{ pincode: 627713, min_days: 2, max_days: 3 },
{ pincode: 627714, min_days: 2, max_days: 3 },
{ pincode: 627716, min_days: 2, max_days: 3 },
{ pincode: 627717, min_days: 2, max_days: 3 },
{ pincode: 627718, min_days: 2, max_days: 3 },
{ pincode: 627719, min_days: 2, max_days: 3 },
{ pincode: 627720, min_days: 2, max_days: 3 },
{ pincode: 627721, min_days: 2, max_days: 3 },
{ pincode: 627722, min_days: 2, max_days: 3 },
{ pincode: 627723, min_days: 2, max_days: 3 },
{ pincode: 627724, min_days: 2, max_days: 3 },
{ pincode: 627725, min_days: 2, max_days: 3 },
{ pincode: 627726, min_days: 2, max_days: 3 },
{ pincode: 627727, min_days: 2, max_days: 3 },
{ pincode: 627751, min_days: 2, max_days: 3 },
{ pincode: 627752, min_days: 2, max_days: 3 },
{ pincode: 627753, min_days: 2, max_days: 3 },
{ pincode: 627754, min_days: 2, max_days: 3 },
{ pincode: 627755, min_days: 2, max_days: 3 },
{ pincode: 627756, min_days: 2, max_days: 3 },
{ pincode: 627757, min_days: 2, max_days: 3 },
{ pincode: 627758, min_days: 2, max_days: 3 },
{ pincode: 627759, min_days: 2, max_days: 3 },
{ pincode: 627760, min_days: 2, max_days: 3 },
{ pincode: 627761, min_days: 2, max_days: 3 },
{ pincode: 627762, min_days: 2, max_days: 3 },
{ pincode: 627763, min_days: 2, max_days: 3 },
{ pincode: 627764, min_days: 2, max_days: 3 },
{ pincode: 627765, min_days: 2, max_days: 3 },
{ pincode: 627767, min_days: 2, max_days: 3 },
{ pincode: 627768, min_days: 2, max_days: 3 },
{ pincode: 627769, min_days: 2, max_days: 3 },
{ pincode: 627770, min_days: 2, max_days: 3 },
{ pincode: 627771, min_days: 2, max_days: 3 },
{ pincode: 627773, min_days: 2, max_days: 3 },
{ pincode: 627774, min_days: 2, max_days: 3 },
{ pincode: 627801, min_days: 2, max_days: 3 },
{ pincode: 627802, min_days: 2, max_days: 3 },
{ pincode: 627803, min_days: 2, max_days: 3 },
{ pincode: 627804, min_days: 2, max_days: 3 },
{ pincode: 627805, min_days: 2, max_days: 3 },
{ pincode: 627806, min_days: 2, max_days: 3 },
{ pincode: 627807, min_days: 2, max_days: 3 },
{ pincode: 627808, min_days: 2, max_days: 3 },
{ pincode: 627809, min_days: 2, max_days: 3 },
{ pincode: 627810, min_days: 2, max_days: 3 },
{ pincode: 627811, min_days: 2, max_days: 3 },
{ pincode: 627812, min_days: 2, max_days: 3 },
{ pincode: 627813, min_days: 2, max_days: 3 },
{ pincode: 627814, min_days: 2, max_days: 3 },
{ pincode: 627815, min_days: 2, max_days: 3 },
{ pincode: 627817, min_days: 2, max_days: 3 },
{ pincode: 627818, min_days: 2, max_days: 3 },
{ pincode: 627819, min_days: 2, max_days: 3 },
{ pincode: 627821, min_days: 2, max_days: 3 },
{ pincode: 627822, min_days: 2, max_days: 3 },
{ pincode: 627823, min_days: 2, max_days: 3 },
{ pincode: 627851, min_days: 2, max_days: 3 },
{ pincode: 627852, min_days: 2, max_days: 3 },
{ pincode: 627853, min_days: 2, max_days: 3 },
{ pincode: 627854, min_days: 2, max_days: 3 },
{ pincode: 627855, min_days: 2, max_days: 3 },
{ pincode: 627856, min_days: 2, max_days: 3 },
{ pincode: 627857, min_days: 2, max_days: 3 },
{ pincode: 627858, min_days: 2, max_days: 3 },
{ pincode: 627859, min_days: 2, max_days: 3 },
{ pincode: 627860, min_days: 2, max_days: 3 },
{ pincode: 627861, min_days: 2, max_days: 3 },
{ pincode: 627862, min_days: 2, max_days: 3 },
{ pincode: 627866, min_days: 2, max_days: 3 },
{ pincode: 627867, min_days: 2, max_days: 3 },
{ pincode: 627901, min_days: 2, max_days: 3 },
{ pincode: 627902, min_days: 2, max_days: 3 },
{ pincode: 627903, min_days: 2, max_days: 3 },
{ pincode: 627904, min_days: 2, max_days: 3 },
{ pincode: 627905, min_days: 2, max_days: 3 },
{ pincode: 627907, min_days: 2, max_days: 3 },
{ pincode: 627908, min_days: 2, max_days: 3 },
{ pincode: 627909, min_days: 2, max_days: 3 },
{ pincode: 627911, min_days: 2, max_days: 3 },
{ pincode: 627912, min_days: 2, max_days: 3 },
{ pincode: 627951, min_days: 2, max_days: 3 },
{ pincode: 627952, min_days: 2, max_days: 3 },
{ pincode: 627953, min_days: 2, max_days: 3 },
{ pincode: 627954, min_days: 2, max_days: 3 },
{ pincode: 627955, min_days: 2, max_days: 3 },
{ pincode: 627956, min_days: 2, max_days: 3 },
{ pincode: 628001, min_days: 2, max_days: 3 },
{ pincode: 628002, min_days: 2, max_days: 3 },
{ pincode: 628003, min_days: 2, max_days: 3 },
{ pincode: 628004, min_days: 2, max_days: 3 },
{ pincode: 628005, min_days: 2, max_days: 3 },
{ pincode: 628006, min_days: 2, max_days: 3 },
{ pincode: 628007, min_days: 2, max_days: 3 },
{ pincode: 628008, min_days: 2, max_days: 3 },
{ pincode: 628051, min_days: 2, max_days: 3 },
{ pincode: 628101, min_days: 2, max_days: 3 },
{ pincode: 628102, min_days: 2, max_days: 3 },
{ pincode: 628103, min_days: 2, max_days: 3 },
{ pincode: 628104, min_days: 2, max_days: 3 },
{ pincode: 628105, min_days: 2, max_days: 3 },
{ pincode: 628151, min_days: 2, max_days: 3 },
{ pincode: 628152, min_days: 2, max_days: 3 },
{ pincode: 628153, min_days: 2, max_days: 3 },
{ pincode: 628154, min_days: 2, max_days: 3 },
{ pincode: 628155, min_days: 2, max_days: 3 },
{ pincode: 628201, min_days: 2, max_days: 3 },
{ pincode: 628202, min_days: 2, max_days: 3 },
{ pincode: 628203, min_days: 2, max_days: 3 },
{ pincode: 628204, min_days: 2, max_days: 3 },
{ pincode: 628205, min_days: 2, max_days: 3 },
{ pincode: 628206, min_days: 2, max_days: 3 },
{ pincode: 628207, min_days: 2, max_days: 3 },
{ pincode: 628208, min_days: 2, max_days: 3 },
{ pincode: 628209, min_days: 2, max_days: 3 },
{ pincode: 628210, min_days: 2, max_days: 3 },
{ pincode: 628211, min_days: 2, max_days: 3 },
{ pincode: 628212, min_days: 2, max_days: 3 },
{ pincode: 628213, min_days: 2, max_days: 3 },
{ pincode: 628214, min_days: 2, max_days: 3 },
{ pincode: 628215, min_days: 2, max_days: 3 },
{ pincode: 628216, min_days: 2, max_days: 3 },
{ pincode: 628217, min_days: 2, max_days: 3 },
{ pincode: 628218, min_days: 2, max_days: 3 },
{ pincode: 628219, min_days: 2, max_days: 3 },
{ pincode: 628220, min_days: 2, max_days: 3 },
{ pincode: 628221, min_days: 2, max_days: 3 },
{ pincode: 628222, min_days: 2, max_days: 3 },
{ pincode: 628223, min_days: 2, max_days: 3 },
{ pincode: 628224, min_days: 2, max_days: 3 },
{ pincode: 628225, min_days: 2, max_days: 3 },
{ pincode: 628227, min_days: 2, max_days: 3 },
{ pincode: 628228, min_days: 2, max_days: 3 },
{ pincode: 628229, min_days: 2, max_days: 3 },
{ pincode: 628251, min_days: 2, max_days: 3 },
{ pincode: 628252, min_days: 2, max_days: 3 },
{ pincode: 628301, min_days: 2, max_days: 3 },
{ pincode: 628302, min_days: 2, max_days: 3 },
{ pincode: 628303, min_days: 2, max_days: 3 },
{ pincode: 628304, min_days: 2, max_days: 3 },
{ pincode: 628305, min_days: 2, max_days: 3 },
{ pincode: 628306, min_days: 2, max_days: 3 },
{ pincode: 628307, min_days: 2, max_days: 3 },
{ pincode: 628308, min_days: 2, max_days: 3 },
{ pincode: 628309, min_days: 2, max_days: 3 },
{ pincode: 628313, min_days: 2, max_days: 3 },
{ pincode: 628401, min_days: 2, max_days: 3 },
{ pincode: 628402, min_days: 2, max_days: 3 },
{ pincode: 628501, min_days: 2, max_days: 3 },
{ pincode: 628502, min_days: 2, max_days: 3 },
{ pincode: 628503, min_days: 2, max_days: 3 },
{ pincode: 628552, min_days: 2, max_days: 3 },
{ pincode: 628601, min_days: 2, max_days: 3 },
{ pincode: 628612, min_days: 2, max_days: 3 },
{ pincode: 628613, min_days: 2, max_days: 3 },
{ pincode: 628614, min_days: 2, max_days: 3 },
{ pincode: 628615, min_days: 2, max_days: 3 },
{ pincode: 628616, min_days: 2, max_days: 3 },
{ pincode: 628617, min_days: 2, max_days: 3 },
{ pincode: 628618, min_days: 2, max_days: 3 },
{ pincode: 628619, min_days: 2, max_days: 3 },
{ pincode: 628620, min_days: 2, max_days: 3 },
{ pincode: 628621, min_days: 2, max_days: 3 },
{ pincode: 628622, min_days: 2, max_days: 3 },
{ pincode: 628623, min_days: 2, max_days: 3 },
{ pincode: 628624, min_days: 2, max_days: 3 },
{ pincode: 628625, min_days: 2, max_days: 3 },
{ pincode: 628626, min_days: 2, max_days: 3 },
{ pincode: 628627, min_days: 2, max_days: 3 },
{ pincode: 628628, min_days: 2, max_days: 3 },
{ pincode: 628629, min_days: 2, max_days: 3 },
{ pincode: 628630, min_days: 2, max_days: 3 },
{ pincode: 628631, min_days: 2, max_days: 3 },
{ pincode: 628651, min_days: 2, max_days: 3 },
{ pincode: 628652, min_days: 2, max_days: 3 },
{ pincode: 628653, min_days: 2, max_days: 3 },
{ pincode: 628654, min_days: 2, max_days: 3 },
{ pincode: 628656, min_days: 2, max_days: 3 },
{ pincode: 628657, min_days: 2, max_days: 3 },
{ pincode: 628659, min_days: 2, max_days: 3 },
{ pincode: 628660, min_days: 2, max_days: 3 },
{ pincode: 628661, min_days: 2, max_days: 3 },
{ pincode: 628662, min_days: 2, max_days: 3 },
{ pincode: 628663, min_days: 2, max_days: 3 },
{ pincode: 628701, min_days: 2, max_days: 3 },
{ pincode: 628702, min_days: 2, max_days: 3 },
{ pincode: 628703, min_days: 2, max_days: 3 },
{ pincode: 628704, min_days: 2, max_days: 3 },
{ pincode: 628705, min_days: 2, max_days: 3 },
{ pincode: 628706, min_days: 2, max_days: 3 },
{ pincode: 628707, min_days: 2, max_days: 3 },
{ pincode: 628712, min_days: 2, max_days: 3 },
{ pincode: 628714, min_days: 2, max_days: 3 },
{ pincode: 628716, min_days: 2, max_days: 3 },
{ pincode: 628718, min_days: 2, max_days: 3 },
{ pincode: 628720, min_days: 2, max_days: 3 },
{ pincode: 628721, min_days: 2, max_days: 3 },
{ pincode: 628722, min_days: 2, max_days: 3 },
{ pincode: 628751, min_days: 2, max_days: 3 },
{ pincode: 628752, min_days: 2, max_days: 3 },
{ pincode: 628753, min_days: 2, max_days: 3 },
{ pincode: 628801, min_days: 2, max_days: 3 },
{ pincode: 628802, min_days: 2, max_days: 3 },
{ pincode: 628803, min_days: 2, max_days: 3 },
{ pincode: 628806, min_days: 2, max_days: 3 },
{ pincode: 628809, min_days: 2, max_days: 3 },
{ pincode: 628851, min_days: 2, max_days: 3 },
{ pincode: 628852, min_days: 2, max_days: 3 },
{ pincode: 628901, min_days: 2, max_days: 3 },
{ pincode: 628902, min_days: 2, max_days: 3 },
{ pincode: 628903, min_days: 2, max_days: 3 },
{ pincode: 628904, min_days: 2, max_days: 3 },
{ pincode: 628905, min_days: 2, max_days: 3 },
{ pincode: 628906, min_days: 2, max_days: 3 },
{ pincode: 628907, min_days: 2, max_days: 3 },
{ pincode: 628908, min_days: 2, max_days: 3 },
{ pincode: 628952, min_days: 2, max_days: 3 },
{ pincode: 629001, min_days: 2, max_days: 3 },
{ pincode: 629002, min_days: 2, max_days: 3 },
{ pincode: 629003, min_days: 2, max_days: 3 },
{ pincode: 629004, min_days: 2, max_days: 3 },
{ pincode: 629051, min_days: 2, max_days: 3 },
{ pincode: 629101, min_days: 2, max_days: 3 },
{ pincode: 629102, min_days: 2, max_days: 3 },
{ pincode: 629103, min_days: 2, max_days: 3 },
{ pincode: 629151, min_days: 2, max_days: 3 },
{ pincode: 629152, min_days: 2, max_days: 3 },
{ pincode: 629153, min_days: 2, max_days: 3 },
{ pincode: 629154, min_days: 2, max_days: 3 },
{ pincode: 629155, min_days: 2, max_days: 3 },
{ pincode: 629156, min_days: 2, max_days: 3 },
{ pincode: 629157, min_days: 2, max_days: 3 },
{ pincode: 629158, min_days: 2, max_days: 3 },
{ pincode: 629159, min_days: 2, max_days: 3 },
{ pincode: 629160, min_days: 2, max_days: 3 },
{ pincode: 629161, min_days: 2, max_days: 3 },
{ pincode: 629162, min_days: 2, max_days: 3 },
{ pincode: 629163, min_days: 2, max_days: 3 },
{ pincode: 629164, min_days: 2, max_days: 3 },
{ pincode: 629165, min_days: 2, max_days: 3 },
{ pincode: 629166, min_days: 2, max_days: 3 },
{ pincode: 629167, min_days: 2, max_days: 3 },
{ pincode: 629168, min_days: 2, max_days: 3 },
{ pincode: 629169, min_days: 2, max_days: 3 },
{ pincode: 629170, min_days: 2, max_days: 3 },
{ pincode: 629171, min_days: 2, max_days: 3 },
{ pincode: 629172, min_days: 2, max_days: 3 },
{ pincode: 629173, min_days: 2, max_days: 3 },
{ pincode: 629174, min_days: 2, max_days: 3 },
{ pincode: 629175, min_days: 2, max_days: 3 },
{ pincode: 629176, min_days: 2, max_days: 3 },
{ pincode: 629177, min_days: 2, max_days: 3 },
{ pincode: 629178, min_days: 2, max_days: 3 },
{ pincode: 629179, min_days: 2, max_days: 3 },
{ pincode: 629180, min_days: 2, max_days: 3 },
{ pincode: 629181, min_days: 2, max_days: 3 },
{ pincode: 629182, min_days: 2, max_days: 3 },
{ pincode: 629183, min_days: 2, max_days: 3 },
{ pincode: 629187, min_days: 2, max_days: 3 },
{ pincode: 629188, min_days: 2, max_days: 3 },
{ pincode: 629189, min_days: 2, max_days: 3 },
{ pincode: 629190, min_days: 2, max_days: 3 },
{ pincode: 629191, min_days: 2, max_days: 3 },
{ pincode: 629192, min_days: 2, max_days: 3 },
{ pincode: 629193, min_days: 2, max_days: 3 },
{ pincode: 629194, min_days: 2, max_days: 3 },
{ pincode: 629195, min_days: 2, max_days: 3 },
{ pincode: 629196, min_days: 2, max_days: 3 },
{ pincode: 629197, min_days: 2, max_days: 3 },
{ pincode: 629201, min_days: 2, max_days: 3 },
{ pincode: 629202, min_days: 2, max_days: 3 },
{ pincode: 629203, min_days: 2, max_days: 3 },
{ pincode: 629204, min_days: 2, max_days: 3 },
{ pincode: 629205, min_days: 2, max_days: 3 },
{ pincode: 629251, min_days: 2, max_days: 3 },
{ pincode: 629252, min_days: 2, max_days: 3 },
{ pincode: 629253, min_days: 2, max_days: 3 },
{ pincode: 629301, min_days: 2, max_days: 3 },
{ pincode: 629302, min_days: 2, max_days: 3 },
{ pincode: 629303, min_days: 2, max_days: 3 },
{ pincode: 629304, min_days: 2, max_days: 3 },
{ pincode: 629305, min_days: 2, max_days: 3 },
{ pincode: 629401, min_days: 2, max_days: 3 },
{ pincode: 629402, min_days: 2, max_days: 3 },
{ pincode: 629403, min_days: 2, max_days: 3 },
{ pincode: 629404, min_days: 2, max_days: 3 },
{ pincode: 629406, min_days: 2, max_days: 3 },
{ pincode: 629501, min_days: 2, max_days: 3 },
{ pincode: 629502, min_days: 2, max_days: 3 },
{ pincode: 629503, min_days: 2, max_days: 3 },
{ pincode: 629504, min_days: 2, max_days: 3 },
{ pincode: 629509, min_days: 2, max_days: 3 },
{ pincode: 629601, min_days: 2, max_days: 3 },
{ pincode: 629602, min_days: 2, max_days: 3 },
{ pincode: 629603, min_days: 2, max_days: 3 },
{ pincode: 629701, min_days: 2, max_days: 3 },
{ pincode: 629702, min_days: 2, max_days: 3 },
{ pincode: 629703, min_days: 2, max_days: 3 },
{ pincode: 629704, min_days: 2, max_days: 3 },
{ pincode: 629706, min_days: 2, max_days: 3 },
{ pincode: 629707, min_days: 2, max_days: 3 },
{ pincode: 629708, min_days: 2, max_days: 3 },
{ pincode: 629801, min_days: 2, max_days: 3 },
{ pincode: 629802, min_days: 2, max_days: 3 },
{ pincode: 629803, min_days: 2, max_days: 3 },
{ pincode: 629804, min_days: 2, max_days: 3 },
{ pincode: 629805, min_days: 2, max_days: 3 },
{ pincode: 629806, min_days: 2, max_days: 3 },
{ pincode: 629807, min_days: 2, max_days: 3 },
{ pincode: 629808, min_days: 2, max_days: 3 },
{ pincode: 629809, min_days: 2, max_days: 3 },
{ pincode: 629810, min_days: 2, max_days: 3 },
{ pincode: 629851, min_days: 2, max_days: 3 },
{ pincode: 629852, min_days: 2, max_days: 3 },
{ pincode: 629854, min_days: 2, max_days: 3 },
{ pincode: 629855, min_days: 2, max_days: 3 },
{ pincode: 629901, min_days: 2, max_days: 3 },
{ pincode: 629902, min_days: 2, max_days: 3 },
{ pincode: 630001, min_days: 2, max_days: 3 },
{ pincode: 630002, min_days: 2, max_days: 3 },
{ pincode: 630003, min_days: 2, max_days: 3 },
{ pincode: 630004, min_days: 2, max_days: 3 },
{ pincode: 630005, min_days: 2, max_days: 3 },
{ pincode: 630006, min_days: 2, max_days: 3 },
{ pincode: 630009, min_days: 2, max_days: 3 },
{ pincode: 630101, min_days: 2, max_days: 3 },
{ pincode: 630102, min_days: 2, max_days: 3 },
{ pincode: 630103, min_days: 2, max_days: 3 },
{ pincode: 630104, min_days: 2, max_days: 3 },
{ pincode: 630105, min_days: 2, max_days: 3 },
{ pincode: 630106, min_days: 2, max_days: 3 },
{ pincode: 630107, min_days: 2, max_days: 3 },
{ pincode: 630108, min_days: 2, max_days: 3 },
{ pincode: 630201, min_days: 2, max_days: 3 },
{ pincode: 630202, min_days: 2, max_days: 3 },
{ pincode: 630203, min_days: 2, max_days: 3 },
{ pincode: 630204, min_days: 2, max_days: 3 },
{ pincode: 630205, min_days: 2, max_days: 3 },
{ pincode: 630206, min_days: 2, max_days: 3 },
{ pincode: 630207, min_days: 2, max_days: 3 },
{ pincode: 630208, min_days: 2, max_days: 3 },
{ pincode: 630209, min_days: 2, max_days: 3 },
{ pincode: 630210, min_days: 2, max_days: 3 },
{ pincode: 630211, min_days: 2, max_days: 3 },
{ pincode: 630212, min_days: 2, max_days: 3 },
{ pincode: 630214, min_days: 2, max_days: 3 },
{ pincode: 630215, min_days: 2, max_days: 3 },
{ pincode: 630301, min_days: 2, max_days: 3 },
{ pincode: 630302, min_days: 2, max_days: 3 },
{ pincode: 630303, min_days: 2, max_days: 3 },
{ pincode: 630305, min_days: 2, max_days: 3 },
{ pincode: 630306, min_days: 2, max_days: 3 },
{ pincode: 630307, min_days: 2, max_days: 3 },
{ pincode: 630309, min_days: 2, max_days: 3 },
{ pincode: 630310, min_days: 2, max_days: 3 },
{ pincode: 630311, min_days: 2, max_days: 3 },
{ pincode: 630312, min_days: 2, max_days: 3 },
{ pincode: 630313, min_days: 2, max_days: 3 },
{ pincode: 630314, min_days: 2, max_days: 3 },
{ pincode: 630317, min_days: 2, max_days: 3 },
{ pincode: 630318, min_days: 2, max_days: 3 },
{ pincode: 630321, min_days: 2, max_days: 3 },
{ pincode: 630405, min_days: 2, max_days: 3 },
{ pincode: 630408, min_days: 2, max_days: 3 },
{ pincode: 630410, min_days: 2, max_days: 3 },
{ pincode: 630411, min_days: 2, max_days: 3 },
{ pincode: 630501, min_days: 2, max_days: 3 },
{ pincode: 630502, min_days: 2, max_days: 3 },
{ pincode: 630551, min_days: 2, max_days: 3 },
{ pincode: 630552, min_days: 2, max_days: 3 },
{ pincode: 630553, min_days: 2, max_days: 3 },
{ pincode: 630554, min_days: 2, max_days: 3 },
{ pincode: 630555, min_days: 2, max_days: 3 },
{ pincode: 630556, min_days: 2, max_days: 3 },
{ pincode: 630557, min_days: 2, max_days: 3 },
{ pincode: 630558, min_days: 2, max_days: 3 },
{ pincode: 630559, min_days: 2, max_days: 3 },
{ pincode: 630560, min_days: 2, max_days: 3 },
{ pincode: 630561, min_days: 2, max_days: 3 },
{ pincode: 630562, min_days: 2, max_days: 3 },
{ pincode: 630565, min_days: 2, max_days: 3 },
{ pincode: 630566, min_days: 2, max_days: 3 },
{ pincode: 630602, min_days: 2, max_days: 3 },
{ pincode: 630606, min_days: 2, max_days: 3 },
{ pincode: 630607, min_days: 2, max_days: 3 },
{ pincode: 630609, min_days: 2, max_days: 3 },
{ pincode: 630610, min_days: 2, max_days: 3 },
{ pincode: 630611, min_days: 2, max_days: 3 },
{ pincode: 630612, min_days: 2, max_days: 3 },
{ pincode: 630702, min_days: 2, max_days: 3 },
{ pincode: 630709, min_days: 2, max_days: 3 },
{ pincode: 630710, min_days: 2, max_days: 3 },
{ pincode: 630713, min_days: 2, max_days: 3 },
{ pincode: 631001, min_days: 2, max_days: 3 },
{ pincode: 631002, min_days: 2, max_days: 3 },
{ pincode: 631003, min_days: 2, max_days: 3 },
{ pincode: 631004, min_days: 2, max_days: 3 },
{ pincode: 631005, min_days: 2, max_days: 3 },
{ pincode: 631006, min_days: 2, max_days: 3 },
{ pincode: 631027, min_days: 2, max_days: 3 },
{ pincode: 631051, min_days: 2, max_days: 3 },
{ pincode: 631052, min_days: 2, max_days: 3 },
{ pincode: 631053, min_days: 2, max_days: 3 },
{ pincode: 631057, min_days: 2, max_days: 3 },
{ pincode: 631060, min_days: 2, max_days: 3 },
{ pincode: 631061, min_days: 2, max_days: 3 },
{ pincode: 631101, min_days: 2, max_days: 3 },
{ pincode: 631102, min_days: 2, max_days: 3 },
{ pincode: 631104, min_days: 2, max_days: 3 },
{ pincode: 631105, min_days: 2, max_days: 3 },
{ pincode: 631118, min_days: 2, max_days: 3 },
{ pincode: 631151, min_days: 2, max_days: 3 },
{ pincode: 631152, min_days: 2, max_days: 3 },
{ pincode: 631201, min_days: 2, max_days: 3 },
{ pincode: 631202, min_days: 2, max_days: 3 },
{ pincode: 631203, min_days: 2, max_days: 3 },
{ pincode: 631204, min_days: 2, max_days: 3 },
{ pincode: 631205, min_days: 2, max_days: 3 },
{ pincode: 631206, min_days: 2, max_days: 3 },
{ pincode: 631207, min_days: 2, max_days: 3 },
{ pincode: 631208, min_days: 2, max_days: 3 },
{ pincode: 631209, min_days: 2, max_days: 3 },
{ pincode: 631210, min_days: 2, max_days: 3 },
{ pincode: 631211, min_days: 2, max_days: 3 },
{ pincode: 631212, min_days: 2, max_days: 3 },
{ pincode: 631213, min_days: 2, max_days: 3 },
{ pincode: 631301, min_days: 2, max_days: 3 },
{ pincode: 631302, min_days: 2, max_days: 3 },
{ pincode: 631303, min_days: 2, max_days: 3 },
{ pincode: 631304, min_days: 2, max_days: 3 },
{ pincode: 631401, min_days: 2, max_days: 3 },
{ pincode: 631402, min_days: 2, max_days: 3 },
{ pincode: 631404, min_days: 2, max_days: 3 },
{ pincode: 631501, min_days: 2, max_days: 3 },
{ pincode: 631502, min_days: 2, max_days: 3 },
{ pincode: 631503, min_days: 2, max_days: 3 },
{ pincode: 631505, min_days: 2, max_days: 3 },
{ pincode: 631551, min_days: 2, max_days: 3 },
{ pincode: 631552, min_days: 2, max_days: 3 },
{ pincode: 631553, min_days: 2, max_days: 3 },
{ pincode: 631561, min_days: 2, max_days: 3 },
{ pincode: 631601, min_days: 2, max_days: 3 },
{ pincode: 631602, min_days: 2, max_days: 3 },
{ pincode: 631603, min_days: 2, max_days: 3 },
{ pincode: 631604, min_days: 2, max_days: 3 },
{ pincode: 631605, min_days: 2, max_days: 3 },
{ pincode: 631606, min_days: 2, max_days: 3 },
{ pincode: 631609, min_days: 2, max_days: 3 },
{ pincode: 631701, min_days: 2, max_days: 3 },
{ pincode: 631702, min_days: 2, max_days: 3 },
{ pincode: 631703, min_days: 2, max_days: 3 },
{ pincode: 632001, min_days: 2, max_days: 3 },
{ pincode: 632002, min_days: 2, max_days: 3 },
{ pincode: 632003, min_days: 2, max_days: 3 },
{ pincode: 632004, min_days: 2, max_days: 3 },
{ pincode: 632005, min_days: 2, max_days: 3 },
{ pincode: 632006, min_days: 2, max_days: 3 },
{ pincode: 632007, min_days: 2, max_days: 3 },
{ pincode: 632008, min_days: 2, max_days: 3 },
{ pincode: 632009, min_days: 2, max_days: 3 },
{ pincode: 632010, min_days: 2, max_days: 3 },
{ pincode: 632011, min_days: 2, max_days: 3 },
{ pincode: 632012, min_days: 2, max_days: 3 },
{ pincode: 632013, min_days: 2, max_days: 3 },
{ pincode: 632014, min_days: 2, max_days: 3 },
{ pincode: 632051, min_days: 2, max_days: 3 },
{ pincode: 632052, min_days: 2, max_days: 3 },
{ pincode: 632053, min_days: 2, max_days: 3 },
{ pincode: 632054, min_days: 2, max_days: 3 },
{ pincode: 632055, min_days: 2, max_days: 3 },
{ pincode: 632057, min_days: 2, max_days: 3 },
{ pincode: 632058, min_days: 2, max_days: 3 },
{ pincode: 632059, min_days: 2, max_days: 3 },
{ pincode: 632101, min_days: 2, max_days: 3 },
{ pincode: 632102, min_days: 2, max_days: 3 },
{ pincode: 632103, min_days: 2, max_days: 3 },
{ pincode: 632104, min_days: 2, max_days: 3 },
{ pincode: 632105, min_days: 2, max_days: 3 },
{ pincode: 632106, min_days: 2, max_days: 3 },
{ pincode: 632107, min_days: 2, max_days: 3 },
{ pincode: 632108, min_days: 2, max_days: 3 },
{ pincode: 632109, min_days: 2, max_days: 3 },
{ pincode: 632110, min_days: 2, max_days: 3 },
{ pincode: 632113, min_days: 2, max_days: 3 },
{ pincode: 632114, min_days: 2, max_days: 3 },
{ pincode: 632115, min_days: 2, max_days: 3 },
{ pincode: 632201, min_days: 2, max_days: 3 },
{ pincode: 632202, min_days: 2, max_days: 3 },
{ pincode: 632203, min_days: 2, max_days: 3 },
{ pincode: 632204, min_days: 2, max_days: 3 },
{ pincode: 632205, min_days: 2, max_days: 3 },
{ pincode: 632206, min_days: 2, max_days: 3 },
{ pincode: 632207, min_days: 2, max_days: 3 },
{ pincode: 632208, min_days: 2, max_days: 3 },
{ pincode: 632209, min_days: 2, max_days: 3 },
{ pincode: 632211, min_days: 2, max_days: 3 },
{ pincode: 632218, min_days: 2, max_days: 3 },
{ pincode: 632234, min_days: 2, max_days: 3 },
{ pincode: 632301, min_days: 2, max_days: 3 },
{ pincode: 632311, min_days: 2, max_days: 3 },
{ pincode: 632312, min_days: 2, max_days: 3 },
{ pincode: 632313, min_days: 2, max_days: 3 },
{ pincode: 632314, min_days: 2, max_days: 3 },
{ pincode: 632315, min_days: 2, max_days: 3 },
{ pincode: 632316, min_days: 2, max_days: 3 },
{ pincode: 632317, min_days: 2, max_days: 3 },
{ pincode: 632318, min_days: 2, max_days: 3 },
{ pincode: 632319, min_days: 2, max_days: 3 },
{ pincode: 632320, min_days: 2, max_days: 3 },
{ pincode: 632321, min_days: 2, max_days: 3 },
{ pincode: 632322, min_days: 2, max_days: 3 },
{ pincode: 632323, min_days: 2, max_days: 3 },
{ pincode: 632324, min_days: 2, max_days: 3 },
{ pincode: 632325, min_days: 2, max_days: 3 },
{ pincode: 632326, min_days: 2, max_days: 3 },
{ pincode: 632401, min_days: 2, max_days: 3 },
{ pincode: 632402, min_days: 2, max_days: 3 },
{ pincode: 632403, min_days: 2, max_days: 3 },
{ pincode: 632404, min_days: 2, max_days: 3 },
{ pincode: 632405, min_days: 2, max_days: 3 },
{ pincode: 632406, min_days: 2, max_days: 3 },
{ pincode: 632501, min_days: 2, max_days: 3 },
{ pincode: 632502, min_days: 2, max_days: 3 },
{ pincode: 632503, min_days: 2, max_days: 3 },
{ pincode: 632504, min_days: 2, max_days: 3 },
{ pincode: 632505, min_days: 2, max_days: 3 },
{ pincode: 632506, min_days: 2, max_days: 3 },
{ pincode: 632507, min_days: 2, max_days: 3 },
{ pincode: 632508, min_days: 2, max_days: 3 },
{ pincode: 632509, min_days: 2, max_days: 3 },
{ pincode: 632510, min_days: 2, max_days: 3 },
{ pincode: 632511, min_days: 2, max_days: 3 },
{ pincode: 632512, min_days: 2, max_days: 3 },
{ pincode: 632513, min_days: 2, max_days: 3 },
{ pincode: 632514, min_days: 2, max_days: 3 },
{ pincode: 632515, min_days: 2, max_days: 3 },
{ pincode: 632516, min_days: 2, max_days: 3 },
{ pincode: 632517, min_days: 2, max_days: 3 },
{ pincode: 632518, min_days: 2, max_days: 3 },
{ pincode: 632519, min_days: 2, max_days: 3 },
{ pincode: 632520, min_days: 2, max_days: 3 },
{ pincode: 632521, min_days: 2, max_days: 3 },
{ pincode: 632522, min_days: 2, max_days: 3 },
{ pincode: 632523, min_days: 2, max_days: 3 },
{ pincode: 632524, min_days: 2, max_days: 3 },
{ pincode: 632525, min_days: 2, max_days: 3 },
{ pincode: 632526, min_days: 2, max_days: 3 },
{ pincode: 632527, min_days: 2, max_days: 3 },
{ pincode: 632529, min_days: 2, max_days: 3 },
{ pincode: 632531, min_days: 2, max_days: 3 },
{ pincode: 632601, min_days: 2, max_days: 3 },
{ pincode: 632602, min_days: 2, max_days: 3 },
{ pincode: 632603, min_days: 2, max_days: 3 },
{ pincode: 632604, min_days: 2, max_days: 3 },
{ pincode: 632605, min_days: 2, max_days: 3 },
{ pincode: 632606, min_days: 2, max_days: 3 },
{ pincode: 632607, min_days: 2, max_days: 3 },
{ pincode: 632608, min_days: 2, max_days: 3 },
{ pincode: 632631, min_days: 2, max_days: 3 },
{ pincode: 635001, min_days: 2, max_days: 3 },
{ pincode: 635002, min_days: 2, max_days: 3 },
{ pincode: 635101, min_days: 2, max_days: 3 },
{ pincode: 635102, min_days: 2, max_days: 3 },
{ pincode: 635103, min_days: 2, max_days: 3 },
{ pincode: 635104, min_days: 2, max_days: 3 },
{ pincode: 635105, min_days: 2, max_days: 3 },
{ pincode: 635106, min_days: 2, max_days: 3 },
{ pincode: 635107, min_days: 2, max_days: 3 },
{ pincode: 635108, min_days: 2, max_days: 3 },
{ pincode: 635109, min_days: 2, max_days: 3 },
{ pincode: 635110, min_days: 2, max_days: 3 },
{ pincode: 635111, min_days: 2, max_days: 3 },
{ pincode: 635112, min_days: 2, max_days: 3 },
{ pincode: 635113, min_days: 2, max_days: 3 },
{ pincode: 635114, min_days: 2, max_days: 3 },
{ pincode: 635115, min_days: 2, max_days: 3 },
{ pincode: 635116, min_days: 2, max_days: 3 },
{ pincode: 635117, min_days: 2, max_days: 3 },
{ pincode: 635118, min_days: 2, max_days: 3 },
{ pincode: 635119, min_days: 2, max_days: 3 },
{ pincode: 635120, min_days: 2, max_days: 3 },
{ pincode: 635121, min_days: 2, max_days: 3 },
{ pincode: 635122, min_days: 2, max_days: 3 },
{ pincode: 635123, min_days: 2, max_days: 3 },
{ pincode: 635124, min_days: 2, max_days: 3 },
{ pincode: 635125, min_days: 2, max_days: 3 },
{ pincode: 635126, min_days: 2, max_days: 3 },
{ pincode: 635127, min_days: 2, max_days: 3 },
{ pincode: 635128, min_days: 2, max_days: 3 },
{ pincode: 635130, min_days: 2, max_days: 3 },
{ pincode: 635131, min_days: 2, max_days: 3 },
{ pincode: 635133, min_days: 2, max_days: 3 },
{ pincode: 635134, min_days: 2, max_days: 3 },
{ pincode: 635137, min_days: 2, max_days: 3 },
{ pincode: 635138, min_days: 2, max_days: 3 },
{ pincode: 635139, min_days: 2, max_days: 3 },
{ pincode: 635140, min_days: 2, max_days: 3 },
{ pincode: 635141, min_days: 2, max_days: 3 },
{ pincode: 635201, min_days: 2, max_days: 3 },
{ pincode: 635202, min_days: 2, max_days: 3 },
{ pincode: 635203, min_days: 2, max_days: 3 },
{ pincode: 635204, min_days: 2, max_days: 3 },
{ pincode: 635205, min_days: 2, max_days: 3 },
{ pincode: 635206, min_days: 2, max_days: 3 },
{ pincode: 635207, min_days: 2, max_days: 3 },
{ pincode: 635208, min_days: 2, max_days: 3 },
{ pincode: 635209, min_days: 2, max_days: 3 },
{ pincode: 635211, min_days: 2, max_days: 3 },
{ pincode: 635301, min_days: 2, max_days: 3 },
{ pincode: 635302, min_days: 2, max_days: 3 },
{ pincode: 635303, min_days: 2, max_days: 3 },
{ pincode: 635304, min_days: 2, max_days: 3 },
{ pincode: 635305, min_days: 2, max_days: 3 },
{ pincode: 635306, min_days: 2, max_days: 3 },
{ pincode: 635307, min_days: 2, max_days: 3 },
{ pincode: 635309, min_days: 2, max_days: 3 },
{ pincode: 635601, min_days: 2, max_days: 3 },
{ pincode: 635602, min_days: 2, max_days: 3 },
{ pincode: 635611, min_days: 2, max_days: 3 },
{ pincode: 635635, min_days: 2, max_days: 3 },
{ pincode: 635651, min_days: 2, max_days: 3 },
{ pincode: 635652, min_days: 2, max_days: 3 },
{ pincode: 635653, min_days: 2, max_days: 3 },
{ pincode: 635654, min_days: 2, max_days: 3 },
{ pincode: 635655, min_days: 2, max_days: 3 },
{ pincode: 635656, min_days: 2, max_days: 3 },
{ pincode: 635659, min_days: 2, max_days: 3 },
{ pincode: 635660, min_days: 2, max_days: 3 },
{ pincode: 635661, min_days: 2, max_days: 3 },
{ pincode: 635662, min_days: 2, max_days: 3 },
{ pincode: 635701, min_days: 2, max_days: 3 },
{ pincode: 635702, min_days: 2, max_days: 3 },
{ pincode: 635703, min_days: 2, max_days: 3 },
{ pincode: 635705, min_days: 2, max_days: 3 },
{ pincode: 635706, min_days: 2, max_days: 3 },
{ pincode: 635709, min_days: 2, max_days: 3 },
{ pincode: 635710, min_days: 2, max_days: 3 },
{ pincode: 635751, min_days: 2, max_days: 3 },
{ pincode: 635752, min_days: 2, max_days: 3 },
{ pincode: 635753, min_days: 2, max_days: 3 },
{ pincode: 635754, min_days: 2, max_days: 3 },
{ pincode: 635801, min_days: 2, max_days: 3 },
{ pincode: 635802, min_days: 2, max_days: 3 },
{ pincode: 635803, min_days: 2, max_days: 3 },
{ pincode: 635804, min_days: 2, max_days: 3 },
{ pincode: 635805, min_days: 2, max_days: 3 },
{ pincode: 635806, min_days: 2, max_days: 3 },
{ pincode: 635807, min_days: 2, max_days: 3 },
{ pincode: 635808, min_days: 2, max_days: 3 },
{ pincode: 635809, min_days: 2, max_days: 3 },
{ pincode: 635810, min_days: 2, max_days: 3 },
{ pincode: 635811, min_days: 2, max_days: 3 },
{ pincode: 635812, min_days: 2, max_days: 3 },
{ pincode: 635813, min_days: 2, max_days: 3 },
{ pincode: 635814, min_days: 2, max_days: 3 },
{ pincode: 635815, min_days: 2, max_days: 3 },
{ pincode: 635817, min_days: 2, max_days: 3 },
{ pincode: 635818, min_days: 2, max_days: 3 },
{ pincode: 635819, min_days: 2, max_days: 3 },
{ pincode: 635820, min_days: 2, max_days: 3 },
{ pincode: 635825, min_days: 2, max_days: 3 },
{ pincode: 635826, min_days: 2, max_days: 3 },
{ pincode: 635851, min_days: 2, max_days: 3 },
{ pincode: 635852, min_days: 2, max_days: 3 },
{ pincode: 635853, min_days: 2, max_days: 3 },
{ pincode: 635854, min_days: 2, max_days: 3 },
{ pincode: 635855, min_days: 2, max_days: 3 },
{ pincode: 635856, min_days: 2, max_days: 3 },
{ pincode: 635857, min_days: 2, max_days: 3 },
{ pincode: 635901, min_days: 2, max_days: 3 },
{ pincode: 636001, min_days: 2, max_days: 3 },
{ pincode: 636002, min_days: 2, max_days: 3 },
{ pincode: 636003, min_days: 2, max_days: 3 },
{ pincode: 636004, min_days: 2, max_days: 3 },
{ pincode: 636005, min_days: 2, max_days: 3 },
{ pincode: 636006, min_days: 2, max_days: 3 },
{ pincode: 636007, min_days: 2, max_days: 3 },
{ pincode: 636008, min_days: 2, max_days: 3 },
{ pincode: 636009, min_days: 2, max_days: 3 },
{ pincode: 636010, min_days: 2, max_days: 3 },
{ pincode: 636011, min_days: 2, max_days: 3 },
{ pincode: 636012, min_days: 2, max_days: 3 },
{ pincode: 636013, min_days: 2, max_days: 3 },
{ pincode: 636014, min_days: 2, max_days: 3 },
{ pincode: 636015, min_days: 2, max_days: 3 },
{ pincode: 636016, min_days: 2, max_days: 3 },
{ pincode: 636017, min_days: 2, max_days: 3 },
{ pincode: 636030, min_days: 2, max_days: 3 },
{ pincode: 636063, min_days: 2, max_days: 3 },
{ pincode: 636101, min_days: 2, max_days: 3 },
{ pincode: 636102, min_days: 2, max_days: 3 },
{ pincode: 636103, min_days: 2, max_days: 3 },
{ pincode: 636104, min_days: 2, max_days: 3 },
{ pincode: 636105, min_days: 2, max_days: 3 },
{ pincode: 636106, min_days: 2, max_days: 3 },
{ pincode: 636107, min_days: 2, max_days: 3 },
{ pincode: 636108, min_days: 2, max_days: 3 },
{ pincode: 636109, min_days: 2, max_days: 3 },
{ pincode: 636110, min_days: 2, max_days: 3 },
{ pincode: 636111, min_days: 2, max_days: 3 },
{ pincode: 636112, min_days: 2, max_days: 3 },
{ pincode: 636113, min_days: 2, max_days: 3 },
{ pincode: 636114, min_days: 2, max_days: 3 },
{ pincode: 636115, min_days: 2, max_days: 3 },
{ pincode: 636116, min_days: 2, max_days: 3 },
{ pincode: 636117, min_days: 2, max_days: 3 },
{ pincode: 636118, min_days: 2, max_days: 3 },
{ pincode: 636119, min_days: 2, max_days: 3 },
{ pincode: 636121, min_days: 2, max_days: 3 },
{ pincode: 636122, min_days: 2, max_days: 3 },
{ pincode: 636138, min_days: 2, max_days: 3 },
{ pincode: 636139, min_days: 2, max_days: 3 },
{ pincode: 636140, min_days: 2, max_days: 3 },
{ pincode: 636141, min_days: 2, max_days: 3 },
{ pincode: 636142, min_days: 2, max_days: 3 },
{ pincode: 636201, min_days: 2, max_days: 3 },
{ pincode: 636202, min_days: 2, max_days: 3 },
{ pincode: 636203, min_days: 2, max_days: 3 },
{ pincode: 636204, min_days: 2, max_days: 3 },
{ pincode: 636301, min_days: 2, max_days: 3 },
{ pincode: 636302, min_days: 2, max_days: 3 },
{ pincode: 636303, min_days: 2, max_days: 3 },
{ pincode: 636304, min_days: 2, max_days: 3 },
{ pincode: 636305, min_days: 2, max_days: 3 },
{ pincode: 636306, min_days: 2, max_days: 3 },
{ pincode: 636307, min_days: 2, max_days: 3 },
{ pincode: 636308, min_days: 2, max_days: 3 },
{ pincode: 636309, min_days: 2, max_days: 3 },
{ pincode: 636318, min_days: 2, max_days: 3 },
{ pincode: 636351, min_days: 2, max_days: 3 },
{ pincode: 636352, min_days: 2, max_days: 3 },
{ pincode: 636354, min_days: 2, max_days: 3 },
{ pincode: 636401, min_days: 2, max_days: 3 },
{ pincode: 636402, min_days: 2, max_days: 3 },
{ pincode: 636403, min_days: 2, max_days: 3 },
{ pincode: 636404, min_days: 2, max_days: 3 },
{ pincode: 636406, min_days: 2, max_days: 3 },
{ pincode: 636407, min_days: 2, max_days: 3 },
{ pincode: 636451, min_days: 2, max_days: 3 },
{ pincode: 636452, min_days: 2, max_days: 3 },
{ pincode: 636453, min_days: 2, max_days: 3 },
{ pincode: 636454, min_days: 2, max_days: 3 },
{ pincode: 636455, min_days: 2, max_days: 3 },
{ pincode: 636456, min_days: 2, max_days: 3 },
{ pincode: 636457, min_days: 2, max_days: 3 },
{ pincode: 636458, min_days: 2, max_days: 3 },
{ pincode: 636462, min_days: 2, max_days: 3 },
{ pincode: 636463, min_days: 2, max_days: 3 },
{ pincode: 636501, min_days: 2, max_days: 3 },
{ pincode: 636502, min_days: 2, max_days: 3 },
{ pincode: 636503, min_days: 2, max_days: 3 },
{ pincode: 636601, min_days: 2, max_days: 3 },
{ pincode: 636602, min_days: 2, max_days: 3 },
{ pincode: 636604, min_days: 2, max_days: 3 },
{ pincode: 636701, min_days: 2, max_days: 3 },
{ pincode: 636702, min_days: 2, max_days: 3 },
{ pincode: 636703, min_days: 2, max_days: 3 },
{ pincode: 636704, min_days: 2, max_days: 3 },
{ pincode: 636705, min_days: 2, max_days: 3 },
{ pincode: 636706, min_days: 2, max_days: 3 },
{ pincode: 636751, min_days: 2, max_days: 3 },
{ pincode: 636803, min_days: 2, max_days: 3 },
{ pincode: 636804, min_days: 2, max_days: 3 },
{ pincode: 636805, min_days: 2, max_days: 3 },
{ pincode: 636806, min_days: 2, max_days: 3 },
{ pincode: 636807, min_days: 2, max_days: 3 },
{ pincode: 636808, min_days: 2, max_days: 3 },
{ pincode: 636809, min_days: 2, max_days: 3 },
{ pincode: 636810, min_days: 2, max_days: 3 },
{ pincode: 636811, min_days: 2, max_days: 3 },
{ pincode: 636812, min_days: 2, max_days: 3 },
{ pincode: 636813, min_days: 2, max_days: 3 },
{ pincode: 636815, min_days: 2, max_days: 3 },
{ pincode: 636816, min_days: 2, max_days: 3 },
{ pincode: 636902, min_days: 2, max_days: 3 },
{ pincode: 636903, min_days: 2, max_days: 3 },
{ pincode: 636904, min_days: 2, max_days: 3 },
{ pincode: 636905, min_days: 2, max_days: 3 },
{ pincode: 636906, min_days: 2, max_days: 3 },
{ pincode: 636907, min_days: 2, max_days: 3 },
{ pincode: 636908, min_days: 2, max_days: 3 },
{ pincode: 636915, min_days: 2, max_days: 3 },
{ pincode: 637001, min_days: 2, max_days: 3 },
{ pincode: 637002, min_days: 2, max_days: 3 },
{ pincode: 637003, min_days: 2, max_days: 3 },
{ pincode: 637004, min_days: 2, max_days: 3 },
{ pincode: 637005, min_days: 2, max_days: 3 },
{ pincode: 637013, min_days: 2, max_days: 3 },
{ pincode: 637014, min_days: 2, max_days: 3 },
{ pincode: 637015, min_days: 2, max_days: 3 },
{ pincode: 637017, min_days: 2, max_days: 3 },
{ pincode: 637018, min_days: 2, max_days: 3 },
{ pincode: 637019, min_days: 2, max_days: 3 },
{ pincode: 637020, min_days: 2, max_days: 3 },
{ pincode: 637021, min_days: 2, max_days: 3 },
{ pincode: 637024, min_days: 2, max_days: 3 },
{ pincode: 637026, min_days: 2, max_days: 3 },
{ pincode: 637101, min_days: 2, max_days: 3 },
{ pincode: 637102, min_days: 2, max_days: 3 },
{ pincode: 637103, min_days: 2, max_days: 3 },
{ pincode: 637104, min_days: 2, max_days: 3 },
{ pincode: 637105, min_days: 2, max_days: 3 },
{ pincode: 637107, min_days: 2, max_days: 3 },
{ pincode: 637109, min_days: 2, max_days: 3 },
{ pincode: 637201, min_days: 2, max_days: 3 },
{ pincode: 637202, min_days: 2, max_days: 3 },
{ pincode: 637203, min_days: 2, max_days: 3 },
{ pincode: 637204, min_days: 2, max_days: 3 },
{ pincode: 637205, min_days: 2, max_days: 3 },
{ pincode: 637206, min_days: 2, max_days: 3 },
{ pincode: 637207, min_days: 2, max_days: 3 },
{ pincode: 637208, min_days: 2, max_days: 3 },
{ pincode: 637209, min_days: 2, max_days: 3 },
{ pincode: 637210, min_days: 2, max_days: 3 },
{ pincode: 637211, min_days: 2, max_days: 3 },
{ pincode: 637212, min_days: 2, max_days: 3 },
{ pincode: 637213, min_days: 2, max_days: 3 },
{ pincode: 637214, min_days: 2, max_days: 3 },
{ pincode: 637215, min_days: 2, max_days: 3 },
{ pincode: 637216, min_days: 2, max_days: 3 },
{ pincode: 637217, min_days: 2, max_days: 3 },
{ pincode: 637301, min_days: 2, max_days: 3 },
{ pincode: 637302, min_days: 2, max_days: 3 },
{ pincode: 637303, min_days: 2, max_days: 3 },
{ pincode: 637304, min_days: 2, max_days: 3 },
{ pincode: 637306, min_days: 2, max_days: 3 },
{ pincode: 637401, min_days: 2, max_days: 3 },
{ pincode: 637402, min_days: 2, max_days: 3 },
{ pincode: 637403, min_days: 2, max_days: 3 },
{ pincode: 637404, min_days: 2, max_days: 3 },
{ pincode: 637405, min_days: 2, max_days: 3 },
{ pincode: 637406, min_days: 2, max_days: 3 },
{ pincode: 637407, min_days: 2, max_days: 3 },
{ pincode: 637408, min_days: 2, max_days: 3 },
{ pincode: 637409, min_days: 2, max_days: 3 },
{ pincode: 637410, min_days: 2, max_days: 3 },
{ pincode: 637411, min_days: 2, max_days: 3 },
{ pincode: 637412, min_days: 2, max_days: 3 },
{ pincode: 637415, min_days: 2, max_days: 3 },
{ pincode: 637418, min_days: 2, max_days: 3 },
{ pincode: 637420, min_days: 2, max_days: 3 },
{ pincode: 637501, min_days: 2, max_days: 3 },
{ pincode: 637502, min_days: 2, max_days: 3 },
{ pincode: 637503, min_days: 2, max_days: 3 },
{ pincode: 637504, min_days: 2, max_days: 3 },
{ pincode: 637505, min_days: 2, max_days: 3 },
{ pincode: 637508, min_days: 2, max_days: 3 },
{ pincode: 638001, min_days: 2, max_days: 3 },
{ pincode: 638002, min_days: 2, max_days: 3 },
{ pincode: 638003, min_days: 2, max_days: 3 },
{ pincode: 638004, min_days: 2, max_days: 3 },
{ pincode: 638005, min_days: 2, max_days: 3 },
{ pincode: 638006, min_days: 2, max_days: 3 },
{ pincode: 638007, min_days: 2, max_days: 3 },
{ pincode: 638008, min_days: 2, max_days: 3 },
{ pincode: 638009, min_days: 2, max_days: 3 },
{ pincode: 638010, min_days: 2, max_days: 3 },
{ pincode: 638011, min_days: 2, max_days: 3 },
{ pincode: 638012, min_days: 2, max_days: 3 },
{ pincode: 638051, min_days: 2, max_days: 3 },
{ pincode: 638052, min_days: 2, max_days: 3 },
{ pincode: 638053, min_days: 2, max_days: 3 },
{ pincode: 638054, min_days: 2, max_days: 3 },
{ pincode: 638055, min_days: 2, max_days: 3 },
{ pincode: 638056, min_days: 2, max_days: 3 },
{ pincode: 638057, min_days: 2, max_days: 3 },
{ pincode: 638058, min_days: 2, max_days: 3 },
{ pincode: 638060, min_days: 2, max_days: 3 },
{ pincode: 638101, min_days: 2, max_days: 3 },
{ pincode: 638102, min_days: 2, max_days: 3 },
{ pincode: 638103, min_days: 2, max_days: 3 },
{ pincode: 638104, min_days: 2, max_days: 3 },
{ pincode: 638105, min_days: 2, max_days: 3 },
{ pincode: 638106, min_days: 2, max_days: 3 },
{ pincode: 638107, min_days: 2, max_days: 3 },
{ pincode: 638108, min_days: 2, max_days: 3 },
{ pincode: 638109, min_days: 2, max_days: 3 },
{ pincode: 638110, min_days: 2, max_days: 3 },
{ pincode: 638111, min_days: 2, max_days: 3 },
{ pincode: 638112, min_days: 2, max_days: 3 },
{ pincode: 638113, min_days: 2, max_days: 3 },
{ pincode: 638115, min_days: 2, max_days: 3 },
{ pincode: 638116, min_days: 2, max_days: 3 },
{ pincode: 638117, min_days: 2, max_days: 3 },
{ pincode: 638118, min_days: 2, max_days: 3 },
{ pincode: 638129, min_days: 2, max_days: 3 },
{ pincode: 638130, min_days: 2, max_days: 3 },
{ pincode: 638151, min_days: 2, max_days: 3 },
{ pincode: 638152, min_days: 2, max_days: 3 },
{ pincode: 638153, min_days: 2, max_days: 3 },
{ pincode: 638154, min_days: 2, max_days: 3 },
{ pincode: 638181, min_days: 2, max_days: 3 },
{ pincode: 638182, min_days: 2, max_days: 3 },
{ pincode: 638183, min_days: 2, max_days: 3 },
{ pincode: 638201, min_days: 2, max_days: 3 },
{ pincode: 638202, min_days: 2, max_days: 3 },
{ pincode: 638203, min_days: 2, max_days: 3 },
{ pincode: 638204, min_days: 2, max_days: 3 },
{ pincode: 638206, min_days: 2, max_days: 3 },
{ pincode: 638211, min_days: 2, max_days: 3 },
{ pincode: 638301, min_days: 2, max_days: 3 },
{ pincode: 638302, min_days: 2, max_days: 3 },
{ pincode: 638311, min_days: 2, max_days: 3 },
{ pincode: 638312, min_days: 2, max_days: 3 },
{ pincode: 638313, min_days: 2, max_days: 3 },
{ pincode: 638314, min_days: 2, max_days: 3 },
{ pincode: 638315, min_days: 2, max_days: 3 },
{ pincode: 638316, min_days: 2, max_days: 3 },
{ pincode: 638319, min_days: 2, max_days: 3 },
{ pincode: 638324, min_days: 2, max_days: 3 },
{ pincode: 638327, min_days: 2, max_days: 3 },
{ pincode: 638328, min_days: 2, max_days: 3 },
{ pincode: 638401, min_days: 2, max_days: 3 },
{ pincode: 638402, min_days: 2, max_days: 3 },
{ pincode: 638403, min_days: 2, max_days: 3 },
{ pincode: 638406, min_days: 2, max_days: 3 },
{ pincode: 638450, min_days: 2, max_days: 3 },
{ pincode: 638451, min_days: 2, max_days: 3 },
{ pincode: 638452, min_days: 2, max_days: 3 },
{ pincode: 638453, min_days: 2, max_days: 3 },
{ pincode: 638454, min_days: 2, max_days: 3 },
{ pincode: 638455, min_days: 2, max_days: 3 },
{ pincode: 638456, min_days: 2, max_days: 3 },
{ pincode: 638457, min_days: 2, max_days: 3 },
{ pincode: 638458, min_days: 2, max_days: 3 },
{ pincode: 638459, min_days: 2, max_days: 3 },
{ pincode: 638460, min_days: 2, max_days: 3 },
{ pincode: 638461, min_days: 2, max_days: 3 },
{ pincode: 638462, min_days: 2, max_days: 3 },
{ pincode: 638466, min_days: 2, max_days: 3 },
{ pincode: 638469, min_days: 2, max_days: 3 },
{ pincode: 638471, min_days: 2, max_days: 3 },
{ pincode: 638476, min_days: 2, max_days: 3 },
{ pincode: 638501, min_days: 2, max_days: 3 },
{ pincode: 638502, min_days: 2, max_days: 3 },
{ pincode: 638503, min_days: 2, max_days: 3 },
{ pincode: 638504, min_days: 2, max_days: 3 },
{ pincode: 638505, min_days: 2, max_days: 3 },
{ pincode: 638506, min_days: 2, max_days: 3 },
{ pincode: 638512, min_days: 2, max_days: 3 },
{ pincode: 638602, min_days: 2, max_days: 3 },
{ pincode: 638603, min_days: 2, max_days: 3 },
{ pincode: 638605, min_days: 2, max_days: 3 },
{ pincode: 638606, min_days: 2, max_days: 3 },
{ pincode: 638652, min_days: 2, max_days: 3 },
{ pincode: 638653, min_days: 2, max_days: 3 },
{ pincode: 638654, min_days: 2, max_days: 3 },
{ pincode: 638656, min_days: 2, max_days: 3 },
{ pincode: 638657, min_days: 2, max_days: 3 },
{ pincode: 638658, min_days: 2, max_days: 3 },
{ pincode: 638660, min_days: 2, max_days: 3 },
{ pincode: 638661, min_days: 2, max_days: 3 },
{ pincode: 638664, min_days: 2, max_days: 3 },
{ pincode: 638666, min_days: 2, max_days: 3 },
{ pincode: 638668, min_days: 2, max_days: 3 },
{ pincode: 638669, min_days: 2, max_days: 3 },
{ pincode: 638671, min_days: 2, max_days: 3 },
{ pincode: 638672, min_days: 2, max_days: 3 },
{ pincode: 638673, min_days: 2, max_days: 3 },
{ pincode: 638675, min_days: 2, max_days: 3 },
{ pincode: 638684, min_days: 2, max_days: 3 },
{ pincode: 638687, min_days: 2, max_days: 3 },
{ pincode: 638696, min_days: 2, max_days: 3 },
{ pincode: 638701, min_days: 2, max_days: 3 },
{ pincode: 638702, min_days: 2, max_days: 3 },
{ pincode: 638703, min_days: 2, max_days: 3 },
{ pincode: 638706, min_days: 2, max_days: 3 },
{ pincode: 638751, min_days: 2, max_days: 3 },
{ pincode: 638752, min_days: 2, max_days: 3 },
{ pincode: 638802, min_days: 2, max_days: 3 },
{ pincode: 638807, min_days: 2, max_days: 3 },
{ pincode: 638812, min_days: 2, max_days: 3 },
{ pincode: 639001, min_days: 2, max_days: 3 },
{ pincode: 639002, min_days: 2, max_days: 3 },
{ pincode: 639003, min_days: 2, max_days: 3 },
{ pincode: 639004, min_days: 2, max_days: 3 },
{ pincode: 639005, min_days: 2, max_days: 3 },
{ pincode: 639006, min_days: 2, max_days: 3 },
{ pincode: 639007, min_days: 2, max_days: 3 },
{ pincode: 639008, min_days: 2, max_days: 3 },
{ pincode: 639101, min_days: 2, max_days: 3 },
{ pincode: 639102, min_days: 2, max_days: 3 },
{ pincode: 639103, min_days: 2, max_days: 3 },
{ pincode: 639104, min_days: 2, max_days: 3 },
{ pincode: 639105, min_days: 2, max_days: 3 },
{ pincode: 639106, min_days: 2, max_days: 3 },
{ pincode: 639107, min_days: 2, max_days: 3 },
{ pincode: 639108, min_days: 2, max_days: 3 },
{ pincode: 639109, min_days: 2, max_days: 3 },
{ pincode: 639110, min_days: 2, max_days: 3 },
{ pincode: 639111, min_days: 2, max_days: 3 },
{ pincode: 639112, min_days: 2, max_days: 3 },
{ pincode: 639113, min_days: 2, max_days: 3 },
{ pincode: 639114, min_days: 2, max_days: 3 },
{ pincode: 639115, min_days: 2, max_days: 3 },
{ pincode: 639116, min_days: 2, max_days: 3 },
{ pincode: 639117, min_days: 2, max_days: 3 },
{ pincode: 639118, min_days: 2, max_days: 3 },
{ pincode: 639119, min_days: 2, max_days: 3 },
{ pincode: 639120, min_days: 2, max_days: 3 },
{ pincode: 639136, min_days: 2, max_days: 3 },
{ pincode: 639144, min_days: 2, max_days: 3 },
{ pincode: 639151, min_days: 2, max_days: 3 },
{ pincode: 639201, min_days: 2, max_days: 3 },
{ pincode: 639202, min_days: 2, max_days: 3 },
{ pincode: 639203, min_days: 2, max_days: 3 },
{ pincode: 639204, min_days: 2, max_days: 3 },
{ pincode: 639205, min_days: 2, max_days: 3 },
{ pincode: 639206, min_days: 2, max_days: 3 },
{ pincode: 639207, min_days: 2, max_days: 3 },
{ pincode: 639210, min_days: 2, max_days: 3 },
{ pincode: 640103, min_days: 2, max_days: 3 },
{ pincode: 640613, min_days: 2, max_days: 3 },
{ pincode: 641001, min_days: 2, max_days: 3 },
{ pincode: 641002, min_days: 2, max_days: 3 },
{ pincode: 641003, min_days: 2, max_days: 3 },
{ pincode: 641004, min_days: 2, max_days: 3 },
{ pincode: 641005, min_days: 2, max_days: 3 },
{ pincode: 641006, min_days: 2, max_days: 3 },
{ pincode: 641007, min_days: 2, max_days: 3 },
{ pincode: 641008, min_days: 2, max_days: 3 },
{ pincode: 641009, min_days: 2, max_days: 3 },
{ pincode: 641010, min_days: 2, max_days: 3 },
{ pincode: 641011, min_days: 2, max_days: 3 },
{ pincode: 641012, min_days: 2, max_days: 3 },
{ pincode: 641013, min_days: 2, max_days: 3 },
{ pincode: 641014, min_days: 2, max_days: 3 },
{ pincode: 641015, min_days: 2, max_days: 3 },
{ pincode: 641016, min_days: 2, max_days: 3 },
{ pincode: 641017, min_days: 2, max_days: 3 },
{ pincode: 641018, min_days: 2, max_days: 3 },
{ pincode: 641019, min_days: 2, max_days: 3 },
{ pincode: 641020, min_days: 2, max_days: 3 },
{ pincode: 641021, min_days: 2, max_days: 3 },
{ pincode: 641022, min_days: 2, max_days: 3 },
{ pincode: 641023, min_days: 2, max_days: 3 },
{ pincode: 641024, min_days: 2, max_days: 3 },
{ pincode: 641025, min_days: 2, max_days: 3 },
{ pincode: 641026, min_days: 2, max_days: 3 },
{ pincode: 641027, min_days: 2, max_days: 3 },
{ pincode: 641028, min_days: 2, max_days: 3 },
{ pincode: 641029, min_days: 2, max_days: 3 },
{ pincode: 641030, min_days: 2, max_days: 3 },
{ pincode: 641031, min_days: 2, max_days: 3 },
{ pincode: 641032, min_days: 2, max_days: 3 },
{ pincode: 641033, min_days: 2, max_days: 3 },
{ pincode: 641034, min_days: 2, max_days: 3 },
{ pincode: 641035, min_days: 2, max_days: 3 },
{ pincode: 641036, min_days: 2, max_days: 3 },
{ pincode: 641037, min_days: 2, max_days: 3 },
{ pincode: 641038, min_days: 2, max_days: 3 },
{ pincode: 641039, min_days: 2, max_days: 3 },
{ pincode: 641040, min_days: 2, max_days: 3 },
{ pincode: 641041, min_days: 2, max_days: 3 },
{ pincode: 641042, min_days: 2, max_days: 3 },
{ pincode: 641043, min_days: 2, max_days: 3 },
{ pincode: 641044, min_days: 2, max_days: 3 },
{ pincode: 641045, min_days: 2, max_days: 3 },
{ pincode: 641046, min_days: 2, max_days: 3 },
{ pincode: 641047, min_days: 2, max_days: 3 },
{ pincode: 641048, min_days: 2, max_days: 3 },
{ pincode: 641049, min_days: 2, max_days: 3 },
{ pincode: 641050, min_days: 2, max_days: 3 },
{ pincode: 641051, min_days: 2, max_days: 3 },
{ pincode: 641061, min_days: 2, max_days: 3 },
{ pincode: 641062, min_days: 2, max_days: 3 },
{ pincode: 641064, min_days: 2, max_days: 3 },
{ pincode: 641065, min_days: 2, max_days: 3 },
{ pincode: 641101, min_days: 2, max_days: 3 },
{ pincode: 641102, min_days: 2, max_days: 3 },
{ pincode: 641103, min_days: 2, max_days: 3 },
{ pincode: 641104, min_days: 2, max_days: 3 },
{ pincode: 641105, min_days: 2, max_days: 3 },
{ pincode: 641106, min_days: 2, max_days: 3 },
{ pincode: 641107, min_days: 2, max_days: 3 },
{ pincode: 641108, min_days: 2, max_days: 3 },
{ pincode: 641109, min_days: 2, max_days: 3 },
{ pincode: 641110, min_days: 2, max_days: 3 },
{ pincode: 641111, min_days: 2, max_days: 3 },
{ pincode: 641112, min_days: 2, max_days: 3 },
{ pincode: 641113, min_days: 2, max_days: 3 },
{ pincode: 641114, min_days: 2, max_days: 3 },
{ pincode: 641115, min_days: 2, max_days: 3 },
{ pincode: 641116, min_days: 2, max_days: 3 },
{ pincode: 641118, min_days: 2, max_days: 3 },
{ pincode: 641120, min_days: 2, max_days: 3 },
{ pincode: 641201, min_days: 2, max_days: 3 },
{ pincode: 641202, min_days: 2, max_days: 3 },
{ pincode: 641301, min_days: 2, max_days: 3 },
{ pincode: 641302, min_days: 2, max_days: 3 },
{ pincode: 641303, min_days: 2, max_days: 3 },
{ pincode: 641304, min_days: 2, max_days: 3 },
{ pincode: 641305, min_days: 2, max_days: 3 },
{ pincode: 641401, min_days: 2, max_days: 3 },
{ pincode: 641402, min_days: 2, max_days: 3 },
{ pincode: 641404, min_days: 2, max_days: 3 },
{ pincode: 641405, min_days: 2, max_days: 3 },
{ pincode: 641406, min_days: 2, max_days: 3 },
{ pincode: 641407, min_days: 2, max_days: 3 },
{ pincode: 641408, min_days: 2, max_days: 3 },
{ pincode: 641601, min_days: 2, max_days: 3 },
{ pincode: 641602, min_days: 2, max_days: 3 },
{ pincode: 641603, min_days: 2, max_days: 3 },
{ pincode: 641604, min_days: 2, max_days: 3 },
{ pincode: 641605, min_days: 2, max_days: 3 },
{ pincode: 641606, min_days: 2, max_days: 3 },
{ pincode: 641607, min_days: 2, max_days: 3 },
{ pincode: 641608, min_days: 2, max_days: 3 },
{ pincode: 641652, min_days: 2, max_days: 3 },
{ pincode: 641653, min_days: 2, max_days: 3 },
{ pincode: 641654, min_days: 2, max_days: 3 },
{ pincode: 641655, min_days: 2, max_days: 3 },
{ pincode: 641657, min_days: 2, max_days: 3 },
{ pincode: 641658, min_days: 2, max_days: 3 },
{ pincode: 641659, min_days: 2, max_days: 3 },
{ pincode: 641662, min_days: 2, max_days: 3 },
{ pincode: 641663, min_days: 2, max_days: 3 },
{ pincode: 641664, min_days: 2, max_days: 3 },
{ pincode: 641665, min_days: 2, max_days: 3 },
{ pincode: 641666, min_days: 2, max_days: 3 },
{ pincode: 641667, min_days: 2, max_days: 3 },
{ pincode: 641668, min_days: 2, max_days: 3 },
{ pincode: 641669, min_days: 2, max_days: 3 },
{ pincode: 641670, min_days: 2, max_days: 3 },
{ pincode: 641671, min_days: 2, max_days: 3 },
{ pincode: 641687, min_days: 2, max_days: 3 },
{ pincode: 641697, min_days: 2, max_days: 3 },
{ pincode: 642001, min_days: 2, max_days: 3 },
{ pincode: 642002, min_days: 2, max_days: 3 },
{ pincode: 642003, min_days: 2, max_days: 3 },
{ pincode: 642004, min_days: 2, max_days: 3 },
{ pincode: 642005, min_days: 2, max_days: 3 },
{ pincode: 642006, min_days: 2, max_days: 3 },
{ pincode: 642007, min_days: 2, max_days: 3 },
{ pincode: 642032, min_days: 2, max_days: 3 },
{ pincode: 642051, min_days: 2, max_days: 3 },
{ pincode: 642052, min_days: 2, max_days: 3 },
{ pincode: 642053, min_days: 2, max_days: 3 },
{ pincode: 642054, min_days: 2, max_days: 3 },
{ pincode: 642055, min_days: 2, max_days: 3 },
{ pincode: 642101, min_days: 2, max_days: 3 },
{ pincode: 642102, min_days: 2, max_days: 3 },
{ pincode: 642103, min_days: 2, max_days: 3 },
{ pincode: 642104, min_days: 2, max_days: 3 },
{ pincode: 642105, min_days: 2, max_days: 3 },
{ pincode: 642106, min_days: 2, max_days: 3 },
{ pincode: 642107, min_days: 2, max_days: 3 },
{ pincode: 642108, min_days: 2, max_days: 3 },
{ pincode: 642109, min_days: 2, max_days: 3 },
{ pincode: 642110, min_days: 2, max_days: 3 },
{ pincode: 642111, min_days: 2, max_days: 3 },
{ pincode: 642112, min_days: 2, max_days: 3 },
{ pincode: 642113, min_days: 2, max_days: 3 },
{ pincode: 642114, min_days: 2, max_days: 3 },
{ pincode: 642115, min_days: 2, max_days: 3 },
{ pincode: 642116, min_days: 2, max_days: 3 },
{ pincode: 642117, min_days: 2, max_days: 3 },
{ pincode: 642118, min_days: 2, max_days: 3 },
{ pincode: 642119, min_days: 2, max_days: 3 },
{ pincode: 642120, min_days: 2, max_days: 3 },
{ pincode: 642122, min_days: 2, max_days: 3 },
{ pincode: 642123, min_days: 2, max_days: 3 },
{ pincode: 642124, min_days: 2, max_days: 3 },
{ pincode: 642125, min_days: 2, max_days: 3 },
{ pincode: 642126, min_days: 2, max_days: 3 },
{ pincode: 642127, min_days: 2, max_days: 3 },
{ pincode: 642128, min_days: 2, max_days: 3 },
{ pincode: 642129, min_days: 2, max_days: 3 },
{ pincode: 642130, min_days: 2, max_days: 3 },
{ pincode: 642131, min_days: 2, max_days: 3 },
{ pincode: 642132, min_days: 2, max_days: 3 },
{ pincode: 642133, min_days: 2, max_days: 3 },
{ pincode: 642134, min_days: 2, max_days: 3 },
{ pincode: 642135, min_days: 2, max_days: 3 },
{ pincode: 642137, min_days: 2, max_days: 3 },
{ pincode: 642138, min_days: 2, max_days: 3 },
{ pincode: 642139, min_days: 2, max_days: 3 },
{ pincode: 642140, min_days: 2, max_days: 3 },
{ pincode: 642142, min_days: 2, max_days: 3 },
{ pincode: 642143, min_days: 2, max_days: 3 },
{ pincode: 642144, min_days: 2, max_days: 3 },
{ pincode: 642145, min_days: 2, max_days: 3 },
{ pincode: 642146, min_days: 2, max_days: 3 },
{ pincode: 642147, min_days: 2, max_days: 3 },
{ pincode: 642148, min_days: 2, max_days: 3 },
{ pincode: 642149, min_days: 2, max_days: 3 },
{ pincode: 642152, min_days: 2, max_days: 3 },
{ pincode: 642153, min_days: 2, max_days: 3 },
{ pincode: 642154, min_days: 2, max_days: 3 },
{ pincode: 642201, min_days: 2, max_days: 3 },
{ pincode: 642202, min_days: 2, max_days: 3 },
{ pincode: 642203, min_days: 2, max_days: 3 },
{ pincode: 642204, min_days: 2, max_days: 3 },
{ pincode: 642205, min_days: 2, max_days: 3 },
{ pincode: 642206, min_days: 2, max_days: 3 },
{ pincode: 642207, min_days: 2, max_days: 3 },
{ pincode: 643001, min_days: 2, max_days: 3 },
{ pincode: 643002, min_days: 2, max_days: 3 },
{ pincode: 643003, min_days: 2, max_days: 3 },
{ pincode: 643004, min_days: 2, max_days: 3 },
{ pincode: 643005, min_days: 2, max_days: 3 },
{ pincode: 643006, min_days: 2, max_days: 3 },
{ pincode: 643007, min_days: 2, max_days: 3 },
{ pincode: 643051, min_days: 2, max_days: 3 },
{ pincode: 643052, min_days: 2, max_days: 3 },
{ pincode: 643053, min_days: 2, max_days: 3 },
{ pincode: 643054, min_days: 2, max_days: 3 },
{ pincode: 643055, min_days: 2, max_days: 3 },
{ pincode: 643101, min_days: 2, max_days: 3 },
{ pincode: 643102, min_days: 2, max_days: 3 },
{ pincode: 643103, min_days: 2, max_days: 3 },
{ pincode: 643104, min_days: 2, max_days: 3 },
{ pincode: 643105, min_days: 2, max_days: 3 },
{ pincode: 643106, min_days: 2, max_days: 3 },
{ pincode: 643201, min_days: 2, max_days: 3 },
{ pincode: 643202, min_days: 2, max_days: 3 },
{ pincode: 643203, min_days: 2, max_days: 3 },
{ pincode: 643204, min_days: 2, max_days: 3 },
{ pincode: 643205, min_days: 2, max_days: 3 },
{ pincode: 643206, min_days: 2, max_days: 3 },
{ pincode: 643207, min_days: 2, max_days: 3 },
{ pincode: 643209, min_days: 2, max_days: 3 },
{ pincode: 643210, min_days: 2, max_days: 3 },
{ pincode: 643211, min_days: 2, max_days: 3 },
{ pincode: 643212, min_days: 2, max_days: 3 },
{ pincode: 643213, min_days: 2, max_days: 3 },
{ pincode: 643214, min_days: 2, max_days: 3 },
{ pincode: 643215, min_days: 2, max_days: 3 },
{ pincode: 643216, min_days: 2, max_days: 3 },
{ pincode: 643217, min_days: 2, max_days: 3 },
{ pincode: 643218, min_days: 2, max_days: 3 },
{ pincode: 643219, min_days: 2, max_days: 3 },
{ pincode: 643220, min_days: 2, max_days: 3 },
{ pincode: 643221, min_days: 2, max_days: 3 },
{ pincode: 643222, min_days: 2, max_days: 3 },
{ pincode: 643223, min_days: 2, max_days: 3 },
{ pincode: 643224, min_days: 2, max_days: 3 },
{ pincode: 643225, min_days: 2, max_days: 3 },
{ pincode: 643226, min_days: 2, max_days: 3 },
{ pincode: 643229, min_days: 2, max_days: 3 },
{ pincode: 643231, min_days: 2, max_days: 3 },
{ pincode: 643232, min_days: 2, max_days: 3 },
{ pincode: 643233, min_days: 2, max_days: 3 },
{ pincode: 643234, min_days: 2, max_days: 3 },
{ pincode: 643236, min_days: 2, max_days: 3 },
{ pincode: 643237, min_days: 2, max_days: 3 },
{ pincode: 643238, min_days: 2, max_days: 3 },
{ pincode: 643239, min_days: 2, max_days: 3 },
{ pincode: 643240, min_days: 2, max_days: 3 },
{ pincode: 643241, min_days: 2, max_days: 3 },
{ pincode: 643242, min_days: 2, max_days: 3 },
{ pincode: 643243, min_days: 2, max_days: 3 },
{ pincode: 643245, min_days: 2, max_days: 3 },
{ pincode: 643246, min_days: 2, max_days: 3 },
{ pincode: 643247, min_days: 2, max_days: 3 },
{ pincode: 643250, min_days: 2, max_days: 3 },
{ pincode: 643251, min_days: 2, max_days: 3 },
{ pincode: 643252, min_days: 2, max_days: 3 },
{ pincode: 643253, min_days: 2, max_days: 3 },
{ pincode: 643256, min_days: 2, max_days: 3 },
{ pincode: 643257, min_days: 2, max_days: 3 },
{ pincode: 643258, min_days: 2, max_days: 3 },
{ pincode: 643259, min_days: 2, max_days: 3 },
{ pincode: 643260, min_days: 2, max_days: 3 },
{ pincode: 643261, min_days: 2, max_days: 3 },
{ pincode: 643264, min_days: 2, max_days: 3 },
{ pincode: 643265, min_days: 2, max_days: 3 },
{ pincode: 643267, min_days: 2, max_days: 3 },
{ pincode: 643269, min_days: 2, max_days: 3 },
{ pincode: 643270, min_days: 2, max_days: 3 },
{ pincode: 643271, min_days: 2, max_days: 3 },
{ pincode: 643272, min_days: 2, max_days: 3 },
{ pincode: 643273, min_days: 2, max_days: 3 },
{ pincode: 643276, min_days: 2, max_days: 3 },
{ pincode: 643277, min_days: 2, max_days: 3 },
{ pincode: 643278, min_days: 2, max_days: 3 },
{ pincode: 643279, min_days: 2, max_days: 3 },
{ pincode: 643282, min_days: 2, max_days: 3 },
{ pincode: 643518, min_days: 2, max_days: 3 },
{ pincode: 666213, min_days: 2, max_days: 3 },
{ pincode: 670001, min_days: 2, max_days: 3 },
{ pincode: 670002, min_days: 2, max_days: 3 },
{ pincode: 670003, min_days: 2, max_days: 3 },
{ pincode: 670004, min_days: 2, max_days: 3 },
{ pincode: 670005, min_days: 2, max_days: 3 },
{ pincode: 670006, min_days: 2, max_days: 3 },
{ pincode: 670007, min_days: 2, max_days: 3 },
{ pincode: 670008, min_days: 2, max_days: 3 },
{ pincode: 670009, min_days: 2, max_days: 3 },
{ pincode: 670010, min_days: 2, max_days: 3 },
{ pincode: 670011, min_days: 2, max_days: 3 },
{ pincode: 670012, min_days: 2, max_days: 3 },
{ pincode: 670013, min_days: 2, max_days: 3 },
{ pincode: 670014, min_days: 2, max_days: 3 },
{ pincode: 670015, min_days: 3, max_days: 4 },
{ pincode: 670016, min_days: 3, max_days: 4 },
{ pincode: 670017, min_days: 2, max_days: 3 },
{ pincode: 670018, min_days: 2, max_days: 3 },
{ pincode: 670051, min_days: 2, max_days: 3 },
{ pincode: 670101, min_days: 2, max_days: 3 },
{ pincode: 670102, min_days: 2, max_days: 3 },
{ pincode: 670103, min_days: 2, max_days: 3 },
{ pincode: 670104, min_days: 2, max_days: 3 },
{ pincode: 670105, min_days: 2, max_days: 3 },
{ pincode: 670106, min_days: 2, max_days: 3 },
{ pincode: 670107, min_days: 2, max_days: 3 },
{ pincode: 670109, min_days: 3, max_days: 4 },
{ pincode: 670110, min_days: 3, max_days: 4 },
{ pincode: 670111, min_days: 3, max_days: 4 },
{ pincode: 670141, min_days: 2, max_days: 3 },
{ pincode: 670142, min_days: 2, max_days: 3 },
{ pincode: 670143, min_days: 2, max_days: 3 },
{ pincode: 670144, min_days: 3, max_days: 4 },
{ pincode: 670301, min_days: 2, max_days: 3 },
{ pincode: 670302, min_days: 2, max_days: 3 },
{ pincode: 670303, min_days: 2, max_days: 3 },
{ pincode: 670304, min_days: 2, max_days: 3 },
{ pincode: 670305, min_days: 2, max_days: 3 },
{ pincode: 670306, min_days: 2, max_days: 3 },
{ pincode: 670307, min_days: 2, max_days: 3 },
{ pincode: 670308, min_days: 2, max_days: 3 },
{ pincode: 670309, min_days: 2, max_days: 3 },
{ pincode: 670310, min_days: 2, max_days: 3 },
{ pincode: 670312, min_days: 3, max_days: 4 },
{ pincode: 670313, min_days: 3, max_days: 4 },
{ pincode: 670314, min_days: 3, max_days: 4 },
{ pincode: 670315, min_days: 3, max_days: 4 },
{ pincode: 670316, min_days: 3, max_days: 4 },
{ pincode: 670317, min_days: 3, max_days: 4 },
{ pincode: 670318, min_days: 3, max_days: 4 },
{ pincode: 670319, min_days: 3, max_days: 4 },
{ pincode: 670321, min_days: 3, max_days: 4 },
{ pincode: 670322, min_days: 3, max_days: 4 },
{ pincode: 670325, min_days: 2, max_days: 3 },
{ pincode: 670327, min_days: 2, max_days: 3 },
{ pincode: 670330, min_days: 3, max_days: 4 },
{ pincode: 670331, min_days: 2, max_days: 3 },
{ pincode: 670332, min_days: 3, max_days: 4 },
{ pincode: 670333, min_days: 3, max_days: 4 },
{ pincode: 670334, min_days: 2, max_days: 3 },
{ pincode: 670337, min_days: 3, max_days: 4 },
{ pincode: 670338, min_days: 3, max_days: 4 },
{ pincode: 670339, min_days: 3, max_days: 4 },
{ pincode: 670343, min_days: 3, max_days: 4 },
{ pincode: 670346, min_days: 3, max_days: 4 },
{ pincode: 670353, min_days: 2, max_days: 3 },
{ pincode: 670354, min_days: 3, max_days: 4 },
{ pincode: 670358, min_days: 2, max_days: 3 },
{ pincode: 670501, min_days: 2, max_days: 3 },
{ pincode: 670502, min_days: 2, max_days: 3 },
{ pincode: 670503, min_days: 2, max_days: 3 },
{ pincode: 670504, min_days: 2, max_days: 3 },
{ pincode: 670507, min_days: 3, max_days: 4 },
{ pincode: 670511, min_days: 2, max_days: 3 },
{ pincode: 670521, min_days: 2, max_days: 3 },
{ pincode: 670522, min_days: 3, max_days: 4 },
{ pincode: 670561, min_days: 2, max_days: 3 },
{ pincode: 670562, min_days: 2, max_days: 3 },
{ pincode: 670563, min_days: 2, max_days: 3 },
{ pincode: 670564, min_days: 3, max_days: 4 },
{ pincode: 670565, min_days: 3, max_days: 4 },
{ pincode: 670566, min_days: 3, max_days: 4 },
{ pincode: 670567, min_days: 2, max_days: 3 },
{ pincode: 670571, min_days: 2, max_days: 3 },
{ pincode: 670581, min_days: 2, max_days: 3 },
{ pincode: 670582, min_days: 2, max_days: 3 },
{ pincode: 670583, min_days: 3, max_days: 4 },
{ pincode: 670591, min_days: 2, max_days: 3 },
{ pincode: 670592, min_days: 2, max_days: 3 },
{ pincode: 670593, min_days: 2, max_days: 3 },
{ pincode: 670594, min_days: 2, max_days: 3 },
{ pincode: 670595, min_days: 2, max_days: 3 },
{ pincode: 670597, min_days: 3, max_days: 4 },
{ pincode: 670601, min_days: 2, max_days: 3 },
{ pincode: 670602, min_days: 2, max_days: 3 },
{ pincode: 670603, min_days: 3, max_days: 4 },
{ pincode: 670604, min_days: 2, max_days: 3 },
{ pincode: 670605, min_days: 3, max_days: 4 },
{ pincode: 670611, min_days: 2, max_days: 3 },
{ pincode: 670612, min_days: 2, max_days: 3 },
{ pincode: 670613, min_days: 2, max_days: 3 },
{ pincode: 670614, min_days: 3, max_days: 4 },
{ pincode: 670615, min_days: 3, max_days: 4 },
{ pincode: 670621, min_days: 2, max_days: 3 },
{ pincode: 670622, min_days: 2, max_days: 3 },
{ pincode: 670631, min_days: 2, max_days: 3 },
{ pincode: 670632, min_days: 2, max_days: 3 },
{ pincode: 670633, min_days: 2, max_days: 3 },
{ pincode: 670641, min_days: 2, max_days: 3 },
{ pincode: 670642, min_days: 2, max_days: 3 },
{ pincode: 670643, min_days: 2, max_days: 3 },
{ pincode: 670644, min_days: 2, max_days: 3 },
{ pincode: 670645, min_days: 2, max_days: 3 },
{ pincode: 670646, min_days: 2, max_days: 3 },
{ pincode: 670647, min_days: 3, max_days: 4 },
{ pincode: 670649, min_days: 2, max_days: 3 },
{ pincode: 670650, min_days: 2, max_days: 3 },
{ pincode: 670651, min_days: 2, max_days: 3 },
{ pincode: 670661, min_days: 2, max_days: 3 },
{ pincode: 670662, min_days: 2, max_days: 3 },
{ pincode: 670663, min_days: 2, max_days: 3 },
{ pincode: 670671, min_days: 2, max_days: 3 },
{ pincode: 670672, min_days: 2, max_days: 3 },
{ pincode: 670673, min_days: 2, max_days: 3 },
{ pincode: 670674, min_days: 2, max_days: 3 },
{ pincode: 670675, min_days: 2, max_days: 3 },
{ pincode: 670676, min_days: 2, max_days: 3 },
{ pincode: 670677, min_days: 3, max_days: 4 },
{ pincode: 670678, min_days: 3, max_days: 4 },
{ pincode: 670679, min_days: 3, max_days: 4 },
{ pincode: 670691, min_days: 2, max_days: 3 },
{ pincode: 670692, min_days: 2, max_days: 3 },
{ pincode: 670693, min_days: 2, max_days: 3 },
{ pincode: 670694, min_days: 2, max_days: 3 },
{ pincode: 670695, min_days: 3, max_days: 4 },
{ pincode: 670701, min_days: 2, max_days: 3 },
{ pincode: 670702, min_days: 2, max_days: 3 },
{ pincode: 670703, min_days: 2, max_days: 3 },
{ pincode: 670704, min_days: 2, max_days: 3 },
{ pincode: 670705, min_days: 2, max_days: 3 },
{ pincode: 670706, min_days: 2, max_days: 3 },
{ pincode: 670708, min_days: 2, max_days: 3 },
{ pincode: 670721, min_days: 2, max_days: 3 },
{ pincode: 670731, min_days: 2, max_days: 3 },
{ pincode: 670732, min_days: 3, max_days: 4 },
{ pincode: 670741, min_days: 2, max_days: 3 },
{ pincode: 671121, min_days: 2, max_days: 3 },
{ pincode: 671122, min_days: 2, max_days: 3 },
{ pincode: 671123, min_days: 2, max_days: 3 },
{ pincode: 671124, min_days: 2, max_days: 3 },
{ pincode: 671125, min_days: 3, max_days: 4 },
{ pincode: 671128, min_days: 3, max_days: 4 },
{ pincode: 671221, min_days: 3, max_days: 4 },
{ pincode: 671310, min_days: 2, max_days: 3 },
{ pincode: 671311, min_days: 2, max_days: 3 },
{ pincode: 671312, min_days: 2, max_days: 3 },
{ pincode: 671313, min_days: 2, max_days: 3 },
{ pincode: 671314, min_days: 2, max_days: 3 },
{ pincode: 671315, min_days: 2, max_days: 3 },
{ pincode: 671316, min_days: 2, max_days: 3 },
{ pincode: 671317, min_days: 2, max_days: 3 },
{ pincode: 671318, min_days: 2, max_days: 3 },
{ pincode: 671319, min_days: 2, max_days: 3 },
{ pincode: 671320, min_days: 2, max_days: 3 },
{ pincode: 671321, min_days: 2, max_days: 3 },
{ pincode: 671322, min_days: 2, max_days: 3 },
{ pincode: 671323, min_days: 2, max_days: 3 },
{ pincode: 671324, min_days: 2, max_days: 3 },
{ pincode: 671326, min_days: 2, max_days: 3 },
{ pincode: 671328, min_days: 3, max_days: 4 },
{ pincode: 671329, min_days: 3, max_days: 4 },
{ pincode: 671341, min_days: 3, max_days: 4 },
{ pincode: 671344, min_days: 3, max_days: 4 },
{ pincode: 671345, min_days: 3, max_days: 4 },
{ pincode: 671348, min_days: 2, max_days: 3 },
{ pincode: 671349, min_days: 3, max_days: 4 },
{ pincode: 671350, min_days: 3, max_days: 4 },
{ pincode: 671351, min_days: 2, max_days: 3 },
{ pincode: 671353, min_days: 3, max_days: 4 },
{ pincode: 671357, min_days: 3, max_days: 4 },
{ pincode: 671531, min_days: 2, max_days: 3 },
{ pincode: 671532, min_days: 2, max_days: 3 },
{ pincode: 671533, min_days: 2, max_days: 3 },
{ pincode: 671534, min_days: 2, max_days: 3 },
{ pincode: 671535, min_days: 3, max_days: 4 },
{ pincode: 671541, min_days: 2, max_days: 3 },
{ pincode: 671542, min_days: 2, max_days: 3 },
{ pincode: 671543, min_days: 2, max_days: 3 },
{ pincode: 671545, min_days: 3, max_days: 4 },
{ pincode: 671551, min_days: 2, max_days: 3 },
{ pincode: 671552, min_days: 2, max_days: 3 },
{ pincode: 672105, min_days: 2, max_days: 3 },
{ pincode: 673000, min_days: 3, max_days: 4 },
{ pincode: 673001, min_days: 2, max_days: 3 },
{ pincode: 673002, min_days: 2, max_days: 3 },
{ pincode: 673003, min_days: 2, max_days: 3 },
{ pincode: 673004, min_days: 2, max_days: 3 },
{ pincode: 673005, min_days: 2, max_days: 3 },
{ pincode: 673006, min_days: 2, max_days: 3 },
{ pincode: 673007, min_days: 2, max_days: 3 },
{ pincode: 673008, min_days: 2, max_days: 3 },
{ pincode: 673009, min_days: 2, max_days: 3 },
{ pincode: 673010, min_days: 2, max_days: 3 },
{ pincode: 673011, min_days: 2, max_days: 3 },
{ pincode: 673012, min_days: 2, max_days: 3 },
{ pincode: 673013, min_days: 3, max_days: 4 },
{ pincode: 673014, min_days: 2, max_days: 3 },
{ pincode: 673015, min_days: 2, max_days: 3 },
{ pincode: 673016, min_days: 2, max_days: 3 },
{ pincode: 673017, min_days: 2, max_days: 3 },
{ pincode: 673018, min_days: 2, max_days: 3 },
{ pincode: 673019, min_days: 2, max_days: 3 },
{ pincode: 673020, min_days: 2, max_days: 3 },
{ pincode: 673021, min_days: 2, max_days: 3 },
{ pincode: 673022, min_days: 3, max_days: 4 },
{ pincode: 673023, min_days: 3, max_days: 4 },
{ pincode: 673024, min_days: 3, max_days: 4 },
{ pincode: 673025, min_days: 3, max_days: 4 },
{ pincode: 673026, min_days: 3, max_days: 4 },
{ pincode: 673027, min_days: 2, max_days: 3 },
{ pincode: 673028, min_days: 2, max_days: 3 },
{ pincode: 673029, min_days: 2, max_days: 3 },
{ pincode: 673031, min_days: 3, max_days: 4 },
{ pincode: 673032, min_days: 2, max_days: 3 },
{ pincode: 673035, min_days: 3, max_days: 4 },
{ pincode: 673037, min_days: 3, max_days: 4 },
{ pincode: 673051, min_days: 2, max_days: 3 },
{ pincode: 673101, min_days: 2, max_days: 3 },
{ pincode: 673102, min_days: 2, max_days: 3 },
{ pincode: 673103, min_days: 2, max_days: 3 },
{ pincode: 673104, min_days: 2, max_days: 3 },
{ pincode: 673105, min_days: 2, max_days: 3 },
{ pincode: 673106, min_days: 2, max_days: 3 },
{ pincode: 673110, min_days: 3, max_days: 4 },
{ pincode: 673121, min_days: 2, max_days: 3 },
{ pincode: 673122, min_days: 2, max_days: 3 },
{ pincode: 673123, min_days: 2, max_days: 3 },
{ pincode: 673124, min_days: 2, max_days: 3 },
{ pincode: 673125, min_days: 3, max_days: 4 },
{ pincode: 673126, min_days: 3, max_days: 4 },
{ pincode: 673300, min_days: 3, max_days: 4 },
{ pincode: 673301, min_days: 2, max_days: 3 },
{ pincode: 673302, min_days: 2, max_days: 3 },
{ pincode: 673303, min_days: 2, max_days: 3 },
{ pincode: 673304, min_days: 2, max_days: 3 },
{ pincode: 673305, min_days: 2, max_days: 3 },
{ pincode: 673306, min_days: 2, max_days: 3 },
{ pincode: 673307, min_days: 2, max_days: 3 },
{ pincode: 673308, min_days: 2, max_days: 3 },
{ pincode: 673309, min_days: 2, max_days: 3 },
{ pincode: 673310, min_days: 2, max_days: 3 },
{ pincode: 673311, min_days: 2, max_days: 3 },
{ pincode: 673312, min_days: 2, max_days: 3 },
{ pincode: 673313, min_days: 2, max_days: 3 },
{ pincode: 673314, min_days: 2, max_days: 3 },
{ pincode: 673315, min_days: 2, max_days: 3 },
{ pincode: 673316, min_days: 2, max_days: 3 },
{ pincode: 673317, min_days: 2, max_days: 3 },
{ pincode: 673318, min_days: 3, max_days: 4 },
{ pincode: 673319, min_days: 3, max_days: 4 },
{ pincode: 673320, min_days: 3, max_days: 4 },
{ pincode: 673321, min_days: 3, max_days: 4 },
{ pincode: 673322, min_days: 3, max_days: 4 },
{ pincode: 673323, min_days: 2, max_days: 3 },
{ pincode: 673324, min_days: 3, max_days: 4 },
{ pincode: 673325, min_days: 3, max_days: 4 },
{ pincode: 673326, min_days: 3, max_days: 4 },
{ pincode: 673327, min_days: 3, max_days: 4 },
{ pincode: 673328, min_days: 2, max_days: 3 },
{ pincode: 673330, min_days: 3, max_days: 4 },
{ pincode: 673333, min_days: 3, max_days: 4 },
{ pincode: 673338, min_days: 3, max_days: 4 },
{ pincode: 673501, min_days: 2, max_days: 3 },
{ pincode: 673502, min_days: 2, max_days: 3 },
{ pincode: 673503, min_days: 2, max_days: 3 },
{ pincode: 673504, min_days: 2, max_days: 3 },
{ pincode: 673505, min_days: 2, max_days: 3 },
{ pincode: 673506, min_days: 2, max_days: 3 },
{ pincode: 673507, min_days: 2, max_days: 3 },
{ pincode: 673508, min_days: 2, max_days: 3 },
{ pincode: 673509, min_days: 2, max_days: 3 },
{ pincode: 673510, min_days: 3, max_days: 4 },
{ pincode: 673511, min_days: 3, max_days: 4 },
{ pincode: 673513, min_days: 2, max_days: 3 },
{ pincode: 673514, min_days: 3, max_days: 4 },
{ pincode: 673515, min_days: 3, max_days: 4 },
{ pincode: 673516, min_days: 3, max_days: 4 },
{ pincode: 673517, min_days: 2, max_days: 3 },
{ pincode: 673519, min_days: 3, max_days: 4 },
{ pincode: 673520, min_days: 3, max_days: 4 },
{ pincode: 673521, min_days: 2, max_days: 3 },
{ pincode: 673522, min_days: 2, max_days: 3 },
{ pincode: 673523, min_days: 2, max_days: 3 },
{ pincode: 673524, min_days: 2, max_days: 3 },
{ pincode: 673525, min_days: 2, max_days: 3 },
{ pincode: 673526, min_days: 2, max_days: 3 },
{ pincode: 673527, min_days: 2, max_days: 3 },
{ pincode: 673528, min_days: 2, max_days: 3 },
{ pincode: 673529, min_days: 2, max_days: 3 },
{ pincode: 673530, min_days: 3, max_days: 4 },
{ pincode: 673531, min_days: 3, max_days: 4 },
{ pincode: 673532, min_days: 3, max_days: 4 },
{ pincode: 673533, min_days: 3, max_days: 4 },
{ pincode: 673534, min_days: 3, max_days: 4 },
{ pincode: 673535, min_days: 3, max_days: 4 },
{ pincode: 673541, min_days: 2, max_days: 3 },
{ pincode: 673542, min_days: 2, max_days: 3 },
{ pincode: 673543, min_days: 3, max_days: 4 },
{ pincode: 673544, min_days: 3, max_days: 4 },
{ pincode: 673570, min_days: 2, max_days: 3 },
{ pincode: 673571, min_days: 2, max_days: 3 },
{ pincode: 673572, min_days: 2, max_days: 3 },
{ pincode: 673573, min_days: 2, max_days: 3 },
{ pincode: 673574, min_days: 2, max_days: 3 },
{ pincode: 673575, min_days: 2, max_days: 3 },
{ pincode: 673576, min_days: 2, max_days: 3 },
{ pincode: 673577, min_days: 2, max_days: 3 },
{ pincode: 673578, min_days: 3, max_days: 4 },
{ pincode: 673579, min_days: 2, max_days: 3 },
{ pincode: 673580, min_days: 2, max_days: 3 },
{ pincode: 673581, min_days: 2, max_days: 3 },
{ pincode: 673582, min_days: 2, max_days: 3 },
{ pincode: 673583, min_days: 3, max_days: 4 },
{ pincode: 673584, min_days: 3, max_days: 4 },
{ pincode: 673585, min_days: 2, max_days: 3 },
{ pincode: 673586, min_days: 2, max_days: 3 },
{ pincode: 673587, min_days: 3, max_days: 4 },
{ pincode: 673588, min_days: 3, max_days: 4 },
{ pincode: 673589, min_days: 3, max_days: 4 },
{ pincode: 673591, min_days: 2, max_days: 3 },
{ pincode: 673592, min_days: 2, max_days: 3 },
{ pincode: 673593, min_days: 2, max_days: 3 },
{ pincode: 673595, min_days: 2, max_days: 3 },
{ pincode: 673596, min_days: 2, max_days: 3 },
{ pincode: 673600, min_days: 3, max_days: 4 },
{ pincode: 673601, min_days: 2, max_days: 3 },
{ pincode: 673602, min_days: 2, max_days: 3 },
{ pincode: 673603, min_days: 2, max_days: 3 },
{ pincode: 673604, min_days: 2, max_days: 3 },
{ pincode: 673607, min_days: 3, max_days: 4 },
{ pincode: 673611, min_days: 2, max_days: 3 },
{ pincode: 673612, min_days: 2, max_days: 3 },
{ pincode: 673613, min_days: 2, max_days: 3 },
{ pincode: 673614, min_days: 2, max_days: 3 },
{ pincode: 673615, min_days: 3, max_days: 4 },
{ pincode: 673616, min_days: 2, max_days: 3 },
{ pincode: 673617, min_days: 3, max_days: 4 },
{ pincode: 673618, min_days: 3, max_days: 4 },
{ pincode: 673619, min_days: 3, max_days: 4 },
{ pincode: 673620, min_days: 2, max_days: 3 },
{ pincode: 673621, min_days: 3, max_days: 4 },
{ pincode: 673622, min_days: 3, max_days: 4 },
{ pincode: 673623, min_days: 3, max_days: 4 },
{ pincode: 673624, min_days: 3, max_days: 4 },
{ pincode: 673631, min_days: 2, max_days: 3 },
{ pincode: 673632, min_days: 2, max_days: 3 },
{ pincode: 673633, min_days: 2, max_days: 3 },
{ pincode: 673634, min_days: 2, max_days: 3 },
{ pincode: 673635, min_days: 2, max_days: 3 },
{ pincode: 673636, min_days: 2, max_days: 3 },
{ pincode: 673637, min_days: 2, max_days: 3 },
{ pincode: 673638, min_days: 2, max_days: 3 },
{ pincode: 673639, min_days: 2, max_days: 3 },
{ pincode: 673640, min_days: 2, max_days: 3 },
{ pincode: 673641, min_days: 2, max_days: 3 },
{ pincode: 673642, min_days: 2, max_days: 3 },
{ pincode: 673643, min_days: 3, max_days: 4 },
{ pincode: 673644, min_days: 3, max_days: 4 },
{ pincode: 673645, min_days: 2, max_days: 3 },
{ pincode: 673647, min_days: 2, max_days: 3 },
{ pincode: 673648, min_days: 3, max_days: 4 },
{ pincode: 673649, min_days: 3, max_days: 4 },
{ pincode: 673650, min_days: 3, max_days: 4 },
{ pincode: 673651, min_days: 3, max_days: 4 },
{ pincode: 673652, min_days: 3, max_days: 4 },
{ pincode: 673653, min_days: 3, max_days: 4 },
{ pincode: 673654, min_days: 3, max_days: 4 },
{ pincode: 673655, min_days: 2, max_days: 3 },
{ pincode: 673661, min_days: 2, max_days: 3 },
{ pincode: 676101, min_days: 2, max_days: 3 },
{ pincode: 676102, min_days: 2, max_days: 3 },
{ pincode: 676103, min_days: 2, max_days: 3 },
{ pincode: 676104, min_days: 2, max_days: 3 },
{ pincode: 676105, min_days: 2, max_days: 3 },
{ pincode: 676106, min_days: 2, max_days: 3 },
{ pincode: 676107, min_days: 2, max_days: 3 },
{ pincode: 676108, min_days: 2, max_days: 3 },
{ pincode: 676109, min_days: 2, max_days: 3 },
{ pincode: 676110, min_days: 3, max_days: 4 },
{ pincode: 676111, min_days: 3, max_days: 4 },
{ pincode: 676121, min_days: 2, max_days: 3 },
{ pincode: 676122, min_days: 2, max_days: 3 },
{ pincode: 676123, min_days: 2, max_days: 3 },
{ pincode: 676126, min_days: 3, max_days: 4 },
{ pincode: 676127, min_days: 3, max_days: 4 },
{ pincode: 676161, min_days: 3, max_days: 4 },
{ pincode: 676301, min_days: 2, max_days: 3 },
{ pincode: 676302, min_days: 2, max_days: 3 },
{ pincode: 676303, min_days: 2, max_days: 3 },
{ pincode: 676304, min_days: 2, max_days: 3 },
{ pincode: 676305, min_days: 2, max_days: 3 },
{ pincode: 676306, min_days: 2, max_days: 3 },
{ pincode: 676307, min_days: 2, max_days: 3 },
{ pincode: 676308, min_days: 3, max_days: 4 },
{ pincode: 676309, min_days: 2, max_days: 3 },
{ pincode: 676310, min_days: 3, max_days: 4 },
{ pincode: 676311, min_days: 2, max_days: 3 },
{ pincode: 676312, min_days: 2, max_days: 3 },
{ pincode: 676313, min_days: 3, max_days: 4 },
{ pincode: 676314, min_days: 3, max_days: 4 },
{ pincode: 676315, min_days: 3, max_days: 4 },
{ pincode: 676317, min_days: 2, max_days: 3 },
{ pincode: 676318, min_days: 3, max_days: 4 },
{ pincode: 676319, min_days: 2, max_days: 3 },
{ pincode: 676320, min_days: 2, max_days: 3 },
{ pincode: 676501, min_days: 2, max_days: 3 },
{ pincode: 676502, min_days: 2, max_days: 3 },
{ pincode: 676503, min_days: 2, max_days: 3 },
{ pincode: 676504, min_days: 2, max_days: 3 },
{ pincode: 676505, min_days: 2, max_days: 3 },
{ pincode: 676506, min_days: 2, max_days: 3 },
{ pincode: 676507, min_days: 2, max_days: 3 },
{ pincode: 676508, min_days: 2, max_days: 3 },
{ pincode: 676509, min_days: 2, max_days: 3 },
{ pincode: 676510, min_days: 2, max_days: 3 },
{ pincode: 676511, min_days: 3, max_days: 4 },
{ pincode: 676512, min_days: 3, max_days: 4 },
{ pincode: 676513, min_days: 3, max_days: 4 },
{ pincode: 676514, min_days: 3, max_days: 4 },
{ pincode: 676515, min_days: 3, max_days: 4 },
{ pincode: 676516, min_days: 3, max_days: 4 },
{ pincode: 676517, min_days: 2, max_days: 3 },
{ pincode: 676518, min_days: 3, max_days: 4 },
{ pincode: 676519, min_days: 2, max_days: 3 },
{ pincode: 676520, min_days: 3, max_days: 4 },
{ pincode: 676521, min_days: 2, max_days: 3 },
{ pincode: 676522, min_days: 2, max_days: 3 },
{ pincode: 676523, min_days: 2, max_days: 3 },
{ pincode: 676525, min_days: 2, max_days: 3 },
{ pincode: 676528, min_days: 2, max_days: 3 },
{ pincode: 676541, min_days: 2, max_days: 3 },
{ pincode: 676542, min_days: 2, max_days: 3 },
{ pincode: 676551, min_days: 2, max_days: 3 },
{ pincode: 676552, min_days: 2, max_days: 3 },
{ pincode: 676553, min_days: 2, max_days: 3 },
{ pincode: 676554, min_days: 3, max_days: 4 },
{ pincode: 676556, min_days: 3, max_days: 4 },
{ pincode: 676557, min_days: 3, max_days: 4 },
{ pincode: 676561, min_days: 2, max_days: 3 },
{ pincode: 676562, min_days: 2, max_days: 3 },
{ pincode: 678001, min_days: 2, max_days: 3 },
{ pincode: 678002, min_days: 2, max_days: 3 },
{ pincode: 678003, min_days: 2, max_days: 3 },
{ pincode: 678004, min_days: 2, max_days: 3 },
{ pincode: 678005, min_days: 2, max_days: 3 },
{ pincode: 678006, min_days: 2, max_days: 3 },
{ pincode: 678007, min_days: 2, max_days: 3 },
{ pincode: 678008, min_days: 2, max_days: 3 },
{ pincode: 678009, min_days: 2, max_days: 3 },
{ pincode: 678010, min_days: 2, max_days: 3 },
{ pincode: 678011, min_days: 2, max_days: 3 },
{ pincode: 678012, min_days: 2, max_days: 3 },
{ pincode: 678013, min_days: 2, max_days: 3 },
{ pincode: 678014, min_days: 2, max_days: 3 },
{ pincode: 678015, min_days: 3, max_days: 4 },
{ pincode: 678017, min_days: 3, max_days: 4 },
{ pincode: 678018, min_days: 3, max_days: 4 },
{ pincode: 678019, min_days: 3, max_days: 4 },
{ pincode: 678020, min_days: 3, max_days: 4 },
{ pincode: 678051, min_days: 2, max_days: 3 },
{ pincode: 678101, min_days: 2, max_days: 3 },
{ pincode: 678102, min_days: 2, max_days: 3 },
{ pincode: 678103, min_days: 2, max_days: 3 },
{ pincode: 678104, min_days: 2, max_days: 3 },
{ pincode: 678501, min_days: 2, max_days: 3 },
{ pincode: 678502, min_days: 2, max_days: 3 },
{ pincode: 678503, min_days: 2, max_days: 3 },
{ pincode: 678504, min_days: 2, max_days: 3 },
{ pincode: 678505, min_days: 2, max_days: 3 },
{ pincode: 678506, min_days: 2, max_days: 3 },
{ pincode: 678507, min_days: 2, max_days: 3 },
{ pincode: 678508, min_days: 2, max_days: 3 },
{ pincode: 678509, min_days: 3, max_days: 4 },
{ pincode: 678510, min_days: 2, max_days: 3 },
{ pincode: 678511, min_days: 3, max_days: 4 },
{ pincode: 678512, min_days: 2, max_days: 3 },
{ pincode: 678513, min_days: 3, max_days: 4 },
{ pincode: 678531, min_days: 2, max_days: 3 },
{ pincode: 678532, min_days: 2, max_days: 3 },
{ pincode: 678533, min_days: 2, max_days: 3 },
{ pincode: 678534, min_days: 2, max_days: 3 },
{ pincode: 678541, min_days: 2, max_days: 3 },
{ pincode: 678542, min_days: 2, max_days: 3 },
{ pincode: 678543, min_days: 2, max_days: 3 },
{ pincode: 678544, min_days: 2, max_days: 3 },
{ pincode: 678545, min_days: 2, max_days: 3 },
{ pincode: 678546, min_days: 2, max_days: 3 },
{ pincode: 678547, min_days: 3, max_days: 4 },
{ pincode: 678548, min_days: 3, max_days: 4 },
{ pincode: 678551, min_days: 2, max_days: 3 },
{ pincode: 678552, min_days: 2, max_days: 3 },
{ pincode: 678553, min_days: 2, max_days: 3 },
{ pincode: 678554, min_days: 2, max_days: 3 },
{ pincode: 678555, min_days: 2, max_days: 3 },
{ pincode: 678556, min_days: 2, max_days: 3 },
{ pincode: 678557, min_days: 2, max_days: 3 },
{ pincode: 678558, min_days: 3, max_days: 4 },
{ pincode: 678559, min_days: 3, max_days: 4 },
{ pincode: 678570, min_days: 3, max_days: 4 },
{ pincode: 678571, min_days: 2, max_days: 3 },
{ pincode: 678572, min_days: 2, max_days: 3 },
{ pincode: 678573, min_days: 2, max_days: 3 },
{ pincode: 678574, min_days: 2, max_days: 3 },
{ pincode: 678575, min_days: 3, max_days: 4 },
{ pincode: 678581, min_days: 2, max_days: 3 },
{ pincode: 678582, min_days: 2, max_days: 3 },
{ pincode: 678583, min_days: 2, max_days: 3 },
{ pincode: 678585, min_days: 3, max_days: 4 },
{ pincode: 678586, min_days: 3, max_days: 4 },
{ pincode: 678589, min_days: 3, max_days: 4 },
{ pincode: 678591, min_days: 2, max_days: 3 },
{ pincode: 678592, min_days: 2, max_days: 3 },
{ pincode: 678593, min_days: 2, max_days: 3 },
{ pincode: 678594, min_days: 2, max_days: 3 },
{ pincode: 678595, min_days: 2, max_days: 3 },
{ pincode: 678596, min_days: 2, max_days: 3 },
{ pincode: 678597, min_days: 2, max_days: 3 },
{ pincode: 678598, min_days: 2, max_days: 3 },
{ pincode: 678600, min_days: 3, max_days: 4 },
{ pincode: 678601, min_days: 2, max_days: 3 },
{ pincode: 678605, min_days: 3, max_days: 4 },
{ pincode: 678609, min_days: 3, max_days: 4 },
{ pincode: 678611, min_days: 2, max_days: 3 },
{ pincode: 678612, min_days: 2, max_days: 3 },
{ pincode: 678613, min_days: 2, max_days: 3 },
{ pincode: 678614, min_days: 3, max_days: 4 },
{ pincode: 678615, min_days: 3, max_days: 4 },
{ pincode: 678616, min_days: 3, max_days: 4 },
{ pincode: 678621, min_days: 2, max_days: 3 },
{ pincode: 678622, min_days: 2, max_days: 3 },
{ pincode: 678623, min_days: 2, max_days: 3 },
{ pincode: 678624, min_days: 2, max_days: 3 },
{ pincode: 678631, min_days: 2, max_days: 3 },
{ pincode: 678632, min_days: 2, max_days: 3 },
{ pincode: 678633, min_days: 2, max_days: 3 },
{ pincode: 678634, min_days: 3, max_days: 4 },
{ pincode: 678637, min_days: 3, max_days: 4 },
{ pincode: 678641, min_days: 2, max_days: 3 },
{ pincode: 678642, min_days: 2, max_days: 3 },
{ pincode: 678651, min_days: 2, max_days: 3 },
{ pincode: 678661, min_days: 2, max_days: 3 },
{ pincode: 678671, min_days: 2, max_days: 3 },
{ pincode: 678681, min_days: 2, max_days: 3 },
{ pincode: 678682, min_days: 2, max_days: 3 },
{ pincode: 678683, min_days: 2, max_days: 3 },
{ pincode: 678684, min_days: 2, max_days: 3 },
{ pincode: 678685, min_days: 2, max_days: 3 },
{ pincode: 678686, min_days: 2, max_days: 3 },
{ pincode: 678687, min_days: 2, max_days: 3 },
{ pincode: 678688, min_days: 2, max_days: 3 },
{ pincode: 678689, min_days: 3, max_days: 4 },
{ pincode: 678701, min_days: 2, max_days: 3 },
{ pincode: 678702, min_days: 2, max_days: 3 },
{ pincode: 678703, min_days: 2, max_days: 3 },
{ pincode: 678704, min_days: 2, max_days: 3 },
{ pincode: 678705, min_days: 2, max_days: 3 },
{ pincode: 678706, min_days: 2, max_days: 3 },
{ pincode: 678707, min_days: 3, max_days: 4 },
{ pincode: 678709, min_days: 3, max_days: 4 },
{ pincode: 678721, min_days: 2, max_days: 3 },
{ pincode: 678722, min_days: 2, max_days: 3 },
{ pincode: 678731, min_days: 2, max_days: 3 },
{ pincode: 678732, min_days: 2, max_days: 3 },
{ pincode: 678733, min_days: 3, max_days: 4 },
{ pincode: 678761, min_days: 3, max_days: 4 },
{ pincode: 678762, min_days: 2, max_days: 3 },
{ pincode: 679101, min_days: 2, max_days: 3 },
{ pincode: 679102, min_days: 2, max_days: 3 },
{ pincode: 679103, min_days: 2, max_days: 3 },
{ pincode: 679104, min_days: 2, max_days: 3 },
{ pincode: 679105, min_days: 2, max_days: 3 },
{ pincode: 679106, min_days: 2, max_days: 3 },
{ pincode: 679121, min_days: 2, max_days: 3 },
{ pincode: 679122, min_days: 2, max_days: 3 },
{ pincode: 679123, min_days: 2, max_days: 3 },
{ pincode: 679124, min_days: 3, max_days: 4 },
{ pincode: 679125, min_days: 3, max_days: 4 },
{ pincode: 679301, min_days: 2, max_days: 3 },
{ pincode: 679302, min_days: 2, max_days: 3 },
{ pincode: 679303, min_days: 2, max_days: 3 },
{ pincode: 679304, min_days: 2, max_days: 3 },
{ pincode: 679305, min_days: 2, max_days: 3 },
{ pincode: 679306, min_days: 2, max_days: 3 },
{ pincode: 679307, min_days: 2, max_days: 3 },
{ pincode: 679308, min_days: 2, max_days: 3 },
{ pincode: 679309, min_days: 2, max_days: 3 },
{ pincode: 679310, min_days: 3, max_days: 4 },
{ pincode: 679311, min_days: 3, max_days: 4 },
{ pincode: 679312, min_days: 3, max_days: 4 },
{ pincode: 679313, min_days: 2, max_days: 3 },
{ pincode: 679314, min_days: 3, max_days: 4 },
{ pincode: 679321, min_days: 2, max_days: 3 },
{ pincode: 679322, min_days: 2, max_days: 3 },
{ pincode: 679323, min_days: 2, max_days: 3 },
{ pincode: 679324, min_days: 2, max_days: 3 },
{ pincode: 679325, min_days: 2, max_days: 3 },
{ pincode: 679326, min_days: 2, max_days: 3 },
{ pincode: 679327, min_days: 2, max_days: 3 },
{ pincode: 679328, min_days: 2, max_days: 3 },
{ pincode: 679329, min_days: 2, max_days: 3 },
{ pincode: 679330, min_days: 2, max_days: 3 },
{ pincode: 679331, min_days: 2, max_days: 3 },
{ pincode: 679332, min_days: 2, max_days: 3 },
{ pincode: 679333, min_days: 2, max_days: 3 },
{ pincode: 679334, min_days: 2, max_days: 3 },
{ pincode: 679335, min_days: 2, max_days: 3 },
{ pincode: 679336, min_days: 2, max_days: 3 },
{ pincode: 679337, min_days: 2, max_days: 3 },
{ pincode: 679338, min_days: 2, max_days: 3 },
{ pincode: 679339, min_days: 2, max_days: 3 },
{ pincode: 679340, min_days: 2, max_days: 3 },
{ pincode: 679341, min_days: 2, max_days: 3 },
{ pincode: 679342, min_days: 3, max_days: 4 },
{ pincode: 679343, min_days: 3, max_days: 4 },
{ pincode: 679344, min_days: 3, max_days: 4 },
{ pincode: 679348, min_days: 3, max_days: 4 },
{ pincode: 679350, min_days: 3, max_days: 4 },
{ pincode: 679351, min_days: 3, max_days: 4 },
{ pincode: 679354, min_days: 3, max_days: 4 },
{ pincode: 679355, min_days: 3, max_days: 4 },
{ pincode: 679356, min_days: 3, max_days: 4 },
{ pincode: 679357, min_days: 2, max_days: 3 },
{ pincode: 679501, min_days: 2, max_days: 3 },
{ pincode: 679502, min_days: 2, max_days: 3 },
{ pincode: 679503, min_days: 2, max_days: 3 },
{ pincode: 679504, min_days: 2, max_days: 3 },
{ pincode: 679505, min_days: 2, max_days: 3 },
{ pincode: 679506, min_days: 2, max_days: 3 },
{ pincode: 679511, min_days: 2, max_days: 3 },
{ pincode: 679512, min_days: 2, max_days: 3 },
{ pincode: 679513, min_days: 2, max_days: 3 },
{ pincode: 679514, min_days: 2, max_days: 3 },
{ pincode: 679515, min_days: 2, max_days: 3 },
{ pincode: 679516, min_days: 2, max_days: 3 },
{ pincode: 679517, min_days: 3, max_days: 4 },
{ pincode: 679518, min_days: 3, max_days: 4 },
{ pincode: 679521, min_days: 2, max_days: 3 },
{ pincode: 679522, min_days: 2, max_days: 3 },
{ pincode: 679523, min_days: 2, max_days: 3 },
{ pincode: 679531, min_days: 2, max_days: 3 },
{ pincode: 679532, min_days: 2, max_days: 3 },
{ pincode: 679533, min_days: 2, max_days: 3 },
{ pincode: 679534, min_days: 2, max_days: 3 },
{ pincode: 679535, min_days: 2, max_days: 3 },
{ pincode: 679536, min_days: 2, max_days: 3 },
{ pincode: 679537, min_days: 3, max_days: 4 },
{ pincode: 679538, min_days: 3, max_days: 4 },
{ pincode: 679551, min_days: 2, max_days: 3 },
{ pincode: 679552, min_days: 2, max_days: 3 },
{ pincode: 679553, min_days: 2, max_days: 3 },
{ pincode: 679554, min_days: 2, max_days: 3 },
{ pincode: 679556, min_days: 3, max_days: 4 },
{ pincode: 679561, min_days: 2, max_days: 3 },
{ pincode: 679562, min_days: 2, max_days: 3 },
{ pincode: 679563, min_days: 2, max_days: 3 },
{ pincode: 679564, min_days: 2, max_days: 3 },
{ pincode: 679571, min_days: 2, max_days: 3 },
{ pincode: 679572, min_days: 2, max_days: 3 },
{ pincode: 679573, min_days: 2, max_days: 3 },
{ pincode: 679574, min_days: 2, max_days: 3 },
{ pincode: 679575, min_days: 2, max_days: 3 },
{ pincode: 679576, min_days: 2, max_days: 3 },
{ pincode: 679577, min_days: 2, max_days: 3 },
{ pincode: 679578, min_days: 2, max_days: 3 },
{ pincode: 679579, min_days: 2, max_days: 3 },
{ pincode: 679580, min_days: 2, max_days: 3 },
{ pincode: 679581, min_days: 2, max_days: 3 },
{ pincode: 679582, min_days: 2, max_days: 3 },
{ pincode: 679583, min_days: 2, max_days: 3 },
{ pincode: 679584, min_days: 2, max_days: 3 },
{ pincode: 679585, min_days: 2, max_days: 3 },
{ pincode: 679586, min_days: 2, max_days: 3 },
{ pincode: 679587, min_days: 2, max_days: 3 },
{ pincode: 679588, min_days: 3, max_days: 4 },
{ pincode: 679589, min_days: 3, max_days: 4 },
{ pincode: 679590, min_days: 3, max_days: 4 },
{ pincode: 679591, min_days: 2, max_days: 3 },
{ pincode: 679592, min_days: 3, max_days: 4 },
{ pincode: 679594, min_days: 3, max_days: 4 },
{ pincode: 679633, min_days: 3, max_days: 4 },
{ pincode: 680001, min_days: 2, max_days: 3 },
{ pincode: 680002, min_days: 2, max_days: 3 },
{ pincode: 680003, min_days: 2, max_days: 3 },
{ pincode: 680004, min_days: 2, max_days: 3 },
{ pincode: 680005, min_days: 2, max_days: 3 },
{ pincode: 680006, min_days: 2, max_days: 3 },
{ pincode: 680007, min_days: 2, max_days: 3 },
{ pincode: 680008, min_days: 2, max_days: 3 },
{ pincode: 680009, min_days: 2, max_days: 3 },
{ pincode: 680010, min_days: 2, max_days: 3 },
{ pincode: 680011, min_days: 2, max_days: 3 },
{ pincode: 680012, min_days: 2, max_days: 3 },
{ pincode: 680013, min_days: 2, max_days: 3 },
{ pincode: 680014, min_days: 2, max_days: 3 },
{ pincode: 680015, min_days: 3, max_days: 4 },
{ pincode: 680016, min_days: 3, max_days: 4 },
{ pincode: 680017, min_days: 3, max_days: 4 },
{ pincode: 680018, min_days: 3, max_days: 4 },
{ pincode: 680020, min_days: 2, max_days: 3 },
{ pincode: 680021, min_days: 2, max_days: 3 },
{ pincode: 680022, min_days: 2, max_days: 3 },
{ pincode: 680026, min_days: 2, max_days: 3 },
{ pincode: 680027, min_days: 2, max_days: 3 },
{ pincode: 680028, min_days: 2, max_days: 3 },
{ pincode: 680051, min_days: 2, max_days: 3 },
{ pincode: 680052, min_days: 3, max_days: 4 },
{ pincode: 680101, min_days: 2, max_days: 3 },
{ pincode: 680102, min_days: 2, max_days: 3 },
{ pincode: 680103, min_days: 2, max_days: 3 },
{ pincode: 680104, min_days: 2, max_days: 3 },
{ pincode: 680106, min_days: 3, max_days: 4 },
{ pincode: 680109, min_days: 3, max_days: 4 },
{ pincode: 680111, min_days: 3, max_days: 4 },
{ pincode: 680121, min_days: 2, max_days: 3 },
{ pincode: 680122, min_days: 2, max_days: 3 },
{ pincode: 680123, min_days: 2, max_days: 3 },
{ pincode: 680124, min_days: 3, max_days: 4 },
{ pincode: 680125, min_days: 2, max_days: 3 },
{ pincode: 680221, min_days: 3, max_days: 4 },
{ pincode: 680301, min_days: 2, max_days: 3 },
{ pincode: 680302, min_days: 2, max_days: 3 },
{ pincode: 680303, min_days: 2, max_days: 3 },
{ pincode: 680304, min_days: 2, max_days: 3 },
{ pincode: 680305, min_days: 2, max_days: 3 },
{ pincode: 680306, min_days: 2, max_days: 3 },
{ pincode: 680307, min_days: 2, max_days: 3 },
{ pincode: 680308, min_days: 2, max_days: 3 },
{ pincode: 680309, min_days: 2, max_days: 3 },
{ pincode: 680310, min_days: 2, max_days: 3 },
{ pincode: 680311, min_days: 2, max_days: 3 },
{ pincode: 680312, min_days: 2, max_days: 3 },
{ pincode: 680313, min_days: 3, max_days: 4 },
{ pincode: 680314, min_days: 3, max_days: 4 },
{ pincode: 680315, min_days: 3, max_days: 4 },
{ pincode: 680316, min_days: 3, max_days: 4 },
{ pincode: 680317, min_days: 2, max_days: 3 },
{ pincode: 680319, min_days: 3, max_days: 4 },
{ pincode: 680320, min_days: 3, max_days: 4 },
{ pincode: 680321, min_days: 3, max_days: 4 },
{ pincode: 680322, min_days: 3, max_days: 4 },
{ pincode: 680323, min_days: 3, max_days: 4 },
{ pincode: 680325, min_days: 3, max_days: 4 },
{ pincode: 680501, min_days: 2, max_days: 3 },
{ pincode: 680502, min_days: 2, max_days: 3 },
{ pincode: 680503, min_days: 2, max_days: 3 },
{ pincode: 680504, min_days: 2, max_days: 3 },
{ pincode: 680505, min_days: 2, max_days: 3 },
{ pincode: 680506, min_days: 2, max_days: 3 },
{ pincode: 680507, min_days: 2, max_days: 3 },
{ pincode: 680508, min_days: 2, max_days: 3 },
{ pincode: 680509, min_days: 2, max_days: 3 },
{ pincode: 680510, min_days: 2, max_days: 3 },
{ pincode: 680511, min_days: 2, max_days: 3 },
{ pincode: 680512, min_days: 2, max_days: 3 },
{ pincode: 680513, min_days: 2, max_days: 3 },
{ pincode: 680514, min_days: 2, max_days: 3 },
{ pincode: 680515, min_days: 2, max_days: 3 },
{ pincode: 680516, min_days: 2, max_days: 3 },
{ pincode: 680517, min_days: 2, max_days: 3 },
{ pincode: 680518, min_days: 2, max_days: 3 },
{ pincode: 680519, min_days: 2, max_days: 3 },
{ pincode: 680520, min_days: 2, max_days: 3 },
{ pincode: 680521, min_days: 2, max_days: 3 },
{ pincode: 680522, min_days: 2, max_days: 3 },
{ pincode: 680523, min_days: 2, max_days: 3 },
{ pincode: 680524, min_days: 2, max_days: 3 },
{ pincode: 680541, min_days: 2, max_days: 3 },
{ pincode: 680542, min_days: 2, max_days: 3 },
{ pincode: 680543, min_days: 2, max_days: 3 },
{ pincode: 680544, min_days: 2, max_days: 3 },
{ pincode: 680545, min_days: 2, max_days: 3 },
{ pincode: 680546, min_days: 2, max_days: 3 },
{ pincode: 680547, min_days: 3, max_days: 4 },
{ pincode: 680549, min_days: 3, max_days: 4 },
{ pincode: 680551, min_days: 2, max_days: 3 },
{ pincode: 680552, min_days: 2, max_days: 3 },
{ pincode: 680553, min_days: 2, max_days: 3 },
{ pincode: 680555, min_days: 2, max_days: 3 },
{ pincode: 680561, min_days: 2, max_days: 3 },
{ pincode: 680562, min_days: 2, max_days: 3 },
{ pincode: 680563, min_days: 2, max_days: 3 },
{ pincode: 680564, min_days: 2, max_days: 3 },
{ pincode: 680565, min_days: 2, max_days: 3 },
{ pincode: 680566, min_days: 2, max_days: 3 },
{ pincode: 680567, min_days: 2, max_days: 3 },
{ pincode: 680568, min_days: 2, max_days: 3 },
{ pincode: 680569, min_days: 2, max_days: 3 },
{ pincode: 680570, min_days: 2, max_days: 3 },
{ pincode: 680571, min_days: 2, max_days: 3 },
{ pincode: 680572, min_days: 3, max_days: 4 },
{ pincode: 680573, min_days: 3, max_days: 4 },
{ pincode: 680574, min_days: 3, max_days: 4 },
{ pincode: 680575, min_days: 3, max_days: 4 },
{ pincode: 680581, min_days: 2, max_days: 3 },
{ pincode: 680582, min_days: 2, max_days: 3 },
{ pincode: 680583, min_days: 2, max_days: 3 },
{ pincode: 680584, min_days: 2, max_days: 3 },
{ pincode: 680585, min_days: 2, max_days: 3 },
{ pincode: 680586, min_days: 2, max_days: 3 },
{ pincode: 680587, min_days: 2, max_days: 3 },
{ pincode: 680588, min_days: 2, max_days: 3 },
{ pincode: 680589, min_days: 2, max_days: 3 },
{ pincode: 680590, min_days: 2, max_days: 3 },
{ pincode: 680591, min_days: 2, max_days: 3 },
{ pincode: 680592, min_days: 3, max_days: 4 },
{ pincode: 680593, min_days: 3, max_days: 4 },
{ pincode: 680594, min_days: 2, max_days: 3 },
{ pincode: 680595, min_days: 3, max_days: 4 },
{ pincode: 680596, min_days: 2, max_days: 3 },
{ pincode: 680597, min_days: 3, max_days: 4 },
{ pincode: 680600, min_days: 3, max_days: 4 },
{ pincode: 680601, min_days: 2, max_days: 3 },
{ pincode: 680602, min_days: 2, max_days: 3 },
{ pincode: 680603, min_days: 3, max_days: 4 },
{ pincode: 680604, min_days: 2, max_days: 3 },
{ pincode: 680608, min_days: 3, max_days: 4 },
{ pincode: 680609, min_days: 3, max_days: 4 },
{ pincode: 680610, min_days: 3, max_days: 4 },
{ pincode: 680611, min_days: 2, max_days: 3 },
{ pincode: 680612, min_days: 2, max_days: 3 },
{ pincode: 680613, min_days: 2, max_days: 3 },
{ pincode: 680614, min_days: 2, max_days: 3 },
{ pincode: 680615, min_days: 2, max_days: 3 },
{ pincode: 680616, min_days: 2, max_days: 3 },
{ pincode: 680617, min_days: 2, max_days: 3 },
{ pincode: 680618, min_days: 2, max_days: 3 },
{ pincode: 680619, min_days: 2, max_days: 3 },
{ pincode: 680620, min_days: 2, max_days: 3 },
{ pincode: 680621, min_days: 3, max_days: 4 },
{ pincode: 680623, min_days: 2, max_days: 3 },
{ pincode: 680631, min_days: 2, max_days: 3 },
{ pincode: 680641, min_days: 2, max_days: 3 },
{ pincode: 680642, min_days: 2, max_days: 3 },
{ pincode: 680651, min_days: 2, max_days: 3 },
{ pincode: 680652, min_days: 2, max_days: 3 },
{ pincode: 680653, min_days: 2, max_days: 3 },
{ pincode: 680654, min_days: 2, max_days: 3 },
{ pincode: 680655, min_days: 2, max_days: 3 },
{ pincode: 680656, min_days: 2, max_days: 3 },
{ pincode: 680657, min_days: 3, max_days: 4 },
{ pincode: 680661, min_days: 2, max_days: 3 },
{ pincode: 680662, min_days: 2, max_days: 3 },
{ pincode: 680663, min_days: 2, max_days: 3 },
{ pincode: 680664, min_days: 2, max_days: 3 },
{ pincode: 680665, min_days: 2, max_days: 3 },
{ pincode: 680666, min_days: 2, max_days: 3 },
{ pincode: 680667, min_days: 2, max_days: 3 },
{ pincode: 680668, min_days: 2, max_days: 3 },
{ pincode: 680669, min_days: 2, max_days: 3 },
{ pincode: 680670, min_days: 2, max_days: 3 },
{ pincode: 680671, min_days: 2, max_days: 3 },
{ pincode: 680672, min_days: 3, max_days: 4 },
{ pincode: 680673, min_days: 3, max_days: 4 },
{ pincode: 680681, min_days: 2, max_days: 3 },
{ pincode: 680682, min_days: 2, max_days: 3 },
{ pincode: 680683, min_days: 2, max_days: 3 },
{ pincode: 680684, min_days: 2, max_days: 3 },
{ pincode: 680685, min_days: 2, max_days: 3 },
{ pincode: 680686, min_days: 2, max_days: 3 },
{ pincode: 680687, min_days: 2, max_days: 3 },
{ pincode: 680688, min_days: 2, max_days: 3 },
{ pincode: 680689, min_days: 2, max_days: 3 },
{ pincode: 680691, min_days: 2, max_days: 3 },
{ pincode: 680692, min_days: 3, max_days: 4 },
{ pincode: 680693, min_days: 3, max_days: 4 },
{ pincode: 680694, min_days: 3, max_days: 4 },
{ pincode: 680695, min_days: 3, max_days: 4 },
{ pincode: 680697, min_days: 2, max_days: 3 },
{ pincode: 680698, min_days: 3, max_days: 4 },
{ pincode: 680699, min_days: 2, max_days: 3 },
{ pincode: 680701, min_days: 2, max_days: 3 },
{ pincode: 680702, min_days: 2, max_days: 3 },
{ pincode: 680703, min_days: 2, max_days: 3 },
{ pincode: 680704, min_days: 3, max_days: 4 },
{ pincode: 680711, min_days: 2, max_days: 3 },
{ pincode: 680712, min_days: 2, max_days: 3 },
{ pincode: 680721, min_days: 2, max_days: 3 },
{ pincode: 680722, min_days: 2, max_days: 3 },
{ pincode: 680724, min_days: 2, max_days: 3 },
{ pincode: 680731, min_days: 2, max_days: 3 },
{ pincode: 680732, min_days: 2, max_days: 3 },
{ pincode: 680733, min_days: 2, max_days: 3 },
{ pincode: 680734, min_days: 2, max_days: 3 },
{ pincode: 680735, min_days: 3, max_days: 4 },
{ pincode: 680736, min_days: 3, max_days: 4 },
{ pincode: 680741, min_days: 2, max_days: 3 },
{ pincode: 680751, min_days: 2, max_days: 3 },
{ pincode: 680752, min_days: 3, max_days: 4 },
{ pincode: 680771, min_days: 3, max_days: 4 },
{ pincode: 681029, min_days: 3, max_days: 4 },
{ pincode: 682000, min_days: 3, max_days: 4 },
{ pincode: 682001, min_days: 2, max_days: 3 },
{ pincode: 682002, min_days: 2, max_days: 3 },
{ pincode: 682003, min_days: 2, max_days: 3 },
{ pincode: 682004, min_days: 2, max_days: 3 },
{ pincode: 682005, min_days: 2, max_days: 3 },
{ pincode: 682006, min_days: 2, max_days: 3 },
{ pincode: 682007, min_days: 2, max_days: 3 },
{ pincode: 682008, min_days: 2, max_days: 3 },
{ pincode: 682009, min_days: 2, max_days: 3 },
{ pincode: 682010, min_days: 2, max_days: 3 },
{ pincode: 682011, min_days: 2, max_days: 3 },
{ pincode: 682012, min_days: 2, max_days: 3 },
{ pincode: 682013, min_days: 2, max_days: 3 },
{ pincode: 682014, min_days: 3, max_days: 4 },
{ pincode: 682015, min_days: 2, max_days: 3 },
{ pincode: 682016, min_days: 2, max_days: 3 },
{ pincode: 682017, min_days: 2, max_days: 3 },
{ pincode: 682018, min_days: 2, max_days: 3 },
{ pincode: 682019, min_days: 2, max_days: 3 },
{ pincode: 682020, min_days: 2, max_days: 3 },
{ pincode: 682021, min_days: 2, max_days: 3 },
{ pincode: 682022, min_days: 2, max_days: 3 },
{ pincode: 682023, min_days: 2, max_days: 3 },
{ pincode: 682024, min_days: 2, max_days: 3 },
{ pincode: 682025, min_days: 2, max_days: 3 },
{ pincode: 682026, min_days: 2, max_days: 3 },
{ pincode: 682027, min_days: 2, max_days: 3 },
{ pincode: 682028, min_days: 2, max_days: 3 },
{ pincode: 682029, min_days: 2, max_days: 3 },
{ pincode: 682030, min_days: 2, max_days: 3 },
{ pincode: 682031, min_days: 2, max_days: 3 },
{ pincode: 682032, min_days: 2, max_days: 3 },
{ pincode: 682033, min_days: 2, max_days: 3 },
{ pincode: 682034, min_days: 2, max_days: 3 },
{ pincode: 682035, min_days: 2, max_days: 3 },
{ pincode: 682036, min_days: 2, max_days: 3 },
{ pincode: 682037, min_days: 2, max_days: 3 },
{ pincode: 682038, min_days: 2, max_days: 3 },
{ pincode: 682039, min_days: 2, max_days: 3 },
{ pincode: 682040, min_days: 2, max_days: 3 },
{ pincode: 682041, min_days: 2, max_days: 3 },
{ pincode: 682042, min_days: 2, max_days: 3 },
{ pincode: 682050, min_days: 2, max_days: 3 },
{ pincode: 682051, min_days: 2, max_days: 3 },
{ pincode: 682052, min_days: 2, max_days: 3 },
{ pincode: 682301, min_days: 2, max_days: 3 },
{ pincode: 682302, min_days: 2, max_days: 3 },
{ pincode: 682303, min_days: 2, max_days: 3 },
{ pincode: 682304, min_days: 2, max_days: 3 },
{ pincode: 682305, min_days: 2, max_days: 3 },
{ pincode: 682306, min_days: 2, max_days: 3 },
{ pincode: 682307, min_days: 2, max_days: 3 },
{ pincode: 682308, min_days: 2, max_days: 3 },
{ pincode: 682309, min_days: 2, max_days: 3 },
{ pincode: 682310, min_days: 2, max_days: 3 },
{ pincode: 682311, min_days: 2, max_days: 3 },
{ pincode: 682312, min_days: 2, max_days: 3 },
{ pincode: 682313, min_days: 2, max_days: 3 },
{ pincode: 682314, min_days: 2, max_days: 3 },
{ pincode: 682315, min_days: 2, max_days: 3 },
{ pincode: 682316, min_days: 2, max_days: 3 },
{ pincode: 682317, min_days: 2, max_days: 3 },
{ pincode: 682319, min_days: 3, max_days: 4 },
{ pincode: 682320, min_days: 3, max_days: 4 },
{ pincode: 682501, min_days: 2, max_days: 3 },
{ pincode: 682502, min_days: 2, max_days: 3 },
{ pincode: 682503, min_days: 2, max_days: 3 },
{ pincode: 682504, min_days: 2, max_days: 3 },
{ pincode: 682505, min_days: 2, max_days: 3 },
{ pincode: 682506, min_days: 2, max_days: 3 },
{ pincode: 682507, min_days: 2, max_days: 3 },
{ pincode: 682508, min_days: 2, max_days: 3 },
{ pincode: 682509, min_days: 2, max_days: 3 },
{ pincode: 682510, min_days: 3, max_days: 4 },
{ pincode: 682511, min_days: 2, max_days: 3 },
{ pincode: 682551, min_days: 2, max_days: 3 },
{ pincode: 682552, min_days: 2, max_days: 3 },
{ pincode: 682553, min_days: 2, max_days: 3 },
{ pincode: 682554, min_days: 2, max_days: 3 },
{ pincode: 682555, min_days: 2, max_days: 3 },
{ pincode: 682556, min_days: 2, max_days: 3 },
{ pincode: 682557, min_days: 2, max_days: 3 },
{ pincode: 682558, min_days: 2, max_days: 3 },
{ pincode: 682559, min_days: 2, max_days: 3 },
{ pincode: 683001, min_days: 3, max_days: 4 },
{ pincode: 683101, min_days: 2, max_days: 3 },
{ pincode: 683102, min_days: 2, max_days: 3 },
{ pincode: 683103, min_days: 3, max_days: 4 },
{ pincode: 683104, min_days: 2, max_days: 3 },
{ pincode: 683105, min_days: 2, max_days: 3 },
{ pincode: 683106, min_days: 2, max_days: 3 },
{ pincode: 683107, min_days: 3, max_days: 4 },
{ pincode: 683108, min_days: 2, max_days: 3 },
{ pincode: 683109, min_days: 3, max_days: 4 },
{ pincode: 683110, min_days: 2, max_days: 3 },
{ pincode: 683111, min_days: 2, max_days: 3 },
{ pincode: 683112, min_days: 2, max_days: 3 },
{ pincode: 683302, min_days: 3, max_days: 4 },
{ pincode: 683303, min_days: 3, max_days: 4 },
{ pincode: 683501, min_days: 2, max_days: 3 },
{ pincode: 683502, min_days: 2, max_days: 3 },
{ pincode: 683503, min_days: 2, max_days: 3 },
{ pincode: 683504, min_days: 3, max_days: 4 },
{ pincode: 683511, min_days: 2, max_days: 3 },
{ pincode: 683512, min_days: 2, max_days: 3 },
{ pincode: 683513, min_days: 2, max_days: 3 },
{ pincode: 683514, min_days: 2, max_days: 3 },
{ pincode: 683515, min_days: 2, max_days: 3 },
{ pincode: 683516, min_days: 2, max_days: 3 },
{ pincode: 683517, min_days: 2, max_days: 3 },
{ pincode: 683518, min_days: 2, max_days: 3 },
{ pincode: 683519, min_days: 2, max_days: 3 },
{ pincode: 683520, min_days: 2, max_days: 3 },
{ pincode: 683521, min_days: 2, max_days: 3 },
{ pincode: 683522, min_days: 2, max_days: 3 },
{ pincode: 683523, min_days: 3, max_days: 4 },
{ pincode: 683524, min_days: 3, max_days: 4 },
{ pincode: 683525, min_days: 3, max_days: 4 },
{ pincode: 683541, min_days: 2, max_days: 3 },
{ pincode: 683542, min_days: 2, max_days: 3 },
{ pincode: 683543, min_days: 2, max_days: 3 },
{ pincode: 683544, min_days: 2, max_days: 3 },
{ pincode: 683545, min_days: 2, max_days: 3 },
{ pincode: 683546, min_days: 2, max_days: 3 },
{ pincode: 683547, min_days: 2, max_days: 3 },
{ pincode: 683548, min_days: 2, max_days: 3 },
{ pincode: 683549, min_days: 2, max_days: 3 },
{ pincode: 683550, min_days: 2, max_days: 3 },
{ pincode: 683553, min_days: 3, max_days: 4 },
{ pincode: 683554, min_days: 3, max_days: 4 },
{ pincode: 683555, min_days: 3, max_days: 4 },
{ pincode: 683556, min_days: 2, max_days: 3 },
{ pincode: 683557, min_days: 3, max_days: 4 },
{ pincode: 683561, min_days: 2, max_days: 3 },
{ pincode: 683562, min_days: 2, max_days: 3 },
{ pincode: 683563, min_days: 2, max_days: 3 },
{ pincode: 683564, min_days: 3, max_days: 4 },
{ pincode: 683565, min_days: 2, max_days: 3 },
{ pincode: 683571, min_days: 2, max_days: 3 },
{ pincode: 683572, min_days: 2, max_days: 3 },
{ pincode: 683573, min_days: 2, max_days: 3 },
{ pincode: 683574, min_days: 2, max_days: 3 },
{ pincode: 683575, min_days: 2, max_days: 3 },
{ pincode: 683576, min_days: 2, max_days: 3 },
{ pincode: 683577, min_days: 2, max_days: 3 },
{ pincode: 683578, min_days: 2, max_days: 3 },
{ pincode: 683579, min_days: 2, max_days: 3 },
{ pincode: 683580, min_days: 2, max_days: 3 },
{ pincode: 683581, min_days: 2, max_days: 3 },
{ pincode: 683582, min_days: 3, max_days: 4 },
{ pincode: 683583, min_days: 3, max_days: 4 },
{ pincode: 683584, min_days: 3, max_days: 4 },
{ pincode: 683585, min_days: 2, max_days: 3 },
{ pincode: 683586, min_days: 3, max_days: 4 },
{ pincode: 683587, min_days: 2, max_days: 3 },
{ pincode: 683589, min_days: 2, max_days: 3 },
{ pincode: 683591, min_days: 3, max_days: 4 },
{ pincode: 683592, min_days: 3, max_days: 4 },
{ pincode: 683593, min_days: 3, max_days: 4 },
{ pincode: 683594, min_days: 2, max_days: 3 },
{ pincode: 685005, min_days: 3, max_days: 4 },
{ pincode: 685501, min_days: 2, max_days: 3 },
{ pincode: 685503, min_days: 2, max_days: 3 },
{ pincode: 685505, min_days: 2, max_days: 3 },
{ pincode: 685506, min_days: 3, max_days: 4 },
{ pincode: 685507, min_days: 2, max_days: 3 },
{ pincode: 685508, min_days: 2, max_days: 3 },
{ pincode: 685509, min_days: 2, max_days: 3 },
{ pincode: 685510, min_days: 3, max_days: 4 },
{ pincode: 685511, min_days: 2, max_days: 3 },
{ pincode: 685512, min_days: 2, max_days: 3 },
{ pincode: 685514, min_days: 2, max_days: 3 },
{ pincode: 685515, min_days: 2, max_days: 3 },
{ pincode: 685518, min_days: 3, max_days: 4 },
{ pincode: 685531, min_days: 2, max_days: 3 },
{ pincode: 685532, min_days: 2, max_days: 3 },
{ pincode: 685533, min_days: 2, max_days: 3 },
{ pincode: 685535, min_days: 2, max_days: 3 },
{ pincode: 685536, min_days: 3, max_days: 4 },
{ pincode: 685537, min_days: 3, max_days: 4 },
{ pincode: 685538, min_days: 3, max_days: 4 },
{ pincode: 685539, min_days: 3, max_days: 4 },
{ pincode: 685551, min_days: 2, max_days: 3 },
{ pincode: 685552, min_days: 2, max_days: 3 },
{ pincode: 685553, min_days: 2, max_days: 3 },
{ pincode: 685554, min_days: 2, max_days: 3 },
{ pincode: 685556, min_days: 3, max_days: 4 },
{ pincode: 685561, min_days: 2, max_days: 3 },
{ pincode: 685562, min_days: 2, max_days: 3 },
{ pincode: 685563, min_days: 2, max_days: 3 },
{ pincode: 685564, min_days: 3, max_days: 4 },
{ pincode: 685565, min_days: 2, max_days: 3 },
{ pincode: 685566, min_days: 2, max_days: 3 },
{ pincode: 685571, min_days: 2, max_days: 3 },
{ pincode: 685581, min_days: 2, max_days: 3 },
{ pincode: 685582, min_days: 2, max_days: 3 },
{ pincode: 685583, min_days: 2, max_days: 3 },
{ pincode: 685584, min_days: 2, max_days: 3 },
{ pincode: 685585, min_days: 2, max_days: 3 },
{ pincode: 685586, min_days: 2, max_days: 3 },
{ pincode: 685587, min_days: 2, max_days: 3 },
{ pincode: 685588, min_days: 2, max_days: 3 },
{ pincode: 685589, min_days: 2, max_days: 3 },
{ pincode: 685590, min_days: 2, max_days: 3 },
{ pincode: 685591, min_days: 2, max_days: 3 },
{ pincode: 685592, min_days: 3, max_days: 4 },
{ pincode: 685595, min_days: 2, max_days: 3 },
{ pincode: 685597, min_days: 3, max_days: 4 },
{ pincode: 685601, min_days: 2, max_days: 3 },
{ pincode: 685602, min_days: 2, max_days: 3 },
{ pincode: 685603, min_days: 2, max_days: 3 },
{ pincode: 685604, min_days: 2, max_days: 3 },
{ pincode: 685605, min_days: 2, max_days: 3 },
{ pincode: 685606, min_days: 2, max_days: 3 },
{ pincode: 685607, min_days: 2, max_days: 3 },
{ pincode: 685608, min_days: 2, max_days: 3 },
{ pincode: 685609, min_days: 2, max_days: 3 },
{ pincode: 685611, min_days: 3, max_days: 4 },
{ pincode: 685612, min_days: 2, max_days: 3 },
{ pincode: 685613, min_days: 2, max_days: 3 },
{ pincode: 685614, min_days: 2, max_days: 3 },
{ pincode: 685615, min_days: 2, max_days: 3 },
{ pincode: 685616, min_days: 2, max_days: 3 },
{ pincode: 685618, min_days: 2, max_days: 3 },
{ pincode: 685619, min_days: 2, max_days: 3 },
{ pincode: 685620, min_days: 2, max_days: 3 },
{ pincode: 685621, min_days: 3, max_days: 4 },
{ pincode: 686001, min_days: 2, max_days: 3 },
{ pincode: 686002, min_days: 2, max_days: 3 },
{ pincode: 686003, min_days: 2, max_days: 3 },
{ pincode: 686004, min_days: 2, max_days: 3 },
{ pincode: 686005, min_days: 2, max_days: 3 },
{ pincode: 686006, min_days: 2, max_days: 3 },
{ pincode: 686007, min_days: 2, max_days: 3 },
{ pincode: 686008, min_days: 2, max_days: 3 },
{ pincode: 686009, min_days: 2, max_days: 3 },
{ pincode: 686010, min_days: 2, max_days: 3 },
{ pincode: 686011, min_days: 2, max_days: 3 },
{ pincode: 686012, min_days: 2, max_days: 3 },
{ pincode: 686013, min_days: 2, max_days: 3 },
{ pincode: 686014, min_days: 2, max_days: 3 },
{ pincode: 686015, min_days: 2, max_days: 3 },
{ pincode: 686016, min_days: 2, max_days: 3 },
{ pincode: 686017, min_days: 2, max_days: 3 },
{ pincode: 686018, min_days: 2, max_days: 3 },
{ pincode: 686019, min_days: 2, max_days: 3 },
{ pincode: 686020, min_days: 2, max_days: 3 },
{ pincode: 686021, min_days: 2, max_days: 3 },
{ pincode: 686022, min_days: 2, max_days: 3 },
{ pincode: 686023, min_days: 3, max_days: 4 },
{ pincode: 686024, min_days: 3, max_days: 4 },
{ pincode: 686025, min_days: 3, max_days: 4 },
{ pincode: 686026, min_days: 3, max_days: 4 },
{ pincode: 686027, min_days: 3, max_days: 4 },
{ pincode: 686028, min_days: 3, max_days: 4 },
{ pincode: 686029, min_days: 3, max_days: 4 },
{ pincode: 686030, min_days: 3, max_days: 4 },
{ pincode: 686031, min_days: 3, max_days: 4 },
{ pincode: 686032, min_days: 3, max_days: 4 },
{ pincode: 686033, min_days: 3, max_days: 4 },
{ pincode: 686034, min_days: 3, max_days: 4 },
{ pincode: 686035, min_days: 3, max_days: 4 },
{ pincode: 686036, min_days: 3, max_days: 4 },
{ pincode: 686037, min_days: 3, max_days: 4 },
{ pincode: 686038, min_days: 3, max_days: 4 },
{ pincode: 686039, min_days: 3, max_days: 4 },
{ pincode: 686040, min_days: 3, max_days: 4 },
{ pincode: 686041, min_days: 2, max_days: 3 },
{ pincode: 686101, min_days: 2, max_days: 3 },
{ pincode: 686102, min_days: 2, max_days: 3 },
{ pincode: 686103, min_days: 2, max_days: 3 },
{ pincode: 686104, min_days: 2, max_days: 3 },
{ pincode: 686105, min_days: 2, max_days: 3 },
{ pincode: 686106, min_days: 2, max_days: 3 },
{ pincode: 686107, min_days: 3, max_days: 4 },
{ pincode: 686108, min_days: 3, max_days: 4 },
{ pincode: 686121, min_days: 2, max_days: 3 },
{ pincode: 686122, min_days: 2, max_days: 3 },
{ pincode: 686123, min_days: 2, max_days: 3 },
{ pincode: 686124, min_days: 3, max_days: 4 },
{ pincode: 686141, min_days: 2, max_days: 3 },
{ pincode: 686142, min_days: 3, max_days: 4 },
{ pincode: 686143, min_days: 2, max_days: 3 },
{ pincode: 686144, min_days: 2, max_days: 3 },
{ pincode: 686145, min_days: 3, max_days: 4 },
{ pincode: 686146, min_days: 2, max_days: 3 },
{ pincode: 686307, min_days: 3, max_days: 4 },
{ pincode: 686501, min_days: 2, max_days: 3 },
{ pincode: 686502, min_days: 2, max_days: 3 },
{ pincode: 686503, min_days: 2, max_days: 3 },
{ pincode: 686504, min_days: 2, max_days: 3 },
{ pincode: 686505, min_days: 2, max_days: 3 },
{ pincode: 686506, min_days: 2, max_days: 3 },
{ pincode: 686507, min_days: 2, max_days: 3 },
{ pincode: 686508, min_days: 2, max_days: 3 },
{ pincode: 686509, min_days: 2, max_days: 3 },
{ pincode: 686510, min_days: 2, max_days: 3 },
{ pincode: 686511, min_days: 2, max_days: 3 },
{ pincode: 686512, min_days: 2, max_days: 3 },
{ pincode: 686513, min_days: 2, max_days: 3 },
{ pincode: 686514, min_days: 2, max_days: 3 },
{ pincode: 686515, min_days: 2, max_days: 3 },
{ pincode: 686516, min_days: 2, max_days: 3 },
{ pincode: 686517, min_days: 2, max_days: 3 },
{ pincode: 686518, min_days: 2, max_days: 3 },
{ pincode: 686519, min_days: 2, max_days: 3 },
{ pincode: 686520, min_days: 2, max_days: 3 },
{ pincode: 686521, min_days: 2, max_days: 3 },
{ pincode: 686522, min_days: 2, max_days: 3 },
{ pincode: 686523, min_days: 3, max_days: 4 },
{ pincode: 686524, min_days: 3, max_days: 4 },
{ pincode: 686527, min_days: 3, max_days: 4 },
{ pincode: 686531, min_days: 2, max_days: 3 },
{ pincode: 686532, min_days: 2, max_days: 3 },
{ pincode: 686533, min_days: 2, max_days: 3 },
{ pincode: 686534, min_days: 2, max_days: 3 },
{ pincode: 686535, min_days: 2, max_days: 3 },
{ pincode: 686536, min_days: 2, max_days: 3 },
{ pincode: 686537, min_days: 2, max_days: 3 },
{ pincode: 686538, min_days: 2, max_days: 3 },
{ pincode: 686539, min_days: 2, max_days: 3 },
{ pincode: 686540, min_days: 2, max_days: 3 },
{ pincode: 686541, min_days: 2, max_days: 3 },
{ pincode: 686542, min_days: 2, max_days: 3 },
{ pincode: 686543, min_days: 2, max_days: 3 },
{ pincode: 686544, min_days: 2, max_days: 3 },
{ pincode: 686545, min_days: 2, max_days: 3 },
{ pincode: 686546, min_days: 2, max_days: 3 },
{ pincode: 686547, min_days: 2, max_days: 3 },
{ pincode: 686548, min_days: 2, max_days: 3 },
{ pincode: 686549, min_days: 3, max_days: 4 },
{ pincode: 686550, min_days: 3, max_days: 4 },
{ pincode: 686552, min_days: 3, max_days: 4 },
{ pincode: 686553, min_days: 3, max_days: 4 },
{ pincode: 686555, min_days: 2, max_days: 3 },
{ pincode: 686560, min_days: 2, max_days: 3 },
{ pincode: 686561, min_days: 2, max_days: 3 },
{ pincode: 686562, min_days: 2, max_days: 3 },
{ pincode: 686563, min_days: 2, max_days: 3 },
{ pincode: 686564, min_days: 2, max_days: 3 },
{ pincode: 686565, min_days: 3, max_days: 4 },
{ pincode: 686566, min_days: 3, max_days: 4 },
{ pincode: 686568, min_days: 3, max_days: 4 },
{ pincode: 686571, min_days: 2, max_days: 3 },
{ pincode: 686572, min_days: 2, max_days: 3 },
{ pincode: 686573, min_days: 2, max_days: 3 },
{ pincode: 686574, min_days: 2, max_days: 3 },
{ pincode: 686575, min_days: 2, max_days: 3 },
{ pincode: 686576, min_days: 2, max_days: 3 },
{ pincode: 686577, min_days: 2, max_days: 3 },
{ pincode: 686578, min_days: 2, max_days: 3 },
{ pincode: 686579, min_days: 2, max_days: 3 },
{ pincode: 686580, min_days: 2, max_days: 3 },
{ pincode: 686581, min_days: 2, max_days: 3 },
{ pincode: 686582, min_days: 2, max_days: 3 },
{ pincode: 686583, min_days: 2, max_days: 3 },
{ pincode: 686584, min_days: 2, max_days: 3 },
{ pincode: 686585, min_days: 2, max_days: 3 },
{ pincode: 686586, min_days: 2, max_days: 3 },
{ pincode: 686587, min_days: 2, max_days: 3 },
{ pincode: 686588, min_days: 3, max_days: 4 },
{ pincode: 686589, min_days: 3, max_days: 4 },
{ pincode: 686590, min_days: 3, max_days: 4 },
{ pincode: 686591, min_days: 3, max_days: 4 },
{ pincode: 686592, min_days: 3, max_days: 4 },
{ pincode: 686594, min_days: 3, max_days: 4 },
{ pincode: 686595, min_days: 3, max_days: 4 },
{ pincode: 686597, min_days: 3, max_days: 4 },
{ pincode: 686600, min_days: 3, max_days: 4 },
{ pincode: 686601, min_days: 2, max_days: 3 },
{ pincode: 686602, min_days: 2, max_days: 3 },
{ pincode: 686603, min_days: 2, max_days: 3 },
{ pincode: 686604, min_days: 2, max_days: 3 },
{ pincode: 686605, min_days: 2, max_days: 3 },
{ pincode: 686606, min_days: 2, max_days: 3 },
{ pincode: 686607, min_days: 2, max_days: 3 },
{ pincode: 686608, min_days: 2, max_days: 3 },
{ pincode: 686609, min_days: 2, max_days: 3 },
{ pincode: 686610, min_days: 2, max_days: 3 },
{ pincode: 686611, min_days: 2, max_days: 3 },
{ pincode: 686612, min_days: 2, max_days: 3 },
{ pincode: 686613, min_days: 2, max_days: 3 },
{ pincode: 686614, min_days: 3, max_days: 4 },
{ pincode: 686615, min_days: 3, max_days: 4 },
{ pincode: 686616, min_days: 2, max_days: 3 },
{ pincode: 686617, min_days: 3, max_days: 4 },
{ pincode: 686620, min_days: 3, max_days: 4 },
{ pincode: 686627, min_days: 3, max_days: 4 },
{ pincode: 686630, min_days: 2, max_days: 3 },
{ pincode: 686631, min_days: 2, max_days: 3 },
{ pincode: 686632, min_days: 2, max_days: 3 },
{ pincode: 686633, min_days: 2, max_days: 3 },
{ pincode: 686634, min_days: 2, max_days: 3 },
{ pincode: 686635, min_days: 2, max_days: 3 },
{ pincode: 686636, min_days: 2, max_days: 3 },
{ pincode: 686637, min_days: 2, max_days: 3 },
{ pincode: 686638, min_days: 3, max_days: 4 },
{ pincode: 686640, min_days: 3, max_days: 4 },
{ pincode: 686641, min_days: 3, max_days: 4 },
{ pincode: 686642, min_days: 3, max_days: 4 },
{ pincode: 686651, min_days: 2, max_days: 3 },
{ pincode: 686652, min_days: 2, max_days: 3 },
{ pincode: 686653, min_days: 2, max_days: 3 },
{ pincode: 686654, min_days: 3, max_days: 4 },
{ pincode: 686655, min_days: 3, max_days: 4 },
{ pincode: 686661, min_days: 2, max_days: 3 },
{ pincode: 686662, min_days: 2, max_days: 3 },
{ pincode: 686663, min_days: 2, max_days: 3 },
{ pincode: 686664, min_days: 2, max_days: 3 },
{ pincode: 686665, min_days: 2, max_days: 3 },
{ pincode: 686666, min_days: 2, max_days: 3 },
{ pincode: 686667, min_days: 2, max_days: 3 },
{ pincode: 686668, min_days: 2, max_days: 3 },
{ pincode: 686669, min_days: 2, max_days: 3 },
{ pincode: 686670, min_days: 2, max_days: 3 },
{ pincode: 686671, min_days: 2, max_days: 3 },
{ pincode: 686672, min_days: 2, max_days: 3 },
{ pincode: 686673, min_days: 2, max_days: 3 },
{ pincode: 686674, min_days: 3, max_days: 4 },
{ pincode: 686676, min_days: 3, max_days: 4 },
{ pincode: 686677, min_days: 3, max_days: 4 },
{ pincode: 686679, min_days: 3, max_days: 4 },
{ pincode: 686680, min_days: 3, max_days: 4 },
{ pincode: 686681, min_days: 2, max_days: 3 },
{ pincode: 686683, min_days: 3, max_days: 4 },
{ pincode: 686686, min_days: 3, max_days: 4 },
{ pincode: 686687, min_days: 3, max_days: 4 },
{ pincode: 686689, min_days: 3, max_days: 4 },
{ pincode: 686691, min_days: 2, max_days: 3 },
{ pincode: 686692, min_days: 2, max_days: 3 },
{ pincode: 686693, min_days: 2, max_days: 3 },
{ pincode: 686694, min_days: 3, max_days: 4 },
{ pincode: 686695, min_days: 3, max_days: 4 },
{ pincode: 686696, min_days: 3, max_days: 4 },
{ pincode: 686697, min_days: 3, max_days: 4 },
{ pincode: 686698, min_days: 3, max_days: 4 },
{ pincode: 686702, min_days: 3, max_days: 4 },
{ pincode: 686721, min_days: 3, max_days: 4 },
{ pincode: 686722, min_days: 3, max_days: 4 },
{ pincode: 686723, min_days: 3, max_days: 4 },
{ pincode: 686726, min_days: 3, max_days: 4 },
{ pincode: 686730, min_days: 3, max_days: 4 },
{ pincode: 688001, min_days: 2, max_days: 3 },
{ pincode: 688002, min_days: 2, max_days: 3 },
{ pincode: 688003, min_days: 2, max_days: 3 },
{ pincode: 688004, min_days: 2, max_days: 3 },
{ pincode: 688005, min_days: 2, max_days: 3 },
{ pincode: 688006, min_days: 2, max_days: 3 },
{ pincode: 688007, min_days: 2, max_days: 3 },
{ pincode: 688008, min_days: 2, max_days: 3 },
{ pincode: 688009, min_days: 2, max_days: 3 },
{ pincode: 688010, min_days: 3, max_days: 4 },
{ pincode: 688011, min_days: 2, max_days: 3 },
{ pincode: 688012, min_days: 2, max_days: 3 },
{ pincode: 688013, min_days: 2, max_days: 3 },
{ pincode: 688014, min_days: 2, max_days: 3 },
{ pincode: 688016, min_days: 3, max_days: 4 },
{ pincode: 688017, min_days: 3, max_days: 4 },
{ pincode: 688020, min_days: 3, max_days: 4 },
{ pincode: 688022, min_days: 3, max_days: 4 },
{ pincode: 688028, min_days: 3, max_days: 4 },
{ pincode: 688029, min_days: 3, max_days: 4 },
{ pincode: 688042, min_days: 3, max_days: 4 },
{ pincode: 688101, min_days: 3, max_days: 4 },
{ pincode: 688501, min_days: 2, max_days: 3 },
{ pincode: 688502, min_days: 2, max_days: 3 },
{ pincode: 688503, min_days: 2, max_days: 3 },
{ pincode: 688504, min_days: 2, max_days: 3 },
{ pincode: 688505, min_days: 2, max_days: 3 },
{ pincode: 688506, min_days: 2, max_days: 3 },
{ pincode: 688507, min_days: 3, max_days: 4 },
{ pincode: 688508, min_days: 3, max_days: 4 },
{ pincode: 688509, min_days: 3, max_days: 4 },
{ pincode: 688511, min_days: 3, max_days: 4 },
{ pincode: 688512, min_days: 3, max_days: 4 },
{ pincode: 688521, min_days: 2, max_days: 3 },
{ pincode: 688522, min_days: 2, max_days: 3 },
{ pincode: 688523, min_days: 2, max_days: 3 },
{ pincode: 688524, min_days: 2, max_days: 3 },
{ pincode: 688525, min_days: 2, max_days: 3 },
{ pincode: 688526, min_days: 2, max_days: 3 },
{ pincode: 688527, min_days: 2, max_days: 3 },
{ pincode: 688528, min_days: 2, max_days: 3 },
{ pincode: 688529, min_days: 2, max_days: 3 },
{ pincode: 688530, min_days: 2, max_days: 3 },
{ pincode: 688531, min_days: 2, max_days: 3 },
{ pincode: 688532, min_days: 2, max_days: 3 },
{ pincode: 688533, min_days: 2, max_days: 3 },
{ pincode: 688534, min_days: 2, max_days: 3 },
{ pincode: 688535, min_days: 2, max_days: 3 },
{ pincode: 688536, min_days: 2, max_days: 3 },
{ pincode: 688537, min_days: 2, max_days: 3 },
{ pincode: 688538, min_days: 2, max_days: 3 },
{ pincode: 688539, min_days: 2, max_days: 3 },
{ pincode: 688540, min_days: 2, max_days: 3 },
{ pincode: 688541, min_days: 2, max_days: 3 },
{ pincode: 688542, min_days: 3, max_days: 4 },
{ pincode: 688543, min_days: 3, max_days: 4 },
{ pincode: 688544, min_days: 3, max_days: 4 },
{ pincode: 688545, min_days: 3, max_days: 4 },
{ pincode: 688546, min_days: 3, max_days: 4 },
{ pincode: 688547, min_days: 3, max_days: 4 },
{ pincode: 688548, min_days: 3, max_days: 4 },
{ pincode: 688549, min_days: 3, max_days: 4 },
{ pincode: 688550, min_days: 3, max_days: 4 },
{ pincode: 688552, min_days: 3, max_days: 4 },
{ pincode: 688554, min_days: 3, max_days: 4 },
{ pincode: 688555, min_days: 2, max_days: 3 },
{ pincode: 688556, min_days: 3, max_days: 4 },
{ pincode: 688557, min_days: 3, max_days: 4 },
{ pincode: 688558, min_days: 3, max_days: 4 },
{ pincode: 688559, min_days: 3, max_days: 4 },
{ pincode: 688560, min_days: 3, max_days: 4 },
{ pincode: 688561, min_days: 2, max_days: 3 },
{ pincode: 688562, min_days: 2, max_days: 3 },
{ pincode: 688563, min_days: 3, max_days: 4 },
{ pincode: 688564, min_days: 3, max_days: 4 },
{ pincode: 688565, min_days: 3, max_days: 4 },
{ pincode: 688566, min_days: 3, max_days: 4 },
{ pincode: 688567, min_days: 3, max_days: 4 },
{ pincode: 688570, min_days: 2, max_days: 3 },
{ pincode: 688581, min_days: 3, max_days: 4 },
{ pincode: 688582, min_days: 2, max_days: 3 },
{ pincode: 688583, min_days: 3, max_days: 4 },
{ pincode: 688584, min_days: 3, max_days: 4 },
{ pincode: 688585, min_days: 3, max_days: 4 },
{ pincode: 688586, min_days: 3, max_days: 4 },
{ pincode: 688587, min_days: 3, max_days: 4 },
{ pincode: 688625, min_days: 3, max_days: 4 },
{ pincode: 688656, min_days: 3, max_days: 4 },
{ pincode: 689006, min_days: 2, max_days: 3 },
{ pincode: 689101, min_days: 2, max_days: 3 },
{ pincode: 689102, min_days: 2, max_days: 3 },
{ pincode: 689103, min_days: 2, max_days: 3 },
{ pincode: 689104, min_days: 2, max_days: 3 },
{ pincode: 689105, min_days: 2, max_days: 3 },
{ pincode: 689106, min_days: 2, max_days: 3 },
{ pincode: 689107, min_days: 2, max_days: 3 },
{ pincode: 689108, min_days: 2, max_days: 3 },
{ pincode: 689109, min_days: 2, max_days: 3 },
{ pincode: 689110, min_days: 2, max_days: 3 },
{ pincode: 689111, min_days: 2, max_days: 3 },
{ pincode: 689112, min_days: 2, max_days: 3 },
{ pincode: 689113, min_days: 2, max_days: 3 },
{ pincode: 689114, min_days: 3, max_days: 4 },
{ pincode: 689115, min_days: 2, max_days: 3 },
{ pincode: 689121, min_days: 2, max_days: 3 },
{ pincode: 689122, min_days: 2, max_days: 3 },
{ pincode: 689123, min_days: 2, max_days: 3 },
{ pincode: 689124, min_days: 2, max_days: 3 },
{ pincode: 689125, min_days: 3, max_days: 4 },
{ pincode: 689126, min_days: 2, max_days: 3 },
{ pincode: 689501, min_days: 2, max_days: 3 },
{ pincode: 689502, min_days: 2, max_days: 3 },
{ pincode: 689503, min_days: 2, max_days: 3 },
{ pincode: 689504, min_days: 2, max_days: 3 },
{ pincode: 689505, min_days: 2, max_days: 3 },
{ pincode: 689506, min_days: 2, max_days: 3 },
{ pincode: 689507, min_days: 2, max_days: 3 },
{ pincode: 689508, min_days: 2, max_days: 3 },
{ pincode: 689509, min_days: 2, max_days: 3 },
{ pincode: 689510, min_days: 2, max_days: 3 },
{ pincode: 689511, min_days: 2, max_days: 3 },
{ pincode: 689512, min_days: 2, max_days: 3 },
{ pincode: 689513, min_days: 2, max_days: 3 },
{ pincode: 689514, min_days: 2, max_days: 3 },
{ pincode: 689515, min_days: 2, max_days: 3 },
{ pincode: 689516, min_days: 3, max_days: 4 },
{ pincode: 689517, min_days: 3, max_days: 4 },
{ pincode: 689518, min_days: 3, max_days: 4 },
{ pincode: 689519, min_days: 3, max_days: 4 },
{ pincode: 689520, min_days: 2, max_days: 3 },
{ pincode: 689521, min_days: 2, max_days: 3 },
{ pincode: 689529, min_days: 3, max_days: 4 },
{ pincode: 689531, min_days: 2, max_days: 3 },
{ pincode: 689532, min_days: 2, max_days: 3 },
{ pincode: 689533, min_days: 2, max_days: 3 },
{ pincode: 689541, min_days: 2, max_days: 3 },
{ pincode: 689542, min_days: 2, max_days: 3 },
{ pincode: 689543, min_days: 2, max_days: 3 },
{ pincode: 689544, min_days: 2, max_days: 3 },
{ pincode: 689545, min_days: 2, max_days: 3 },
{ pincode: 689546, min_days: 2, max_days: 3 },
{ pincode: 689547, min_days: 2, max_days: 3 },
{ pincode: 689548, min_days: 2, max_days: 3 },
{ pincode: 689549, min_days: 2, max_days: 3 },
{ pincode: 689550, min_days: 2, max_days: 3 },
{ pincode: 689551, min_days: 2, max_days: 3 },
{ pincode: 689552, min_days: 3, max_days: 4 },
{ pincode: 689571, min_days: 2, max_days: 3 },
{ pincode: 689572, min_days: 2, max_days: 3 },
{ pincode: 689573, min_days: 2, max_days: 3 },
{ pincode: 689574, min_days: 2, max_days: 3 },
{ pincode: 689575, min_days: 3, max_days: 4 },
{ pincode: 689576, min_days: 3, max_days: 4 },
{ pincode: 689578, min_days: 3, max_days: 4 },
{ pincode: 689579, min_days: 3, max_days: 4 },
{ pincode: 689580, min_days: 3, max_days: 4 },
{ pincode: 689581, min_days: 2, max_days: 3 },
{ pincode: 689582, min_days: 2, max_days: 3 },
{ pincode: 689583, min_days: 2, max_days: 3 },
{ pincode: 689584, min_days: 2, max_days: 3 },
{ pincode: 689585, min_days: 2, max_days: 3 },
{ pincode: 689586, min_days: 2, max_days: 3 },
{ pincode: 689587, min_days: 2, max_days: 3 },
{ pincode: 689588, min_days: 2, max_days: 3 },
{ pincode: 689589, min_days: 2, max_days: 3 },
{ pincode: 689590, min_days: 2, max_days: 3 },
{ pincode: 689591, min_days: 2, max_days: 3 },
{ pincode: 689592, min_days: 2, max_days: 3 },
{ pincode: 689593, min_days: 3, max_days: 4 },
{ pincode: 689594, min_days: 2, max_days: 3 },
{ pincode: 689595, min_days: 2, max_days: 3 },
{ pincode: 689596, min_days: 3, max_days: 4 },
{ pincode: 689597, min_days: 2, max_days: 3 },
{ pincode: 689598, min_days: 3, max_days: 4 },
{ pincode: 689600, min_days: 3, max_days: 4 },
{ pincode: 689602, min_days: 2, max_days: 3 },
{ pincode: 689603, min_days: 3, max_days: 4 },
{ pincode: 689611, min_days: 2, max_days: 3 },
{ pincode: 689612, min_days: 2, max_days: 3 },
{ pincode: 689613, min_days: 2, max_days: 3 },
{ pincode: 689614, min_days: 2, max_days: 3 },
{ pincode: 689615, min_days: 2, max_days: 3 },
{ pincode: 689616, min_days: 3, max_days: 4 },
{ pincode: 689620, min_days: 3, max_days: 4 },
{ pincode: 689621, min_days: 2, max_days: 3 },
{ pincode: 689622, min_days: 2, max_days: 3 },
{ pincode: 689623, min_days: 2, max_days: 3 },
{ pincode: 689624, min_days: 2, max_days: 3 },
{ pincode: 689625, min_days: 2, max_days: 3 },
{ pincode: 689626, min_days: 2, max_days: 3 },
{ pincode: 689627, min_days: 2, max_days: 3 },
{ pincode: 689628, min_days: 3, max_days: 4 },
{ pincode: 689629, min_days: 3, max_days: 4 },
{ pincode: 689630, min_days: 3, max_days: 4 },
{ pincode: 689632, min_days: 3, max_days: 4 },
{ pincode: 689641, min_days: 2, max_days: 3 },
{ pincode: 689642, min_days: 2, max_days: 3 },
{ pincode: 689643, min_days: 2, max_days: 3 },
{ pincode: 689644, min_days: 2, max_days: 3 },
{ pincode: 689645, min_days: 2, max_days: 3 },
{ pincode: 689646, min_days: 2, max_days: 3 },
{ pincode: 689647, min_days: 2, max_days: 3 },
{ pincode: 689648, min_days: 2, max_days: 3 },
{ pincode: 689649, min_days: 2, max_days: 3 },
{ pincode: 689650, min_days: 2, max_days: 3 },
{ pincode: 689652, min_days: 2, max_days: 3 },
{ pincode: 689653, min_days: 2, max_days: 3 },
{ pincode: 689654, min_days: 2, max_days: 3 },
{ pincode: 689656, min_days: 2, max_days: 3 },
{ pincode: 689657, min_days: 3, max_days: 4 },
{ pincode: 689659, min_days: 3, max_days: 4 },
{ pincode: 689660, min_days: 3, max_days: 4 },
{ pincode: 689661, min_days: 2, max_days: 3 },
{ pincode: 689662, min_days: 2, max_days: 3 },
{ pincode: 689663, min_days: 2, max_days: 3 },
{ pincode: 689664, min_days: 2, max_days: 3 },
{ pincode: 689665, min_days: 3, max_days: 4 },
{ pincode: 689666, min_days: 2, max_days: 3 },
{ pincode: 689667, min_days: 2, max_days: 3 },
{ pincode: 689668, min_days: 2, max_days: 3 },
{ pincode: 689671, min_days: 2, max_days: 3 },
{ pincode: 689672, min_days: 2, max_days: 3 },
{ pincode: 689673, min_days: 2, max_days: 3 },
{ pincode: 689674, min_days: 2, max_days: 3 },
{ pincode: 689675, min_days: 2, max_days: 3 },
{ pincode: 689676, min_days: 2, max_days: 3 },
{ pincode: 689677, min_days: 2, max_days: 3 },
{ pincode: 689678, min_days: 2, max_days: 3 },
{ pincode: 689680, min_days: 3, max_days: 4 },
{ pincode: 689681, min_days: 3, max_days: 4 },
{ pincode: 689682, min_days: 3, max_days: 4 },
{ pincode: 689691, min_days: 2, max_days: 3 },
{ pincode: 689692, min_days: 2, max_days: 3 },
{ pincode: 689693, min_days: 2, max_days: 3 },
{ pincode: 689694, min_days: 2, max_days: 3 },
{ pincode: 689695, min_days: 2, max_days: 3 },
{ pincode: 689696, min_days: 2, max_days: 3 },
{ pincode: 689698, min_days: 2, max_days: 3 },
{ pincode: 689699, min_days: 2, max_days: 3 },
{ pincode: 689703, min_days: 3, max_days: 4 },
{ pincode: 689705, min_days: 3, max_days: 4 },
{ pincode: 689706, min_days: 3, max_days: 4 },
{ pincode: 689711, min_days: 2, max_days: 3 },
{ pincode: 689712, min_days: 3, max_days: 4 },
{ pincode: 689713, min_days: 3, max_days: 4 },
{ pincode: 689721, min_days: 3, max_days: 4 },
{ pincode: 689722, min_days: 3, max_days: 4 },
{ pincode: 689723, min_days: 3, max_days: 4 },
{ pincode: 689842, min_days: 3, max_days: 4 },
{ pincode: 690001, min_days: 3, max_days: 4 },
{ pincode: 690010, min_days: 3, max_days: 4 },
{ pincode: 690101, min_days: 2, max_days: 3 },
{ pincode: 690102, min_days: 2, max_days: 3 },
{ pincode: 690103, min_days: 2, max_days: 3 },
{ pincode: 690104, min_days: 2, max_days: 3 },
{ pincode: 690105, min_days: 2, max_days: 3 },
{ pincode: 690106, min_days: 2, max_days: 3 },
{ pincode: 690107, min_days: 2, max_days: 3 },
{ pincode: 690108, min_days: 2, max_days: 3 },
{ pincode: 690109, min_days: 3, max_days: 4 },
{ pincode: 690110, min_days: 2, max_days: 3 },
{ pincode: 690112, min_days: 2, max_days: 3 },
{ pincode: 690501, min_days: 2, max_days: 3 },
{ pincode: 690502, min_days: 2, max_days: 3 },
{ pincode: 690503, min_days: 2, max_days: 3 },
{ pincode: 690504, min_days: 2, max_days: 3 },
{ pincode: 690505, min_days: 2, max_days: 3 },
{ pincode: 690506, min_days: 2, max_days: 3 },
{ pincode: 690507, min_days: 2, max_days: 3 },
{ pincode: 690508, min_days: 2, max_days: 3 },
{ pincode: 690509, min_days: 2, max_days: 3 },
{ pincode: 690510, min_days: 2, max_days: 3 },
{ pincode: 690511, min_days: 2, max_days: 3 },
{ pincode: 690512, min_days: 2, max_days: 3 },
{ pincode: 690513, min_days: 2, max_days: 3 },
{ pincode: 690514, min_days: 2, max_days: 3 },
{ pincode: 690515, min_days: 2, max_days: 3 },
{ pincode: 690516, min_days: 2, max_days: 3 },
{ pincode: 690517, min_days: 2, max_days: 3 },
{ pincode: 690518, min_days: 2, max_days: 3 },
{ pincode: 690519, min_days: 2, max_days: 3 },
{ pincode: 690520, min_days: 2, max_days: 3 },
{ pincode: 690521, min_days: 2, max_days: 3 },
{ pincode: 690522, min_days: 2, max_days: 3 },
{ pincode: 690523, min_days: 2, max_days: 3 },
{ pincode: 690524, min_days: 2, max_days: 3 },
{ pincode: 690525, min_days: 2, max_days: 3 },
{ pincode: 690526, min_days: 2, max_days: 3 },
{ pincode: 690527, min_days: 2, max_days: 3 },
{ pincode: 690528, min_days: 2, max_days: 3 },
{ pincode: 690529, min_days: 2, max_days: 3 },
{ pincode: 690530, min_days: 2, max_days: 3 },
{ pincode: 690531, min_days: 2, max_days: 3 },
{ pincode: 690532, min_days: 2, max_days: 3 },
{ pincode: 690533, min_days: 2, max_days: 3 },
{ pincode: 690534, min_days: 2, max_days: 3 },
{ pincode: 690535, min_days: 2, max_days: 3 },
{ pincode: 690536, min_days: 2, max_days: 3 },
{ pincode: 690537, min_days: 2, max_days: 3 },
{ pincode: 690538, min_days: 2, max_days: 3 },
{ pincode: 690539, min_days: 2, max_days: 3 },
{ pincode: 690540, min_days: 2, max_days: 3 },
{ pincode: 690541, min_days: 3, max_days: 4 },
{ pincode: 690542, min_days: 2, max_days: 3 },
{ pincode: 690543, min_days: 3, max_days: 4 },
{ pincode: 690544, min_days: 2, max_days: 3 },
{ pincode: 690546, min_days: 2, max_days: 3 },
{ pincode: 690547, min_days: 2, max_days: 3 },
{ pincode: 690548, min_days: 2, max_days: 3 },
{ pincode: 690549, min_days: 3, max_days: 4 },
{ pincode: 690550, min_days: 3, max_days: 4 },
{ pincode: 690551, min_days: 3, max_days: 4 },
{ pincode: 690552, min_days: 3, max_days: 4 },
{ pincode: 690553, min_days: 3, max_days: 4 },
{ pincode: 690554, min_days: 3, max_days: 4 },
{ pincode: 690555, min_days: 3, max_days: 4 },
{ pincode: 690556, min_days: 3, max_days: 4 },
{ pincode: 690557, min_days: 3, max_days: 4 },
{ pincode: 690558, min_days: 2, max_days: 3 },
{ pincode: 690559, min_days: 2, max_days: 3 },
{ pincode: 690560, min_days: 3, max_days: 4 },
{ pincode: 690561, min_days: 2, max_days: 3 },
{ pincode: 690563, min_days: 3, max_days: 4 },
{ pincode: 690564, min_days: 3, max_days: 4 },
{ pincode: 690565, min_days: 3, max_days: 4 },
{ pincode: 690566, min_days: 3, max_days: 4 },
{ pincode: 690567, min_days: 3, max_days: 4 },
{ pincode: 690568, min_days: 3, max_days: 4 },
{ pincode: 690569, min_days: 3, max_days: 4 },
{ pincode: 690570, min_days: 3, max_days: 4 },
{ pincode: 690571, min_days: 2, max_days: 3 },
{ pincode: 690572, min_days: 2, max_days: 3 },
{ pincode: 690573, min_days: 2, max_days: 3 },
{ pincode: 690574, min_days: 2, max_days: 3 },
{ pincode: 691001, min_days: 2, max_days: 3 },
{ pincode: 691002, min_days: 2, max_days: 3 },
{ pincode: 691003, min_days: 2, max_days: 3 },
{ pincode: 691004, min_days: 2, max_days: 3 },
{ pincode: 691005, min_days: 2, max_days: 3 },
{ pincode: 691006, min_days: 2, max_days: 3 },
{ pincode: 691007, min_days: 2, max_days: 3 },
{ pincode: 691008, min_days: 2, max_days: 3 },
{ pincode: 691009, min_days: 2, max_days: 3 },
{ pincode: 691010, min_days: 2, max_days: 3 },
{ pincode: 691011, min_days: 2, max_days: 3 },
{ pincode: 691012, min_days: 2, max_days: 3 },
{ pincode: 691013, min_days: 2, max_days: 3 },
{ pincode: 691014, min_days: 2, max_days: 3 },
{ pincode: 691015, min_days: 2, max_days: 3 },
{ pincode: 691016, min_days: 2, max_days: 3 },
{ pincode: 691017, min_days: 3, max_days: 4 },
{ pincode: 691018, min_days: 3, max_days: 4 },
{ pincode: 691019, min_days: 2, max_days: 3 },
{ pincode: 691020, min_days: 2, max_days: 3 },
{ pincode: 691021, min_days: 2, max_days: 3 },
{ pincode: 691301, min_days: 2, max_days: 3 },
{ pincode: 691302, min_days: 2, max_days: 3 },
{ pincode: 691303, min_days: 2, max_days: 3 },
{ pincode: 691304, min_days: 2, max_days: 3 },
{ pincode: 691305, min_days: 2, max_days: 3 },
{ pincode: 691306, min_days: 2, max_days: 3 },
{ pincode: 691307, min_days: 2, max_days: 3 },
{ pincode: 691308, min_days: 2, max_days: 3 },
{ pincode: 691309, min_days: 2, max_days: 3 },
{ pincode: 691310, min_days: 2, max_days: 3 },
{ pincode: 691311, min_days: 2, max_days: 3 },
{ pincode: 691312, min_days: 2, max_days: 3 },
{ pincode: 691314, min_days: 3, max_days: 4 },
{ pincode: 691315, min_days: 3, max_days: 4 },
{ pincode: 691316, min_days: 3, max_days: 4 },
{ pincode: 691317, min_days: 3, max_days: 4 },
{ pincode: 691318, min_days: 3, max_days: 4 },
{ pincode: 691319, min_days: 2, max_days: 3 },
{ pincode: 691320, min_days: 3, max_days: 4 },
{ pincode: 691321, min_days: 3, max_days: 4 },
{ pincode: 691322, min_days: 2, max_days: 3 },
{ pincode: 691324, min_days: 3, max_days: 4 },
{ pincode: 691325, min_days: 3, max_days: 4 },
{ pincode: 691326, min_days: 3, max_days: 4 },
{ pincode: 691329, min_days: 3, max_days: 4 },
{ pincode: 691330, min_days: 3, max_days: 4 },
{ pincode: 691331, min_days: 2, max_days: 3 },
{ pincode: 691332, min_days: 2, max_days: 3 },
{ pincode: 691333, min_days: 2, max_days: 3 },
{ pincode: 691334, min_days: 2, max_days: 3 },
{ pincode: 691335, min_days: 3, max_days: 4 },
{ pincode: 691500, min_days: 2, max_days: 3 },
{ pincode: 691501, min_days: 2, max_days: 3 },
{ pincode: 691502, min_days: 2, max_days: 3 },
{ pincode: 691503, min_days: 2, max_days: 3 },
{ pincode: 691504, min_days: 2, max_days: 3 },
{ pincode: 691505, min_days: 2, max_days: 3 },
{ pincode: 691506, min_days: 2, max_days: 3 },
{ pincode: 691507, min_days: 2, max_days: 3 },
{ pincode: 691508, min_days: 2, max_days: 3 },
{ pincode: 691509, min_days: 2, max_days: 3 },
{ pincode: 691510, min_days: 2, max_days: 3 },
{ pincode: 691511, min_days: 2, max_days: 3 },
{ pincode: 691512, min_days: 2, max_days: 3 },
{ pincode: 691513, min_days: 3, max_days: 4 },
{ pincode: 691514, min_days: 3, max_days: 4 },
{ pincode: 691515, min_days: 2, max_days: 3 },
{ pincode: 691516, min_days: 2, max_days: 3 },
{ pincode: 691517, min_days: 3, max_days: 4 },
{ pincode: 691518, min_days: 3, max_days: 4 },
{ pincode: 691519, min_days: 3, max_days: 4 },
{ pincode: 691520, min_days: 2, max_days: 3 },
{ pincode: 691521, min_days: 2, max_days: 3 },
{ pincode: 691522, min_days: 2, max_days: 3 },
{ pincode: 691523, min_days: 2, max_days: 3 },
{ pincode: 691524, min_days: 2, max_days: 3 },
{ pincode: 691525, min_days: 2, max_days: 3 },
{ pincode: 691526, min_days: 2, max_days: 3 },
{ pincode: 691527, min_days: 2, max_days: 3 },
{ pincode: 691528, min_days: 3, max_days: 4 },
{ pincode: 691529, min_days: 3, max_days: 4 },
{ pincode: 691530, min_days: 2, max_days: 3 },
{ pincode: 691531, min_days: 2, max_days: 3 },
{ pincode: 691532, min_days: 2, max_days: 3 },
{ pincode: 691533, min_days: 2, max_days: 3 },
{ pincode: 691534, min_days: 2, max_days: 3 },
{ pincode: 691535, min_days: 2, max_days: 3 },
{ pincode: 691536, min_days: 2, max_days: 3 },
{ pincode: 691537, min_days: 2, max_days: 3 },
{ pincode: 691538, min_days: 2, max_days: 3 },
{ pincode: 691539, min_days: 3, max_days: 4 },
{ pincode: 691540, min_days: 2, max_days: 3 },
{ pincode: 691541, min_days: 2, max_days: 3 },
{ pincode: 691542, min_days: 3, max_days: 4 },
{ pincode: 691543, min_days: 2, max_days: 3 },
{ pincode: 691544, min_days: 3, max_days: 4 },
{ pincode: 691545, min_days: 3, max_days: 4 },
{ pincode: 691546, min_days: 3, max_days: 4 },
{ pincode: 691547, min_days: 3, max_days: 4 },
{ pincode: 691548, min_days: 3, max_days: 4 },
{ pincode: 691550, min_days: 3, max_days: 4 },
{ pincode: 691551, min_days: 2, max_days: 3 },
{ pincode: 691552, min_days: 2, max_days: 3 },
{ pincode: 691553, min_days: 2, max_days: 3 },
{ pincode: 691554, min_days: 2, max_days: 3 },
{ pincode: 691555, min_days: 2, max_days: 3 },
{ pincode: 691556, min_days: 2, max_days: 3 },
{ pincode: 691557, min_days: 2, max_days: 3 },
{ pincode: 691559, min_days: 2, max_days: 3 },
{ pincode: 691560, min_days: 2, max_days: 3 },
{ pincode: 691562, min_days: 3, max_days: 4 },
{ pincode: 691566, min_days: 2, max_days: 3 },
{ pincode: 691571, min_days: 2, max_days: 3 },
{ pincode: 691572, min_days: 2, max_days: 3 },
{ pincode: 691573, min_days: 2, max_days: 3 },
{ pincode: 691574, min_days: 2, max_days: 3 },
{ pincode: 691576, min_days: 2, max_days: 3 },
{ pincode: 691577, min_days: 2, max_days: 3 },
{ pincode: 691578, min_days: 2, max_days: 3 },
{ pincode: 691579, min_days: 2, max_days: 3 },
{ pincode: 691580, min_days: 3, max_days: 4 },
{ pincode: 691581, min_days: 2, max_days: 3 },
{ pincode: 691582, min_days: 2, max_days: 3 },
{ pincode: 691583, min_days: 2, max_days: 3 },
{ pincode: 691584, min_days: 2, max_days: 3 },
{ pincode: 691585, min_days: 2, max_days: 3 },
{ pincode: 691587, min_days: 3, max_days: 4 },
{ pincode: 691588, min_days: 3, max_days: 4 },
{ pincode: 691589, min_days: 2, max_days: 3 },
{ pincode: 691590, min_days: 2, max_days: 3 },
{ pincode: 691601, min_days: 2, max_days: 3 },
{ pincode: 691602, min_days: 2, max_days: 3 },
{ pincode: 691603, min_days: 3, max_days: 4 },
{ pincode: 691604, min_days: 3, max_days: 4 },
{ pincode: 691623, min_days: 3, max_days: 4 },
{ pincode: 691624, min_days: 3, max_days: 4 },
{ pincode: 691625, min_days: 3, max_days: 4 },
{ pincode: 691641, min_days: 3, max_days: 4 },
{ pincode: 695001, min_days: 2, max_days: 3 },
{ pincode: 695002, min_days: 2, max_days: 3 },
{ pincode: 695003, min_days: 2, max_days: 3 },
{ pincode: 695004, min_days: 2, max_days: 3 },
{ pincode: 695005, min_days: 2, max_days: 3 },
{ pincode: 695006, min_days: 2, max_days: 3 },
{ pincode: 695007, min_days: 2, max_days: 3 },
{ pincode: 695008, min_days: 2, max_days: 3 },
{ pincode: 695009, min_days: 2, max_days: 3 },
{ pincode: 695010, min_days: 2, max_days: 3 },
{ pincode: 695011, min_days: 2, max_days: 3 },
{ pincode: 695012, min_days: 2, max_days: 3 },
{ pincode: 695013, min_days: 2, max_days: 3 },
{ pincode: 695014, min_days: 2, max_days: 3 },
{ pincode: 695015, min_days: 2, max_days: 3 },
{ pincode: 695016, min_days: 2, max_days: 3 },
{ pincode: 695017, min_days: 2, max_days: 3 },
{ pincode: 695018, min_days: 2, max_days: 3 },
{ pincode: 695019, min_days: 2, max_days: 3 },
{ pincode: 695020, min_days: 2, max_days: 3 },
{ pincode: 695021, min_days: 2, max_days: 3 },
{ pincode: 695022, min_days: 2, max_days: 3 },
{ pincode: 695023, min_days: 2, max_days: 3 },
{ pincode: 695024, min_days: 2, max_days: 3 },
{ pincode: 695025, min_days: 2, max_days: 3 },
{ pincode: 695026, min_days: 2, max_days: 3 },
{ pincode: 695027, min_days: 2, max_days: 3 },
{ pincode: 695028, min_days: 2, max_days: 3 },
{ pincode: 695029, min_days: 2, max_days: 3 },
{ pincode: 695030, min_days: 2, max_days: 3 },
{ pincode: 695031, min_days: 3, max_days: 4 },
{ pincode: 695032, min_days: 2, max_days: 3 },
{ pincode: 695033, min_days: 2, max_days: 3 },
{ pincode: 695034, min_days: 2, max_days: 3 },
{ pincode: 695035, min_days: 2, max_days: 3 },
{ pincode: 695036, min_days: 2, max_days: 3 },
{ pincode: 695037, min_days: 3, max_days: 4 },
{ pincode: 695038, min_days: 2, max_days: 3 },
{ pincode: 695039, min_days: 3, max_days: 4 },
{ pincode: 695040, min_days: 2, max_days: 3 },
{ pincode: 695041, min_days: 3, max_days: 4 },
{ pincode: 695042, min_days: 2, max_days: 3 },
{ pincode: 695043, min_days: 2, max_days: 3 },
{ pincode: 695044, min_days: 3, max_days: 4 },
{ pincode: 695051, min_days: 2, max_days: 3 },
{ pincode: 695081, min_days: 3, max_days: 4 },
{ pincode: 695099, min_days: 2, max_days: 3 },
{ pincode: 695101, min_days: 2, max_days: 3 },
{ pincode: 695102, min_days: 2, max_days: 3 },
{ pincode: 695103, min_days: 2, max_days: 3 },
{ pincode: 695104, min_days: 2, max_days: 3 },
{ pincode: 695105, min_days: 3, max_days: 4 },
{ pincode: 695106, min_days: 3, max_days: 4 },
{ pincode: 695120, min_days: 3, max_days: 4 },
{ pincode: 695121, min_days: 2, max_days: 3 },
{ pincode: 695122, min_days: 2, max_days: 3 },
{ pincode: 695123, min_days: 2, max_days: 3 },
{ pincode: 695124, min_days: 2, max_days: 3 },
{ pincode: 695125, min_days: 2, max_days: 3 },
{ pincode: 695126, min_days: 2, max_days: 3 },
{ pincode: 695127, min_days: 3, max_days: 4 },
{ pincode: 695128, min_days: 3, max_days: 4 },
{ pincode: 695130, min_days: 3, max_days: 4 },
{ pincode: 695131, min_days: 3, max_days: 4 },
{ pincode: 695132, min_days: 2, max_days: 3 },
{ pincode: 695133, min_days: 2, max_days: 3 },
{ pincode: 695134, min_days: 2, max_days: 3 },
{ pincode: 695141, min_days: 2, max_days: 3 },
{ pincode: 695142, min_days: 2, max_days: 3 },
{ pincode: 695143, min_days: 2, max_days: 3 },
{ pincode: 695144, min_days: 2, max_days: 3 },
{ pincode: 695145, min_days: 2, max_days: 3 },
{ pincode: 695146, min_days: 2, max_days: 3 },
{ pincode: 695301, min_days: 2, max_days: 3 },
{ pincode: 695302, min_days: 2, max_days: 3 },
{ pincode: 695303, min_days: 2, max_days: 3 },
{ pincode: 695304, min_days: 2, max_days: 3 },
{ pincode: 695305, min_days: 2, max_days: 3 },
{ pincode: 695306, min_days: 2, max_days: 3 },
{ pincode: 695307, min_days: 2, max_days: 3 },
{ pincode: 695308, min_days: 2, max_days: 3 },
{ pincode: 695309, min_days: 2, max_days: 3 },
{ pincode: 695310, min_days: 2, max_days: 3 },
{ pincode: 695311, min_days: 2, max_days: 3 },
{ pincode: 695312, min_days: 2, max_days: 3 },
{ pincode: 695313, min_days: 2, max_days: 3 },
{ pincode: 695314, min_days: 3, max_days: 4 },
{ pincode: 695315, min_days: 3, max_days: 4 },
{ pincode: 695316, min_days: 2, max_days: 3 },
{ pincode: 695317, min_days: 2, max_days: 3 },
{ pincode: 695318, min_days: 2, max_days: 3 },
{ pincode: 695323, min_days: 3, max_days: 4 },
{ pincode: 695501, min_days: 2, max_days: 3 },
{ pincode: 695502, min_days: 2, max_days: 3 },
{ pincode: 695503, min_days: 2, max_days: 3 },
{ pincode: 695504, min_days: 2, max_days: 3 },
{ pincode: 695505, min_days: 2, max_days: 3 },
{ pincode: 695506, min_days: 2, max_days: 3 },
{ pincode: 695507, min_days: 2, max_days: 3 },
{ pincode: 695508, min_days: 2, max_days: 3 },
{ pincode: 695509, min_days: 3, max_days: 4 },
{ pincode: 695510, min_days: 3, max_days: 4 },
{ pincode: 695512, min_days: 2, max_days: 3 },
{ pincode: 695513, min_days: 2, max_days: 3 },
{ pincode: 695521, min_days: 2, max_days: 3 },
{ pincode: 695522, min_days: 2, max_days: 3 },
{ pincode: 695523, min_days: 2, max_days: 3 },
{ pincode: 695524, min_days: 2, max_days: 3 },
{ pincode: 695525, min_days: 2, max_days: 3 },
{ pincode: 695526, min_days: 2, max_days: 3 },
{ pincode: 695527, min_days: 2, max_days: 3 },
{ pincode: 695528, min_days: 2, max_days: 3 },
{ pincode: 695541, min_days: 2, max_days: 3 },
{ pincode: 695542, min_days: 2, max_days: 3 },
{ pincode: 695543, min_days: 2, max_days: 3 },
{ pincode: 695544, min_days: 3, max_days: 4 },
{ pincode: 695547, min_days: 2, max_days: 3 },
{ pincode: 695551, min_days: 2, max_days: 3 },
{ pincode: 695557, min_days: 3, max_days: 4 },
{ pincode: 695560, min_days: 3, max_days: 4 },
{ pincode: 695561, min_days: 2, max_days: 3 },
{ pincode: 695562, min_days: 2, max_days: 3 },
{ pincode: 695563, min_days: 2, max_days: 3 },
{ pincode: 695564, min_days: 2, max_days: 3 },
{ pincode: 695566, min_days: 3, max_days: 4 },
{ pincode: 695568, min_days: 2, max_days: 3 },
{ pincode: 695570, min_days: 2, max_days: 3 },
{ pincode: 695571, min_days: 2, max_days: 3 },
{ pincode: 695572, min_days: 2, max_days: 3 },
{ pincode: 695573, min_days: 2, max_days: 3 },
{ pincode: 695574, min_days: 2, max_days: 3 },
{ pincode: 695575, min_days: 2, max_days: 3 },
{ pincode: 695581, min_days: 2, max_days: 3 },
{ pincode: 695582, min_days: 2, max_days: 3 },
{ pincode: 695583, min_days: 2, max_days: 3 },
{ pincode: 695584, min_days: 2, max_days: 3 },
{ pincode: 695585, min_days: 2, max_days: 3 },
{ pincode: 695586, min_days: 2, max_days: 3 },
{ pincode: 695587, min_days: 2, max_days: 3 },
{ pincode: 695588, min_days: 2, max_days: 3 },
{ pincode: 695589, min_days: 2, max_days: 3 },
{ pincode: 695601, min_days: 2, max_days: 3 },
{ pincode: 695602, min_days: 2, max_days: 3 },
{ pincode: 695603, min_days: 2, max_days: 3 },
{ pincode: 695604, min_days: 2, max_days: 3 },
{ pincode: 695605, min_days: 2, max_days: 3 },
{ pincode: 695606, min_days: 2, max_days: 3 },
{ pincode: 695607, min_days: 2, max_days: 3 },
{ pincode: 695608, min_days: 2, max_days: 3 },
{ pincode: 695609, min_days: 2, max_days: 3 },
{ pincode: 695610, min_days: 2, max_days: 3 },
{ pincode: 695611, min_days: 2, max_days: 3 },
{ pincode: 695612, min_days: 2, max_days: 3 },
{ pincode: 695614, min_days: 2, max_days: 3 },
{ pincode: 695615, min_days: 2, max_days: 3 },
{ pincode: 695616, min_days: 3, max_days: 4 },
{ pincode: 695618, min_days: 3, max_days: 4 },
{ pincode: 700000, min_days: 2, max_days: 3 },
{ pincode: 700001, min_days: 2, max_days: 3 },
{ pincode: 700002, min_days: 2, max_days: 3 },
{ pincode: 700003, min_days: 2, max_days: 3 },
{ pincode: 700004, min_days: 2, max_days: 3 },
{ pincode: 700005, min_days: 2, max_days: 3 },
{ pincode: 700006, min_days: 2, max_days: 3 },
{ pincode: 700007, min_days: 2, max_days: 3 },
{ pincode: 700008, min_days: 2, max_days: 3 },
{ pincode: 700009, min_days: 2, max_days: 3 },
{ pincode: 700010, min_days: 2, max_days: 3 },
{ pincode: 700011, min_days: 2, max_days: 3 },
{ pincode: 700012, min_days: 2, max_days: 3 },
{ pincode: 700013, min_days: 2, max_days: 3 },
{ pincode: 700014, min_days: 2, max_days: 3 },
{ pincode: 700015, min_days: 2, max_days: 3 },
{ pincode: 700016, min_days: 2, max_days: 3 },
{ pincode: 700017, min_days: 2, max_days: 3 },
{ pincode: 700018, min_days: 2, max_days: 3 },
{ pincode: 700019, min_days: 2, max_days: 3 },
{ pincode: 700020, min_days: 2, max_days: 3 },
{ pincode: 700021, min_days: 2, max_days: 3 },
{ pincode: 700022, min_days: 2, max_days: 3 },
{ pincode: 700023, min_days: 2, max_days: 3 },
{ pincode: 700024, min_days: 2, max_days: 3 },
{ pincode: 700025, min_days: 2, max_days: 3 },
{ pincode: 700026, min_days: 2, max_days: 3 },
{ pincode: 700027, min_days: 2, max_days: 3 },
{ pincode: 700028, min_days: 2, max_days: 3 },
{ pincode: 700029, min_days: 2, max_days: 3 },
{ pincode: 700030, min_days: 2, max_days: 3 },
{ pincode: 700031, min_days: 2, max_days: 3 },
{ pincode: 700032, min_days: 2, max_days: 3 },
{ pincode: 700033, min_days: 2, max_days: 3 },
{ pincode: 700034, min_days: 2, max_days: 3 },
{ pincode: 700035, min_days: 2, max_days: 3 },
{ pincode: 700036, min_days: 2, max_days: 3 },
{ pincode: 700037, min_days: 2, max_days: 3 },
{ pincode: 700038, min_days: 2, max_days: 3 },
{ pincode: 700039, min_days: 2, max_days: 3 },
{ pincode: 700040, min_days: 2, max_days: 3 },
{ pincode: 700041, min_days: 2, max_days: 3 },
{ pincode: 700042, min_days: 2, max_days: 3 },
{ pincode: 700043, min_days: 2, max_days: 3 },
{ pincode: 700044, min_days: 2, max_days: 3 },
{ pincode: 700045, min_days: 2, max_days: 3 },
{ pincode: 700046, min_days: 2, max_days: 3 },
{ pincode: 700047, min_days: 2, max_days: 3 },
{ pincode: 700048, min_days: 2, max_days: 3 },
{ pincode: 700049, min_days: 2, max_days: 3 },
{ pincode: 700050, min_days: 2, max_days: 3 },
{ pincode: 700051, min_days: 2, max_days: 3 },
{ pincode: 700052, min_days: 2, max_days: 3 },
{ pincode: 700053, min_days: 2, max_days: 3 },
{ pincode: 700054, min_days: 2, max_days: 3 },
{ pincode: 700055, min_days: 2, max_days: 3 },
{ pincode: 700056, min_days: 2, max_days: 3 },
{ pincode: 700057, min_days: 2, max_days: 3 },
{ pincode: 700058, min_days: 2, max_days: 3 },
{ pincode: 700059, min_days: 2, max_days: 3 },
{ pincode: 700060, min_days: 2, max_days: 3 },
{ pincode: 700061, min_days: 2, max_days: 3 },
{ pincode: 700062, min_days: 2, max_days: 3 },
{ pincode: 700063, min_days: 2, max_days: 3 },
{ pincode: 700064, min_days: 2, max_days: 3 },
{ pincode: 700065, min_days: 2, max_days: 3 },
{ pincode: 700066, min_days: 2, max_days: 3 },
{ pincode: 700067, min_days: 2, max_days: 3 },
{ pincode: 700068, min_days: 2, max_days: 3 },
{ pincode: 700069, min_days: 2, max_days: 3 },
{ pincode: 700070, min_days: 2, max_days: 3 },
{ pincode: 700071, min_days: 2, max_days: 3 },
{ pincode: 700072, min_days: 2, max_days: 3 },
{ pincode: 700073, min_days: 2, max_days: 3 },
{ pincode: 700074, min_days: 2, max_days: 3 },
{ pincode: 700075, min_days: 2, max_days: 3 },
{ pincode: 700076, min_days: 2, max_days: 3 },
{ pincode: 700077, min_days: 2, max_days: 3 },
{ pincode: 700078, min_days: 2, max_days: 3 },
{ pincode: 700079, min_days: 2, max_days: 3 },
{ pincode: 700080, min_days: 2, max_days: 3 },
{ pincode: 700081, min_days: 2, max_days: 3 },
{ pincode: 700082, min_days: 2, max_days: 3 },
{ pincode: 700083, min_days: 2, max_days: 3 },
{ pincode: 700084, min_days: 2, max_days: 3 },
{ pincode: 700085, min_days: 2, max_days: 3 },
{ pincode: 700086, min_days: 2, max_days: 3 },
{ pincode: 700087, min_days: 2, max_days: 3 },
{ pincode: 700088, min_days: 2, max_days: 3 },
{ pincode: 700089, min_days: 2, max_days: 3 },
{ pincode: 700090, min_days: 2, max_days: 3 },
{ pincode: 700091, min_days: 2, max_days: 3 },
{ pincode: 700092, min_days: 2, max_days: 3 },
{ pincode: 700093, min_days: 2, max_days: 3 },
{ pincode: 700094, min_days: 2, max_days: 3 },
{ pincode: 700095, min_days: 2, max_days: 3 },
{ pincode: 700096, min_days: 2, max_days: 3 },
{ pincode: 700097, min_days: 2, max_days: 3 },
{ pincode: 700098, min_days: 2, max_days: 3 },
{ pincode: 700099, min_days: 2, max_days: 3 },
{ pincode: 700100, min_days: 2, max_days: 3 },
{ pincode: 700101, min_days: 2, max_days: 3 },
{ pincode: 700102, min_days: 2, max_days: 3 },
{ pincode: 700103, min_days: 2, max_days: 3 },
{ pincode: 700104, min_days: 2, max_days: 3 },
{ pincode: 700105, min_days: 2, max_days: 3 },
{ pincode: 700106, min_days: 2, max_days: 3 },
{ pincode: 700107, min_days: 2, max_days: 3 },
{ pincode: 700108, min_days: 2, max_days: 3 },
{ pincode: 700109, min_days: 2, max_days: 3 },
{ pincode: 700110, min_days: 2, max_days: 3 },
{ pincode: 700111, min_days: 2, max_days: 3 },
{ pincode: 700112, min_days: 2, max_days: 3 },
{ pincode: 700113, min_days: 2, max_days: 3 },
{ pincode: 700114, min_days: 2, max_days: 3 },
{ pincode: 700115, min_days: 2, max_days: 3 },
{ pincode: 700116, min_days: 2, max_days: 3 },
{ pincode: 700117, min_days: 2, max_days: 3 },
{ pincode: 700118, min_days: 2, max_days: 3 },
{ pincode: 700119, min_days: 2, max_days: 3 },
{ pincode: 700120, min_days: 2, max_days: 3 },
{ pincode: 700121, min_days: 2, max_days: 3 },
{ pincode: 700122, min_days: 2, max_days: 3 },
{ pincode: 700123, min_days: 2, max_days: 3 },
{ pincode: 700124, min_days: 2, max_days: 3 },
{ pincode: 700125, min_days: 2, max_days: 3 },
{ pincode: 700126, min_days: 2, max_days: 3 },
{ pincode: 700127, min_days: 2, max_days: 3 },
{ pincode: 700128, min_days: 2, max_days: 3 },
{ pincode: 700129, min_days: 2, max_days: 3 },
{ pincode: 700130, min_days: 2, max_days: 3 },
{ pincode: 700131, min_days: 2, max_days: 3 },
{ pincode: 700132, min_days: 2, max_days: 3 },
{ pincode: 700133, min_days: 2, max_days: 3 },
{ pincode: 700134, min_days: 2, max_days: 3 },
{ pincode: 700135, min_days: 2, max_days: 3 },
{ pincode: 700136, min_days: 2, max_days: 3 },
{ pincode: 700137, min_days: 2, max_days: 3 },
{ pincode: 700138, min_days: 2, max_days: 3 },
{ pincode: 700139, min_days: 2, max_days: 3 },
{ pincode: 700140, min_days: 2, max_days: 3 },
{ pincode: 700141, min_days: 2, max_days: 3 },
{ pincode: 700142, min_days: 2, max_days: 3 },
{ pincode: 700143, min_days: 2, max_days: 3 },
{ pincode: 700144, min_days: 2, max_days: 3 },
{ pincode: 700145, min_days: 2, max_days: 3 },
{ pincode: 700146, min_days: 2, max_days: 3 },
{ pincode: 700147, min_days: 2, max_days: 3 },
{ pincode: 700148, min_days: 2, max_days: 3 },
{ pincode: 700149, min_days: 2, max_days: 3 },
{ pincode: 700150, min_days: 2, max_days: 3 },
{ pincode: 700151, min_days: 2, max_days: 3 },
{ pincode: 700152, min_days: 2, max_days: 3 },
{ pincode: 700153, min_days: 2, max_days: 3 },
{ pincode: 700154, min_days: 2, max_days: 3 },
{ pincode: 700155, min_days: 2, max_days: 3 },
{ pincode: 700156, min_days: 2, max_days: 3 },
{ pincode: 700157, min_days: 2, max_days: 3 },
{ pincode: 700158, min_days: 2, max_days: 3 },
{ pincode: 700159, min_days: 2, max_days: 3 },
{ pincode: 700160, min_days: 2, max_days: 3 },
{ pincode: 700161, min_days: 2, max_days: 3 },
{ pincode: 700162, min_days: 2, max_days: 3 },
{ pincode: 700163, min_days: 2, max_days: 3 },
{ pincode: 700404, min_days: 2, max_days: 3 },
{ pincode: 700408, min_days: 2, max_days: 3 },
{ pincode: 701101, min_days: 2, max_days: 3 },
{ pincode: 701102, min_days: 2, max_days: 3 },
{ pincode: 701111, min_days: 2, max_days: 3 },
{ pincode: 711001, min_days: 2, max_days: 3 },
{ pincode: 711101, min_days: 2, max_days: 3 },
{ pincode: 711102, min_days: 2, max_days: 3 },
{ pincode: 711103, min_days: 2, max_days: 3 },
{ pincode: 711104, min_days: 2, max_days: 3 },
{ pincode: 711105, min_days: 2, max_days: 3 },
{ pincode: 711106, min_days: 2, max_days: 3 },
{ pincode: 711107, min_days: 2, max_days: 3 },
{ pincode: 711108, min_days: 2, max_days: 3 },
{ pincode: 711109, min_days: 2, max_days: 3 },
{ pincode: 711110, min_days: 2, max_days: 3 },
{ pincode: 711111, min_days: 2, max_days: 3 },
{ pincode: 711112, min_days: 2, max_days: 3 },
{ pincode: 711113, min_days: 2, max_days: 3 },
{ pincode: 711114, min_days: 2, max_days: 3 },
{ pincode: 711115, min_days: 2, max_days: 3 },
{ pincode: 711120, min_days: 2, max_days: 3 },
{ pincode: 711127, min_days: 2, max_days: 3 },
{ pincode: 711201, min_days: 2, max_days: 3 },
{ pincode: 711202, min_days: 2, max_days: 3 },
{ pincode: 711203, min_days: 2, max_days: 3 },
{ pincode: 711204, min_days: 2, max_days: 3 },
{ pincode: 711205, min_days: 2, max_days: 3 },
{ pincode: 711206, min_days: 2, max_days: 3 },
{ pincode: 711212, min_days: 2, max_days: 3 },
{ pincode: 711224, min_days: 2, max_days: 3 },
{ pincode: 711225, min_days: 2, max_days: 3 },
{ pincode: 711226, min_days: 2, max_days: 3 },
{ pincode: 711227, min_days: 2, max_days: 3 },
{ pincode: 711247, min_days: 2, max_days: 3 },
{ pincode: 711301, min_days: 2, max_days: 3 },
{ pincode: 711302, min_days: 2, max_days: 3 },
{ pincode: 711303, min_days: 2, max_days: 3 },
{ pincode: 711304, min_days: 2, max_days: 3 },
{ pincode: 711305, min_days: 2, max_days: 3 },
{ pincode: 711306, min_days: 2, max_days: 3 },
{ pincode: 711307, min_days: 2, max_days: 3 },
{ pincode: 711308, min_days: 2, max_days: 3 },
{ pincode: 711309, min_days: 2, max_days: 3 },
{ pincode: 711310, min_days: 2, max_days: 3 },
{ pincode: 711311, min_days: 2, max_days: 3 },
{ pincode: 711312, min_days: 2, max_days: 3 },
{ pincode: 711313, min_days: 2, max_days: 3 },
{ pincode: 711314, min_days: 2, max_days: 3 },
{ pincode: 711315, min_days: 2, max_days: 3 },
{ pincode: 711316, min_days: 2, max_days: 3 },
{ pincode: 711317, min_days: 2, max_days: 3 },
{ pincode: 711320, min_days: 2, max_days: 3 },
{ pincode: 711321, min_days: 2, max_days: 3 },
{ pincode: 711322, min_days: 2, max_days: 3 },
{ pincode: 711323, min_days: 2, max_days: 3 },
{ pincode: 711324, min_days: 2, max_days: 3 },
{ pincode: 711325, min_days: 2, max_days: 3 },
{ pincode: 711326, min_days: 2, max_days: 3 },
{ pincode: 711327, min_days: 2, max_days: 3 },
{ pincode: 711328, min_days: 2, max_days: 3 },
{ pincode: 711331, min_days: 2, max_days: 3 },
{ pincode: 711401, min_days: 2, max_days: 3 },
{ pincode: 711402, min_days: 2, max_days: 3 },
{ pincode: 711403, min_days: 2, max_days: 3 },
{ pincode: 711404, min_days: 2, max_days: 3 },
{ pincode: 711405, min_days: 2, max_days: 3 },
{ pincode: 711406, min_days: 2, max_days: 3 },
{ pincode: 711408, min_days: 2, max_days: 3 },
{ pincode: 711409, min_days: 2, max_days: 3 },
{ pincode: 711410, min_days: 2, max_days: 3 },
{ pincode: 711411, min_days: 2, max_days: 3 },
{ pincode: 711412, min_days: 2, max_days: 3 },
{ pincode: 711413, min_days: 2, max_days: 3 },
{ pincode: 711414, min_days: 2, max_days: 3 },
{ pincode: 711415, min_days: 2, max_days: 3 },
{ pincode: 711416, min_days: 2, max_days: 3 },
{ pincode: 712101, min_days: 2, max_days: 3 },
{ pincode: 712102, min_days: 2, max_days: 3 },
{ pincode: 712103, min_days: 2, max_days: 3 },
{ pincode: 712104, min_days: 2, max_days: 3 },
{ pincode: 712105, min_days: 2, max_days: 3 },
{ pincode: 712106, min_days: 2, max_days: 3 },
{ pincode: 712121, min_days: 2, max_days: 3 },
{ pincode: 712122, min_days: 2, max_days: 3 },
{ pincode: 712123, min_days: 2, max_days: 3 },
{ pincode: 712124, min_days: 2, max_days: 3 },
{ pincode: 712125, min_days: 2, max_days: 3 },
{ pincode: 712134, min_days: 2, max_days: 3 },
{ pincode: 712135, min_days: 2, max_days: 3 },
{ pincode: 712136, min_days: 2, max_days: 3 },
{ pincode: 712137, min_days: 2, max_days: 3 },
{ pincode: 712138, min_days: 2, max_days: 3 },
{ pincode: 712139, min_days: 2, max_days: 3 },
{ pincode: 712146, min_days: 2, max_days: 3 },
{ pincode: 712147, min_days: 2, max_days: 3 },
{ pincode: 712148, min_days: 2, max_days: 3 },
{ pincode: 712149, min_days: 2, max_days: 3 },
{ pincode: 712150, min_days: 2, max_days: 3 },
{ pincode: 712151, min_days: 2, max_days: 3 },
{ pincode: 712152, min_days: 2, max_days: 3 },
{ pincode: 712153, min_days: 2, max_days: 3 },
{ pincode: 712154, min_days: 2, max_days: 3 },
{ pincode: 712155, min_days: 2, max_days: 3 },
{ pincode: 712156, min_days: 2, max_days: 3 },
{ pincode: 712157, min_days: 2, max_days: 3 },
{ pincode: 712158, min_days: 2, max_days: 3 },
{ pincode: 712201, min_days: 2, max_days: 3 },
{ pincode: 712202, min_days: 2, max_days: 3 },
{ pincode: 712203, min_days: 2, max_days: 3 },
{ pincode: 712204, min_days: 2, max_days: 3 },
{ pincode: 712205, min_days: 2, max_days: 3 },
{ pincode: 712206, min_days: 2, max_days: 3 },
{ pincode: 712208, min_days: 2, max_days: 3 },
{ pincode: 712221, min_days: 2, max_days: 3 },
{ pincode: 712222, min_days: 2, max_days: 3 },
{ pincode: 712223, min_days: 2, max_days: 3 },
{ pincode: 712224, min_days: 2, max_days: 3 },
{ pincode: 712232, min_days: 2, max_days: 3 },
{ pincode: 712233, min_days: 2, max_days: 3 },
{ pincode: 712234, min_days: 2, max_days: 3 },
{ pincode: 712235, min_days: 2, max_days: 3 },
{ pincode: 712245, min_days: 2, max_days: 3 },
{ pincode: 712246, min_days: 2, max_days: 3 },
{ pincode: 712247, min_days: 2, max_days: 3 },
{ pincode: 712248, min_days: 2, max_days: 3 },
{ pincode: 712249, min_days: 2, max_days: 3 },
{ pincode: 712250, min_days: 2, max_days: 3 },
{ pincode: 712258, min_days: 2, max_days: 3 },
{ pincode: 712301, min_days: 2, max_days: 3 },
{ pincode: 712302, min_days: 2, max_days: 3 },
{ pincode: 712303, min_days: 2, max_days: 3 },
{ pincode: 712304, min_days: 2, max_days: 3 },
{ pincode: 712305, min_days: 2, max_days: 3 },
{ pincode: 712306, min_days: 2, max_days: 3 },
{ pincode: 712307, min_days: 2, max_days: 3 },
{ pincode: 712308, min_days: 2, max_days: 3 },
{ pincode: 712309, min_days: 2, max_days: 3 },
{ pincode: 712310, min_days: 2, max_days: 3 },
{ pincode: 712311, min_days: 2, max_days: 3 },
{ pincode: 712331, min_days: 2, max_days: 3 },
{ pincode: 712344, min_days: 2, max_days: 3 },
{ pincode: 712365, min_days: 2, max_days: 3 },
{ pincode: 712401, min_days: 2, max_days: 3 },
{ pincode: 712402, min_days: 2, max_days: 3 },
{ pincode: 712403, min_days: 2, max_days: 3 },
{ pincode: 712404, min_days: 2, max_days: 3 },
{ pincode: 712405, min_days: 2, max_days: 3 },
{ pincode: 712406, min_days: 2, max_days: 3 },
{ pincode: 712407, min_days: 2, max_days: 3 },
{ pincode: 712408, min_days: 2, max_days: 3 },
{ pincode: 712409, min_days: 2, max_days: 3 },
{ pincode: 712410, min_days: 2, max_days: 3 },
{ pincode: 712411, min_days: 2, max_days: 3 },
{ pincode: 712412, min_days: 2, max_days: 3 },
{ pincode: 712413, min_days: 2, max_days: 3 },
{ pincode: 712414, min_days: 2, max_days: 3 },
{ pincode: 712415, min_days: 2, max_days: 3 },
{ pincode: 712416, min_days: 2, max_days: 3 },
{ pincode: 712417, min_days: 2, max_days: 3 },
{ pincode: 712418, min_days: 2, max_days: 3 },
{ pincode: 712419, min_days: 2, max_days: 3 },
{ pincode: 712420, min_days: 2, max_days: 3 },
{ pincode: 712421, min_days: 2, max_days: 3 },
{ pincode: 712422, min_days: 2, max_days: 3 },
{ pincode: 712423, min_days: 2, max_days: 3 },
{ pincode: 712424, min_days: 2, max_days: 3 },
{ pincode: 712426, min_days: 2, max_days: 3 },
{ pincode: 712428, min_days: 2, max_days: 3 },
{ pincode: 712429, min_days: 2, max_days: 3 },
{ pincode: 712501, min_days: 2, max_days: 3 },
{ pincode: 712502, min_days: 2, max_days: 3 },
{ pincode: 712503, min_days: 2, max_days: 3 },
{ pincode: 712504, min_days: 2, max_days: 3 },
{ pincode: 712512, min_days: 2, max_days: 3 },
{ pincode: 712513, min_days: 2, max_days: 3 },
{ pincode: 712514, min_days: 2, max_days: 3 },
{ pincode: 712515, min_days: 2, max_days: 3 },
{ pincode: 712601, min_days: 2, max_days: 3 },
{ pincode: 712602, min_days: 2, max_days: 3 },
{ pincode: 712611, min_days: 2, max_days: 3 },
{ pincode: 712612, min_days: 2, max_days: 3 },
{ pincode: 712613, min_days: 2, max_days: 3 },
{ pincode: 712614, min_days: 2, max_days: 3 },
{ pincode: 712615, min_days: 2, max_days: 3 },
{ pincode: 712616, min_days: 2, max_days: 3 },
{ pincode: 712617, min_days: 2, max_days: 3 },
{ pincode: 712701, min_days: 2, max_days: 3 },
{ pincode: 712702, min_days: 2, max_days: 3 },
{ pincode: 712703, min_days: 2, max_days: 3 },
{ pincode: 712704, min_days: 2, max_days: 3 },
{ pincode: 712705, min_days: 2, max_days: 3 },
{ pincode: 712706, min_days: 2, max_days: 3 },
{ pincode: 712707, min_days: 2, max_days: 3 },
{ pincode: 712708, min_days: 2, max_days: 3 },
{ pincode: 712712, min_days: 2, max_days: 3 },
{ pincode: 713101, min_days: 2, max_days: 3 },
{ pincode: 713102, min_days: 2, max_days: 3 },
{ pincode: 713103, min_days: 2, max_days: 3 },
{ pincode: 713104, min_days: 2, max_days: 3 },
{ pincode: 713121, min_days: 2, max_days: 3 },
{ pincode: 713122, min_days: 2, max_days: 3 },
{ pincode: 713123, min_days: 2, max_days: 3 },
{ pincode: 713124, min_days: 2, max_days: 3 },
{ pincode: 713125, min_days: 2, max_days: 3 },
{ pincode: 713126, min_days: 2, max_days: 3 },
{ pincode: 713127, min_days: 2, max_days: 3 },
{ pincode: 713128, min_days: 2, max_days: 3 },
{ pincode: 713129, min_days: 2, max_days: 3 },
{ pincode: 713130, min_days: 2, max_days: 3 },
{ pincode: 713131, min_days: 2, max_days: 3 },
{ pincode: 713132, min_days: 2, max_days: 3 },
{ pincode: 713140, min_days: 2, max_days: 3 },
{ pincode: 713141, min_days: 2, max_days: 3 },
{ pincode: 713142, min_days: 2, max_days: 3 },
{ pincode: 713143, min_days: 2, max_days: 3 },
{ pincode: 713144, min_days: 2, max_days: 3 },
{ pincode: 713145, min_days: 2, max_days: 3 },
{ pincode: 713146, min_days: 2, max_days: 3 },
{ pincode: 713147, min_days: 2, max_days: 3 },
{ pincode: 713148, min_days: 2, max_days: 3 },
{ pincode: 713149, min_days: 2, max_days: 3 },
{ pincode: 713150, min_days: 2, max_days: 3 },
{ pincode: 713151, min_days: 2, max_days: 3 },
{ pincode: 713152, min_days: 2, max_days: 3 },
{ pincode: 713153, min_days: 2, max_days: 3 },
{ pincode: 713154, min_days: 2, max_days: 3 },
{ pincode: 713155, min_days: 2, max_days: 3 },
{ pincode: 713156, min_days: 2, max_days: 3 },
{ pincode: 713157, min_days: 2, max_days: 3 },
{ pincode: 713158, min_days: 2, max_days: 3 },
{ pincode: 713159, min_days: 2, max_days: 3 },
{ pincode: 713160, min_days: 2, max_days: 3 },
{ pincode: 713161, min_days: 2, max_days: 3 },
{ pincode: 713162, min_days: 2, max_days: 3 },
{ pincode: 713164, min_days: 2, max_days: 3 },
{ pincode: 713165, min_days: 2, max_days: 3 },
{ pincode: 713166, min_days: 2, max_days: 3 },
{ pincode: 713167, min_days: 2, max_days: 3 },
{ pincode: 713168, min_days: 2, max_days: 3 },
{ pincode: 713169, min_days: 2, max_days: 3 },
{ pincode: 713170, min_days: 2, max_days: 3 },
{ pincode: 713171, min_days: 2, max_days: 3 },
{ pincode: 713172, min_days: 2, max_days: 3 },
{ pincode: 713173, min_days: 2, max_days: 3 },
{ pincode: 713174, min_days: 2, max_days: 3 },
{ pincode: 713201, min_days: 2, max_days: 3 },
{ pincode: 713202, min_days: 2, max_days: 3 },
{ pincode: 713203, min_days: 2, max_days: 3 },
{ pincode: 713204, min_days: 2, max_days: 3 },
{ pincode: 713205, min_days: 2, max_days: 3 },
{ pincode: 713206, min_days: 2, max_days: 3 },
{ pincode: 713207, min_days: 2, max_days: 3 },
{ pincode: 713208, min_days: 2, max_days: 3 },
{ pincode: 713209, min_days: 2, max_days: 3 },
{ pincode: 713210, min_days: 2, max_days: 3 },
{ pincode: 713211, min_days: 2, max_days: 3 },
{ pincode: 713212, min_days: 2, max_days: 3 },
{ pincode: 713213, min_days: 2, max_days: 3 },
{ pincode: 713214, min_days: 2, max_days: 3 },
{ pincode: 713215, min_days: 2, max_days: 3 },
{ pincode: 713216, min_days: 2, max_days: 3 },
{ pincode: 713217, min_days: 2, max_days: 3 },
{ pincode: 713218, min_days: 2, max_days: 3 },
{ pincode: 713219, min_days: 2, max_days: 3 },
{ pincode: 713301, min_days: 2, max_days: 3 },
{ pincode: 713302, min_days: 2, max_days: 3 },
{ pincode: 713303, min_days: 2, max_days: 3 },
{ pincode: 713304, min_days: 2, max_days: 3 },
{ pincode: 713305, min_days: 2, max_days: 3 },
{ pincode: 713308, min_days: 2, max_days: 3 },
{ pincode: 713310, min_days: 2, max_days: 3 },
{ pincode: 713315, min_days: 2, max_days: 3 },
{ pincode: 713317, min_days: 2, max_days: 3 },
{ pincode: 713321, min_days: 2, max_days: 3 },
{ pincode: 713322, min_days: 2, max_days: 3 },
{ pincode: 713323, min_days: 2, max_days: 3 },
{ pincode: 713324, min_days: 2, max_days: 3 },
{ pincode: 713325, min_days: 2, max_days: 3 },
{ pincode: 713326, min_days: 2, max_days: 3 },
{ pincode: 713330, min_days: 2, max_days: 3 },
{ pincode: 713331, min_days: 2, max_days: 3 },
{ pincode: 713332, min_days: 2, max_days: 3 },
{ pincode: 713333, min_days: 2, max_days: 3 },
{ pincode: 713334, min_days: 2, max_days: 3 },
{ pincode: 713335, min_days: 2, max_days: 3 },
{ pincode: 713336, min_days: 2, max_days: 3 },
{ pincode: 713337, min_days: 2, max_days: 3 },
{ pincode: 713338, min_days: 2, max_days: 3 },
{ pincode: 713339, min_days: 2, max_days: 3 },
{ pincode: 713340, min_days: 2, max_days: 3 },
{ pincode: 713341, min_days: 2, max_days: 3 },
{ pincode: 713342, min_days: 2, max_days: 3 },
{ pincode: 713343, min_days: 2, max_days: 3 },
{ pincode: 713344, min_days: 2, max_days: 3 },
{ pincode: 713345, min_days: 2, max_days: 3 },
{ pincode: 713346, min_days: 2, max_days: 3 },
{ pincode: 713347, min_days: 2, max_days: 3 },
{ pincode: 713357, min_days: 2, max_days: 3 },
{ pincode: 713358, min_days: 2, max_days: 3 },
{ pincode: 713359, min_days: 2, max_days: 3 },
{ pincode: 713360, min_days: 2, max_days: 3 },
{ pincode: 713361, min_days: 2, max_days: 3 },
{ pincode: 713362, min_days: 2, max_days: 3 },
{ pincode: 713363, min_days: 2, max_days: 3 },
{ pincode: 713364, min_days: 2, max_days: 3 },
{ pincode: 713365, min_days: 2, max_days: 3 },
{ pincode: 713366, min_days: 2, max_days: 3 },
{ pincode: 713367, min_days: 2, max_days: 3 },
{ pincode: 713368, min_days: 2, max_days: 3 },
{ pincode: 713369, min_days: 2, max_days: 3 },
{ pincode: 713370, min_days: 2, max_days: 3 },
{ pincode: 713371, min_days: 2, max_days: 3 },
{ pincode: 713372, min_days: 2, max_days: 3 },
{ pincode: 713373, min_days: 2, max_days: 3 },
{ pincode: 713374, min_days: 2, max_days: 3 },
{ pincode: 713375, min_days: 2, max_days: 3 },
{ pincode: 713376, min_days: 2, max_days: 3 },
{ pincode: 713377, min_days: 2, max_days: 3 },
{ pincode: 713378, min_days: 2, max_days: 3 },
{ pincode: 713379, min_days: 2, max_days: 3 },
{ pincode: 713380, min_days: 2, max_days: 3 },
{ pincode: 713381, min_days: 2, max_days: 3 },
{ pincode: 713382, min_days: 2, max_days: 3 },
{ pincode: 713383, min_days: 2, max_days: 3 },
{ pincode: 713384, min_days: 2, max_days: 3 },
{ pincode: 713385, min_days: 2, max_days: 3 },
{ pincode: 713386, min_days: 2, max_days: 3 },
{ pincode: 713387, min_days: 2, max_days: 3 },
{ pincode: 713401, min_days: 2, max_days: 3 },
{ pincode: 713402, min_days: 2, max_days: 3 },
{ pincode: 713403, min_days: 2, max_days: 3 },
{ pincode: 713404, min_days: 2, max_days: 3 },
{ pincode: 713405, min_days: 2, max_days: 3 },
{ pincode: 713406, min_days: 2, max_days: 3 },
{ pincode: 713407, min_days: 2, max_days: 3 },
{ pincode: 713408, min_days: 2, max_days: 3 },
{ pincode: 713409, min_days: 2, max_days: 3 },
{ pincode: 713419, min_days: 2, max_days: 3 },
{ pincode: 713420, min_days: 2, max_days: 3 },
{ pincode: 713421, min_days: 2, max_days: 3 },
{ pincode: 713422, min_days: 2, max_days: 3 },
{ pincode: 713423, min_days: 2, max_days: 3 },
{ pincode: 713424, min_days: 2, max_days: 3 },
{ pincode: 713425, min_days: 2, max_days: 3 },
{ pincode: 713426, min_days: 2, max_days: 3 },
{ pincode: 713427, min_days: 2, max_days: 3 },
{ pincode: 713428, min_days: 2, max_days: 3 },
{ pincode: 713429, min_days: 2, max_days: 3 },
{ pincode: 713430, min_days: 2, max_days: 3 },
{ pincode: 713431, min_days: 2, max_days: 3 },
{ pincode: 713432, min_days: 2, max_days: 3 },
{ pincode: 713433, min_days: 2, max_days: 3 },
{ pincode: 713434, min_days: 2, max_days: 3 },
{ pincode: 713501, min_days: 2, max_days: 3 },
{ pincode: 713502, min_days: 2, max_days: 3 },
{ pincode: 713512, min_days: 2, max_days: 3 },
{ pincode: 713513, min_days: 2, max_days: 3 },
{ pincode: 713514, min_days: 2, max_days: 3 },
{ pincode: 713515, min_days: 2, max_days: 3 },
{ pincode: 713516, min_days: 2, max_days: 3 },
{ pincode: 713517, min_days: 2, max_days: 3 },
{ pincode: 713518, min_days: 2, max_days: 3 },
{ pincode: 713519, min_days: 2, max_days: 3 },
{ pincode: 713520, min_days: 2, max_days: 3 },
{ pincode: 713706, min_days: 2, max_days: 3 },
{ pincode: 715513, min_days: 2, max_days: 3 },
{ pincode: 721101, min_days: 2, max_days: 3 },
{ pincode: 721102, min_days: 2, max_days: 3 },
{ pincode: 721103, min_days: 2, max_days: 3 },
{ pincode: 721121, min_days: 2, max_days: 3 },
{ pincode: 721122, min_days: 2, max_days: 3 },
{ pincode: 721123, min_days: 2, max_days: 3 },
{ pincode: 721124, min_days: 2, max_days: 3 },
{ pincode: 721125, min_days: 2, max_days: 3 },
{ pincode: 721126, min_days: 2, max_days: 3 },
{ pincode: 721127, min_days: 2, max_days: 3 },
{ pincode: 721128, min_days: 2, max_days: 3 },
{ pincode: 721129, min_days: 2, max_days: 3 },
{ pincode: 721130, min_days: 2, max_days: 3 },
{ pincode: 721131, min_days: 2, max_days: 3 },
{ pincode: 721132, min_days: 2, max_days: 3 },
{ pincode: 721133, min_days: 2, max_days: 3 },
{ pincode: 721134, min_days: 2, max_days: 3 },
{ pincode: 721135, min_days: 2, max_days: 3 },
{ pincode: 721136, min_days: 2, max_days: 3 },
{ pincode: 721137, min_days: 2, max_days: 3 },
{ pincode: 721138, min_days: 2, max_days: 3 },
{ pincode: 721139, min_days: 2, max_days: 3 },
{ pincode: 721140, min_days: 2, max_days: 3 },
{ pincode: 721141, min_days: 2, max_days: 3 },
{ pincode: 721142, min_days: 2, max_days: 3 },
{ pincode: 721143, min_days: 2, max_days: 3 },
{ pincode: 721144, min_days: 2, max_days: 3 },
{ pincode: 721145, min_days: 2, max_days: 3 },
{ pincode: 721146, min_days: 2, max_days: 3 },
{ pincode: 721147, min_days: 2, max_days: 3 },
{ pincode: 721148, min_days: 2, max_days: 3 },
{ pincode: 721149, min_days: 2, max_days: 3 },
{ pincode: 721150, min_days: 2, max_days: 3 },
{ pincode: 721151, min_days: 2, max_days: 3 },
{ pincode: 721152, min_days: 2, max_days: 3 },
{ pincode: 721153, min_days: 2, max_days: 3 },
{ pincode: 721154, min_days: 2, max_days: 3 },
{ pincode: 721155, min_days: 2, max_days: 3 },
{ pincode: 721156, min_days: 2, max_days: 3 },
{ pincode: 721157, min_days: 2, max_days: 3 },
{ pincode: 721158, min_days: 2, max_days: 3 },
{ pincode: 721159, min_days: 2, max_days: 3 },
{ pincode: 721160, min_days: 2, max_days: 3 },
{ pincode: 721161, min_days: 2, max_days: 3 },
{ pincode: 721162, min_days: 2, max_days: 3 },
{ pincode: 721163, min_days: 2, max_days: 3 },
{ pincode: 721164, min_days: 2, max_days: 3 },
{ pincode: 721165, min_days: 2, max_days: 3 },
{ pincode: 721166, min_days: 2, max_days: 3 },
{ pincode: 721167, min_days: 2, max_days: 3 },
{ pincode: 721168, min_days: 2, max_days: 3 },
{ pincode: 721169, min_days: 2, max_days: 3 },
{ pincode: 721170, min_days: 2, max_days: 3 },
{ pincode: 721171, min_days: 2, max_days: 3 },
{ pincode: 721172, min_days: 2, max_days: 3 },
{ pincode: 721201, min_days: 2, max_days: 3 },
{ pincode: 721211, min_days: 2, max_days: 3 },
{ pincode: 721212, min_days: 2, max_days: 3 },
{ pincode: 721222, min_days: 2, max_days: 3 },
{ pincode: 721232, min_days: 2, max_days: 3 },
{ pincode: 721242, min_days: 2, max_days: 3 },
{ pincode: 721252, min_days: 2, max_days: 3 },
{ pincode: 721253, min_days: 2, max_days: 3 },
{ pincode: 721254, min_days: 2, max_days: 3 },
{ pincode: 721256, min_days: 2, max_days: 3 },
{ pincode: 721257, min_days: 2, max_days: 3 },
{ pincode: 721258, min_days: 2, max_days: 3 },
{ pincode: 721259, min_days: 2, max_days: 3 },
{ pincode: 721260, min_days: 2, max_days: 3 },
{ pincode: 721301, min_days: 2, max_days: 3 },
{ pincode: 721302, min_days: 2, max_days: 3 },
{ pincode: 721303, min_days: 2, max_days: 3 },
{ pincode: 721304, min_days: 2, max_days: 3 },
{ pincode: 721305, min_days: 2, max_days: 3 },
{ pincode: 721306, min_days: 2, max_days: 3 },
{ pincode: 721307, min_days: 2, max_days: 3 },
{ pincode: 721315, min_days: 2, max_days: 3 },
{ pincode: 721363, min_days: 2, max_days: 3 },
{ pincode: 721401, min_days: 2, max_days: 3 },
{ pincode: 721402, min_days: 2, max_days: 3 },
{ pincode: 721403, min_days: 2, max_days: 3 },
{ pincode: 721404, min_days: 2, max_days: 3 },
{ pincode: 721405, min_days: 2, max_days: 3 },
{ pincode: 721406, min_days: 2, max_days: 3 },
{ pincode: 721420, min_days: 2, max_days: 3 },
{ pincode: 721421, min_days: 2, max_days: 3 },
{ pincode: 721422, min_days: 2, max_days: 3 },
{ pincode: 721423, min_days: 2, max_days: 3 },
{ pincode: 721424, min_days: 2, max_days: 3 },
{ pincode: 721425, min_days: 2, max_days: 3 },
{ pincode: 721426, min_days: 2, max_days: 3 },
{ pincode: 721427, min_days: 2, max_days: 3 },
{ pincode: 721428, min_days: 2, max_days: 3 },
{ pincode: 721429, min_days: 2, max_days: 3 },
{ pincode: 721430, min_days: 2, max_days: 3 },
{ pincode: 721431, min_days: 2, max_days: 3 },
{ pincode: 721432, min_days: 2, max_days: 3 },
{ pincode: 721433, min_days: 2, max_days: 3 },
{ pincode: 721434, min_days: 2, max_days: 3 },
{ pincode: 721435, min_days: 2, max_days: 3 },
{ pincode: 721436, min_days: 2, max_days: 3 },
{ pincode: 721437, min_days: 2, max_days: 3 },
{ pincode: 721438, min_days: 2, max_days: 3 },
{ pincode: 721439, min_days: 2, max_days: 3 },
{ pincode: 721440, min_days: 2, max_days: 3 },
{ pincode: 721441, min_days: 2, max_days: 3 },
{ pincode: 721442, min_days: 2, max_days: 3 },
{ pincode: 721443, min_days: 2, max_days: 3 },
{ pincode: 721444, min_days: 2, max_days: 3 },
{ pincode: 721445, min_days: 2, max_days: 3 },
{ pincode: 721446, min_days: 2, max_days: 3 },
{ pincode: 721447, min_days: 2, max_days: 3 },
{ pincode: 721448, min_days: 2, max_days: 3 },
{ pincode: 721449, min_days: 2, max_days: 3 },
{ pincode: 721450, min_days: 2, max_days: 3 },
{ pincode: 721451, min_days: 2, max_days: 3 },
{ pincode: 721452, min_days: 2, max_days: 3 },
{ pincode: 721453, min_days: 2, max_days: 3 },
{ pincode: 721454, min_days: 2, max_days: 3 },
{ pincode: 721455, min_days: 2, max_days: 3 },
{ pincode: 721456, min_days: 2, max_days: 3 },
{ pincode: 721457, min_days: 2, max_days: 3 },
{ pincode: 721458, min_days: 2, max_days: 3 },
{ pincode: 721459, min_days: 2, max_days: 3 },
{ pincode: 721460, min_days: 2, max_days: 3 },
{ pincode: 721461, min_days: 2, max_days: 3 },
{ pincode: 721463, min_days: 2, max_days: 3 },
{ pincode: 721464, min_days: 2, max_days: 3 },
{ pincode: 721466, min_days: 2, max_days: 3 },
{ pincode: 721467, min_days: 2, max_days: 3 },
{ pincode: 721501, min_days: 2, max_days: 3 },
{ pincode: 721502, min_days: 2, max_days: 3 },
{ pincode: 721503, min_days: 2, max_days: 3 },
{ pincode: 721504, min_days: 2, max_days: 3 },
{ pincode: 721505, min_days: 2, max_days: 3 },
{ pincode: 721506, min_days: 2, max_days: 3 },
{ pincode: 721507, min_days: 2, max_days: 3 },
{ pincode: 721513, min_days: 2, max_days: 3 },
{ pincode: 721514, min_days: 2, max_days: 3 },
{ pincode: 721515, min_days: 2, max_days: 3 },
{ pincode: 721516, min_days: 2, max_days: 3 },
{ pincode: 721517, min_days: 2, max_days: 3 },
{ pincode: 721518, min_days: 2, max_days: 3 },
{ pincode: 721519, min_days: 2, max_days: 3 },
{ pincode: 721601, min_days: 2, max_days: 3 },
{ pincode: 721602, min_days: 2, max_days: 3 },
{ pincode: 721603, min_days: 2, max_days: 3 },
{ pincode: 721604, min_days: 2, max_days: 3 },
{ pincode: 721605, min_days: 2, max_days: 3 },
{ pincode: 721606, min_days: 2, max_days: 3 },
{ pincode: 721607, min_days: 2, max_days: 3 },
{ pincode: 721624, min_days: 2, max_days: 3 },
{ pincode: 721625, min_days: 2, max_days: 3 },
{ pincode: 721626, min_days: 2, max_days: 3 },
{ pincode: 721627, min_days: 2, max_days: 3 },
{ pincode: 721628, min_days: 2, max_days: 3 },
{ pincode: 721629, min_days: 2, max_days: 3 },
{ pincode: 721630, min_days: 2, max_days: 3 },
{ pincode: 721631, min_days: 2, max_days: 3 },
{ pincode: 721632, min_days: 2, max_days: 3 },
{ pincode: 721633, min_days: 2, max_days: 3 },
{ pincode: 721634, min_days: 2, max_days: 3 },
{ pincode: 721635, min_days: 2, max_days: 3 },
{ pincode: 721636, min_days: 2, max_days: 3 },
{ pincode: 721637, min_days: 2, max_days: 3 },
{ pincode: 721638, min_days: 2, max_days: 3 },
{ pincode: 721641, min_days: 2, max_days: 3 },
{ pincode: 721642, min_days: 2, max_days: 3 },
{ pincode: 721643, min_days: 2, max_days: 3 },
{ pincode: 721644, min_days: 2, max_days: 3 },
{ pincode: 721645, min_days: 2, max_days: 3 },
{ pincode: 721646, min_days: 2, max_days: 3 },
{ pincode: 721647, min_days: 2, max_days: 3 },
{ pincode: 721648, min_days: 2, max_days: 3 },
{ pincode: 721649, min_days: 2, max_days: 3 },
{ pincode: 721650, min_days: 2, max_days: 3 },
{ pincode: 721651, min_days: 2, max_days: 3 },
{ pincode: 721652, min_days: 2, max_days: 3 },
{ pincode: 721653, min_days: 2, max_days: 3 },
{ pincode: 721654, min_days: 2, max_days: 3 },
{ pincode: 721655, min_days: 2, max_days: 3 },
{ pincode: 721656, min_days: 2, max_days: 3 },
{ pincode: 721657, min_days: 2, max_days: 3 },
{ pincode: 721658, min_days: 2, max_days: 3 },
{ pincode: 721659, min_days: 2, max_days: 3 },
{ pincode: 721660, min_days: 2, max_days: 3 },
{ pincode: 721661, min_days: 2, max_days: 3 },
{ pincode: 721662, min_days: 2, max_days: 3 },
{ pincode: 721663, min_days: 2, max_days: 3 },
{ pincode: 721664, min_days: 2, max_days: 3 },
{ pincode: 721665, min_days: 2, max_days: 3 },
{ pincode: 721666, min_days: 2, max_days: 3 },
{ pincode: 721668, min_days: 2, max_days: 3 },
{ pincode: 721669, min_days: 2, max_days: 3 },
{ pincode: 721670, min_days: 2, max_days: 3 },
{ pincode: 722101, min_days: 2, max_days: 3 },
{ pincode: 722102, min_days: 2, max_days: 3 },
{ pincode: 722103, min_days: 2, max_days: 3 },
{ pincode: 722107, min_days: 2, max_days: 3 },
{ pincode: 722110, min_days: 2, max_days: 3 },
{ pincode: 722111, min_days: 2, max_days: 3 },
{ pincode: 722112, min_days: 2, max_days: 3 },
{ pincode: 722121, min_days: 2, max_days: 3 },
{ pincode: 722122, min_days: 2, max_days: 3 },
{ pincode: 722132, min_days: 2, max_days: 3 },
{ pincode: 722133, min_days: 2, max_days: 3 },
{ pincode: 722134, min_days: 2, max_days: 3 },
{ pincode: 722135, min_days: 2, max_days: 3 },
{ pincode: 722136, min_days: 2, max_days: 3 },
{ pincode: 722137, min_days: 2, max_days: 3 },
{ pincode: 722138, min_days: 2, max_days: 3 },
{ pincode: 722139, min_days: 2, max_days: 3 },
{ pincode: 722140, min_days: 2, max_days: 3 },
{ pincode: 722141, min_days: 2, max_days: 3 },
{ pincode: 722142, min_days: 2, max_days: 3 },
{ pincode: 722143, min_days: 2, max_days: 3 },
{ pincode: 722144, min_days: 2, max_days: 3 },
{ pincode: 722145, min_days: 2, max_days: 3 },
{ pincode: 722146, min_days: 2, max_days: 3 },
{ pincode: 722147, min_days: 2, max_days: 3 },
{ pincode: 722148, min_days: 2, max_days: 3 },
{ pincode: 722149, min_days: 2, max_days: 3 },
{ pincode: 722150, min_days: 2, max_days: 3 },
{ pincode: 722151, min_days: 2, max_days: 3 },
{ pincode: 722152, min_days: 2, max_days: 3 },
{ pincode: 722153, min_days: 2, max_days: 3 },
{ pincode: 722154, min_days: 2, max_days: 3 },
{ pincode: 722155, min_days: 2, max_days: 3 },
{ pincode: 722156, min_days: 2, max_days: 3 },
{ pincode: 722157, min_days: 2, max_days: 3 },
{ pincode: 722158, min_days: 2, max_days: 3 },
{ pincode: 722159, min_days: 2, max_days: 3 },
{ pincode: 722160, min_days: 2, max_days: 3 },
{ pincode: 722161, min_days: 2, max_days: 3 },
{ pincode: 722162, min_days: 2, max_days: 3 },
{ pincode: 722163, min_days: 2, max_days: 3 },
{ pincode: 722164, min_days: 2, max_days: 3 },
{ pincode: 722165, min_days: 2, max_days: 3 },
{ pincode: 722166, min_days: 2, max_days: 3 },
{ pincode: 722168, min_days: 2, max_days: 3 },
{ pincode: 722169, min_days: 2, max_days: 3 },
{ pincode: 722170, min_days: 2, max_days: 3 },
{ pincode: 722171, min_days: 2, max_days: 3 },
{ pincode: 722172, min_days: 2, max_days: 3 },
{ pincode: 722173, min_days: 2, max_days: 3 },
{ pincode: 722174, min_days: 2, max_days: 3 },
{ pincode: 722175, min_days: 2, max_days: 3 },
{ pincode: 722176, min_days: 2, max_days: 3 },
{ pincode: 722177, min_days: 2, max_days: 3 },
{ pincode: 722178, min_days: 2, max_days: 3 },
{ pincode: 722179, min_days: 2, max_days: 3 },
{ pincode: 722180, min_days: 2, max_days: 3 },
{ pincode: 722181, min_days: 2, max_days: 3 },
{ pincode: 722182, min_days: 2, max_days: 3 },
{ pincode: 722183, min_days: 2, max_days: 3 },
{ pincode: 722201, min_days: 2, max_days: 3 },
{ pincode: 722202, min_days: 2, max_days: 3 },
{ pincode: 722203, min_days: 2, max_days: 3 },
{ pincode: 722204, min_days: 2, max_days: 3 },
{ pincode: 722205, min_days: 2, max_days: 3 },
{ pincode: 722206, min_days: 2, max_days: 3 },
{ pincode: 722207, min_days: 2, max_days: 3 },
{ pincode: 722208, min_days: 2, max_days: 3 },
{ pincode: 722209, min_days: 2, max_days: 3 },
{ pincode: 722222, min_days: 2, max_days: 3 },
{ pincode: 723101, min_days: 2, max_days: 3 },
{ pincode: 723102, min_days: 2, max_days: 3 },
{ pincode: 723103, min_days: 2, max_days: 3 },
{ pincode: 723104, min_days: 2, max_days: 3 },
{ pincode: 723121, min_days: 2, max_days: 3 },
{ pincode: 723126, min_days: 2, max_days: 3 },
{ pincode: 723127, min_days: 2, max_days: 3 },
{ pincode: 723128, min_days: 2, max_days: 3 },
{ pincode: 723129, min_days: 2, max_days: 3 },
{ pincode: 723130, min_days: 2, max_days: 3 },
{ pincode: 723131, min_days: 2, max_days: 3 },
{ pincode: 723132, min_days: 2, max_days: 3 },
{ pincode: 723133, min_days: 2, max_days: 3 },
{ pincode: 723142, min_days: 2, max_days: 3 },
{ pincode: 723143, min_days: 2, max_days: 3 },
{ pincode: 723144, min_days: 2, max_days: 3 },
{ pincode: 723145, min_days: 2, max_days: 3 },
{ pincode: 723146, min_days: 2, max_days: 3 },
{ pincode: 723147, min_days: 2, max_days: 3 },
{ pincode: 723148, min_days: 2, max_days: 3 },
{ pincode: 723149, min_days: 2, max_days: 3 },
{ pincode: 723150, min_days: 2, max_days: 3 },
{ pincode: 723151, min_days: 2, max_days: 3 },
{ pincode: 723152, min_days: 2, max_days: 3 },
{ pincode: 723153, min_days: 2, max_days: 3 },
{ pincode: 723154, min_days: 2, max_days: 3 },
{ pincode: 723155, min_days: 2, max_days: 3 },
{ pincode: 723156, min_days: 2, max_days: 3 },
{ pincode: 723157, min_days: 2, max_days: 3 },
{ pincode: 723158, min_days: 2, max_days: 3 },
{ pincode: 723159, min_days: 2, max_days: 3 },
{ pincode: 723160, min_days: 2, max_days: 3 },
{ pincode: 723161, min_days: 2, max_days: 3 },
{ pincode: 723162, min_days: 2, max_days: 3 },
{ pincode: 723163, min_days: 2, max_days: 3 },
{ pincode: 723164, min_days: 2, max_days: 3 },
{ pincode: 723165, min_days: 2, max_days: 3 },
{ pincode: 723166, min_days: 2, max_days: 3 },
{ pincode: 723167, min_days: 2, max_days: 3 },
{ pincode: 723168, min_days: 2, max_days: 3 },
{ pincode: 723201, min_days: 2, max_days: 3 },
{ pincode: 723202, min_days: 2, max_days: 3 },
{ pincode: 723212, min_days: 2, max_days: 3 },
{ pincode: 723213, min_days: 2, max_days: 3 },
{ pincode: 723214, min_days: 2, max_days: 3 },
{ pincode: 723215, min_days: 2, max_days: 3 },
{ pincode: 723216, min_days: 2, max_days: 3 },
{ pincode: 726206, min_days: 2, max_days: 3 },
{ pincode: 731101, min_days: 2, max_days: 3 },
{ pincode: 731102, min_days: 2, max_days: 3 },
{ pincode: 731103, min_days: 2, max_days: 3 },
{ pincode: 731104, min_days: 2, max_days: 3 },
{ pincode: 731121, min_days: 2, max_days: 3 },
{ pincode: 731122, min_days: 2, max_days: 3 },
{ pincode: 731123, min_days: 2, max_days: 3 },
{ pincode: 731124, min_days: 2, max_days: 3 },
{ pincode: 731125, min_days: 2, max_days: 3 },
{ pincode: 731126, min_days: 2, max_days: 3 },
{ pincode: 731127, min_days: 2, max_days: 3 },
{ pincode: 731129, min_days: 2, max_days: 3 },
{ pincode: 731130, min_days: 2, max_days: 3 },
{ pincode: 731131, min_days: 2, max_days: 3 },
{ pincode: 731132, min_days: 2, max_days: 3 },
{ pincode: 731133, min_days: 2, max_days: 3 },
{ pincode: 731134, min_days: 2, max_days: 3 },
{ pincode: 731135, min_days: 2, max_days: 3 },
{ pincode: 731136, min_days: 2, max_days: 3 },
{ pincode: 731139, min_days: 2, max_days: 3 },
{ pincode: 731144, min_days: 2, max_days: 3 },
{ pincode: 731146, min_days: 2, max_days: 3 },
{ pincode: 731147, min_days: 2, max_days: 3 },
{ pincode: 731201, min_days: 2, max_days: 3 },
{ pincode: 731202, min_days: 2, max_days: 3 },
{ pincode: 731203, min_days: 2, max_days: 3 },
{ pincode: 731204, min_days: 2, max_days: 3 },
{ pincode: 731212, min_days: 2, max_days: 3 },
{ pincode: 731213, min_days: 2, max_days: 3 },
{ pincode: 731214, min_days: 2, max_days: 3 },
{ pincode: 731215, min_days: 2, max_days: 3 },
{ pincode: 731216, min_days: 2, max_days: 3 },
{ pincode: 731217, min_days: 2, max_days: 3 },
{ pincode: 731218, min_days: 2, max_days: 3 },
{ pincode: 731219, min_days: 2, max_days: 3 },
{ pincode: 731220, min_days: 2, max_days: 3 },
{ pincode: 731221, min_days: 2, max_days: 3 },
{ pincode: 731222, min_days: 2, max_days: 3 },
{ pincode: 731223, min_days: 2, max_days: 3 },
{ pincode: 731224, min_days: 2, max_days: 3 },
{ pincode: 731233, min_days: 2, max_days: 3 },
{ pincode: 731234, min_days: 2, max_days: 3 },
{ pincode: 731235, min_days: 2, max_days: 3 },
{ pincode: 731236, min_days: 2, max_days: 3 },
{ pincode: 731237, min_days: 2, max_days: 3 },
{ pincode: 731238, min_days: 2, max_days: 3 },
{ pincode: 731239, min_days: 2, max_days: 3 },
{ pincode: 731240, min_days: 2, max_days: 3 },
{ pincode: 731241, min_days: 2, max_days: 3 },
{ pincode: 731242, min_days: 2, max_days: 3 },
{ pincode: 731243, min_days: 2, max_days: 3 },
{ pincode: 731244, min_days: 2, max_days: 3 },
{ pincode: 731245, min_days: 2, max_days: 3 },
{ pincode: 731246, min_days: 2, max_days: 3 },
{ pincode: 731247, min_days: 2, max_days: 3 },
{ pincode: 731249, min_days: 2, max_days: 3 },
{ pincode: 731250, min_days: 2, max_days: 3 },
{ pincode: 731251, min_days: 2, max_days: 3 },
{ pincode: 731252, min_days: 2, max_days: 3 },
{ pincode: 731253, min_days: 2, max_days: 3 },
{ pincode: 731254, min_days: 2, max_days: 3 },
{ pincode: 731255, min_days: 2, max_days: 3 },
{ pincode: 731284, min_days: 2, max_days: 3 },
{ pincode: 731301, min_days: 2, max_days: 3 },
{ pincode: 731302, min_days: 2, max_days: 3 },
{ pincode: 731303, min_days: 2, max_days: 3 },
{ pincode: 731304, min_days: 2, max_days: 3 },
{ pincode: 732001, min_days: 2, max_days: 3 },
{ pincode: 732013, min_days: 2, max_days: 3 },
{ pincode: 732101, min_days: 2, max_days: 3 },
{ pincode: 732102, min_days: 2, max_days: 3 },
{ pincode: 732103, min_days: 2, max_days: 3 },
{ pincode: 732104, min_days: 2, max_days: 3 },
{ pincode: 732121, min_days: 2, max_days: 3 },
{ pincode: 732122, min_days: 2, max_days: 3 },
{ pincode: 732123, min_days: 2, max_days: 3 },
{ pincode: 732124, min_days: 2, max_days: 3 },
{ pincode: 732125, min_days: 2, max_days: 3 },
{ pincode: 732126, min_days: 2, max_days: 3 },
{ pincode: 732127, min_days: 2, max_days: 3 },
{ pincode: 732128, min_days: 2, max_days: 3 },
{ pincode: 732138, min_days: 2, max_days: 3 },
{ pincode: 732139, min_days: 2, max_days: 3 },
{ pincode: 732140, min_days: 2, max_days: 3 },
{ pincode: 732141, min_days: 2, max_days: 3 },
{ pincode: 732142, min_days: 2, max_days: 3 },
{ pincode: 732143, min_days: 2, max_days: 3 },
{ pincode: 732144, min_days: 2, max_days: 3 },
{ pincode: 732145, min_days: 2, max_days: 3 },
{ pincode: 732146, min_days: 2, max_days: 3 },
{ pincode: 732147, min_days: 2, max_days: 3 },
{ pincode: 732148, min_days: 2, max_days: 3 },
{ pincode: 732149, min_days: 2, max_days: 3 },
{ pincode: 732150, min_days: 2, max_days: 3 },
{ pincode: 732151, min_days: 2, max_days: 3 },
{ pincode: 732152, min_days: 2, max_days: 3 },
{ pincode: 732153, min_days: 2, max_days: 3 },
{ pincode: 732154, min_days: 2, max_days: 3 },
{ pincode: 732155, min_days: 2, max_days: 3 },
{ pincode: 732156, min_days: 2, max_days: 3 },
{ pincode: 732157, min_days: 2, max_days: 3 },
{ pincode: 732158, min_days: 2, max_days: 3 },
{ pincode: 732159, min_days: 2, max_days: 3 },
{ pincode: 732160, min_days: 2, max_days: 3 },
{ pincode: 732161, min_days: 2, max_days: 3 },
{ pincode: 732162, min_days: 2, max_days: 3 },
{ pincode: 732163, min_days: 2, max_days: 3 },
{ pincode: 732201, min_days: 2, max_days: 3 },
{ pincode: 732202, min_days: 2, max_days: 3 },
{ pincode: 732203, min_days: 2, max_days: 3 },
{ pincode: 732204, min_days: 2, max_days: 3 },
{ pincode: 732205, min_days: 2, max_days: 3 },
{ pincode: 732206, min_days: 2, max_days: 3 },
{ pincode: 732207, min_days: 2, max_days: 3 },
{ pincode: 732208, min_days: 2, max_days: 3 },
{ pincode: 732209, min_days: 2, max_days: 3 },
{ pincode: 732210, min_days: 2, max_days: 3 },
{ pincode: 732211, min_days: 2, max_days: 3 },
{ pincode: 732212, min_days: 2, max_days: 3 },
{ pincode: 732213, min_days: 2, max_days: 3 },
{ pincode: 732214, min_days: 2, max_days: 3 },
{ pincode: 732215, min_days: 2, max_days: 3 },
{ pincode: 732216, min_days: 2, max_days: 3 },
{ pincode: 732236, min_days: 2, max_days: 3 },
{ pincode: 732312, min_days: 2, max_days: 3 },
{ pincode: 732706, min_days: 2, max_days: 3 },
{ pincode: 733006, min_days: 2, max_days: 3 },
{ pincode: 733101, min_days: 2, max_days: 3 },
{ pincode: 733102, min_days: 2, max_days: 3 },
{ pincode: 733103, min_days: 2, max_days: 3 },
{ pincode: 733121, min_days: 2, max_days: 3 },
{ pincode: 733123, min_days: 2, max_days: 3 },
{ pincode: 733124, min_days: 2, max_days: 3 },
{ pincode: 733125, min_days: 2, max_days: 3 },
{ pincode: 733126, min_days: 2, max_days: 3 },
{ pincode: 733127, min_days: 2, max_days: 3 },
{ pincode: 733128, min_days: 2, max_days: 3 },
{ pincode: 733129, min_days: 2, max_days: 3 },
{ pincode: 733130, min_days: 2, max_days: 3 },
{ pincode: 733131, min_days: 2, max_days: 3 },
{ pincode: 733132, min_days: 2, max_days: 3 },
{ pincode: 733133, min_days: 2, max_days: 3 },
{ pincode: 733134, min_days: 2, max_days: 3 },
{ pincode: 733140, min_days: 2, max_days: 3 },
{ pincode: 733141, min_days: 2, max_days: 3 },
{ pincode: 733142, min_days: 2, max_days: 3 },
{ pincode: 733143, min_days: 2, max_days: 3 },
{ pincode: 733144, min_days: 2, max_days: 3 },
{ pincode: 733145, min_days: 2, max_days: 3 },
{ pincode: 733146, min_days: 2, max_days: 3 },
{ pincode: 733147, min_days: 2, max_days: 3 },
{ pincode: 733148, min_days: 2, max_days: 3 },
{ pincode: 733149, min_days: 2, max_days: 3 },
{ pincode: 733150, min_days: 2, max_days: 3 },
{ pincode: 733151, min_days: 2, max_days: 3 },
{ pincode: 733153, min_days: 2, max_days: 3 },
{ pincode: 733154, min_days: 2, max_days: 3 },
{ pincode: 733155, min_days: 2, max_days: 3 },
{ pincode: 733156, min_days: 2, max_days: 3 },
{ pincode: 733157, min_days: 2, max_days: 3 },
{ pincode: 733158, min_days: 2, max_days: 3 },
{ pincode: 733201, min_days: 2, max_days: 3 },
{ pincode: 733202, min_days: 2, max_days: 3 },
{ pincode: 733207, min_days: 2, max_days: 3 },
{ pincode: 733208, min_days: 2, max_days: 3 },
{ pincode: 733209, min_days: 2, max_days: 3 },
{ pincode: 733210, min_days: 2, max_days: 3 },
{ pincode: 733211, min_days: 2, max_days: 3 },
{ pincode: 733212, min_days: 2, max_days: 3 },
{ pincode: 733213, min_days: 2, max_days: 3 },
{ pincode: 733214, min_days: 2, max_days: 3 },
{ pincode: 733215, min_days: 2, max_days: 3 },
{ pincode: 733216, min_days: 2, max_days: 3 },
{ pincode: 733246, min_days: 2, max_days: 3 },
{ pincode: 733252, min_days: 2, max_days: 3 },
{ pincode: 733302, min_days: 2, max_days: 3 },
{ pincode: 734001, min_days: 2, max_days: 3 },
{ pincode: 734002, min_days: 2, max_days: 3 },
{ pincode: 734003, min_days: 2, max_days: 3 },
{ pincode: 734004, min_days: 2, max_days: 3 },
{ pincode: 734005, min_days: 2, max_days: 3 },
{ pincode: 734006, min_days: 2, max_days: 3 },
{ pincode: 734007, min_days: 2, max_days: 3 },
{ pincode: 734008, min_days: 2, max_days: 3 },
{ pincode: 734009, min_days: 2, max_days: 3 },
{ pincode: 734010, min_days: 2, max_days: 3 },
{ pincode: 734011, min_days: 2, max_days: 3 },
{ pincode: 734012, min_days: 2, max_days: 3 },
{ pincode: 734013, min_days: 2, max_days: 3 },
{ pincode: 734014, min_days: 2, max_days: 3 },
{ pincode: 734015, min_days: 2, max_days: 3 },
{ pincode: 734016, min_days: 2, max_days: 3 },
{ pincode: 734018, min_days: 2, max_days: 3 },
{ pincode: 734025, min_days: 2, max_days: 3 },
{ pincode: 734100, min_days: 2, max_days: 3 },
{ pincode: 734101, min_days: 2, max_days: 3 },
{ pincode: 734102, min_days: 2, max_days: 3 },
{ pincode: 734103, min_days: 2, max_days: 3 },
{ pincode: 734104, min_days: 2, max_days: 3 },
{ pincode: 734105, min_days: 2, max_days: 3 },
{ pincode: 734121, min_days: 2, max_days: 3 },
{ pincode: 734122, min_days: 2, max_days: 3 },
{ pincode: 734123, min_days: 2, max_days: 3 },
{ pincode: 734124, min_days: 2, max_days: 3 },
{ pincode: 734201, min_days: 2, max_days: 3 },
{ pincode: 734203, min_days: 2, max_days: 3 },
{ pincode: 734204, min_days: 2, max_days: 3 },
{ pincode: 734209, min_days: 2, max_days: 3 },
{ pincode: 734213, min_days: 2, max_days: 3 },
{ pincode: 734214, min_days: 2, max_days: 3 },
{ pincode: 734215, min_days: 2, max_days: 3 },
{ pincode: 734216, min_days: 2, max_days: 3 },
{ pincode: 734217, min_days: 2, max_days: 3 },
{ pincode: 734218, min_days: 2, max_days: 3 },
{ pincode: 734219, min_days: 2, max_days: 3 },
{ pincode: 734220, min_days: 2, max_days: 3 },
{ pincode: 734221, min_days: 2, max_days: 3 },
{ pincode: 734222, min_days: 2, max_days: 3 },
{ pincode: 734223, min_days: 2, max_days: 3 },
{ pincode: 734224, min_days: 2, max_days: 3 },
{ pincode: 734225, min_days: 2, max_days: 3 },
{ pincode: 734226, min_days: 2, max_days: 3 },
{ pincode: 734227, min_days: 2, max_days: 3 },
{ pincode: 734301, min_days: 2, max_days: 3 },
{ pincode: 734311, min_days: 2, max_days: 3 },
{ pincode: 734312, min_days: 2, max_days: 3 },
{ pincode: 734313, min_days: 2, max_days: 3 },
{ pincode: 734314, min_days: 2, max_days: 3 },
{ pincode: 734315, min_days: 2, max_days: 3 },
{ pincode: 734316, min_days: 2, max_days: 3 },
{ pincode: 734317, min_days: 2, max_days: 3 },
{ pincode: 734318, min_days: 2, max_days: 3 },
{ pincode: 734320, min_days: 2, max_days: 3 },
{ pincode: 734321, min_days: 2, max_days: 3 },
{ pincode: 734325, min_days: 2, max_days: 3 },
{ pincode: 734333, min_days: 2, max_days: 3 },
{ pincode: 734401, min_days: 2, max_days: 3 },
{ pincode: 734402, min_days: 2, max_days: 3 },
{ pincode: 734403, min_days: 2, max_days: 3 },
{ pincode: 734404, min_days: 2, max_days: 3 },
{ pincode: 734405, min_days: 2, max_days: 3 },
{ pincode: 734406, min_days: 2, max_days: 3 },
{ pincode: 734407, min_days: 2, max_days: 3 },
{ pincode: 734418, min_days: 2, max_days: 3 },
{ pincode: 734421, min_days: 2, max_days: 3 },
{ pincode: 734422, min_days: 2, max_days: 3 },
{ pincode: 734423, min_days: 2, max_days: 3 },
{ pincode: 734424, min_days: 2, max_days: 3 },
{ pincode: 734425, min_days: 2, max_days: 3 },
{ pincode: 734426, min_days: 2, max_days: 3 },
{ pincode: 734427, min_days: 2, max_days: 3 },
{ pincode: 734428, min_days: 2, max_days: 3 },
{ pincode: 734429, min_days: 2, max_days: 3 },
{ pincode: 734430, min_days: 2, max_days: 3 },
{ pincode: 734431, min_days: 2, max_days: 3 },
{ pincode: 734432, min_days: 2, max_days: 3 },
{ pincode: 734433, min_days: 2, max_days: 3 },
{ pincode: 734434, min_days: 2, max_days: 3 },
{ pincode: 734436, min_days: 2, max_days: 3 },
{ pincode: 734501, min_days: 2, max_days: 3 },
{ pincode: 734502, min_days: 2, max_days: 3 },
{ pincode: 734503, min_days: 2, max_days: 3 },
{ pincode: 735101, min_days: 2, max_days: 3 },
{ pincode: 735102, min_days: 2, max_days: 3 },
{ pincode: 735121, min_days: 2, max_days: 3 },
{ pincode: 735122, min_days: 2, max_days: 3 },
{ pincode: 735132, min_days: 2, max_days: 3 },
{ pincode: 735133, min_days: 2, max_days: 3 },
{ pincode: 735134, min_days: 2, max_days: 3 },
{ pincode: 735135, min_days: 2, max_days: 3 },
{ pincode: 735136, min_days: 2, max_days: 3 },
{ pincode: 735137, min_days: 2, max_days: 3 },
{ pincode: 735138, min_days: 2, max_days: 3 },
{ pincode: 735139, min_days: 2, max_days: 3 },
{ pincode: 735140, min_days: 2, max_days: 3 },
{ pincode: 735152, min_days: 2, max_days: 3 },
{ pincode: 735201, min_days: 2, max_days: 3 },
{ pincode: 735202, min_days: 2, max_days: 3 },
{ pincode: 735203, min_days: 2, max_days: 3 },
{ pincode: 735204, min_days: 2, max_days: 3 },
{ pincode: 735205, min_days: 2, max_days: 3 },
{ pincode: 735206, min_days: 2, max_days: 3 },
{ pincode: 735207, min_days: 2, max_days: 3 },
{ pincode: 735208, min_days: 2, max_days: 3 },
{ pincode: 735209, min_days: 2, max_days: 3 },
{ pincode: 735210, min_days: 2, max_days: 3 },
{ pincode: 735211, min_days: 2, max_days: 3 },
{ pincode: 735212, min_days: 2, max_days: 3 },
{ pincode: 735213, min_days: 2, max_days: 3 },
{ pincode: 735214, min_days: 2, max_days: 3 },
{ pincode: 735215, min_days: 2, max_days: 3 },
{ pincode: 735216, min_days: 2, max_days: 3 },
{ pincode: 735217, min_days: 2, max_days: 3 },
{ pincode: 735218, min_days: 2, max_days: 3 },
{ pincode: 735219, min_days: 2, max_days: 3 },
{ pincode: 735220, min_days: 2, max_days: 3 },
{ pincode: 735221, min_days: 2, max_days: 3 },
{ pincode: 735222, min_days: 2, max_days: 3 },
{ pincode: 735223, min_days: 2, max_days: 3 },
{ pincode: 735224, min_days: 2, max_days: 3 },
{ pincode: 735225, min_days: 2, max_days: 3 },
{ pincode: 735226, min_days: 2, max_days: 3 },
{ pincode: 735227, min_days: 2, max_days: 3 },
{ pincode: 735228, min_days: 2, max_days: 3 },
{ pincode: 735229, min_days: 2, max_days: 3 },
{ pincode: 735230, min_days: 2, max_days: 3 },
{ pincode: 735231, min_days: 2, max_days: 3 },
{ pincode: 735232, min_days: 2, max_days: 3 },
{ pincode: 735233, min_days: 2, max_days: 3 },
{ pincode: 735234, min_days: 2, max_days: 3 },
{ pincode: 735235, min_days: 2, max_days: 3 },
{ pincode: 735236, min_days: 2, max_days: 3 },
{ pincode: 735237, min_days: 2, max_days: 3 },
{ pincode: 735238, min_days: 2, max_days: 3 },
{ pincode: 735251, min_days: 2, max_days: 3 },
{ pincode: 735301, min_days: 2, max_days: 3 },
{ pincode: 735302, min_days: 2, max_days: 3 },
{ pincode: 735303, min_days: 2, max_days: 3 },
{ pincode: 735304, min_days: 2, max_days: 3 },
{ pincode: 735305, min_days: 2, max_days: 3 },
{ pincode: 735306, min_days: 2, max_days: 3 },
{ pincode: 735307, min_days: 2, max_days: 3 },
{ pincode: 735308, min_days: 2, max_days: 3 },
{ pincode: 735350, min_days: 2, max_days: 3 },
{ pincode: 735503, min_days: 2, max_days: 3 },
{ pincode: 735505, min_days: 2, max_days: 3 },
{ pincode: 736101, min_days: 2, max_days: 3 },
{ pincode: 736102, min_days: 2, max_days: 3 },
{ pincode: 736118, min_days: 2, max_days: 3 },
{ pincode: 736121, min_days: 2, max_days: 3 },
{ pincode: 736122, min_days: 2, max_days: 3 },
{ pincode: 736123, min_days: 2, max_days: 3 },
{ pincode: 736131, min_days: 2, max_days: 3 },
{ pincode: 736132, min_days: 2, max_days: 3 },
{ pincode: 736133, min_days: 2, max_days: 3 },
{ pincode: 736134, min_days: 2, max_days: 3 },
{ pincode: 736135, min_days: 2, max_days: 3 },
{ pincode: 736136, min_days: 2, max_days: 3 },
{ pincode: 736145, min_days: 2, max_days: 3 },
{ pincode: 736146, min_days: 2, max_days: 3 },
{ pincode: 736156, min_days: 2, max_days: 3 },
{ pincode: 736157, min_days: 2, max_days: 3 },
{ pincode: 736158, min_days: 2, max_days: 3 },
{ pincode: 736159, min_days: 2, max_days: 3 },
{ pincode: 736160, min_days: 2, max_days: 3 },
{ pincode: 736162, min_days: 2, max_days: 3 },
{ pincode: 736165, min_days: 2, max_days: 3 },
{ pincode: 736166, min_days: 2, max_days: 3 },
{ pincode: 736167, min_days: 2, max_days: 3 },
{ pincode: 736168, min_days: 2, max_days: 3 },
{ pincode: 736169, min_days: 2, max_days: 3 },
{ pincode: 736170, min_days: 2, max_days: 3 },
{ pincode: 736171, min_days: 2, max_days: 3 },
{ pincode: 736172, min_days: 2, max_days: 3 },
{ pincode: 736173, min_days: 2, max_days: 3 },
{ pincode: 736174, min_days: 2, max_days: 3 },
{ pincode: 736175, min_days: 2, max_days: 3 },
{ pincode: 736176, min_days: 2, max_days: 3 },
{ pincode: 736177, min_days: 2, max_days: 3 },
{ pincode: 736179, min_days: 2, max_days: 3 },
{ pincode: 736180, min_days: 2, max_days: 3 },
{ pincode: 736181, min_days: 2, max_days: 3 },
{ pincode: 736182, min_days: 2, max_days: 3 },
{ pincode: 736201, min_days: 2, max_days: 3 },
{ pincode: 736202, min_days: 2, max_days: 3 },
{ pincode: 736203, min_days: 2, max_days: 3 },
{ pincode: 736204, min_days: 2, max_days: 3 },
{ pincode: 736205, min_days: 2, max_days: 3 },
{ pincode: 736206, min_days: 2, max_days: 3 },
{ pincode: 736207, min_days: 2, max_days: 3 },
{ pincode: 736208, min_days: 2, max_days: 3 },
{ pincode: 736257, min_days: 2, max_days: 3 },
{ pincode: 736358, min_days: 2, max_days: 3 },
{ pincode: 737101, min_days: 2, max_days: 3 },
{ pincode: 737102, min_days: 2, max_days: 3 },
{ pincode: 737103, min_days: 2, max_days: 3 },
{ pincode: 737106, min_days: 2, max_days: 3 },
{ pincode: 737107, min_days: 2, max_days: 3 },
{ pincode: 737111, min_days: 2, max_days: 3 },
{ pincode: 737113, min_days: 2, max_days: 3 },
{ pincode: 737116, min_days: 2, max_days: 3 },
{ pincode: 737120, min_days: 2, max_days: 3 },
{ pincode: 737121, min_days: 2, max_days: 3 },
{ pincode: 737126, min_days: 2, max_days: 3 },
{ pincode: 737128, min_days: 2, max_days: 3 },
{ pincode: 737131, min_days: 2, max_days: 3 },
{ pincode: 737132, min_days: 2, max_days: 3 },
{ pincode: 737133, min_days: 2, max_days: 3 },
{ pincode: 737134, min_days: 2, max_days: 3 },
{ pincode: 737135, min_days: 2, max_days: 3 },
{ pincode: 737136, min_days: 2, max_days: 3 },
{ pincode: 737139, min_days: 2, max_days: 3 },
{ pincode: 738001, min_days: 2, max_days: 3 },
{ pincode: 741001, min_days: 2, max_days: 3 },
{ pincode: 741101, min_days: 2, max_days: 3 },
{ pincode: 741102, min_days: 2, max_days: 3 },
{ pincode: 741103, min_days: 2, max_days: 3 },
{ pincode: 741104, min_days: 2, max_days: 3 },
{ pincode: 741111, min_days: 2, max_days: 3 },
{ pincode: 741121, min_days: 2, max_days: 3 },
{ pincode: 741122, min_days: 2, max_days: 3 },
{ pincode: 741123, min_days: 2, max_days: 3 },
{ pincode: 741124, min_days: 2, max_days: 3 },
{ pincode: 741125, min_days: 2, max_days: 3 },
{ pincode: 741126, min_days: 2, max_days: 3 },
{ pincode: 741127, min_days: 2, max_days: 3 },
{ pincode: 741137, min_days: 2, max_days: 3 },
{ pincode: 741138, min_days: 2, max_days: 3 },
{ pincode: 741139, min_days: 2, max_days: 3 },
{ pincode: 741140, min_days: 2, max_days: 3 },
{ pincode: 741150, min_days: 2, max_days: 3 },
{ pincode: 741151, min_days: 2, max_days: 3 },
{ pincode: 741152, min_days: 2, max_days: 3 },
{ pincode: 741153, min_days: 2, max_days: 3 },
{ pincode: 741154, min_days: 2, max_days: 3 },
{ pincode: 741155, min_days: 2, max_days: 3 },
{ pincode: 741156, min_days: 2, max_days: 3 },
{ pincode: 741157, min_days: 2, max_days: 3 },
{ pincode: 741158, min_days: 2, max_days: 3 },
{ pincode: 741159, min_days: 2, max_days: 3 },
{ pincode: 741160, min_days: 2, max_days: 3 },
{ pincode: 741161, min_days: 2, max_days: 3 },
{ pincode: 741162, min_days: 2, max_days: 3 },
{ pincode: 741163, min_days: 2, max_days: 3 },
{ pincode: 741164, min_days: 2, max_days: 3 },
{ pincode: 741165, min_days: 2, max_days: 3 },
{ pincode: 741166, min_days: 2, max_days: 3 },
{ pincode: 741167, min_days: 2, max_days: 3 },
{ pincode: 741168, min_days: 2, max_days: 3 },
{ pincode: 741169, min_days: 2, max_days: 3 },
{ pincode: 741170, min_days: 2, max_days: 3 },
{ pincode: 741171, min_days: 2, max_days: 3 },
{ pincode: 741172, min_days: 2, max_days: 3 },
{ pincode: 741173, min_days: 2, max_days: 3 },
{ pincode: 741174, min_days: 2, max_days: 3 },
{ pincode: 741175, min_days: 2, max_days: 3 },
{ pincode: 741176, min_days: 2, max_days: 3 },
{ pincode: 741177, min_days: 2, max_days: 3 },
{ pincode: 741178, min_days: 2, max_days: 3 },
{ pincode: 741179, min_days: 2, max_days: 3 },
{ pincode: 741180, min_days: 2, max_days: 3 },
{ pincode: 741181, min_days: 2, max_days: 3 },
{ pincode: 741182, min_days: 2, max_days: 3 },
{ pincode: 741183, min_days: 2, max_days: 3 },
{ pincode: 741184, min_days: 2, max_days: 3 },
{ pincode: 741185, min_days: 2, max_days: 3 },
{ pincode: 741186, min_days: 2, max_days: 3 },
{ pincode: 741187, min_days: 2, max_days: 3 },
{ pincode: 741188, min_days: 2, max_days: 3 },
{ pincode: 741189, min_days: 2, max_days: 3 },
{ pincode: 741190, min_days: 2, max_days: 3 },
{ pincode: 741192, min_days: 2, max_days: 3 },
{ pincode: 741193, min_days: 2, max_days: 3 },
{ pincode: 741194, min_days: 2, max_days: 3 },
{ pincode: 741195, min_days: 2, max_days: 3 },
{ pincode: 741196, min_days: 2, max_days: 3 },
{ pincode: 741197, min_days: 2, max_days: 3 },
{ pincode: 741198, min_days: 2, max_days: 3 },
{ pincode: 741199, min_days: 2, max_days: 3 },
{ pincode: 741201, min_days: 2, max_days: 3 },
{ pincode: 741202, min_days: 2, max_days: 3 },
{ pincode: 741203, min_days: 2, max_days: 3 },
{ pincode: 741221, min_days: 2, max_days: 3 },
{ pincode: 741222, min_days: 2, max_days: 3 },
{ pincode: 741223, min_days: 2, max_days: 3 },
{ pincode: 741224, min_days: 2, max_days: 3 },
{ pincode: 741225, min_days: 2, max_days: 3 },
{ pincode: 741232, min_days: 2, max_days: 3 },
{ pincode: 741233, min_days: 2, max_days: 3 },
{ pincode: 741234, min_days: 2, max_days: 3 },
{ pincode: 741235, min_days: 2, max_days: 3 },
{ pincode: 741236, min_days: 2, max_days: 3 },
{ pincode: 741238, min_days: 2, max_days: 3 },
{ pincode: 741243, min_days: 2, max_days: 3 },
{ pincode: 741245, min_days: 2, max_days: 3 },
{ pincode: 741246, min_days: 2, max_days: 3 },
{ pincode: 741247, min_days: 2, max_days: 3 },
{ pincode: 741248, min_days: 2, max_days: 3 },
{ pincode: 741249, min_days: 2, max_days: 3 },
{ pincode: 741250, min_days: 2, max_days: 3 },
{ pincode: 741251, min_days: 2, max_days: 3 },
{ pincode: 741252, min_days: 2, max_days: 3 },
{ pincode: 741253, min_days: 2, max_days: 3 },
{ pincode: 741254, min_days: 2, max_days: 3 },
{ pincode: 741255, min_days: 2, max_days: 3 },
{ pincode: 741256, min_days: 2, max_days: 3 },
{ pincode: 741257, min_days: 2, max_days: 3 },
{ pincode: 741258, min_days: 2, max_days: 3 },
{ pincode: 741301, min_days: 2, max_days: 3 },
{ pincode: 741302, min_days: 2, max_days: 3 },
{ pincode: 741312, min_days: 2, max_days: 3 },
{ pincode: 741313, min_days: 2, max_days: 3 },
{ pincode: 741314, min_days: 2, max_days: 3 },
{ pincode: 741315, min_days: 2, max_days: 3 },
{ pincode: 741316, min_days: 2, max_days: 3 },
{ pincode: 741317, min_days: 2, max_days: 3 },
{ pincode: 741318, min_days: 2, max_days: 3 },
{ pincode: 741319, min_days: 2, max_days: 3 },
{ pincode: 741401, min_days: 2, max_days: 3 },
{ pincode: 741402, min_days: 2, max_days: 3 },
{ pincode: 741403, min_days: 2, max_days: 3 },
{ pincode: 741404, min_days: 2, max_days: 3 },
{ pincode: 741405, min_days: 2, max_days: 3 },
{ pincode: 741501, min_days: 2, max_days: 3 },
{ pincode: 741502, min_days: 2, max_days: 3 },
{ pincode: 741503, min_days: 2, max_days: 3 },
{ pincode: 741504, min_days: 2, max_days: 3 },
{ pincode: 741505, min_days: 2, max_days: 3 },
{ pincode: 741506, min_days: 2, max_days: 3 },
{ pincode: 741507, min_days: 2, max_days: 3 },
{ pincode: 741508, min_days: 2, max_days: 3 },
{ pincode: 741509, min_days: 2, max_days: 3 },
{ pincode: 741510, min_days: 2, max_days: 3 },
{ pincode: 741511, min_days: 2, max_days: 3 },
{ pincode: 741512, min_days: 2, max_days: 3 },
{ pincode: 741513, min_days: 2, max_days: 3 },
{ pincode: 741514, min_days: 2, max_days: 3 },
{ pincode: 741515, min_days: 2, max_days: 3 },
{ pincode: 741516, min_days: 2, max_days: 3 },
{ pincode: 742000, min_days: 2, max_days: 3 },
{ pincode: 742101, min_days: 2, max_days: 3 },
{ pincode: 742102, min_days: 2, max_days: 3 },
{ pincode: 742103, min_days: 2, max_days: 3 },
{ pincode: 742104, min_days: 2, max_days: 3 },
{ pincode: 742109, min_days: 2, max_days: 3 },
{ pincode: 742113, min_days: 2, max_days: 3 },
{ pincode: 742121, min_days: 2, max_days: 3 },
{ pincode: 742122, min_days: 2, max_days: 3 },
{ pincode: 742123, min_days: 2, max_days: 3 },
{ pincode: 742124, min_days: 2, max_days: 3 },
{ pincode: 742131, min_days: 2, max_days: 3 },
{ pincode: 742132, min_days: 2, max_days: 3 },
{ pincode: 742133, min_days: 2, max_days: 3 },
{ pincode: 742134, min_days: 2, max_days: 3 },
{ pincode: 742135, min_days: 2, max_days: 3 },
{ pincode: 742136, min_days: 2, max_days: 3 },
{ pincode: 742137, min_days: 2, max_days: 3 },
{ pincode: 742138, min_days: 2, max_days: 3 },
{ pincode: 742139, min_days: 2, max_days: 3 },
{ pincode: 742140, min_days: 2, max_days: 3 },
{ pincode: 742147, min_days: 2, max_days: 3 },
{ pincode: 742148, min_days: 2, max_days: 3 },
{ pincode: 742149, min_days: 2, max_days: 3 },
{ pincode: 742150, min_days: 2, max_days: 3 },
{ pincode: 742151, min_days: 2, max_days: 3 },
{ pincode: 742152, min_days: 2, max_days: 3 },
{ pincode: 742156, min_days: 2, max_days: 3 },
{ pincode: 742157, min_days: 2, max_days: 3 },
{ pincode: 742159, min_days: 2, max_days: 3 },
{ pincode: 742160, min_days: 2, max_days: 3 },
{ pincode: 742161, min_days: 2, max_days: 3 },
{ pincode: 742162, min_days: 2, max_days: 3 },
{ pincode: 742163, min_days: 2, max_days: 3 },
{ pincode: 742164, min_days: 2, max_days: 3 },
{ pincode: 742165, min_days: 2, max_days: 3 },
{ pincode: 742166, min_days: 2, max_days: 3 },
{ pincode: 742167, min_days: 2, max_days: 3 },
{ pincode: 742168, min_days: 2, max_days: 3 },
{ pincode: 742169, min_days: 2, max_days: 3 },
{ pincode: 742170, min_days: 2, max_days: 3 },
{ pincode: 742171, min_days: 2, max_days: 3 },
{ pincode: 742172, min_days: 2, max_days: 3 },
{ pincode: 742173, min_days: 2, max_days: 3 },
{ pincode: 742174, min_days: 2, max_days: 3 },
{ pincode: 742175, min_days: 2, max_days: 3 },
{ pincode: 742176, min_days: 2, max_days: 3 },
{ pincode: 742177, min_days: 2, max_days: 3 },
{ pincode: 742178, min_days: 2, max_days: 3 },
{ pincode: 742179, min_days: 2, max_days: 3 },
{ pincode: 742180, min_days: 2, max_days: 3 },
{ pincode: 742181, min_days: 2, max_days: 3 },
{ pincode: 742182, min_days: 2, max_days: 3 },
{ pincode: 742183, min_days: 2, max_days: 3 },
{ pincode: 742184, min_days: 2, max_days: 3 },
{ pincode: 742185, min_days: 2, max_days: 3 },
{ pincode: 742186, min_days: 2, max_days: 3 },
{ pincode: 742187, min_days: 2, max_days: 3 },
{ pincode: 742188, min_days: 2, max_days: 3 },
{ pincode: 742189, min_days: 2, max_days: 3 },
{ pincode: 742190, min_days: 2, max_days: 3 },
{ pincode: 742191, min_days: 2, max_days: 3 },
{ pincode: 742201, min_days: 2, max_days: 3 },
{ pincode: 742202, min_days: 2, max_days: 3 },
{ pincode: 742212, min_days: 2, max_days: 3 },
{ pincode: 742213, min_days: 2, max_days: 3 },
{ pincode: 742223, min_days: 2, max_days: 3 },
{ pincode: 742224, min_days: 2, max_days: 3 },
{ pincode: 742225, min_days: 2, max_days: 3 },
{ pincode: 742226, min_days: 2, max_days: 3 },
{ pincode: 742227, min_days: 2, max_days: 3 },
{ pincode: 742229, min_days: 2, max_days: 3 },
{ pincode: 742230, min_days: 2, max_days: 3 },
{ pincode: 742231, min_days: 2, max_days: 3 },
{ pincode: 742232, min_days: 2, max_days: 3 },
{ pincode: 742234, min_days: 2, max_days: 3 },
{ pincode: 742235, min_days: 2, max_days: 3 },
{ pincode: 742236, min_days: 2, max_days: 3 },
{ pincode: 742237, min_days: 2, max_days: 3 },
{ pincode: 742238, min_days: 2, max_days: 3 },
{ pincode: 742286, min_days: 2, max_days: 3 },
{ pincode: 742301, min_days: 2, max_days: 3 },
{ pincode: 742302, min_days: 2, max_days: 3 },
{ pincode: 742303, min_days: 2, max_days: 3 },
{ pincode: 742304, min_days: 2, max_days: 3 },
{ pincode: 742305, min_days: 2, max_days: 3 },
{ pincode: 742306, min_days: 2, max_days: 3 },
{ pincode: 742307, min_days: 2, max_days: 3 },
{ pincode: 742308, min_days: 2, max_days: 3 },
{ pincode: 742401, min_days: 2, max_days: 3 },
{ pincode: 742402, min_days: 2, max_days: 3 },
{ pincode: 742403, min_days: 2, max_days: 3 },
{ pincode: 742404, min_days: 2, max_days: 3 },
{ pincode: 742405, min_days: 2, max_days: 3 },
{ pincode: 742406, min_days: 2, max_days: 3 },
{ pincode: 742407, min_days: 2, max_days: 3 },
{ pincode: 742408, min_days: 2, max_days: 3 },
{ pincode: 742409, min_days: 2, max_days: 3 },
{ pincode: 742410, min_days: 2, max_days: 3 },
{ pincode: 743001, min_days: 2, max_days: 3 },
{ pincode: 743004, min_days: 2, max_days: 3 },
{ pincode: 743101, min_days: 2, max_days: 3 },
{ pincode: 743102, min_days: 2, max_days: 3 },
{ pincode: 743120, min_days: 2, max_days: 3 },
{ pincode: 743121, min_days: 2, max_days: 3 },
{ pincode: 743122, min_days: 2, max_days: 3 },
{ pincode: 743123, min_days: 2, max_days: 3 },
{ pincode: 743124, min_days: 2, max_days: 3 },
{ pincode: 743125, min_days: 2, max_days: 3 },
{ pincode: 743126, min_days: 2, max_days: 3 },
{ pincode: 743127, min_days: 2, max_days: 3 },
{ pincode: 743128, min_days: 2, max_days: 3 },
{ pincode: 743129, min_days: 2, max_days: 3 },
{ pincode: 743130, min_days: 2, max_days: 3 },
{ pincode: 743133, min_days: 2, max_days: 3 },
{ pincode: 743134, min_days: 2, max_days: 3 },
{ pincode: 743135, min_days: 2, max_days: 3 },
{ pincode: 743136, min_days: 2, max_days: 3 },
{ pincode: 743143, min_days: 2, max_days: 3 },
{ pincode: 743144, min_days: 2, max_days: 3 },
{ pincode: 743145, min_days: 2, max_days: 3 },
{ pincode: 743146, min_days: 2, max_days: 3 },
{ pincode: 743155, min_days: 2, max_days: 3 },
{ pincode: 743164, min_days: 2, max_days: 3 },
{ pincode: 743165, min_days: 2, max_days: 3 },
{ pincode: 743166, min_days: 2, max_days: 3 },
{ pincode: 743170, min_days: 2, max_days: 3 },
{ pincode: 743175, min_days: 2, max_days: 3 },
{ pincode: 743176, min_days: 2, max_days: 3 },
{ pincode: 743177, min_days: 2, max_days: 3 },
{ pincode: 743178, min_days: 2, max_days: 3 },
{ pincode: 743179, min_days: 2, max_days: 3 },
{ pincode: 743180, min_days: 2, max_days: 3 },
{ pincode: 743186, min_days: 2, max_days: 3 },
{ pincode: 743187, min_days: 2, max_days: 3 },
{ pincode: 743188, min_days: 2, max_days: 3 },
{ pincode: 743193, min_days: 2, max_days: 3 },
{ pincode: 743194, min_days: 2, max_days: 3 },
{ pincode: 743195, min_days: 2, max_days: 3 },
{ pincode: 743200, min_days: 2, max_days: 3 },
{ pincode: 743201, min_days: 2, max_days: 3 },
{ pincode: 743202, min_days: 2, max_days: 3 },
{ pincode: 743203, min_days: 2, max_days: 3 },
{ pincode: 743204, min_days: 2, max_days: 3 },
{ pincode: 743211, min_days: 2, max_days: 3 },
{ pincode: 743212, min_days: 2, max_days: 3 },
{ pincode: 743221, min_days: 2, max_days: 3 },
{ pincode: 743222, min_days: 2, max_days: 3 },
{ pincode: 743223, min_days: 2, max_days: 3 },
{ pincode: 743232, min_days: 2, max_days: 3 },
{ pincode: 743233, min_days: 2, max_days: 3 },
{ pincode: 743234, min_days: 2, max_days: 3 },
{ pincode: 743235, min_days: 2, max_days: 3 },
{ pincode: 743244, min_days: 2, max_days: 3 },
{ pincode: 743245, min_days: 2, max_days: 3 },
{ pincode: 743246, min_days: 2, max_days: 3 },
{ pincode: 743247, min_days: 2, max_days: 3 },
{ pincode: 743248, min_days: 2, max_days: 3 },
{ pincode: 743249, min_days: 2, max_days: 3 },
{ pincode: 743250, min_days: 2, max_days: 3 },
{ pincode: 743251, min_days: 2, max_days: 3 },
{ pincode: 743252, min_days: 2, max_days: 3 },
{ pincode: 743262, min_days: 2, max_days: 3 },
{ pincode: 743263, min_days: 2, max_days: 3 },
{ pincode: 743266, min_days: 2, max_days: 3 },
{ pincode: 743268, min_days: 2, max_days: 3 },
{ pincode: 743269, min_days: 2, max_days: 3 },
{ pincode: 743270, min_days: 2, max_days: 3 },
{ pincode: 743271, min_days: 2, max_days: 3 },
{ pincode: 743272, min_days: 2, max_days: 3 },
{ pincode: 743273, min_days: 2, max_days: 3 },
{ pincode: 743274, min_days: 2, max_days: 3 },
{ pincode: 743275, min_days: 2, max_days: 3 },
{ pincode: 743276, min_days: 2, max_days: 3 },
{ pincode: 743286, min_days: 2, max_days: 3 },
{ pincode: 743287, min_days: 2, max_days: 3 },
{ pincode: 743288, min_days: 2, max_days: 3 },
{ pincode: 743289, min_days: 2, max_days: 3 },
{ pincode: 743290, min_days: 2, max_days: 3 },
{ pincode: 743291, min_days: 2, max_days: 3 },
{ pincode: 743292, min_days: 2, max_days: 3 },
{ pincode: 743293, min_days: 2, max_days: 3 },
{ pincode: 743294, min_days: 2, max_days: 3 },
{ pincode: 743295, min_days: 2, max_days: 3 },
{ pincode: 743296, min_days: 2, max_days: 3 },
{ pincode: 743297, min_days: 2, max_days: 3 },
{ pincode: 743298, min_days: 2, max_days: 3 },
{ pincode: 743299, min_days: 2, max_days: 3 },
{ pincode: 743301, min_days: 2, max_days: 3 },
{ pincode: 743302, min_days: 2, max_days: 3 },
{ pincode: 743304, min_days: 2, max_days: 3 },
{ pincode: 743311, min_days: 2, max_days: 3 },
{ pincode: 743312, min_days: 2, max_days: 3 },
{ pincode: 743313, min_days: 2, max_days: 3 },
{ pincode: 743316, min_days: 2, max_days: 3 },
{ pincode: 743318, min_days: 2, max_days: 3 },
{ pincode: 743319, min_days: 2, max_days: 3 },
{ pincode: 743322, min_days: 2, max_days: 3 },
{ pincode: 743329, min_days: 2, max_days: 3 },
{ pincode: 743330, min_days: 2, max_days: 3 },
{ pincode: 743331, min_days: 2, max_days: 3 },
{ pincode: 743332, min_days: 2, max_days: 3 },
{ pincode: 743336, min_days: 2, max_days: 3 },
{ pincode: 743337, min_days: 2, max_days: 3 },
{ pincode: 743338, min_days: 2, max_days: 3 },
{ pincode: 743339, min_days: 2, max_days: 3 },
{ pincode: 743343, min_days: 2, max_days: 3 },
{ pincode: 743345, min_days: 2, max_days: 3 },
{ pincode: 743347, min_days: 2, max_days: 3 },
{ pincode: 743348, min_days: 2, max_days: 3 },
{ pincode: 743349, min_days: 2, max_days: 3 },
{ pincode: 743351, min_days: 2, max_days: 3 },
{ pincode: 743352, min_days: 2, max_days: 3 },
{ pincode: 743353, min_days: 2, max_days: 3 },
{ pincode: 743354, min_days: 2, max_days: 3 },
{ pincode: 743355, min_days: 2, max_days: 3 },
{ pincode: 743356, min_days: 2, max_days: 3 },
{ pincode: 743357, min_days: 2, max_days: 3 },
{ pincode: 743358, min_days: 2, max_days: 3 },
{ pincode: 743360, min_days: 2, max_days: 3 },
{ pincode: 743363, min_days: 2, max_days: 3 },
{ pincode: 743368, min_days: 2, max_days: 3 },
{ pincode: 743369, min_days: 2, max_days: 3 },
{ pincode: 743370, min_days: 2, max_days: 3 },
{ pincode: 743371, min_days: 2, max_days: 3 },
{ pincode: 743372, min_days: 2, max_days: 3 },
{ pincode: 743373, min_days: 2, max_days: 3 },
{ pincode: 743374, min_days: 2, max_days: 3 },
{ pincode: 743375, min_days: 2, max_days: 3 },
{ pincode: 743376, min_days: 2, max_days: 3 },
{ pincode: 743377, min_days: 2, max_days: 3 },
{ pincode: 743378, min_days: 2, max_days: 3 },
{ pincode: 743379, min_days: 2, max_days: 3 },
{ pincode: 743380, min_days: 2, max_days: 3 },
{ pincode: 743381, min_days: 2, max_days: 3 },
{ pincode: 743382, min_days: 2, max_days: 3 },
{ pincode: 743383, min_days: 2, max_days: 3 },
{ pincode: 743384, min_days: 2, max_days: 3 },
{ pincode: 743385, min_days: 2, max_days: 3 },
{ pincode: 743387, min_days: 2, max_days: 3 },
{ pincode: 743388, min_days: 2, max_days: 3 },
{ pincode: 743389, min_days: 2, max_days: 3 },
{ pincode: 743390, min_days: 2, max_days: 3 },
{ pincode: 743391, min_days: 2, max_days: 3 },
{ pincode: 743392, min_days: 2, max_days: 3 },
{ pincode: 743393, min_days: 2, max_days: 3 },
{ pincode: 743394, min_days: 2, max_days: 3 },
{ pincode: 743395, min_days: 2, max_days: 3 },
{ pincode: 743396, min_days: 2, max_days: 3 },
{ pincode: 743397, min_days: 2, max_days: 3 },
{ pincode: 743398, min_days: 2, max_days: 3 },
{ pincode: 743399, min_days: 2, max_days: 3 },
{ pincode: 743401, min_days: 2, max_days: 3 },
{ pincode: 743402, min_days: 2, max_days: 3 },
{ pincode: 743405, min_days: 2, max_days: 3 },
{ pincode: 743411, min_days: 2, max_days: 3 },
{ pincode: 743412, min_days: 2, max_days: 3 },
{ pincode: 743413, min_days: 2, max_days: 3 },
{ pincode: 743414, min_days: 2, max_days: 3 },
{ pincode: 743422, min_days: 2, max_days: 3 },
{ pincode: 743423, min_days: 2, max_days: 3 },
{ pincode: 743424, min_days: 2, max_days: 3 },
{ pincode: 743425, min_days: 2, max_days: 3 },
{ pincode: 743426, min_days: 2, max_days: 3 },
{ pincode: 743427, min_days: 2, max_days: 3 },
{ pincode: 743428, min_days: 2, max_days: 3 },
{ pincode: 743429, min_days: 2, max_days: 3 },
{ pincode: 743435, min_days: 2, max_days: 3 },
{ pincode: 743436, min_days: 2, max_days: 3 },
{ pincode: 743437, min_days: 2, max_days: 3 },
{ pincode: 743438, min_days: 2, max_days: 3 },
{ pincode: 743439, min_days: 2, max_days: 3 },
{ pincode: 743440, min_days: 2, max_days: 3 },
{ pincode: 743441, min_days: 2, max_days: 3 },
{ pincode: 743442, min_days: 2, max_days: 3 },
{ pincode: 743443, min_days: 2, max_days: 3 },
{ pincode: 743445, min_days: 2, max_days: 3 },
{ pincode: 743446, min_days: 2, max_days: 3 },
{ pincode: 743456, min_days: 2, max_days: 3 },
{ pincode: 743486, min_days: 2, max_days: 3 },
{ pincode: 743502, min_days: 2, max_days: 3 },
{ pincode: 743503, min_days: 2, max_days: 3 },
{ pincode: 743504, min_days: 2, max_days: 3 },
{ pincode: 743505, min_days: 2, max_days: 3 },
{ pincode: 743506, min_days: 2, max_days: 3 },
{ pincode: 743507, min_days: 2, max_days: 3 },
{ pincode: 743508, min_days: 2, max_days: 3 },
{ pincode: 743510, min_days: 2, max_days: 3 },
{ pincode: 743511, min_days: 2, max_days: 3 },
{ pincode: 743512, min_days: 2, max_days: 3 },
{ pincode: 743513, min_days: 2, max_days: 3 },
{ pincode: 743514, min_days: 2, max_days: 3 },
{ pincode: 743515, min_days: 2, max_days: 3 },
{ pincode: 743516, min_days: 2, max_days: 3 },
{ pincode: 743517, min_days: 2, max_days: 3 },
{ pincode: 743601, min_days: 2, max_days: 3 },
{ pincode: 743603, min_days: 2, max_days: 3 },
{ pincode: 743604, min_days: 2, max_days: 3 },
{ pincode: 743605, min_days: 2, max_days: 3 },
{ pincode: 743606, min_days: 2, max_days: 3 },
{ pincode: 743607, min_days: 2, max_days: 3 },
{ pincode: 743608, min_days: 2, max_days: 3 },
{ pincode: 743609, min_days: 2, max_days: 3 },
{ pincode: 743610, min_days: 2, max_days: 3 },
{ pincode: 743611, min_days: 2, max_days: 3 },
{ pincode: 743612, min_days: 2, max_days: 3 },
{ pincode: 743613, min_days: 2, max_days: 3 },
{ pincode: 743700, min_days: 2, max_days: 3 },
{ pincode: 743701, min_days: 2, max_days: 3 },
{ pincode: 743702, min_days: 2, max_days: 3 },
{ pincode: 743703, min_days: 2, max_days: 3 },
{ pincode: 743704, min_days: 2, max_days: 3 },
{ pincode: 743705, min_days: 2, max_days: 3 },
{ pincode: 743706, min_days: 2, max_days: 3 },
{ pincode: 743707, min_days: 2, max_days: 3 },
{ pincode: 743708, min_days: 2, max_days: 3 },
{ pincode: 743710, min_days: 2, max_days: 3 },
{ pincode: 743711, min_days: 2, max_days: 3 },
{ pincode: 743744, min_days: 2, max_days: 3 },
{ pincode: 744101, min_days: 2, max_days: 3 },
{ pincode: 744102, min_days: 2, max_days: 3 },
{ pincode: 744103, min_days: 2, max_days: 3 },
{ pincode: 744104, min_days: 3, max_days: 4 },
{ pincode: 744105, min_days: 2, max_days: 3 },
{ pincode: 744106, min_days: 2, max_days: 3 },
{ pincode: 744107, min_days: 2, max_days: 3 },
{ pincode: 744112, min_days: 2, max_days: 3 },
{ pincode: 744127, min_days: 2, max_days: 3 },
{ pincode: 744201, min_days: 2, max_days: 3 },
{ pincode: 744202, min_days: 3, max_days: 4 },
{ pincode: 744203, min_days: 3, max_days: 4 },
{ pincode: 744204, min_days: 2, max_days: 3 },
{ pincode: 744205, min_days: 2, max_days: 3 },
{ pincode: 744206, min_days: 2, max_days: 3 },
{ pincode: 744207, min_days: 3, max_days: 4 },
{ pincode: 744209, min_days: 2, max_days: 3 },
{ pincode: 744210, min_days: 3, max_days: 4 },
{ pincode: 744211, min_days: 3, max_days: 4 },
{ pincode: 744301, min_days: 3, max_days: 4 },
{ pincode: 744302, min_days: 2, max_days: 3 },
{ pincode: 744303, min_days: 2, max_days: 3 },
{ pincode: 744304, min_days: 2, max_days: 3 },
{ pincode: 747273, min_days: 2, max_days: 3 },
{ pincode: 748706, min_days: 2, max_days: 3 },
{ pincode: 750014, min_days: 2, max_days: 3 },
{ pincode: 750026, min_days: 2, max_days: 3 },
{ pincode: 750122, min_days: 2, max_days: 3 },
{ pincode: 751000, min_days: 2, max_days: 3 },
{ pincode: 751001, min_days: 2, max_days: 3 },
{ pincode: 751002, min_days: 2, max_days: 3 },
{ pincode: 751003, min_days: 2, max_days: 3 },
{ pincode: 751004, min_days: 2, max_days: 3 },
{ pincode: 751005, min_days: 2, max_days: 3 },
{ pincode: 751006, min_days: 2, max_days: 3 },
{ pincode: 751007, min_days: 2, max_days: 3 },
{ pincode: 751008, min_days: 2, max_days: 3 },
{ pincode: 751009, min_days: 2, max_days: 3 },
{ pincode: 751010, min_days: 2, max_days: 3 },
{ pincode: 751011, min_days: 2, max_days: 3 },
{ pincode: 751012, min_days: 2, max_days: 3 },
{ pincode: 751013, min_days: 2, max_days: 3 },
{ pincode: 751014, min_days: 2, max_days: 3 },
{ pincode: 751015, min_days: 2, max_days: 3 },
{ pincode: 751016, min_days: 2, max_days: 3 },
{ pincode: 751017, min_days: 2, max_days: 3 },
{ pincode: 751018, min_days: 2, max_days: 3 },
{ pincode: 751019, min_days: 2, max_days: 3 },
{ pincode: 751020, min_days: 2, max_days: 3 },
{ pincode: 751021, min_days: 2, max_days: 3 },
{ pincode: 751022, min_days: 2, max_days: 3 },
{ pincode: 751023, min_days: 2, max_days: 3 },
{ pincode: 751024, min_days: 2, max_days: 3 },
{ pincode: 751025, min_days: 2, max_days: 3 },
{ pincode: 751026, min_days: 2, max_days: 3 },
{ pincode: 751027, min_days: 2, max_days: 3 },
{ pincode: 751028, min_days: 2, max_days: 3 },
{ pincode: 751029, min_days: 2, max_days: 3 },
{ pincode: 751030, min_days: 2, max_days: 3 },
{ pincode: 751031, min_days: 2, max_days: 3 },
{ pincode: 751032, min_days: 2, max_days: 3 },
{ pincode: 751033, min_days: 2, max_days: 3 },
{ pincode: 751034, min_days: 2, max_days: 3 },
{ pincode: 751054, min_days: 2, max_days: 3 },
{ pincode: 751062, min_days: 2, max_days: 3 },
{ pincode: 752001, min_days: 2, max_days: 3 },
{ pincode: 752002, min_days: 2, max_days: 3 },
{ pincode: 752003, min_days: 2, max_days: 3 },
{ pincode: 752004, min_days: 2, max_days: 3 },
{ pincode: 752006, min_days: 2, max_days: 3 },
{ pincode: 752010, min_days: 2, max_days: 3 },
{ pincode: 752011, min_days: 2, max_days: 3 },
{ pincode: 752012, min_days: 2, max_days: 3 },
{ pincode: 752013, min_days: 2, max_days: 3 },
{ pincode: 752014, min_days: 2, max_days: 3 },
{ pincode: 752015, min_days: 2, max_days: 3 },
{ pincode: 752016, min_days: 2, max_days: 3 },
{ pincode: 752017, min_days: 2, max_days: 3 },
{ pincode: 752018, min_days: 2, max_days: 3 },
{ pincode: 752019, min_days: 2, max_days: 3 },
{ pincode: 752020, min_days: 2, max_days: 3 },
{ pincode: 752021, min_days: 2, max_days: 3 },
{ pincode: 752022, min_days: 2, max_days: 3 },
{ pincode: 752023, min_days: 2, max_days: 3 },
{ pincode: 752024, min_days: 2, max_days: 3 },
{ pincode: 752025, min_days: 2, max_days: 3 },
{ pincode: 752026, min_days: 2, max_days: 3 },
{ pincode: 752027, min_days: 2, max_days: 3 },
{ pincode: 752028, min_days: 2, max_days: 3 },
{ pincode: 752029, min_days: 2, max_days: 3 },
{ pincode: 752030, min_days: 2, max_days: 3 },
{ pincode: 752031, min_days: 2, max_days: 3 },
{ pincode: 752032, min_days: 2, max_days: 3 },
{ pincode: 752033, min_days: 2, max_days: 3 },
{ pincode: 752034, min_days: 2, max_days: 3 },
{ pincode: 752035, min_days: 2, max_days: 3 },
{ pincode: 752036, min_days: 2, max_days: 3 },
{ pincode: 752037, min_days: 2, max_days: 3 },
{ pincode: 752038, min_days: 2, max_days: 3 },
{ pincode: 752041, min_days: 2, max_days: 3 },
{ pincode: 752042, min_days: 2, max_days: 3 },
{ pincode: 752043, min_days: 2, max_days: 3 },
{ pincode: 752044, min_days: 2, max_days: 3 },
{ pincode: 752045, min_days: 2, max_days: 3 },
{ pincode: 752046, min_days: 2, max_days: 3 },
{ pincode: 752050, min_days: 2, max_days: 3 },
{ pincode: 752054, min_days: 2, max_days: 3 },
{ pincode: 752055, min_days: 2, max_days: 3 },
{ pincode: 752056, min_days: 2, max_days: 3 },
{ pincode: 752057, min_days: 2, max_days: 3 },
{ pincode: 752058, min_days: 2, max_days: 3 },
{ pincode: 752059, min_days: 2, max_days: 3 },
{ pincode: 752060, min_days: 2, max_days: 3 },
{ pincode: 752061, min_days: 2, max_days: 3 },
{ pincode: 752062, min_days: 2, max_days: 3 },
{ pincode: 752063, min_days: 2, max_days: 3 },
{ pincode: 752064, min_days: 2, max_days: 3 },
{ pincode: 752065, min_days: 2, max_days: 3 },
{ pincode: 752066, min_days: 2, max_days: 3 },
{ pincode: 752067, min_days: 2, max_days: 3 },
{ pincode: 752068, min_days: 2, max_days: 3 },
{ pincode: 752069, min_days: 2, max_days: 3 },
{ pincode: 752070, min_days: 2, max_days: 3 },
{ pincode: 752077, min_days: 2, max_days: 3 },
{ pincode: 752078, min_days: 2, max_days: 3 },
{ pincode: 752079, min_days: 2, max_days: 3 },
{ pincode: 752080, min_days: 2, max_days: 3 },
{ pincode: 752081, min_days: 2, max_days: 3 },
{ pincode: 752082, min_days: 2, max_days: 3 },
{ pincode: 752083, min_days: 2, max_days: 3 },
{ pincode: 752084, min_days: 2, max_days: 3 },
{ pincode: 752085, min_days: 2, max_days: 3 },
{ pincode: 752086, min_days: 2, max_days: 3 },
{ pincode: 752087, min_days: 2, max_days: 3 },
{ pincode: 752089, min_days: 2, max_days: 3 },
{ pincode: 752090, min_days: 2, max_days: 3 },
{ pincode: 752091, min_days: 2, max_days: 3 },
{ pincode: 752092, min_days: 2, max_days: 3 },
{ pincode: 752093, min_days: 2, max_days: 3 },
{ pincode: 752094, min_days: 2, max_days: 3 },
{ pincode: 752095, min_days: 2, max_days: 3 },
{ pincode: 752096, min_days: 2, max_days: 3 },
{ pincode: 752100, min_days: 2, max_days: 3 },
{ pincode: 752101, min_days: 2, max_days: 3 },
{ pincode: 752102, min_days: 2, max_days: 3 },
{ pincode: 752103, min_days: 2, max_days: 3 },
{ pincode: 752104, min_days: 2, max_days: 3 },
{ pincode: 752105, min_days: 2, max_days: 3 },
{ pincode: 752106, min_days: 2, max_days: 3 },
{ pincode: 752107, min_days: 2, max_days: 3 },
{ pincode: 752108, min_days: 2, max_days: 3 },
{ pincode: 752109, min_days: 2, max_days: 3 },
{ pincode: 752110, min_days: 2, max_days: 3 },
{ pincode: 752111, min_days: 2, max_days: 3 },
{ pincode: 752112, min_days: 2, max_days: 3 },
{ pincode: 752113, min_days: 2, max_days: 3 },
{ pincode: 752114, min_days: 2, max_days: 3 },
{ pincode: 752115, min_days: 2, max_days: 3 },
{ pincode: 752116, min_days: 2, max_days: 3 },
{ pincode: 752117, min_days: 2, max_days: 3 },
{ pincode: 752118, min_days: 2, max_days: 3 },
{ pincode: 752119, min_days: 2, max_days: 3 },
{ pincode: 752120, min_days: 2, max_days: 3 },
{ pincode: 752121, min_days: 2, max_days: 3 },
{ pincode: 753000, min_days: 2, max_days: 3 },
{ pincode: 753001, min_days: 2, max_days: 3 },
{ pincode: 753002, min_days: 2, max_days: 3 },
{ pincode: 753003, min_days: 2, max_days: 3 },
{ pincode: 753004, min_days: 2, max_days: 3 },
{ pincode: 753005, min_days: 2, max_days: 3 },
{ pincode: 753006, min_days: 2, max_days: 3 },
{ pincode: 753007, min_days: 2, max_days: 3 },
{ pincode: 753008, min_days: 2, max_days: 3 },
{ pincode: 753009, min_days: 2, max_days: 3 },
{ pincode: 753010, min_days: 2, max_days: 3 },
{ pincode: 753011, min_days: 2, max_days: 3 },
{ pincode: 753012, min_days: 2, max_days: 3 },
{ pincode: 753013, min_days: 2, max_days: 3 },
{ pincode: 753014, min_days: 2, max_days: 3 },
{ pincode: 753015, min_days: 2, max_days: 3 },
{ pincode: 753021, min_days: 2, max_days: 3 },
{ pincode: 753025, min_days: 2, max_days: 3 },
{ pincode: 753027, min_days: 2, max_days: 3 },
{ pincode: 753051, min_days: 2, max_days: 3 },
{ pincode: 753052, min_days: 2, max_days: 3 },
{ pincode: 753071, min_days: 2, max_days: 3 },
{ pincode: 753121, min_days: 2, max_days: 3 },
{ pincode: 753127, min_days: 2, max_days: 3 },
{ pincode: 753132, min_days: 2, max_days: 3 },
{ pincode: 753141, min_days: 2, max_days: 3 },
{ pincode: 754001, min_days: 2, max_days: 3 },
{ pincode: 754002, min_days: 2, max_days: 3 },
{ pincode: 754003, min_days: 2, max_days: 3 },
{ pincode: 754004, min_days: 2, max_days: 3 },
{ pincode: 754005, min_days: 2, max_days: 3 },
{ pincode: 754006, min_days: 2, max_days: 3 },
{ pincode: 754007, min_days: 2, max_days: 3 },
{ pincode: 754008, min_days: 2, max_days: 3 },
{ pincode: 754009, min_days: 2, max_days: 3 },
{ pincode: 754010, min_days: 2, max_days: 3 },
{ pincode: 754011, min_days: 2, max_days: 3 },
{ pincode: 754012, min_days: 2, max_days: 3 },
{ pincode: 754013, min_days: 2, max_days: 3 },
{ pincode: 754014, min_days: 2, max_days: 3 },
{ pincode: 754015, min_days: 2, max_days: 3 },
{ pincode: 754016, min_days: 2, max_days: 3 },
{ pincode: 754017, min_days: 2, max_days: 3 },
{ pincode: 754018, min_days: 2, max_days: 3 },
{ pincode: 754020, min_days: 2, max_days: 3 },
{ pincode: 754021, min_days: 2, max_days: 3 },
{ pincode: 754022, min_days: 2, max_days: 3 },
{ pincode: 754023, min_days: 2, max_days: 3 },
{ pincode: 754024, min_days: 2, max_days: 3 },
{ pincode: 754025, min_days: 2, max_days: 3 },
{ pincode: 754026, min_days: 2, max_days: 3 },
{ pincode: 754027, min_days: 2, max_days: 3 },
{ pincode: 754028, min_days: 2, max_days: 3 },
{ pincode: 754029, min_days: 2, max_days: 3 },
{ pincode: 754030, min_days: 2, max_days: 3 },
{ pincode: 754031, min_days: 2, max_days: 3 },
{ pincode: 754032, min_days: 2, max_days: 3 },
{ pincode: 754033, min_days: 2, max_days: 3 },
{ pincode: 754034, min_days: 2, max_days: 3 },
{ pincode: 754035, min_days: 2, max_days: 3 },
{ pincode: 754036, min_days: 2, max_days: 3 },
{ pincode: 754037, min_days: 2, max_days: 3 },
{ pincode: 754070, min_days: 2, max_days: 3 },
{ pincode: 754071, min_days: 2, max_days: 3 },
{ pincode: 754080, min_days: 2, max_days: 3 },
{ pincode: 754081, min_days: 2, max_days: 3 },
{ pincode: 754082, min_days: 2, max_days: 3 },
{ pincode: 754100, min_days: 2, max_days: 3 },
{ pincode: 754101, min_days: 2, max_days: 3 },
{ pincode: 754102, min_days: 2, max_days: 3 },
{ pincode: 754103, min_days: 2, max_days: 3 },
{ pincode: 754104, min_days: 2, max_days: 3 },
{ pincode: 754105, min_days: 2, max_days: 3 },
{ pincode: 754106, min_days: 2, max_days: 3 },
{ pincode: 754107, min_days: 2, max_days: 3 },
{ pincode: 754108, min_days: 2, max_days: 3 },
{ pincode: 754109, min_days: 2, max_days: 3 },
{ pincode: 754110, min_days: 2, max_days: 3 },
{ pincode: 754111, min_days: 2, max_days: 3 },
{ pincode: 754112, min_days: 2, max_days: 3 },
{ pincode: 754113, min_days: 2, max_days: 3 },
{ pincode: 754114, min_days: 2, max_days: 3 },
{ pincode: 754115, min_days: 2, max_days: 3 },
{ pincode: 754116, min_days: 2, max_days: 3 },
{ pincode: 754118, min_days: 2, max_days: 3 },
{ pincode: 754119, min_days: 2, max_days: 3 },
{ pincode: 754120, min_days: 2, max_days: 3 },
{ pincode: 754130, min_days: 2, max_days: 3 },
{ pincode: 754131, min_days: 2, max_days: 3 },
{ pincode: 754132, min_days: 2, max_days: 3 },
{ pincode: 754133, min_days: 2, max_days: 3 },
{ pincode: 754134, min_days: 2, max_days: 3 },
{ pincode: 754135, min_days: 2, max_days: 3 },
{ pincode: 754136, min_days: 2, max_days: 3 },
{ pincode: 754137, min_days: 2, max_days: 3 },
{ pincode: 754138, min_days: 2, max_days: 3 },
{ pincode: 754139, min_days: 2, max_days: 3 },
{ pincode: 754140, min_days: 2, max_days: 3 },
{ pincode: 754141, min_days: 2, max_days: 3 },
{ pincode: 754142, min_days: 2, max_days: 3 },
{ pincode: 754143, min_days: 2, max_days: 3 },
{ pincode: 754144, min_days: 2, max_days: 3 },
{ pincode: 754145, min_days: 2, max_days: 3 },
{ pincode: 754153, min_days: 2, max_days: 3 },
{ pincode: 754155, min_days: 2, max_days: 3 },
{ pincode: 754156, min_days: 2, max_days: 3 },
{ pincode: 754157, min_days: 2, max_days: 3 },
{ pincode: 754158, min_days: 2, max_days: 3 },
{ pincode: 754159, min_days: 2, max_days: 3 },
{ pincode: 754160, min_days: 2, max_days: 3 },
{ pincode: 754161, min_days: 2, max_days: 3 },
{ pincode: 754162, min_days: 2, max_days: 3 },
{ pincode: 754200, min_days: 2, max_days: 3 },
{ pincode: 754201, min_days: 2, max_days: 3 },
{ pincode: 754202, min_days: 2, max_days: 3 },
{ pincode: 754203, min_days: 2, max_days: 3 },
{ pincode: 754204, min_days: 2, max_days: 3 },
{ pincode: 754205, min_days: 2, max_days: 3 },
{ pincode: 754206, min_days: 2, max_days: 3 },
{ pincode: 754207, min_days: 2, max_days: 3 },
{ pincode: 754208, min_days: 2, max_days: 3 },
{ pincode: 754209, min_days: 2, max_days: 3 },
{ pincode: 754210, min_days: 2, max_days: 3 },
{ pincode: 754211, min_days: 2, max_days: 3 },
{ pincode: 754212, min_days: 2, max_days: 3 },
{ pincode: 754213, min_days: 2, max_days: 3 },
{ pincode: 754214, min_days: 2, max_days: 3 },
{ pincode: 754215, min_days: 2, max_days: 3 },
{ pincode: 754216, min_days: 2, max_days: 3 },
{ pincode: 754217, min_days: 2, max_days: 3 },
{ pincode: 754218, min_days: 2, max_days: 3 },
{ pincode: 754219, min_days: 2, max_days: 3 },
{ pincode: 754220, min_days: 2, max_days: 3 },
{ pincode: 754221, min_days: 2, max_days: 3 },
{ pincode: 754222, min_days: 2, max_days: 3 },
{ pincode: 754223, min_days: 2, max_days: 3 },
{ pincode: 754224, min_days: 2, max_days: 3 },
{ pincode: 754225, min_days: 2, max_days: 3 },
{ pincode: 754226, min_days: 2, max_days: 3 },
{ pincode: 754227, min_days: 2, max_days: 3 },
{ pincode: 754228, min_days: 2, max_days: 3 },
{ pincode: 754229, min_days: 2, max_days: 3 },
{ pincode: 754230, min_days: 2, max_days: 3 },
{ pincode: 754231, min_days: 2, max_days: 3 },
{ pincode: 754232, min_days: 2, max_days: 3 },
{ pincode: 754233, min_days: 2, max_days: 3 },
{ pincode: 754234, min_days: 2, max_days: 3 },
{ pincode: 754237, min_days: 2, max_days: 3 },
{ pincode: 754238, min_days: 2, max_days: 3 },
{ pincode: 754239, min_days: 2, max_days: 3 },
{ pincode: 754240, min_days: 2, max_days: 3 },
{ pincode: 754241, min_days: 2, max_days: 3 },
{ pincode: 754244, min_days: 2, max_days: 3 },
{ pincode: 754245, min_days: 2, max_days: 3 },
{ pincode: 754246, min_days: 2, max_days: 3 },
{ pincode: 754247, min_days: 2, max_days: 3 },
{ pincode: 754248, min_days: 2, max_days: 3 },
{ pincode: 754250, min_days: 2, max_days: 3 },
{ pincode: 754251, min_days: 2, max_days: 3 },
{ pincode: 754252, min_days: 2, max_days: 3 },
{ pincode: 754253, min_days: 2, max_days: 3 },
{ pincode: 754261, min_days: 2, max_days: 3 },
{ pincode: 754280, min_days: 2, max_days: 3 },
{ pincode: 754281, min_days: 2, max_days: 3 },
{ pincode: 754282, min_days: 2, max_days: 3 },
{ pincode: 754283, min_days: 2, max_days: 3 },
{ pincode: 754284, min_days: 2, max_days: 3 },
{ pincode: 754285, min_days: 2, max_days: 3 },
{ pincode: 754286, min_days: 2, max_days: 3 },
{ pincode: 754287, min_days: 2, max_days: 3 },
{ pincode: 754288, min_days: 2, max_days: 3 },
{ pincode: 754289, min_days: 2, max_days: 3 },
{ pincode: 754290, min_days: 2, max_days: 3 },
{ pincode: 754291, min_days: 2, max_days: 3 },
{ pincode: 754292, min_days: 2, max_days: 3 },
{ pincode: 754293, min_days: 2, max_days: 3 },
{ pincode: 754294, min_days: 2, max_days: 3 },
{ pincode: 754295, min_days: 2, max_days: 3 },
{ pincode: 754296, min_days: 2, max_days: 3 },
{ pincode: 754297, min_days: 2, max_days: 3 },
{ pincode: 754298, min_days: 2, max_days: 3 },
{ pincode: 754299, min_days: 2, max_days: 3 },
{ pincode: 755001, min_days: 2, max_days: 3 },
{ pincode: 755003, min_days: 2, max_days: 3 },
{ pincode: 755004, min_days: 2, max_days: 3 },
{ pincode: 755005, min_days: 2, max_days: 3 },
{ pincode: 755006, min_days: 2, max_days: 3 },
{ pincode: 755007, min_days: 2, max_days: 3 },
{ pincode: 755008, min_days: 2, max_days: 3 },
{ pincode: 755009, min_days: 2, max_days: 3 },
{ pincode: 755010, min_days: 2, max_days: 3 },
{ pincode: 755011, min_days: 2, max_days: 3 },
{ pincode: 755012, min_days: 2, max_days: 3 },
{ pincode: 755013, min_days: 2, max_days: 3 },
{ pincode: 755014, min_days: 2, max_days: 3 },
{ pincode: 755015, min_days: 2, max_days: 3 },
{ pincode: 755016, min_days: 2, max_days: 3 },
{ pincode: 755017, min_days: 2, max_days: 3 },
{ pincode: 755018, min_days: 2, max_days: 3 },
{ pincode: 755019, min_days: 2, max_days: 3 },
{ pincode: 755020, min_days: 2, max_days: 3 },
{ pincode: 755021, min_days: 2, max_days: 3 },
{ pincode: 755022, min_days: 2, max_days: 3 },
{ pincode: 755023, min_days: 2, max_days: 3 },
{ pincode: 755024, min_days: 2, max_days: 3 },
{ pincode: 755025, min_days: 2, max_days: 3 },
{ pincode: 755026, min_days: 2, max_days: 3 },
{ pincode: 755027, min_days: 2, max_days: 3 },
{ pincode: 755028, min_days: 2, max_days: 3 },
{ pincode: 755029, min_days: 2, max_days: 3 },
{ pincode: 755031, min_days: 2, max_days: 3 },
{ pincode: 755032, min_days: 2, max_days: 3 },
{ pincode: 755033, min_days: 2, max_days: 3 },
{ pincode: 755034, min_days: 2, max_days: 3 },
{ pincode: 755035, min_days: 2, max_days: 3 },
{ pincode: 755036, min_days: 2, max_days: 3 },
{ pincode: 755037, min_days: 2, max_days: 3 },
{ pincode: 755038, min_days: 2, max_days: 3 },
{ pincode: 755039, min_days: 2, max_days: 3 },
{ pincode: 755040, min_days: 2, max_days: 3 },
{ pincode: 755041, min_days: 2, max_days: 3 },
{ pincode: 755042, min_days: 2, max_days: 3 },
{ pincode: 755043, min_days: 2, max_days: 3 },
{ pincode: 755044, min_days: 2, max_days: 3 },
{ pincode: 755045, min_days: 2, max_days: 3 },
{ pincode: 755046, min_days: 2, max_days: 3 },
{ pincode: 755047, min_days: 2, max_days: 3 },
{ pincode: 755048, min_days: 2, max_days: 3 },
{ pincode: 755049, min_days: 2, max_days: 3 },
{ pincode: 755050, min_days: 2, max_days: 3 },
{ pincode: 755051, min_days: 2, max_days: 3 },
{ pincode: 755061, min_days: 2, max_days: 3 },
{ pincode: 755062, min_days: 2, max_days: 3 },
{ pincode: 756001, min_days: 2, max_days: 3 },
{ pincode: 756002, min_days: 2, max_days: 3 },
{ pincode: 756003, min_days: 2, max_days: 3 },
{ pincode: 756009, min_days: 2, max_days: 3 },
{ pincode: 756017, min_days: 2, max_days: 3 },
{ pincode: 756018, min_days: 2, max_days: 3 },
{ pincode: 756019, min_days: 2, max_days: 3 },
{ pincode: 756020, min_days: 2, max_days: 3 },
{ pincode: 756021, min_days: 2, max_days: 3 },
{ pincode: 756022, min_days: 2, max_days: 3 },
{ pincode: 756023, min_days: 2, max_days: 3 },
{ pincode: 756024, min_days: 2, max_days: 3 },
{ pincode: 756025, min_days: 2, max_days: 3 },
{ pincode: 756026, min_days: 2, max_days: 3 },
{ pincode: 756027, min_days: 2, max_days: 3 },
{ pincode: 756028, min_days: 2, max_days: 3 },
{ pincode: 756029, min_days: 2, max_days: 3 },
{ pincode: 756030, min_days: 2, max_days: 3 },
{ pincode: 756032, min_days: 2, max_days: 3 },
{ pincode: 756033, min_days: 2, max_days: 3 },
{ pincode: 756034, min_days: 2, max_days: 3 },
{ pincode: 756035, min_days: 2, max_days: 3 },
{ pincode: 756036, min_days: 2, max_days: 3 },
{ pincode: 756037, min_days: 2, max_days: 3 },
{ pincode: 756038, min_days: 2, max_days: 3 },
{ pincode: 756039, min_days: 2, max_days: 3 },
{ pincode: 756040, min_days: 2, max_days: 3 },
{ pincode: 756041, min_days: 2, max_days: 3 },
{ pincode: 756042, min_days: 2, max_days: 3 },
{ pincode: 756043, min_days: 2, max_days: 3 },
{ pincode: 756044, min_days: 2, max_days: 3 },
{ pincode: 756045, min_days: 2, max_days: 3 },
{ pincode: 756046, min_days: 2, max_days: 3 },
{ pincode: 756047, min_days: 2, max_days: 3 },
{ pincode: 756048, min_days: 2, max_days: 3 },
{ pincode: 756049, min_days: 2, max_days: 3 },
{ pincode: 756050, min_days: 2, max_days: 3 },
{ pincode: 756051, min_days: 2, max_days: 3 },
{ pincode: 756052, min_days: 2, max_days: 3 },
{ pincode: 756053, min_days: 2, max_days: 3 },
{ pincode: 756054, min_days: 2, max_days: 3 },
{ pincode: 756055, min_days: 2, max_days: 3 },
{ pincode: 756056, min_days: 2, max_days: 3 },
{ pincode: 756057, min_days: 2, max_days: 3 },
{ pincode: 756058, min_days: 2, max_days: 3 },
{ pincode: 756059, min_days: 2, max_days: 3 },
{ pincode: 756060, min_days: 2, max_days: 3 },
{ pincode: 756071, min_days: 2, max_days: 3 },
{ pincode: 756072, min_days: 2, max_days: 3 },
{ pincode: 756073, min_days: 2, max_days: 3 },
{ pincode: 756074, min_days: 2, max_days: 3 },
{ pincode: 756075, min_days: 2, max_days: 3 },
{ pincode: 756076, min_days: 2, max_days: 3 },
{ pincode: 756077, min_days: 2, max_days: 3 },
{ pincode: 756078, min_days: 2, max_days: 3 },
{ pincode: 756079, min_days: 2, max_days: 3 },
{ pincode: 756080, min_days: 2, max_days: 3 },
{ pincode: 756081, min_days: 2, max_days: 3 },
{ pincode: 756082, min_days: 2, max_days: 3 },
{ pincode: 756083, min_days: 2, max_days: 3 },
{ pincode: 756084, min_days: 2, max_days: 3 },
{ pincode: 756085, min_days: 2, max_days: 3 },
{ pincode: 756086, min_days: 2, max_days: 3 },
{ pincode: 756087, min_days: 2, max_days: 3 },
{ pincode: 756089, min_days: 2, max_days: 3 },
{ pincode: 756100, min_days: 2, max_days: 3 },
{ pincode: 756101, min_days: 2, max_days: 3 },
{ pincode: 756110, min_days: 2, max_days: 3 },
{ pincode: 756111, min_days: 2, max_days: 3 },
{ pincode: 756112, min_days: 2, max_days: 3 },
{ pincode: 756113, min_days: 2, max_days: 3 },
{ pincode: 756114, min_days: 2, max_days: 3 },
{ pincode: 756115, min_days: 2, max_days: 3 },
{ pincode: 756116, min_days: 2, max_days: 3 },
{ pincode: 756117, min_days: 2, max_days: 3 },
{ pincode: 756118, min_days: 2, max_days: 3 },
{ pincode: 756119, min_days: 2, max_days: 3 },
{ pincode: 756120, min_days: 2, max_days: 3 },
{ pincode: 756121, min_days: 2, max_days: 3 },
{ pincode: 756122, min_days: 2, max_days: 3 },
{ pincode: 756123, min_days: 2, max_days: 3 },
{ pincode: 756124, min_days: 2, max_days: 3 },
{ pincode: 756125, min_days: 2, max_days: 3 },
{ pincode: 756126, min_days: 2, max_days: 3 },
{ pincode: 756127, min_days: 2, max_days: 3 },
{ pincode: 756128, min_days: 2, max_days: 3 },
{ pincode: 756129, min_days: 2, max_days: 3 },
{ pincode: 756130, min_days: 2, max_days: 3 },
{ pincode: 756131, min_days: 2, max_days: 3 },
{ pincode: 756132, min_days: 2, max_days: 3 },
{ pincode: 756133, min_days: 2, max_days: 3 },
{ pincode: 756134, min_days: 2, max_days: 3 },
{ pincode: 756135, min_days: 2, max_days: 3 },
{ pincode: 756136, min_days: 2, max_days: 3 },
{ pincode: 756137, min_days: 2, max_days: 3 },
{ pincode: 756138, min_days: 2, max_days: 3 },
{ pincode: 756139, min_days: 2, max_days: 3 },
{ pincode: 756140, min_days: 2, max_days: 3 },
{ pincode: 756142, min_days: 2, max_days: 3 },
{ pincode: 756144, min_days: 2, max_days: 3 },
{ pincode: 756161, min_days: 2, max_days: 3 },
{ pincode: 756162, min_days: 2, max_days: 3 },
{ pincode: 756163, min_days: 2, max_days: 3 },
{ pincode: 756164, min_days: 2, max_days: 3 },
{ pincode: 756165, min_days: 2, max_days: 3 },
{ pincode: 756166, min_days: 2, max_days: 3 },
{ pincode: 756167, min_days: 2, max_days: 3 },
{ pincode: 756168, min_days: 2, max_days: 3 },
{ pincode: 756171, min_days: 2, max_days: 3 },
{ pincode: 756181, min_days: 2, max_days: 3 },
{ pincode: 756182, min_days: 2, max_days: 3 },
{ pincode: 757001, min_days: 2, max_days: 3 },
{ pincode: 757002, min_days: 2, max_days: 3 },
{ pincode: 757003, min_days: 2, max_days: 3 },
{ pincode: 757012, min_days: 2, max_days: 3 },
{ pincode: 757014, min_days: 2, max_days: 3 },
{ pincode: 757015, min_days: 2, max_days: 3 },
{ pincode: 757016, min_days: 2, max_days: 3 },
{ pincode: 757017, min_days: 2, max_days: 3 },
{ pincode: 757018, min_days: 2, max_days: 3 },
{ pincode: 757019, min_days: 2, max_days: 3 },
{ pincode: 757020, min_days: 2, max_days: 3 },
{ pincode: 757021, min_days: 2, max_days: 3 },
{ pincode: 757022, min_days: 2, max_days: 3 },
{ pincode: 757023, min_days: 2, max_days: 3 },
{ pincode: 757024, min_days: 2, max_days: 3 },
{ pincode: 757025, min_days: 2, max_days: 3 },
{ pincode: 757026, min_days: 2, max_days: 3 },
{ pincode: 757027, min_days: 2, max_days: 3 },
{ pincode: 757028, min_days: 2, max_days: 3 },
{ pincode: 757029, min_days: 2, max_days: 3 },
{ pincode: 757030, min_days: 2, max_days: 3 },
{ pincode: 757031, min_days: 2, max_days: 3 },
{ pincode: 757032, min_days: 2, max_days: 3 },
{ pincode: 757033, min_days: 2, max_days: 3 },
{ pincode: 757034, min_days: 2, max_days: 3 },
{ pincode: 757035, min_days: 2, max_days: 3 },
{ pincode: 757036, min_days: 2, max_days: 3 },
{ pincode: 757037, min_days: 2, max_days: 3 },
{ pincode: 757038, min_days: 2, max_days: 3 },
{ pincode: 757039, min_days: 2, max_days: 3 },
{ pincode: 757040, min_days: 2, max_days: 3 },
{ pincode: 757041, min_days: 2, max_days: 3 },
{ pincode: 757042, min_days: 2, max_days: 3 },
{ pincode: 757043, min_days: 2, max_days: 3 },
{ pincode: 757045, min_days: 2, max_days: 3 },
{ pincode: 757046, min_days: 2, max_days: 3 },
{ pincode: 757047, min_days: 2, max_days: 3 },
{ pincode: 757048, min_days: 2, max_days: 3 },
{ pincode: 757049, min_days: 2, max_days: 3 },
{ pincode: 757050, min_days: 2, max_days: 3 },
{ pincode: 757051, min_days: 2, max_days: 3 },
{ pincode: 757052, min_days: 2, max_days: 3 },
{ pincode: 757053, min_days: 2, max_days: 3 },
{ pincode: 757054, min_days: 2, max_days: 3 },
{ pincode: 757055, min_days: 2, max_days: 3 },
{ pincode: 757056, min_days: 2, max_days: 3 },
{ pincode: 757073, min_days: 2, max_days: 3 },
{ pincode: 757074, min_days: 2, max_days: 3 },
{ pincode: 757075, min_days: 2, max_days: 3 },
{ pincode: 757077, min_days: 2, max_days: 3 },
{ pincode: 757079, min_days: 2, max_days: 3 },
{ pincode: 757081, min_days: 2, max_days: 3 },
{ pincode: 757082, min_days: 2, max_days: 3 },
{ pincode: 757083, min_days: 2, max_days: 3 },
{ pincode: 757084, min_days: 2, max_days: 3 },
{ pincode: 757085, min_days: 2, max_days: 3 },
{ pincode: 757086, min_days: 2, max_days: 3 },
{ pincode: 757087, min_days: 2, max_days: 3 },
{ pincode: 757091, min_days: 2, max_days: 3 },
{ pincode: 757092, min_days: 2, max_days: 3 },
{ pincode: 757093, min_days: 2, max_days: 3 },
{ pincode: 757100, min_days: 2, max_days: 3 },
{ pincode: 757101, min_days: 2, max_days: 3 },
{ pincode: 757102, min_days: 2, max_days: 3 },
{ pincode: 757103, min_days: 2, max_days: 3 },
{ pincode: 757104, min_days: 2, max_days: 3 },
{ pincode: 757105, min_days: 2, max_days: 3 },
{ pincode: 757106, min_days: 2, max_days: 3 },
{ pincode: 757107, min_days: 2, max_days: 3 },
{ pincode: 758001, min_days: 2, max_days: 3 },
{ pincode: 758002, min_days: 2, max_days: 3 },
{ pincode: 758013, min_days: 2, max_days: 3 },
{ pincode: 758014, min_days: 2, max_days: 3 },
{ pincode: 758015, min_days: 2, max_days: 3 },
{ pincode: 758016, min_days: 2, max_days: 3 },
{ pincode: 758017, min_days: 2, max_days: 3 },
{ pincode: 758018, min_days: 2, max_days: 3 },
{ pincode: 758019, min_days: 2, max_days: 3 },
{ pincode: 758020, min_days: 2, max_days: 3 },
{ pincode: 758021, min_days: 2, max_days: 3 },
{ pincode: 758022, min_days: 2, max_days: 3 },
{ pincode: 758023, min_days: 2, max_days: 3 },
{ pincode: 758025, min_days: 2, max_days: 3 },
{ pincode: 758026, min_days: 2, max_days: 3 },
{ pincode: 758027, min_days: 2, max_days: 3 },
{ pincode: 758028, min_days: 2, max_days: 3 },
{ pincode: 758029, min_days: 2, max_days: 3 },
{ pincode: 758030, min_days: 2, max_days: 3 },
{ pincode: 758031, min_days: 2, max_days: 3 },
{ pincode: 758032, min_days: 2, max_days: 3 },
{ pincode: 758033, min_days: 2, max_days: 3 },
{ pincode: 758034, min_days: 2, max_days: 3 },
{ pincode: 758035, min_days: 2, max_days: 3 },
{ pincode: 758036, min_days: 2, max_days: 3 },
{ pincode: 758037, min_days: 2, max_days: 3 },
{ pincode: 758038, min_days: 2, max_days: 3 },
{ pincode: 758040, min_days: 2, max_days: 3 },
{ pincode: 758041, min_days: 2, max_days: 3 },
{ pincode: 758042, min_days: 2, max_days: 3 },
{ pincode: 758043, min_days: 2, max_days: 3 },
{ pincode: 758044, min_days: 2, max_days: 3 },
{ pincode: 758045, min_days: 2, max_days: 3 },
{ pincode: 758046, min_days: 2, max_days: 3 },
{ pincode: 758047, min_days: 2, max_days: 3 },
{ pincode: 758051, min_days: 2, max_days: 3 },
{ pincode: 758052, min_days: 2, max_days: 3 },
{ pincode: 758054, min_days: 2, max_days: 3 },
{ pincode: 758061, min_days: 2, max_days: 3 },
{ pincode: 758074, min_days: 2, max_days: 3 },
{ pincode: 758075, min_days: 2, max_days: 3 },
{ pincode: 758076, min_days: 2, max_days: 3 },
{ pincode: 758078, min_days: 2, max_days: 3 },
{ pincode: 758079, min_days: 2, max_days: 3 },
{ pincode: 758080, min_days: 2, max_days: 3 },
{ pincode: 758081, min_days: 2, max_days: 3 },
{ pincode: 758082, min_days: 2, max_days: 3 },
{ pincode: 758083, min_days: 2, max_days: 3 },
{ pincode: 758084, min_days: 2, max_days: 3 },
{ pincode: 758085, min_days: 2, max_days: 3 },
{ pincode: 758086, min_days: 2, max_days: 3 },
{ pincode: 758087, min_days: 2, max_days: 3 },
{ pincode: 759001, min_days: 2, max_days: 3 },
{ pincode: 759013, min_days: 2, max_days: 3 },
{ pincode: 759014, min_days: 2, max_days: 3 },
{ pincode: 759015, min_days: 2, max_days: 3 },
{ pincode: 759016, min_days: 2, max_days: 3 },
{ pincode: 759017, min_days: 2, max_days: 3 },
{ pincode: 759018, min_days: 2, max_days: 3 },
{ pincode: 759019, min_days: 2, max_days: 3 },
{ pincode: 759020, min_days: 2, max_days: 3 },
{ pincode: 759021, min_days: 2, max_days: 3 },
{ pincode: 759022, min_days: 2, max_days: 3 },
{ pincode: 759023, min_days: 2, max_days: 3 },
{ pincode: 759024, min_days: 2, max_days: 3 },
{ pincode: 759025, min_days: 2, max_days: 3 },
{ pincode: 759026, min_days: 2, max_days: 3 },
{ pincode: 759027, min_days: 2, max_days: 3 },
{ pincode: 759028, min_days: 2, max_days: 3 },
{ pincode: 759029, min_days: 2, max_days: 3 },
{ pincode: 759031, min_days: 2, max_days: 3 },
{ pincode: 759032, min_days: 2, max_days: 3 },
{ pincode: 759036, min_days: 2, max_days: 3 },
{ pincode: 759037, min_days: 2, max_days: 3 },
{ pincode: 759039, min_days: 2, max_days: 3 },
{ pincode: 759040, min_days: 2, max_days: 3 },
{ pincode: 759100, min_days: 2, max_days: 3 },
{ pincode: 759101, min_days: 2, max_days: 3 },
{ pincode: 759102, min_days: 2, max_days: 3 },
{ pincode: 759103, min_days: 2, max_days: 3 },
{ pincode: 759104, min_days: 2, max_days: 3 },
{ pincode: 759105, min_days: 2, max_days: 3 },
{ pincode: 759106, min_days: 2, max_days: 3 },
{ pincode: 759107, min_days: 2, max_days: 3 },
{ pincode: 759111, min_days: 2, max_days: 3 },
{ pincode: 759114, min_days: 2, max_days: 3 },
{ pincode: 759116, min_days: 2, max_days: 3 },
{ pincode: 759117, min_days: 2, max_days: 3 },
{ pincode: 759118, min_days: 2, max_days: 3 },
{ pincode: 759119, min_days: 2, max_days: 3 },
{ pincode: 759120, min_days: 2, max_days: 3 },
{ pincode: 759121, min_days: 2, max_days: 3 },
{ pincode: 759122, min_days: 2, max_days: 3 },
{ pincode: 759123, min_days: 2, max_days: 3 },
{ pincode: 759124, min_days: 2, max_days: 3 },
{ pincode: 759125, min_days: 2, max_days: 3 },
{ pincode: 759126, min_days: 2, max_days: 3 },
{ pincode: 759127, min_days: 2, max_days: 3 },
{ pincode: 759128, min_days: 2, max_days: 3 },
{ pincode: 759129, min_days: 2, max_days: 3 },
{ pincode: 759130, min_days: 2, max_days: 3 },
{ pincode: 759131, min_days: 2, max_days: 3 },
{ pincode: 759132, min_days: 2, max_days: 3 },
{ pincode: 759133, min_days: 2, max_days: 3 },
{ pincode: 759134, min_days: 2, max_days: 3 },
{ pincode: 759135, min_days: 2, max_days: 3 },
{ pincode: 759136, min_days: 2, max_days: 3 },
{ pincode: 759137, min_days: 2, max_days: 3 },
{ pincode: 759138, min_days: 2, max_days: 3 },
{ pincode: 759139, min_days: 2, max_days: 3 },
{ pincode: 759140, min_days: 2, max_days: 3 },
{ pincode: 759141, min_days: 2, max_days: 3 },
{ pincode: 759142, min_days: 2, max_days: 3 },
{ pincode: 759143, min_days: 2, max_days: 3 },
{ pincode: 759144, min_days: 2, max_days: 3 },
{ pincode: 759145, min_days: 2, max_days: 3 },
{ pincode: 759146, min_days: 2, max_days: 3 },
{ pincode: 759147, min_days: 2, max_days: 3 },
{ pincode: 759148, min_days: 2, max_days: 3 },
{ pincode: 759149, min_days: 2, max_days: 3 },
{ pincode: 759150, min_days: 2, max_days: 3 },
{ pincode: 759151, min_days: 2, max_days: 3 },
{ pincode: 760001, min_days: 2, max_days: 3 },
{ pincode: 760002, min_days: 2, max_days: 3 },
{ pincode: 760003, min_days: 2, max_days: 3 },
{ pincode: 760004, min_days: 2, max_days: 3 },
{ pincode: 760005, min_days: 2, max_days: 3 },
{ pincode: 760006, min_days: 2, max_days: 3 },
{ pincode: 760007, min_days: 2, max_days: 3 },
{ pincode: 760008, min_days: 2, max_days: 3 },
{ pincode: 760009, min_days: 2, max_days: 3 },
{ pincode: 760010, min_days: 2, max_days: 3 },
{ pincode: 760011, min_days: 2, max_days: 3 },
{ pincode: 760020, min_days: 2, max_days: 3 },
{ pincode: 760031, min_days: 2, max_days: 3 },
{ pincode: 760032, min_days: 2, max_days: 3 },
{ pincode: 760033, min_days: 2, max_days: 3 },
{ pincode: 760034, min_days: 2, max_days: 3 },
{ pincode: 760100, min_days: 2, max_days: 3 },
{ pincode: 761001, min_days: 2, max_days: 3 },
{ pincode: 761002, min_days: 2, max_days: 3 },
{ pincode: 761003, min_days: 2, max_days: 3 },
{ pincode: 761004, min_days: 2, max_days: 3 },
{ pincode: 761005, min_days: 2, max_days: 3 },
{ pincode: 761006, min_days: 2, max_days: 3 },
{ pincode: 761007, min_days: 2, max_days: 3 },
{ pincode: 761008, min_days: 2, max_days: 3 },
{ pincode: 761009, min_days: 2, max_days: 3 },
{ pincode: 761010, min_days: 2, max_days: 3 },
{ pincode: 761011, min_days: 2, max_days: 3 },
{ pincode: 761012, min_days: 2, max_days: 3 },
{ pincode: 761013, min_days: 2, max_days: 3 },
{ pincode: 761014, min_days: 2, max_days: 3 },
{ pincode: 761015, min_days: 2, max_days: 3 },
{ pincode: 761016, min_days: 2, max_days: 3 },
{ pincode: 761017, min_days: 2, max_days: 3 },
{ pincode: 761018, min_days: 2, max_days: 3 },
{ pincode: 761019, min_days: 2, max_days: 3 },
{ pincode: 761020, min_days: 2, max_days: 3 },
{ pincode: 761021, min_days: 2, max_days: 3 },
{ pincode: 761025, min_days: 2, max_days: 3 },
{ pincode: 761026, min_days: 2, max_days: 3 },
{ pincode: 761027, min_days: 2, max_days: 3 },
{ pincode: 761028, min_days: 2, max_days: 3 },
{ pincode: 761029, min_days: 2, max_days: 3 },
{ pincode: 761030, min_days: 2, max_days: 3 },
{ pincode: 761031, min_days: 2, max_days: 3 },
{ pincode: 761032, min_days: 2, max_days: 3 },
{ pincode: 761034, min_days: 2, max_days: 3 },
{ pincode: 761035, min_days: 2, max_days: 3 },
{ pincode: 761036, min_days: 2, max_days: 3 },
{ pincode: 761037, min_days: 2, max_days: 3 },
{ pincode: 761038, min_days: 2, max_days: 3 },
{ pincode: 761039, min_days: 2, max_days: 3 },
{ pincode: 761040, min_days: 2, max_days: 3 },
{ pincode: 761041, min_days: 2, max_days: 3 },
{ pincode: 761042, min_days: 2, max_days: 3 },
{ pincode: 761043, min_days: 2, max_days: 3 },
{ pincode: 761045, min_days: 2, max_days: 3 },
{ pincode: 761051, min_days: 2, max_days: 3 },
{ pincode: 761052, min_days: 2, max_days: 3 },
{ pincode: 761053, min_days: 2, max_days: 3 },
{ pincode: 761054, min_days: 2, max_days: 3 },
{ pincode: 761055, min_days: 2, max_days: 3 },
{ pincode: 761100, min_days: 2, max_days: 3 },
{ pincode: 761101, min_days: 2, max_days: 3 },
{ pincode: 761102, min_days: 2, max_days: 3 },
{ pincode: 761103, min_days: 2, max_days: 3 },
{ pincode: 761104, min_days: 2, max_days: 3 },
{ pincode: 761105, min_days: 2, max_days: 3 },
{ pincode: 761106, min_days: 2, max_days: 3 },
{ pincode: 761107, min_days: 2, max_days: 3 },
{ pincode: 761108, min_days: 2, max_days: 3 },
{ pincode: 761109, min_days: 2, max_days: 3 },
{ pincode: 761110, min_days: 2, max_days: 3 },
{ pincode: 761111, min_days: 2, max_days: 3 },
{ pincode: 761112, min_days: 2, max_days: 3 },
{ pincode: 761113, min_days: 2, max_days: 3 },
{ pincode: 761114, min_days: 2, max_days: 3 },
{ pincode: 761115, min_days: 2, max_days: 3 },
{ pincode: 761116, min_days: 2, max_days: 3 },
{ pincode: 761117, min_days: 2, max_days: 3 },
{ pincode: 761118, min_days: 2, max_days: 3 },
{ pincode: 761119, min_days: 2, max_days: 3 },
{ pincode: 761120, min_days: 2, max_days: 3 },
{ pincode: 761121, min_days: 2, max_days: 3 },
{ pincode: 761122, min_days: 2, max_days: 3 },
{ pincode: 761123, min_days: 2, max_days: 3 },
{ pincode: 761124, min_days: 2, max_days: 3 },
{ pincode: 761125, min_days: 2, max_days: 3 },
{ pincode: 761126, min_days: 2, max_days: 3 },
{ pincode: 761127, min_days: 2, max_days: 3 },
{ pincode: 761128, min_days: 2, max_days: 3 },
{ pincode: 761131, min_days: 2, max_days: 3 },
{ pincode: 761132, min_days: 2, max_days: 3 },
{ pincode: 761133, min_days: 2, max_days: 3 },
{ pincode: 761134, min_days: 2, max_days: 3 },
{ pincode: 761135, min_days: 2, max_days: 3 },
{ pincode: 761136, min_days: 2, max_days: 3 },
{ pincode: 761140, min_days: 2, max_days: 3 },
{ pincode: 761141, min_days: 2, max_days: 3 },
{ pincode: 761143, min_days: 2, max_days: 3 },
{ pincode: 761144, min_days: 2, max_days: 3 },
{ pincode: 761145, min_days: 2, max_days: 3 },
{ pincode: 761146, min_days: 2, max_days: 3 },
{ pincode: 761151, min_days: 2, max_days: 3 },
{ pincode: 761200, min_days: 2, max_days: 3 },
{ pincode: 761201, min_days: 2, max_days: 3 },
{ pincode: 761206, min_days: 2, max_days: 3 },
{ pincode: 761207, min_days: 2, max_days: 3 },
{ pincode: 761208, min_days: 2, max_days: 3 },
{ pincode: 761209, min_days: 2, max_days: 3 },
{ pincode: 761210, min_days: 2, max_days: 3 },
{ pincode: 761211, min_days: 2, max_days: 3 },
{ pincode: 761212, min_days: 2, max_days: 3 },
{ pincode: 761213, min_days: 2, max_days: 3 },
{ pincode: 761214, min_days: 2, max_days: 3 },
{ pincode: 761215, min_days: 2, max_days: 3 },
{ pincode: 761216, min_days: 2, max_days: 3 },
{ pincode: 761217, min_days: 2, max_days: 3 },
{ pincode: 762001, min_days: 2, max_days: 3 },
{ pincode: 762002, min_days: 2, max_days: 3 },
{ pincode: 762010, min_days: 2, max_days: 3 },
{ pincode: 762011, min_days: 2, max_days: 3 },
{ pincode: 762012, min_days: 2, max_days: 3 },
{ pincode: 762013, min_days: 2, max_days: 3 },
{ pincode: 762014, min_days: 2, max_days: 3 },
{ pincode: 762015, min_days: 2, max_days: 3 },
{ pincode: 762016, min_days: 2, max_days: 3 },
{ pincode: 762017, min_days: 2, max_days: 3 },
{ pincode: 762018, min_days: 2, max_days: 3 },
{ pincode: 762019, min_days: 2, max_days: 3 },
{ pincode: 762020, min_days: 2, max_days: 3 },
{ pincode: 762021, min_days: 2, max_days: 3 },
{ pincode: 762022, min_days: 2, max_days: 3 },
{ pincode: 762023, min_days: 2, max_days: 3 },
{ pincode: 762024, min_days: 2, max_days: 3 },
{ pincode: 762025, min_days: 2, max_days: 3 },
{ pincode: 762026, min_days: 2, max_days: 3 },
{ pincode: 762027, min_days: 2, max_days: 3 },
{ pincode: 762028, min_days: 2, max_days: 3 },
{ pincode: 762029, min_days: 2, max_days: 3 },
{ pincode: 762030, min_days: 2, max_days: 3 },
{ pincode: 762100, min_days: 2, max_days: 3 },
{ pincode: 762101, min_days: 2, max_days: 3 },
{ pincode: 762102, min_days: 2, max_days: 3 },
{ pincode: 762103, min_days: 2, max_days: 3 },
{ pincode: 762104, min_days: 2, max_days: 3 },
{ pincode: 762105, min_days: 2, max_days: 3 },
{ pincode: 762106, min_days: 2, max_days: 3 },
{ pincode: 762107, min_days: 2, max_days: 3 },
{ pincode: 762108, min_days: 2, max_days: 3 },
{ pincode: 762109, min_days: 2, max_days: 3 },
{ pincode: 762110, min_days: 2, max_days: 3 },
{ pincode: 762111, min_days: 2, max_days: 3 },
{ pincode: 762112, min_days: 2, max_days: 3 },
{ pincode: 763001, min_days: 2, max_days: 3 },
{ pincode: 763002, min_days: 2, max_days: 3 },
{ pincode: 763003, min_days: 2, max_days: 3 },
{ pincode: 763004, min_days: 2, max_days: 3 },
{ pincode: 763008, min_days: 2, max_days: 3 },
{ pincode: 763036, min_days: 2, max_days: 3 },
{ pincode: 764001, min_days: 2, max_days: 3 },
{ pincode: 764002, min_days: 2, max_days: 3 },
{ pincode: 764003, min_days: 2, max_days: 3 },
{ pincode: 764004, min_days: 2, max_days: 3 },
{ pincode: 764005, min_days: 2, max_days: 3 },
{ pincode: 764006, min_days: 2, max_days: 3 },
{ pincode: 764008, min_days: 2, max_days: 3 },
{ pincode: 764011, min_days: 2, max_days: 3 },
{ pincode: 764012, min_days: 2, max_days: 3 },
{ pincode: 764014, min_days: 2, max_days: 3 },
{ pincode: 764020, min_days: 2, max_days: 3 },
{ pincode: 764021, min_days: 2, max_days: 3 },
{ pincode: 764022, min_days: 2, max_days: 3 },
{ pincode: 764027, min_days: 2, max_days: 3 },
{ pincode: 764028, min_days: 2, max_days: 3 },
{ pincode: 764036, min_days: 2, max_days: 3 },
{ pincode: 764037, min_days: 2, max_days: 3 },
{ pincode: 764038, min_days: 2, max_days: 3 },
{ pincode: 764039, min_days: 2, max_days: 3 },
{ pincode: 764040, min_days: 2, max_days: 3 },
{ pincode: 764041, min_days: 2, max_days: 3 },
{ pincode: 764042, min_days: 2, max_days: 3 },
{ pincode: 764043, min_days: 2, max_days: 3 },
{ pincode: 764044, min_days: 2, max_days: 3 },
{ pincode: 764045, min_days: 2, max_days: 3 },
{ pincode: 764046, min_days: 2, max_days: 3 },
{ pincode: 764047, min_days: 2, max_days: 3 },
{ pincode: 764048, min_days: 2, max_days: 3 },
{ pincode: 764049, min_days: 2, max_days: 3 },
{ pincode: 764051, min_days: 2, max_days: 3 },
{ pincode: 764052, min_days: 2, max_days: 3 },
{ pincode: 764053, min_days: 2, max_days: 3 },
{ pincode: 764054, min_days: 2, max_days: 3 },
{ pincode: 764055, min_days: 2, max_days: 3 },
{ pincode: 764056, min_days: 2, max_days: 3 },
{ pincode: 764057, min_days: 2, max_days: 3 },
{ pincode: 764058, min_days: 2, max_days: 3 },
{ pincode: 764059, min_days: 2, max_days: 3 },
{ pincode: 764061, min_days: 2, max_days: 3 },
{ pincode: 764062, min_days: 2, max_days: 3 },
{ pincode: 764063, min_days: 2, max_days: 3 },
{ pincode: 764069, min_days: 2, max_days: 3 },
{ pincode: 764070, min_days: 2, max_days: 3 },
{ pincode: 764071, min_days: 2, max_days: 3 },
{ pincode: 764072, min_days: 2, max_days: 3 },
{ pincode: 764073, min_days: 2, max_days: 3 },
{ pincode: 764074, min_days: 2, max_days: 3 },
{ pincode: 764075, min_days: 2, max_days: 3 },
{ pincode: 764076, min_days: 2, max_days: 3 },
{ pincode: 764077, min_days: 2, max_days: 3 },
{ pincode: 764078, min_days: 2, max_days: 3 },
{ pincode: 764081, min_days: 2, max_days: 3 },
{ pincode: 764082, min_days: 2, max_days: 3 },
{ pincode: 764083, min_days: 2, max_days: 3 },
{ pincode: 764084, min_days: 2, max_days: 3 },
{ pincode: 764085, min_days: 2, max_days: 3 },
{ pincode: 764086, min_days: 2, max_days: 3 },
{ pincode: 764087, min_days: 2, max_days: 3 },
{ pincode: 764088, min_days: 2, max_days: 3 },
{ pincode: 765001, min_days: 2, max_days: 3 },
{ pincode: 765002, min_days: 2, max_days: 3 },
{ pincode: 765012, min_days: 2, max_days: 3 },
{ pincode: 765013, min_days: 2, max_days: 3 },
{ pincode: 765015, min_days: 2, max_days: 3 },
{ pincode: 765016, min_days: 2, max_days: 3 },
{ pincode: 765017, min_days: 2, max_days: 3 },
{ pincode: 765018, min_days: 2, max_days: 3 },
{ pincode: 765019, min_days: 2, max_days: 3 },
{ pincode: 765020, min_days: 2, max_days: 3 },
{ pincode: 765021, min_days: 2, max_days: 3 },
{ pincode: 765022, min_days: 2, max_days: 3 },
{ pincode: 765023, min_days: 2, max_days: 3 },
{ pincode: 765024, min_days: 2, max_days: 3 },
{ pincode: 765025, min_days: 2, max_days: 3 },
{ pincode: 765026, min_days: 2, max_days: 3 },
{ pincode: 765028, min_days: 2, max_days: 3 },
{ pincode: 765029, min_days: 2, max_days: 3 },
{ pincode: 765030, min_days: 2, max_days: 3 },
{ pincode: 765031, min_days: 2, max_days: 3 },
{ pincode: 765033, min_days: 2, max_days: 3 },
{ pincode: 765034, min_days: 2, max_days: 3 },
{ pincode: 765062, min_days: 2, max_days: 3 },
{ pincode: 766001, min_days: 2, max_days: 3 },
{ pincode: 766002, min_days: 2, max_days: 3 },
{ pincode: 766003, min_days: 2, max_days: 3 },
{ pincode: 766011, min_days: 2, max_days: 3 },
{ pincode: 766012, min_days: 2, max_days: 3 },
{ pincode: 766013, min_days: 2, max_days: 3 },
{ pincode: 766014, min_days: 2, max_days: 3 },
{ pincode: 766015, min_days: 2, max_days: 3 },
{ pincode: 766016, min_days: 2, max_days: 3 },
{ pincode: 766017, min_days: 2, max_days: 3 },
{ pincode: 766018, min_days: 2, max_days: 3 },
{ pincode: 766019, min_days: 2, max_days: 3 },
{ pincode: 766020, min_days: 2, max_days: 3 },
{ pincode: 766021, min_days: 2, max_days: 3 },
{ pincode: 766023, min_days: 2, max_days: 3 },
{ pincode: 766025, min_days: 2, max_days: 3 },
{ pincode: 766026, min_days: 2, max_days: 3 },
{ pincode: 766027, min_days: 2, max_days: 3 },
{ pincode: 766028, min_days: 2, max_days: 3 },
{ pincode: 766029, min_days: 2, max_days: 3 },
{ pincode: 766031, min_days: 2, max_days: 3 },
{ pincode: 766032, min_days: 2, max_days: 3 },
{ pincode: 766036, min_days: 2, max_days: 3 },
{ pincode: 766037, min_days: 2, max_days: 3 },
{ pincode: 766100, min_days: 2, max_days: 3 },
{ pincode: 766101, min_days: 2, max_days: 3 },
{ pincode: 766102, min_days: 2, max_days: 3 },
{ pincode: 766103, min_days: 2, max_days: 3 },
{ pincode: 766104, min_days: 2, max_days: 3 },
{ pincode: 766105, min_days: 2, max_days: 3 },
{ pincode: 766106, min_days: 2, max_days: 3 },
{ pincode: 766107, min_days: 2, max_days: 3 },
{ pincode: 766108, min_days: 2, max_days: 3 },
{ pincode: 766110, min_days: 2, max_days: 3 },
{ pincode: 766111, min_days: 2, max_days: 3 },
{ pincode: 766112, min_days: 2, max_days: 3 },
{ pincode: 766113, min_days: 2, max_days: 3 },
{ pincode: 766116, min_days: 2, max_days: 3 },
{ pincode: 766117, min_days: 2, max_days: 3 },
{ pincode: 766118, min_days: 2, max_days: 3 },
{ pincode: 767001, min_days: 2, max_days: 3 },
{ pincode: 767002, min_days: 2, max_days: 3 },
{ pincode: 767003, min_days: 2, max_days: 3 },
{ pincode: 767004, min_days: 2, max_days: 3 },
{ pincode: 767005, min_days: 2, max_days: 3 },
{ pincode: 767006, min_days: 2, max_days: 3 },
{ pincode: 767016, min_days: 2, max_days: 3 },
{ pincode: 767017, min_days: 2, max_days: 3 },
{ pincode: 767018, min_days: 2, max_days: 3 },
{ pincode: 767019, min_days: 2, max_days: 3 },
{ pincode: 767020, min_days: 2, max_days: 3 },
{ pincode: 767021, min_days: 2, max_days: 3 },
{ pincode: 767022, min_days: 2, max_days: 3 },
{ pincode: 767023, min_days: 2, max_days: 3 },
{ pincode: 767024, min_days: 2, max_days: 3 },
{ pincode: 767025, min_days: 2, max_days: 3 },
{ pincode: 767026, min_days: 2, max_days: 3 },
{ pincode: 767027, min_days: 2, max_days: 3 },
{ pincode: 767028, min_days: 2, max_days: 3 },
{ pincode: 767029, min_days: 2, max_days: 3 },
{ pincode: 767030, min_days: 2, max_days: 3 },
{ pincode: 767032, min_days: 2, max_days: 3 },
{ pincode: 767033, min_days: 2, max_days: 3 },
{ pincode: 767034, min_days: 2, max_days: 3 },
{ pincode: 767035, min_days: 2, max_days: 3 },
{ pincode: 767037, min_days: 2, max_days: 3 },
{ pincode: 767038, min_days: 2, max_days: 3 },
{ pincode: 767039, min_days: 2, max_days: 3 },
{ pincode: 767040, min_days: 2, max_days: 3 },
{ pincode: 767041, min_days: 2, max_days: 3 },
{ pincode: 767042, min_days: 2, max_days: 3 },
{ pincode: 767045, min_days: 2, max_days: 3 },
{ pincode: 767046, min_days: 2, max_days: 3 },
{ pincode: 767048, min_days: 2, max_days: 3 },
{ pincode: 767060, min_days: 2, max_days: 3 },
{ pincode: 767061, min_days: 2, max_days: 3 },
{ pincode: 767062, min_days: 2, max_days: 3 },
{ pincode: 767065, min_days: 2, max_days: 3 },
{ pincode: 767066, min_days: 2, max_days: 3 },
{ pincode: 767067, min_days: 2, max_days: 3 },
{ pincode: 767068, min_days: 2, max_days: 3 },
{ pincode: 767070, min_days: 2, max_days: 3 },
{ pincode: 767071, min_days: 2, max_days: 3 },
{ pincode: 767091, min_days: 2, max_days: 3 },
{ pincode: 767184, min_days: 2, max_days: 3 },
{ pincode: 768001, min_days: 2, max_days: 3 },
{ pincode: 768002, min_days: 2, max_days: 3 },
{ pincode: 768003, min_days: 2, max_days: 3 },
{ pincode: 768004, min_days: 2, max_days: 3 },
{ pincode: 768005, min_days: 2, max_days: 3 },
{ pincode: 768006, min_days: 2, max_days: 3 },
{ pincode: 768007, min_days: 2, max_days: 3 },
{ pincode: 768011, min_days: 2, max_days: 3 },
{ pincode: 768016, min_days: 2, max_days: 3 },
{ pincode: 768017, min_days: 2, max_days: 3 },
{ pincode: 768018, min_days: 2, max_days: 3 },
{ pincode: 768019, min_days: 2, max_days: 3 },
{ pincode: 768020, min_days: 2, max_days: 3 },
{ pincode: 768024, min_days: 2, max_days: 3 },
{ pincode: 768025, min_days: 2, max_days: 3 },
{ pincode: 768026, min_days: 2, max_days: 3 },
{ pincode: 768027, min_days: 2, max_days: 3 },
{ pincode: 768028, min_days: 2, max_days: 3 },
{ pincode: 768029, min_days: 2, max_days: 3 },
{ pincode: 768030, min_days: 2, max_days: 3 },
{ pincode: 768031, min_days: 2, max_days: 3 },
{ pincode: 768032, min_days: 2, max_days: 3 },
{ pincode: 768033, min_days: 2, max_days: 3 },
{ pincode: 768034, min_days: 2, max_days: 3 },
{ pincode: 768035, min_days: 2, max_days: 3 },
{ pincode: 768036, min_days: 2, max_days: 3 },
{ pincode: 768037, min_days: 2, max_days: 3 },
{ pincode: 768038, min_days: 2, max_days: 3 },
{ pincode: 768039, min_days: 2, max_days: 3 },
{ pincode: 768040, min_days: 2, max_days: 3 },
{ pincode: 768042, min_days: 2, max_days: 3 },
{ pincode: 768043, min_days: 2, max_days: 3 },
{ pincode: 768045, min_days: 2, max_days: 3 },
{ pincode: 768046, min_days: 2, max_days: 3 },
{ pincode: 768047, min_days: 2, max_days: 3 },
{ pincode: 768048, min_days: 2, max_days: 3 },
{ pincode: 768049, min_days: 2, max_days: 3 },
{ pincode: 768050, min_days: 2, max_days: 3 },
{ pincode: 768051, min_days: 2, max_days: 3 },
{ pincode: 768052, min_days: 2, max_days: 3 },
{ pincode: 768053, min_days: 2, max_days: 3 },
{ pincode: 768100, min_days: 2, max_days: 3 },
{ pincode: 768101, min_days: 2, max_days: 3 },
{ pincode: 768102, min_days: 2, max_days: 3 },
{ pincode: 768103, min_days: 2, max_days: 3 },
{ pincode: 768104, min_days: 2, max_days: 3 },
{ pincode: 768105, min_days: 2, max_days: 3 },
{ pincode: 768106, min_days: 2, max_days: 3 },
{ pincode: 768107, min_days: 2, max_days: 3 },
{ pincode: 768108, min_days: 2, max_days: 3 },
{ pincode: 768109, min_days: 2, max_days: 3 },
{ pincode: 768110, min_days: 2, max_days: 3 },
{ pincode: 768111, min_days: 2, max_days: 3 },
{ pincode: 768112, min_days: 2, max_days: 3 },
{ pincode: 768113, min_days: 2, max_days: 3 },
{ pincode: 768114, min_days: 2, max_days: 3 },
{ pincode: 768115, min_days: 2, max_days: 3 },
{ pincode: 768116, min_days: 2, max_days: 3 },
{ pincode: 768117, min_days: 2, max_days: 3 },
{ pincode: 768118, min_days: 2, max_days: 3 },
{ pincode: 768119, min_days: 2, max_days: 3 },
{ pincode: 768120, min_days: 2, max_days: 3 },
{ pincode: 768121, min_days: 2, max_days: 3 },
{ pincode: 768130, min_days: 2, max_days: 3 },
{ pincode: 768142, min_days: 2, max_days: 3 },
{ pincode: 768150, min_days: 2, max_days: 3 },
{ pincode: 768200, min_days: 2, max_days: 3 },
{ pincode: 768201, min_days: 2, max_days: 3 },
{ pincode: 768202, min_days: 2, max_days: 3 },
{ pincode: 768203, min_days: 2, max_days: 3 },
{ pincode: 768204, min_days: 2, max_days: 3 },
{ pincode: 768205, min_days: 2, max_days: 3 },
{ pincode: 768210, min_days: 2, max_days: 3 },
{ pincode: 768211, min_days: 2, max_days: 3 },
{ pincode: 768212, min_days: 2, max_days: 3 },
{ pincode: 768213, min_days: 2, max_days: 3 },
{ pincode: 768214, min_days: 2, max_days: 3 },
{ pincode: 768215, min_days: 2, max_days: 3 },
{ pincode: 768216, min_days: 2, max_days: 3 },
{ pincode: 768217, min_days: 2, max_days: 3 },
{ pincode: 768218, min_days: 2, max_days: 3 },
{ pincode: 768219, min_days: 2, max_days: 3 },
{ pincode: 768220, min_days: 2, max_days: 3 },
{ pincode: 768221, min_days: 2, max_days: 3 },
{ pincode: 768222, min_days: 2, max_days: 3 },
{ pincode: 768223, min_days: 2, max_days: 3 },
{ pincode: 768224, min_days: 2, max_days: 3 },
{ pincode: 768225, min_days: 2, max_days: 3 },
{ pincode: 768226, min_days: 2, max_days: 3 },
{ pincode: 768227, min_days: 2, max_days: 3 },
{ pincode: 768228, min_days: 2, max_days: 3 },
{ pincode: 768229, min_days: 2, max_days: 3 },
{ pincode: 768230, min_days: 2, max_days: 3 },
{ pincode: 768231, min_days: 2, max_days: 3 },
{ pincode: 768232, min_days: 2, max_days: 3 },
{ pincode: 768233, min_days: 2, max_days: 3 },
{ pincode: 768234, min_days: 2, max_days: 3 },
{ pincode: 769001, min_days: 2, max_days: 3 },
{ pincode: 769002, min_days: 2, max_days: 3 },
{ pincode: 769003, min_days: 2, max_days: 3 },
{ pincode: 769004, min_days: 2, max_days: 3 },
{ pincode: 769005, min_days: 2, max_days: 3 },
{ pincode: 769006, min_days: 2, max_days: 3 },
{ pincode: 769007, min_days: 2, max_days: 3 },
{ pincode: 769008, min_days: 2, max_days: 3 },
{ pincode: 769009, min_days: 2, max_days: 3 },
{ pincode: 769010, min_days: 2, max_days: 3 },
{ pincode: 769011, min_days: 2, max_days: 3 },
{ pincode: 769012, min_days: 2, max_days: 3 },
{ pincode: 769013, min_days: 2, max_days: 3 },
{ pincode: 769014, min_days: 2, max_days: 3 },
{ pincode: 769015, min_days: 2, max_days: 3 },
{ pincode: 769016, min_days: 2, max_days: 3 },
{ pincode: 769017, min_days: 2, max_days: 3 },
{ pincode: 769018, min_days: 2, max_days: 3 },
{ pincode: 769019, min_days: 2, max_days: 3 },
{ pincode: 769031, min_days: 2, max_days: 3 },
{ pincode: 769032, min_days: 2, max_days: 3 },
{ pincode: 769034, min_days: 2, max_days: 3 },
{ pincode: 769037, min_days: 2, max_days: 3 },
{ pincode: 769041, min_days: 2, max_days: 3 },
{ pincode: 769042, min_days: 2, max_days: 3 },
{ pincode: 769043, min_days: 2, max_days: 3 },
{ pincode: 770001, min_days: 2, max_days: 3 },
{ pincode: 770002, min_days: 2, max_days: 3 },
{ pincode: 770011, min_days: 2, max_days: 3 },
{ pincode: 770012, min_days: 2, max_days: 3 },
{ pincode: 770013, min_days: 2, max_days: 3 },
{ pincode: 770014, min_days: 2, max_days: 3 },
{ pincode: 770015, min_days: 2, max_days: 3 },
{ pincode: 770016, min_days: 2, max_days: 3 },
{ pincode: 770017, min_days: 2, max_days: 3 },
{ pincode: 770018, min_days: 2, max_days: 3 },
{ pincode: 770019, min_days: 2, max_days: 3 },
{ pincode: 770020, min_days: 2, max_days: 3 },
{ pincode: 770021, min_days: 2, max_days: 3 },
{ pincode: 770022, min_days: 2, max_days: 3 },
{ pincode: 770023, min_days: 2, max_days: 3 },
{ pincode: 770024, min_days: 2, max_days: 3 },
{ pincode: 770025, min_days: 2, max_days: 3 },
{ pincode: 770031, min_days: 2, max_days: 3 },
{ pincode: 770032, min_days: 2, max_days: 3 },
{ pincode: 770033, min_days: 2, max_days: 3 },
{ pincode: 770034, min_days: 2, max_days: 3 },
{ pincode: 770035, min_days: 2, max_days: 3 },
{ pincode: 770036, min_days: 2, max_days: 3 },
{ pincode: 770037, min_days: 2, max_days: 3 },
{ pincode: 770038, min_days: 2, max_days: 3 },
{ pincode: 770039, min_days: 2, max_days: 3 },
{ pincode: 770040, min_days: 2, max_days: 3 },
{ pincode: 770041, min_days: 2, max_days: 3 },
{ pincode: 770042, min_days: 2, max_days: 3 },
{ pincode: 770043, min_days: 2, max_days: 3 },
{ pincode: 770044, min_days: 2, max_days: 3 },
{ pincode: 770046, min_days: 2, max_days: 3 },
{ pincode: 770048, min_days: 2, max_days: 3 },
{ pincode: 770049, min_days: 2, max_days: 3 },
{ pincode: 770051, min_days: 2, max_days: 3 },
{ pincode: 770052, min_days: 2, max_days: 3 },
{ pincode: 770070, min_days: 2, max_days: 3 },
{ pincode: 770072, min_days: 2, max_days: 3 },
{ pincode: 770073, min_days: 2, max_days: 3 },
{ pincode: 770074, min_days: 2, max_days: 3 },
{ pincode: 770075, min_days: 2, max_days: 3 },
{ pincode: 770076, min_days: 2, max_days: 3 },
{ pincode: 773235, min_days: 2, max_days: 3 },
{ pincode: 781001, min_days: 3, max_days: 4 },
{ pincode: 781002, min_days: 3, max_days: 4 },
{ pincode: 781003, min_days: 3, max_days: 4 },
{ pincode: 781004, min_days: 3, max_days: 4 },
{ pincode: 781005, min_days: 3, max_days: 4 },
{ pincode: 781006, min_days: 3, max_days: 4 },
{ pincode: 781007, min_days: 3, max_days: 4 },
{ pincode: 781008, min_days: 3, max_days: 4 },
{ pincode: 781009, min_days: 2, max_days: 3 },
{ pincode: 781010, min_days: 2, max_days: 3 },
{ pincode: 781011, min_days: 3, max_days: 4 },
{ pincode: 781012, min_days: 2, max_days: 3 },
{ pincode: 781013, min_days: 2, max_days: 3 },
{ pincode: 781014, min_days: 2, max_days: 3 },
{ pincode: 781015, min_days: 2, max_days: 3 },
{ pincode: 781016, min_days: 3, max_days: 4 },
{ pincode: 781017, min_days: 2, max_days: 3 },
{ pincode: 781018, min_days: 3, max_days: 4 },
{ pincode: 781019, min_days: 3, max_days: 4 },
{ pincode: 781020, min_days: 3, max_days: 4 },
{ pincode: 781021, min_days: 3, max_days: 4 },
{ pincode: 781022, min_days: 3, max_days: 4 },
{ pincode: 781023, min_days: 2, max_days: 3 },
{ pincode: 781024, min_days: 3, max_days: 4 },
{ pincode: 781025, min_days: 2, max_days: 3 },
{ pincode: 781026, min_days: 3, max_days: 4 },
{ pincode: 781027, min_days: 3, max_days: 4 },
{ pincode: 781028, min_days: 3, max_days: 4 },
{ pincode: 781029, min_days: 3, max_days: 4 },
{ pincode: 781030, min_days: 3, max_days: 4 },
{ pincode: 781031, min_days: 2, max_days: 3 },
{ pincode: 781032, min_days: 3, max_days: 4 },
{ pincode: 781033, min_days: 2, max_days: 3 },
{ pincode: 781034, min_days: 3, max_days: 4 },
{ pincode: 781035, min_days: 2, max_days: 3 },
{ pincode: 781036, min_days: 3, max_days: 4 },
{ pincode: 781037, min_days: 3, max_days: 4 },
{ pincode: 781038, min_days: 3, max_days: 4 },
{ pincode: 781039, min_days: 2, max_days: 3 },
{ pincode: 781040, min_days: 3, max_days: 4 },
{ pincode: 781068, min_days: 3, max_days: 4 },
{ pincode: 781071, min_days: 3, max_days: 4 },
{ pincode: 781101, min_days: 2, max_days: 3 },
{ pincode: 781102, min_days: 2, max_days: 3 },
{ pincode: 781103, min_days: 2, max_days: 3 },
{ pincode: 781104, min_days: 2, max_days: 3 },
{ pincode: 781112, min_days: 3, max_days: 4 },
{ pincode: 781120, min_days: 2, max_days: 3 },
{ pincode: 781121, min_days: 2, max_days: 3 },
{ pincode: 781122, min_days: 2, max_days: 3 },
{ pincode: 781123, min_days: 2, max_days: 3 },
{ pincode: 781124, min_days: 2, max_days: 3 },
{ pincode: 781125, min_days: 2, max_days: 3 },
{ pincode: 781126, min_days: 2, max_days: 3 },
{ pincode: 781127, min_days: 3, max_days: 4 },
{ pincode: 781128, min_days: 2, max_days: 3 },
{ pincode: 781129, min_days: 2, max_days: 3 },
{ pincode: 781130, min_days: 3, max_days: 4 },
{ pincode: 781131, min_days: 3, max_days: 4 },
{ pincode: 781132, min_days: 3, max_days: 4 },
{ pincode: 781133, min_days: 2, max_days: 3 },
{ pincode: 781134, min_days: 2, max_days: 3 },
{ pincode: 781135, min_days: 2, max_days: 3 },
{ pincode: 781136, min_days: 2, max_days: 3 },
{ pincode: 781137, min_days: 2, max_days: 3 },
{ pincode: 781138, min_days: 2, max_days: 3 },
{ pincode: 781141, min_days: 3, max_days: 4 },
{ pincode: 781150, min_days: 3, max_days: 4 },
{ pincode: 781171, min_days: 3, max_days: 4 },
{ pincode: 781301, min_days: 2, max_days: 3 },
{ pincode: 781302, min_days: 2, max_days: 3 },
{ pincode: 781303, min_days: 2, max_days: 3 },
{ pincode: 781304, min_days: 2, max_days: 3 },
{ pincode: 781305, min_days: 2, max_days: 3 },
{ pincode: 781306, min_days: 2, max_days: 3 },
{ pincode: 781307, min_days: 2, max_days: 3 },
{ pincode: 781308, min_days: 2, max_days: 3 },
{ pincode: 781309, min_days: 2, max_days: 3 },
{ pincode: 781310, min_days: 2, max_days: 3 },
{ pincode: 781311, min_days: 2, max_days: 3 },
{ pincode: 781312, min_days: 2, max_days: 3 },
{ pincode: 781313, min_days: 2, max_days: 3 },
{ pincode: 781314, min_days: 2, max_days: 3 },
{ pincode: 781315, min_days: 2, max_days: 3 },
{ pincode: 781316, min_days: 2, max_days: 3 },
{ pincode: 781317, min_days: 2, max_days: 3 },
{ pincode: 781318, min_days: 2, max_days: 3 },
{ pincode: 781319, min_days: 2, max_days: 3 },
{ pincode: 781320, min_days: 2, max_days: 3 },
{ pincode: 781321, min_days: 2, max_days: 3 },
{ pincode: 781325, min_days: 2, max_days: 3 },
{ pincode: 781326, min_days: 2, max_days: 3 },
{ pincode: 781327, min_days: 2, max_days: 3 },
{ pincode: 781328, min_days: 2, max_days: 3 },
{ pincode: 781329, min_days: 2, max_days: 3 },
{ pincode: 781330, min_days: 2, max_days: 3 },
{ pincode: 781333, min_days: 2, max_days: 3 },
{ pincode: 781334, min_days: 2, max_days: 3 },
{ pincode: 781335, min_days: 2, max_days: 3 },
{ pincode: 781336, min_days: 3, max_days: 4 },
{ pincode: 781337, min_days: 2, max_days: 3 },
{ pincode: 781338, min_days: 2, max_days: 3 },
{ pincode: 781339, min_days: 2, max_days: 3 },
{ pincode: 781340, min_days: 2, max_days: 3 },
{ pincode: 781341, min_days: 2, max_days: 3 },
{ pincode: 781343, min_days: 2, max_days: 3 },
{ pincode: 781344, min_days: 2, max_days: 3 },
{ pincode: 781346, min_days: 2, max_days: 3 },
{ pincode: 781347, min_days: 2, max_days: 3 },
{ pincode: 781348, min_days: 2, max_days: 3 },
{ pincode: 781349, min_days: 2, max_days: 3 },
{ pincode: 781350, min_days: 3, max_days: 4 },
{ pincode: 781351, min_days: 2, max_days: 3 },
{ pincode: 781352, min_days: 2, max_days: 3 },
{ pincode: 781353, min_days: 2, max_days: 3 },
{ pincode: 781354, min_days: 3, max_days: 4 },
{ pincode: 781355, min_days: 2, max_days: 3 },
{ pincode: 781360, min_days: 2, max_days: 3 },
{ pincode: 781364, min_days: 2, max_days: 3 },
{ pincode: 781365, min_days: 2, max_days: 3 },
{ pincode: 781366, min_days: 2, max_days: 3 },
{ pincode: 781367, min_days: 2, max_days: 3 },
{ pincode: 781368, min_days: 2, max_days: 3 },
{ pincode: 781369, min_days: 2, max_days: 3 },
{ pincode: 781370, min_days: 2, max_days: 3 },
{ pincode: 781371, min_days: 2, max_days: 3 },
{ pincode: 781372, min_days: 2, max_days: 3 },
{ pincode: 781373, min_days: 2, max_days: 3 },
{ pincode: 781374, min_days: 2, max_days: 3 },
{ pincode: 781375, min_days: 2, max_days: 3 },
{ pincode: 781376, min_days: 3, max_days: 4 },
{ pincode: 781377, min_days: 2, max_days: 3 },
{ pincode: 781378, min_days: 2, max_days: 3 },
{ pincode: 781380, min_days: 2, max_days: 3 },
{ pincode: 781381, min_days: 3, max_days: 4 },
{ pincode: 781382, min_days: 3, max_days: 4 },
{ pincode: 781385, min_days: 3, max_days: 4 },
{ pincode: 782001, min_days: 3, max_days: 4 },
{ pincode: 782002, min_days: 3, max_days: 4 },
{ pincode: 782003, min_days: 3, max_days: 4 },
{ pincode: 782010, min_days: 3, max_days: 4 },
{ pincode: 782101, min_days: 3, max_days: 4 },
{ pincode: 782102, min_days: 3, max_days: 4 },
{ pincode: 782103, min_days: 3, max_days: 4 },
{ pincode: 782104, min_days: 3, max_days: 4 },
{ pincode: 782105, min_days: 3, max_days: 4 },
{ pincode: 782106, min_days: 3, max_days: 4 },
{ pincode: 782107, min_days: 3, max_days: 4 },
{ pincode: 782108, min_days: 3, max_days: 4 },
{ pincode: 782120, min_days: 3, max_days: 4 },
{ pincode: 782121, min_days: 3, max_days: 4 },
{ pincode: 782122, min_days: 3, max_days: 4 },
{ pincode: 782123, min_days: 3, max_days: 4 },
{ pincode: 782124, min_days: 3, max_days: 4 },
{ pincode: 782125, min_days: 3, max_days: 4 },
{ pincode: 782126, min_days: 3, max_days: 4 },
{ pincode: 782127, min_days: 3, max_days: 4 },
{ pincode: 782128, min_days: 3, max_days: 4 },
{ pincode: 782135, min_days: 3, max_days: 4 },
{ pincode: 782136, min_days: 3, max_days: 4 },
{ pincode: 782137, min_days: 3, max_days: 4 },
{ pincode: 782138, min_days: 3, max_days: 4 },
{ pincode: 782139, min_days: 3, max_days: 4 },
{ pincode: 782140, min_days: 3, max_days: 4 },
{ pincode: 782141, min_days: 3, max_days: 4 },
{ pincode: 782142, min_days: 3, max_days: 4 },
{ pincode: 782143, min_days: 3, max_days: 4 },
{ pincode: 782144, min_days: 3, max_days: 4 },
{ pincode: 782401, min_days: 2, max_days: 3 },
{ pincode: 782402, min_days: 2, max_days: 3 },
{ pincode: 782403, min_days: 3, max_days: 4 },
{ pincode: 782410, min_days: 3, max_days: 4 },
{ pincode: 782411, min_days: 3, max_days: 4 },
{ pincode: 782412, min_days: 3, max_days: 4 },
{ pincode: 782413, min_days: 3, max_days: 4 },
{ pincode: 782425, min_days: 3, max_days: 4 },
{ pincode: 782426, min_days: 3, max_days: 4 },
{ pincode: 782427, min_days: 3, max_days: 4 },
{ pincode: 782428, min_days: 3, max_days: 4 },
{ pincode: 782429, min_days: 3, max_days: 4 },
{ pincode: 782435, min_days: 3, max_days: 4 },
{ pincode: 782439, min_days: 3, max_days: 4 },
{ pincode: 782440, min_days: 3, max_days: 4 },
{ pincode: 782441, min_days: 3, max_days: 4 },
{ pincode: 782442, min_days: 3, max_days: 4 },
{ pincode: 782445, min_days: 3, max_days: 4 },
{ pincode: 782446, min_days: 3, max_days: 4 },
{ pincode: 782447, min_days: 3, max_days: 4 },
{ pincode: 782448, min_days: 3, max_days: 4 },
{ pincode: 782450, min_days: 3, max_days: 4 },
{ pincode: 782460, min_days: 3, max_days: 4 },
{ pincode: 782461, min_days: 3, max_days: 4 },
{ pincode: 782462, min_days: 3, max_days: 4 },
{ pincode: 782470, min_days: 3, max_days: 4 },
{ pincode: 782475, min_days: 3, max_days: 4 },
{ pincode: 782480, min_days: 3, max_days: 4 },
{ pincode: 782481, min_days: 3, max_days: 4 },
{ pincode: 782482, min_days: 3, max_days: 4 },
{ pincode: 782485, min_days: 3, max_days: 4 },
{ pincode: 782486, min_days: 3, max_days: 4 },
{ pincode: 782490, min_days: 3, max_days: 4 },
{ pincode: 783101, min_days: 2, max_days: 3 },
{ pincode: 783120, min_days: 2, max_days: 3 },
{ pincode: 783121, min_days: 3, max_days: 4 },
{ pincode: 783122, min_days: 2, max_days: 3 },
{ pincode: 783123, min_days: 2, max_days: 3 },
{ pincode: 783124, min_days: 2, max_days: 3 },
{ pincode: 783125, min_days: 2, max_days: 3 },
{ pincode: 783126, min_days: 2, max_days: 3 },
{ pincode: 783127, min_days: 2, max_days: 3 },
{ pincode: 783128, min_days: 2, max_days: 3 },
{ pincode: 783129, min_days: 2, max_days: 3 },
{ pincode: 783130, min_days: 2, max_days: 3 },
{ pincode: 783131, min_days: 2, max_days: 3 },
{ pincode: 783132, min_days: 2, max_days: 3 },
{ pincode: 783133, min_days: 2, max_days: 3 },
{ pincode: 783134, min_days: 2, max_days: 3 },
{ pincode: 783135, min_days: 2, max_days: 3 },
{ pincode: 783136, min_days: 2, max_days: 3 },
{ pincode: 783301, min_days: 2, max_days: 3 },
{ pincode: 783302, min_days: 3, max_days: 4 },
{ pincode: 783303, min_days: 3, max_days: 4 },
{ pincode: 783304, min_days: 3, max_days: 4 },
{ pincode: 783305, min_days: 3, max_days: 4 },
{ pincode: 783306, min_days: 3, max_days: 4 },
{ pincode: 783307, min_days: 3, max_days: 4 },
{ pincode: 783308, min_days: 3, max_days: 4 },
{ pincode: 783309, min_days: 3, max_days: 4 },
{ pincode: 783310, min_days: 3, max_days: 4 },
{ pincode: 783311, min_days: 3, max_days: 4 },
{ pincode: 783312, min_days: 3, max_days: 4 },
{ pincode: 783313, min_days: 3, max_days: 4 },
{ pincode: 783314, min_days: 3, max_days: 4 },
{ pincode: 783315, min_days: 3, max_days: 4 },
{ pincode: 783316, min_days: 3, max_days: 4 },
{ pincode: 783317, min_days: 3, max_days: 4 },
{ pincode: 783318, min_days: 3, max_days: 4 },
{ pincode: 783319, min_days: 3, max_days: 4 },
{ pincode: 783320, min_days: 3, max_days: 4 },
{ pincode: 783321, min_days: 3, max_days: 4 },
{ pincode: 783322, min_days: 3, max_days: 4 },
{ pincode: 783323, min_days: 2, max_days: 3 },
{ pincode: 783324, min_days: 2, max_days: 3 },
{ pincode: 783325, min_days: 2, max_days: 3 },
{ pincode: 783330, min_days: 2, max_days: 3 },
{ pincode: 783331, min_days: 2, max_days: 3 },
{ pincode: 783332, min_days: 2, max_days: 3 },
{ pincode: 783333, min_days: 2, max_days: 3 },
{ pincode: 783334, min_days: 2, max_days: 3 },
{ pincode: 783335, min_days: 2, max_days: 3 },
{ pincode: 783336, min_days: 2, max_days: 3 },
{ pincode: 783337, min_days: 2, max_days: 3 },
{ pincode: 783338, min_days: 3, max_days: 4 },
{ pincode: 783339, min_days: 2, max_days: 3 },
{ pincode: 783344, min_days: 3, max_days: 4 },
{ pincode: 783345, min_days: 2, max_days: 3 },
{ pincode: 783346, min_days: 2, max_days: 3 },
{ pincode: 783347, min_days: 2, max_days: 3 },
{ pincode: 783348, min_days: 2, max_days: 3 },
{ pincode: 783349, min_days: 2, max_days: 3 },
{ pincode: 783350, min_days: 2, max_days: 3 },
{ pincode: 783351, min_days: 3, max_days: 4 },
{ pincode: 783354, min_days: 2, max_days: 3 },
{ pincode: 783360, min_days: 2, max_days: 3 },
{ pincode: 783361, min_days: 2, max_days: 3 },
{ pincode: 783362, min_days: 3, max_days: 4 },
{ pincode: 783369, min_days: 2, max_days: 3 },
{ pincode: 783370, min_days: 2, max_days: 3 },
{ pincode: 783371, min_days: 2, max_days: 3 },
{ pincode: 783372, min_days: 2, max_days: 3 },
{ pincode: 783373, min_days: 2, max_days: 3 },
{ pincode: 783374, min_days: 3, max_days: 4 },
{ pincode: 783375, min_days: 2, max_days: 3 },
{ pincode: 783376, min_days: 2, max_days: 3 },
{ pincode: 783380, min_days: 2, max_days: 3 },
{ pincode: 783381, min_days: 2, max_days: 3 },
{ pincode: 783382, min_days: 2, max_days: 3 },
{ pincode: 783383, min_days: 2, max_days: 3 },
{ pincode: 783384, min_days: 2, max_days: 3 },
{ pincode: 783385, min_days: 2, max_days: 3 },
{ pincode: 783386, min_days: 2, max_days: 3 },
{ pincode: 783387, min_days: 3, max_days: 4 },
{ pincode: 783388, min_days: 2, max_days: 3 },
{ pincode: 783389, min_days: 3, max_days: 4 },
{ pincode: 783390, min_days: 2, max_days: 3 },
{ pincode: 783391, min_days: 2, max_days: 3 },
{ pincode: 783392, min_days: 2, max_days: 3 },
{ pincode: 783393, min_days: 2, max_days: 3 },
{ pincode: 783394, min_days: 2, max_days: 3 },
{ pincode: 784001, min_days: 3, max_days: 4 },
{ pincode: 784002, min_days: 3, max_days: 4 },
{ pincode: 784003, min_days: 3, max_days: 4 },
{ pincode: 784004, min_days: 3, max_days: 4 },
{ pincode: 784010, min_days: 3, max_days: 4 },
{ pincode: 784025, min_days: 3, max_days: 4 },
{ pincode: 784026, min_days: 3, max_days: 4 },
{ pincode: 784027, min_days: 3, max_days: 4 },
{ pincode: 784028, min_days: 3, max_days: 4 },
{ pincode: 784101, min_days: 3, max_days: 4 },
{ pincode: 784102, min_days: 3, max_days: 4 },
{ pincode: 784103, min_days: 3, max_days: 4 },
{ pincode: 784104, min_days: 3, max_days: 4 },
{ pincode: 784105, min_days: 3, max_days: 4 },
{ pincode: 784110, min_days: 3, max_days: 4 },
{ pincode: 784111, min_days: 3, max_days: 4 },
{ pincode: 784112, min_days: 3, max_days: 4 },
{ pincode: 784113, min_days: 3, max_days: 4 },
{ pincode: 784114, min_days: 3, max_days: 4 },
{ pincode: 784115, min_days: 3, max_days: 4 },
{ pincode: 784116, min_days: 3, max_days: 4 },
{ pincode: 784117, min_days: 3, max_days: 4 },
{ pincode: 784118, min_days: 3, max_days: 4 },
{ pincode: 784120, min_days: 3, max_days: 4 },
{ pincode: 784125, min_days: 3, max_days: 4 },
{ pincode: 784144, min_days: 3, max_days: 4 },
{ pincode: 784145, min_days: 3, max_days: 4 },
{ pincode: 784146, min_days: 3, max_days: 4 },
{ pincode: 784147, min_days: 3, max_days: 4 },
{ pincode: 784148, min_days: 3, max_days: 4 },
{ pincode: 784149, min_days: 3, max_days: 4 },
{ pincode: 784150, min_days: 3, max_days: 4 },
{ pincode: 784151, min_days: 3, max_days: 4 },
{ pincode: 784153, min_days: 3, max_days: 4 },
{ pincode: 784154, min_days: 3, max_days: 4 },
{ pincode: 784160, min_days: 3, max_days: 4 },
{ pincode: 784161, min_days: 3, max_days: 4 },
{ pincode: 784162, min_days: 3, max_days: 4 },
{ pincode: 784163, min_days: 3, max_days: 4 },
{ pincode: 784164, min_days: 3, max_days: 4 },
{ pincode: 784165, min_days: 3, max_days: 4 },
{ pincode: 784166, min_days: 3, max_days: 4 },
{ pincode: 784167, min_days: 3, max_days: 4 },
{ pincode: 784168, min_days: 3, max_days: 4 },
{ pincode: 784169, min_days: 3, max_days: 4 },
{ pincode: 784170, min_days: 3, max_days: 4 },
{ pincode: 784171, min_days: 3, max_days: 4 },
{ pincode: 784172, min_days: 3, max_days: 4 },
{ pincode: 784173, min_days: 3, max_days: 4 },
{ pincode: 784174, min_days: 3, max_days: 4 },
{ pincode: 784175, min_days: 3, max_days: 4 },
{ pincode: 784176, min_days: 3, max_days: 4 },
{ pincode: 784177, min_days: 3, max_days: 4 },
{ pincode: 784178, min_days: 3, max_days: 4 },
{ pincode: 784179, min_days: 3, max_days: 4 },
{ pincode: 784180, min_days: 3, max_days: 4 },
{ pincode: 784182, min_days: 3, max_days: 4 },
{ pincode: 784184, min_days: 3, max_days: 4 },
{ pincode: 784189, min_days: 3, max_days: 4 },
{ pincode: 784190, min_days: 3, max_days: 4 },
{ pincode: 784501, min_days: 3, max_days: 4 },
{ pincode: 784502, min_days: 3, max_days: 4 },
{ pincode: 784503, min_days: 3, max_days: 4 },
{ pincode: 784504, min_days: 3, max_days: 4 },
{ pincode: 784505, min_days: 3, max_days: 4 },
{ pincode: 784506, min_days: 3, max_days: 4 },
{ pincode: 784507, min_days: 3, max_days: 4 },
{ pincode: 784508, min_days: 3, max_days: 4 },
{ pincode: 784509, min_days: 3, max_days: 4 },
{ pincode: 784510, min_days: 3, max_days: 4 },
{ pincode: 784513, min_days: 3, max_days: 4 },
{ pincode: 784514, min_days: 3, max_days: 4 },
{ pincode: 784521, min_days: 3, max_days: 4 },
{ pincode: 784522, min_days: 3, max_days: 4 },
{ pincode: 784523, min_days: 3, max_days: 4 },
{ pincode: 784524, min_days: 3, max_days: 4 },
{ pincode: 784525, min_days: 3, max_days: 4 },
{ pincode: 784526, min_days: 3, max_days: 4 },
{ pincode: 784527, min_days: 3, max_days: 4 },
{ pincode: 784528, min_days: 3, max_days: 4 },
{ pincode: 784529, min_days: 3, max_days: 4 },
{ pincode: 785001, min_days: 3, max_days: 4 },
{ pincode: 785002, min_days: 3, max_days: 4 },
{ pincode: 785003, min_days: 3, max_days: 4 },
{ pincode: 785004, min_days: 3, max_days: 4 },
{ pincode: 785005, min_days: 3, max_days: 4 },
{ pincode: 785006, min_days: 3, max_days: 4 },
{ pincode: 785007, min_days: 3, max_days: 4 },
{ pincode: 785008, min_days: 3, max_days: 4 },
{ pincode: 785009, min_days: 3, max_days: 4 },
{ pincode: 785010, min_days: 3, max_days: 4 },
{ pincode: 785011, min_days: 3, max_days: 4 },
{ pincode: 785012, min_days: 3, max_days: 4 },
{ pincode: 785013, min_days: 3, max_days: 4 },
{ pincode: 785014, min_days: 3, max_days: 4 },
{ pincode: 785015, min_days: 3, max_days: 4 },
{ pincode: 785016, min_days: 3, max_days: 4 },
{ pincode: 785018, min_days: 3, max_days: 4 },
{ pincode: 785020, min_days: 3, max_days: 4 },
{ pincode: 785057, min_days: 3, max_days: 4 },
{ pincode: 785101, min_days: 3, max_days: 4 },
{ pincode: 785102, min_days: 3, max_days: 4 },
{ pincode: 785104, min_days: 3, max_days: 4 },
{ pincode: 785105, min_days: 3, max_days: 4 },
{ pincode: 785106, min_days: 3, max_days: 4 },
{ pincode: 785107, min_days: 3, max_days: 4 },
{ pincode: 785108, min_days: 3, max_days: 4 },
{ pincode: 785109, min_days: 3, max_days: 4 },
{ pincode: 785110, min_days: 3, max_days: 4 },
{ pincode: 785111, min_days: 3, max_days: 4 },
{ pincode: 785112, min_days: 3, max_days: 4 },
{ pincode: 785113, min_days: 3, max_days: 4 },
{ pincode: 785203, min_days: 3, max_days: 4 },
{ pincode: 785232, min_days: 3, max_days: 4 },
{ pincode: 785601, min_days: 3, max_days: 4 },
{ pincode: 785602, min_days: 3, max_days: 4 },
{ pincode: 785603, min_days: 3, max_days: 4 },
{ pincode: 785604, min_days: 3, max_days: 4 },
{ pincode: 785609, min_days: 3, max_days: 4 },
{ pincode: 785610, min_days: 3, max_days: 4 },
{ pincode: 785611, min_days: 3, max_days: 4 },
{ pincode: 785612, min_days: 3, max_days: 4 },
{ pincode: 785613, min_days: 3, max_days: 4 },
{ pincode: 785614, min_days: 3, max_days: 4 },
{ pincode: 785615, min_days: 3, max_days: 4 },
{ pincode: 785616, min_days: 3, max_days: 4 },
{ pincode: 785618, min_days: 3, max_days: 4 },
{ pincode: 785619, min_days: 3, max_days: 4 },
{ pincode: 785620, min_days: 3, max_days: 4 },
{ pincode: 785621, min_days: 3, max_days: 4 },
{ pincode: 785622, min_days: 3, max_days: 4 },
{ pincode: 785623, min_days: 3, max_days: 4 },
{ pincode: 785624, min_days: 3, max_days: 4 },
{ pincode: 785625, min_days: 3, max_days: 4 },
{ pincode: 785626, min_days: 3, max_days: 4 },
{ pincode: 785627, min_days: 3, max_days: 4 },
{ pincode: 785628, min_days: 3, max_days: 4 },
{ pincode: 785630, min_days: 3, max_days: 4 },
{ pincode: 785631, min_days: 3, max_days: 4 },
{ pincode: 785632, min_days: 3, max_days: 4 },
{ pincode: 785633, min_days: 3, max_days: 4 },
{ pincode: 785634, min_days: 3, max_days: 4 },
{ pincode: 785635, min_days: 3, max_days: 4 },
{ pincode: 785636, min_days: 3, max_days: 4 },
{ pincode: 785638, min_days: 3, max_days: 4 },
{ pincode: 785640, min_days: 3, max_days: 4 },
{ pincode: 785641, min_days: 3, max_days: 4 },
{ pincode: 785643, min_days: 3, max_days: 4 },
{ pincode: 785644, min_days: 3, max_days: 4 },
{ pincode: 785648, min_days: 3, max_days: 4 },
{ pincode: 785649, min_days: 3, max_days: 4 },
{ pincode: 785660, min_days: 3, max_days: 4 },
{ pincode: 785661, min_days: 3, max_days: 4 },
{ pincode: 785662, min_days: 3, max_days: 4 },
{ pincode: 785663, min_days: 3, max_days: 4 },
{ pincode: 785664, min_days: 3, max_days: 4 },
{ pincode: 785665, min_days: 3, max_days: 4 },
{ pincode: 785666, min_days: 3, max_days: 4 },
{ pincode: 785667, min_days: 3, max_days: 4 },
{ pincode: 785668, min_days: 3, max_days: 4 },
{ pincode: 785669, min_days: 3, max_days: 4 },
{ pincode: 785670, min_days: 3, max_days: 4 },
{ pincode: 785671, min_days: 3, max_days: 4 },
{ pincode: 785672, min_days: 3, max_days: 4 },
{ pincode: 785673, min_days: 3, max_days: 4 },
{ pincode: 785674, min_days: 3, max_days: 4 },
{ pincode: 785675, min_days: 3, max_days: 4 },
{ pincode: 785676, min_days: 3, max_days: 4 },
{ pincode: 785677, min_days: 3, max_days: 4 },
{ pincode: 785678, min_days: 3, max_days: 4 },
{ pincode: 785679, min_days: 3, max_days: 4 },
{ pincode: 785680, min_days: 3, max_days: 4 },
{ pincode: 785681, min_days: 3, max_days: 4 },
{ pincode: 785682, min_days: 3, max_days: 4 },
{ pincode: 785683, min_days: 3, max_days: 4 },
{ pincode: 785684, min_days: 3, max_days: 4 },
{ pincode: 785685, min_days: 3, max_days: 4 },
{ pincode: 785686, min_days: 3, max_days: 4 },
{ pincode: 785687, min_days: 3, max_days: 4 },
{ pincode: 785688, min_days: 3, max_days: 4 },
{ pincode: 785689, min_days: 3, max_days: 4 },
{ pincode: 785690, min_days: 3, max_days: 4 },
{ pincode: 785691, min_days: 2, max_days: 3 },
{ pincode: 785692, min_days: 3, max_days: 4 },
{ pincode: 785693, min_days: 3, max_days: 4 },
{ pincode: 785694, min_days: 3, max_days: 4 },
{ pincode: 785695, min_days: 3, max_days: 4 },
{ pincode: 785696, min_days: 3, max_days: 4 },
{ pincode: 785697, min_days: 3, max_days: 4 },
{ pincode: 785698, min_days: 3, max_days: 4 },
{ pincode: 785699, min_days: 3, max_days: 4 },
{ pincode: 785700, min_days: 3, max_days: 4 },
{ pincode: 785701, min_days: 3, max_days: 4 },
{ pincode: 785702, min_days: 3, max_days: 4 },
{ pincode: 785703, min_days: 3, max_days: 4 },
{ pincode: 785704, min_days: 3, max_days: 4 },
{ pincode: 785705, min_days: 3, max_days: 4 },
{ pincode: 786001, min_days: 3, max_days: 4 },
{ pincode: 786002, min_days: 3, max_days: 4 },
{ pincode: 786003, min_days: 3, max_days: 4 },
{ pincode: 786004, min_days: 3, max_days: 4 },
{ pincode: 786005, min_days: 3, max_days: 4 },
{ pincode: 786006, min_days: 3, max_days: 4 },
{ pincode: 786007, min_days: 3, max_days: 4 },
{ pincode: 786008, min_days: 3, max_days: 4 },
{ pincode: 786009, min_days: 3, max_days: 4 },
{ pincode: 786010, min_days: 3, max_days: 4 },
{ pincode: 786012, min_days: 3, max_days: 4 },
{ pincode: 786052, min_days: 3, max_days: 4 },
{ pincode: 786053, min_days: 3, max_days: 4 },
{ pincode: 786054, min_days: 3, max_days: 4 },
{ pincode: 786101, min_days: 3, max_days: 4 },
{ pincode: 786102, min_days: 3, max_days: 4 },
{ pincode: 786103, min_days: 2, max_days: 3 },
{ pincode: 786110, min_days: 3, max_days: 4 },
{ pincode: 786121, min_days: 3, max_days: 4 },
{ pincode: 786124, min_days: 3, max_days: 4 },
{ pincode: 786125, min_days: 3, max_days: 4 },
{ pincode: 786126, min_days: 3, max_days: 4 },
{ pincode: 786145, min_days: 3, max_days: 4 },
{ pincode: 786146, min_days: 3, max_days: 4 },
{ pincode: 786147, min_days: 3, max_days: 4 },
{ pincode: 786148, min_days: 3, max_days: 4 },
{ pincode: 786150, min_days: 3, max_days: 4 },
{ pincode: 786151, min_days: 3, max_days: 4 },
{ pincode: 786152, min_days: 3, max_days: 4 },
{ pincode: 786153, min_days: 3, max_days: 4 },
{ pincode: 786154, min_days: 3, max_days: 4 },
{ pincode: 786155, min_days: 3, max_days: 4 },
{ pincode: 786156, min_days: 3, max_days: 4 },
{ pincode: 786157, min_days: 3, max_days: 4 },
{ pincode: 786158, min_days: 3, max_days: 4 },
{ pincode: 786159, min_days: 3, max_days: 4 },
{ pincode: 786160, min_days: 3, max_days: 4 },
{ pincode: 786170, min_days: 3, max_days: 4 },
{ pincode: 786171, min_days: 3, max_days: 4 },
{ pincode: 786172, min_days: 3, max_days: 4 },
{ pincode: 786173, min_days: 3, max_days: 4 },
{ pincode: 786174, min_days: 3, max_days: 4 },
{ pincode: 786179, min_days: 3, max_days: 4 },
{ pincode: 786180, min_days: 3, max_days: 4 },
{ pincode: 786181, min_days: 3, max_days: 4 },
{ pincode: 786182, min_days: 3, max_days: 4 },
{ pincode: 786183, min_days: 3, max_days: 4 },
{ pincode: 786184, min_days: 3, max_days: 4 },
{ pincode: 786185, min_days: 3, max_days: 4 },
{ pincode: 786187, min_days: 3, max_days: 4 },
{ pincode: 786188, min_days: 3, max_days: 4 },
{ pincode: 786189, min_days: 3, max_days: 4 },
{ pincode: 786190, min_days: 3, max_days: 4 },
{ pincode: 786191, min_days: 3, max_days: 4 },
{ pincode: 786192, min_days: 3, max_days: 4 },
{ pincode: 786601, min_days: 3, max_days: 4 },
{ pincode: 786602, min_days: 3, max_days: 4 },
{ pincode: 786610, min_days: 3, max_days: 4 },
{ pincode: 786611, min_days: 3, max_days: 4 },
{ pincode: 786612, min_days: 3, max_days: 4 },
{ pincode: 786613, min_days: 3, max_days: 4 },
{ pincode: 786614, min_days: 3, max_days: 4 },
{ pincode: 786615, min_days: 3, max_days: 4 },
{ pincode: 786621, min_days: 3, max_days: 4 },
{ pincode: 786622, min_days: 3, max_days: 4 },
{ pincode: 786623, min_days: 3, max_days: 4 },
{ pincode: 786624, min_days: 3, max_days: 4 },
{ pincode: 786629, min_days: 3, max_days: 4 },
{ pincode: 786630, min_days: 3, max_days: 4 },
{ pincode: 786631, min_days: 3, max_days: 4 },
{ pincode: 786678, min_days: 3, max_days: 4 },
{ pincode: 786684, min_days: 3, max_days: 4 },
{ pincode: 786692, min_days: 3, max_days: 4 },
{ pincode: 787001, min_days: 3, max_days: 4 },
{ pincode: 787023, min_days: 3, max_days: 4 },
{ pincode: 787026, min_days: 3, max_days: 4 },
{ pincode: 787027, min_days: 3, max_days: 4 },
{ pincode: 787029, min_days: 3, max_days: 4 },
{ pincode: 787031, min_days: 3, max_days: 4 },
{ pincode: 787032, min_days: 3, max_days: 4 },
{ pincode: 787033, min_days: 3, max_days: 4 },
{ pincode: 787034, min_days: 3, max_days: 4 },
{ pincode: 787035, min_days: 3, max_days: 4 },
{ pincode: 787051, min_days: 3, max_days: 4 },
{ pincode: 787052, min_days: 3, max_days: 4 },
{ pincode: 787053, min_days: 3, max_days: 4 },
{ pincode: 787054, min_days: 2, max_days: 3 },
{ pincode: 787055, min_days: 3, max_days: 4 },
{ pincode: 787056, min_days: 3, max_days: 4 },
{ pincode: 787057, min_days: 3, max_days: 4 },
{ pincode: 787058, min_days: 3, max_days: 4 },
{ pincode: 787059, min_days: 3, max_days: 4 },
{ pincode: 787060, min_days: 3, max_days: 4 },
{ pincode: 787061, min_days: 3, max_days: 4 },
{ pincode: 787110, min_days: 3, max_days: 4 },
{ pincode: 787160, min_days: 3, max_days: 4 },
{ pincode: 788001, min_days: 3, max_days: 4 },
{ pincode: 788002, min_days: 3, max_days: 4 },
{ pincode: 788003, min_days: 3, max_days: 4 },
{ pincode: 788004, min_days: 3, max_days: 4 },
{ pincode: 788005, min_days: 3, max_days: 4 },
{ pincode: 788006, min_days: 3, max_days: 4 },
{ pincode: 788007, min_days: 3, max_days: 4 },
{ pincode: 788008, min_days: 3, max_days: 4 },
{ pincode: 788009, min_days: 3, max_days: 4 },
{ pincode: 788010, min_days: 3, max_days: 4 },
{ pincode: 788011, min_days: 3, max_days: 4 },
{ pincode: 788012, min_days: 3, max_days: 4 },
{ pincode: 788013, min_days: 3, max_days: 4 },
{ pincode: 788014, min_days: 3, max_days: 4 },
{ pincode: 788015, min_days: 3, max_days: 4 },
{ pincode: 788025, min_days: 3, max_days: 4 },
{ pincode: 788026, min_days: 3, max_days: 4 },
{ pincode: 788030, min_days: 3, max_days: 4 },
{ pincode: 788031, min_days: 3, max_days: 4 },
{ pincode: 788098, min_days: 3, max_days: 4 },
{ pincode: 788099, min_days: 3, max_days: 4 },
{ pincode: 788101, min_days: 3, max_days: 4 },
{ pincode: 788102, min_days: 3, max_days: 4 },
{ pincode: 788103, min_days: 3, max_days: 4 },
{ pincode: 788104, min_days: 3, max_days: 4 },
{ pincode: 788106, min_days: 3, max_days: 4 },
{ pincode: 788107, min_days: 3, max_days: 4 },
{ pincode: 788108, min_days: 3, max_days: 4 },
{ pincode: 788109, min_days: 3, max_days: 4 },
{ pincode: 788110, min_days: 3, max_days: 4 },
{ pincode: 788111, min_days: 3, max_days: 4 },
{ pincode: 788112, min_days: 3, max_days: 4 },
{ pincode: 788113, min_days: 3, max_days: 4 },
{ pincode: 788114, min_days: 3, max_days: 4 },
{ pincode: 788115, min_days: 3, max_days: 4 },
{ pincode: 788116, min_days: 3, max_days: 4 },
{ pincode: 788117, min_days: 3, max_days: 4 },
{ pincode: 788118, min_days: 3, max_days: 4 },
{ pincode: 788119, min_days: 3, max_days: 4 },
{ pincode: 788120, min_days: 3, max_days: 4 },
{ pincode: 788121, min_days: 3, max_days: 4 },
{ pincode: 788123, min_days: 3, max_days: 4 },
{ pincode: 788126, min_days: 3, max_days: 4 },
{ pincode: 788127, min_days: 3, max_days: 4 },
{ pincode: 788150, min_days: 3, max_days: 4 },
{ pincode: 788151, min_days: 3, max_days: 4 },
{ pincode: 788152, min_days: 3, max_days: 4 },
{ pincode: 788155, min_days: 3, max_days: 4 },
{ pincode: 788156, min_days: 3, max_days: 4 },
{ pincode: 788160, min_days: 3, max_days: 4 },
{ pincode: 788161, min_days: 3, max_days: 4 },
{ pincode: 788162, min_days: 3, max_days: 4 },
{ pincode: 788163, min_days: 3, max_days: 4 },
{ pincode: 788164, min_days: 3, max_days: 4 },
{ pincode: 788165, min_days: 3, max_days: 4 },
{ pincode: 788166, min_days: 3, max_days: 4 },
{ pincode: 788167, min_days: 3, max_days: 4 },
{ pincode: 788168, min_days: 3, max_days: 4 },
{ pincode: 788169, min_days: 3, max_days: 4 },
{ pincode: 788701, min_days: 3, max_days: 4 },
{ pincode: 788702, min_days: 3, max_days: 4 },
{ pincode: 788706, min_days: 3, max_days: 4 },
{ pincode: 788709, min_days: 3, max_days: 4 },
{ pincode: 788710, min_days: 3, max_days: 4 },
{ pincode: 788711, min_days: 3, max_days: 4 },
{ pincode: 788712, min_days: 3, max_days: 4 },
{ pincode: 788713, min_days: 3, max_days: 4 },
{ pincode: 788719, min_days: 3, max_days: 4 },
{ pincode: 788720, min_days: 3, max_days: 4 },
{ pincode: 788722, min_days: 3, max_days: 4 },
{ pincode: 788723, min_days: 3, max_days: 4 },
{ pincode: 788724, min_days: 3, max_days: 4 },
{ pincode: 788725, min_days: 3, max_days: 4 },
{ pincode: 788726, min_days: 3, max_days: 4 },
{ pincode: 788727, min_days: 3, max_days: 4 },
{ pincode: 788728, min_days: 3, max_days: 4 },
{ pincode: 788733, min_days: 3, max_days: 4 },
{ pincode: 788734, min_days: 3, max_days: 4 },
{ pincode: 788735, min_days: 3, max_days: 4 },
{ pincode: 788736, min_days: 3, max_days: 4 },
{ pincode: 788737, min_days: 3, max_days: 4 },
{ pincode: 788781, min_days: 3, max_days: 4 },
{ pincode: 788790, min_days: 3, max_days: 4 },
{ pincode: 788801, min_days: 2, max_days: 3 },
{ pincode: 788802, min_days: 3, max_days: 4 },
{ pincode: 788803, min_days: 3, max_days: 4 },
{ pincode: 788804, min_days: 3, max_days: 4 },
{ pincode: 788805, min_days: 3, max_days: 4 },
{ pincode: 788806, min_days: 3, max_days: 4 },
{ pincode: 788815, min_days: 3, max_days: 4 },
{ pincode: 788816, min_days: 3, max_days: 4 },
{ pincode: 788817, min_days: 3, max_days: 4 },
{ pincode: 788818, min_days: 3, max_days: 4 },
{ pincode: 788819, min_days: 3, max_days: 4 },
{ pincode: 788820, min_days: 3, max_days: 4 },
{ pincode: 788830, min_days: 3, max_days: 4 },
{ pincode: 788831, min_days: 3, max_days: 4 },
{ pincode: 788832, min_days: 3, max_days: 4 },
{ pincode: 788834, min_days: 3, max_days: 4 },
{ pincode: 788931, min_days: 3, max_days: 4 },
{ pincode: 790001, min_days: 3, max_days: 4 },
{ pincode: 790002, min_days: 3, max_days: 4 },
{ pincode: 790003, min_days: 3, max_days: 4 },
{ pincode: 790101, min_days: 3, max_days: 4 },
{ pincode: 790102, min_days: 3, max_days: 4 },
{ pincode: 790103, min_days: 3, max_days: 4 },
{ pincode: 790104, min_days: 3, max_days: 4 },
{ pincode: 790105, min_days: 3, max_days: 4 },
{ pincode: 790106, min_days: 3, max_days: 4 },
{ pincode: 790114, min_days: 3, max_days: 4 },
{ pincode: 790116, min_days: 3, max_days: 4 },
{ pincode: 791001, min_days: 3, max_days: 4 },
{ pincode: 791002, min_days: 3, max_days: 4 },
{ pincode: 791003, min_days: 3, max_days: 4 },
{ pincode: 791101, min_days: 3, max_days: 4 },
{ pincode: 791102, min_days: 3, max_days: 4 },
{ pincode: 791103, min_days: 3, max_days: 4 },
{ pincode: 791104, min_days: 3, max_days: 4 },
{ pincode: 791105, min_days: 3, max_days: 4 },
{ pincode: 791109, min_days: 3, max_days: 4 },
{ pincode: 791110, min_days: 3, max_days: 4 },
{ pincode: 791111, min_days: 3, max_days: 4 },
{ pincode: 791112, min_days: 3, max_days: 4 },
{ pincode: 791113, min_days: 3, max_days: 4 },
{ pincode: 791114, min_days: 3, max_days: 4 },
{ pincode: 791118, min_days: 3, max_days: 4 },
{ pincode: 791119, min_days: 3, max_days: 4 },
{ pincode: 791120, min_days: 3, max_days: 4 },
{ pincode: 791121, min_days: 3, max_days: 4 },
{ pincode: 791122, min_days: 3, max_days: 4 },
{ pincode: 791123, min_days: 3, max_days: 4 },
{ pincode: 791125, min_days: 3, max_days: 4 },
{ pincode: 792001, min_days: 3, max_days: 4 },
{ pincode: 792056, min_days: 3, max_days: 4 },
{ pincode: 792101, min_days: 3, max_days: 4 },
{ pincode: 792102, min_days: 3, max_days: 4 },
{ pincode: 792103, min_days: 3, max_days: 4 },
{ pincode: 792104, min_days: 3, max_days: 4 },
{ pincode: 792105, min_days: 3, max_days: 4 },
{ pincode: 792110, min_days: 3, max_days: 4 },
{ pincode: 792111, min_days: 3, max_days: 4 },
{ pincode: 792120, min_days: 3, max_days: 4 },
{ pincode: 792121, min_days: 3, max_days: 4 },
{ pincode: 792122, min_days: 3, max_days: 4 },
{ pincode: 792123, min_days: 3, max_days: 4 },
{ pincode: 792129, min_days: 3, max_days: 4 },
{ pincode: 792130, min_days: 3, max_days: 4 },
{ pincode: 792131, min_days: 3, max_days: 4 },
{ pincode: 793001, min_days: 3, max_days: 4 },
{ pincode: 793002, min_days: 3, max_days: 4 },
{ pincode: 793003, min_days: 3, max_days: 4 },
{ pincode: 793004, min_days: 3, max_days: 4 },
{ pincode: 793005, min_days: 3, max_days: 4 },
{ pincode: 793006, min_days: 3, max_days: 4 },
{ pincode: 793007, min_days: 3, max_days: 4 },
{ pincode: 793008, min_days: 3, max_days: 4 },
{ pincode: 793009, min_days: 3, max_days: 4 },
{ pincode: 793010, min_days: 3, max_days: 4 },
{ pincode: 793011, min_days: 3, max_days: 4 },
{ pincode: 793012, min_days: 3, max_days: 4 },
{ pincode: 793014, min_days: 3, max_days: 4 },
{ pincode: 793015, min_days: 3, max_days: 4 },
{ pincode: 793016, min_days: 3, max_days: 4 },
{ pincode: 793017, min_days: 3, max_days: 4 },
{ pincode: 793018, min_days: 3, max_days: 4 },
{ pincode: 793019, min_days: 3, max_days: 4 },
{ pincode: 793021, min_days: 3, max_days: 4 },
{ pincode: 793022, min_days: 3, max_days: 4 },
{ pincode: 793101, min_days: 3, max_days: 4 },
{ pincode: 793102, min_days: 3, max_days: 4 },
{ pincode: 793103, min_days: 3, max_days: 4 },
{ pincode: 793104, min_days: 3, max_days: 4 },
{ pincode: 793105, min_days: 3, max_days: 4 },
{ pincode: 793106, min_days: 3, max_days: 4 },
{ pincode: 793107, min_days: 3, max_days: 4 },
{ pincode: 793108, min_days: 2, max_days: 3 },
{ pincode: 793109, min_days: 3, max_days: 4 },
{ pincode: 793110, min_days: 3, max_days: 4 },
{ pincode: 793111, min_days: 3, max_days: 4 },
{ pincode: 793112, min_days: 3, max_days: 4 },
{ pincode: 793113, min_days: 3, max_days: 4 },
{ pincode: 793114, min_days: 2, max_days: 3 },
{ pincode: 793115, min_days: 2, max_days: 3 },
{ pincode: 793116, min_days: 3, max_days: 4 },
{ pincode: 793119, min_days: 2, max_days: 3 },
{ pincode: 793120, min_days: 2, max_days: 3 },
{ pincode: 793121, min_days: 3, max_days: 4 },
{ pincode: 793122, min_days: 3, max_days: 4 },
{ pincode: 793123, min_days: 3, max_days: 4 },
{ pincode: 793126, min_days: 2, max_days: 3 },
{ pincode: 793150, min_days: 3, max_days: 4 },
{ pincode: 793151, min_days: 3, max_days: 4 },
{ pincode: 793160, min_days: 3, max_days: 4 },
{ pincode: 793161, min_days: 3, max_days: 4 },
{ pincode: 793200, min_days: 3, max_days: 4 },
{ pincode: 793210, min_days: 2, max_days: 3 },
{ pincode: 794001, min_days: 2, max_days: 3 },
{ pincode: 794002, min_days: 2, max_days: 3 },
{ pincode: 794003, min_days: 2, max_days: 3 },
{ pincode: 794004, min_days: 2, max_days: 3 },
{ pincode: 794005, min_days: 2, max_days: 3 },
{ pincode: 794101, min_days: 2, max_days: 3 },
{ pincode: 794102, min_days: 2, max_days: 3 },
{ pincode: 794103, min_days: 2, max_days: 3 },
{ pincode: 794104, min_days: 2, max_days: 3 },
{ pincode: 794105, min_days: 2, max_days: 3 },
{ pincode: 794106, min_days: 2, max_days: 3 },
{ pincode: 794107, min_days: 2, max_days: 3 },
{ pincode: 794108, min_days: 2, max_days: 3 },
{ pincode: 794109, min_days: 2, max_days: 3 },
{ pincode: 794110, min_days: 2, max_days: 3 },
{ pincode: 794111, min_days: 2, max_days: 3 },
{ pincode: 794112, min_days: 2, max_days: 3 },
{ pincode: 794113, min_days: 2, max_days: 3 },
{ pincode: 794114, min_days: 2, max_days: 3 },
{ pincode: 794115, min_days: 2, max_days: 3 },
{ pincode: 795001, min_days: 3, max_days: 4 },
{ pincode: 795002, min_days: 3, max_days: 4 },
{ pincode: 795003, min_days: 3, max_days: 4 },
{ pincode: 795004, min_days: 3, max_days: 4 },
{ pincode: 795005, min_days: 3, max_days: 4 },
{ pincode: 795008, min_days: 3, max_days: 4 },
{ pincode: 795009, min_days: 3, max_days: 4 },
{ pincode: 795010, min_days: 3, max_days: 4 },
{ pincode: 795011, min_days: 3, max_days: 4 },
{ pincode: 795103, min_days: 3, max_days: 4 },
{ pincode: 795113, min_days: 3, max_days: 4 },
{ pincode: 795114, min_days: 3, max_days: 4 },
{ pincode: 795124, min_days: 3, max_days: 4 },
{ pincode: 795126, min_days: 3, max_days: 4 },
{ pincode: 795130, min_days: 3, max_days: 4 },
{ pincode: 795132, min_days: 3, max_days: 4 },
{ pincode: 795133, min_days: 3, max_days: 4 },
{ pincode: 795134, min_days: 3, max_days: 4 },
{ pincode: 795138, min_days: 3, max_days: 4 },
{ pincode: 795140, min_days: 3, max_days: 4 },
{ pincode: 795146, min_days: 3, max_days: 4 },
{ pincode: 795148, min_days: 3, max_days: 4 },
{ pincode: 795149, min_days: 3, max_days: 4 },
{ pincode: 796001, min_days: 3, max_days: 4 },
{ pincode: 796004, min_days: 3, max_days: 4 },
{ pincode: 796005, min_days: 3, max_days: 4 },
{ pincode: 796007, min_days: 3, max_days: 4 },
{ pincode: 796008, min_days: 3, max_days: 4 },
{ pincode: 796009, min_days: 3, max_days: 4 },
{ pincode: 796012, min_days: 3, max_days: 4 },
{ pincode: 796014, min_days: 3, max_days: 4 },
{ pincode: 796015, min_days: 3, max_days: 4 },
{ pincode: 796017, min_days: 3, max_days: 4 },
{ pincode: 796025, min_days: 3, max_days: 4 },
{ pincode: 796036, min_days: 3, max_days: 4 },
{ pincode: 796070, min_days: 3, max_days: 4 },
{ pincode: 796081, min_days: 3, max_days: 4 },
{ pincode: 796082, min_days: 3, max_days: 4 },
{ pincode: 796091, min_days: 3, max_days: 4 },
{ pincode: 796101, min_days: 3, max_days: 4 },
{ pincode: 796111, min_days: 3, max_days: 4 },
{ pincode: 796161, min_days: 3, max_days: 4 },
{ pincode: 796181, min_days: 3, max_days: 4 },
{ pincode: 796184, min_days: 3, max_days: 4 },
{ pincode: 796186, min_days: 3, max_days: 4 },
{ pincode: 796190, min_days: 3, max_days: 4 },
{ pincode: 796261, min_days: 3, max_days: 4 },
{ pincode: 796290, min_days: 3, max_days: 4 },
{ pincode: 796291, min_days: 3, max_days: 4 },
{ pincode: 796310, min_days: 3, max_days: 4 },
{ pincode: 796320, min_days: 3, max_days: 4 },
{ pincode: 796321, min_days: 3, max_days: 4 },
{ pincode: 796370, min_days: 3, max_days: 4 },
{ pincode: 796410, min_days: 3, max_days: 4 },
{ pincode: 796421, min_days: 3, max_days: 4 },
{ pincode: 796431, min_days: 3, max_days: 4 },
{ pincode: 796441, min_days: 3, max_days: 4 },
{ pincode: 796470, min_days: 3, max_days: 4 },
{ pincode: 796471, min_days: 3, max_days: 4 },
{ pincode: 796501, min_days: 3, max_days: 4 },
{ pincode: 796571, min_days: 3, max_days: 4 },
{ pincode: 796691, min_days: 3, max_days: 4 },
{ pincode: 796701, min_days: 3, max_days: 4 },
{ pincode: 796730, min_days: 3, max_days: 4 },
{ pincode: 796751, min_days: 3, max_days: 4 },
{ pincode: 796770, min_days: 3, max_days: 4 },
{ pincode: 796772, min_days: 3, max_days: 4 },
{ pincode: 796810, min_days: 3, max_days: 4 },
{ pincode: 796891, min_days: 3, max_days: 4 },
{ pincode: 796901, min_days: 3, max_days: 4 },
{ pincode: 797001, min_days: 3, max_days: 4 },
{ pincode: 797002, min_days: 3, max_days: 4 },
{ pincode: 797003, min_days: 3, max_days: 4 },
{ pincode: 797004, min_days: 3, max_days: 4 },
{ pincode: 797005, min_days: 3, max_days: 4 },
{ pincode: 797101, min_days: 3, max_days: 4 },
{ pincode: 797103, min_days: 3, max_days: 4 },
{ pincode: 797104, min_days: 3, max_days: 4 },
{ pincode: 797105, min_days: 3, max_days: 4 },
{ pincode: 797106, min_days: 3, max_days: 4 },
{ pincode: 797107, min_days: 3, max_days: 4 },
{ pincode: 797108, min_days: 3, max_days: 4 },
{ pincode: 797109, min_days: 3, max_days: 4 },
{ pincode: 797110, min_days: 3, max_days: 4 },
{ pincode: 797111, min_days: 3, max_days: 4 },
{ pincode: 797112, min_days: 3, max_days: 4 },
{ pincode: 797113, min_days: 3, max_days: 4 },
{ pincode: 797114, min_days: 3, max_days: 4 },
{ pincode: 797115, min_days: 3, max_days: 4 },
{ pincode: 797116, min_days: 3, max_days: 4 },
{ pincode: 797117, min_days: 3, max_days: 4 },
{ pincode: 797118, min_days: 3, max_days: 4 },
{ pincode: 797119, min_days: 3, max_days: 4 },
{ pincode: 797120, min_days: 3, max_days: 4 },
{ pincode: 797121, min_days: 3, max_days: 4 },
{ pincode: 798601, min_days: 3, max_days: 4 },
{ pincode: 798602, min_days: 3, max_days: 4 },
{ pincode: 798603, min_days: 3, max_days: 4 },
{ pincode: 798604, min_days: 3, max_days: 4 },
{ pincode: 798607, min_days: 3, max_days: 4 },
{ pincode: 798611, min_days: 3, max_days: 4 },
{ pincode: 798612, min_days: 3, max_days: 4 },
{ pincode: 798613, min_days: 3, max_days: 4 },
{ pincode: 798614, min_days: 3, max_days: 4 },
{ pincode: 798615, min_days: 3, max_days: 4 },
{ pincode: 798616, min_days: 3, max_days: 4 },
{ pincode: 798617, min_days: 3, max_days: 4 },
{ pincode: 798618, min_days: 3, max_days: 4 },
{ pincode: 798620, min_days: 3, max_days: 4 },
{ pincode: 798621, min_days: 3, max_days: 4 },
{ pincode: 798622, min_days: 3, max_days: 4 },
{ pincode: 798623, min_days: 3, max_days: 4 },
{ pincode: 798625, min_days: 3, max_days: 4 },
{ pincode: 798626, min_days: 3, max_days: 4 },
{ pincode: 798627, min_days: 3, max_days: 4 },
{ pincode: 799001, min_days: 3, max_days: 4 },
{ pincode: 799002, min_days: 2, max_days: 3 },
{ pincode: 799003, min_days: 2, max_days: 3 },
{ pincode: 799004, min_days: 2, max_days: 3 },
{ pincode: 799005, min_days: 2, max_days: 3 },
{ pincode: 799006, min_days: 2, max_days: 3 },
{ pincode: 799007, min_days: 2, max_days: 3 },
{ pincode: 799008, min_days: 2, max_days: 3 },
{ pincode: 799009, min_days: 2, max_days: 3 },
{ pincode: 799010, min_days: 2, max_days: 3 },
{ pincode: 799011, min_days: 2, max_days: 3 },
{ pincode: 799012, min_days: 2, max_days: 3 },
{ pincode: 799013, min_days: 2, max_days: 3 },
{ pincode: 799014, min_days: 2, max_days: 3 },
{ pincode: 799015, min_days: 2, max_days: 3 },
{ pincode: 799022, min_days: 2, max_days: 3 },
{ pincode: 799035, min_days: 2, max_days: 3 },
{ pincode: 799045, min_days: 2, max_days: 3 },
{ pincode: 799046, min_days: 2, max_days: 3 },
{ pincode: 799055, min_days: 3, max_days: 4 },
{ pincode: 799100, min_days: 3, max_days: 4 },
{ pincode: 799101, min_days: 2, max_days: 3 },
{ pincode: 799102, min_days: 2, max_days: 3 },
{ pincode: 799103, min_days: 2, max_days: 3 },
{ pincode: 799104, min_days: 2, max_days: 3 },
{ pincode: 799105, min_days: 2, max_days: 3 },
{ pincode: 799113, min_days: 2, max_days: 3 },
{ pincode: 799114, min_days: 2, max_days: 3 },
{ pincode: 799115, min_days: 2, max_days: 3 },
{ pincode: 799116, min_days: 3, max_days: 4 },
{ pincode: 799120, min_days: 2, max_days: 3 },
{ pincode: 799125, min_days: 2, max_days: 3 },
{ pincode: 799130, min_days: 2, max_days: 3 },
{ pincode: 799131, min_days: 2, max_days: 3 },
{ pincode: 799132, min_days: 2, max_days: 3 },
{ pincode: 799141, min_days: 2, max_days: 3 },
{ pincode: 799142, min_days: 2, max_days: 3 },
{ pincode: 799143, min_days: 2, max_days: 3 },
{ pincode: 799144, min_days: 2, max_days: 3 },
{ pincode: 799145, min_days: 2, max_days: 3 },
{ pincode: 799150, min_days: 2, max_days: 3 },
{ pincode: 799153, min_days: 2, max_days: 3 },
{ pincode: 799155, min_days: 2, max_days: 3 },
{ pincode: 799156, min_days: 2, max_days: 3 },
{ pincode: 799157, min_days: 2, max_days: 3 },
{ pincode: 799181, min_days: 2, max_days: 3 },
{ pincode: 799201, min_days: 2, max_days: 3 },
{ pincode: 799202, min_days: 2, max_days: 3 },
{ pincode: 799203, min_days: 2, max_days: 3 },
{ pincode: 799204, min_days: 2, max_days: 3 },
{ pincode: 799205, min_days: 2, max_days: 3 },
{ pincode: 799206, min_days: 3, max_days: 4 },
{ pincode: 799207, min_days: 2, max_days: 3 },
{ pincode: 799210, min_days: 2, max_days: 3 },
{ pincode: 799211, min_days: 2, max_days: 3 },
{ pincode: 799212, min_days: 2, max_days: 3 },
{ pincode: 799250, min_days: 3, max_days: 4 },
{ pincode: 799251, min_days: 3, max_days: 4 },
{ pincode: 799252, min_days: 2, max_days: 3 },
{ pincode: 799253, min_days: 3, max_days: 4 },
{ pincode: 799254, min_days: 3, max_days: 4 },
{ pincode: 799256, min_days: 3, max_days: 4 },
{ pincode: 799260, min_days: 3, max_days: 4 },
{ pincode: 799261, min_days: 3, max_days: 4 },
{ pincode: 799262, min_days: 3, max_days: 4 },
{ pincode: 799263, min_days: 3, max_days: 4 },
{ pincode: 799264, min_days: 2, max_days: 3 },
{ pincode: 799266, min_days: 3, max_days: 4 },
{ pincode: 799269, min_days: 3, max_days: 4 },
{ pincode: 799270, min_days: 3, max_days: 4 },
{ pincode: 799271, min_days: 3, max_days: 4 },
{ pincode: 799273, min_days: 2, max_days: 3 },
{ pincode: 799275, min_days: 2, max_days: 3 },
{ pincode: 799277, min_days: 2, max_days: 3 },
{ pincode: 799278, min_days: 2, max_days: 3 },
{ pincode: 799279, min_days: 3, max_days: 4 },
{ pincode: 799280, min_days: 3, max_days: 4 },
{ pincode: 799281, min_days: 3, max_days: 4 },
{ pincode: 799282, min_days: 3, max_days: 4 },
{ pincode: 799284, min_days: 2, max_days: 3 },
{ pincode: 799285, min_days: 2, max_days: 3 },
{ pincode: 799286, min_days: 2, max_days: 3 },
{ pincode: 799287, min_days: 2, max_days: 3 },
{ pincode: 799288, min_days: 3, max_days: 4 },
{ pincode: 799289, min_days: 2, max_days: 3 },
{ pincode: 799290, min_days: 2, max_days: 3 },
{ pincode: 800001, min_days: 2, max_days: 3 },
{ pincode: 800002, min_days: 2, max_days: 3 },
{ pincode: 800003, min_days: 2, max_days: 3 },
{ pincode: 800004, min_days: 2, max_days: 3 },
{ pincode: 800005, min_days: 2, max_days: 3 },
{ pincode: 800006, min_days: 2, max_days: 3 },
{ pincode: 800007, min_days: 2, max_days: 3 },
{ pincode: 800008, min_days: 2, max_days: 3 },
{ pincode: 800009, min_days: 2, max_days: 3 },
{ pincode: 800010, min_days: 2, max_days: 3 },
{ pincode: 800011, min_days: 2, max_days: 3 },
{ pincode: 800012, min_days: 2, max_days: 3 },
{ pincode: 800013, min_days: 2, max_days: 3 },
{ pincode: 800014, min_days: 2, max_days: 3 },
{ pincode: 800015, min_days: 2, max_days: 3 },
{ pincode: 800016, min_days: 2, max_days: 3 },
{ pincode: 800017, min_days: 2, max_days: 3 },
{ pincode: 800018, min_days: 2, max_days: 3 },
{ pincode: 800019, min_days: 2, max_days: 3 },
{ pincode: 800020, min_days: 2, max_days: 3 },
{ pincode: 800021, min_days: 2, max_days: 3 },
{ pincode: 800022, min_days: 2, max_days: 3 },
{ pincode: 800023, min_days: 2, max_days: 3 },
{ pincode: 800024, min_days: 2, max_days: 3 },
{ pincode: 800025, min_days: 2, max_days: 3 },
{ pincode: 800026, min_days: 2, max_days: 3 },
{ pincode: 800027, min_days: 2, max_days: 3 },
{ pincode: 800028, min_days: 2, max_days: 3 },
{ pincode: 800029, min_days: 2, max_days: 3 },
{ pincode: 800030, min_days: 2, max_days: 3 },
{ pincode: 800031, min_days: 2, max_days: 3 },
{ pincode: 800111, min_days: 2, max_days: 3 },
{ pincode: 801102, min_days: 2, max_days: 3 },
{ pincode: 801103, min_days: 2, max_days: 3 },
{ pincode: 801104, min_days: 2, max_days: 3 },
{ pincode: 801105, min_days: 2, max_days: 3 },
{ pincode: 801106, min_days: 2, max_days: 3 },
{ pincode: 801108, min_days: 2, max_days: 3 },
{ pincode: 801109, min_days: 2, max_days: 3 },
{ pincode: 801110, min_days: 2, max_days: 3 },
{ pincode: 801111, min_days: 2, max_days: 3 },
{ pincode: 801112, min_days: 2, max_days: 3 },
{ pincode: 801113, min_days: 2, max_days: 3 },
{ pincode: 801115, min_days: 2, max_days: 3 },
{ pincode: 801117, min_days: 2, max_days: 3 },
{ pincode: 801118, min_days: 2, max_days: 3 },
{ pincode: 801301, min_days: 2, max_days: 3 },
{ pincode: 801302, min_days: 2, max_days: 3 },
{ pincode: 801303, min_days: 2, max_days: 3 },
{ pincode: 801304, min_days: 2, max_days: 3 },
{ pincode: 801305, min_days: 2, max_days: 3 },
{ pincode: 801306, min_days: 2, max_days: 3 },
{ pincode: 801307, min_days: 2, max_days: 3 },
{ pincode: 801501, min_days: 2, max_days: 3 },
{ pincode: 801502, min_days: 2, max_days: 3 },
{ pincode: 801503, min_days: 2, max_days: 3 },
{ pincode: 801504, min_days: 2, max_days: 3 },
{ pincode: 801505, min_days: 2, max_days: 3 },
{ pincode: 801506, min_days: 2, max_days: 3 },
{ pincode: 801507, min_days: 2, max_days: 3 },
{ pincode: 801509, min_days: 2, max_days: 3 },
{ pincode: 802101, min_days: 2, max_days: 3 },
{ pincode: 802102, min_days: 2, max_days: 3 },
{ pincode: 802103, min_days: 2, max_days: 3 },
{ pincode: 802111, min_days: 2, max_days: 3 },
{ pincode: 802112, min_days: 2, max_days: 3 },
{ pincode: 802113, min_days: 2, max_days: 3 },
{ pincode: 802114, min_days: 2, max_days: 3 },
{ pincode: 802115, min_days: 2, max_days: 3 },
{ pincode: 802116, min_days: 2, max_days: 3 },
{ pincode: 802117, min_days: 2, max_days: 3 },
{ pincode: 802118, min_days: 2, max_days: 3 },
{ pincode: 802119, min_days: 2, max_days: 3 },
{ pincode: 802120, min_days: 2, max_days: 3 },
{ pincode: 802122, min_days: 2, max_days: 3 },
{ pincode: 802123, min_days: 2, max_days: 3 },
{ pincode: 802125, min_days: 2, max_days: 3 },
{ pincode: 802126, min_days: 2, max_days: 3 },
{ pincode: 802127, min_days: 2, max_days: 3 },
{ pincode: 802128, min_days: 2, max_days: 3 },
{ pincode: 802129, min_days: 2, max_days: 3 },
{ pincode: 802130, min_days: 2, max_days: 3 },
{ pincode: 802131, min_days: 2, max_days: 3 },
{ pincode: 802132, min_days: 2, max_days: 3 },
{ pincode: 802133, min_days: 2, max_days: 3 },
{ pincode: 802134, min_days: 2, max_days: 3 },
{ pincode: 802135, min_days: 2, max_days: 3 },
{ pincode: 802136, min_days: 2, max_days: 3 },
{ pincode: 802151, min_days: 2, max_days: 3 },
{ pincode: 802152, min_days: 2, max_days: 3 },
{ pincode: 802154, min_days: 2, max_days: 3 },
{ pincode: 802155, min_days: 2, max_days: 3 },
{ pincode: 802156, min_days: 2, max_days: 3 },
{ pincode: 802157, min_days: 2, max_days: 3 },
{ pincode: 802158, min_days: 2, max_days: 3 },
{ pincode: 802159, min_days: 2, max_days: 3 },
{ pincode: 802160, min_days: 2, max_days: 3 },
{ pincode: 802161, min_days: 2, max_days: 3 },
{ pincode: 802162, min_days: 2, max_days: 3 },
{ pincode: 802163, min_days: 2, max_days: 3 },
{ pincode: 802164, min_days: 2, max_days: 3 },
{ pincode: 802165, min_days: 2, max_days: 3 },
{ pincode: 802166, min_days: 2, max_days: 3 },
{ pincode: 802178, min_days: 2, max_days: 3 },
{ pincode: 802182, min_days: 2, max_days: 3 },
{ pincode: 802183, min_days: 2, max_days: 3 },
{ pincode: 802201, min_days: 2, max_days: 3 },
{ pincode: 802202, min_days: 2, max_days: 3 },
{ pincode: 802203, min_days: 2, max_days: 3 },
{ pincode: 802204, min_days: 2, max_days: 3 },
{ pincode: 802205, min_days: 2, max_days: 3 },
{ pincode: 802206, min_days: 2, max_days: 3 },
{ pincode: 802207, min_days: 2, max_days: 3 },
{ pincode: 802208, min_days: 2, max_days: 3 },
{ pincode: 802209, min_days: 2, max_days: 3 },
{ pincode: 802210, min_days: 2, max_days: 3 },
{ pincode: 802211, min_days: 2, max_days: 3 },
{ pincode: 802212, min_days: 2, max_days: 3 },
{ pincode: 802213, min_days: 2, max_days: 3 },
{ pincode: 802214, min_days: 2, max_days: 3 },
{ pincode: 802215, min_days: 2, max_days: 3 },
{ pincode: 802216, min_days: 2, max_days: 3 },
{ pincode: 802217, min_days: 2, max_days: 3 },
{ pincode: 802218, min_days: 2, max_days: 3 },
{ pincode: 802219, min_days: 2, max_days: 3 },
{ pincode: 802220, min_days: 2, max_days: 3 },
{ pincode: 802221, min_days: 2, max_days: 3 },
{ pincode: 802222, min_days: 2, max_days: 3 },
{ pincode: 802223, min_days: 2, max_days: 3 },
{ pincode: 802226, min_days: 2, max_days: 3 },
{ pincode: 802237, min_days: 2, max_days: 3 },
{ pincode: 802301, min_days: 2, max_days: 3 },
{ pincode: 802302, min_days: 2, max_days: 3 },
{ pincode: 802304, min_days: 2, max_days: 3 },
{ pincode: 802311, min_days: 2, max_days: 3 },
{ pincode: 802312, min_days: 2, max_days: 3 },
{ pincode: 802313, min_days: 2, max_days: 3 },
{ pincode: 802314, min_days: 2, max_days: 3 },
{ pincode: 802315, min_days: 2, max_days: 3 },
{ pincode: 802316, min_days: 2, max_days: 3 },
{ pincode: 802351, min_days: 2, max_days: 3 },
{ pincode: 802352, min_days: 2, max_days: 3 },
{ pincode: 803101, min_days: 2, max_days: 3 },
{ pincode: 803102, min_days: 2, max_days: 3 },
{ pincode: 803107, min_days: 2, max_days: 3 },
{ pincode: 803108, min_days: 2, max_days: 3 },
{ pincode: 803109, min_days: 2, max_days: 3 },
{ pincode: 803110, min_days: 2, max_days: 3 },
{ pincode: 803111, min_days: 2, max_days: 3 },
{ pincode: 803113, min_days: 2, max_days: 3 },
{ pincode: 803114, min_days: 2, max_days: 3 },
{ pincode: 803115, min_days: 2, max_days: 3 },
{ pincode: 803116, min_days: 2, max_days: 3 },
{ pincode: 803117, min_days: 2, max_days: 3 },
{ pincode: 803118, min_days: 2, max_days: 3 },
{ pincode: 803119, min_days: 2, max_days: 3 },
{ pincode: 803120, min_days: 2, max_days: 3 },
{ pincode: 803121, min_days: 2, max_days: 3 },
{ pincode: 803122, min_days: 2, max_days: 3 },
{ pincode: 803123, min_days: 2, max_days: 3 },
{ pincode: 803124, min_days: 2, max_days: 3 },
{ pincode: 803201, min_days: 2, max_days: 3 },
{ pincode: 803202, min_days: 2, max_days: 3 },
{ pincode: 803203, min_days: 2, max_days: 3 },
{ pincode: 803204, min_days: 2, max_days: 3 },
{ pincode: 803205, min_days: 2, max_days: 3 },
{ pincode: 803206, min_days: 2, max_days: 3 },
{ pincode: 803211, min_days: 2, max_days: 3 },
{ pincode: 803212, min_days: 2, max_days: 3 },
{ pincode: 803213, min_days: 2, max_days: 3 },
{ pincode: 803214, min_days: 2, max_days: 3 },
{ pincode: 803215, min_days: 2, max_days: 3 },
{ pincode: 803216, min_days: 2, max_days: 3 },
{ pincode: 803218, min_days: 2, max_days: 3 },
{ pincode: 803221, min_days: 2, max_days: 3 },
{ pincode: 803232, min_days: 2, max_days: 3 },
{ pincode: 803301, min_days: 2, max_days: 3 },
{ pincode: 803302, min_days: 2, max_days: 3 },
{ pincode: 803303, min_days: 2, max_days: 3 },
{ pincode: 803306, min_days: 2, max_days: 3 },
{ pincode: 803307, min_days: 2, max_days: 3 },
{ pincode: 804401, min_days: 2, max_days: 3 },
{ pincode: 804402, min_days: 2, max_days: 3 },
{ pincode: 804403, min_days: 2, max_days: 3 },
{ pincode: 804404, min_days: 2, max_days: 3 },
{ pincode: 804405, min_days: 2, max_days: 3 },
{ pincode: 804406, min_days: 2, max_days: 3 },
{ pincode: 804407, min_days: 2, max_days: 3 },
{ pincode: 804408, min_days: 2, max_days: 3 },
{ pincode: 804409, min_days: 2, max_days: 3 },
{ pincode: 804417, min_days: 2, max_days: 3 },
{ pincode: 804418, min_days: 2, max_days: 3 },
{ pincode: 804419, min_days: 2, max_days: 3 },
{ pincode: 804420, min_days: 2, max_days: 3 },
{ pincode: 804421, min_days: 2, max_days: 3 },
{ pincode: 804422, min_days: 2, max_days: 3 },
{ pincode: 804423, min_days: 2, max_days: 3 },
{ pincode: 804424, min_days: 2, max_days: 3 },
{ pincode: 804425, min_days: 2, max_days: 3 },
{ pincode: 804426, min_days: 2, max_days: 3 },
{ pincode: 804427, min_days: 2, max_days: 3 },
{ pincode: 804428, min_days: 2, max_days: 3 },
{ pincode: 804429, min_days: 2, max_days: 3 },
{ pincode: 804430, min_days: 2, max_days: 3 },
{ pincode: 804431, min_days: 2, max_days: 3 },
{ pincode: 804432, min_days: 2, max_days: 3 },
{ pincode: 804433, min_days: 2, max_days: 3 },
{ pincode: 804434, min_days: 2, max_days: 3 },
{ pincode: 804435, min_days: 2, max_days: 3 },
{ pincode: 804451, min_days: 2, max_days: 3 },
{ pincode: 804452, min_days: 2, max_days: 3 },
{ pincode: 804453, min_days: 2, max_days: 3 },
{ pincode: 804454, min_days: 2, max_days: 3 },
{ pincode: 805101, min_days: 2, max_days: 3 },
{ pincode: 805102, min_days: 2, max_days: 3 },
{ pincode: 805103, min_days: 2, max_days: 3 },
{ pincode: 805104, min_days: 2, max_days: 3 },
{ pincode: 805105, min_days: 2, max_days: 3 },
{ pincode: 805106, min_days: 2, max_days: 3 },
{ pincode: 805107, min_days: 2, max_days: 3 },
{ pincode: 805108, min_days: 2, max_days: 3 },
{ pincode: 805109, min_days: 2, max_days: 3 },
{ pincode: 805110, min_days: 2, max_days: 3 },
{ pincode: 805111, min_days: 2, max_days: 3 },
{ pincode: 805112, min_days: 2, max_days: 3 },
{ pincode: 805113, min_days: 2, max_days: 3 },
{ pincode: 805114, min_days: 2, max_days: 3 },
{ pincode: 805121, min_days: 2, max_days: 3 },
{ pincode: 805122, min_days: 2, max_days: 3 },
{ pincode: 805123, min_days: 2, max_days: 3 },
{ pincode: 805124, min_days: 2, max_days: 3 },
{ pincode: 805125, min_days: 2, max_days: 3 },
{ pincode: 805126, min_days: 2, max_days: 3 },
{ pincode: 805127, min_days: 2, max_days: 3 },
{ pincode: 805128, min_days: 2, max_days: 3 },
{ pincode: 805129, min_days: 2, max_days: 3 },
{ pincode: 805130, min_days: 2, max_days: 3 },
{ pincode: 805131, min_days: 2, max_days: 3 },
{ pincode: 805132, min_days: 2, max_days: 3 },
{ pincode: 805133, min_days: 2, max_days: 3 },
{ pincode: 805135, min_days: 2, max_days: 3 },
{ pincode: 805138, min_days: 2, max_days: 3 },
{ pincode: 805141, min_days: 2, max_days: 3 },
{ pincode: 805143, min_days: 2, max_days: 3 },
{ pincode: 805236, min_days: 2, max_days: 3 },
{ pincode: 811101, min_days: 2, max_days: 3 },
{ pincode: 811102, min_days: 2, max_days: 3 },
{ pincode: 811103, min_days: 2, max_days: 3 },
{ pincode: 811104, min_days: 2, max_days: 3 },
{ pincode: 811105, min_days: 2, max_days: 3 },
{ pincode: 811106, min_days: 2, max_days: 3 },
{ pincode: 811107, min_days: 2, max_days: 3 },
{ pincode: 811112, min_days: 2, max_days: 3 },
{ pincode: 811201, min_days: 2, max_days: 3 },
{ pincode: 811202, min_days: 2, max_days: 3 },
{ pincode: 811203, min_days: 2, max_days: 3 },
{ pincode: 811211, min_days: 2, max_days: 3 },
{ pincode: 811212, min_days: 2, max_days: 3 },
{ pincode: 811213, min_days: 2, max_days: 3 },
{ pincode: 811214, min_days: 2, max_days: 3 },
{ pincode: 811241, min_days: 2, max_days: 3 },
{ pincode: 811301, min_days: 2, max_days: 3 },
{ pincode: 811302, min_days: 2, max_days: 3 },
{ pincode: 811303, min_days: 2, max_days: 3 },
{ pincode: 811304, min_days: 2, max_days: 3 },
{ pincode: 811305, min_days: 2, max_days: 3 },
{ pincode: 811306, min_days: 2, max_days: 3 },
{ pincode: 811307, min_days: 2, max_days: 3 },
{ pincode: 811308, min_days: 2, max_days: 3 },
{ pincode: 811309, min_days: 2, max_days: 3 },
{ pincode: 811310, min_days: 2, max_days: 3 },
{ pincode: 811311, min_days: 2, max_days: 3 },
{ pincode: 811312, min_days: 2, max_days: 3 },
{ pincode: 811313, min_days: 2, max_days: 3 },
{ pincode: 811314, min_days: 2, max_days: 3 },
{ pincode: 811315, min_days: 2, max_days: 3 },
{ pincode: 811316, min_days: 2, max_days: 3 },
{ pincode: 811317, min_days: 2, max_days: 3 },
{ pincode: 812001, min_days: 2, max_days: 3 },
{ pincode: 812002, min_days: 2, max_days: 3 },
{ pincode: 812003, min_days: 2, max_days: 3 },
{ pincode: 812004, min_days: 2, max_days: 3 },
{ pincode: 812005, min_days: 2, max_days: 3 },
{ pincode: 812006, min_days: 2, max_days: 3 },
{ pincode: 812007, min_days: 2, max_days: 3 },
{ pincode: 812008, min_days: 2, max_days: 3 },
{ pincode: 812009, min_days: 2, max_days: 3 },
{ pincode: 812010, min_days: 2, max_days: 3 },
{ pincode: 813101, min_days: 2, max_days: 3 },
{ pincode: 813102, min_days: 2, max_days: 3 },
{ pincode: 813103, min_days: 2, max_days: 3 },
{ pincode: 813104, min_days: 2, max_days: 3 },
{ pincode: 813105, min_days: 2, max_days: 3 },
{ pincode: 813106, min_days: 2, max_days: 3 },
{ pincode: 813107, min_days: 2, max_days: 3 },
{ pincode: 813108, min_days: 2, max_days: 3 },
{ pincode: 813109, min_days: 2, max_days: 3 },
{ pincode: 813110, min_days: 2, max_days: 3 },
{ pincode: 813112, min_days: 2, max_days: 3 },
{ pincode: 813113, min_days: 2, max_days: 3 },
{ pincode: 813115, min_days: 2, max_days: 3 },
{ pincode: 813116, min_days: 2, max_days: 3 },
{ pincode: 813118, min_days: 2, max_days: 3 },
{ pincode: 813121, min_days: 2, max_days: 3 },
{ pincode: 813123, min_days: 2, max_days: 3 },
{ pincode: 813124, min_days: 2, max_days: 3 },
{ pincode: 813125, min_days: 2, max_days: 3 },
{ pincode: 813126, min_days: 2, max_days: 3 },
{ pincode: 813127, min_days: 2, max_days: 3 },
{ pincode: 813129, min_days: 2, max_days: 3 },
{ pincode: 813201, min_days: 2, max_days: 3 },
{ pincode: 813202, min_days: 2, max_days: 3 },
{ pincode: 813203, min_days: 2, max_days: 3 },
{ pincode: 813204, min_days: 2, max_days: 3 },
{ pincode: 813205, min_days: 2, max_days: 3 },
{ pincode: 813206, min_days: 2, max_days: 3 },
{ pincode: 813207, min_days: 2, max_days: 3 },
{ pincode: 813208, min_days: 2, max_days: 3 },
{ pincode: 813209, min_days: 2, max_days: 3 },
{ pincode: 813210, min_days: 2, max_days: 3 },
{ pincode: 813211, min_days: 2, max_days: 3 },
{ pincode: 813212, min_days: 2, max_days: 3 },
{ pincode: 813213, min_days: 2, max_days: 3 },
{ pincode: 813214, min_days: 2, max_days: 3 },
{ pincode: 813221, min_days: 2, max_days: 3 },
{ pincode: 813222, min_days: 2, max_days: 3 },
{ pincode: 813223, min_days: 2, max_days: 3 },
{ pincode: 813224, min_days: 2, max_days: 3 },
{ pincode: 813225, min_days: 2, max_days: 3 },
{ pincode: 813227, min_days: 2, max_days: 3 },
{ pincode: 813228, min_days: 2, max_days: 3 },
{ pincode: 813231, min_days: 2, max_days: 3 },
{ pincode: 813233, min_days: 2, max_days: 3 },
{ pincode: 814101, min_days: 2, max_days: 3 },
{ pincode: 814102, min_days: 2, max_days: 3 },
{ pincode: 814103, min_days: 2, max_days: 3 },
{ pincode: 814110, min_days: 2, max_days: 3 },
{ pincode: 814111, min_days: 2, max_days: 3 },
{ pincode: 814112, min_days: 2, max_days: 3 },
{ pincode: 814113, min_days: 2, max_days: 3 },
{ pincode: 814114, min_days: 2, max_days: 3 },
{ pincode: 814115, min_days: 2, max_days: 3 },
{ pincode: 814116, min_days: 2, max_days: 3 },
{ pincode: 814117, min_days: 2, max_days: 3 },
{ pincode: 814118, min_days: 2, max_days: 3 },
{ pincode: 814119, min_days: 2, max_days: 3 },
{ pincode: 814120, min_days: 2, max_days: 3 },
{ pincode: 814122, min_days: 2, max_days: 3 },
{ pincode: 814124, min_days: 2, max_days: 3 },
{ pincode: 814131, min_days: 2, max_days: 3 },
{ pincode: 814133, min_days: 2, max_days: 3 },
{ pincode: 814141, min_days: 2, max_days: 3 },
{ pincode: 814142, min_days: 2, max_days: 3 },
{ pincode: 814143, min_days: 2, max_days: 3 },
{ pincode: 814144, min_days: 2, max_days: 3 },
{ pincode: 814145, min_days: 2, max_days: 3 },
{ pincode: 814146, min_days: 2, max_days: 3 },
{ pincode: 814147, min_days: 2, max_days: 3 },
{ pincode: 814148, min_days: 2, max_days: 3 },
{ pincode: 814149, min_days: 2, max_days: 3 },
{ pincode: 814150, min_days: 2, max_days: 3 },
{ pincode: 814151, min_days: 2, max_days: 3 },
{ pincode: 814152, min_days: 2, max_days: 3 },
{ pincode: 814153, min_days: 2, max_days: 3 },
{ pincode: 814154, min_days: 2, max_days: 3 },
{ pincode: 814155, min_days: 2, max_days: 3 },
{ pincode: 814156, min_days: 2, max_days: 3 },
{ pincode: 814157, min_days: 2, max_days: 3 },
{ pincode: 814158, min_days: 2, max_days: 3 },
{ pincode: 814160, min_days: 2, max_days: 3 },
{ pincode: 814165, min_days: 2, max_days: 3 },
{ pincode: 814166, min_days: 2, max_days: 3 },
{ pincode: 814167, min_days: 2, max_days: 3 },
{ pincode: 815301, min_days: 2, max_days: 3 },
{ pincode: 815302, min_days: 2, max_days: 3 },
{ pincode: 815303, min_days: 2, max_days: 3 },
{ pincode: 815305, min_days: 2, max_days: 3 },
{ pincode: 815311, min_days: 2, max_days: 3 },
{ pincode: 815312, min_days: 2, max_days: 3 },
{ pincode: 815313, min_days: 2, max_days: 3 },
{ pincode: 815314, min_days: 2, max_days: 3 },
{ pincode: 815315, min_days: 2, max_days: 3 },
{ pincode: 815316, min_days: 2, max_days: 3 },
{ pincode: 815317, min_days: 2, max_days: 3 },
{ pincode: 815318, min_days: 2, max_days: 3 },
{ pincode: 815351, min_days: 2, max_days: 3 },
{ pincode: 815352, min_days: 2, max_days: 3 },
{ pincode: 815353, min_days: 2, max_days: 3 },
{ pincode: 815354, min_days: 2, max_days: 3 },
{ pincode: 815355, min_days: 2, max_days: 3 },
{ pincode: 815357, min_days: 2, max_days: 3 },
{ pincode: 815359, min_days: 2, max_days: 3 },
{ pincode: 816101, min_days: 2, max_days: 3 },
{ pincode: 816102, min_days: 2, max_days: 3 },
{ pincode: 816103, min_days: 2, max_days: 3 },
{ pincode: 816104, min_days: 2, max_days: 3 },
{ pincode: 816105, min_days: 2, max_days: 3 },
{ pincode: 816106, min_days: 2, max_days: 3 },
{ pincode: 816107, min_days: 2, max_days: 3 },
{ pincode: 816108, min_days: 2, max_days: 3 },
{ pincode: 816109, min_days: 2, max_days: 3 },
{ pincode: 816110, min_days: 2, max_days: 3 },
{ pincode: 816115, min_days: 2, max_days: 3 },
{ pincode: 816116, min_days: 2, max_days: 3 },
{ pincode: 816117, min_days: 2, max_days: 3 },
{ pincode: 816118, min_days: 2, max_days: 3 },
{ pincode: 816119, min_days: 2, max_days: 3 },
{ pincode: 816120, min_days: 2, max_days: 3 },
{ pincode: 816122, min_days: 2, max_days: 3 },
{ pincode: 816124, min_days: 2, max_days: 3 },
{ pincode: 816129, min_days: 2, max_days: 3 },
{ pincode: 821002, min_days: 2, max_days: 3 },
{ pincode: 821004, min_days: 2, max_days: 3 },
{ pincode: 821101, min_days: 2, max_days: 3 },
{ pincode: 821102, min_days: 2, max_days: 3 },
{ pincode: 821103, min_days: 2, max_days: 3 },
{ pincode: 821104, min_days: 2, max_days: 3 },
{ pincode: 821105, min_days: 2, max_days: 3 },
{ pincode: 821106, min_days: 2, max_days: 3 },
{ pincode: 821107, min_days: 2, max_days: 3 },
{ pincode: 821108, min_days: 2, max_days: 3 },
{ pincode: 821109, min_days: 2, max_days: 3 },
{ pincode: 821110, min_days: 2, max_days: 3 },
{ pincode: 821111, min_days: 2, max_days: 3 },
{ pincode: 821112, min_days: 2, max_days: 3 },
{ pincode: 821113, min_days: 2, max_days: 3 },
{ pincode: 821114, min_days: 2, max_days: 3 },
{ pincode: 821115, min_days: 2, max_days: 3 },
{ pincode: 821118, min_days: 2, max_days: 3 },
{ pincode: 821124, min_days: 2, max_days: 3 },
{ pincode: 821301, min_days: 2, max_days: 3 },
{ pincode: 821302, min_days: 2, max_days: 3 },
{ pincode: 821303, min_days: 2, max_days: 3 },
{ pincode: 821304, min_days: 2, max_days: 3 },
{ pincode: 821305, min_days: 2, max_days: 3 },
{ pincode: 821306, min_days: 2, max_days: 3 },
{ pincode: 821307, min_days: 2, max_days: 3 },
{ pincode: 821308, min_days: 2, max_days: 3 },
{ pincode: 821309, min_days: 2, max_days: 3 },
{ pincode: 821310, min_days: 2, max_days: 3 },
{ pincode: 821311, min_days: 2, max_days: 3 },
{ pincode: 821312, min_days: 2, max_days: 3 },
{ pincode: 821315, min_days: 2, max_days: 3 },
{ pincode: 821316, min_days: 2, max_days: 3 },
{ pincode: 822101, min_days: 2, max_days: 3 },
{ pincode: 822102, min_days: 2, max_days: 3 },
{ pincode: 822110, min_days: 2, max_days: 3 },
{ pincode: 822111, min_days: 2, max_days: 3 },
{ pincode: 822112, min_days: 2, max_days: 3 },
{ pincode: 822113, min_days: 2, max_days: 3 },
{ pincode: 822114, min_days: 2, max_days: 3 },
{ pincode: 822115, min_days: 2, max_days: 3 },
{ pincode: 822116, min_days: 2, max_days: 3 },
{ pincode: 822117, min_days: 2, max_days: 3 },
{ pincode: 822118, min_days: 2, max_days: 3 },
{ pincode: 822119, min_days: 2, max_days: 3 },
{ pincode: 822120, min_days: 2, max_days: 3 },
{ pincode: 822121, min_days: 2, max_days: 3 },
{ pincode: 822122, min_days: 2, max_days: 3 },
{ pincode: 822123, min_days: 2, max_days: 3 },
{ pincode: 822124, min_days: 2, max_days: 3 },
{ pincode: 822125, min_days: 2, max_days: 3 },
{ pincode: 822126, min_days: 2, max_days: 3 },
{ pincode: 822127, min_days: 2, max_days: 3 },
{ pincode: 822128, min_days: 2, max_days: 3 },
{ pincode: 822129, min_days: 2, max_days: 3 },
{ pincode: 822131, min_days: 2, max_days: 3 },
{ pincode: 822132, min_days: 2, max_days: 3 },
{ pincode: 822133, min_days: 2, max_days: 3 },
{ pincode: 822134, min_days: 2, max_days: 3 },
{ pincode: 823000, min_days: 2, max_days: 3 },
{ pincode: 823001, min_days: 2, max_days: 3 },
{ pincode: 823002, min_days: 2, max_days: 3 },
{ pincode: 823003, min_days: 2, max_days: 3 },
{ pincode: 823004, min_days: 2, max_days: 3 },
{ pincode: 823005, min_days: 2, max_days: 3 },
{ pincode: 823311, min_days: 2, max_days: 3 },
{ pincode: 824101, min_days: 2, max_days: 3 },
{ pincode: 824102, min_days: 2, max_days: 3 },
{ pincode: 824103, min_days: 2, max_days: 3 },
{ pincode: 824111, min_days: 2, max_days: 3 },
{ pincode: 824112, min_days: 2, max_days: 3 },
{ pincode: 824113, min_days: 2, max_days: 3 },
{ pincode: 824114, min_days: 2, max_days: 3 },
{ pincode: 824115, min_days: 2, max_days: 3 },
{ pincode: 824116, min_days: 2, max_days: 3 },
{ pincode: 824118, min_days: 2, max_days: 3 },
{ pincode: 824120, min_days: 2, max_days: 3 },
{ pincode: 824121, min_days: 2, max_days: 3 },
{ pincode: 824122, min_days: 2, max_days: 3 },
{ pincode: 824123, min_days: 2, max_days: 3 },
{ pincode: 824124, min_days: 2, max_days: 3 },
{ pincode: 824125, min_days: 2, max_days: 3 },
{ pincode: 824126, min_days: 2, max_days: 3 },
{ pincode: 824127, min_days: 2, max_days: 3 },
{ pincode: 824129, min_days: 2, max_days: 3 },
{ pincode: 824130, min_days: 2, max_days: 3 },
{ pincode: 824143, min_days: 2, max_days: 3 },
{ pincode: 824201, min_days: 2, max_days: 3 },
{ pincode: 824202, min_days: 2, max_days: 3 },
{ pincode: 824203, min_days: 2, max_days: 3 },
{ pincode: 824205, min_days: 2, max_days: 3 },
{ pincode: 824206, min_days: 2, max_days: 3 },
{ pincode: 824207, min_days: 2, max_days: 3 },
{ pincode: 824208, min_days: 2, max_days: 3 },
{ pincode: 824209, min_days: 2, max_days: 3 },
{ pincode: 824210, min_days: 2, max_days: 3 },
{ pincode: 824211, min_days: 2, max_days: 3 },
{ pincode: 824213, min_days: 2, max_days: 3 },
{ pincode: 824216, min_days: 2, max_days: 3 },
{ pincode: 824217, min_days: 2, max_days: 3 },
{ pincode: 824218, min_days: 2, max_days: 3 },
{ pincode: 824219, min_days: 2, max_days: 3 },
{ pincode: 824220, min_days: 2, max_days: 3 },
{ pincode: 824221, min_days: 2, max_days: 3 },
{ pincode: 824230, min_days: 2, max_days: 3 },
{ pincode: 824231, min_days: 2, max_days: 3 },
{ pincode: 824232, min_days: 2, max_days: 3 },
{ pincode: 824233, min_days: 2, max_days: 3 },
{ pincode: 824234, min_days: 2, max_days: 3 },
{ pincode: 824235, min_days: 2, max_days: 3 },
{ pincode: 824236, min_days: 2, max_days: 3 },
{ pincode: 824237, min_days: 2, max_days: 3 },
{ pincode: 824301, min_days: 2, max_days: 3 },
{ pincode: 824302, min_days: 2, max_days: 3 },
{ pincode: 824303, min_days: 2, max_days: 3 },
{ pincode: 824304, min_days: 2, max_days: 3 },
{ pincode: 824401, min_days: 2, max_days: 3 },
{ pincode: 824402, min_days: 2, max_days: 3 },
{ pincode: 825101, min_days: 2, max_days: 3 },
{ pincode: 825102, min_days: 2, max_days: 3 },
{ pincode: 825103, min_days: 2, max_days: 3 },
{ pincode: 825106, min_days: 2, max_days: 3 },
{ pincode: 825108, min_days: 2, max_days: 3 },
{ pincode: 825109, min_days: 2, max_days: 3 },
{ pincode: 825132, min_days: 2, max_days: 3 },
{ pincode: 825137, min_days: 2, max_days: 3 },
{ pincode: 825167, min_days: 2, max_days: 3 },
{ pincode: 825301, min_days: 2, max_days: 3 },
{ pincode: 825302, min_days: 2, max_days: 3 },
{ pincode: 825303, min_days: 2, max_days: 3 },
{ pincode: 825304, min_days: 2, max_days: 3 },
{ pincode: 825311, min_days: 2, max_days: 3 },
{ pincode: 825312, min_days: 2, max_days: 3 },
{ pincode: 825313, min_days: 2, max_days: 3 },
{ pincode: 825314, min_days: 2, max_days: 3 },
{ pincode: 825315, min_days: 2, max_days: 3 },
{ pincode: 825316, min_days: 2, max_days: 3 },
{ pincode: 825317, min_days: 2, max_days: 3 },
{ pincode: 825318, min_days: 2, max_days: 3 },
{ pincode: 825319, min_days: 2, max_days: 3 },
{ pincode: 825320, min_days: 2, max_days: 3 },
{ pincode: 825321, min_days: 2, max_days: 3 },
{ pincode: 825322, min_days: 2, max_days: 3 },
{ pincode: 825323, min_days: 2, max_days: 3 },
{ pincode: 825324, min_days: 2, max_days: 3 },
{ pincode: 825325, min_days: 2, max_days: 3 },
{ pincode: 825326, min_days: 2, max_days: 3 },
{ pincode: 825327, min_days: 2, max_days: 3 },
{ pincode: 825328, min_days: 2, max_days: 3 },
{ pincode: 825329, min_days: 2, max_days: 3 },
{ pincode: 825330, min_days: 2, max_days: 3 },
{ pincode: 825335, min_days: 2, max_days: 3 },
{ pincode: 825336, min_days: 2, max_days: 3 },
{ pincode: 825401, min_days: 2, max_days: 3 },
{ pincode: 825402, min_days: 2, max_days: 3 },
{ pincode: 825403, min_days: 2, max_days: 3 },
{ pincode: 825404, min_days: 2, max_days: 3 },
{ pincode: 825405, min_days: 2, max_days: 3 },
{ pincode: 825406, min_days: 2, max_days: 3 },
{ pincode: 825407, min_days: 2, max_days: 3 },
{ pincode: 825408, min_days: 2, max_days: 3 },
{ pincode: 825409, min_days: 2, max_days: 3 },
{ pincode: 825410, min_days: 2, max_days: 3 },
{ pincode: 825411, min_days: 2, max_days: 3 },
{ pincode: 825412, min_days: 2, max_days: 3 },
{ pincode: 825413, min_days: 2, max_days: 3 },
{ pincode: 825414, min_days: 2, max_days: 3 },
{ pincode: 825415, min_days: 2, max_days: 3 },
{ pincode: 825418, min_days: 2, max_days: 3 },
{ pincode: 825420, min_days: 2, max_days: 3 },
{ pincode: 825421, min_days: 2, max_days: 3 },
{ pincode: 826001, min_days: 2, max_days: 3 },
{ pincode: 826002, min_days: 2, max_days: 3 },
{ pincode: 826003, min_days: 2, max_days: 3 },
{ pincode: 826004, min_days: 2, max_days: 3 },
{ pincode: 826005, min_days: 2, max_days: 3 },
{ pincode: 826006, min_days: 2, max_days: 3 },
{ pincode: 826007, min_days: 2, max_days: 3 },
{ pincode: 826008, min_days: 2, max_days: 3 },
{ pincode: 826009, min_days: 2, max_days: 3 },
{ pincode: 826010, min_days: 2, max_days: 3 },
{ pincode: 826011, min_days: 2, max_days: 3 },
{ pincode: 826012, min_days: 2, max_days: 3 },
{ pincode: 826013, min_days: 2, max_days: 3 },
{ pincode: 826015, min_days: 2, max_days: 3 },
{ pincode: 826106, min_days: 2, max_days: 3 },
{ pincode: 826124, min_days: 2, max_days: 3 },
{ pincode: 827001, min_days: 2, max_days: 3 },
{ pincode: 827002, min_days: 2, max_days: 3 },
{ pincode: 827003, min_days: 2, max_days: 3 },
{ pincode: 827004, min_days: 2, max_days: 3 },
{ pincode: 827005, min_days: 2, max_days: 3 },
{ pincode: 827006, min_days: 2, max_days: 3 },
{ pincode: 827007, min_days: 2, max_days: 3 },
{ pincode: 827008, min_days: 2, max_days: 3 },
{ pincode: 827009, min_days: 2, max_days: 3 },
{ pincode: 827010, min_days: 2, max_days: 3 },
{ pincode: 827011, min_days: 2, max_days: 3 },
{ pincode: 827012, min_days: 2, max_days: 3 },
{ pincode: 827013, min_days: 2, max_days: 3 },
{ pincode: 827014, min_days: 2, max_days: 3 },
{ pincode: 827015, min_days: 2, max_days: 3 },
{ pincode: 827016, min_days: 2, max_days: 3 },
{ pincode: 827302, min_days: 2, max_days: 3 },
{ pincode: 828101, min_days: 2, max_days: 3 },
{ pincode: 828102, min_days: 2, max_days: 3 },
{ pincode: 828103, min_days: 2, max_days: 3 },
{ pincode: 828104, min_days: 2, max_days: 3 },
{ pincode: 828105, min_days: 2, max_days: 3 },
{ pincode: 828106, min_days: 2, max_days: 3 },
{ pincode: 828107, min_days: 2, max_days: 3 },
{ pincode: 828108, min_days: 2, max_days: 3 },
{ pincode: 828109, min_days: 2, max_days: 3 },
{ pincode: 828110, min_days: 2, max_days: 3 },
{ pincode: 828111, min_days: 2, max_days: 3 },
{ pincode: 828112, min_days: 2, max_days: 3 },
{ pincode: 828113, min_days: 2, max_days: 3 },
{ pincode: 828114, min_days: 2, max_days: 3 },
{ pincode: 828115, min_days: 2, max_days: 3 },
{ pincode: 828116, min_days: 2, max_days: 3 },
{ pincode: 828117, min_days: 2, max_days: 3 },
{ pincode: 828119, min_days: 2, max_days: 3 },
{ pincode: 828120, min_days: 2, max_days: 3 },
{ pincode: 828121, min_days: 2, max_days: 3 },
{ pincode: 828122, min_days: 2, max_days: 3 },
{ pincode: 828123, min_days: 2, max_days: 3 },
{ pincode: 828124, min_days: 2, max_days: 3 },
{ pincode: 828125, min_days: 2, max_days: 3 },
{ pincode: 828126, min_days: 2, max_days: 3 },
{ pincode: 828127, min_days: 2, max_days: 3 },
{ pincode: 828128, min_days: 2, max_days: 3 },
{ pincode: 828129, min_days: 2, max_days: 3 },
{ pincode: 828130, min_days: 2, max_days: 3 },
{ pincode: 828131, min_days: 2, max_days: 3 },
{ pincode: 828132, min_days: 2, max_days: 3 },
{ pincode: 828133, min_days: 2, max_days: 3 },
{ pincode: 828134, min_days: 2, max_days: 3 },
{ pincode: 828135, min_days: 2, max_days: 3 },
{ pincode: 828142, min_days: 2, max_days: 3 },
{ pincode: 828201, min_days: 2, max_days: 3 },
{ pincode: 828202, min_days: 2, max_days: 3 },
{ pincode: 828203, min_days: 2, max_days: 3 },
{ pincode: 828204, min_days: 2, max_days: 3 },
{ pincode: 828205, min_days: 2, max_days: 3 },
{ pincode: 828206, min_days: 2, max_days: 3 },
{ pincode: 828207, min_days: 2, max_days: 3 },
{ pincode: 828209, min_days: 2, max_days: 3 },
{ pincode: 828301, min_days: 2, max_days: 3 },
{ pincode: 828302, min_days: 2, max_days: 3 },
{ pincode: 828303, min_days: 2, max_days: 3 },
{ pincode: 828304, min_days: 2, max_days: 3 },
{ pincode: 828305, min_days: 2, max_days: 3 },
{ pincode: 828306, min_days: 2, max_days: 3 },
{ pincode: 828307, min_days: 2, max_days: 3 },
{ pincode: 828308, min_days: 2, max_days: 3 },
{ pincode: 828309, min_days: 2, max_days: 3 },
{ pincode: 828311, min_days: 2, max_days: 3 },
{ pincode: 828401, min_days: 2, max_days: 3 },
{ pincode: 828402, min_days: 2, max_days: 3 },
{ pincode: 828403, min_days: 2, max_days: 3 },
{ pincode: 828404, min_days: 2, max_days: 3 },
{ pincode: 828828, min_days: 2, max_days: 3 },
{ pincode: 829101, min_days: 2, max_days: 3 },
{ pincode: 829102, min_days: 2, max_days: 3 },
{ pincode: 829103, min_days: 2, max_days: 3 },
{ pincode: 829104, min_days: 2, max_days: 3 },
{ pincode: 829105, min_days: 2, max_days: 3 },
{ pincode: 829106, min_days: 2, max_days: 3 },
{ pincode: 829107, min_days: 2, max_days: 3 },
{ pincode: 829108, min_days: 2, max_days: 3 },
{ pincode: 829109, min_days: 2, max_days: 3 },
{ pincode: 829110, min_days: 2, max_days: 3 },
{ pincode: 829111, min_days: 2, max_days: 3 },
{ pincode: 829112, min_days: 2, max_days: 3 },
{ pincode: 829113, min_days: 2, max_days: 3 },
{ pincode: 829114, min_days: 2, max_days: 3 },
{ pincode: 829115, min_days: 2, max_days: 3 },
{ pincode: 829116, min_days: 2, max_days: 3 },
{ pincode: 829117, min_days: 2, max_days: 3 },
{ pincode: 829118, min_days: 2, max_days: 3 },
{ pincode: 829119, min_days: 2, max_days: 3 },
{ pincode: 829120, min_days: 2, max_days: 3 },
{ pincode: 829121, min_days: 2, max_days: 3 },
{ pincode: 829122, min_days: 2, max_days: 3 },
{ pincode: 829123, min_days: 2, max_days: 3 },
{ pincode: 829124, min_days: 2, max_days: 3 },
{ pincode: 829125, min_days: 2, max_days: 3 },
{ pincode: 829126, min_days: 2, max_days: 3 },
{ pincode: 829127, min_days: 2, max_days: 3 },
{ pincode: 829128, min_days: 2, max_days: 3 },
{ pincode: 829129, min_days: 2, max_days: 3 },
{ pincode: 829130, min_days: 2, max_days: 3 },
{ pincode: 829131, min_days: 2, max_days: 3 },
{ pincode: 829132, min_days: 2, max_days: 3 },
{ pincode: 829133, min_days: 2, max_days: 3 },
{ pincode: 829134, min_days: 2, max_days: 3 },
{ pincode: 829135, min_days: 2, max_days: 3 },
{ pincode: 829138, min_days: 2, max_days: 3 },
{ pincode: 829143, min_days: 2, max_days: 3 },
{ pincode: 829144, min_days: 2, max_days: 3 },
{ pincode: 829145, min_days: 2, max_days: 3 },
{ pincode: 829146, min_days: 2, max_days: 3 },
{ pincode: 829149, min_days: 2, max_days: 3 },
{ pincode: 829150, min_days: 2, max_days: 3 },
{ pincode: 829201, min_days: 2, max_days: 3 },
{ pincode: 829202, min_days: 2, max_days: 3 },
{ pincode: 829203, min_days: 2, max_days: 3 },
{ pincode: 829204, min_days: 2, max_days: 3 },
{ pincode: 829205, min_days: 2, max_days: 3 },
{ pincode: 829206, min_days: 2, max_days: 3 },
{ pincode: 829207, min_days: 2, max_days: 3 },
{ pincode: 829208, min_days: 2, max_days: 3 },
{ pincode: 829209, min_days: 2, max_days: 3 },
{ pincode: 829210, min_days: 2, max_days: 3 },
{ pincode: 829301, min_days: 2, max_days: 3 },
{ pincode: 831001, min_days: 2, max_days: 3 },
{ pincode: 831002, min_days: 2, max_days: 3 },
{ pincode: 831003, min_days: 2, max_days: 3 },
{ pincode: 831004, min_days: 2, max_days: 3 },
{ pincode: 831005, min_days: 2, max_days: 3 },
{ pincode: 831006, min_days: 2, max_days: 3 },
{ pincode: 831007, min_days: 2, max_days: 3 },
{ pincode: 831008, min_days: 2, max_days: 3 },
{ pincode: 831009, min_days: 2, max_days: 3 },
{ pincode: 831010, min_days: 2, max_days: 3 },
{ pincode: 831011, min_days: 2, max_days: 3 },
{ pincode: 831012, min_days: 2, max_days: 3 },
{ pincode: 831013, min_days: 2, max_days: 3 },
{ pincode: 831014, min_days: 2, max_days: 3 },
{ pincode: 831015, min_days: 2, max_days: 3 },
{ pincode: 831016, min_days: 2, max_days: 3 },
{ pincode: 831017, min_days: 2, max_days: 3 },
{ pincode: 831018, min_days: 2, max_days: 3 },
{ pincode: 831019, min_days: 2, max_days: 3 },
{ pincode: 831020, min_days: 2, max_days: 3 },
{ pincode: 831021, min_days: 2, max_days: 3 },
{ pincode: 831035, min_days: 2, max_days: 3 },
{ pincode: 831107, min_days: 2, max_days: 3 },
{ pincode: 831109, min_days: 2, max_days: 3 },
{ pincode: 831110, min_days: 2, max_days: 3 },
{ pincode: 832101, min_days: 2, max_days: 3 },
{ pincode: 832102, min_days: 2, max_days: 3 },
{ pincode: 832103, min_days: 2, max_days: 3 },
{ pincode: 832104, min_days: 2, max_days: 3 },
{ pincode: 832105, min_days: 2, max_days: 3 },
{ pincode: 832106, min_days: 2, max_days: 3 },
{ pincode: 832107, min_days: 2, max_days: 3 },
{ pincode: 832108, min_days: 2, max_days: 3 },
{ pincode: 832109, min_days: 2, max_days: 3 },
{ pincode: 832110, min_days: 2, max_days: 3 },
{ pincode: 832111, min_days: 2, max_days: 3 },
{ pincode: 832112, min_days: 2, max_days: 3 },
{ pincode: 832113, min_days: 2, max_days: 3 },
{ pincode: 832119, min_days: 2, max_days: 3 },
{ pincode: 832301, min_days: 2, max_days: 3 },
{ pincode: 832302, min_days: 2, max_days: 3 },
{ pincode: 832303, min_days: 2, max_days: 3 },
{ pincode: 832304, min_days: 2, max_days: 3 },
{ pincode: 832401, min_days: 2, max_days: 3 },
{ pincode: 832402, min_days: 2, max_days: 3 },
{ pincode: 832403, min_days: 2, max_days: 3 },
{ pincode: 832404, min_days: 2, max_days: 3 },
{ pincode: 833101, min_days: 2, max_days: 3 },
{ pincode: 833102, min_days: 2, max_days: 3 },
{ pincode: 833103, min_days: 2, max_days: 3 },
{ pincode: 833104, min_days: 2, max_days: 3 },
{ pincode: 833105, min_days: 2, max_days: 3 },
{ pincode: 833106, min_days: 2, max_days: 3 },
{ pincode: 833201, min_days: 2, max_days: 3 },
{ pincode: 833202, min_days: 2, max_days: 3 },
{ pincode: 833203, min_days: 2, max_days: 3 },
{ pincode: 833204, min_days: 2, max_days: 3 },
{ pincode: 833212, min_days: 2, max_days: 3 },
{ pincode: 833213, min_days: 2, max_days: 3 },
{ pincode: 833214, min_days: 2, max_days: 3 },
{ pincode: 833215, min_days: 2, max_days: 3 },
{ pincode: 833216, min_days: 2, max_days: 3 },
{ pincode: 833217, min_days: 2, max_days: 3 },
{ pincode: 833218, min_days: 2, max_days: 3 },
{ pincode: 833219, min_days: 2, max_days: 3 },
{ pincode: 833220, min_days: 2, max_days: 3 },
{ pincode: 833221, min_days: 2, max_days: 3 },
{ pincode: 833222, min_days: 2, max_days: 3 },
{ pincode: 833223, min_days: 2, max_days: 3 },
{ pincode: 834001, min_days: 2, max_days: 3 },
{ pincode: 834002, min_days: 2, max_days: 3 },
{ pincode: 834003, min_days: 2, max_days: 3 },
{ pincode: 834004, min_days: 2, max_days: 3 },
{ pincode: 834005, min_days: 2, max_days: 3 },
{ pincode: 834006, min_days: 2, max_days: 3 },
{ pincode: 834007, min_days: 2, max_days: 3 },
{ pincode: 834008, min_days: 2, max_days: 3 },
{ pincode: 834009, min_days: 2, max_days: 3 },
{ pincode: 834010, min_days: 2, max_days: 3 },
{ pincode: 834011, min_days: 2, max_days: 3 },
{ pincode: 834012, min_days: 2, max_days: 3 },
{ pincode: 834013, min_days: 2, max_days: 3 },
{ pincode: 834014, min_days: 2, max_days: 3 },
{ pincode: 835101, min_days: 2, max_days: 3 },
{ pincode: 835102, min_days: 2, max_days: 3 },
{ pincode: 835103, min_days: 2, max_days: 3 },
{ pincode: 835201, min_days: 2, max_days: 3 },
{ pincode: 835202, min_days: 2, max_days: 3 },
{ pincode: 835203, min_days: 2, max_days: 3 },
{ pincode: 835204, min_days: 2, max_days: 3 },
{ pincode: 835205, min_days: 2, max_days: 3 },
{ pincode: 835206, min_days: 2, max_days: 3 },
{ pincode: 835207, min_days: 2, max_days: 3 },
{ pincode: 835208, min_days: 2, max_days: 3 },
{ pincode: 835209, min_days: 2, max_days: 3 },
{ pincode: 835210, min_days: 2, max_days: 3 },
{ pincode: 835211, min_days: 2, max_days: 3 },
{ pincode: 835212, min_days: 2, max_days: 3 },
{ pincode: 835213, min_days: 2, max_days: 3 },
{ pincode: 835214, min_days: 2, max_days: 3 },
{ pincode: 835215, min_days: 2, max_days: 3 },
{ pincode: 835216, min_days: 2, max_days: 3 },
{ pincode: 835217, min_days: 2, max_days: 3 },
{ pincode: 835218, min_days: 2, max_days: 3 },
{ pincode: 835219, min_days: 2, max_days: 3 },
{ pincode: 835220, min_days: 2, max_days: 3 },
{ pincode: 835221, min_days: 2, max_days: 3 },
{ pincode: 835222, min_days: 2, max_days: 3 },
{ pincode: 835223, min_days: 2, max_days: 3 },
{ pincode: 835224, min_days: 2, max_days: 3 },
{ pincode: 835225, min_days: 2, max_days: 3 },
{ pincode: 835226, min_days: 2, max_days: 3 },
{ pincode: 835227, min_days: 2, max_days: 3 },
{ pincode: 835228, min_days: 2, max_days: 3 },
{ pincode: 835229, min_days: 2, max_days: 3 },
{ pincode: 835230, min_days: 2, max_days: 3 },
{ pincode: 835231, min_days: 2, max_days: 3 },
{ pincode: 835232, min_days: 2, max_days: 3 },
{ pincode: 835233, min_days: 2, max_days: 3 },
{ pincode: 835234, min_days: 2, max_days: 3 },
{ pincode: 835235, min_days: 2, max_days: 3 },
{ pincode: 835238, min_days: 2, max_days: 3 },
{ pincode: 835240, min_days: 2, max_days: 3 },
{ pincode: 835244, min_days: 2, max_days: 3 },
{ pincode: 835301, min_days: 2, max_days: 3 },
{ pincode: 835302, min_days: 2, max_days: 3 },
{ pincode: 835303, min_days: 2, max_days: 3 },
{ pincode: 835304, min_days: 2, max_days: 3 },
{ pincode: 835305, min_days: 2, max_days: 3 },
{ pincode: 835306, min_days: 2, max_days: 3 },
{ pincode: 835324, min_days: 2, max_days: 3 },
{ pincode: 835325, min_days: 2, max_days: 3 },
{ pincode: 838303, min_days: 2, max_days: 3 },
{ pincode: 840001, min_days: 2, max_days: 3 },
{ pincode: 841101, min_days: 2, max_days: 3 },
{ pincode: 841201, min_days: 2, max_days: 3 },
{ pincode: 841202, min_days: 2, max_days: 3 },
{ pincode: 841203, min_days: 2, max_days: 3 },
{ pincode: 841204, min_days: 2, max_days: 3 },
{ pincode: 841205, min_days: 2, max_days: 3 },
{ pincode: 841206, min_days: 2, max_days: 3 },
{ pincode: 841207, min_days: 2, max_days: 3 },
{ pincode: 841208, min_days: 2, max_days: 3 },
{ pincode: 841209, min_days: 2, max_days: 3 },
{ pincode: 841210, min_days: 2, max_days: 3 },
{ pincode: 841211, min_days: 2, max_days: 3 },
{ pincode: 841212, min_days: 2, max_days: 3 },
{ pincode: 841213, min_days: 2, max_days: 3 },
{ pincode: 841214, min_days: 2, max_days: 3 },
{ pincode: 841215, min_days: 2, max_days: 3 },
{ pincode: 841216, min_days: 2, max_days: 3 },
{ pincode: 841217, min_days: 2, max_days: 3 },
{ pincode: 841218, min_days: 2, max_days: 3 },
{ pincode: 841219, min_days: 2, max_days: 3 },
{ pincode: 841220, min_days: 2, max_days: 3 },
{ pincode: 841221, min_days: 2, max_days: 3 },
{ pincode: 841222, min_days: 2, max_days: 3 },
{ pincode: 841223, min_days: 2, max_days: 3 },
{ pincode: 841224, min_days: 2, max_days: 3 },
{ pincode: 841225, min_days: 2, max_days: 3 },
{ pincode: 841226, min_days: 2, max_days: 3 },
{ pincode: 841227, min_days: 2, max_days: 3 },
{ pincode: 841228, min_days: 2, max_days: 3 },
{ pincode: 841231, min_days: 2, max_days: 3 },
{ pincode: 841232, min_days: 2, max_days: 3 },
{ pincode: 841233, min_days: 2, max_days: 3 },
{ pincode: 841234, min_days: 2, max_days: 3 },
{ pincode: 841235, min_days: 2, max_days: 3 },
{ pincode: 841236, min_days: 2, max_days: 3 },
{ pincode: 841237, min_days: 2, max_days: 3 },
{ pincode: 841238, min_days: 2, max_days: 3 },
{ pincode: 841239, min_days: 2, max_days: 3 },
{ pincode: 841240, min_days: 2, max_days: 3 },
{ pincode: 841241, min_days: 2, max_days: 3 },
{ pincode: 841242, min_days: 2, max_days: 3 },
{ pincode: 841243, min_days: 2, max_days: 3 },
{ pincode: 841244, min_days: 2, max_days: 3 },
{ pincode: 841245, min_days: 2, max_days: 3 },
{ pincode: 841247, min_days: 2, max_days: 3 },
{ pincode: 841251, min_days: 2, max_days: 3 },
{ pincode: 841252, min_days: 2, max_days: 3 },
{ pincode: 841286, min_days: 2, max_days: 3 },
{ pincode: 841287, min_days: 2, max_days: 3 },
{ pincode: 841301, min_days: 2, max_days: 3 },
{ pincode: 841302, min_days: 2, max_days: 3 },
{ pincode: 841305, min_days: 2, max_days: 3 },
{ pincode: 841311, min_days: 2, max_days: 3 },
{ pincode: 841312, min_days: 2, max_days: 3 },
{ pincode: 841313, min_days: 2, max_days: 3 },
{ pincode: 841316, min_days: 2, max_days: 3 },
{ pincode: 841401, min_days: 2, max_days: 3 },
{ pincode: 841402, min_days: 2, max_days: 3 },
{ pincode: 841403, min_days: 2, max_days: 3 },
{ pincode: 841404, min_days: 2, max_days: 3 },
{ pincode: 841405, min_days: 2, max_days: 3 },
{ pincode: 841406, min_days: 2, max_days: 3 },
{ pincode: 841407, min_days: 2, max_days: 3 },
{ pincode: 841408, min_days: 2, max_days: 3 },
{ pincode: 841409, min_days: 2, max_days: 3 },
{ pincode: 841410, min_days: 2, max_days: 3 },
{ pincode: 841411, min_days: 2, max_days: 3 },
{ pincode: 841412, min_days: 2, max_days: 3 },
{ pincode: 841413, min_days: 2, max_days: 3 },
{ pincode: 841414, min_days: 2, max_days: 3 },
{ pincode: 841415, min_days: 2, max_days: 3 },
{ pincode: 841416, min_days: 2, max_days: 3 },
{ pincode: 841417, min_days: 2, max_days: 3 },
{ pincode: 841418, min_days: 2, max_days: 3 },
{ pincode: 841419, min_days: 2, max_days: 3 },
{ pincode: 841420, min_days: 2, max_days: 3 },
{ pincode: 841421, min_days: 2, max_days: 3 },
{ pincode: 841422, min_days: 2, max_days: 3 },
{ pincode: 841423, min_days: 2, max_days: 3 },
{ pincode: 841424, min_days: 2, max_days: 3 },
{ pincode: 841425, min_days: 2, max_days: 3 },
{ pincode: 841426, min_days: 2, max_days: 3 },
{ pincode: 841427, min_days: 2, max_days: 3 },
{ pincode: 841428, min_days: 2, max_days: 3 },
{ pincode: 841432, min_days: 2, max_days: 3 },
{ pincode: 841433, min_days: 2, max_days: 3 },
{ pincode: 841434, min_days: 2, max_days: 3 },
{ pincode: 841435, min_days: 2, max_days: 3 },
{ pincode: 841436, min_days: 2, max_days: 3 },
{ pincode: 841437, min_days: 2, max_days: 3 },
{ pincode: 841438, min_days: 2, max_days: 3 },
{ pincode: 841439, min_days: 2, max_days: 3 },
{ pincode: 841440, min_days: 2, max_days: 3 },
{ pincode: 841441, min_days: 2, max_days: 3 },
{ pincode: 841442, min_days: 2, max_days: 3 },
{ pincode: 841443, min_days: 2, max_days: 3 },
{ pincode: 841446, min_days: 2, max_days: 3 },
{ pincode: 841447, min_days: 2, max_days: 3 },
{ pincode: 841460, min_days: 2, max_days: 3 },
{ pincode: 841501, min_days: 2, max_days: 3 },
{ pincode: 841502, min_days: 2, max_days: 3 },
{ pincode: 841503, min_days: 2, max_days: 3 },
{ pincode: 841504, min_days: 2, max_days: 3 },
{ pincode: 841505, min_days: 2, max_days: 3 },
{ pincode: 841506, min_days: 2, max_days: 3 },
{ pincode: 841507, min_days: 2, max_days: 3 },
{ pincode: 841508, min_days: 2, max_days: 3 },
{ pincode: 841509, min_days: 2, max_days: 3 },
{ pincode: 842001, min_days: 2, max_days: 3 },
{ pincode: 842002, min_days: 2, max_days: 3 },
{ pincode: 842003, min_days: 2, max_days: 3 },
{ pincode: 842004, min_days: 2, max_days: 3 },
{ pincode: 842005, min_days: 2, max_days: 3 },
{ pincode: 842006, min_days: 2, max_days: 3 },
{ pincode: 842008, min_days: 2, max_days: 3 },
{ pincode: 842101, min_days: 2, max_days: 3 },
{ pincode: 843031, min_days: 2, max_days: 3 },
{ pincode: 843101, min_days: 2, max_days: 3 },
{ pincode: 843102, min_days: 2, max_days: 3 },
{ pincode: 843103, min_days: 2, max_days: 3 },
{ pincode: 843104, min_days: 2, max_days: 3 },
{ pincode: 843105, min_days: 2, max_days: 3 },
{ pincode: 843106, min_days: 2, max_days: 3 },
{ pincode: 843107, min_days: 2, max_days: 3 },
{ pincode: 843108, min_days: 2, max_days: 3 },
{ pincode: 843109, min_days: 2, max_days: 3 },
{ pincode: 843110, min_days: 2, max_days: 3 },
{ pincode: 843111, min_days: 2, max_days: 3 },
{ pincode: 843112, min_days: 2, max_days: 3 },
{ pincode: 843113, min_days: 2, max_days: 3 },
{ pincode: 843114, min_days: 2, max_days: 3 },
{ pincode: 843115, min_days: 2, max_days: 3 },
{ pincode: 843116, min_days: 2, max_days: 3 },
{ pincode: 843117, min_days: 2, max_days: 3 },
{ pincode: 843118, min_days: 2, max_days: 3 },
{ pincode: 843119, min_days: 2, max_days: 3 },
{ pincode: 843120, min_days: 2, max_days: 3 },
{ pincode: 843121, min_days: 2, max_days: 3 },
{ pincode: 843122, min_days: 2, max_days: 3 },
{ pincode: 843123, min_days: 2, max_days: 3 },
{ pincode: 843124, min_days: 2, max_days: 3 },
{ pincode: 843125, min_days: 2, max_days: 3 },
{ pincode: 843126, min_days: 2, max_days: 3 },
{ pincode: 843127, min_days: 2, max_days: 3 },
{ pincode: 843128, min_days: 2, max_days: 3 },
{ pincode: 843129, min_days: 2, max_days: 3 },
{ pincode: 843130, min_days: 2, max_days: 3 },
{ pincode: 843131, min_days: 2, max_days: 3 },
{ pincode: 843132, min_days: 2, max_days: 3 },
{ pincode: 843133, min_days: 2, max_days: 3 },
{ pincode: 843134, min_days: 2, max_days: 3 },
{ pincode: 843138, min_days: 2, max_days: 3 },
{ pincode: 843139, min_days: 2, max_days: 3 },
{ pincode: 843141, min_days: 2, max_days: 3 },
{ pincode: 843142, min_days: 2, max_days: 3 },
{ pincode: 843143, min_days: 2, max_days: 3 },
{ pincode: 843144, min_days: 2, max_days: 3 },
{ pincode: 843145, min_days: 2, max_days: 3 },
{ pincode: 843146, min_days: 2, max_days: 3 },
{ pincode: 843147, min_days: 2, max_days: 3 },
{ pincode: 843152, min_days: 2, max_days: 3 },
{ pincode: 843153, min_days: 2, max_days: 3 },
{ pincode: 843161, min_days: 2, max_days: 3 },
{ pincode: 843162, min_days: 2, max_days: 3 },
{ pincode: 843165, min_days: 2, max_days: 3 },
{ pincode: 843301, min_days: 2, max_days: 3 },
{ pincode: 843302, min_days: 2, max_days: 3 },
{ pincode: 843311, min_days: 2, max_days: 3 },
{ pincode: 843312, min_days: 2, max_days: 3 },
{ pincode: 843313, min_days: 2, max_days: 3 },
{ pincode: 843314, min_days: 2, max_days: 3 },
{ pincode: 843315, min_days: 2, max_days: 3 },
{ pincode: 843316, min_days: 2, max_days: 3 },
{ pincode: 843317, min_days: 2, max_days: 3 },
{ pincode: 843318, min_days: 2, max_days: 3 },
{ pincode: 843319, min_days: 2, max_days: 3 },
{ pincode: 843320, min_days: 2, max_days: 3 },
{ pincode: 843321, min_days: 2, max_days: 3 },
{ pincode: 843322, min_days: 2, max_days: 3 },
{ pincode: 843323, min_days: 2, max_days: 3 },
{ pincode: 843324, min_days: 2, max_days: 3 },
{ pincode: 843325, min_days: 2, max_days: 3 },
{ pincode: 843326, min_days: 2, max_days: 3 },
{ pincode: 843327, min_days: 2, max_days: 3 },
{ pincode: 843328, min_days: 2, max_days: 3 },
{ pincode: 843329, min_days: 2, max_days: 3 },
{ pincode: 843330, min_days: 2, max_days: 3 },
{ pincode: 843331, min_days: 2, max_days: 3 },
{ pincode: 843332, min_days: 2, max_days: 3 },
{ pincode: 843333, min_days: 2, max_days: 3 },
{ pincode: 843334, min_days: 2, max_days: 3 },
{ pincode: 843335, min_days: 2, max_days: 3 },
{ pincode: 843337, min_days: 2, max_days: 3 },
{ pincode: 843349, min_days: 2, max_days: 3 },
{ pincode: 843350, min_days: 2, max_days: 3 },
{ pincode: 843351, min_days: 2, max_days: 3 },
{ pincode: 843352, min_days: 2, max_days: 3 },
{ pincode: 843360, min_days: 2, max_days: 3 },
{ pincode: 843361, min_days: 2, max_days: 3 },
{ pincode: 844101, min_days: 2, max_days: 3 },
{ pincode: 844102, min_days: 2, max_days: 3 },
{ pincode: 844103, min_days: 2, max_days: 3 },
{ pincode: 844111, min_days: 2, max_days: 3 },
{ pincode: 844112, min_days: 2, max_days: 3 },
{ pincode: 844113, min_days: 2, max_days: 3 },
{ pincode: 844114, min_days: 2, max_days: 3 },
{ pincode: 844115, min_days: 2, max_days: 3 },
{ pincode: 844116, min_days: 2, max_days: 3 },
{ pincode: 844117, min_days: 2, max_days: 3 },
{ pincode: 844118, min_days: 2, max_days: 3 },
{ pincode: 844119, min_days: 2, max_days: 3 },
{ pincode: 844120, min_days: 2, max_days: 3 },
{ pincode: 844121, min_days: 2, max_days: 3 },
{ pincode: 844122, min_days: 2, max_days: 3 },
{ pincode: 844123, min_days: 2, max_days: 3 },
{ pincode: 844124, min_days: 2, max_days: 3 },
{ pincode: 844125, min_days: 2, max_days: 3 },
{ pincode: 844126, min_days: 2, max_days: 3 },
{ pincode: 844127, min_days: 2, max_days: 3 },
{ pincode: 844128, min_days: 2, max_days: 3 },
{ pincode: 844129, min_days: 2, max_days: 3 },
{ pincode: 844131, min_days: 2, max_days: 3 },
{ pincode: 844133, min_days: 2, max_days: 3 },
{ pincode: 844134, min_days: 2, max_days: 3 },
{ pincode: 844139, min_days: 2, max_days: 3 },
{ pincode: 844141, min_days: 2, max_days: 3 },
{ pincode: 844501, min_days: 2, max_days: 3 },
{ pincode: 844502, min_days: 2, max_days: 3 },
{ pincode: 844503, min_days: 2, max_days: 3 },
{ pincode: 844504, min_days: 2, max_days: 3 },
{ pincode: 844505, min_days: 2, max_days: 3 },
{ pincode: 844506, min_days: 2, max_days: 3 },
{ pincode: 844507, min_days: 2, max_days: 3 },
{ pincode: 844508, min_days: 2, max_days: 3 },
{ pincode: 844509, min_days: 2, max_days: 3 },
{ pincode: 845101, min_days: 2, max_days: 3 },
{ pincode: 845102, min_days: 2, max_days: 3 },
{ pincode: 845103, min_days: 2, max_days: 3 },
{ pincode: 845104, min_days: 2, max_days: 3 },
{ pincode: 845105, min_days: 2, max_days: 3 },
{ pincode: 845106, min_days: 2, max_days: 3 },
{ pincode: 845107, min_days: 2, max_days: 3 },
{ pincode: 845301, min_days: 2, max_days: 3 },
{ pincode: 845302, min_days: 2, max_days: 3 },
{ pincode: 845303, min_days: 2, max_days: 3 },
{ pincode: 845304, min_days: 2, max_days: 3 },
{ pincode: 845305, min_days: 2, max_days: 3 },
{ pincode: 845306, min_days: 2, max_days: 3 },
{ pincode: 845307, min_days: 2, max_days: 3 },
{ pincode: 845311, min_days: 2, max_days: 3 },
{ pincode: 845315, min_days: 2, max_days: 3 },
{ pincode: 845318, min_days: 2, max_days: 3 },
{ pincode: 845401, min_days: 2, max_days: 3 },
{ pincode: 845402, min_days: 2, max_days: 3 },
{ pincode: 845405, min_days: 2, max_days: 3 },
{ pincode: 845406, min_days: 2, max_days: 3 },
{ pincode: 845408, min_days: 2, max_days: 3 },
{ pincode: 845411, min_days: 2, max_days: 3 },
{ pincode: 845412, min_days: 2, max_days: 3 },
{ pincode: 845413, min_days: 2, max_days: 3 },
{ pincode: 845414, min_days: 2, max_days: 3 },
{ pincode: 845415, min_days: 2, max_days: 3 },
{ pincode: 845416, min_days: 2, max_days: 3 },
{ pincode: 845417, min_days: 2, max_days: 3 },
{ pincode: 845418, min_days: 2, max_days: 3 },
{ pincode: 845419, min_days: 2, max_days: 3 },
{ pincode: 845420, min_days: 2, max_days: 3 },
{ pincode: 845422, min_days: 2, max_days: 3 },
{ pincode: 845423, min_days: 2, max_days: 3 },
{ pincode: 845424, min_days: 2, max_days: 3 },
{ pincode: 845425, min_days: 2, max_days: 3 },
{ pincode: 845426, min_days: 2, max_days: 3 },
{ pincode: 845427, min_days: 2, max_days: 3 },
{ pincode: 845428, min_days: 2, max_days: 3 },
{ pincode: 845429, min_days: 2, max_days: 3 },
{ pincode: 845430, min_days: 2, max_days: 3 },
{ pincode: 845431, min_days: 2, max_days: 3 },
{ pincode: 845432, min_days: 2, max_days: 3 },
{ pincode: 845433, min_days: 2, max_days: 3 },
{ pincode: 845434, min_days: 2, max_days: 3 },
{ pincode: 845435, min_days: 2, max_days: 3 },
{ pincode: 845436, min_days: 2, max_days: 3 },
{ pincode: 845437, min_days: 2, max_days: 3 },
{ pincode: 845438, min_days: 2, max_days: 3 },
{ pincode: 845439, min_days: 2, max_days: 3 },
{ pincode: 845440, min_days: 2, max_days: 3 },
{ pincode: 845449, min_days: 2, max_days: 3 },
{ pincode: 845450, min_days: 2, max_days: 3 },
{ pincode: 845451, min_days: 2, max_days: 3 },
{ pincode: 845452, min_days: 2, max_days: 3 },
{ pincode: 845453, min_days: 2, max_days: 3 },
{ pincode: 845454, min_days: 2, max_days: 3 },
{ pincode: 845455, min_days: 2, max_days: 3 },
{ pincode: 845456, min_days: 2, max_days: 3 },
{ pincode: 845457, min_days: 2, max_days: 3 },
{ pincode: 845458, min_days: 2, max_days: 3 },
{ pincode: 845459, min_days: 2, max_days: 3 },
{ pincode: 845460, min_days: 2, max_days: 3 },
{ pincode: 845468, min_days: 2, max_days: 3 },
{ pincode: 845487, min_days: 2, max_days: 3 },
{ pincode: 845501, min_days: 2, max_days: 3 },
{ pincode: 845519, min_days: 2, max_days: 3 },
{ pincode: 845522, min_days: 2, max_days: 3 },
{ pincode: 846001, min_days: 2, max_days: 3 },
{ pincode: 846002, min_days: 2, max_days: 3 },
{ pincode: 846003, min_days: 2, max_days: 3 },
{ pincode: 846004, min_days: 2, max_days: 3 },
{ pincode: 846005, min_days: 2, max_days: 3 },
{ pincode: 846006, min_days: 2, max_days: 3 },
{ pincode: 846007, min_days: 2, max_days: 3 },
{ pincode: 846008, min_days: 2, max_days: 3 },
{ pincode: 846009, min_days: 2, max_days: 3 },
{ pincode: 846010, min_days: 2, max_days: 3 },
{ pincode: 847101, min_days: 2, max_days: 3 },
{ pincode: 847102, min_days: 2, max_days: 3 },
{ pincode: 847103, min_days: 2, max_days: 3 },
{ pincode: 847104, min_days: 2, max_days: 3 },
{ pincode: 847105, min_days: 2, max_days: 3 },
{ pincode: 847106, min_days: 2, max_days: 3 },
{ pincode: 847107, min_days: 2, max_days: 3 },
{ pincode: 847108, min_days: 2, max_days: 3 },
{ pincode: 847109, min_days: 2, max_days: 3 },
{ pincode: 847112, min_days: 2, max_days: 3 },
{ pincode: 847115, min_days: 2, max_days: 3 },
{ pincode: 847119, min_days: 2, max_days: 3 },
{ pincode: 847120, min_days: 2, max_days: 3 },
{ pincode: 847121, min_days: 2, max_days: 3 },
{ pincode: 847122, min_days: 2, max_days: 3 },
{ pincode: 847123, min_days: 2, max_days: 3 },
{ pincode: 847124, min_days: 2, max_days: 3 },
{ pincode: 847201, min_days: 2, max_days: 3 },
{ pincode: 847202, min_days: 2, max_days: 3 },
{ pincode: 847203, min_days: 2, max_days: 3 },
{ pincode: 847204, min_days: 2, max_days: 3 },
{ pincode: 847211, min_days: 2, max_days: 3 },
{ pincode: 847212, min_days: 2, max_days: 3 },
{ pincode: 847213, min_days: 2, max_days: 3 },
{ pincode: 847214, min_days: 2, max_days: 3 },
{ pincode: 847215, min_days: 2, max_days: 3 },
{ pincode: 847222, min_days: 2, max_days: 3 },
{ pincode: 847223, min_days: 2, max_days: 3 },
{ pincode: 847224, min_days: 2, max_days: 3 },
{ pincode: 847225, min_days: 2, max_days: 3 },
{ pincode: 847226, min_days: 2, max_days: 3 },
{ pincode: 847227, min_days: 2, max_days: 3 },
{ pincode: 847228, min_days: 2, max_days: 3 },
{ pincode: 847229, min_days: 2, max_days: 3 },
{ pincode: 847230, min_days: 2, max_days: 3 },
{ pincode: 847231, min_days: 2, max_days: 3 },
{ pincode: 847232, min_days: 2, max_days: 3 },
{ pincode: 847233, min_days: 2, max_days: 3 },
{ pincode: 847234, min_days: 2, max_days: 3 },
{ pincode: 847235, min_days: 2, max_days: 3 },
{ pincode: 847236, min_days: 2, max_days: 3 },
{ pincode: 847237, min_days: 2, max_days: 3 },
{ pincode: 847238, min_days: 2, max_days: 3 },
{ pincode: 847239, min_days: 2, max_days: 3 },
{ pincode: 847240, min_days: 2, max_days: 3 },
{ pincode: 847301, min_days: 2, max_days: 3 },
{ pincode: 847302, min_days: 2, max_days: 3 },
{ pincode: 847303, min_days: 2, max_days: 3 },
{ pincode: 847304, min_days: 2, max_days: 3 },
{ pincode: 847305, min_days: 2, max_days: 3 },
{ pincode: 847306, min_days: 2, max_days: 3 },
{ pincode: 847307, min_days: 2, max_days: 3 },
{ pincode: 847308, min_days: 2, max_days: 3 },
{ pincode: 847309, min_days: 2, max_days: 3 },
{ pincode: 847311, min_days: 2, max_days: 3 },
{ pincode: 847313, min_days: 2, max_days: 3 },
{ pincode: 847337, min_days: 2, max_days: 3 },
{ pincode: 847401, min_days: 2, max_days: 3 },
{ pincode: 847402, min_days: 2, max_days: 3 },
{ pincode: 847403, min_days: 2, max_days: 3 },
{ pincode: 847404, min_days: 2, max_days: 3 },
{ pincode: 847405, min_days: 2, max_days: 3 },
{ pincode: 847407, min_days: 2, max_days: 3 },
{ pincode: 847408, min_days: 2, max_days: 3 },
{ pincode: 847409, min_days: 2, max_days: 3 },
{ pincode: 847410, min_days: 2, max_days: 3 },
{ pincode: 847411, min_days: 2, max_days: 3 },
{ pincode: 847412, min_days: 2, max_days: 3 },
{ pincode: 847421, min_days: 2, max_days: 3 },
{ pincode: 847422, min_days: 2, max_days: 3 },
{ pincode: 847423, min_days: 2, max_days: 3 },
{ pincode: 847424, min_days: 2, max_days: 3 },
{ pincode: 847425, min_days: 2, max_days: 3 },
{ pincode: 847426, min_days: 2, max_days: 3 },
{ pincode: 847427, min_days: 2, max_days: 3 },
{ pincode: 847428, min_days: 2, max_days: 3 },
{ pincode: 847429, min_days: 2, max_days: 3 },
{ pincode: 847451, min_days: 2, max_days: 3 },
{ pincode: 847452, min_days: 2, max_days: 3 },
{ pincode: 848101, min_days: 2, max_days: 3 },
{ pincode: 848102, min_days: 2, max_days: 3 },
{ pincode: 848103, min_days: 2, max_days: 3 },
{ pincode: 848104, min_days: 2, max_days: 3 },
{ pincode: 848109, min_days: 2, max_days: 3 },
{ pincode: 848110, min_days: 2, max_days: 3 },
{ pincode: 848112, min_days: 2, max_days: 3 },
{ pincode: 848113, min_days: 2, max_days: 3 },
{ pincode: 848114, min_days: 2, max_days: 3 },
{ pincode: 848115, min_days: 2, max_days: 3 },
{ pincode: 848116, min_days: 2, max_days: 3 },
{ pincode: 848117, min_days: 2, max_days: 3 },
{ pincode: 848118, min_days: 2, max_days: 3 },
{ pincode: 848121, min_days: 2, max_days: 3 },
{ pincode: 848122, min_days: 2, max_days: 3 },
{ pincode: 848125, min_days: 2, max_days: 3 },
{ pincode: 848127, min_days: 2, max_days: 3 },
{ pincode: 848129, min_days: 2, max_days: 3 },
{ pincode: 848130, min_days: 2, max_days: 3 },
{ pincode: 848131, min_days: 2, max_days: 3 },
{ pincode: 848132, min_days: 2, max_days: 3 },
{ pincode: 848133, min_days: 2, max_days: 3 },
{ pincode: 848134, min_days: 2, max_days: 3 },
{ pincode: 848135, min_days: 2, max_days: 3 },
{ pincode: 848138, min_days: 2, max_days: 3 },
{ pincode: 848142, min_days: 2, max_days: 3 },
{ pincode: 848160, min_days: 2, max_days: 3 },
{ pincode: 848201, min_days: 2, max_days: 3 },
{ pincode: 848202, min_days: 2, max_days: 3 },
{ pincode: 848203, min_days: 2, max_days: 3 },
{ pincode: 848204, min_days: 2, max_days: 3 },
{ pincode: 848205, min_days: 2, max_days: 3 },
{ pincode: 848206, min_days: 2, max_days: 3 },
{ pincode: 848207, min_days: 2, max_days: 3 },
{ pincode: 848208, min_days: 2, max_days: 3 },
{ pincode: 848209, min_days: 2, max_days: 3 },
{ pincode: 848210, min_days: 2, max_days: 3 },
{ pincode: 848211, min_days: 2, max_days: 3 },
{ pincode: 848213, min_days: 2, max_days: 3 },
{ pincode: 848216, min_days: 2, max_days: 3 },
{ pincode: 848218, min_days: 2, max_days: 3 },
{ pincode: 848220, min_days: 2, max_days: 3 },
{ pincode: 848236, min_days: 2, max_days: 3 },
{ pincode: 848237, min_days: 2, max_days: 3 },
{ pincode: 848301, min_days: 2, max_days: 3 },
{ pincode: 848302, min_days: 2, max_days: 3 },
{ pincode: 848303, min_days: 2, max_days: 3 },
{ pincode: 848501, min_days: 2, max_days: 3 },
{ pincode: 848502, min_days: 2, max_days: 3 },
{ pincode: 848503, min_days: 2, max_days: 3 },
{ pincode: 848504, min_days: 2, max_days: 3 },
{ pincode: 848505, min_days: 2, max_days: 3 },
{ pincode: 848506, min_days: 2, max_days: 3 },
{ pincode: 848507, min_days: 2, max_days: 3 },
{ pincode: 848511, min_days: 2, max_days: 3 },
{ pincode: 848516, min_days: 2, max_days: 3 },
{ pincode: 851101, min_days: 2, max_days: 3 },
{ pincode: 851102, min_days: 2, max_days: 3 },
{ pincode: 851110, min_days: 2, max_days: 3 },
{ pincode: 851111, min_days: 2, max_days: 3 },
{ pincode: 851112, min_days: 2, max_days: 3 },
{ pincode: 851113, min_days: 2, max_days: 3 },
{ pincode: 851114, min_days: 2, max_days: 3 },
{ pincode: 851115, min_days: 2, max_days: 3 },
{ pincode: 851116, min_days: 2, max_days: 3 },
{ pincode: 851117, min_days: 2, max_days: 3 },
{ pincode: 851118, min_days: 2, max_days: 3 },
{ pincode: 851119, min_days: 2, max_days: 3 },
{ pincode: 851120, min_days: 2, max_days: 3 },
{ pincode: 851121, min_days: 2, max_days: 3 },
{ pincode: 851122, min_days: 2, max_days: 3 },
{ pincode: 851126, min_days: 2, max_days: 3 },
{ pincode: 851127, min_days: 2, max_days: 3 },
{ pincode: 851128, min_days: 2, max_days: 3 },
{ pincode: 851129, min_days: 2, max_days: 3 },
{ pincode: 851130, min_days: 2, max_days: 3 },
{ pincode: 851131, min_days: 2, max_days: 3 },
{ pincode: 851132, min_days: 2, max_days: 3 },
{ pincode: 851133, min_days: 2, max_days: 3 },
{ pincode: 851134, min_days: 2, max_days: 3 },
{ pincode: 851135, min_days: 2, max_days: 3 },
{ pincode: 851139, min_days: 2, max_days: 3 },
{ pincode: 851201, min_days: 2, max_days: 3 },
{ pincode: 851202, min_days: 2, max_days: 3 },
{ pincode: 851203, min_days: 2, max_days: 3 },
{ pincode: 851204, min_days: 2, max_days: 3 },
{ pincode: 851205, min_days: 2, max_days: 3 },
{ pincode: 851206, min_days: 2, max_days: 3 },
{ pincode: 851210, min_days: 2, max_days: 3 },
{ pincode: 851211, min_days: 2, max_days: 3 },
{ pincode: 851212, min_days: 2, max_days: 3 },
{ pincode: 851213, min_days: 2, max_days: 3 },
{ pincode: 851214, min_days: 2, max_days: 3 },
{ pincode: 851215, min_days: 2, max_days: 3 },
{ pincode: 851216, min_days: 2, max_days: 3 },
{ pincode: 851217, min_days: 2, max_days: 3 },
{ pincode: 851218, min_days: 2, max_days: 3 },
{ pincode: 851219, min_days: 2, max_days: 3 },
{ pincode: 851220, min_days: 2, max_days: 3 },
{ pincode: 851221, min_days: 2, max_days: 3 },
{ pincode: 851225, min_days: 2, max_days: 3 },
{ pincode: 852101, min_days: 2, max_days: 3 },
{ pincode: 852105, min_days: 2, max_days: 3 },
{ pincode: 852106, min_days: 2, max_days: 3 },
{ pincode: 852107, min_days: 2, max_days: 3 },
{ pincode: 852108, min_days: 2, max_days: 3 },
{ pincode: 852109, min_days: 2, max_days: 3 },
{ pincode: 852110, min_days: 2, max_days: 3 },
{ pincode: 852111, min_days: 2, max_days: 3 },
{ pincode: 852112, min_days: 2, max_days: 3 },
{ pincode: 852113, min_days: 2, max_days: 3 },
{ pincode: 852114, min_days: 2, max_days: 3 },
{ pincode: 852115, min_days: 2, max_days: 3 },
{ pincode: 852116, min_days: 2, max_days: 3 },
{ pincode: 852121, min_days: 2, max_days: 3 },
{ pincode: 852122, min_days: 2, max_days: 3 },
{ pincode: 852123, min_days: 2, max_days: 3 },
{ pincode: 852124, min_days: 2, max_days: 3 },
{ pincode: 852125, min_days: 2, max_days: 3 },
{ pincode: 852126, min_days: 2, max_days: 3 },
{ pincode: 852127, min_days: 2, max_days: 3 },
{ pincode: 852128, min_days: 2, max_days: 3 },
{ pincode: 852129, min_days: 2, max_days: 3 },
{ pincode: 852130, min_days: 2, max_days: 3 },
{ pincode: 852131, min_days: 2, max_days: 3 },
{ pincode: 852132, min_days: 2, max_days: 3 },
{ pincode: 852133, min_days: 2, max_days: 3 },
{ pincode: 852134, min_days: 2, max_days: 3 },
{ pincode: 852137, min_days: 2, max_days: 3 },
{ pincode: 852138, min_days: 2, max_days: 3 },
{ pincode: 852139, min_days: 2, max_days: 3 },
{ pincode: 852161, min_days: 2, max_days: 3 },
{ pincode: 852171, min_days: 2, max_days: 3 },
{ pincode: 852201, min_days: 2, max_days: 3 },
{ pincode: 852202, min_days: 2, max_days: 3 },
{ pincode: 852212, min_days: 2, max_days: 3 },
{ pincode: 852213, min_days: 2, max_days: 3 },
{ pincode: 852214, min_days: 2, max_days: 3 },
{ pincode: 852215, min_days: 2, max_days: 3 },
{ pincode: 852216, min_days: 2, max_days: 3 },
{ pincode: 852217, min_days: 2, max_days: 3 },
{ pincode: 852218, min_days: 2, max_days: 3 },
{ pincode: 852219, min_days: 2, max_days: 3 },
{ pincode: 852220, min_days: 2, max_days: 3 },
{ pincode: 852221, min_days: 2, max_days: 3 },
{ pincode: 853201, min_days: 2, max_days: 3 },
{ pincode: 853202, min_days: 2, max_days: 3 },
{ pincode: 853203, min_days: 2, max_days: 3 },
{ pincode: 853204, min_days: 2, max_days: 3 },
{ pincode: 853205, min_days: 2, max_days: 3 },
{ pincode: 853207, min_days: 2, max_days: 3 },
{ pincode: 854101, min_days: 2, max_days: 3 },
{ pincode: 854102, min_days: 2, max_days: 3 },
{ pincode: 854103, min_days: 2, max_days: 3 },
{ pincode: 854104, min_days: 2, max_days: 3 },
{ pincode: 854105, min_days: 2, max_days: 3 },
{ pincode: 854106, min_days: 2, max_days: 3 },
{ pincode: 854107, min_days: 2, max_days: 3 },
{ pincode: 854108, min_days: 2, max_days: 3 },
{ pincode: 854109, min_days: 2, max_days: 3 },
{ pincode: 854110, min_days: 2, max_days: 3 },
{ pincode: 854112, min_days: 2, max_days: 3 },
{ pincode: 854113, min_days: 2, max_days: 3 },
{ pincode: 854114, min_days: 2, max_days: 3 },
{ pincode: 854115, min_days: 2, max_days: 3 },
{ pincode: 854116, min_days: 2, max_days: 3 },
{ pincode: 854117, min_days: 2, max_days: 3 },
{ pincode: 854119, min_days: 2, max_days: 3 },
{ pincode: 854201, min_days: 2, max_days: 3 },
{ pincode: 854202, min_days: 2, max_days: 3 },
{ pincode: 854203, min_days: 2, max_days: 3 },
{ pincode: 854204, min_days: 2, max_days: 3 },
{ pincode: 854205, min_days: 2, max_days: 3 },
{ pincode: 854206, min_days: 2, max_days: 3 },
{ pincode: 854208, min_days: 2, max_days: 3 },
{ pincode: 854301, min_days: 2, max_days: 3 },
{ pincode: 854302, min_days: 2, max_days: 3 },
{ pincode: 854303, min_days: 2, max_days: 3 },
{ pincode: 854304, min_days: 2, max_days: 3 },
{ pincode: 854305, min_days: 2, max_days: 3 },
{ pincode: 854306, min_days: 2, max_days: 3 },
{ pincode: 854311, min_days: 2, max_days: 3 },
{ pincode: 854312, min_days: 2, max_days: 3 },
{ pincode: 854315, min_days: 2, max_days: 3 },
{ pincode: 854316, min_days: 2, max_days: 3 },
{ pincode: 854317, min_days: 2, max_days: 3 },
{ pincode: 854318, min_days: 2, max_days: 3 },
{ pincode: 854321, min_days: 2, max_days: 3 },
{ pincode: 854325, min_days: 2, max_days: 3 },
{ pincode: 854326, min_days: 2, max_days: 3 },
{ pincode: 854327, min_days: 2, max_days: 3 },
{ pincode: 854328, min_days: 2, max_days: 3 },
{ pincode: 854329, min_days: 2, max_days: 3 },
{ pincode: 854330, min_days: 2, max_days: 3 },
{ pincode: 854331, min_days: 2, max_days: 3 },
{ pincode: 854332, min_days: 2, max_days: 3 },
{ pincode: 854333, min_days: 2, max_days: 3 },
{ pincode: 854334, min_days: 2, max_days: 3 },
{ pincode: 854335, min_days: 2, max_days: 3 },
{ pincode: 854336, min_days: 2, max_days: 3 },
{ pincode: 854337, min_days: 2, max_days: 3 },
{ pincode: 854338, min_days: 2, max_days: 3 },
{ pincode: 854339, min_days: 2, max_days: 3 },
{ pincode: 854340, min_days: 2, max_days: 3 },
{ pincode: 854344, min_days: 2, max_days: 3 },
{ pincode: 854347, min_days: 2, max_days: 3 },
{ pincode: 854357, min_days: 2, max_days: 3 },
{ pincode: 854365, min_days: 2, max_days: 3 },
{ pincode: 855101, min_days: 2, max_days: 3 },
{ pincode: 855102, min_days: 2, max_days: 3 },
{ pincode: 855105, min_days: 2, max_days: 3 },
{ pincode: 855106, min_days: 2, max_days: 3 },
{ pincode: 855107, min_days: 2, max_days: 3 },
{ pincode: 855108, min_days: 2, max_days: 3 },
{ pincode: 855113, min_days: 2, max_days: 3 },
{ pincode: 855114, min_days: 2, max_days: 3 },
{ pincode: 855115, min_days: 2, max_days: 3 },
{ pincode: 855116, min_days: 2, max_days: 3 },
{ pincode: 855117, min_days: 2, max_days: 3 },
{ pincode: 855120, min_days: 2, max_days: 3 },
{ pincode: 857225, min_days: 2, max_days: 3 },
]